webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global = __webpack_require__(6),
    core = __webpack_require__(47),
    hide = __webpack_require__(26),
    redefine = __webpack_require__(27),
    ctx = __webpack_require__(48),
    PROTOTYPE = 'prototype';

var $export = function $export(type, name, source) {
  var IS_FORCED = type & $export.F,
      IS_GLOBAL = type & $export.G,
      IS_STATIC = type & $export.S,
      IS_PROTO = type & $export.P,
      IS_BIND = type & $export.B,
      target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE],
      exports = IS_GLOBAL ? core : core[name] || (core[name] = {}),
      expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {}),
      key,
      own,
      out,
      exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1; // forced
$export.G = 2; // global
$export.S = 4; // static
$export.P = 8; // proto
$export.B = 16; // bind
$export.W = 32; // wrap
$export.U = 64; // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isObject = __webpack_require__(9);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

/***/ }),
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports = function (it) {
  return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var store = __webpack_require__(124)('wks'),
    uid = __webpack_require__(72),
    _Symbol = __webpack_require__(6).Symbol,
    USE_SYMBOL = typeof _Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] = USE_SYMBOL && _Symbol[name] || (USE_SYMBOL ? _Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(7)(function () {
  return Object.defineProperty({}, 'a', { get: function get() {
      return 7;
    } }).a != 7;
});

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(4),
    IE8_DOM_DEFINE = __webpack_require__(225),
    toPrimitive = __webpack_require__(43),
    dP = Object.defineProperty;

exports.f = __webpack_require__(12) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) {/* empty */}
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 7.1.15 ToLength
var toInteger = __webpack_require__(57),
    min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 7.1.13 ToObject(argument)
var defined = __webpack_require__(38);
module.exports = function (it) {
  return Object(defined(it));
};

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.logError = exports.initErrorLogger = exports.passPropsTo = exports.iamBaseHeader = exports.makeRequest = exports.hasPreviouslyLoggedIn = exports.getQueryString = exports.waitFor = exports.queryStringParse = exports.Cookies = exports.dispatchAction = exports.makeActionCreator = undefined;

var _reduxActions = __webpack_require__(599);

Object.defineProperty(exports, 'makeActionCreator', {
	enumerable: true,
	get: function get() {
		return _reduxActions.makeActionCreator;
	}
});
Object.defineProperty(exports, 'dispatchAction', {
	enumerable: true,
	get: function get() {
		return _reduxActions.dispatchAction;
	}
});

var _cookies = __webpack_require__(597);

Object.defineProperty(exports, 'Cookies', {
	enumerable: true,
	get: function get() {
		return _cookies.Cookies;
	}
});

var _queryString = __webpack_require__(170);

Object.defineProperty(exports, 'queryStringParse', {
	enumerable: true,
	get: function get() {
		return _queryString.queryStringParse;
	}
});

var _queryString2 = __webpack_require__(393);

Object.defineProperty(exports, 'getQueryString', {
	enumerable: true,
	get: function get() {
		return _queryString2.getQueryString;
	}
});

var _hasPreviouslyLoggedIn = __webpack_require__(390);

Object.defineProperty(exports, 'hasPreviouslyLoggedIn', {
	enumerable: true,
	get: function get() {
		return _hasPreviouslyLoggedIn.hasPreviouslyLoggedIn;
	}
});

var _http = __webpack_require__(391);

Object.defineProperty(exports, 'makeRequest', {
	enumerable: true,
	get: function get() {
		return _http.makeRequest;
	}
});
Object.defineProperty(exports, 'iamBaseHeader', {
	enumerable: true,
	get: function get() {
		return _http.iamBaseHeader;
	}
});

var _component = __webpack_require__(389);

Object.defineProperty(exports, 'passPropsTo', {
	enumerable: true,
	get: function get() {
		return _component.passPropsTo;
	}
});

var _errors = __webpack_require__(247);

Object.defineProperty(exports, 'initErrorLogger', {
	enumerable: true,
	get: function get() {
		return _errors.initErrorLogger;
	}
});

var _logError = __webpack_require__(392);

Object.defineProperty(exports, 'logError', {
	enumerable: true,
	get: function get() {
		return _logError.logError;
	}
});

var _waitFor2 = __webpack_require__(394);

var _waitFor3 = _interopRequireDefault(_waitFor2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.waitFor = _waitFor3.default;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Svg = exports.Breakpoints = exports.LessThanXLarge = exports.LessThanLarge = exports.LessThanMedium = exports.LessThanSmall = exports.LessThanXSmall = exports.XLarge = exports.Large = exports.Medium = exports.Small = exports.XSmall = exports.MediaFeatures = exports.MatchMedia = exports.StickToFooter = exports.Loading = exports.Alerts = undefined;

var _Alerts = __webpack_require__(329);

Object.defineProperty(exports, 'Alerts', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Alerts).default;
  }
});

var _Loading = __webpack_require__(331);

Object.defineProperty(exports, 'Loading', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Loading).default;
  }
});

var _StickToFooter = __webpack_require__(344);

Object.defineProperty(exports, 'StickToFooter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_StickToFooter).default;
  }
});

var _MatchMedia = __webpack_require__(35);

Object.defineProperty(exports, 'MatchMedia', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MatchMedia).default;
  }
});

var _MediaFeatures = __webpack_require__(338);

Object.defineProperty(exports, 'MediaFeatures', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MediaFeatures).default;
  }
});

var _XSmall = __webpack_require__(342);

Object.defineProperty(exports, 'XSmall', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_XSmall).default;
  }
});

var _Small = __webpack_require__(340);

Object.defineProperty(exports, 'Small', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Small).default;
  }
});

var _Medium = __webpack_require__(339);

Object.defineProperty(exports, 'Medium', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Medium).default;
  }
});

var _Large = __webpack_require__(332);

Object.defineProperty(exports, 'Large', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Large).default;
  }
});

var _XLarge = __webpack_require__(341);

Object.defineProperty(exports, 'XLarge', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_XLarge).default;
  }
});

var _LessThanXSmall = __webpack_require__(337);

Object.defineProperty(exports, 'LessThanXSmall', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_LessThanXSmall).default;
  }
});

var _LessThanSmall = __webpack_require__(335);

Object.defineProperty(exports, 'LessThanSmall', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_LessThanSmall).default;
  }
});

var _LessThanMedium = __webpack_require__(334);

Object.defineProperty(exports, 'LessThanMedium', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_LessThanMedium).default;
  }
});

var _LessThanLarge = __webpack_require__(333);

Object.defineProperty(exports, 'LessThanLarge', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_LessThanLarge).default;
  }
});

var _LessThanXLarge = __webpack_require__(336);

Object.defineProperty(exports, 'LessThanXLarge', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_LessThanXLarge).default;
  }
});

var _breakpoints = __webpack_require__(36);

Object.defineProperty(exports, 'Breakpoints', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_breakpoints).default;
  }
});

var _Svg = __webpack_require__(346);

Object.defineProperty(exports, 'Svg', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Svg).default;
  }
});

var _Alerts2 = _interopRequireDefault(_Alerts);

var _Loading2 = _interopRequireDefault(_Loading);

var _StickToFooter2 = _interopRequireDefault(_StickToFooter);

var _MatchMedia2 = _interopRequireDefault(_MatchMedia);

var _MediaFeatures2 = _interopRequireDefault(_MediaFeatures);

var _XSmall2 = _interopRequireDefault(_XSmall);

var _Small2 = _interopRequireDefault(_Small);

var _Medium2 = _interopRequireDefault(_Medium);

var _Large2 = _interopRequireDefault(_Large);

var _XLarge2 = _interopRequireDefault(_XLarge);

var _LessThanXSmall2 = _interopRequireDefault(_LessThanXSmall);

var _LessThanSmall2 = _interopRequireDefault(_LessThanSmall);

var _LessThanMedium2 = _interopRequireDefault(_LessThanMedium);

var _LessThanLarge2 = _interopRequireDefault(_LessThanLarge);

var _LessThanXLarge2 = _interopRequireDefault(_LessThanXLarge);

var _breakpoints2 = _interopRequireDefault(_breakpoints);

var _Svg2 = _interopRequireDefault(_Svg);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = {
  Alerts: _Alerts2.default,
  Loading: _Loading2.default,
  StickToFooter: _StickToFooter2.default,
  MatchMedia: _MatchMedia2.default,
  MediaFeatures: _MediaFeatures2.default,
  XSmall: _XSmall2.default,
  Small: _Small2.default,
  Medium: _Medium2.default,
  Large: _Large2.default,
  XLarge: _XLarge2.default,
  LessThanXSmall: _LessThanXSmall2.default,
  LessThanSmall: _LessThanSmall2.default,
  LessThanMedium: _LessThanMedium2.default,
  LessThanLarge: _LessThanLarge2.default,
  LessThanXLarge: _LessThanXLarge2.default,
  Breakpoints: _breakpoints2.default,
  Svg: _Svg2.default
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var dP = __webpack_require__(13),
    createDesc = __webpack_require__(56);
module.exports = __webpack_require__(12) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global = __webpack_require__(6),
    hide = __webpack_require__(26),
    has = __webpack_require__(23),
    SRC = __webpack_require__(72)('src'),
    TO_STRING = 'toString',
    $toString = Function[TO_STRING],
    TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(47).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else {
    if (!safe) {
      delete O[key];
      hide(O, key, val);
    } else {
      if (O[key]) O[key] = val;else hide(O, key, val);
    }
  }
  // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(0),
    fails = __webpack_require__(7),
    defined = __webpack_require__(38),
    quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function createHTML(string, tag, attribute, value) {
  var S = String(defined(string)),
      p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(97),
    defined = __webpack_require__(38);
module.exports = function (it) {
  return IObject(defined(it));
};

/***/ }),
/* 30 */,
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
window.GG = window.GG || {};

exports.default = window.GG.matchMyMilesConfig;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.authActionTypes = exports.facebookActionTypes = exports.httpActionTypes = exports.validationActionTypes = exports.userActionTypes = exports.appActionTypes = undefined;

var _keymirror = __webpack_require__(172);

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * App action types
 */
var appActionTypes = exports.appActionTypes = (0, _keymirror2.default)({
	'UPDATE_LOCALE': null,
	'UPDATE_PREVIOUS_PAGE': null,
	'UPDATE_CURRENT_PAGE': null,
	'UPDATE_NEXT_PAGE': null,
	'UPDATE_NETWORK_STATUS': null,
	'UPDATE_DEVICE_TYPE': null
});

/**
 * User action types
 */
var userActionTypes = exports.userActionTypes = (0, _keymirror2.default)({
	'UPDATE_EMAIL_ADDRESS': null,
	'UPDATE_PASSWORD': null,
	'UPDATE_FIRSTNAME': null,
	'UPDATE_LASTNAME': null,
	'UPDATE_FB_LOGIN_SCOPE': null,
	'SET_PROPS_FROM_HOST': null
});

/**
 * Validation action types
 */
var validationActionTypes = exports.validationActionTypes = (0, _keymirror2.default)({
	'UPDATE_VALIDATION_ERRORS': null
});

/**
 * HTTP action types
 */
var httpActionTypes = exports.httpActionTypes = (0, _keymirror2.default)({
	'FACEBOOK_REQUEST_MADE': null,
	'FACEBOOK_REQUEST_SUCCESS': null,
	'FACEBOOK_REQUEST_ERROR': null,
	'IAM_REQUEST_MADE': null,
	'IAM_REQUEST_SUCCESS': null,
	'IAM_REQUEST_ERROR': null
});

/**
 * FACEBOOK action types
 */
var facebookActionTypes = exports.facebookActionTypes = (0, _keymirror2.default)({
	'UPDATE_FACEBOOK_LOGIN_STATUS': null,
	'UPDATE_FACEBOOK_FIRST_NAME': null,
	'UPDATE_FACEBOOK_LAST_NAME': null,
	'UPDATE_FACEBOOK_EMAIL': null,
	'UPDATE_FACEBOOK_ACCESS_TOKEN': null
});

/**
 * AUTH action types
 */
var authActionTypes = exports.authActionTypes = (0, _keymirror2.default)({
	'UPDATE_AUTH_TOKEN': null
});

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var pIE = __webpack_require__(98),
    createDesc = __webpack_require__(56),
    toIObject = __webpack_require__(29),
    toPrimitive = __webpack_require__(43),
    has = __webpack_require__(23),
    IE8_DOM_DEFINE = __webpack_require__(225),
    gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(12) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) {/* empty */}
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(23),
    toObject = __webpack_require__(17),
    IE_PROTO = __webpack_require__(158)('IE_PROTO'),
    ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  }return O instanceof Object ? ObjectProto : null;
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _cssMediaquery = __webpack_require__(591);

var _cssMediaquery2 = _interopRequireDefault(_cssMediaquery);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = {
  mediaQuery: _propTypes2.default.string.isRequired,
  mediaFeatures: _propTypes2.default.shape({ width: _propTypes2.default.string })
};

var defaultProps = {
  mediaFeatures: null
};

var contextTypes = {
  mediaFeatures: _propTypes2.default.shape({ width: _propTypes2.default.string })
};

var MatchMedia = function (_Component) {
  _inherits(MatchMedia, _Component);

  _createClass(MatchMedia, null, [{
    key: 'matchMediaExists',
    value: function matchMediaExists() {
      if (typeof window === 'undefined') return false;
      if (typeof window.matchMedia === 'undefined') {
        console.warn('Missing \'matchMedia\' polyfill.'); // eslint-disable-line no-console
        return false;
      }
      return true;
    }
  }, {
    key: 'isServerRendered',
    value: function isServerRendered() {
      return typeof window === 'undefined';
    }
  }]);

  function MatchMedia() {
    _classCallCheck(this, MatchMedia);

    var _this = _possibleConstructorReturn(this, (MatchMedia.__proto__ || Object.getPrototypeOf(MatchMedia)).call(this));

    _this.state = {
      matches: true
    };

    _this.onResize = _this.onResize.bind(_this);
    return _this;
  }

  _createClass(MatchMedia, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (MatchMedia.isServerRendered() && this.getMediaFeatures()) {
        this.setState({
          matches: this.serverMatches()
        });
      }

      if (MatchMedia.matchMediaExists()) {
        this.mediaQuery = window.matchMedia(this.props.mediaQuery);
        this.mediaQuery.addListener(this.onResize);

        this.setState({
          matches: this.clientMatches()
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (MatchMedia.matchMediaExists()) {
        this.mediaQuery.removeListener(this.onResize);
      }
    }
  }, {
    key: 'onResize',
    value: function onResize() {
      this.setState({
        matches: this.clientMatches()
      });
    }
  }, {
    key: 'getMediaFeatures',
    value: function getMediaFeatures() {
      if (!this.context.mediaFeatures && !this.props.mediaFeatures) {
        return undefined;
      }

      var mediaFeatures = { type: 'screen' };

      if (this.context.mediaFeatures) {
        mediaFeatures = Object.assign(mediaFeatures, this.context.mediaFeatures);
      }

      if (this.props.mediaFeatures) {
        mediaFeatures = Object.assign(mediaFeatures, this.props.mediaFeatures);
      }

      return mediaFeatures;
    }
  }, {
    key: 'clientMatches',
    value: function clientMatches() {
      return this.mediaQuery.matches;
    }
  }, {
    key: 'serverMatches',
    value: function serverMatches() {
      return _cssMediaquery2.default.match(this.props.mediaQuery, this.getMediaFeatures());
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;
      var matches = this.state.matches;

      return _react2.default.createElement('div', null, matches ? children : null);
    }
  }]);

  return MatchMedia;
}(_react.Component);

MatchMedia.propTypes = propTypes;

MatchMedia.defaultProps = defaultProps;

MatchMedia.contextTypes = contextTypes;

exports.default = MatchMedia;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// must be kept in-sync with
// https://source.justgiving.com/JustGiving/JG.FrontEnd.Toolkit/blob/master/packages/styles/src/settings/_breakpoints.scss

var XSMALL = exports.XSMALL = 320; // 0-319
var SMALL = exports.SMALL = 568; // 320-567
var MEDIUM = exports.MEDIUM = 768; // 568-767
var LARGE = exports.LARGE = 1024; // 768-1023
var XLARGE = exports.XLARGE = 1240; // 1024-1240

exports.default = {
  XSMALL: XSMALL,
  SMALL: SMALL,
  MEDIUM: MEDIUM,
  LARGE: LARGE,
  XLARGE: XLARGE
};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fails = __webpack_require__(7);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    arg ? method.call(null, function () {}, 1) : method.call(null);
  });
};

/***/ }),
/* 40 */,
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(48),
    IObject = __webpack_require__(97),
    toObject = __webpack_require__(17),
    toLength = __webpack_require__(16),
    asc = __webpack_require__(408);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1,
      IS_FILTER = TYPE == 2,
      IS_SOME = TYPE == 3,
      IS_EVERY = TYPE == 4,
      IS_FIND_INDEX = TYPE == 6,
      NO_HOLES = TYPE == 5 || IS_FIND_INDEX,
      create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this),
        self = IObject(O),
        f = ctx(callbackfn, that, 3),
        length = toLength(self.length),
        index = 0,
        result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined,
        val,
        res;
    for (; length > index; index++) {
      if (NO_HOLES || index in self) {
        val = self[index];
        res = f(val, index, O);
        if (TYPE) {
          if (IS_MAP) result[index] = res; // map
          else if (res) switch (TYPE) {
              case 3:
                return true; // some
              case 5:
                return val; // find
              case 6:
                return index; // findIndex
              case 2:
                result.push(val); // filter
            } else if (IS_EVERY) return false; // every
        }
      }
    }return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(0),
    core = __webpack_require__(47),
    fails = __webpack_require__(7);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY],
      exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () {
    fn(1);
  }), 'Object', exp);
};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(9);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 *  Copyright (c) 2014-2015, Facebook, Inc.
 *  All rights reserved.
 *
 *  This source code is licensed under the BSD-style license found in the
 *  LICENSE file in the root directory of this source tree. An additional grant
 *  of patent rights can be found in the PATENTS file in the same directory.
 */

(function (global, factory) {
  ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : global.Immutable = factory();
})(undefined, function () {
  'use strict';
  var SLICE$0 = Array.prototype.slice;

  function createClass(ctor, superClass) {
    if (superClass) {
      ctor.prototype = Object.create(superClass.prototype);
    }
    ctor.prototype.constructor = ctor;
  }

  function Iterable(value) {
    return isIterable(value) ? value : Seq(value);
  }

  createClass(KeyedIterable, Iterable);
  function KeyedIterable(value) {
    return isKeyed(value) ? value : KeyedSeq(value);
  }

  createClass(IndexedIterable, Iterable);
  function IndexedIterable(value) {
    return isIndexed(value) ? value : IndexedSeq(value);
  }

  createClass(SetIterable, Iterable);
  function SetIterable(value) {
    return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
  }

  function isIterable(maybeIterable) {
    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
  }

  function isKeyed(maybeKeyed) {
    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
  }

  function isIndexed(maybeIndexed) {
    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
  }

  function isAssociative(maybeAssociative) {
    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
  }

  function isOrdered(maybeOrdered) {
    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
  }

  Iterable.isIterable = isIterable;
  Iterable.isKeyed = isKeyed;
  Iterable.isIndexed = isIndexed;
  Iterable.isAssociative = isAssociative;
  Iterable.isOrdered = isOrdered;

  Iterable.Keyed = KeyedIterable;
  Iterable.Indexed = IndexedIterable;
  Iterable.Set = SetIterable;

  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  // Used for setting prototype methods that IE8 chokes on.
  var DELETE = 'delete';

  // Constants describing the size of trie nodes.
  var SHIFT = 5; // Resulted in best performance after ______?
  var SIZE = 1 << SHIFT;
  var MASK = SIZE - 1;

  // A consistent shared value representing "not set" which equals nothing other
  // than itself, and nothing that could be provided externally.
  var NOT_SET = {};

  // Boolean references, Rough equivalent of `bool &`.
  var CHANGE_LENGTH = { value: false };
  var DID_ALTER = { value: false };

  function MakeRef(ref) {
    ref.value = false;
    return ref;
  }

  function SetRef(ref) {
    ref && (ref.value = true);
  }

  // A function which returns a value representing an "owner" for transient writes
  // to tries. The return value will only ever equal itself, and will not equal
  // the return of any subsequent call of this function.
  function OwnerID() {}

  // http://jsperf.com/copy-array-inline
  function arrCopy(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for (var ii = 0; ii < len; ii++) {
      newArr[ii] = arr[ii + offset];
    }
    return newArr;
  }

  function ensureSize(iter) {
    if (iter.size === undefined) {
      iter.size = iter.__iterate(returnTrue);
    }
    return iter.size;
  }

  function wrapIndex(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== 'number') {
      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
      if ('' + uint32Index !== index || uint32Index === 4294967295) {
        return NaN;
      }
      index = uint32Index;
    }
    return index < 0 ? ensureSize(iter) + index : index;
  }

  function returnTrue() {
    return true;
  }

  function wholeSlice(begin, end, size) {
    return (begin === 0 || size !== undefined && begin <= -size) && (end === undefined || size !== undefined && end >= size);
  }

  function resolveBegin(begin, size) {
    return resolveIndex(begin, size, 0);
  }

  function resolveEnd(end, size) {
    return resolveIndex(end, size, size);
  }

  function resolveIndex(index, size, defaultIndex) {
    return index === undefined ? defaultIndex : index < 0 ? Math.max(0, size + index) : size === undefined ? index : Math.min(size, index);
  }

  /* global Symbol */

  var ITERATE_KEYS = 0;
  var ITERATE_VALUES = 1;
  var ITERATE_ENTRIES = 2;

  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';

  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;

  function Iterator(next) {
    this.next = next;
  }

  Iterator.prototype.toString = function () {
    return '[Iterator]';
  };

  Iterator.KEYS = ITERATE_KEYS;
  Iterator.VALUES = ITERATE_VALUES;
  Iterator.ENTRIES = ITERATE_ENTRIES;

  Iterator.prototype.inspect = Iterator.prototype.toSource = function () {
    return this.toString();
  };
  Iterator.prototype[ITERATOR_SYMBOL] = function () {
    return this;
  };

  function iteratorValue(type, k, v, iteratorResult) {
    var value = type === 0 ? k : type === 1 ? v : [k, v];
    iteratorResult ? iteratorResult.value = value : iteratorResult = {
      value: value, done: false
    };
    return iteratorResult;
  }

  function iteratorDone() {
    return { value: undefined, done: true };
  }

  function hasIterator(maybeIterable) {
    return !!getIteratorFn(maybeIterable);
  }

  function isIterator(maybeIterator) {
    return maybeIterator && typeof maybeIterator.next === 'function';
  }

  function getIterator(iterable) {
    var iteratorFn = getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
  }

  function getIteratorFn(iterable) {
    var iteratorFn = iterable && (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL] || iterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  function isArrayLike(value) {
    return value && typeof value.length === 'number';
  }

  createClass(Seq, Iterable);
  function Seq(value) {
    return value === null || value === undefined ? emptySequence() : isIterable(value) ? value.toSeq() : seqFromValue(value);
  }

  Seq.of = function () /*...values*/{
    return Seq(arguments);
  };

  Seq.prototype.toSeq = function () {
    return this;
  };

  Seq.prototype.toString = function () {
    return this.__toString('Seq {', '}');
  };

  Seq.prototype.cacheResult = function () {
    if (!this._cache && this.__iterateUncached) {
      this._cache = this.entrySeq().toArray();
      this.size = this._cache.length;
    }
    return this;
  };

  // abstract __iterateUncached(fn, reverse)

  Seq.prototype.__iterate = function (fn, reverse) {
    return seqIterate(this, fn, reverse, true);
  };

  // abstract __iteratorUncached(type, reverse)

  Seq.prototype.__iterator = function (type, reverse) {
    return seqIterator(this, type, reverse, true);
  };

  createClass(KeyedSeq, Seq);
  function KeyedSeq(value) {
    return value === null || value === undefined ? emptySequence().toKeyedSeq() : isIterable(value) ? isKeyed(value) ? value.toSeq() : value.fromEntrySeq() : keyedSeqFromValue(value);
  }

  KeyedSeq.prototype.toKeyedSeq = function () {
    return this;
  };

  createClass(IndexedSeq, Seq);
  function IndexedSeq(value) {
    return value === null || value === undefined ? emptySequence() : !isIterable(value) ? indexedSeqFromValue(value) : isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
  }

  IndexedSeq.of = function () /*...values*/{
    return IndexedSeq(arguments);
  };

  IndexedSeq.prototype.toIndexedSeq = function () {
    return this;
  };

  IndexedSeq.prototype.toString = function () {
    return this.__toString('Seq [', ']');
  };

  IndexedSeq.prototype.__iterate = function (fn, reverse) {
    return seqIterate(this, fn, reverse, false);
  };

  IndexedSeq.prototype.__iterator = function (type, reverse) {
    return seqIterator(this, type, reverse, false);
  };

  createClass(SetSeq, Seq);
  function SetSeq(value) {
    return (value === null || value === undefined ? emptySequence() : !isIterable(value) ? indexedSeqFromValue(value) : isKeyed(value) ? value.entrySeq() : value).toSetSeq();
  }

  SetSeq.of = function () /*...values*/{
    return SetSeq(arguments);
  };

  SetSeq.prototype.toSetSeq = function () {
    return this;
  };

  Seq.isSeq = isSeq;
  Seq.Keyed = KeyedSeq;
  Seq.Set = SetSeq;
  Seq.Indexed = IndexedSeq;

  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';

  Seq.prototype[IS_SEQ_SENTINEL] = true;

  createClass(ArraySeq, IndexedSeq);
  function ArraySeq(array) {
    this._array = array;
    this.size = array.length;
  }

  ArraySeq.prototype.get = function (index, notSetValue) {
    return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
  };

  ArraySeq.prototype.__iterate = function (fn, reverse) {
    var array = this._array;
    var maxIndex = array.length - 1;
    for (var ii = 0; ii <= maxIndex; ii++) {
      if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
        return ii + 1;
      }
    }
    return ii;
  };

  ArraySeq.prototype.__iterator = function (type, reverse) {
    var array = this._array;
    var maxIndex = array.length - 1;
    var ii = 0;
    return new Iterator(function () {
      return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++]);
    });
  };

  createClass(ObjectSeq, KeyedSeq);
  function ObjectSeq(object) {
    var keys = Object.keys(object);
    this._object = object;
    this._keys = keys;
    this.size = keys.length;
  }

  ObjectSeq.prototype.get = function (key, notSetValue) {
    if (notSetValue !== undefined && !this.has(key)) {
      return notSetValue;
    }
    return this._object[key];
  };

  ObjectSeq.prototype.has = function (key) {
    return this._object.hasOwnProperty(key);
  };

  ObjectSeq.prototype.__iterate = function (fn, reverse) {
    var object = this._object;
    var keys = this._keys;
    var maxIndex = keys.length - 1;
    for (var ii = 0; ii <= maxIndex; ii++) {
      var key = keys[reverse ? maxIndex - ii : ii];
      if (fn(object[key], key, this) === false) {
        return ii + 1;
      }
    }
    return ii;
  };

  ObjectSeq.prototype.__iterator = function (type, reverse) {
    var object = this._object;
    var keys = this._keys;
    var maxIndex = keys.length - 1;
    var ii = 0;
    return new Iterator(function () {
      var key = keys[reverse ? maxIndex - ii : ii];
      return ii++ > maxIndex ? iteratorDone() : iteratorValue(type, key, object[key]);
    });
  };

  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;

  createClass(IterableSeq, IndexedSeq);
  function IterableSeq(iterable) {
    this._iterable = iterable;
    this.size = iterable.length || iterable.size;
  }

  IterableSeq.prototype.__iterateUncached = function (fn, reverse) {
    if (reverse) {
      return this.cacheResult().__iterate(fn, reverse);
    }
    var iterable = this._iterable;
    var iterator = getIterator(iterable);
    var iterations = 0;
    if (isIterator(iterator)) {
      var step;
      while (!(step = iterator.next()).done) {
        if (fn(step.value, iterations++, this) === false) {
          break;
        }
      }
    }
    return iterations;
  };

  IterableSeq.prototype.__iteratorUncached = function (type, reverse) {
    if (reverse) {
      return this.cacheResult().__iterator(type, reverse);
    }
    var iterable = this._iterable;
    var iterator = getIterator(iterable);
    if (!isIterator(iterator)) {
      return new Iterator(iteratorDone);
    }
    var iterations = 0;
    return new Iterator(function () {
      var step = iterator.next();
      return step.done ? step : iteratorValue(type, iterations++, step.value);
    });
  };

  createClass(IteratorSeq, IndexedSeq);
  function IteratorSeq(iterator) {
    this._iterator = iterator;
    this._iteratorCache = [];
  }

  IteratorSeq.prototype.__iterateUncached = function (fn, reverse) {
    if (reverse) {
      return this.cacheResult().__iterate(fn, reverse);
    }
    var iterator = this._iterator;
    var cache = this._iteratorCache;
    var iterations = 0;
    while (iterations < cache.length) {
      if (fn(cache[iterations], iterations++, this) === false) {
        return iterations;
      }
    }
    var step;
    while (!(step = iterator.next()).done) {
      var val = step.value;
      cache[iterations] = val;
      if (fn(val, iterations++, this) === false) {
        break;
      }
    }
    return iterations;
  };

  IteratorSeq.prototype.__iteratorUncached = function (type, reverse) {
    if (reverse) {
      return this.cacheResult().__iterator(type, reverse);
    }
    var iterator = this._iterator;
    var cache = this._iteratorCache;
    var iterations = 0;
    return new Iterator(function () {
      if (iterations >= cache.length) {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        cache[iterations] = step.value;
      }
      return iteratorValue(type, iterations, cache[iterations++]);
    });
  };

  // # pragma Helper functions

  function isSeq(maybeSeq) {
    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
  }

  var EMPTY_SEQ;

  function emptySequence() {
    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
  }

  function keyedSeqFromValue(value) {
    var seq = Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() : isIterator(value) ? new IteratorSeq(value).fromEntrySeq() : hasIterator(value) ? new IterableSeq(value).fromEntrySeq() : (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' ? new ObjectSeq(value) : undefined;
    if (!seq) {
      throw new TypeError('Expected Array or iterable object of [k, v] entries, ' + 'or keyed object: ' + value);
    }
    return seq;
  }

  function indexedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (!seq) {
      throw new TypeError('Expected Array or iterable object of values: ' + value);
    }
    return seq;
  }

  function seqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value) || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && new ObjectSeq(value);
    if (!seq) {
      throw new TypeError('Expected Array or iterable object of values, or keyed object: ' + value);
    }
    return seq;
  }

  function maybeIndexedSeqFromValue(value) {
    return isArrayLike(value) ? new ArraySeq(value) : isIterator(value) ? new IteratorSeq(value) : hasIterator(value) ? new IterableSeq(value) : undefined;
  }

  function seqIterate(seq, fn, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var entry = cache[reverse ? maxIndex - ii : ii];
        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
          return ii + 1;
        }
      }
      return ii;
    }
    return seq.__iterateUncached(fn, reverse);
  }

  function seqIterator(seq, type, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      var ii = 0;
      return new Iterator(function () {
        var entry = cache[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ? iteratorDone() : iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
      });
    }
    return seq.__iteratorUncached(type, reverse);
  }

  function fromJS(json, converter) {
    return converter ? fromJSWith(converter, json, '', { '': json }) : fromJSDefault(json);
  }

  function fromJSWith(converter, json, key, parentJSON) {
    if (Array.isArray(json)) {
      return converter.call(parentJSON, key, IndexedSeq(json).map(function (v, k) {
        return fromJSWith(converter, v, k, json);
      }));
    }
    if (isPlainObj(json)) {
      return converter.call(parentJSON, key, KeyedSeq(json).map(function (v, k) {
        return fromJSWith(converter, v, k, json);
      }));
    }
    return json;
  }

  function fromJSDefault(json) {
    if (Array.isArray(json)) {
      return IndexedSeq(json).map(fromJSDefault).toList();
    }
    if (isPlainObj(json)) {
      return KeyedSeq(json).map(fromJSDefault).toMap();
    }
    return json;
  }

  function isPlainObj(value) {
    return value && (value.constructor === Object || value.constructor === undefined);
  }

  /**
   * An extension of the "same-value" algorithm as [described for use by ES6 Map
   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
   *
   * NaN is considered the same as NaN, however -0 and 0 are considered the same
   * value, which is different from the algorithm described by
   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
   *
   * This is extended further to allow Objects to describe the values they
   * represent, by way of `valueOf` or `equals` (and `hashCode`).
   *
   * Note: because of this extension, the key equality of Immutable.Map and the
   * value equality of Immutable.Set will differ from ES6 Map and Set.
   *
   * ### Defining custom values
   *
   * The easiest way to describe the value an object represents is by implementing
   * `valueOf`. For example, `Date` represents a value by returning a unix
   * timestamp for `valueOf`:
   *
   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
   *     var date2 = new Date(1234567890000);
   *     date1.valueOf(); // 1234567890000
   *     assert( date1 !== date2 );
   *     assert( Immutable.is( date1, date2 ) );
   *
   * Note: overriding `valueOf` may have other implications if you use this object
   * where JavaScript expects a primitive, such as implicit string coercion.
   *
   * For more complex types, especially collections, implementing `valueOf` may
   * not be performant. An alternative is to implement `equals` and `hashCode`.
   *
   * `equals` takes another object, presumably of similar type, and returns true
   * if the it is equal. Equality is symmetrical, so the same result should be
   * returned if this and the argument are flipped.
   *
   *     assert( a.equals(b) === b.equals(a) );
   *
   * `hashCode` returns a 32bit integer number representing the object which will
   * be used to determine how to store the value object in a Map or Set. You must
   * provide both or neither methods, one must not exist without the other.
   *
   * Also, an important relationship between these methods must be upheld: if two
   * values are equal, they *must* return the same hashCode. If the values are not
   * equal, they might have the same hashCode; this is called a hash collision,
   * and while undesirable for performance reasons, it is acceptable.
   *
   *     if (a.equals(b)) {
   *       assert( a.hashCode() === b.hashCode() );
   *     }
   *
   * All Immutable collections implement `equals` and `hashCode`.
   *
   */
  function is(valueA, valueB) {
    if (valueA === valueB || valueA !== valueA && valueB !== valueB) {
      return true;
    }
    if (!valueA || !valueB) {
      return false;
    }
    if (typeof valueA.valueOf === 'function' && typeof valueB.valueOf === 'function') {
      valueA = valueA.valueOf();
      valueB = valueB.valueOf();
      if (valueA === valueB || valueA !== valueA && valueB !== valueB) {
        return true;
      }
      if (!valueA || !valueB) {
        return false;
      }
    }
    if (typeof valueA.equals === 'function' && typeof valueB.equals === 'function' && valueA.equals(valueB)) {
      return true;
    }
    return false;
  }

  function deepEqual(a, b) {
    if (a === b) {
      return true;
    }

    if (!isIterable(b) || a.size !== undefined && b.size !== undefined && a.size !== b.size || a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash || isKeyed(a) !== isKeyed(b) || isIndexed(a) !== isIndexed(b) || isOrdered(a) !== isOrdered(b)) {
      return false;
    }

    if (a.size === 0 && b.size === 0) {
      return true;
    }

    var notAssociative = !isAssociative(a);

    if (isOrdered(a)) {
      var entries = a.entries();
      return b.every(function (v, k) {
        var entry = entries.next().value;
        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
      }) && entries.next().done;
    }

    var flipped = false;

    if (a.size === undefined) {
      if (b.size === undefined) {
        if (typeof a.cacheResult === 'function') {
          a.cacheResult();
        }
      } else {
        flipped = true;
        var _ = a;
        a = b;
        b = _;
      }
    }

    var allEqual = true;
    var bSize = b.__iterate(function (v, k) {
      if (notAssociative ? !a.has(v) : flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
        allEqual = false;
        return false;
      }
    });

    return allEqual && a.size === bSize;
  }

  createClass(Repeat, IndexedSeq);

  function Repeat(value, times) {
    if (!(this instanceof Repeat)) {
      return new Repeat(value, times);
    }
    this._value = value;
    this.size = times === undefined ? Infinity : Math.max(0, times);
    if (this.size === 0) {
      if (EMPTY_REPEAT) {
        return EMPTY_REPEAT;
      }
      EMPTY_REPEAT = this;
    }
  }

  Repeat.prototype.toString = function () {
    if (this.size === 0) {
      return 'Repeat []';
    }
    return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
  };

  Repeat.prototype.get = function (index, notSetValue) {
    return this.has(index) ? this._value : notSetValue;
  };

  Repeat.prototype.includes = function (searchValue) {
    return is(this._value, searchValue);
  };

  Repeat.prototype.slice = function (begin, end) {
    var size = this.size;
    return wholeSlice(begin, end, size) ? this : new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
  };

  Repeat.prototype.reverse = function () {
    return this;
  };

  Repeat.prototype.indexOf = function (searchValue) {
    if (is(this._value, searchValue)) {
      return 0;
    }
    return -1;
  };

  Repeat.prototype.lastIndexOf = function (searchValue) {
    if (is(this._value, searchValue)) {
      return this.size;
    }
    return -1;
  };

  Repeat.prototype.__iterate = function (fn, reverse) {
    for (var ii = 0; ii < this.size; ii++) {
      if (fn(this._value, ii, this) === false) {
        return ii + 1;
      }
    }
    return ii;
  };

  Repeat.prototype.__iterator = function (type, reverse) {
    var this$0 = this;
    var ii = 0;
    return new Iterator(function () {
      return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone();
    });
  };

  Repeat.prototype.equals = function (other) {
    return other instanceof Repeat ? is(this._value, other._value) : deepEqual(other);
  };

  var EMPTY_REPEAT;

  function invariant(condition, error) {
    if (!condition) throw new Error(error);
  }

  createClass(Range, IndexedSeq);

  function Range(start, end, step) {
    if (!(this instanceof Range)) {
      return new Range(start, end, step);
    }
    invariant(step !== 0, 'Cannot step a Range by 0');
    start = start || 0;
    if (end === undefined) {
      end = Infinity;
    }
    step = step === undefined ? 1 : Math.abs(step);
    if (end < start) {
      step = -step;
    }
    this._start = start;
    this._end = end;
    this._step = step;
    this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
    if (this.size === 0) {
      if (EMPTY_RANGE) {
        return EMPTY_RANGE;
      }
      EMPTY_RANGE = this;
    }
  }

  Range.prototype.toString = function () {
    if (this.size === 0) {
      return 'Range []';
    }
    return 'Range [ ' + this._start + '...' + this._end + (this._step !== 1 ? ' by ' + this._step : '') + ' ]';
  };

  Range.prototype.get = function (index, notSetValue) {
    return this.has(index) ? this._start + wrapIndex(this, index) * this._step : notSetValue;
  };

  Range.prototype.includes = function (searchValue) {
    var possibleIndex = (searchValue - this._start) / this._step;
    return possibleIndex >= 0 && possibleIndex < this.size && possibleIndex === Math.floor(possibleIndex);
  };

  Range.prototype.slice = function (begin, end) {
    if (wholeSlice(begin, end, this.size)) {
      return this;
    }
    begin = resolveBegin(begin, this.size);
    end = resolveEnd(end, this.size);
    if (end <= begin) {
      return new Range(0, 0);
    }
    return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
  };

  Range.prototype.indexOf = function (searchValue) {
    var offsetValue = searchValue - this._start;
    if (offsetValue % this._step === 0) {
      var index = offsetValue / this._step;
      if (index >= 0 && index < this.size) {
        return index;
      }
    }
    return -1;
  };

  Range.prototype.lastIndexOf = function (searchValue) {
    return this.indexOf(searchValue);
  };

  Range.prototype.__iterate = function (fn, reverse) {
    var maxIndex = this.size - 1;
    var step = this._step;
    var value = reverse ? this._start + maxIndex * step : this._start;
    for (var ii = 0; ii <= maxIndex; ii++) {
      if (fn(value, ii, this) === false) {
        return ii + 1;
      }
      value += reverse ? -step : step;
    }
    return ii;
  };

  Range.prototype.__iterator = function (type, reverse) {
    var maxIndex = this.size - 1;
    var step = this._step;
    var value = reverse ? this._start + maxIndex * step : this._start;
    var ii = 0;
    return new Iterator(function () {
      var v = value;
      value += reverse ? -step : step;
      return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
    });
  };

  Range.prototype.equals = function (other) {
    return other instanceof Range ? this._start === other._start && this._end === other._end && this._step === other._step : deepEqual(this, other);
  };

  var EMPTY_RANGE;

  createClass(Collection, Iterable);
  function Collection() {
    throw TypeError('Abstract');
  }

  createClass(KeyedCollection, Collection);function KeyedCollection() {}

  createClass(IndexedCollection, Collection);function IndexedCollection() {}

  createClass(SetCollection, Collection);function SetCollection() {}

  Collection.Keyed = KeyedCollection;
  Collection.Indexed = IndexedCollection;
  Collection.Set = SetCollection;

  var imul = typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ? Math.imul : function imul(a, b) {
    a = a | 0; // int
    b = b | 0; // int
    var c = a & 0xffff;
    var d = b & 0xffff;
    // Shift by 0 fixes the sign on the high part.
    return c * d + ((a >>> 16) * d + c * (b >>> 16) << 16 >>> 0) | 0; // int
  };

  // v8 has an optimization for storing 31-bit signed numbers.
  // Values which have either 00 or 11 as the high order bits qualify.
  // This function drops the highest order bit in a signed number, maintaining
  // the sign bit.
  function smi(i32) {
    return i32 >>> 1 & 0x40000000 | i32 & 0xBFFFFFFF;
  }

  function hash(o) {
    if (o === false || o === null || o === undefined) {
      return 0;
    }
    if (typeof o.valueOf === 'function') {
      o = o.valueOf();
      if (o === false || o === null || o === undefined) {
        return 0;
      }
    }
    if (o === true) {
      return 1;
    }
    var type = typeof o === 'undefined' ? 'undefined' : _typeof(o);
    if (type === 'number') {
      if (o !== o || o === Infinity) {
        return 0;
      }
      var h = o | 0;
      if (h !== o) {
        h ^= o * 0xFFFFFFFF;
      }
      while (o > 0xFFFFFFFF) {
        o /= 0xFFFFFFFF;
        h ^= o;
      }
      return smi(h);
    }
    if (type === 'string') {
      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
    }
    if (typeof o.hashCode === 'function') {
      return o.hashCode();
    }
    if (type === 'object') {
      return hashJSObj(o);
    }
    if (typeof o.toString === 'function') {
      return hashString(o.toString());
    }
    throw new Error('Value type ' + type + ' cannot be hashed.');
  }

  function cachedHashString(string) {
    var hash = stringHashCache[string];
    if (hash === undefined) {
      hash = hashString(string);
      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
        STRING_HASH_CACHE_SIZE = 0;
        stringHashCache = {};
      }
      STRING_HASH_CACHE_SIZE++;
      stringHashCache[string] = hash;
    }
    return hash;
  }

  // http://jsperf.com/hashing-strings
  function hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hash = 0;
    for (var ii = 0; ii < string.length; ii++) {
      hash = 31 * hash + string.charCodeAt(ii) | 0;
    }
    return smi(hash);
  }

  function hashJSObj(obj) {
    var hash;
    if (usingWeakMap) {
      hash = weakMap.get(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = obj[UID_HASH_KEY];
    if (hash !== undefined) {
      return hash;
    }

    if (!canDefineProperty) {
      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
      if (hash !== undefined) {
        return hash;
      }

      hash = getIENodeHash(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = ++objHashUID;
    if (objHashUID & 0x40000000) {
      objHashUID = 0;
    }

    if (usingWeakMap) {
      weakMap.set(obj, hash);
    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
      throw new Error('Non-extensible objects are not allowed as keys.');
    } else if (canDefineProperty) {
      Object.defineProperty(obj, UID_HASH_KEY, {
        'enumerable': false,
        'configurable': false,
        'writable': false,
        'value': hash
      });
    } else if (obj.propertyIsEnumerable !== undefined && obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
      // Since we can't define a non-enumerable property on the object
      // we'll hijack one of the less-used non-enumerable properties to
      // save our hash on it. Since this is a function it will not show up in
      // `JSON.stringify` which is what we want.
      obj.propertyIsEnumerable = function () {
        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
      };
      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
    } else if (obj.nodeType !== undefined) {
      // At this point we couldn't get the IE `uniqueID` to use as a hash
      // and we couldn't use a non-enumerable property to exploit the
      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
      // itself.
      obj[UID_HASH_KEY] = hash;
    } else {
      throw new Error('Unable to set a non-enumerable property on object.');
    }

    return hash;
  }

  // Get references to ES5 object methods.
  var isExtensible = Object.isExtensible;

  // True if Object.defineProperty works as expected. IE8 fails this test.
  var canDefineProperty = function () {
    try {
      Object.defineProperty({}, '@', {});
      return true;
    } catch (e) {
      return false;
    }
  }();

  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
  // and avoid memory leaks from the IE cloneNode bug.
  function getIENodeHash(node) {
    if (node && node.nodeType > 0) {
      switch (node.nodeType) {
        case 1:
          // Element
          return node.uniqueID;
        case 9:
          // Document
          return node.documentElement && node.documentElement.uniqueID;
      }
    }
  }

  // If possible, use a WeakMap.
  var usingWeakMap = typeof WeakMap === 'function';
  var weakMap;
  if (usingWeakMap) {
    weakMap = new WeakMap();
  }

  var objHashUID = 0;

  var UID_HASH_KEY = '__immutablehash__';
  if (typeof Symbol === 'function') {
    UID_HASH_KEY = Symbol(UID_HASH_KEY);
  }

  var STRING_HASH_CACHE_MIN_STRLEN = 16;
  var STRING_HASH_CACHE_MAX_SIZE = 255;
  var STRING_HASH_CACHE_SIZE = 0;
  var stringHashCache = {};

  function assertNotInfinite(size) {
    invariant(size !== Infinity, 'Cannot perform this action with an infinite size.');
  }

  createClass(Map, KeyedCollection);

  // @pragma Construction

  function Map(value) {
    return value === null || value === undefined ? emptyMap() : isMap(value) && !isOrdered(value) ? value : emptyMap().withMutations(function (map) {
      var iter = KeyedIterable(value);
      assertNotInfinite(iter.size);
      iter.forEach(function (v, k) {
        return map.set(k, v);
      });
    });
  }

  Map.of = function () {
    var keyValues = SLICE$0.call(arguments, 0);
    return emptyMap().withMutations(function (map) {
      for (var i = 0; i < keyValues.length; i += 2) {
        if (i + 1 >= keyValues.length) {
          throw new Error('Missing value for key: ' + keyValues[i]);
        }
        map.set(keyValues[i], keyValues[i + 1]);
      }
    });
  };

  Map.prototype.toString = function () {
    return this.__toString('Map {', '}');
  };

  // @pragma Access

  Map.prototype.get = function (k, notSetValue) {
    return this._root ? this._root.get(0, undefined, k, notSetValue) : notSetValue;
  };

  // @pragma Modification

  Map.prototype.set = function (k, v) {
    return updateMap(this, k, v);
  };

  Map.prototype.setIn = function (keyPath, v) {
    return this.updateIn(keyPath, NOT_SET, function () {
      return v;
    });
  };

  Map.prototype.remove = function (k) {
    return updateMap(this, k, NOT_SET);
  };

  Map.prototype.deleteIn = function (keyPath) {
    return this.updateIn(keyPath, function () {
      return NOT_SET;
    });
  };

  Map.prototype.update = function (k, notSetValue, updater) {
    return arguments.length === 1 ? k(this) : this.updateIn([k], notSetValue, updater);
  };

  Map.prototype.updateIn = function (keyPath, notSetValue, updater) {
    if (!updater) {
      updater = notSetValue;
      notSetValue = undefined;
    }
    var updatedValue = updateInDeepMap(this, forceIterator(keyPath), notSetValue, updater);
    return updatedValue === NOT_SET ? undefined : updatedValue;
  };

  Map.prototype.clear = function () {
    if (this.size === 0) {
      return this;
    }
    if (this.__ownerID) {
      this.size = 0;
      this._root = null;
      this.__hash = undefined;
      this.__altered = true;
      return this;
    }
    return emptyMap();
  };

  // @pragma Composition

  Map.prototype.merge = function () /*...iters*/{
    return mergeIntoMapWith(this, undefined, arguments);
  };

  Map.prototype.mergeWith = function (merger) {
    var iters = SLICE$0.call(arguments, 1);
    return mergeIntoMapWith(this, merger, iters);
  };

  Map.prototype.mergeIn = function (keyPath) {
    var iters = SLICE$0.call(arguments, 1);
    return this.updateIn(keyPath, emptyMap(), function (m) {
      return typeof m.merge === 'function' ? m.merge.apply(m, iters) : iters[iters.length - 1];
    });
  };

  Map.prototype.mergeDeep = function () /*...iters*/{
    return mergeIntoMapWith(this, deepMerger, arguments);
  };

  Map.prototype.mergeDeepWith = function (merger) {
    var iters = SLICE$0.call(arguments, 1);
    return mergeIntoMapWith(this, deepMergerWith(merger), iters);
  };

  Map.prototype.mergeDeepIn = function (keyPath) {
    var iters = SLICE$0.call(arguments, 1);
    return this.updateIn(keyPath, emptyMap(), function (m) {
      return typeof m.mergeDeep === 'function' ? m.mergeDeep.apply(m, iters) : iters[iters.length - 1];
    });
  };

  Map.prototype.sort = function (comparator) {
    // Late binding
    return OrderedMap(sortFactory(this, comparator));
  };

  Map.prototype.sortBy = function (mapper, comparator) {
    // Late binding
    return OrderedMap(sortFactory(this, comparator, mapper));
  };

  // @pragma Mutability

  Map.prototype.withMutations = function (fn) {
    var mutable = this.asMutable();
    fn(mutable);
    return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
  };

  Map.prototype.asMutable = function () {
    return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
  };

  Map.prototype.asImmutable = function () {
    return this.__ensureOwner();
  };

  Map.prototype.wasAltered = function () {
    return this.__altered;
  };

  Map.prototype.__iterator = function (type, reverse) {
    return new MapIterator(this, type, reverse);
  };

  Map.prototype.__iterate = function (fn, reverse) {
    var this$0 = this;
    var iterations = 0;
    this._root && this._root.iterate(function (entry) {
      iterations++;
      return fn(entry[1], entry[0], this$0);
    }, reverse);
    return iterations;
  };

  Map.prototype.__ensureOwner = function (ownerID) {
    if (ownerID === this.__ownerID) {
      return this;
    }
    if (!ownerID) {
      this.__ownerID = ownerID;
      this.__altered = false;
      return this;
    }
    return makeMap(this.size, this._root, ownerID, this.__hash);
  };

  function isMap(maybeMap) {
    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
  }

  Map.isMap = isMap;

  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';

  var MapPrototype = Map.prototype;
  MapPrototype[IS_MAP_SENTINEL] = true;
  MapPrototype[DELETE] = MapPrototype.remove;
  MapPrototype.removeIn = MapPrototype.deleteIn;

  // #pragma Trie Nodes


  function ArrayMapNode(ownerID, entries) {
    this.ownerID = ownerID;
    this.entries = entries;
  }

  ArrayMapNode.prototype.get = function (shift, keyHash, key, notSetValue) {
    var entries = this.entries;
    for (var ii = 0, len = entries.length; ii < len; ii++) {
      if (is(key, entries[ii][0])) {
        return entries[ii][1];
      }
    }
    return notSetValue;
  };

  ArrayMapNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    var removed = value === NOT_SET;

    var entries = this.entries;
    var idx = 0;
    for (var len = entries.length; idx < len; idx++) {
      if (is(key, entries[idx][0])) {
        break;
      }
    }
    var exists = idx < len;

    if (exists ? entries[idx][1] === value : removed) {
      return this;
    }

    SetRef(didAlter);
    (removed || !exists) && SetRef(didChangeSize);

    if (removed && entries.length === 1) {
      return; // undefined
    }

    if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
      return createNodes(ownerID, entries, key, value);
    }

    var isEditable = ownerID && ownerID === this.ownerID;
    var newEntries = isEditable ? entries : arrCopy(entries);

    if (exists) {
      if (removed) {
        idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
      } else {
        newEntries[idx] = [key, value];
      }
    } else {
      newEntries.push([key, value]);
    }

    if (isEditable) {
      this.entries = newEntries;
      return this;
    }

    return new ArrayMapNode(ownerID, newEntries);
  };

  function BitmapIndexedNode(ownerID, bitmap, nodes) {
    this.ownerID = ownerID;
    this.bitmap = bitmap;
    this.nodes = nodes;
  }

  BitmapIndexedNode.prototype.get = function (shift, keyHash, key, notSetValue) {
    if (keyHash === undefined) {
      keyHash = hash(key);
    }
    var bit = 1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK);
    var bitmap = this.bitmap;
    return (bitmap & bit) === 0 ? notSetValue : this.nodes[popCount(bitmap & bit - 1)].get(shift + SHIFT, keyHash, key, notSetValue);
  };

  BitmapIndexedNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (keyHash === undefined) {
      keyHash = hash(key);
    }
    var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
    var bit = 1 << keyHashFrag;
    var bitmap = this.bitmap;
    var exists = (bitmap & bit) !== 0;

    if (!exists && value === NOT_SET) {
      return this;
    }

    var idx = popCount(bitmap & bit - 1);
    var nodes = this.nodes;
    var node = exists ? nodes[idx] : undefined;
    var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);

    if (newNode === node) {
      return this;
    }

    if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
      return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
    }

    if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
      return nodes[idx ^ 1];
    }

    if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
      return newNode;
    }

    var isEditable = ownerID && ownerID === this.ownerID;
    var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
    var newNodes = exists ? newNode ? setIn(nodes, idx, newNode, isEditable) : spliceOut(nodes, idx, isEditable) : spliceIn(nodes, idx, newNode, isEditable);

    if (isEditable) {
      this.bitmap = newBitmap;
      this.nodes = newNodes;
      return this;
    }

    return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
  };

  function HashArrayMapNode(ownerID, count, nodes) {
    this.ownerID = ownerID;
    this.count = count;
    this.nodes = nodes;
  }

  HashArrayMapNode.prototype.get = function (shift, keyHash, key, notSetValue) {
    if (keyHash === undefined) {
      keyHash = hash(key);
    }
    var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
    var node = this.nodes[idx];
    return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
  };

  HashArrayMapNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (keyHash === undefined) {
      keyHash = hash(key);
    }
    var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
    var removed = value === NOT_SET;
    var nodes = this.nodes;
    var node = nodes[idx];

    if (removed && !node) {
      return this;
    }

    var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
    if (newNode === node) {
      return this;
    }

    var newCount = this.count;
    if (!node) {
      newCount++;
    } else if (!newNode) {
      newCount--;
      if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
        return packNodes(ownerID, nodes, newCount, idx);
      }
    }

    var isEditable = ownerID && ownerID === this.ownerID;
    var newNodes = setIn(nodes, idx, newNode, isEditable);

    if (isEditable) {
      this.count = newCount;
      this.nodes = newNodes;
      return this;
    }

    return new HashArrayMapNode(ownerID, newCount, newNodes);
  };

  function HashCollisionNode(ownerID, keyHash, entries) {
    this.ownerID = ownerID;
    this.keyHash = keyHash;
    this.entries = entries;
  }

  HashCollisionNode.prototype.get = function (shift, keyHash, key, notSetValue) {
    var entries = this.entries;
    for (var ii = 0, len = entries.length; ii < len; ii++) {
      if (is(key, entries[ii][0])) {
        return entries[ii][1];
      }
    }
    return notSetValue;
  };

  HashCollisionNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (keyHash === undefined) {
      keyHash = hash(key);
    }

    var removed = value === NOT_SET;

    if (keyHash !== this.keyHash) {
      if (removed) {
        return this;
      }
      SetRef(didAlter);
      SetRef(didChangeSize);
      return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
    }

    var entries = this.entries;
    var idx = 0;
    for (var len = entries.length; idx < len; idx++) {
      if (is(key, entries[idx][0])) {
        break;
      }
    }
    var exists = idx < len;

    if (exists ? entries[idx][1] === value : removed) {
      return this;
    }

    SetRef(didAlter);
    (removed || !exists) && SetRef(didChangeSize);

    if (removed && len === 2) {
      return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
    }

    var isEditable = ownerID && ownerID === this.ownerID;
    var newEntries = isEditable ? entries : arrCopy(entries);

    if (exists) {
      if (removed) {
        idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
      } else {
        newEntries[idx] = [key, value];
      }
    } else {
      newEntries.push([key, value]);
    }

    if (isEditable) {
      this.entries = newEntries;
      return this;
    }

    return new HashCollisionNode(ownerID, this.keyHash, newEntries);
  };

  function ValueNode(ownerID, keyHash, entry) {
    this.ownerID = ownerID;
    this.keyHash = keyHash;
    this.entry = entry;
  }

  ValueNode.prototype.get = function (shift, keyHash, key, notSetValue) {
    return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
  };

  ValueNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    var removed = value === NOT_SET;
    var keyMatch = is(key, this.entry[0]);
    if (keyMatch ? value === this.entry[1] : removed) {
      return this;
    }

    SetRef(didAlter);

    if (removed) {
      SetRef(didChangeSize);
      return; // undefined
    }

    if (keyMatch) {
      if (ownerID && ownerID === this.ownerID) {
        this.entry[1] = value;
        return this;
      }
      return new ValueNode(ownerID, this.keyHash, [key, value]);
    }

    SetRef(didChangeSize);
    return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
  };

  // #pragma Iterators

  ArrayMapNode.prototype.iterate = HashCollisionNode.prototype.iterate = function (fn, reverse) {
    var entries = this.entries;
    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
        return false;
      }
    }
  };

  BitmapIndexedNode.prototype.iterate = HashArrayMapNode.prototype.iterate = function (fn, reverse) {
    var nodes = this.nodes;
    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
      var node = nodes[reverse ? maxIndex - ii : ii];
      if (node && node.iterate(fn, reverse) === false) {
        return false;
      }
    }
  };

  ValueNode.prototype.iterate = function (fn, reverse) {
    return fn(this.entry);
  };

  createClass(MapIterator, Iterator);

  function MapIterator(map, type, reverse) {
    this._type = type;
    this._reverse = reverse;
    this._stack = map._root && mapIteratorFrame(map._root);
  }

  MapIterator.prototype.next = function () {
    var type = this._type;
    var stack = this._stack;
    while (stack) {
      var node = stack.node;
      var index = stack.index++;
      var maxIndex;
      if (node.entry) {
        if (index === 0) {
          return mapIteratorValue(type, node.entry);
        }
      } else if (node.entries) {
        maxIndex = node.entries.length - 1;
        if (index <= maxIndex) {
          return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
        }
      } else {
        maxIndex = node.nodes.length - 1;
        if (index <= maxIndex) {
          var subNode = node.nodes[this._reverse ? maxIndex - index : index];
          if (subNode) {
            if (subNode.entry) {
              return mapIteratorValue(type, subNode.entry);
            }
            stack = this._stack = mapIteratorFrame(subNode, stack);
          }
          continue;
        }
      }
      stack = this._stack = this._stack.__prev;
    }
    return iteratorDone();
  };

  function mapIteratorValue(type, entry) {
    return iteratorValue(type, entry[0], entry[1]);
  }

  function mapIteratorFrame(node, prev) {
    return {
      node: node,
      index: 0,
      __prev: prev
    };
  }

  function makeMap(size, root, ownerID, hash) {
    var map = Object.create(MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_MAP;
  function emptyMap() {
    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
  }

  function updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
      if (v === NOT_SET) {
        return map;
      }
      newSize = 1;
      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
    } else {
      var didChangeSize = MakeRef(CHANGE_LENGTH);
      var didAlter = MakeRef(DID_ALTER);
      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
      if (!didAlter.value) {
        return map;
      }
      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
      map.size = newSize;
      map._root = newRoot;
      map.__hash = undefined;
      map.__altered = true;
      return map;
    }
    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
  }

  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
      if (value === NOT_SET) {
        return node;
      }
      SetRef(didAlter);
      SetRef(didChangeSize);
      return new ValueNode(ownerID, keyHash, [key, value]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
  }

  function isLeafNode(node) {
    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
  }

  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) {
      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
    }

    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;

    var newNode;
    var nodes = idx1 === idx2 ? [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] : (newNode = new ValueNode(ownerID, keyHash, entry), idx1 < idx2 ? [node, newNode] : [newNode, node]);

    return new BitmapIndexedNode(ownerID, 1 << idx1 | 1 << idx2, nodes);
  }

  function createNodes(ownerID, entries, key, value) {
    if (!ownerID) {
      ownerID = new OwnerID();
    }
    var node = new ValueNode(ownerID, hash(key), [key, value]);
    for (var ii = 0; ii < entries.length; ii++) {
      var entry = entries[ii];
      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
  }

  function packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
      var node = nodes[ii];
      if (node !== undefined && ii !== excluding) {
        bitmap |= bit;
        packedNodes[packedII++] = node;
      }
    }
    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
  }

  function expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array(SIZE);
    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    }
    expandedNodes[including] = node;
    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
  }

  function mergeIntoMapWith(map, merger, iterables) {
    var iters = [];
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = KeyedIterable(value);
      if (!isIterable(value)) {
        iter = iter.map(function (v) {
          return fromJS(v);
        });
      }
      iters.push(iter);
    }
    return mergeIntoCollectionWith(map, merger, iters);
  }

  function deepMerger(existing, value, key) {
    return existing && existing.mergeDeep && isIterable(value) ? existing.mergeDeep(value) : is(existing, value) ? existing : value;
  }

  function deepMergerWith(merger) {
    return function (existing, value, key) {
      if (existing && existing.mergeDeepWith && isIterable(value)) {
        return existing.mergeDeepWith(merger, value);
      }
      var nextValue = merger(existing, value, key);
      return is(existing, nextValue) ? existing : nextValue;
    };
  }

  function mergeIntoCollectionWith(collection, merger, iters) {
    iters = iters.filter(function (x) {
      return x.size !== 0;
    });
    if (iters.length === 0) {
      return collection;
    }
    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
      return collection.constructor(iters[0]);
    }
    return collection.withMutations(function (collection) {
      var mergeIntoMap = merger ? function (value, key) {
        collection.update(key, NOT_SET, function (existing) {
          return existing === NOT_SET ? value : merger(existing, value, key);
        });
      } : function (value, key) {
        collection.set(key, value);
      };
      for (var ii = 0; ii < iters.length; ii++) {
        iters[ii].forEach(mergeIntoMap);
      }
    });
  }

  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
    var isNotSet = existing === NOT_SET;
    var step = keyPathIter.next();
    if (step.done) {
      var existingValue = isNotSet ? notSetValue : existing;
      var newValue = updater(existingValue);
      return newValue === existingValue ? existing : newValue;
    }
    invariant(isNotSet || existing && existing.set, 'invalid keyPath');
    var key = step.value;
    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
    var nextUpdated = updateInDeepMap(nextExisting, keyPathIter, notSetValue, updater);
    return nextUpdated === nextExisting ? existing : nextUpdated === NOT_SET ? existing.remove(key) : (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
  }

  function popCount(x) {
    x = x - (x >> 1 & 0x55555555);
    x = (x & 0x33333333) + (x >> 2 & 0x33333333);
    x = x + (x >> 4) & 0x0f0f0f0f;
    x = x + (x >> 8);
    x = x + (x >> 16);
    return x & 0x7f;
  }

  function setIn(array, idx, val, canEdit) {
    var newArray = canEdit ? array : arrCopy(array);
    newArray[idx] = val;
    return newArray;
  }

  function spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
      array[idx] = val;
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        newArray[ii] = val;
        after = -1;
      } else {
        newArray[ii] = array[ii + after];
      }
    }
    return newArray;
  }

  function spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
      array.pop();
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        after = 1;
      }
      newArray[ii] = array[ii + after];
    }
    return newArray;
  }

  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;

  createClass(List, IndexedCollection);

  // @pragma Construction

  function List(value) {
    var empty = emptyList();
    if (value === null || value === undefined) {
      return empty;
    }
    if (isList(value)) {
      return value;
    }
    var iter = IndexedIterable(value);
    var size = iter.size;
    if (size === 0) {
      return empty;
    }
    assertNotInfinite(size);
    if (size > 0 && size < SIZE) {
      return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
    }
    return empty.withMutations(function (list) {
      list.setSize(size);
      iter.forEach(function (v, i) {
        return list.set(i, v);
      });
    });
  }

  List.of = function () /*...values*/{
    return this(arguments);
  };

  List.prototype.toString = function () {
    return this.__toString('List [', ']');
  };

  // @pragma Access

  List.prototype.get = function (index, notSetValue) {
    index = wrapIndex(this, index);
    if (index >= 0 && index < this.size) {
      index += this._origin;
      var node = listNodeFor(this, index);
      return node && node.array[index & MASK];
    }
    return notSetValue;
  };

  // @pragma Modification

  List.prototype.set = function (index, value) {
    return updateList(this, index, value);
  };

  List.prototype.remove = function (index) {
    return !this.has(index) ? this : index === 0 ? this.shift() : index === this.size - 1 ? this.pop() : this.splice(index, 1);
  };

  List.prototype.insert = function (index, value) {
    return this.splice(index, 0, value);
  };

  List.prototype.clear = function () {
    if (this.size === 0) {
      return this;
    }
    if (this.__ownerID) {
      this.size = this._origin = this._capacity = 0;
      this._level = SHIFT;
      this._root = this._tail = null;
      this.__hash = undefined;
      this.__altered = true;
      return this;
    }
    return emptyList();
  };

  List.prototype.push = function () /*...values*/{
    var values = arguments;
    var oldSize = this.size;
    return this.withMutations(function (list) {
      setListBounds(list, 0, oldSize + values.length);
      for (var ii = 0; ii < values.length; ii++) {
        list.set(oldSize + ii, values[ii]);
      }
    });
  };

  List.prototype.pop = function () {
    return setListBounds(this, 0, -1);
  };

  List.prototype.unshift = function () /*...values*/{
    var values = arguments;
    return this.withMutations(function (list) {
      setListBounds(list, -values.length);
      for (var ii = 0; ii < values.length; ii++) {
        list.set(ii, values[ii]);
      }
    });
  };

  List.prototype.shift = function () {
    return setListBounds(this, 1);
  };

  // @pragma Composition

  List.prototype.merge = function () /*...iters*/{
    return mergeIntoListWith(this, undefined, arguments);
  };

  List.prototype.mergeWith = function (merger) {
    var iters = SLICE$0.call(arguments, 1);
    return mergeIntoListWith(this, merger, iters);
  };

  List.prototype.mergeDeep = function () /*...iters*/{
    return mergeIntoListWith(this, deepMerger, arguments);
  };

  List.prototype.mergeDeepWith = function (merger) {
    var iters = SLICE$0.call(arguments, 1);
    return mergeIntoListWith(this, deepMergerWith(merger), iters);
  };

  List.prototype.setSize = function (size) {
    return setListBounds(this, 0, size);
  };

  // @pragma Iteration

  List.prototype.slice = function (begin, end) {
    var size = this.size;
    if (wholeSlice(begin, end, size)) {
      return this;
    }
    return setListBounds(this, resolveBegin(begin, size), resolveEnd(end, size));
  };

  List.prototype.__iterator = function (type, reverse) {
    var index = 0;
    var values = iterateList(this, reverse);
    return new Iterator(function () {
      var value = values();
      return value === DONE ? iteratorDone() : iteratorValue(type, index++, value);
    });
  };

  List.prototype.__iterate = function (fn, reverse) {
    var index = 0;
    var values = iterateList(this, reverse);
    var value;
    while ((value = values()) !== DONE) {
      if (fn(value, index++, this) === false) {
        break;
      }
    }
    return index;
  };

  List.prototype.__ensureOwner = function (ownerID) {
    if (ownerID === this.__ownerID) {
      return this;
    }
    if (!ownerID) {
      this.__ownerID = ownerID;
      return this;
    }
    return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
  };

  function isList(maybeList) {
    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
  }

  List.isList = isList;

  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';

  var ListPrototype = List.prototype;
  ListPrototype[IS_LIST_SENTINEL] = true;
  ListPrototype[DELETE] = ListPrototype.remove;
  ListPrototype.setIn = MapPrototype.setIn;
  ListPrototype.deleteIn = ListPrototype.removeIn = MapPrototype.removeIn;
  ListPrototype.update = MapPrototype.update;
  ListPrototype.updateIn = MapPrototype.updateIn;
  ListPrototype.mergeIn = MapPrototype.mergeIn;
  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  ListPrototype.withMutations = MapPrototype.withMutations;
  ListPrototype.asMutable = MapPrototype.asMutable;
  ListPrototype.asImmutable = MapPrototype.asImmutable;
  ListPrototype.wasAltered = MapPrototype.wasAltered;

  function VNode(array, ownerID) {
    this.array = array;
    this.ownerID = ownerID;
  }

  // TODO: seems like these methods are very similar

  VNode.prototype.removeBefore = function (ownerID, level, index) {
    if (index === level ? 1 << level : 0 || this.array.length === 0) {
      return this;
    }
    var originIndex = index >>> level & MASK;
    if (originIndex >= this.array.length) {
      return new VNode([], ownerID);
    }
    var removingFirst = originIndex === 0;
    var newChild;
    if (level > 0) {
      var oldChild = this.array[originIndex];
      newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
      if (newChild === oldChild && removingFirst) {
        return this;
      }
    }
    if (removingFirst && !newChild) {
      return this;
    }
    var editable = editableVNode(this, ownerID);
    if (!removingFirst) {
      for (var ii = 0; ii < originIndex; ii++) {
        editable.array[ii] = undefined;
      }
    }
    if (newChild) {
      editable.array[originIndex] = newChild;
    }
    return editable;
  };

  VNode.prototype.removeAfter = function (ownerID, level, index) {
    if (index === (level ? 1 << level : 0) || this.array.length === 0) {
      return this;
    }
    var sizeIndex = index - 1 >>> level & MASK;
    if (sizeIndex >= this.array.length) {
      return this;
    }

    var newChild;
    if (level > 0) {
      var oldChild = this.array[sizeIndex];
      newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
      if (newChild === oldChild && sizeIndex === this.array.length - 1) {
        return this;
      }
    }

    var editable = editableVNode(this, ownerID);
    editable.array.splice(sizeIndex + 1);
    if (newChild) {
      editable.array[sizeIndex] = newChild;
    }
    return editable;
  };

  var DONE = {};

  function iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = getTailOffset(right);
    var tail = list._tail;

    return iterateNodeOrLeaf(list._root, list._level, 0);

    function iterateNodeOrLeaf(node, level, offset) {
      return level === 0 ? iterateLeaf(node, offset) : iterateNode(node, level, offset);
    }

    function iterateLeaf(node, offset) {
      var array = offset === tailPos ? tail && tail.array : node && node.array;
      var from = offset > left ? 0 : left - offset;
      var to = right - offset;
      if (to > SIZE) {
        to = SIZE;
      }
      return function () {
        if (from === to) {
          return DONE;
        }
        var idx = reverse ? --to : from++;
        return array && array[idx];
      };
    }

    function iterateNode(node, level, offset) {
      var values;
      var array = node && node.array;
      var from = offset > left ? 0 : left - offset >> level;
      var to = (right - offset >> level) + 1;
      if (to > SIZE) {
        to = SIZE;
      }
      return function () {
        do {
          if (values) {
            var value = values();
            if (value !== DONE) {
              return value;
            }
            values = null;
          }
          if (from === to) {
            return DONE;
          }
          var idx = reverse ? --to : from++;
          values = iterateNodeOrLeaf(array && array[idx], level - SHIFT, offset + (idx << level));
        } while (true);
      };
    }
  }

  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create(ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
  }

  var EMPTY_LIST;
  function emptyList() {
    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
  }

  function updateList(list, index, value) {
    index = wrapIndex(list, index);

    if (index !== index) {
      return list;
    }

    if (index >= list.size || index < 0) {
      return list.withMutations(function (list) {
        index < 0 ? setListBounds(list, index).set(0, value) : setListBounds(list, 0, index + 1).set(index, value);
      });
    }

    index += list._origin;

    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = MakeRef(DID_ALTER);
    if (index >= getTailOffset(list._capacity)) {
      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    } else {
      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    }

    if (!didAlter.value) {
      return list;
    }

    if (list.__ownerID) {
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
  }

  function updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = index >>> level & MASK;
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) {
      return node;
    }

    var newNode;

    if (level > 0) {
      var lowerNode = node && node.array[idx];
      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
      if (newLowerNode === lowerNode) {
        return node;
      }
      newNode = editableVNode(node, ownerID);
      newNode.array[idx] = newLowerNode;
      return newNode;
    }

    if (nodeHas && node.array[idx] === value) {
      return node;
    }

    SetRef(didAlter);

    newNode = editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) {
      newNode.array.pop();
    } else {
      newNode.array[idx] = value;
    }
    return newNode;
  }

  function editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) {
      return node;
    }
    return new VNode(node ? node.array.slice() : [], ownerID);
  }

  function listNodeFor(list, rawIndex) {
    if (rawIndex >= getTailOffset(list._capacity)) {
      return list._tail;
    }
    if (rawIndex < 1 << list._level + SHIFT) {
      var node = list._root;
      var level = list._level;
      while (node && level > 0) {
        node = node.array[rawIndex >>> level & MASK];
        level -= SHIFT;
      }
      return node;
    }
  }

  function setListBounds(list, begin, end) {
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }
    var owner = list.__ownerID || new OwnerID();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
      return list;
    }

    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) {
      return list.clear();
    }

    var newLevel = list._level;
    var newRoot = list._root;

    // New origin might need creating a higher root.
    var offsetShift = 0;
    while (newOrigin + offsetShift < 0) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
      newLevel += SHIFT;
      offsetShift += 1 << newLevel;
    }
    if (offsetShift) {
      newOrigin += offsetShift;
      oldOrigin += offsetShift;
      newCapacity += offsetShift;
      oldCapacity += offsetShift;
    }

    var oldTailOffset = getTailOffset(oldCapacity);
    var newTailOffset = getTailOffset(newCapacity);

    // New size might need creating a higher root.
    while (newTailOffset >= 1 << newLevel + SHIFT) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
      newLevel += SHIFT;
    }

    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ? listNodeFor(list, newCapacity - 1) : newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;

    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
      newRoot = editableVNode(newRoot, owner);
      var node = newRoot;
      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
        var idx = oldTailOffset >>> level & MASK;
        node = node.array[idx] = editableVNode(node.array[idx], owner);
      }
      node.array[oldTailOffset >>> SHIFT & MASK] = oldTail;
    }

    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) {
      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    }

    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
      newOrigin -= newTailOffset;
      newCapacity -= newTailOffset;
      newLevel = SHIFT;
      newRoot = null;
      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);

      // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
      offsetShift = 0;

      // Identify the new top root node of the subtree of the old root.
      while (newRoot) {
        var beginIndex = newOrigin >>> newLevel & MASK;
        if (beginIndex !== newTailOffset >>> newLevel & MASK) {
          break;
        }
        if (beginIndex) {
          offsetShift += (1 << newLevel) * beginIndex;
        }
        newLevel -= SHIFT;
        newRoot = newRoot.array[beginIndex];
      }

      // Trim the new sides of the new root.
      if (newRoot && newOrigin > oldOrigin) {
        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
      }
      if (newRoot && newTailOffset < oldTailOffset) {
        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
      }
      if (offsetShift) {
        newOrigin -= offsetShift;
        newCapacity -= offsetShift;
      }
    }

    if (list.__ownerID) {
      list.size = newCapacity - newOrigin;
      list._origin = newOrigin;
      list._capacity = newCapacity;
      list._level = newLevel;
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
  }

  function mergeIntoListWith(list, merger, iterables) {
    var iters = [];
    var maxSize = 0;
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = IndexedIterable(value);
      if (iter.size > maxSize) {
        maxSize = iter.size;
      }
      if (!isIterable(value)) {
        iter = iter.map(function (v) {
          return fromJS(v);
        });
      }
      iters.push(iter);
    }
    if (maxSize > list.size) {
      list = list.setSize(maxSize);
    }
    return mergeIntoCollectionWith(list, merger, iters);
  }

  function getTailOffset(size) {
    return size < SIZE ? 0 : size - 1 >>> SHIFT << SHIFT;
  }

  createClass(OrderedMap, Map);

  // @pragma Construction

  function OrderedMap(value) {
    return value === null || value === undefined ? emptyOrderedMap() : isOrderedMap(value) ? value : emptyOrderedMap().withMutations(function (map) {
      var iter = KeyedIterable(value);
      assertNotInfinite(iter.size);
      iter.forEach(function (v, k) {
        return map.set(k, v);
      });
    });
  }

  OrderedMap.of = function () /*...values*/{
    return this(arguments);
  };

  OrderedMap.prototype.toString = function () {
    return this.__toString('OrderedMap {', '}');
  };

  // @pragma Access

  OrderedMap.prototype.get = function (k, notSetValue) {
    var index = this._map.get(k);
    return index !== undefined ? this._list.get(index)[1] : notSetValue;
  };

  // @pragma Modification

  OrderedMap.prototype.clear = function () {
    if (this.size === 0) {
      return this;
    }
    if (this.__ownerID) {
      this.size = 0;
      this._map.clear();
      this._list.clear();
      return this;
    }
    return emptyOrderedMap();
  };

  OrderedMap.prototype.set = function (k, v) {
    return updateOrderedMap(this, k, v);
  };

  OrderedMap.prototype.remove = function (k) {
    return updateOrderedMap(this, k, NOT_SET);
  };

  OrderedMap.prototype.wasAltered = function () {
    return this._map.wasAltered() || this._list.wasAltered();
  };

  OrderedMap.prototype.__iterate = function (fn, reverse) {
    var this$0 = this;
    return this._list.__iterate(function (entry) {
      return entry && fn(entry[1], entry[0], this$0);
    }, reverse);
  };

  OrderedMap.prototype.__iterator = function (type, reverse) {
    return this._list.fromEntrySeq().__iterator(type, reverse);
  };

  OrderedMap.prototype.__ensureOwner = function (ownerID) {
    if (ownerID === this.__ownerID) {
      return this;
    }
    var newMap = this._map.__ensureOwner(ownerID);
    var newList = this._list.__ensureOwner(ownerID);
    if (!ownerID) {
      this.__ownerID = ownerID;
      this._map = newMap;
      this._list = newList;
      return this;
    }
    return makeOrderedMap(newMap, newList, ownerID, this.__hash);
  };

  function isOrderedMap(maybeOrderedMap) {
    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
  }

  OrderedMap.isOrderedMap = isOrderedMap;

  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;

  function makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create(OrderedMap.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    return omap;
  }

  var EMPTY_ORDERED_MAP;
  function emptyOrderedMap() {
    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
  }

  function updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var has = i !== undefined;
    var newMap;
    var newList;
    if (v === NOT_SET) {
      // removed
      if (!has) {
        return omap;
      }
      if (list.size >= SIZE && list.size >= map.size * 2) {
        newList = list.filter(function (entry, idx) {
          return entry !== undefined && i !== idx;
        });
        newMap = newList.toKeyedSeq().map(function (entry) {
          return entry[0];
        }).flip().toMap();
        if (omap.__ownerID) {
          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        }
      } else {
        newMap = map.remove(k);
        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
      }
    } else {
      if (has) {
        if (v === list.get(i)[1]) {
          return omap;
        }
        newMap = map;
        newList = list.set(i, [k, v]);
      } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [k, v]);
      }
    }
    if (omap.__ownerID) {
      omap.size = newMap.size;
      omap._map = newMap;
      omap._list = newList;
      omap.__hash = undefined;
      return omap;
    }
    return makeOrderedMap(newMap, newList);
  }

  createClass(ToKeyedSequence, KeyedSeq);
  function ToKeyedSequence(indexed, useKeys) {
    this._iter = indexed;
    this._useKeys = useKeys;
    this.size = indexed.size;
  }

  ToKeyedSequence.prototype.get = function (key, notSetValue) {
    return this._iter.get(key, notSetValue);
  };

  ToKeyedSequence.prototype.has = function (key) {
    return this._iter.has(key);
  };

  ToKeyedSequence.prototype.valueSeq = function () {
    return this._iter.valueSeq();
  };

  ToKeyedSequence.prototype.reverse = function () {
    var this$0 = this;
    var reversedSequence = reverseFactory(this, true);
    if (!this._useKeys) {
      reversedSequence.valueSeq = function () {
        return this$0._iter.toSeq().reverse();
      };
    }
    return reversedSequence;
  };

  ToKeyedSequence.prototype.map = function (mapper, context) {
    var this$0 = this;
    var mappedSequence = mapFactory(this, mapper, context);
    if (!this._useKeys) {
      mappedSequence.valueSeq = function () {
        return this$0._iter.toSeq().map(mapper, context);
      };
    }
    return mappedSequence;
  };

  ToKeyedSequence.prototype.__iterate = function (fn, reverse) {
    var this$0 = this;
    var ii;
    return this._iter.__iterate(this._useKeys ? function (v, k) {
      return fn(v, k, this$0);
    } : (ii = reverse ? resolveSize(this) : 0, function (v) {
      return fn(v, reverse ? --ii : ii++, this$0);
    }), reverse);
  };

  ToKeyedSequence.prototype.__iterator = function (type, reverse) {
    if (this._useKeys) {
      return this._iter.__iterator(type, reverse);
    }
    var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
    var ii = reverse ? resolveSize(this) : 0;
    return new Iterator(function () {
      var step = iterator.next();
      return step.done ? step : iteratorValue(type, reverse ? --ii : ii++, step.value, step);
    });
  };

  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;

  createClass(ToIndexedSequence, IndexedSeq);
  function ToIndexedSequence(iter) {
    this._iter = iter;
    this.size = iter.size;
  }

  ToIndexedSequence.prototype.includes = function (value) {
    return this._iter.includes(value);
  };

  ToIndexedSequence.prototype.__iterate = function (fn, reverse) {
    var this$0 = this;
    var iterations = 0;
    return this._iter.__iterate(function (v) {
      return fn(v, iterations++, this$0);
    }, reverse);
  };

  ToIndexedSequence.prototype.__iterator = function (type, reverse) {
    var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
    var iterations = 0;
    return new Iterator(function () {
      var step = iterator.next();
      return step.done ? step : iteratorValue(type, iterations++, step.value, step);
    });
  };

  createClass(ToSetSequence, SetSeq);
  function ToSetSequence(iter) {
    this._iter = iter;
    this.size = iter.size;
  }

  ToSetSequence.prototype.has = function (key) {
    return this._iter.includes(key);
  };

  ToSetSequence.prototype.__iterate = function (fn, reverse) {
    var this$0 = this;
    return this._iter.__iterate(function (v) {
      return fn(v, v, this$0);
    }, reverse);
  };

  ToSetSequence.prototype.__iterator = function (type, reverse) {
    var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
    return new Iterator(function () {
      var step = iterator.next();
      return step.done ? step : iteratorValue(type, step.value, step.value, step);
    });
  };

  createClass(FromEntriesSequence, KeyedSeq);
  function FromEntriesSequence(entries) {
    this._iter = entries;
    this.size = entries.size;
  }

  FromEntriesSequence.prototype.entrySeq = function () {
    return this._iter.toSeq();
  };

  FromEntriesSequence.prototype.__iterate = function (fn, reverse) {
    var this$0 = this;
    return this._iter.__iterate(function (entry) {
      // Check if entry exists first so array access doesn't throw for holes
      // in the parent iteration.
      if (entry) {
        validateEntry(entry);
        var indexedIterable = isIterable(entry);
        return fn(indexedIterable ? entry.get(1) : entry[1], indexedIterable ? entry.get(0) : entry[0], this$0);
      }
    }, reverse);
  };

  FromEntriesSequence.prototype.__iterator = function (type, reverse) {
    var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
    return new Iterator(function () {
      while (true) {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        // Check if entry exists first so array access doesn't throw for holes
        // in the parent iteration.
        if (entry) {
          validateEntry(entry);
          var indexedIterable = isIterable(entry);
          return iteratorValue(type, indexedIterable ? entry.get(0) : entry[0], indexedIterable ? entry.get(1) : entry[1], step);
        }
      }
    });
  };

  ToIndexedSequence.prototype.cacheResult = ToKeyedSequence.prototype.cacheResult = ToSetSequence.prototype.cacheResult = FromEntriesSequence.prototype.cacheResult = cacheResultThrough;

  function flipFactory(iterable) {
    var flipSequence = makeSequence(iterable);
    flipSequence._iter = iterable;
    flipSequence.size = iterable.size;
    flipSequence.flip = function () {
      return iterable;
    };
    flipSequence.reverse = function () {
      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
      reversedSequence.flip = function () {
        return iterable.reverse();
      };
      return reversedSequence;
    };
    flipSequence.has = function (key) {
      return iterable.includes(key);
    };
    flipSequence.includes = function (key) {
      return iterable.has(key);
    };
    flipSequence.cacheResult = cacheResultThrough;
    flipSequence.__iterateUncached = function (fn, reverse) {
      var this$0 = this;
      return iterable.__iterate(function (v, k) {
        return fn(k, v, this$0) !== false;
      }, reverse);
    };
    flipSequence.__iteratorUncached = function (type, reverse) {
      if (type === ITERATE_ENTRIES) {
        var iterator = iterable.__iterator(type, reverse);
        return new Iterator(function () {
          var step = iterator.next();
          if (!step.done) {
            var k = step.value[0];
            step.value[0] = step.value[1];
            step.value[1] = k;
          }
          return step;
        });
      }
      return iterable.__iterator(type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES, reverse);
    };
    return flipSequence;
  }

  function mapFactory(iterable, mapper, context) {
    var mappedSequence = makeSequence(iterable);
    mappedSequence.size = iterable.size;
    mappedSequence.has = function (key) {
      return iterable.has(key);
    };
    mappedSequence.get = function (key, notSetValue) {
      var v = iterable.get(key, NOT_SET);
      return v === NOT_SET ? notSetValue : mapper.call(context, v, key, iterable);
    };
    mappedSequence.__iterateUncached = function (fn, reverse) {
      var this$0 = this;
      return iterable.__iterate(function (v, k, c) {
        return fn(mapper.call(context, v, k, c), k, this$0) !== false;
      }, reverse);
    };
    mappedSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      return new Iterator(function () {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var key = entry[0];
        return iteratorValue(type, key, mapper.call(context, entry[1], key, iterable), step);
      });
    };
    return mappedSequence;
  }

  function reverseFactory(iterable, useKeys) {
    var reversedSequence = makeSequence(iterable);
    reversedSequence._iter = iterable;
    reversedSequence.size = iterable.size;
    reversedSequence.reverse = function () {
      return iterable;
    };
    if (iterable.flip) {
      reversedSequence.flip = function () {
        var flipSequence = flipFactory(iterable);
        flipSequence.reverse = function () {
          return iterable.flip();
        };
        return flipSequence;
      };
    }
    reversedSequence.get = function (key, notSetValue) {
      return iterable.get(useKeys ? key : -1 - key, notSetValue);
    };
    reversedSequence.has = function (key) {
      return iterable.has(useKeys ? key : -1 - key);
    };
    reversedSequence.includes = function (value) {
      return iterable.includes(value);
    };
    reversedSequence.cacheResult = cacheResultThrough;
    reversedSequence.__iterate = function (fn, reverse) {
      var this$0 = this;
      return iterable.__iterate(function (v, k) {
        return fn(v, k, this$0);
      }, !reverse);
    };
    reversedSequence.__iterator = function (type, reverse) {
      return iterable.__iterator(type, !reverse);
    };
    return reversedSequence;
  }

  function filterFactory(iterable, predicate, context, useKeys) {
    var filterSequence = makeSequence(iterable);
    if (useKeys) {
      filterSequence.has = function (key) {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
      };
      filterSequence.get = function (key, notSetValue) {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && predicate.call(context, v, key, iterable) ? v : notSetValue;
      };
    }
    filterSequence.__iterateUncached = function (fn, reverse) {
      var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function (v, k, c) {
        if (predicate.call(context, v, k, c)) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      }, reverse);
      return iterations;
    };
    filterSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterations = 0;
      return new Iterator(function () {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          var key = entry[0];
          var value = entry[1];
          if (predicate.call(context, value, key, iterable)) {
            return iteratorValue(type, useKeys ? key : iterations++, value, step);
          }
        }
      });
    };
    return filterSequence;
  }

  function countByFactory(iterable, grouper, context) {
    var groups = Map().asMutable();
    iterable.__iterate(function (v, k) {
      groups.update(grouper.call(context, v, k, iterable), 0, function (a) {
        return a + 1;
      });
    });
    return groups.asImmutable();
  }

  function groupByFactory(iterable, grouper, context) {
    var isKeyedIter = isKeyed(iterable);
    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
    iterable.__iterate(function (v, k) {
      groups.update(grouper.call(context, v, k, iterable), function (a) {
        return a = a || [], a.push(isKeyedIter ? [k, v] : v), a;
      });
    });
    var coerce = iterableClass(iterable);
    return groups.map(function (arr) {
      return reify(iterable, coerce(arr));
    });
  }

  function sliceFactory(iterable, begin, end, useKeys) {
    var originalSize = iterable.size;

    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      if (end === Infinity) {
        end = originalSize;
      } else {
        end = end | 0;
      }
    }

    if (wholeSlice(begin, end, originalSize)) {
      return iterable;
    }

    var resolvedBegin = resolveBegin(begin, originalSize);
    var resolvedEnd = resolveEnd(end, originalSize);

    // begin or end will be NaN if they were provided as negative numbers and
    // this iterable's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
    }

    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) {
      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    }

    var sliceSeq = makeSequence(iterable);

    // If iterable.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;

    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
      sliceSeq.get = function (index, notSetValue) {
        index = wrapIndex(this, index);
        return index >= 0 && index < sliceSize ? iterable.get(index + resolvedBegin, notSetValue) : notSetValue;
      };
    }

    sliceSeq.__iterateUncached = function (fn, reverse) {
      var this$0 = this;
      if (sliceSize === 0) {
        return 0;
      }
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var skipped = 0;
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function (v, k) {
        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0) !== false && iterations !== sliceSize;
        }
      });
      return iterations;
    };

    sliceSeq.__iteratorUncached = function (type, reverse) {
      if (sliceSize !== 0 && reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      // Don't bother instantiating parent iterator if taking 0.
      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
      var skipped = 0;
      var iterations = 0;
      return new Iterator(function () {
        while (skipped++ < resolvedBegin) {
          iterator.next();
        }
        if (++iterations > sliceSize) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (useKeys || type === ITERATE_VALUES) {
          return step;
        } else if (type === ITERATE_KEYS) {
          return iteratorValue(type, iterations - 1, undefined, step);
        } else {
          return iteratorValue(type, iterations - 1, step.value[1], step);
        }
      });
    };

    return sliceSeq;
  }

  function takeWhileFactory(iterable, predicate, context) {
    var takeSequence = makeSequence(iterable);
    takeSequence.__iterateUncached = function (fn, reverse) {
      var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterations = 0;
      iterable.__iterate(function (v, k, c) {
        return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0);
      });
      return iterations;
    };
    takeSequence.__iteratorUncached = function (type, reverse) {
      var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterating = true;
      return new Iterator(function () {
        if (!iterating) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var k = entry[0];
        var v = entry[1];
        if (!predicate.call(context, v, k, this$0)) {
          iterating = false;
          return iteratorDone();
        }
        return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
      });
    };
    return takeSequence;
  }

  function skipWhileFactory(iterable, predicate, context, useKeys) {
    var skipSequence = makeSequence(iterable);
    skipSequence.__iterateUncached = function (fn, reverse) {
      var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function (v, k, c) {
        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      });
      return iterations;
    };
    skipSequence.__iteratorUncached = function (type, reverse) {
      var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var skipping = true;
      var iterations = 0;
      return new Iterator(function () {
        var step, k, v;
        do {
          step = iterator.next();
          if (step.done) {
            if (useKeys || type === ITERATE_VALUES) {
              return step;
            } else if (type === ITERATE_KEYS) {
              return iteratorValue(type, iterations++, undefined, step);
            } else {
              return iteratorValue(type, iterations++, step.value[1], step);
            }
          }
          var entry = step.value;
          k = entry[0];
          v = entry[1];
          skipping && (skipping = predicate.call(context, v, k, this$0));
        } while (skipping);
        return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
      });
    };
    return skipSequence;
  }

  function concatFactory(iterable, values) {
    var isKeyedIterable = isKeyed(iterable);
    var iters = [iterable].concat(values).map(function (v) {
      if (!isIterable(v)) {
        v = isKeyedIterable ? keyedSeqFromValue(v) : indexedSeqFromValue(Array.isArray(v) ? v : [v]);
      } else if (isKeyedIterable) {
        v = KeyedIterable(v);
      }
      return v;
    }).filter(function (v) {
      return v.size !== 0;
    });

    if (iters.length === 0) {
      return iterable;
    }

    if (iters.length === 1) {
      var singleton = iters[0];
      if (singleton === iterable || isKeyedIterable && isKeyed(singleton) || isIndexed(iterable) && isIndexed(singleton)) {
        return singleton;
      }
    }

    var concatSeq = new ArraySeq(iters);
    if (isKeyedIterable) {
      concatSeq = concatSeq.toKeyedSeq();
    } else if (!isIndexed(iterable)) {
      concatSeq = concatSeq.toSetSeq();
    }
    concatSeq = concatSeq.flatten(true);
    concatSeq.size = iters.reduce(function (sum, seq) {
      if (sum !== undefined) {
        var size = seq.size;
        if (size !== undefined) {
          return sum + size;
        }
      }
    }, 0);
    return concatSeq;
  }

  function flattenFactory(iterable, depth, useKeys) {
    var flatSequence = makeSequence(iterable);
    flatSequence.__iterateUncached = function (fn, reverse) {
      var iterations = 0;
      var stopped = false;
      function flatDeep(iter, currentDepth) {
        var this$0 = this;
        iter.__iterate(function (v, k) {
          if ((!depth || currentDepth < depth) && isIterable(v)) {
            flatDeep(v, currentDepth + 1);
          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
            stopped = true;
          }
          return !stopped;
        }, reverse);
      }
      flatDeep(iterable, 0);
      return iterations;
    };
    flatSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(type, reverse);
      var stack = [];
      var iterations = 0;
      return new Iterator(function () {
        while (iterator) {
          var step = iterator.next();
          if (step.done !== false) {
            iterator = stack.pop();
            continue;
          }
          var v = step.value;
          if (type === ITERATE_ENTRIES) {
            v = v[1];
          }
          if ((!depth || stack.length < depth) && isIterable(v)) {
            stack.push(iterator);
            iterator = v.__iterator(type, reverse);
          } else {
            return useKeys ? step : iteratorValue(type, iterations++, v, step);
          }
        }
        return iteratorDone();
      });
    };
    return flatSequence;
  }

  function flatMapFactory(iterable, mapper, context) {
    var coerce = iterableClass(iterable);
    return iterable.toSeq().map(function (v, k) {
      return coerce(mapper.call(context, v, k, iterable));
    }).flatten(true);
  }

  function interposeFactory(iterable, separator) {
    var interposedSequence = makeSequence(iterable);
    interposedSequence.size = iterable.size && iterable.size * 2 - 1;
    interposedSequence.__iterateUncached = function (fn, reverse) {
      var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function (v, k) {
        return (!iterations || fn(separator, iterations++, this$0) !== false) && fn(v, iterations++, this$0) !== false;
      }, reverse);
      return iterations;
    };
    interposedSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      var step;
      return new Iterator(function () {
        if (!step || iterations % 2) {
          step = iterator.next();
          if (step.done) {
            return step;
          }
        }
        return iterations % 2 ? iteratorValue(type, iterations++, separator) : iteratorValue(type, iterations++, step.value, step);
      });
    };
    return interposedSequence;
  }

  function sortFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    var isKeyedIterable = isKeyed(iterable);
    var index = 0;
    var entries = iterable.toSeq().map(function (v, k) {
      return [k, v, index++, mapper ? mapper(v, k, iterable) : v];
    }).toArray();
    entries.sort(function (a, b) {
      return comparator(a[3], b[3]) || a[2] - b[2];
    }).forEach(isKeyedIterable ? function (v, i) {
      entries[i].length = 2;
    } : function (v, i) {
      entries[i] = v[1];
    });
    return isKeyedIterable ? KeyedSeq(entries) : isIndexed(iterable) ? IndexedSeq(entries) : SetSeq(entries);
  }

  function maxFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    if (mapper) {
      var entry = iterable.toSeq().map(function (v, k) {
        return [v, mapper(v, k, iterable)];
      }).reduce(function (a, b) {
        return maxCompare(comparator, a[1], b[1]) ? b : a;
      });
      return entry && entry[0];
    } else {
      return iterable.reduce(function (a, b) {
        return maxCompare(comparator, a, b) ? b : a;
      });
    }
  }

  function maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return comp === 0 && b !== a && (b === undefined || b === null || b !== b) || comp > 0;
  }

  function zipWithFactory(keyIter, zipper, iters) {
    var zipSequence = makeSequence(keyIter);
    zipSequence.size = new ArraySeq(iters).map(function (i) {
      return i.size;
    }).min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function (fn, reverse) {
      /* generic:
      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        iterations++;
        if (fn(step.value[1], step.value[0], this) === false) {
          break;
        }
      }
      return iterations;
      */
      // indexed:
      var iterator = this.__iterator(ITERATE_VALUES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        if (fn(step.value, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };
    zipSequence.__iteratorUncached = function (type, reverse) {
      var iterators = iters.map(function (i) {
        return i = Iterable(i), getIterator(reverse ? i.reverse() : i);
      });
      var iterations = 0;
      var isDone = false;
      return new Iterator(function () {
        var steps;
        if (!isDone) {
          steps = iterators.map(function (i) {
            return i.next();
          });
          isDone = steps.some(function (s) {
            return s.done;
          });
        }
        if (isDone) {
          return iteratorDone();
        }
        return iteratorValue(type, iterations++, zipper.apply(null, steps.map(function (s) {
          return s.value;
        })));
      });
    };
    return zipSequence;
  }

  // #pragma Helper Functions

  function reify(iter, seq) {
    return isSeq(iter) ? seq : iter.constructor(seq);
  }

  function validateEntry(entry) {
    if (entry !== Object(entry)) {
      throw new TypeError('Expected [K, V] tuple: ' + entry);
    }
  }

  function resolveSize(iter) {
    assertNotInfinite(iter.size);
    return ensureSize(iter);
  }

  function iterableClass(iterable) {
    return isKeyed(iterable) ? KeyedIterable : isIndexed(iterable) ? IndexedIterable : SetIterable;
  }

  function makeSequence(iterable) {
    return Object.create((isKeyed(iterable) ? KeyedSeq : isIndexed(iterable) ? IndexedSeq : SetSeq).prototype);
  }

  function cacheResultThrough() {
    if (this._iter.cacheResult) {
      this._iter.cacheResult();
      this.size = this._iter.size;
      return this;
    } else {
      return Seq.prototype.cacheResult.call(this);
    }
  }

  function defaultComparator(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
  }

  function forceIterator(keyPath) {
    var iter = getIterator(keyPath);
    if (!iter) {
      // Array might not be iterable in this environment, so we need a fallback
      // to our wrapped type.
      if (!isArrayLike(keyPath)) {
        throw new TypeError('Expected iterable or array-like: ' + keyPath);
      }
      iter = getIterator(Iterable(keyPath));
    }
    return iter;
  }

  createClass(Record, KeyedCollection);

  function Record(defaultValues, name) {
    var hasInitialized;

    var RecordType = function Record(values) {
      if (values instanceof RecordType) {
        return values;
      }
      if (!(this instanceof RecordType)) {
        return new RecordType(values);
      }
      if (!hasInitialized) {
        hasInitialized = true;
        var keys = Object.keys(defaultValues);
        setProps(RecordTypePrototype, keys);
        RecordTypePrototype.size = keys.length;
        RecordTypePrototype._name = name;
        RecordTypePrototype._keys = keys;
        RecordTypePrototype._defaultValues = defaultValues;
      }
      this._map = Map(values);
    };

    var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
    RecordTypePrototype.constructor = RecordType;

    return RecordType;
  }

  Record.prototype.toString = function () {
    return this.__toString(recordName(this) + ' {', '}');
  };

  // @pragma Access

  Record.prototype.has = function (k) {
    return this._defaultValues.hasOwnProperty(k);
  };

  Record.prototype.get = function (k, notSetValue) {
    if (!this.has(k)) {
      return notSetValue;
    }
    var defaultVal = this._defaultValues[k];
    return this._map ? this._map.get(k, defaultVal) : defaultVal;
  };

  // @pragma Modification

  Record.prototype.clear = function () {
    if (this.__ownerID) {
      this._map && this._map.clear();
      return this;
    }
    var RecordType = this.constructor;
    return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
  };

  Record.prototype.set = function (k, v) {
    if (!this.has(k)) {
      throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
    }
    if (this._map && !this._map.has(k)) {
      var defaultVal = this._defaultValues[k];
      if (v === defaultVal) {
        return this;
      }
    }
    var newMap = this._map && this._map.set(k, v);
    if (this.__ownerID || newMap === this._map) {
      return this;
    }
    return makeRecord(this, newMap);
  };

  Record.prototype.remove = function (k) {
    if (!this.has(k)) {
      return this;
    }
    var newMap = this._map && this._map.remove(k);
    if (this.__ownerID || newMap === this._map) {
      return this;
    }
    return makeRecord(this, newMap);
  };

  Record.prototype.wasAltered = function () {
    return this._map.wasAltered();
  };

  Record.prototype.__iterator = function (type, reverse) {
    var this$0 = this;
    return KeyedIterable(this._defaultValues).map(function (_, k) {
      return this$0.get(k);
    }).__iterator(type, reverse);
  };

  Record.prototype.__iterate = function (fn, reverse) {
    var this$0 = this;
    return KeyedIterable(this._defaultValues).map(function (_, k) {
      return this$0.get(k);
    }).__iterate(fn, reverse);
  };

  Record.prototype.__ensureOwner = function (ownerID) {
    if (ownerID === this.__ownerID) {
      return this;
    }
    var newMap = this._map && this._map.__ensureOwner(ownerID);
    if (!ownerID) {
      this.__ownerID = ownerID;
      this._map = newMap;
      return this;
    }
    return makeRecord(this, newMap, ownerID);
  };

  var RecordPrototype = Record.prototype;
  RecordPrototype[DELETE] = RecordPrototype.remove;
  RecordPrototype.deleteIn = RecordPrototype.removeIn = MapPrototype.removeIn;
  RecordPrototype.merge = MapPrototype.merge;
  RecordPrototype.mergeWith = MapPrototype.mergeWith;
  RecordPrototype.mergeIn = MapPrototype.mergeIn;
  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  RecordPrototype.setIn = MapPrototype.setIn;
  RecordPrototype.update = MapPrototype.update;
  RecordPrototype.updateIn = MapPrototype.updateIn;
  RecordPrototype.withMutations = MapPrototype.withMutations;
  RecordPrototype.asMutable = MapPrototype.asMutable;
  RecordPrototype.asImmutable = MapPrototype.asImmutable;

  function makeRecord(likeRecord, map, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._map = map;
    record.__ownerID = ownerID;
    return record;
  }

  function recordName(record) {
    return record._name || record.constructor.name || 'Record';
  }

  function setProps(prototype, names) {
    try {
      names.forEach(setProp.bind(undefined, prototype));
    } catch (error) {
      // Object.defineProperty failed. Probably IE8.
    }
  }

  function setProp(prototype, name) {
    Object.defineProperty(prototype, name, {
      get: function get() {
        return this.get(name);
      },
      set: function set(value) {
        invariant(this.__ownerID, 'Cannot set on an immutable record.');
        this.set(name, value);
      }
    });
  }

  createClass(Set, SetCollection);

  // @pragma Construction

  function Set(value) {
    return value === null || value === undefined ? emptySet() : isSet(value) && !isOrdered(value) ? value : emptySet().withMutations(function (set) {
      var iter = SetIterable(value);
      assertNotInfinite(iter.size);
      iter.forEach(function (v) {
        return set.add(v);
      });
    });
  }

  Set.of = function () /*...values*/{
    return this(arguments);
  };

  Set.fromKeys = function (value) {
    return this(KeyedIterable(value).keySeq());
  };

  Set.prototype.toString = function () {
    return this.__toString('Set {', '}');
  };

  // @pragma Access

  Set.prototype.has = function (value) {
    return this._map.has(value);
  };

  // @pragma Modification

  Set.prototype.add = function (value) {
    return updateSet(this, this._map.set(value, true));
  };

  Set.prototype.remove = function (value) {
    return updateSet(this, this._map.remove(value));
  };

  Set.prototype.clear = function () {
    return updateSet(this, this._map.clear());
  };

  // @pragma Composition

  Set.prototype.union = function () {
    var iters = SLICE$0.call(arguments, 0);
    iters = iters.filter(function (x) {
      return x.size !== 0;
    });
    if (iters.length === 0) {
      return this;
    }
    if (this.size === 0 && !this.__ownerID && iters.length === 1) {
      return this.constructor(iters[0]);
    }
    return this.withMutations(function (set) {
      for (var ii = 0; ii < iters.length; ii++) {
        SetIterable(iters[ii]).forEach(function (value) {
          return set.add(value);
        });
      }
    });
  };

  Set.prototype.intersect = function () {
    var iters = SLICE$0.call(arguments, 0);
    if (iters.length === 0) {
      return this;
    }
    iters = iters.map(function (iter) {
      return SetIterable(iter);
    });
    var originalSet = this;
    return this.withMutations(function (set) {
      originalSet.forEach(function (value) {
        if (!iters.every(function (iter) {
          return iter.includes(value);
        })) {
          set.remove(value);
        }
      });
    });
  };

  Set.prototype.subtract = function () {
    var iters = SLICE$0.call(arguments, 0);
    if (iters.length === 0) {
      return this;
    }
    iters = iters.map(function (iter) {
      return SetIterable(iter);
    });
    var originalSet = this;
    return this.withMutations(function (set) {
      originalSet.forEach(function (value) {
        if (iters.some(function (iter) {
          return iter.includes(value);
        })) {
          set.remove(value);
        }
      });
    });
  };

  Set.prototype.merge = function () {
    return this.union.apply(this, arguments);
  };

  Set.prototype.mergeWith = function (merger) {
    var iters = SLICE$0.call(arguments, 1);
    return this.union.apply(this, iters);
  };

  Set.prototype.sort = function (comparator) {
    // Late binding
    return OrderedSet(sortFactory(this, comparator));
  };

  Set.prototype.sortBy = function (mapper, comparator) {
    // Late binding
    return OrderedSet(sortFactory(this, comparator, mapper));
  };

  Set.prototype.wasAltered = function () {
    return this._map.wasAltered();
  };

  Set.prototype.__iterate = function (fn, reverse) {
    var this$0 = this;
    return this._map.__iterate(function (_, k) {
      return fn(k, k, this$0);
    }, reverse);
  };

  Set.prototype.__iterator = function (type, reverse) {
    return this._map.map(function (_, k) {
      return k;
    }).__iterator(type, reverse);
  };

  Set.prototype.__ensureOwner = function (ownerID) {
    if (ownerID === this.__ownerID) {
      return this;
    }
    var newMap = this._map.__ensureOwner(ownerID);
    if (!ownerID) {
      this.__ownerID = ownerID;
      this._map = newMap;
      return this;
    }
    return this.__make(newMap, ownerID);
  };

  function isSet(maybeSet) {
    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
  }

  Set.isSet = isSet;

  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';

  var SetPrototype = Set.prototype;
  SetPrototype[IS_SET_SENTINEL] = true;
  SetPrototype[DELETE] = SetPrototype.remove;
  SetPrototype.mergeDeep = SetPrototype.merge;
  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
  SetPrototype.withMutations = MapPrototype.withMutations;
  SetPrototype.asMutable = MapPrototype.asMutable;
  SetPrototype.asImmutable = MapPrototype.asImmutable;

  SetPrototype.__empty = emptySet;
  SetPrototype.__make = makeSet;

  function updateSet(set, newMap) {
    if (set.__ownerID) {
      set.size = newMap.size;
      set._map = newMap;
      return set;
    }
    return newMap === set._map ? set : newMap.size === 0 ? set.__empty() : set.__make(newMap);
  }

  function makeSet(map, ownerID) {
    var set = Object.create(SetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_SET;
  function emptySet() {
    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
  }

  createClass(OrderedSet, Set);

  // @pragma Construction

  function OrderedSet(value) {
    return value === null || value === undefined ? emptyOrderedSet() : isOrderedSet(value) ? value : emptyOrderedSet().withMutations(function (set) {
      var iter = SetIterable(value);
      assertNotInfinite(iter.size);
      iter.forEach(function (v) {
        return set.add(v);
      });
    });
  }

  OrderedSet.of = function () /*...values*/{
    return this(arguments);
  };

  OrderedSet.fromKeys = function (value) {
    return this(KeyedIterable(value).keySeq());
  };

  OrderedSet.prototype.toString = function () {
    return this.__toString('OrderedSet {', '}');
  };

  function isOrderedSet(maybeOrderedSet) {
    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
  }

  OrderedSet.isOrderedSet = isOrderedSet;

  var OrderedSetPrototype = OrderedSet.prototype;
  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;

  OrderedSetPrototype.__empty = emptyOrderedSet;
  OrderedSetPrototype.__make = makeOrderedSet;

  function makeOrderedSet(map, ownerID) {
    var set = Object.create(OrderedSetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_ORDERED_SET;
  function emptyOrderedSet() {
    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
  }

  createClass(Stack, IndexedCollection);

  // @pragma Construction

  function Stack(value) {
    return value === null || value === undefined ? emptyStack() : isStack(value) ? value : emptyStack().unshiftAll(value);
  }

  Stack.of = function () /*...values*/{
    return this(arguments);
  };

  Stack.prototype.toString = function () {
    return this.__toString('Stack [', ']');
  };

  // @pragma Access

  Stack.prototype.get = function (index, notSetValue) {
    var head = this._head;
    index = wrapIndex(this, index);
    while (head && index--) {
      head = head.next;
    }
    return head ? head.value : notSetValue;
  };

  Stack.prototype.peek = function () {
    return this._head && this._head.value;
  };

  // @pragma Modification

  Stack.prototype.push = function () /*...values*/{
    if (arguments.length === 0) {
      return this;
    }
    var newSize = this.size + arguments.length;
    var head = this._head;
    for (var ii = arguments.length - 1; ii >= 0; ii--) {
      head = {
        value: arguments[ii],
        next: head
      };
    }
    if (this.__ownerID) {
      this.size = newSize;
      this._head = head;
      this.__hash = undefined;
      this.__altered = true;
      return this;
    }
    return makeStack(newSize, head);
  };

  Stack.prototype.pushAll = function (iter) {
    iter = IndexedIterable(iter);
    if (iter.size === 0) {
      return this;
    }
    assertNotInfinite(iter.size);
    var newSize = this.size;
    var head = this._head;
    iter.reverse().forEach(function (value) {
      newSize++;
      head = {
        value: value,
        next: head
      };
    });
    if (this.__ownerID) {
      this.size = newSize;
      this._head = head;
      this.__hash = undefined;
      this.__altered = true;
      return this;
    }
    return makeStack(newSize, head);
  };

  Stack.prototype.pop = function () {
    return this.slice(1);
  };

  Stack.prototype.unshift = function () /*...values*/{
    return this.push.apply(this, arguments);
  };

  Stack.prototype.unshiftAll = function (iter) {
    return this.pushAll(iter);
  };

  Stack.prototype.shift = function () {
    return this.pop.apply(this, arguments);
  };

  Stack.prototype.clear = function () {
    if (this.size === 0) {
      return this;
    }
    if (this.__ownerID) {
      this.size = 0;
      this._head = undefined;
      this.__hash = undefined;
      this.__altered = true;
      return this;
    }
    return emptyStack();
  };

  Stack.prototype.slice = function (begin, end) {
    if (wholeSlice(begin, end, this.size)) {
      return this;
    }
    var resolvedBegin = resolveBegin(begin, this.size);
    var resolvedEnd = resolveEnd(end, this.size);
    if (resolvedEnd !== this.size) {
      // super.slice(begin, end);
      return IndexedCollection.prototype.slice.call(this, begin, end);
    }
    var newSize = this.size - resolvedBegin;
    var head = this._head;
    while (resolvedBegin--) {
      head = head.next;
    }
    if (this.__ownerID) {
      this.size = newSize;
      this._head = head;
      this.__hash = undefined;
      this.__altered = true;
      return this;
    }
    return makeStack(newSize, head);
  };

  // @pragma Mutability

  Stack.prototype.__ensureOwner = function (ownerID) {
    if (ownerID === this.__ownerID) {
      return this;
    }
    if (!ownerID) {
      this.__ownerID = ownerID;
      this.__altered = false;
      return this;
    }
    return makeStack(this.size, this._head, ownerID, this.__hash);
  };

  // @pragma Iteration

  Stack.prototype.__iterate = function (fn, reverse) {
    if (reverse) {
      return this.reverse().__iterate(fn);
    }
    var iterations = 0;
    var node = this._head;
    while (node) {
      if (fn(node.value, iterations++, this) === false) {
        break;
      }
      node = node.next;
    }
    return iterations;
  };

  Stack.prototype.__iterator = function (type, reverse) {
    if (reverse) {
      return this.reverse().__iterator(type);
    }
    var iterations = 0;
    var node = this._head;
    return new Iterator(function () {
      if (node) {
        var value = node.value;
        node = node.next;
        return iteratorValue(type, iterations++, value);
      }
      return iteratorDone();
    });
  };

  function isStack(maybeStack) {
    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
  }

  Stack.isStack = isStack;

  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';

  var StackPrototype = Stack.prototype;
  StackPrototype[IS_STACK_SENTINEL] = true;
  StackPrototype.withMutations = MapPrototype.withMutations;
  StackPrototype.asMutable = MapPrototype.asMutable;
  StackPrototype.asImmutable = MapPrototype.asImmutable;
  StackPrototype.wasAltered = MapPrototype.wasAltered;

  function makeStack(size, head, ownerID, hash) {
    var map = Object.create(StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_STACK;
  function emptyStack() {
    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
  }

  /**
   * Contributes additional methods to a constructor
   */
  function mixin(ctor, methods) {
    var keyCopier = function keyCopier(key) {
      ctor.prototype[key] = methods[key];
    };
    Object.keys(methods).forEach(keyCopier);
    Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
  }

  Iterable.Iterator = Iterator;

  mixin(Iterable, {

    // ### Conversion to other types

    toArray: function toArray() {
      assertNotInfinite(this.size);
      var array = new Array(this.size || 0);
      this.valueSeq().__iterate(function (v, i) {
        array[i] = v;
      });
      return array;
    },

    toIndexedSeq: function toIndexedSeq() {
      return new ToIndexedSequence(this);
    },

    toJS: function toJS() {
      return this.toSeq().map(function (value) {
        return value && typeof value.toJS === 'function' ? value.toJS() : value;
      }).__toJS();
    },

    toJSON: function toJSON() {
      return this.toSeq().map(function (value) {
        return value && typeof value.toJSON === 'function' ? value.toJSON() : value;
      }).__toJS();
    },

    toKeyedSeq: function toKeyedSeq() {
      return new ToKeyedSequence(this, true);
    },

    toMap: function toMap() {
      // Use Late Binding here to solve the circular dependency.
      return Map(this.toKeyedSeq());
    },

    toObject: function toObject() {
      assertNotInfinite(this.size);
      var object = {};
      this.__iterate(function (v, k) {
        object[k] = v;
      });
      return object;
    },

    toOrderedMap: function toOrderedMap() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedMap(this.toKeyedSeq());
    },

    toOrderedSet: function toOrderedSet() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
    },

    toSet: function toSet() {
      // Use Late Binding here to solve the circular dependency.
      return Set(isKeyed(this) ? this.valueSeq() : this);
    },

    toSetSeq: function toSetSeq() {
      return new ToSetSequence(this);
    },

    toSeq: function toSeq() {
      return isIndexed(this) ? this.toIndexedSeq() : isKeyed(this) ? this.toKeyedSeq() : this.toSetSeq();
    },

    toStack: function toStack() {
      // Use Late Binding here to solve the circular dependency.
      return Stack(isKeyed(this) ? this.valueSeq() : this);
    },

    toList: function toList() {
      // Use Late Binding here to solve the circular dependency.
      return List(isKeyed(this) ? this.valueSeq() : this);
    },

    // ### Common JavaScript methods and properties

    toString: function toString() {
      return '[Iterable]';
    },

    __toString: function __toString(head, tail) {
      if (this.size === 0) {
        return head + tail;
      }
      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
    },

    // ### ES6 Collection methods (ES6 Array and Map)

    concat: function concat() {
      var values = SLICE$0.call(arguments, 0);
      return reify(this, concatFactory(this, values));
    },

    includes: function includes(searchValue) {
      return this.some(function (value) {
        return is(value, searchValue);
      });
    },

    entries: function entries() {
      return this.__iterator(ITERATE_ENTRIES);
    },

    every: function every(predicate, context) {
      assertNotInfinite(this.size);
      var returnValue = true;
      this.__iterate(function (v, k, c) {
        if (!predicate.call(context, v, k, c)) {
          returnValue = false;
          return false;
        }
      });
      return returnValue;
    },

    filter: function filter(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, true));
    },

    find: function find(predicate, context, notSetValue) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[1] : notSetValue;
    },

    forEach: function forEach(sideEffect, context) {
      assertNotInfinite(this.size);
      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },

    join: function join(separator) {
      assertNotInfinite(this.size);
      separator = separator !== undefined ? '' + separator : ',';
      var joined = '';
      var isFirst = true;
      this.__iterate(function (v) {
        isFirst ? isFirst = false : joined += separator;
        joined += v !== null && v !== undefined ? v.toString() : '';
      });
      return joined;
    },

    keys: function keys() {
      return this.__iterator(ITERATE_KEYS);
    },

    map: function map(mapper, context) {
      return reify(this, mapFactory(this, mapper, context));
    },

    reduce: function reduce(reducer, initialReduction, context) {
      assertNotInfinite(this.size);
      var reduction;
      var useFirst;
      if (arguments.length < 2) {
        useFirst = true;
      } else {
        reduction = initialReduction;
      }
      this.__iterate(function (v, k, c) {
        if (useFirst) {
          useFirst = false;
          reduction = v;
        } else {
          reduction = reducer.call(context, reduction, v, k, c);
        }
      });
      return reduction;
    },

    reduceRight: function reduceRight(reducer, initialReduction, context) {
      var reversed = this.toKeyedSeq().reverse();
      return reversed.reduce.apply(reversed, arguments);
    },

    reverse: function reverse() {
      return reify(this, reverseFactory(this, true));
    },

    slice: function slice(begin, end) {
      return reify(this, sliceFactory(this, begin, end, true));
    },

    some: function some(predicate, context) {
      return !this.every(not(predicate), context);
    },

    sort: function sort(comparator) {
      return reify(this, sortFactory(this, comparator));
    },

    values: function values() {
      return this.__iterator(ITERATE_VALUES);
    },

    // ### More sequential methods

    butLast: function butLast() {
      return this.slice(0, -1);
    },

    isEmpty: function isEmpty() {
      return this.size !== undefined ? this.size === 0 : !this.some(function () {
        return true;
      });
    },

    count: function count(predicate, context) {
      return ensureSize(predicate ? this.toSeq().filter(predicate, context) : this);
    },

    countBy: function countBy(grouper, context) {
      return countByFactory(this, grouper, context);
    },

    equals: function equals(other) {
      return deepEqual(this, other);
    },

    entrySeq: function entrySeq() {
      var iterable = this;
      if (iterable._cache) {
        // We cache as an entries array, so we can just return the cache!
        return new ArraySeq(iterable._cache);
      }
      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
      entriesSequence.fromEntrySeq = function () {
        return iterable.toSeq();
      };
      return entriesSequence;
    },

    filterNot: function filterNot(predicate, context) {
      return this.filter(not(predicate), context);
    },

    findEntry: function findEntry(predicate, context, notSetValue) {
      var found = notSetValue;
      this.__iterate(function (v, k, c) {
        if (predicate.call(context, v, k, c)) {
          found = [k, v];
          return false;
        }
      });
      return found;
    },

    findKey: function findKey(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry && entry[0];
    },

    findLast: function findLast(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },

    findLastEntry: function findLastEntry(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
    },

    findLastKey: function findLastKey(predicate, context) {
      return this.toKeyedSeq().reverse().findKey(predicate, context);
    },

    first: function first() {
      return this.find(returnTrue);
    },

    flatMap: function flatMap(mapper, context) {
      return reify(this, flatMapFactory(this, mapper, context));
    },

    flatten: function flatten(depth) {
      return reify(this, flattenFactory(this, depth, true));
    },

    fromEntrySeq: function fromEntrySeq() {
      return new FromEntriesSequence(this);
    },

    get: function get(searchKey, notSetValue) {
      return this.find(function (_, key) {
        return is(key, searchKey);
      }, undefined, notSetValue);
    },

    getIn: function getIn(searchKeyPath, notSetValue) {
      var nested = this;
      // Note: in an ES6 environment, we would prefer:
      // for (var key of searchKeyPath) {
      var iter = forceIterator(searchKeyPath);
      var step;
      while (!(step = iter.next()).done) {
        var key = step.value;
        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
        if (nested === NOT_SET) {
          return notSetValue;
        }
      }
      return nested;
    },

    groupBy: function groupBy(grouper, context) {
      return groupByFactory(this, grouper, context);
    },

    has: function has(searchKey) {
      return this.get(searchKey, NOT_SET) !== NOT_SET;
    },

    hasIn: function hasIn(searchKeyPath) {
      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
    },

    isSubset: function isSubset(iter) {
      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
      return this.every(function (value) {
        return iter.includes(value);
      });
    },

    isSuperset: function isSuperset(iter) {
      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
      return iter.isSubset(this);
    },

    keyOf: function keyOf(searchValue) {
      return this.findKey(function (value) {
        return is(value, searchValue);
      });
    },

    keySeq: function keySeq() {
      return this.toSeq().map(keyMapper).toIndexedSeq();
    },

    last: function last() {
      return this.toSeq().reverse().first();
    },

    lastKeyOf: function lastKeyOf(searchValue) {
      return this.toKeyedSeq().reverse().keyOf(searchValue);
    },

    max: function max(comparator) {
      return maxFactory(this, comparator);
    },

    maxBy: function maxBy(mapper, comparator) {
      return maxFactory(this, comparator, mapper);
    },

    min: function min(comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
    },

    minBy: function minBy(mapper, comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
    },

    rest: function rest() {
      return this.slice(1);
    },

    skip: function skip(amount) {
      return this.slice(Math.max(0, amount));
    },

    skipLast: function skipLast(amount) {
      return reify(this, this.toSeq().reverse().skip(amount).reverse());
    },

    skipWhile: function skipWhile(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, true));
    },

    skipUntil: function skipUntil(predicate, context) {
      return this.skipWhile(not(predicate), context);
    },

    sortBy: function sortBy(mapper, comparator) {
      return reify(this, sortFactory(this, comparator, mapper));
    },

    take: function take(amount) {
      return this.slice(0, Math.max(0, amount));
    },

    takeLast: function takeLast(amount) {
      return reify(this, this.toSeq().reverse().take(amount).reverse());
    },

    takeWhile: function takeWhile(predicate, context) {
      return reify(this, takeWhileFactory(this, predicate, context));
    },

    takeUntil: function takeUntil(predicate, context) {
      return this.takeWhile(not(predicate), context);
    },

    valueSeq: function valueSeq() {
      return this.toIndexedSeq();
    },

    // ### Hashable Object

    hashCode: function hashCode() {
      return this.__hash || (this.__hash = hashIterable(this));
    }

    // ### Internal

    // abstract __iterate(fn, reverse)

    // abstract __iterator(type, reverse)
  });

  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  var IterablePrototype = Iterable.prototype;
  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
  IterablePrototype.__toJS = IterablePrototype.toArray;
  IterablePrototype.__toStringMapper = quoteString;
  IterablePrototype.inspect = IterablePrototype.toSource = function () {
    return this.toString();
  };
  IterablePrototype.chain = IterablePrototype.flatMap;
  IterablePrototype.contains = IterablePrototype.includes;

  mixin(KeyedIterable, {

    // ### More sequential methods

    flip: function flip() {
      return reify(this, flipFactory(this));
    },

    mapEntries: function mapEntries(mapper, context) {
      var this$0 = this;
      var iterations = 0;
      return reify(this, this.toSeq().map(function (v, k) {
        return mapper.call(context, [k, v], iterations++, this$0);
      }).fromEntrySeq());
    },

    mapKeys: function mapKeys(mapper, context) {
      var this$0 = this;
      return reify(this, this.toSeq().flip().map(function (k, v) {
        return mapper.call(context, k, v, this$0);
      }).flip());
    }

  });

  var KeyedIterablePrototype = KeyedIterable.prototype;
  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
  KeyedIterablePrototype.__toStringMapper = function (v, k) {
    return JSON.stringify(k) + ': ' + quoteString(v);
  };

  mixin(IndexedIterable, {

    // ### Conversion to other types

    toKeyedSeq: function toKeyedSeq() {
      return new ToKeyedSequence(this, false);
    },

    // ### ES6 Collection methods (ES6 Array and Map)

    filter: function filter(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, false));
    },

    findIndex: function findIndex(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    indexOf: function indexOf(searchValue) {
      var key = this.keyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    lastIndexOf: function lastIndexOf(searchValue) {
      var key = this.lastKeyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    reverse: function reverse() {
      return reify(this, reverseFactory(this, false));
    },

    slice: function slice(begin, end) {
      return reify(this, sliceFactory(this, begin, end, false));
    },

    splice: function splice(index, removeNum /*, ...values*/) {
      var numArgs = arguments.length;
      removeNum = Math.max(removeNum | 0, 0);
      if (numArgs === 0 || numArgs === 2 && !removeNum) {
        return this;
      }
      // If index is negative, it should resolve relative to the size of the
      // collection. However size may be expensive to compute if not cached, so
      // only call count() if the number is in fact negative.
      index = resolveBegin(index, index < 0 ? this.count() : this.size);
      var spliced = this.slice(0, index);
      return reify(this, numArgs === 1 ? spliced : spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum)));
    },

    // ### More collection methods

    findLastIndex: function findLastIndex(predicate, context) {
      var entry = this.findLastEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    first: function first() {
      return this.get(0);
    },

    flatten: function flatten(depth) {
      return reify(this, flattenFactory(this, depth, false));
    },

    get: function get(index, notSetValue) {
      index = wrapIndex(this, index);
      return index < 0 || this.size === Infinity || this.size !== undefined && index > this.size ? notSetValue : this.find(function (_, key) {
        return key === index;
      }, undefined, notSetValue);
    },

    has: function has(index) {
      index = wrapIndex(this, index);
      return index >= 0 && (this.size !== undefined ? this.size === Infinity || index < this.size : this.indexOf(index) !== -1);
    },

    interpose: function interpose(separator) {
      return reify(this, interposeFactory(this, separator));
    },

    interleave: function interleave() /*...iterables*/{
      var iterables = [this].concat(arrCopy(arguments));
      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
      var interleaved = zipped.flatten(true);
      if (zipped.size) {
        interleaved.size = zipped.size * iterables.length;
      }
      return reify(this, interleaved);
    },

    keySeq: function keySeq() {
      return Range(0, this.size);
    },

    last: function last() {
      return this.get(-1);
    },

    skipWhile: function skipWhile(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, false));
    },

    zip: function zip() /*, ...iterables */{
      var iterables = [this].concat(arrCopy(arguments));
      return reify(this, zipWithFactory(this, defaultZipper, iterables));
    },

    zipWith: function zipWith(zipper /*, ...iterables */) {
      var iterables = arrCopy(arguments);
      iterables[0] = this;
      return reify(this, zipWithFactory(this, zipper, iterables));
    }

  });

  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;

  mixin(SetIterable, {

    // ### ES6 Collection methods (ES6 Array and Map)

    get: function get(value, notSetValue) {
      return this.has(value) ? value : notSetValue;
    },

    includes: function includes(value) {
      return this.has(value);
    },

    // ### More sequential methods

    keySeq: function keySeq() {
      return this.valueSeq();
    }

  });

  SetIterable.prototype.has = IterablePrototype.includes;
  SetIterable.prototype.contains = SetIterable.prototype.includes;

  // Mixin subclasses

  mixin(KeyedSeq, KeyedIterable.prototype);
  mixin(IndexedSeq, IndexedIterable.prototype);
  mixin(SetSeq, SetIterable.prototype);

  mixin(KeyedCollection, KeyedIterable.prototype);
  mixin(IndexedCollection, IndexedIterable.prototype);
  mixin(SetCollection, SetIterable.prototype);

  // #pragma Helper functions

  function keyMapper(v, k) {
    return k;
  }

  function entryMapper(v, k) {
    return [k, v];
  }

  function not(predicate) {
    return function () {
      return !predicate.apply(this, arguments);
    };
  }

  function neg(predicate) {
    return function () {
      return -predicate.apply(this, arguments);
    };
  }

  function quoteString(value) {
    return typeof value === 'string' ? JSON.stringify(value) : String(value);
  }

  function defaultZipper() {
    return arrCopy(arguments);
  }

  function defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
  }

  function hashIterable(iterable) {
    if (iterable.size === Infinity) {
      return 0;
    }
    var ordered = isOrdered(iterable);
    var keyed = isKeyed(iterable);
    var h = ordered ? 1 : 0;
    var size = iterable.__iterate(keyed ? ordered ? function (v, k) {
      h = 31 * h + hashMerge(hash(v), hash(k)) | 0;
    } : function (v, k) {
      h = h + hashMerge(hash(v), hash(k)) | 0;
    } : ordered ? function (v) {
      h = 31 * h + hash(v) | 0;
    } : function (v) {
      h = h + hash(v) | 0;
    });
    return murmurHashOfSize(size, h);
  }

  function murmurHashOfSize(size, h) {
    h = imul(h, 0xCC9E2D51);
    h = imul(h << 15 | h >>> -15, 0x1B873593);
    h = imul(h << 13 | h >>> -13, 5);
    h = (h + 0xE6546B64 | 0) ^ size;
    h = imul(h ^ h >>> 16, 0x85EBCA6B);
    h = imul(h ^ h >>> 13, 0xC2B2AE35);
    h = smi(h ^ h >>> 16);
    return h;
  }

  function hashMerge(a, b) {
    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
  }

  var Immutable = {

    Iterable: Iterable,

    Seq: Seq,
    Collection: Collection,
    Map: Map,
    OrderedMap: OrderedMap,
    List: List,
    Stack: Stack,
    Set: Set,
    OrderedSet: OrderedSet,

    Record: Record,
    Range: Range,
    Repeat: Repeat,

    is: is,
    fromJS: fromJS

  };

  return Immutable;
});

/***/ }),
/* 45 */,
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.iamMessages = exports.PAGES = exports.config = undefined;

var _pages = __webpack_require__(360);

Object.defineProperty(exports, 'PAGES', {
	enumerable: true,
	get: function get() {
		return _pages.PAGES;
	}
});

var _iamMessages = __webpack_require__(359);

Object.defineProperty(exports, 'iamMessages', {
	enumerable: true,
	get: function get() {
		return _iamMessages.iamMessages;
	}
});

var _config2 = __webpack_require__(358);

var _config3 = _interopRequireDefault(_config2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.config = _config3.default;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var core = module.exports = { version: '2.4.0' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// optional / simple context binding
var aFunction = __webpack_require__(25);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1:
      return function (a) {
        return fn.call(that, a);
      };
    case 2:
      return function (a, b) {
        return fn.call(that, a, b);
      };
    case 3:
      return function (a, b, c) {
        return fn.call(that, a, b, c);
      };
  }
  return function () /* ...args */{
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var Map = __webpack_require__(241),
    $export = __webpack_require__(0),
    shared = __webpack_require__(124)('metadata'),
    store = shared.store || (shared.store = new (__webpack_require__(244))());

var getOrCreateMetadataMap = function getOrCreateMetadataMap(target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  }return keyMetadata;
};
var ordinaryHasOwnMetadata = function ordinaryHasOwnMetadata(MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function ordinaryGetOwnMetadata(MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function ordinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function ordinaryOwnMetadataKeys(target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false),
      keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) {
    keys.push(key);
  });
  return keys;
};
var toMetaKey = function toMetaKey(it) {
  return it === undefined || (typeof it === 'undefined' ? 'undefined' : _typeof(it)) == 'symbol' ? it : String(it);
};
var exp = function exp(O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

if (__webpack_require__(12)) {
  var LIBRARY = __webpack_require__(65),
      global = __webpack_require__(6),
      fails = __webpack_require__(7),
      $export = __webpack_require__(0),
      $typed = __webpack_require__(125),
      $buffer = __webpack_require__(165),
      ctx = __webpack_require__(48),
      anInstance = __webpack_require__(64),
      propertyDesc = __webpack_require__(56),
      hide = __webpack_require__(26),
      redefineAll = __webpack_require__(69),
      toInteger = __webpack_require__(57),
      toLength = __webpack_require__(16),
      toIndex = __webpack_require__(71),
      toPrimitive = __webpack_require__(43),
      has = __webpack_require__(23),
      same = __webpack_require__(238),
      classof = __webpack_require__(96),
      isObject = __webpack_require__(9),
      toObject = __webpack_require__(17),
      isArrayIter = __webpack_require__(150),
      create = __webpack_require__(66),
      getPrototypeOf = __webpack_require__(34),
      gOPN = __webpack_require__(67).f,
      getIterFn = __webpack_require__(167),
      uid = __webpack_require__(72),
      wks = __webpack_require__(11),
      createArrayMethod = __webpack_require__(41),
      createArrayIncludes = __webpack_require__(115),
      speciesConstructor = __webpack_require__(159),
      ArrayIterators = __webpack_require__(168),
      Iterators = __webpack_require__(78),
      $iterDetect = __webpack_require__(121),
      setSpecies = __webpack_require__(70),
      arrayFill = __webpack_require__(143),
      arrayCopyWithin = __webpack_require__(218),
      $DP = __webpack_require__(13),
      $GOPD = __webpack_require__(33),
      dP = $DP.f,
      gOPD = $GOPD.f,
      RangeError = global.RangeError,
      TypeError = global.TypeError,
      Uint8Array = global.Uint8Array,
      ARRAY_BUFFER = 'ArrayBuffer',
      SHARED_BUFFER = 'Shared' + ARRAY_BUFFER,
      BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT',
      PROTOTYPE = 'prototype',
      ArrayProto = Array[PROTOTYPE],
      $ArrayBuffer = $buffer.ArrayBuffer,
      $DataView = $buffer.DataView,
      arrayForEach = createArrayMethod(0),
      arrayFilter = createArrayMethod(2),
      arraySome = createArrayMethod(3),
      arrayEvery = createArrayMethod(4),
      arrayFind = createArrayMethod(5),
      arrayFindIndex = createArrayMethod(6),
      arrayIncludes = createArrayIncludes(true),
      arrayIndexOf = createArrayIncludes(false),
      arrayValues = ArrayIterators.values,
      arrayKeys = ArrayIterators.keys,
      arrayEntries = ArrayIterators.entries,
      arrayLastIndexOf = ArrayProto.lastIndexOf,
      arrayReduce = ArrayProto.reduce,
      arrayReduceRight = ArrayProto.reduceRight,
      arrayJoin = ArrayProto.join,
      arraySort = ArrayProto.sort,
      arraySlice = ArrayProto.slice,
      arrayToString = ArrayProto.toString,
      arrayToLocaleString = ArrayProto.toLocaleString,
      ITERATOR = wks('iterator'),
      TAG = wks('toStringTag'),
      TYPED_CONSTRUCTOR = uid('typed_constructor'),
      DEF_CONSTRUCTOR = uid('def_constructor'),
      ALL_CONSTRUCTORS = $typed.CONSTR,
      TYPED_ARRAY = $typed.TYPED,
      VIEW = $typed.VIEW,
      WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var strictToLength = function strictToLength(it, SAME) {
    if (it === undefined) throw TypeError(WRONG_LENGTH);
    var number = +it,
        length = toLength(it);
    if (SAME && !same(number, length)) throw RangeError(WRONG_LENGTH);
    return length;
  };

  var toOffset = function toOffset(it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function validate(it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function allocate(C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    }return new C(length);
  };

  var speciesFromList = function speciesFromList(O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function fromList(C, list) {
    var index = 0,
        length = list.length,
        result = allocate(C, length);
    while (length > index) {
      result[index] = list[index++];
    }return result;
  };

  var addGetter = function addGetter(it, key, internal) {
    dP(it, key, { get: function get() {
        return this._d[internal];
      } });
  };

  var $from = function from(source /*, mapfn, thisArg */) {
    var O = toObject(source),
        aLen = arguments.length,
        mapfn = aLen > 1 ? arguments[1] : undefined,
        mapping = mapfn !== undefined,
        iterFn = getIterFn(O),
        i,
        length,
        values,
        result,
        step,
        iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      }O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of() /*...items*/{
    var index = 0,
        length = arguments.length,
        result = allocate(this, length);
    while (length > index) {
      result[index] = arguments[index++];
    }return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () {
    arrayToLocaleString.call(new Uint8Array(1));
  });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /*, end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /*, thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /*, start, end */) {
      // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /*, thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /*, thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /*, thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /*, thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /*, fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /*, fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) {
      // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /*, fromIndex */) {
      // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /*, thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /*, initialValue */) {
      // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /*, initialValue */) {
      // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this,
          length = validate(that).length,
          middle = Math.floor(length / 2),
          index = 0,
          value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      }return that;
    },
    some: function some(callbackfn /*, thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this),
          length = O.length,
          $begin = toIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(O.buffer, O.byteOffset + $begin * O.BYTES_PER_ELEMENT, toLength((end === undefined ? length : toIndex(end, length)) - $begin));
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /*, offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1),
        length = this.length,
        src = toObject(arrayLike),
        len = toLength(src.length),
        index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) {
      this[offset + index] = src[index++];
    }
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function isTAIndex(target, key) {
    return isObject(target) && target[TYPED_ARRAY] && (typeof key === 'undefined' ? 'undefined' : _typeof(key)) != 'symbol' && key in target && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true)) ? propertyDesc(2, target[key]) : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true)) && isObject(desc) && has(desc, 'value') && !has(desc, 'get') && !has(desc, 'set')
    // TODO: add validation descriptor w/o calling accessors
    && !desc.configurable && (!has(desc, 'writable') || desc.writable) && (!has(desc, 'enumerable') || desc.enumerable)) {
      target[key] = desc.value;
      return target;
    } else return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () {
    arrayToString.call({});
  })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function constructor() {/* noop */},
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function get() {
      return this[TYPED_ARRAY];
    }
  });

  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array',
        ISNT_UINT8 = NAME != 'Uint8Array',
        GETTER = 'get' + KEY,
        SETTER = 'set' + KEY,
        TypedArray = global[NAME],
        Base = TypedArray || {},
        TAC = TypedArray && getPrototypeOf(TypedArray),
        FORCED = !TypedArray || !$typed.ABV,
        O = {},
        TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function getter(that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function setter(that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function addElement(that, index) {
      dP(that, index, {
        get: function get() {
          return getter(this, index);
        },
        set: function set(value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0,
            offset = 0,
            buffer,
            byteLength,
            length,
            klass;
        if (!isObject(data)) {
          length = strictToLength(data, true);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) {
          addElement(that, index++);
        }
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!$iterDetect(function (iter) {
      // V8 works with iterators, but fails in many other cases
      // https://code.google.com/p/v8/issues/detail?id=4552
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(strictToLength(data, ISNT_UINT8));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined ? new Base(data, toOffset($offset, BYTES), $length) : $offset !== undefined ? new Base(data, toOffset($offset, BYTES)) : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR],
        CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined),
        $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function get() {
          return NAME;
        }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES,
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    $export($export.P + $export.F * (TypedArrayPrototype.toString != arrayToString), NAME, { toString: arrayToString });

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () {/* empty */};

/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var META = __webpack_require__(72)('meta'),
    isObject = __webpack_require__(9),
    has = __webpack_require__(23),
    setDesc = __webpack_require__(13).f,
    id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(7)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function setMeta(it) {
  setDesc(it, META, { value: {
      i: 'O' + ++id, // object ID
      w: {} // weak collections IDs
    } });
};
var fastKey = function fastKey(it, create) {
  // return primitive with prefix
  if (!isObject(it)) return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
    // return object ID
  }return it[META].i;
};
var getWeak = function getWeak(it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
    // return hash weak collections IDs
  }return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function onFreeze(it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 7.1.4 ToInteger
var ceil = Math.ceil,
    floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var freeGlobal = __webpack_require__(257);

/** Detect free variable `self`. */
var freeSelf = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;

/***/ }),
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserGUID = exports.parseJWT = exports.logError = exports.initLogError = exports.getAuthTokens = exports.getCookieValue = undefined;

var _config = __webpack_require__(31);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  /* istanbul ignore next */
  debounce: function debounce(func, wait, immediate) {
    for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      args[_key - 3] = arguments[_key];
    }

    var _this = this;

    var timeout = void 0;

    /* istanbul ignore next */
    return function () {
      var context = _this;
      var later = function later() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  },
  generateHash: function generateHash() {
    var ALPHABET = '23456789abdegjkmnpqrvwxyzABDEGJKMNPQRVWXYZ';
    var ID_LENGTH = 9;

    var rtn = '';

    for (var i = 0; i < ID_LENGTH; i += 1) {
      rtn += ALPHABET.charAt(Math.floor(Math.random() * ALPHABET.length));
    }

    return rtn;
  },
  scrollToTop: function scrollToTop() {
    if (window && window.scrollTo) {
      window.scrollTo(0, 0);
    }
  },
  storageAvailable: function storageAvailable(type) {
    try {
      var storage = window[type];
      var x = '__storage_test__';
      storage.setItem(x, x);
      storage.removeItem(x);
      return true;
    } catch (e) {
      return false;
    }
  },
  localStorageAvailable: function localStorageAvailable() {
    return this.storageAvailable('localStorage');
  }
};
var getCookieValue = exports.getCookieValue = function getCookieValue(cookieName) {
  var b = document.cookie.match('(^|;)\\s*' + cookieName + '\\s*=\\s*([^;]+)');
  return b ? b.pop() : '';
};

var getAuthTokens = exports.getAuthTokens = function getAuthTokens() {
  var cookieValue = getCookieValue(_config2.default.AUTH_COOKIE_NAME);
  var tokens = {};
  var parts = void 0;
  if (!cookieValue) {
    return false;
  }
  cookieValue.split('&').forEach(function (chunk) {
    parts = chunk.split('=');
    tokens[parts[0]] = parts[1];
  });
  return tokens;
};

var initLogError = exports.initLogError = function initLogError() {
  if (window.GG && window.GG.Raygun) {
    var raygun = window.GG.Raygun;
    raygun.init(_config2.default.DIAGNOSTICS_ENDPOINT, {
      allowInsecureSubmissions: true,
      ignoreAjaxAbort: true,
      debugMode: Boolean(_config2.default.LOCAL),
      ignore3rdPartyErrors: false
    }).attach();

    raygun.setVersion(_config2.default.APP_VERSION, _config2.default.APP_NAME);
  }
};

var logError = exports.logError = function logError(error, customData) {
  if (window.GG && window.GG.Raygun) {
    window.GG.Raygun.send(error, customData);
  }
};

var parseJWT = exports.parseJWT = function parseJWT(jwt) {
  var _logError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : logError;

  var parsedJWT = {};
  try {
    parsedJWT = JSON.parse(window.atob(jwt.split('.')[1]));
  } catch (err) {
    err.jwt = jwt;
    _logError(err);
  }
  return parsedJWT;
};

var getUserGUID = exports.getUserGUID = function getUserGUID(jwt) {
  var _parseJWT = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : parseJWT;

  return _parseJWT(jwt).sub;
};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iamThunk = exports.facebookThunk = exports.facebookActions = exports.authActions = exports.httpActions = exports.validationActions = exports.userActions = exports.appActions = undefined;

var _appActionCreators = __webpack_require__(347);

var _appActions = _interopRequireWildcard(_appActionCreators);

var _userActionCreators = __webpack_require__(351);

var _userActions = _interopRequireWildcard(_userActionCreators);

var _validationActionCreators = __webpack_require__(352);

var _validationActions = _interopRequireWildcard(_validationActionCreators);

var _httpActionCreators = __webpack_require__(350);

var _httpActions = _interopRequireWildcard(_httpActionCreators);

var _authActionCreators = __webpack_require__(348);

var _authActions = _interopRequireWildcard(_authActionCreators);

var _facebookActionCreators = __webpack_require__(349);

var _facebookActions = _interopRequireWildcard(_facebookActionCreators);

var _facebookThunk2 = __webpack_require__(353);

var _facebookThunk = _interopRequireWildcard(_facebookThunk2);

var _iamThunk2 = __webpack_require__(354);

var _iamThunk = _interopRequireWildcard(_iamThunk2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.appActions = _appActions;
exports.userActions = _userActions;
exports.validationActions = _validationActions;
exports.httpActions = _httpActions;
exports.authActions = _authActions;
exports.facebookActions = _facebookActions;
exports.facebookThunk = _facebookThunk;
exports.iamThunk = _iamThunk;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) {
    throw TypeError(name + ': incorrect invocation!');
  }return it;
};

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = false;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(4),
    dPs = __webpack_require__(231),
    enumBugKeys = __webpack_require__(146),
    IE_PROTO = __webpack_require__(158)('IE_PROTO'),
    Empty = function Empty() {/* empty */},
    PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var _createDict = function createDict() {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(145)('iframe'),
      i = enumBugKeys.length,
      lt = '<',
      gt = '>',
      iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(148).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  _createDict = iframeDocument.F;
  while (i--) {
    delete _createDict[PROTOTYPE][enumBugKeys[i]];
  }return _createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = _createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(233),
    hiddenKeys = __webpack_require__(146).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(233),
    enumBugKeys = __webpack_require__(146);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var redefine = __webpack_require__(27);
module.exports = function (target, src, safe) {
  for (var key in src) {
    redefine(target, key, src[key], safe);
  }return target;
};

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global = __webpack_require__(6),
    dP = __webpack_require__(13),
    DESCRIPTORS = __webpack_require__(12),
    SPECIES = __webpack_require__(11)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function get() {
      return this;
    }
  });
};

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toInteger = __webpack_require__(57),
    max = Math.max,
    min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var id = 0,
    px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Symbol = __webpack_require__(174),
    getRawTag = __webpack_require__(657),
    objectToString = __webpack_require__(664);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
    if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
    }
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}

module.exports = baseGetTag;

/***/ }),
/* 74 */,
/* 75 */,
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(11)('unscopables'),
    ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(26)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ctx = __webpack_require__(48),
    call = __webpack_require__(227),
    isArrayIter = __webpack_require__(150),
    anObject = __webpack_require__(4),
    toLength = __webpack_require__(16),
    getIterFn = __webpack_require__(167),
    BREAK = {},
    RETURN = {};
var _exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () {
    return iterable;
  } : getIterFn(iterable),
      f = ctx(fn, that, entries ? 2 : 1),
      index = 0,
      length,
      step,
      iterator,
      result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
_exports.BREAK = BREAK;
_exports.RETURN = RETURN;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {};

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var def = __webpack_require__(13).f,
    has = __webpack_require__(23),
    TAG = __webpack_require__(11)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(0),
    defined = __webpack_require__(38),
    fails = __webpack_require__(7),
    spaces = __webpack_require__(163),
    space = '[' + spaces + ']',
    non = '\u200B\x85',
    ltrim = RegExp('^' + space + space + '*'),
    rtrim = RegExp(space + space + '*$');

var exporter = function exporter(KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;

/***/ }),
/* 81 */,
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseGetTag = __webpack_require__(73),
    isObject = __webpack_require__(177);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
    if (!isObject(value)) {
        return false;
    }
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object';
}

module.exports = isObjectLike;

/***/ }),
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.types = undefined;

var _resources = __webpack_require__(323);

var _resources2 = _interopRequireDefault(_resources);

var _config = __webpack_require__(31);

var _config2 = _interopRequireDefault(_config);

var _apiMiddleware = __webpack_require__(324);

var _apiSelectors = __webpack_require__(94);

var _tools = __webpack_require__(62);

var _tools2 = _interopRequireDefault(_tools);

var _reduxUtils = __webpack_require__(110);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var types = exports.types = {
  CHARITY_SEARCH_REQUEST: 'CHARITY_SEARCH_REQUEST',
  CHARITY_SEARCH_SUCCESS: 'CHARITY_SEARCH_SUCCESS',
  CHARITY_SEARCH_FAILURE: 'CHARITY_SEARCH_FAILURE',
  GET_PARTICIPANT_REQUEST: 'GET_PARTICIPANT_REQUEST',
  GET_PARTICIPANT_SUCCESS: 'GET_PARTICIPANT_SUCCESS',
  GET_PARTICIPANT_FAILURE: 'GET_PARTICIPANT_FAILURE',
  ADD_CHARITY_ENTITY: 'ADD_CHARITY_ENTITY',
  CREATE_FUNDRAISING_PAGE_REQUEST: 'CREATE_FUNDRAISING_PAGE_REQUEST',
  CREATE_FUNDRAISING_PAGE_SUCCESS: 'CREATE_FUNDRAISING_PAGE_SUCCESS',
  CREATE_FUNDRAISING_PAGE_FAILURE: 'CREATE_FUNDRAISING_PAGE_FAILURE',
  CREATE_DONATION_PAGE_REQUEST: 'CREATE_DONATION_REQUEST',
  CREATE_DONATION_PAGE_SUCCESS: 'CREATE_DONATION_SUCCESS',
  CREATE_DONATION_PAGE_FAILURE: 'CREATE_DONATION_FAILURE'
};

var actions = {
  addCharityEntity: (0, _reduxUtils.makeActionCreator)(types.ADD_CHARITY_ENTITY, 'charityId', 'entity'),

  getParticipant: function getParticipant(guid) {
    var _resources$participan = _resources2.default.participant,
        url = _resources$participan.url,
        requestName = _resources$participan.requestName;

    return _defineProperty({}, _apiMiddleware.CALL_API, {
      requestName: requestName,
      types: [types.GET_PARTICIPANT_REQUEST, types.GET_PARTICIPANT_SUCCESS, types.GET_PARTICIPANT_FAILURE],
      endpoint: url + '/' + guid
    });
  },

  getCharitySuggestions: function getCharitySuggestions() {
    return function (dispatch, getState) {
      var _resources$charitySea = _resources2.default.charitySearch,
          url = _resources$charitySea.url,
          requestName = _resources$charitySea.requestName;

      var queryText = getState().mainStore.get('queryText');
      if (queryText) {
        dispatch(_defineProperty({}, _apiMiddleware.CALL_API, {
          requestName: requestName,
          types: [types.CHARITY_SEARCH_REQUEST, types.CHARITY_SEARCH_SUCCESS, types.CHARITY_SEARCH_FAILURE],
          endpoint: url + '/' + queryText
        }));
      }
    };
  },

  createFundraisingPage: function createFundraisingPage() {
    return function (dispatch, getState) {
      var requestName = _resources2.default.fundraisingPage.requestName;

      var guid = getState().api.getIn(['normalized', 'result', 'participant', 'participantGuid']);
      var charityId = getState().mainStore.get('charityId');
      var jwtAuthToken = getState().mainStore.get('authAccessToken');

      return dispatch(_defineProperty({}, _apiMiddleware.CALL_API, {
        requestName: requestName,
        requestOptions: {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + jwtAuthToken
          }
        },
        types: [types.CREATE_FUNDRAISING_PAGE_REQUEST, types.CREATE_FUNDRAISING_PAGE_SUCCESS, types.CREATE_FUNDRAISING_PAGE_FAILURE],
        endpoint: _config2.default.PARTNERS_API.BASE_URL + '/participant/' + guid + '/charity/' + charityId
      }));
    };
  },

  createDonation: function createDonation() {
    return function (dispatch, getState) {
      var requestName = _resources2.default.donationPage.requestName;

      var state = getState();
      var api = state.api;

      var authAccessToken = state.mainStore.get('authAccessToken');
      var guid = api.getIn(['normalized', 'result', 'participant', 'participantGuid']);
      var causeId = api.getIn(['normalized', 'result', 'participant', 'causeId']);
      var matchMyMilesConfig = api.getIn(['normalized', 'result', 'participant', 'mmmConfig']);

      var _getSelectedCharity = (0, _apiSelectors.getSelectedCharity)(state),
          charityName = _getSelectedCharity.charityName,
          selectedCharityId = _getSelectedCharity.charityId;

      var mmmUrl = window.location.protocol + '//' + window.location.hostname;
      var fundraiserName = (0, _apiSelectors.getParticipantFirstName)(state) + ' ' + (0, _apiSelectors.getParticipantLastName)(state);

      var socialShareUrl = (0, _apiSelectors.getParticipantPageUrl)(state) || '';
      var utmContent = 'page_' + socialShareUrl.substr(socialShareUrl.lastIndexOf('/') + 1);

      var utmMedium = 'share';
      var utmCampaign = 'matchmymiles';
      var utmTerm = _tools2.default.generateHash();

      var twitterUrl = socialShareUrl + '?utm_source=twitter&utm_medium=' + utmMedium + '&utm_content=' + utmContent + '&utm_campaign=' + utmCampaign + '&utm_term=' + utmTerm;

      var utmId = guid || '';
      var whatsAppUrl = socialShareUrl + '?utm_id=' + utmId + '&utm_content=' + utmContent + '&utm_term=' + utmTerm;

      var utmSourceFB = 'facebook';
      var facebookUrl = socialShareUrl + '?utm_source=' + utmSourceFB + '&utm_medium=' + utmMedium + '&utm_content=' + utmContent + '&utm_campaign=' + utmCampaign + '&utm_term=' + utmTerm;

      var postBody = {
        causeId: causeId,
        referralCode: 'Cruk-RFL-2015',
        successUri: mmmUrl + '/summary?guid=' + guid + '&charityId=' + selectedCharityId,
        failureUri: mmmUrl + '/todo--------we-need-a-failure-page',
        exitUri: mmmUrl + '/summary?guid=' + guid + '&charityId=' + selectedCharityId,
        marketCode: 'GB',
        additionalData: JSON.stringify({
          // version: 1,
          // sourceURI: 'http://www.justgiving.com/my-funky-page',
          sourceURI: facebookUrl,
          cause: {
            name: charityName
          },
          fundraiser: {
            name: fundraiserName,
            //   avatar: 'fb98c5d3-dbfa-4b03-8bef-71297bb76eb9.jpg',
            userId: (0, _tools.getUserGUID)(authAccessToken)
          },
          // campaign: {
          //   name: 'Step ot for children',
          // },
          // donor: {
          //   name: 'Don Orange',
          //   avatar: '3d43a92c-8608-4e45-af34-b66e8924d778.jpg',
          // },
          callsToAction: {
            // I’m fundraising for ${charityName} on JustGiving. Will you MatchMyMiles by donating to my cause?
            twitter: 'Just donated to my own fundraising page on @JustGiving. Please #MATCHmyMILES by donating and help me hit my target. ' + twitterUrl,
            // TODO: empty as the FB graph should take the message from the page metadata ( after it has parsed the page )
            facebook: '',
            whatsapp: 'I just donated to my own fundraising page on JustGiving. Please MATCHmyMILES by donating and help me hit my target. ' + whatsAppUrl
          },

          matchMyMilesConfig: matchMyMilesConfig
        })
      };

      return dispatch(_defineProperty({}, _apiMiddleware.CALL_API, {
        requestName: requestName,
        returnHeaders: ['location'],
        requestOptions: {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/hal+json; profile=jg.donationcollection; version=1.0',
            'cache-control': 'no-cache',
            Prefer: 'return=representation'
          },
          formData: postBody
        },
        types: [types.CREATE_DONATION_PAGE_REQUEST, types.CREATE_DONATION_PAGE_SUCCESS, types.CREATE_DONATION_PAGE_FAILURE],
        endpoint: _config2.default.DONATE_API.BASE_URL + '/api/donations'
      }));
    };
  }
};

exports.default = actions;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.types = undefined;

var _keymirror = __webpack_require__(172);

var _keymirror2 = _interopRequireDefault(_keymirror);

var _reduxUtils = __webpack_require__(110);

var _httpActions = __webpack_require__(135);

var _httpActions2 = _interopRequireDefault(_httpActions);

var _facebookInviteFriendsActions = __webpack_require__(209);

var _facebookInviteFriendsActions2 = _interopRequireDefault(_facebookInviteFriendsActions);

var _httpSelectors = __webpack_require__(136);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var types = exports.types = (0, _keymirror2.default)({
  SET_CHARITY: null,
  RESET_CHARITY_SELECTION: null,
  UPDATE_QUERY_TEXT: null,
  CLEAR_QUERY_TEXT: null,
  UPDATE_IS_USER_LOGGED_IN: null,
  UPDATE_AUTH_ACCESS_TOKEN: null,
  UPDATE_AUTH_REFRESH_TOKEN: null,
  PARTICIPANT_PROMISE: null,
  PARTICIPANT_REQUEST_ERROR: null,
  RESET_PROCEED_TO_DONATION_CLICKED: null,
  PROCEED_TO_DONATION_CLICKED: null
});

var actions = {
  setCharity: (0, _reduxUtils.makeActionCreator)(types.SET_CHARITY, 'charityId'),

  resetCharitySelection: (0, _reduxUtils.makeActionCreator)(types.RESET_CHARITY_SELECTION),

  updateQueryText: (0, _reduxUtils.makeActionCreator)(types.UPDATE_QUERY_TEXT, 'queryText'),

  clearQueryText: (0, _reduxUtils.makeActionCreator)(types.CLEAR_QUERY_TEXT),

  resetProceedToDonationClicked: (0, _reduxUtils.makeActionCreator)(types.RESET_PROCEED_TO_DONATION_CLICKED),

  proceedToDonationClicked: (0, _reduxUtils.makeActionCreator)(types.PROCEED_TO_DONATION_CLICKED),

  confirmFriendsSelection: function confirmFriendsSelection() {
    return function (dispatch, getState) {
      var state = getState();

      if (!(0, _httpSelectors.isRequestInFlight)('inviteFriends')(state)) {
        dispatch(_httpActions2.default.requestMade('inviteFriends'));

        var apiCallback = function apiCallback(response) {
          dispatch(_httpActions2.default.requestSuccess('inviteFriends'));
          if (response && !response.error) {
            dispatch(actions.proceedToDonationClicked());
          }
        };

        var mainStore = state.mainStore,
            api = state.api;

        var fundraisingPageUrl = api.getIn(['normalized', 'result', 'participant', 'pageUrl']);
        var selectedCharityId = mainStore.get('charityId');
        var charityName = api.getIn(['normalized', 'entities', 'charities', '' + selectedCharityId, 'charityName']);
        var message = 'I\u2019m fundraising for ' + charityName + ' on JustGiving. Will you MATCHmyMILES by donating to my cause?';

        dispatch(_facebookInviteFriendsActions2.default.postToFB(fundraisingPageUrl, message, apiCallback));
      }
    };
  },

  updateUserIsLoggedIn: (0, _reduxUtils.makeActionCreator)(types.UPDATE_IS_USER_LOGGED_IN, 'isUserLoggedIn'),
  updateAuthAccessToken: (0, _reduxUtils.makeActionCreator)(types.UPDATE_AUTH_ACCESS_TOKEN, 'accessToken'),
  updateAuthRefreshToken: (0, _reduxUtils.makeActionCreator)(types.UPDATE_AUTH_REFRESH_TOKEN, 'refreshToken'),
  saveParticipantPromise: (0, _reduxUtils.makeActionCreator)(types.PARTICIPANT_PROMISE, 'participantPromise'),
  updateParticipantRequestError: (0, _reduxUtils.makeActionCreator)(types.PARTICIPANT_REQUEST_ERROR, 'participantRequestError')
};

exports.default = actions;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSelectedCharity = exports.getEventId = exports.getDonationLocation = exports.getParticipantPageUrl = exports.getParticipantPageName = exports.getCharityEntities = exports.getCharityId = exports.charitySearchEnabledSelector = exports.getParticipantEmail = exports.getParticipantLastName = exports.getParticipantFirstName = exports.getCharitiesSearchResponse = exports.getSuggestedCharities = undefined;

var _immutable = __webpack_require__(44);

var _immutable2 = _interopRequireDefault(_immutable);

var _reselect = __webpack_require__(809);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getSuggestedCharities = exports.getSuggestedCharities = function getSuggestedCharities(state) {
  return state.api.getIn(['normalized', 'result', 'participant', 'charities'], _immutable2.default.List()).map(function (charityId) {
    return state.api.getIn(['normalized', 'entities', 'charities', '' + charityId], _immutable2.default.Map());
  });
};

var getCharitiesSearchResponse = exports.getCharitiesSearchResponse = function getCharitiesSearchResponse(state) {
  return state.api.getIn(['normalized', 'result', 'charities'], _immutable2.default.List()).map(function (charityId) {
    return state.api.getIn(['normalized', 'entities', 'charities', '' + charityId], _immutable2.default.Map());
  });
};

var getParticipantFirstName = exports.getParticipantFirstName = function getParticipantFirstName(state) {
  return state.api.getIn(['normalized', 'result', 'participant', 'participantFirstName']);
};

var getParticipantLastName = exports.getParticipantLastName = function getParticipantLastName(state) {
  return state.api.getIn(['normalized', 'result', 'participant', 'participantLastName']);
};

var getParticipantEmail = exports.getParticipantEmail = function getParticipantEmail(state) {
  return state.api.getIn(['normalized', 'result', 'participant', 'participantEmail']);
};

var charitySearchEnabledSelector = exports.charitySearchEnabledSelector = function charitySearchEnabledSelector(state) {
  return state.api.getIn(['normalized', 'result', 'participant', 'charitySearchEnabled']);
};

var getCharityId = exports.getCharityId = function getCharityId(state) {
  return state.mainStore.get('charityId');
};

var getCharityEntities = exports.getCharityEntities = function getCharityEntities(state) {
  return state.api.getIn(['normalized', 'entities', 'charities'], _immutable2.default.Map());
};

var getParticipantPageName = exports.getParticipantPageName = function getParticipantPageName(state) {
  return state.api.getIn(['normalized', 'result', 'participant', 'pageName']);
};

var getParticipantPageUrl = exports.getParticipantPageUrl = function getParticipantPageUrl(state) {
  return state.api.getIn(['normalized', 'result', 'participant', 'pageUrl']);
};

var getDonationLocation = exports.getDonationLocation = function getDonationLocation(state) {
  return state.api.getIn(['normalized', 'result', 'participant', 'donationLocation']);
};
var getEventId = exports.getEventId = function getEventId(state) {
  return state.api.getIn(['normalized', 'result', 'participant', 'eventId']);
};

var getSelectedCharity = exports.getSelectedCharity = (0, _reselect.createSelector)([getCharityId, getCharityEntities], function (charityId, charityEntities) {
  return charityEntities.get(charityId, _immutable2.default.Map()).toJS();
});

exports.default = {
  getSuggestedCharities: getSuggestedCharities,
  getCharitiesSearchResponse: getCharitiesSearchResponse,
  getParticipantFirstName: getParticipantFirstName,
  getParticipantLastName: getParticipantLastName,
  getParticipantEmail: getParticipantEmail,
  charitySearchEnabledSelector: charitySearchEnabledSelector,
  getCharityId: getCharityId,
  getCharityEntities: getCharityEntities
};

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* istanbul ignore next */
exports.default = {
  locationStub: {
    query: {}
  }
};

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(37),
    TAG = __webpack_require__(11)('toStringTag')
// ES3 wrong here
,
    ARG = cof(function () {
  return arguments;
}()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function tryGet(it, key) {
  try {
    return it[key];
  } catch (e) {/* empty */}
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
  // @@toStringTag case
  : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
  // builtinTag case
  : ARG ? cof(O)
  // ES3 arguments fallback
  : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(37);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseIsNative = __webpack_require__(649),
    getValue = __webpack_require__(659);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;

/***/ }),
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.combineActions = exports.handleActions = exports.handleAction = exports.createActions = exports.createAction = undefined;

var _createAction = __webpack_require__(315);

var _createAction2 = _interopRequireDefault(_createAction);

var _handleAction = __webpack_require__(316);

var _handleAction2 = _interopRequireDefault(_handleAction);

var _handleActions = __webpack_require__(802);

var _handleActions2 = _interopRequireDefault(_handleActions);

var _combineActions = __webpack_require__(314);

var _combineActions2 = _interopRequireDefault(_combineActions);

var _createActions = __webpack_require__(801);

var _createActions2 = _interopRequireDefault(_createActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.createAction = _createAction2.default;
exports.createActions = _createActions2.default;
exports.handleAction = _handleAction2.default;
exports.handleActions = _handleActions2.default;
exports.combineActions = _combineActions2.default;

/***/ }),
/* 108 */,
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = __webpack_require__(24);

var _Steps = __webpack_require__(825);

var _Steps2 = _interopRequireDefault(_Steps);

var _matchmymilesRed = __webpack_require__(862);

var _matchmymilesRed2 = _interopRequireDefault(_matchmymilesRed);

__webpack_require__(844);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = function Header(_ref) {
  var step = _ref.step;
  return _react2.default.createElement(
    'div',
    { className: 'header' },
    _react2.default.createElement(_components.Svg, { markup: _matchmymilesRed2.default, alt: 'MATCHmyMILES', className: 'header__matchmymiles-logo' }),
    step && _react2.default.createElement(_Steps2.default, { step: step })
  );
};

Header.propTypes = {
  step: _propTypes2.default.string
};

Header.defaultProps = {
  step: ''
};

exports.default = Header;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeActionCreator = makeActionCreator;
function makeActionCreator(type) {
  for (var _len = arguments.length, argNames = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    argNames[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var action = { type: type };
    argNames.forEach(function (arg, index) {
      action[argNames[index]] = args[index];
    });
    return action;
  };
}

exports.default = {};

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageBoilerplateDefault = exports.Avatar = exports.DNAHeadingH2 = exports.DNAHeadingH1 = exports.FootnoteTsAndCs = exports.DNAButtonSocial = exports.DNAButtonContinue = exports.DNAButtonDefault = exports.DNAValidationMessage = exports.DNAInputWithLabel = exports.DNACheckBoxWithLabel = exports.AlertRecoverableError = exports.DNAAlertSlideDown = exports.DNAAlert = undefined;

var _Alert = __webpack_require__(245);

var _Alert2 = _interopRequireDefault(_Alert);

var _AlertSlideDown = __webpack_require__(246);

var _AlertSlideDown2 = _interopRequireDefault(_AlertSlideDown);

var _AlertRecoverableError2 = __webpack_require__(355);

var _AlertRecoverableError3 = _interopRequireDefault(_AlertRecoverableError2);

var _CheckBoxWithLabel = __webpack_require__(602);

var _CheckBoxWithLabel2 = _interopRequireDefault(_CheckBoxWithLabel);

var _InputWithLabel = __webpack_require__(605);

var _InputWithLabel2 = _interopRequireDefault(_InputWithLabel);

var _ValidationMessage = __webpack_require__(606);

var _ValidationMessage2 = _interopRequireDefault(_ValidationMessage);

var _ButtonDefault = __webpack_require__(169);

var _ButtonDefault2 = _interopRequireDefault(_ButtonDefault);

var _ButtonContinue = __webpack_require__(592);

var _ButtonContinue2 = _interopRequireDefault(_ButtonContinue);

var _ButtonSocial = __webpack_require__(593);

var _ButtonSocial2 = _interopRequireDefault(_ButtonSocial);

var _FootnoteTsAndCs2 = __webpack_require__(357);

var _FootnoteTsAndCs3 = _interopRequireDefault(_FootnoteTsAndCs2);

var _HeadingH = __webpack_require__(610);

var _HeadingH2 = _interopRequireDefault(_HeadingH);

var _HeadingH3 = __webpack_require__(611);

var _HeadingH4 = _interopRequireDefault(_HeadingH3);

var _Avatar2 = __webpack_require__(356);

var _Avatar3 = _interopRequireDefault(_Avatar2);

var _PageBoilerplateDefault2 = __webpack_require__(112);

var _PageBoilerplateDefault3 = _interopRequireDefault(_PageBoilerplateDefault2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.DNAAlert = _Alert2.default; // Alert components

exports.DNAAlertSlideDown = _AlertSlideDown2.default;
exports.AlertRecoverableError = _AlertRecoverableError3.default;

// Form components

exports.DNACheckBoxWithLabel = _CheckBoxWithLabel2.default;
exports.DNAInputWithLabel = _InputWithLabel2.default;
exports.DNAValidationMessage = _ValidationMessage2.default;

// Button components

exports.DNAButtonDefault = _ButtonDefault2.default;
exports.DNAButtonContinue = _ButtonContinue2.default;
exports.DNAButtonSocial = _ButtonSocial2.default;

// Footnote components

exports.FootnoteTsAndCs = _FootnoteTsAndCs3.default;

// Text components

exports.DNAHeadingH1 = _HeadingH2.default;
exports.DNAHeadingH2 = _HeadingH4.default;

// App components

exports.Avatar = _Avatar3.default;

// Page

exports.PageBoilerplateDefault = _PageBoilerplateDefault3.default;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ = __webpack_require__(111);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PageBoilerplateDefault = (_temp = _class = function (_Component) {
	_inherits(PageBoilerplateDefault, _Component);

	function PageBoilerplateDefault() {
		_classCallCheck(this, PageBoilerplateDefault);

		return _possibleConstructorReturn(this, (PageBoilerplateDefault.__proto__ || Object.getPrototypeOf(PageBoilerplateDefault)).apply(this, arguments));
	}

	_createClass(PageBoilerplateDefault, [{
		key: 'handleSubmit',
		value: function handleSubmit(e) {
			var handleSubmit = this.props.handleSubmit;

			e && e.preventDefault && e.preventDefault();
			handleSubmit && handleSubmit(e);
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    intl = _props.intl,
			    useBoilerplateHeadingH1 = _props.useBoilerplateHeadingH1,
			    HeadingH1Content = _props.HeadingH1Content,
			    HeadingH1DecoratorClass = _props.HeadingH1DecoratorClass,
			    isRecoverableError = _props.isRecoverableError,
			    children = _props.children,
			    mainClassName = _props.mainClassName,
			    globalAlertsDecoratorClass = _props.globalAlertsDecoratorClass,
			    useBoilerplateAlertRecoverableError = _props.useBoilerplateAlertRecoverableError;


			return _react2.default.createElement(
				'section',
				null,
				useBoilerplateAlertRecoverableError && _react2.default.createElement(_.AlertRecoverableError, _extends({}, this.props, {
					decoratorClass: globalAlertsDecoratorClass,
					intl: intl,
					isRecoverableError: isRecoverableError })),
				_react2.default.createElement(
					'main',
					{ role: 'main', className: 'login-main-default ' + (mainClassName ? mainClassName : '') },
					_react2.default.createElement(
						'form',
						{ noValidate: true, onSubmit: this.handleSubmit.bind(this) },
						useBoilerplateHeadingH1 && _react2.default.createElement(
							_.DNAHeadingH1,
							{
								headingDecoratorClass: HeadingH1DecoratorClass },
							HeadingH1Content
						),
						children
					)
				)
			);
		}
	}]);

	return PageBoilerplateDefault;
}(_react.Component), _class.propTypes = {
	useBoilerplateHeadingH1: _propTypes2.default.bool.isRequired,
	useBoilerplateAlertRecoverableError: _propTypes2.default.bool,
	HeadingH1Content: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	HeadingH1DecoratorClass: _propTypes2.default.string,
	globalAlertsDecoratorClass: _propTypes2.default.string,
	intl: _propTypes2.default.object.isRequired,
	mainClassName: _propTypes2.default.string,
	isRecoverableError: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string, _propTypes2.default.object]),
	children: _propTypes2.default.any.isRequired,
	handleSubmit: _propTypes2.default.func
}, _class.defaultProps = {
	useBoilerplateHeadingH1: true,
	useBoilerplateAlertRecoverableError: true
}, _temp);
exports.default = PageBoilerplateDefault;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRecoverableErrorType = undefined;

var _redux = __webpack_require__(21);

var _appReducers = __webpack_require__(379);

var appReducers = _interopRequireWildcard(_appReducers);

var _userReducers = __webpack_require__(383);

var userReducers = _interopRequireWildcard(_userReducers);

var _validationReducers = __webpack_require__(384);

var validationReducers = _interopRequireWildcard(_validationReducers);

var _httpReducers = __webpack_require__(382);

var httpReducers = _interopRequireWildcard(_httpReducers);

var _facebookReducers = __webpack_require__(381);

var facebookReducers = _interopRequireWildcard(_facebookReducers);

var _authReducers = __webpack_require__(380);

var authReducers = _interopRequireWildcard(_authReducers);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var reducers = Object.assign({}, appReducers, userReducers, validationReducers, httpReducers, facebookReducers, authReducers);

/**
 * Root reducer
 * @description
 * Combines every reducer and returns a full state tree whenever
 * any reducer is called by an action. The rootReducer creates properties
 * on the state tree whose key names match the reducer names on the object passed
 * into combineReducers (or an alias if provided). This is the standard out-of-the-box
 * Redux combineReducers implementation
 */
var rootReducer = (0, _redux.combineReducers)(reducers);

exports.default = rootReducer;

/**
 * Root UI selectors
 */

var getRecoverableErrorType = exports.getRecoverableErrorType = function getRecoverableErrorType(state, requestKey, networkStatus) {
  var errorState = state.HTTP_request[requestKey] && state.HTTP_request[requestKey].isError ? state.HTTP_request[requestKey].isError : undefined;
  return httpReducers.getRecoverableErrorType(errorState, requestKey, networkStatus);
};

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(387);

Object.defineProperty(exports, 'setRoute', {
  enumerable: true,
  get: function get() {
    return _utils.setRoute;
  }
});

var _path = __webpack_require__(386);

Object.defineProperty(exports, 'path', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_path).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(29),
    toLength = __webpack_require__(16),
    toIndex = __webpack_require__(71);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this),
        length = toLength(O.length),
        index = toIndex(fromIndex, length),
        value;
    // Array#includes uses SameValueZero equality algorithm
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      if (value != value) return true;
      // Array#toIndex ignores holes, Array#includes - not
    } else for (; length > index; index++) {
      if (IS_INCLUDES || index in O) {
        if (O[index] === el) return IS_INCLUDES || index || 0;
      }
    }return !IS_INCLUDES && -1;
  };
};

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global = __webpack_require__(6),
    $export = __webpack_require__(0),
    redefine = __webpack_require__(27),
    redefineAll = __webpack_require__(69),
    meta = __webpack_require__(55),
    forOf = __webpack_require__(77),
    anInstance = __webpack_require__(64),
    isObject = __webpack_require__(9),
    fails = __webpack_require__(7),
    $iterDetect = __webpack_require__(121),
    setToStringTag = __webpack_require__(79),
    inheritIfRequired = __webpack_require__(149);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME],
      C = Base,
      ADDER = IS_MAP ? 'set' : 'add',
      proto = C && C.prototype,
      O = {};
  var fixMethod = function fixMethod(KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY, KEY == 'delete' ? function (a) {
      return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
    } : KEY == 'has' ? function has(a) {
      return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
    } : KEY == 'get' ? function get(a) {
      return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
    } : KEY == 'add' ? function add(a) {
      fn.call(this, a === 0 ? 0 : a);return this;
    } : function set(a, b) {
      fn.call(this, a === 0 ? 0 : a, b);return this;
    });
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C()
    // early implementations not supports chaining
    ,
        HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    ,
        THROWS_ON_PRIMITIVES = fails(function () {
      instance.has(1);
    })
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    ,
        ACCEPT_ITERABLES = $iterDetect(function (iter) {
      new C(iter);
    }) // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    ,
        BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C(),
          index = 5;
      while (index--) {
        $instance[ADDER](index, index);
      }return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hide = __webpack_require__(26),
    redefine = __webpack_require__(27),
    fails = __webpack_require__(7),
    defined = __webpack_require__(38),
    wks = __webpack_require__(11);

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY),
      fns = exec(defined, SYMBOL, ''[KEY]),
      strfn = fns[0],
      rxfn = fns[1];
  if (fails(function () {
    var O = {};
    O[SYMBOL] = function () {
      return 7;
    };
    return ''[KEY](O) != 7;
  })) {
    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
    // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
    // 21.2.5.11 RegExp.prototype[@@split](string, limit)
    ? function (string, arg) {
      return rxfn.call(string, this, arg);
    }
    // 21.2.5.6 RegExp.prototype[@@match](string)
    // 21.2.5.9 RegExp.prototype[@@search](string)
    : function (string) {
      return rxfn.call(string, this);
    });
  }
};

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags

var anObject = __webpack_require__(4);
module.exports = function () {
  var that = anObject(this),
      result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
                  var un = that === undefined;
                  switch (args.length) {
                                    case 0:
                                                      return un ? fn() : fn.call(that);
                                    case 1:
                                                      return un ? fn(args[0]) : fn.call(that, args[0]);
                                    case 2:
                                                      return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);
                                    case 3:
                                                      return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);
                                    case 4:
                                                      return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
                  }return fn.apply(that, args);
};

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(9),
    cof = __webpack_require__(37),
    MATCH = __webpack_require__(11)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ITERATOR = __webpack_require__(11)('iterator'),
    SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () {
    SAFE_CLOSING = true;
  };
  Array.from(riter, function () {
    throw 2;
  });
} catch (e) {/* empty */}

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7],
        iter = arr[ITERATOR]();
    iter.next = function () {
      return { done: safe = true };
    };
    arr[ITERATOR] = function () {
      return iter;
    };
    exec(arr);
  } catch (e) {/* empty */}
  return safe;
};

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Forced replacement prototype accessors methods
module.exports = __webpack_require__(65) || !__webpack_require__(7)(function () {
  var K = Math.random();
  // In FF throws only define methods
  __defineSetter__.call(null, K, function () {/* empty */});
  delete __webpack_require__(6)[K];
});

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global = __webpack_require__(6),
    SHARED = '__core-js_shared__',
    store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global = __webpack_require__(6),
    hide = __webpack_require__(26),
    uid = __webpack_require__(72),
    TYPED = uid('typed_array'),
    VIEW = uid('view'),
    ABV = !!(global.ArrayBuffer && global.DataView),
    CONSTR = ABV,
    i = 0,
    l = 9,
    Typed;

var TypedArrayConstructors = 'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'.split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isImmutable = isImmutable;
exports.denormalizeImmutable = denormalizeImmutable;
/**
 * Helpers to enable Immutable compatibility *without* bringing in
 * the 'immutable' package as a dependency.
 */

/**
 * Check if an object is immutable by checking if it has a key specific
 * to the immutable library.
 *
 * @param  {any} object
 * @return {bool}
 */
function isImmutable(object) {
  return !!(object && (object.hasOwnProperty('__ownerID') || // Immutable.Map
  object._map && object._map.hasOwnProperty('__ownerID') // Immutable.Record
  ));
}

/**
 * Denormalize an immutable entity.
 *
 * @param  {Schema} schema
 * @param  {Immutable.Map|Immutable.Record} input
 * @param  {function} unvisit
 * @param  {function} getDenormalizedEntity
 * @return {Immutable.Map|Immutable.Record}
 */
function denormalizeImmutable(schema, input, unvisit) {
  return Object.keys(schema).reduce(function (object, key) {
    // Immutable maps cast keys to strings on write so we need to ensure
    // we're accessing them using string keys.
    var stringKey = '' + key;

    if (object.has(stringKey)) {
      return object.set(stringKey, unvisit(object.get(stringKey), schema[stringKey]));
    } else {
      return object;
    }
  }, input);
}

/***/ }),
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.types = undefined;

var _reduxUtils = __webpack_require__(110);

var _keymirror = __webpack_require__(172);

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var types = exports.types = (0, _keymirror2.default)({
  REQUEST_MADE: null,
  REQUEST_SUCCESS: null,
  REQUEST_ERROR: null,
  REQUEST_RETRY: null
});

exports.default = {
  requestMade: (0, _reduxUtils.makeActionCreator)(types.REQUEST_MADE, 'requestName'),
  requestSuccess: (0, _reduxUtils.makeActionCreator)(types.REQUEST_SUCCESS, 'requestName'),
  requestError: (0, _reduxUtils.makeActionCreator)(types.REQUEST_ERROR, 'requestName'),
  requestRetry: (0, _reduxUtils.makeActionCreator)(types.REQUEST_RETRY, 'requestName')
};

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var isRequestInFlight = exports.isRequestInFlight = function isRequestInFlight(requestName) {
  return function (state) {
    return state.http.getIn([requestName, 'isInFlight'], false);
  };
};

exports.default = isRequestInFlight;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _koalaFrontEndAnalytics = __webpack_require__(396);

var _koalaFrontEndAnalytics2 = _interopRequireDefault(_koalaFrontEndAnalytics);

var _config = __webpack_require__(31);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clientAnalytics = void 0;

function getKoalaClient() {
  if (!clientAnalytics) {
    clientAnalytics = new _koalaFrontEndAnalytics2.default({ apiUrl: _config2.default.KOALA_API_URI });
  }
  return clientAnalytics;
}

function trackKoala(trackedInfo) {
  var analytics = getKoalaClient();
  return analytics.track(_extends({}, trackedInfo));
}

exports.default = {
  track: function track(event) {
    trackKoala(event);
  }
};

/***/ }),
/* 138 */,
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Intl = exports.Analytics = exports.Validation = undefined;

var _Validation2 = __webpack_require__(378);

var _Validation3 = _interopRequireDefault(_Validation2);

var _Analytics2 = __webpack_require__(376);

var _Analytics3 = _interopRequireDefault(_Analytics2);

var _Intl2 = __webpack_require__(377);

var _Intl3 = _interopRequireDefault(_Intl2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Validation = _Validation3.default;
exports.Analytics = _Analytics3.default;
exports.Intl = _Intl3.default;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var COOKIE_NAMES = exports.COOKIE_NAMES = {
    JG_ANALYTICS_COOKIE_NAME: 'JGAnalytics',
    JG_ANALYTICS_AB: 'JGABID',
    KM: 'km_ai',
    KOALA_EmailIdentity: 'koala_ei',
    GGASPXAUTH_PROD_ID: '.GGASPXAUTH_ID',
    GGASPXAUTH_DEV_ID: '.GGASPXAUTH_DEV_ID',
    GGASPXAUTH_STAGING_ID: '.GGASPXAUTH_STAGING_ID',
    GGASPXAUTH_SANDBOX_ID: '.GGASPXAUTH_SANDBOX_ID'
};

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.blobSupported = blobSupported;
exports.isServer = isServer;
function blobSupported() {
    try {
        return !!new Blob();
    } catch (exception) {
        return false;
    }
}

var APP_ENV = exports.APP_ENV = typeof process !== 'undefined' && process.env.APP_ENV !== null ? process.env.APP_ENV : "browser";
var NODE_ENV = exports.NODE_ENV = typeof process !== 'undefined' && "production" !== null ? "production" : "";

function isServer() {
    return !(typeof window != 'undefined' && window.document);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(127)))

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.extend = extend;
exports.getCurrentEnvironment = getCurrentEnvironment;
exports.getBrowserInfo = getBrowserInfo;
exports.setValueOrEmptyString = setValueOrEmptyString;
exports.queryStringToObject = queryStringToObject;
exports.generateGUID = generateGUID;
exports.encodeBase64 = encodeBase64;

var _base = __webpack_require__(587);

var _base2 = _interopRequireDefault(_base);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function extend(obj, src) {
    for (var key in src) {
        if (src.hasOwnProperty(key) && !obj.hasOwnProperty(key)) obj[key] = src[key];
    }
    return obj;
}

var envMap = [['//identity.justgiving.com/', 'PROD'], ['.dev.', 'DEV'], ['.local.', 'DEV'], ['v3-integration', 'STAGING'], ['v3-rc.staging', 'STAGING'], ['.staging.', 'STAGING'], ['v3-sandbox.', 'SANDBOX'], ['.sandbox.', 'SANDBOX']];

function getCurrentEnvironment(url) {
    var env = 'PROD';
    if (!url) {
        return env;
    };
    var subString = url.slice(0, url.search('justgiving.com'));

    for (var i = 0; i < envMap.length; i++) {
        if (subString.indexOf(envMap[i][0]) > -1) {
            env = envMap[i][1];
            break;
        }
    }
    return env;
}

function getBrowserInfo(request) {
    if (request) {
        return {
            url: request.url,
            user_agent: request.user_agent,
            referer: request.referer,
            cookies: request.cookies
        };
    }

    return {
        url: window.location.href || null,
        user_agent: navigator.userAgent || null,
        referer: document.referrer || location.referrer || 'Direct',
        cookies: document.cookie
    };
}

function setValueOrEmptyString(propertyName, value, object) {
    if (value != null && value.length !== 0 && propertyName) {
        object[propertyName] = value;
    }
}

// Read a page's GET URL variables and return them as an associative array.
function queryStringToObject(url) {
    if (!url) return {};
    var queryStringValues = {},
        hash = void 0;
    var hashes = url.slice(url.indexOf('?') + 1).split('&');
    for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        queryStringValues[hash[0].toLowerCase()] = hash[1];
    }

    return queryStringValues;
}

function generateGUID() {
    var lut = [];for (var i = 0; i < 256; i++) {
        lut[i] = (i < 16 ? '0' : '') + i.toString(16);
    }

    var d0 = Math.random() * 0xffffffff | 0;
    var d1 = Math.random() * 0xffffffff | 0;
    var d2 = Math.random() * 0xffffffff | 0;
    var d3 = Math.random() * 0xffffffff | 0;
    return lut[d0 & 0xff] + lut[d0 >> 8 & 0xff] + lut[d0 >> 16 & 0xff] + lut[d0 >> 24 & 0xff] + '-' + lut[d1 & 0xff] + lut[d1 >> 8 & 0xff] + '-' + lut[d1 >> 16 & 0x0f | 0x40] + lut[d1 >> 24 & 0xff] + '-' + lut[d2 & 0x3f | 0x80] + lut[d2 >> 8 & 0xff] + '-' + lut[d2 >> 16 & 0xff] + lut[d2 >> 24 & 0xff] + lut[d3 & 0xff] + lut[d3 >> 8 & 0xff] + lut[d3 >> 16 & 0xff] + lut[d3 >> 24 & 0xff];
}

function encodeBase64(dataString) {
    return _base2.default.encode(dataString);
}

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)


var toObject = __webpack_require__(17),
    toIndex = __webpack_require__(71),
    toLength = __webpack_require__(16);
module.exports = function fill(value /*, start = 0, end = @length */) {
  var O = toObject(this),
      length = toLength(O.length),
      aLen = arguments.length,
      index = toIndex(aLen > 1 ? arguments[1] : undefined, length),
      end = aLen > 2 ? arguments[2] : undefined,
      endPos = end === undefined ? length : toIndex(end, length);
  while (endPos > index) {
    O[index++] = value;
  }return O;
};

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $defineProperty = __webpack_require__(13),
    createDesc = __webpack_require__(56);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));else object[index] = value;
};

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isObject = __webpack_require__(9),
    document = __webpack_require__(6).document
// in old IE typeof document.createElement is 'object'
,
    is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var MATCH = __webpack_require__(11)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) {/* empty */}
  }return true;
};

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(6).document && document.documentElement;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isObject = __webpack_require__(9),
    setPrototypeOf = __webpack_require__(157).set;
module.exports = function (that, target, C) {
  var P,
      S = target.constructor;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  }return that;
};

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// check on default Array iterator
var Iterators = __webpack_require__(78),
    ITERATOR = __webpack_require__(11)('iterator'),
    ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 7.2.2 IsArray(argument)
var cof = __webpack_require__(37);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var create = __webpack_require__(66),
    descriptor = __webpack_require__(56),
    setToStringTag = __webpack_require__(79),
    IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(26)(IteratorPrototype, __webpack_require__(11)('iterator'), function () {
  return this;
});

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var LIBRARY = __webpack_require__(65),
    $export = __webpack_require__(0),
    redefine = __webpack_require__(27),
    hide = __webpack_require__(26),
    has = __webpack_require__(23),
    Iterators = __webpack_require__(78),
    $iterCreate = __webpack_require__(152),
    setToStringTag = __webpack_require__(79),
    getPrototypeOf = __webpack_require__(34),
    ITERATOR = __webpack_require__(11)('iterator'),
    BUGGY = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
,
    FF_ITERATOR = '@@iterator',
    KEYS = 'keys',
    VALUES = 'values';

var returnThis = function returnThis() {
  return this;
};

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function getMethod(kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS:
        return function keys() {
          return new Constructor(this, kind);
        };
      case VALUES:
        return function values() {
          return new Constructor(this, kind);
        };
    }return function entries() {
      return new Constructor(this, kind);
    };
  };
  var TAG = NAME + ' Iterator',
      DEF_VALUES = DEFAULT == VALUES,
      VALUES_BUG = false,
      proto = Base.prototype,
      $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT],
      $default = $native || getMethod(DEFAULT),
      $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined,
      $anyNative = NAME == 'Array' ? proto.entries || $native : $native,
      methods,
      key,
      IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() {
      return $native.call(this);
    };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = !$expm1
// Old FF bug
|| $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
// Tor Browser bug
|| $expm1(-2e-17) != -2e-17 ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global = __webpack_require__(6),
    macrotask = __webpack_require__(164).set,
    Observer = global.MutationObserver || global.WebKitMutationObserver,
    process = global.process,
    Promise = global.Promise,
    isNode = __webpack_require__(37)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function flush() {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();else last = undefined;
        throw e;
      }
    }last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function notify() {
      process.nextTick(flush);
    };
    // browsers with MutationObserver
  } else if (Observer) {
    var toggle = true,
        node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function notify() {
      node.data = toggle = !toggle;
    };
    // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function notify() {
      promise.then(flush);
    };
    // for other environments - macrotask based on:
    // - setImmediate
    // - MessageChannel
    // - window.postMessag
    // - onreadystatechange
    // - setTimeout
  } else {
    notify = function notify() {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    }last = task;
  };
};

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(9),
    anObject = __webpack_require__(4);
var check = function check(O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
  function (test, buggy, set) {
    try {
      set = __webpack_require__(48)(Function.call, __webpack_require__(33).f(Object.prototype, '__proto__').set, 2);
      set(test, []);
      buggy = !(test instanceof Array);
    } catch (e) {
      buggy = true;
    }
    return function setPrototypeOf(O, proto) {
      check(O, proto);
      if (buggy) O.__proto__ = proto;else set(O, proto);
      return O;
    };
  }({}, false) : undefined),
  check: check
};

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var shared = __webpack_require__(124)('keys'),
    uid = __webpack_require__(72);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(4),
    aFunction = __webpack_require__(25),
    SPECIES = __webpack_require__(11)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor,
      S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toInteger = __webpack_require__(57),
    defined = __webpack_require__(38);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that)),
        i = toInteger(pos),
        l = s.length,
        a,
        b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(120),
    defined = __webpack_require__(38);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toInteger = __webpack_require__(57),
    defined = __webpack_require__(38);

module.exports = function repeat(count) {
  var str = String(defined(this)),
      res = '',
      n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (; n > 0; (n >>>= 1) && (str += str)) {
    if (n & 1) res += str;
  }return res;
};

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = '\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003' + '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ctx = __webpack_require__(48),
    invoke = __webpack_require__(119),
    html = __webpack_require__(148),
    cel = __webpack_require__(145),
    global = __webpack_require__(6),
    process = global.process,
    setTask = global.setImmediate,
    clearTask = global.clearImmediate,
    MessageChannel = global.MessageChannel,
    counter = 0,
    queue = {},
    ONREADYSTATECHANGE = 'onreadystatechange',
    defer,
    channel,
    port;
var run = function run() {
  var id = +this;
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function listener(event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [],
        i = 1;
    while (arguments.length > i) {
      args.push(arguments[i++]);
    }queue[++counter] = function () {
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(37)(process) == 'process') {
    defer = function defer(id) {
      process.nextTick(ctx(run, id, 1));
    };
    // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function defer(id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
    // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function defer(id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
    // Rest old browsers
  } else {
    defer = function defer(id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global = __webpack_require__(6),
    DESCRIPTORS = __webpack_require__(12),
    LIBRARY = __webpack_require__(65),
    $typed = __webpack_require__(125),
    hide = __webpack_require__(26),
    redefineAll = __webpack_require__(69),
    fails = __webpack_require__(7),
    anInstance = __webpack_require__(64),
    toInteger = __webpack_require__(57),
    toLength = __webpack_require__(16),
    gOPN = __webpack_require__(67).f,
    dP = __webpack_require__(13).f,
    arrayFill = __webpack_require__(143),
    setToStringTag = __webpack_require__(79),
    ARRAY_BUFFER = 'ArrayBuffer',
    DATA_VIEW = 'DataView',
    PROTOTYPE = 'prototype',
    WRONG_LENGTH = 'Wrong length!',
    WRONG_INDEX = 'Wrong index!',
    $ArrayBuffer = global[ARRAY_BUFFER],
    $DataView = global[DATA_VIEW],
    Math = global.Math,
    RangeError = global.RangeError,
    Infinity = global.Infinity,
    BaseBuffer = $ArrayBuffer,
    abs = Math.abs,
    pow = Math.pow,
    floor = Math.floor,
    log = Math.log,
    LN2 = Math.LN2,
    BUFFER = 'buffer',
    BYTE_LENGTH = 'byteLength',
    BYTE_OFFSET = 'byteOffset',
    $BUFFER = DESCRIPTORS ? '_b' : BUFFER,
    $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH,
    $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
var packIEEE754 = function packIEEE754(value, mLen, nBytes) {
  var buffer = Array(nBytes),
      eLen = nBytes * 8 - mLen - 1,
      eMax = (1 << eLen) - 1,
      eBias = eMax >> 1,
      rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0,
      i = 0,
      s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0,
      e,
      m,
      c;
  value = abs(value);
  if (value != value || value === Infinity) {
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8) {}
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8) {}
  buffer[--i] |= s * 128;
  return buffer;
};
var unpackIEEE754 = function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1,
      eMax = (1 << eLen) - 1,
      eBias = eMax >> 1,
      nBits = eLen - 7,
      i = nBytes - 1,
      s = buffer[i--],
      e = s & 127,
      m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8) {}
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8) {}
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  }return (s ? -1 : 1) * m * pow(2, e - mLen);
};

var unpackI32 = function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
};
var packI8 = function packI8(it) {
  return [it & 0xff];
};
var packI16 = function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
};
var packI32 = function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
};
var packF64 = function packF64(it) {
  return packIEEE754(it, 52, 8);
};
var packF32 = function packF32(it) {
  return packIEEE754(it, 23, 4);
};

var addGetter = function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function get() {
      return this[internal];
    } });
};

var get = function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index,
      intIndex = toInteger(numIndex);
  if (numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b,
      start = intIndex + view[$OFFSET],
      pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
};
var set = function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index,
      intIndex = toInteger(numIndex);
  if (numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b,
      start = intIndex + view[$OFFSET],
      pack = conversion(+value);
  for (var i = 0; i < bytes; i++) {
    store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
  }
};

var validateArrayBufferArguments = function validateArrayBufferArguments(that, length) {
  anInstance(that, $ArrayBuffer, ARRAY_BUFFER);
  var numberLength = +length,
      byteLength = toLength(numberLength);
  if (numberLength != byteLength) throw RangeError(WRONG_LENGTH);
  return byteLength;
};

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    var byteLength = validateArrayBufferArguments(this, length);
    this._b = arrayFill.call(Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH],
        offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /*, littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /*, littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /*, littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /*, littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /*, littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /*, littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /*, littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /*, littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /*, littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /*, littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /*, littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /*, littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
  }) || !fails(function () {
    new $ArrayBuffer(.5); // eslint-disable-line no-new
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      return new BaseBuffer(validateArrayBufferArguments(this, length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    };
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2)),
      $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global = __webpack_require__(6),
    core = __webpack_require__(47),
    LIBRARY = __webpack_require__(65),
    wksExt = __webpack_require__(240),
    defineProperty = __webpack_require__(13).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(96),
    ITERATOR = __webpack_require__(11)('iterator'),
    Iterators = __webpack_require__(78);
module.exports = __webpack_require__(47).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
};

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var addToUnscopables = __webpack_require__(76),
    step = __webpack_require__(228),
    Iterators = __webpack_require__(78),
    toIObject = __webpack_require__(29);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(153)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0; // next index
  this._k = kind; // kind
  // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t,
      kind = this._k,
      index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Loading = __webpack_require__(595);

var _Loading2 = _interopRequireDefault(_Loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonDefault = function (_Component) {
	_inherits(ButtonDefault, _Component);

	function ButtonDefault() {
		_classCallCheck(this, ButtonDefault);

		return _possibleConstructorReturn(this, (ButtonDefault.__proto__ || Object.getPrototypeOf(ButtonDefault)).apply(this, arguments));
	}

	_createClass(ButtonDefault, [{
		key: 'handleClick',
		value: function handleClick(e) {
			e.preventDefault();
			var buttonState = this.props.buttonState;

			if (buttonState === 'loading') {
				return;
			}
			this.props.handleClick(e);
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    id = _props.id,
			    intl = _props.intl,
			    type = _props.type,
			    children = _props.children,
			    showDisabled = _props.showDisabled,
			    qaSelector = _props.qaSelector,
			    buttonState = _props.buttonState,
			    decoratorClass = _props.decoratorClass,
			    isButtonSmall = _props.isButtonSmall,
			    name = _props.name;


			var isLoading = buttonState === 'loading';
			var isDisabled = this.props.isDisabled || isLoading;
			var accessibleIsLoadingText = buttonState === 'loading' && (this.props.accessibleIsLoadingText ? this.props.accessibleIsLoadingText : intl.formatMessage('content|_defaults|accessibleIsLoadingText'));
			var loadingClass = isButtonSmall ? 'dna-button-small-loading js-is-loading' : 'dna-button-loading js-is-loading';

			return _react2.default.createElement(
				'button',
				{
					role: 'button',
					id: id,
					name: name || id,
					type: type,
					className: (decoratorClass ? decoratorClass : '') + ' ' + (isButtonSmall ? 'dna-button-small' : '') + ' ' + (isLoading ? loadingClass : '') + ' ' + (!isLoading && showDisabled && isDisabled ? 'is-disabled' : ''),
					'data-qa': qaSelector,
					onClick: this.handleClick.bind(this),
					disabled: isDisabled,
					'aria-disabled': isDisabled },
				isLoading && _react2.default.createElement(
					'span',
					null,
					_react2.default.createElement(
						'span',
						{ className: 'dna-button-text' },
						children
					),
					_react2.default.createElement(_Loading2.default, {
						ariaHidden: !isLoading,
						className: 'dna-loading-button',
						accessibleText: accessibleIsLoadingText,
						qaSelector: qaSelector + '-loading' })
				),
				!isLoading && children
			);
		}
	}]);

	return ButtonDefault;
}(_react.Component);

ButtonDefault.propTypes = {
	type: _react.PropTypes.string,
	id: _react.PropTypes.string,
	name: _react.PropTypes.string,
	isDisabled: _react.PropTypes.bool,
	showDisabled: _react.PropTypes.bool,
	handleClick: _react.PropTypes.func,
	decoratorClass: _react.PropTypes.string,
	buttonState: _react.PropTypes.string,
	isButtonSmall: _react.PropTypes.bool,
	qaSelector: _react.PropTypes.string,
	children: _react2.default.PropTypes.any,
	intl: _react.PropTypes.object, // GG.FrontEnd.DNA.react.intl
	accessibleIsLoadingText: _react.PropTypes.string
};
ButtonDefault.defaultProps = {
	type: 'button',
	decoratorClass: 'dna-button-brand',
	handleClick: function handleClick() {},
	isDisabled: false,
	showDisabled: true,
	buttonIsSmallVariant: false
};
exports.default = ButtonDefault;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.queryStringParse = queryStringParse;
/**
 * QueryString utils module
 * @module: utils/queryString
 * @exports: queryStringParse
 */

/**
 * Create a hash map of query string key-value pairs.
 * @param {string} str - location.hash string to hash
 * @returns {object} hash map of query string key-value pairs
 * @author by Sindre Sorhus
 * @license MIT License
 * @see https://github.com/sindresorhus/query-string
 */
function queryStringParse(str) {
	if (typeof str !== 'string') {
		return {};
	}

	str = str.trim().replace(/^(\?|#)/, '');
	str = str.indexOf('#') ? str.slice(str.indexOf('?') + 1) : str;

	if (!str) {
		return {};
	}

	return str.trim().split('&').reduce(function (ret, param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		var key = parts[0];
		var val = parts[1];

		key = decodeURIComponent(key);
		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		if (!ret.hasOwnProperty(key)) {
			ret[key] = val;
		} else if (Array.isArray(ret[key])) {
			ret[key].push(val);
		} else {
			ret[key] = [ret[key], val];
		}

		return ret;
	}, {});
}

/***/ }),
/* 171 */,
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2014 Facebook, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */



/**
 * Constructs an enumeration with keys equal to their value.
 *
 * For example:
 *
 *   var COLORS = keyMirror({blue: null, red: null});
 *   var myColor = COLORS.blue;
 *   var isColorValid = !!COLORS[myColor];
 *
 * The last line could not be performed if the values of the generated enum were
 * not equal to their keys.
 *
 *   Input:  {key1: val1, key2: val2}
 *   Output: {key1: key1, key2: key2}
 *
 * @param {object} obj
 * @return {object}
 */

var keyMirror = function keyMirror(obj) {
  var ret = {};
  var key;
  if (!(obj instanceof Object && !Array.isArray(obj))) {
    throw new Error('keyMirror(...): Argument must be an object.');
  }
  for (key in obj) {
    if (!obj.hasOwnProperty(key)) {
      continue;
    }
    ret[key] = key;
  }
  return ret;
};

module.exports = keyMirror;

/***/ }),
/* 173 */,
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var root = __webpack_require__(58);

/** Built-in value references. */
var _Symbol = root.Symbol;

module.exports = _Symbol;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isFunction = __webpack_require__(82),
    isLength = __webpack_require__(263);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseGetTag = __webpack_require__(73),
    isArray = __webpack_require__(100),
    isObjectLike = __webpack_require__(83);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
    return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
}

module.exports = isString;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var baseGetTag = __webpack_require__(73),
    isObjectLike = __webpack_require__(83);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
    return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
}

module.exports = isSymbol;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _ImmutableUtils = __webpack_require__(126);

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var PolymorphicSchema = function () {
  function PolymorphicSchema(definition, schemaAttribute) {
    _classCallCheck(this, PolymorphicSchema);

    if (schemaAttribute) {
      this._schemaAttribute = typeof schemaAttribute === 'string' ? function (input) {
        return input[schemaAttribute];
      } : schemaAttribute;
    }
    this.define(definition);
  }

  _createClass(PolymorphicSchema, [{
    key: 'define',
    value: function define(definition) {
      this.schema = definition;
    }
  }, {
    key: 'getSchemaAttribute',
    value: function getSchemaAttribute(input, parent, key) {
      return !this.isSingleSchema && this._schemaAttribute(input, parent, key);
    }
  }, {
    key: 'inferSchema',
    value: function inferSchema(input, parent, key) {
      if (this.isSingleSchema) {
        return this.schema;
      }

      var attr = this.getSchemaAttribute(input, parent, key);
      return this.schema[attr];
    }
  }, {
    key: 'normalizeValue',
    value: function normalizeValue(value, parent, key, visit, addEntity) {
      var schema = this.inferSchema(value, parent, key);
      if (!schema) {
        return value;
      }
      var normalizedValue = visit(value, parent, key, schema, addEntity);
      return this.isSingleSchema || normalizedValue === undefined || normalizedValue === null ? normalizedValue : { id: normalizedValue, schema: this.getSchemaAttribute(value, parent, key) };
    }
  }, {
    key: 'denormalizeValue',
    value: function denormalizeValue(value, unvisit) {
      var schemaKey = (0, _ImmutableUtils.isImmutable)(value) ? value.get('schema') : value.schema;
      if (!this.isSingleSchema && !schemaKey) {
        return value;
      }
      var id = (0, _ImmutableUtils.isImmutable)(value) ? value.get('id') : value.id;
      var schema = this.isSingleSchema ? this.schema : this.schema[schemaKey];
      return unvisit(id || value, schema);
    }
  }, {
    key: 'isSingleSchema',
    get: function get() {
      return !this._schemaAttribute;
    }
  }]);

  return PolymorphicSchema;
}();

exports.default = PolymorphicSchema;

/***/ }),
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.types = undefined;

var _reduxUtils = __webpack_require__(110);

var types = exports.types = {
  UPDATE_FRIENDS_LIST: '@jg/UPDATE_FRIENDS_LIST',
  UPDATE_AUTH_RESPONSE: '@jg/UPDATE_AUTH_RESPONSE',
  TOGGLE_FRIEND_SELECTION: '@jg/TOGGLE_FRIEND_SELECTION',
  REMOVE_FRIEND_SELECTION: '@jg/REMOVE_FRIEND_SELECTION',
  FILTER_FRIENDS: '@jg/FILTER_FRIENDS'
};

var actions = {
  fbLogin: function fbLogin() {
    return function (dispatch) {
      var fbOptions = {
        scope: 'user_friends publish_actions',
        auth_type: 'rerequest',
        return_scopes: true
      };

      /* istanbul ignore next */
      window.FB.login(function (response) {
        if (response.authResponse && response.authResponse.grantedScopes && response.authResponse.grantedScopes.includes('publish_actions')) {
          dispatch({
            type: types.UPDATE_AUTH_RESPONSE,
            fbAuthResponse: response.authResponse
          });
          dispatch(actions.getTaggableFriends());
          // } else {
          //   console.log('Authorization failed.');
        }
      }, fbOptions);
    };
  },

  getTaggableFriends: function getTaggableFriends() {
    return function (dispatch) {
      /* istanbul ignore next */
      window.FB.api('/me/taggable_friends?limit=5000', function (response) {
        if (response && !response.error) {
          dispatch({
            type: types.UPDATE_FRIENDS_LIST,
            fbFriendsData: response.data
          });
        }
      });
    };
  },

  toggleFriendSelection: (0, _reduxUtils.makeActionCreator)(types.TOGGLE_FRIEND_SELECTION, 'id'),

  removeFriendSelection: (0, _reduxUtils.makeActionCreator)(types.REMOVE_FRIEND_SELECTION, 'id'),

  filterFriends: (0, _reduxUtils.makeActionCreator)(types.FILTER_FRIENDS, 'friendsFilterText'),

  postToFB: function postToFB(fundraisingPageUrl, message, apiCallback) {
    return function (dispatch, getState) {
      var state = getState();
      var facebookInviteFriendsStore = state.facebookInviteFriendsStore;

      var friendList = facebookInviteFriendsStore.get('selectedFriends').toJS();

      var apiOptions = {
        link: fundraisingPageUrl,
        tags: friendList.join(','),
        message: message
      };

      window.FB.api('/me/feed', 'POST', apiOptions, apiCallback);
    };
  }
};

exports.default = actions;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(586);

__webpack_require__(808);

__webpack_require__(406);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(75)))

/***/ }),
/* 211 */,
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.App = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(20);

var _reactRouter = __webpack_require__(18);

var _redux = __webpack_require__(21);

var _config = __webpack_require__(46);

var _actions = __webpack_require__(63);

var _utils = __webpack_require__(22);

var _router = __webpack_require__(114);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var App = exports.App = (_temp = _class = function (_Component) {
	_inherits(App, _Component);

	function App() {
		_classCallCheck(this, App);

		return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
	}

	_createClass(App, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this.setLoggedInStatus();
		}
	}, {
		key: 'setLoggedInStatus',
		value: function setLoggedInStatus() {
			var _hasPreviouslyLoggedIn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _utils.hasPreviouslyLoggedIn;

			var _props = this.props,
			    updateRoute = _props.updateRoute,
			    router = _props.router,
			    userActions = _props.userActions,
			    publicPath = _props.publicPath;

			var prevLoggedInDetails = _hasPreviouslyLoggedIn();
			var _props$hostAppProps = this.props.hostAppProps,
			    hostEmail = _props$hostAppProps.emailAddress,
			    hostFirstName = _props$hostAppProps.firstName,
			    hostLastName = _props$hostAppProps.lastName,
			    hostFbLoginScope = _props$hostAppProps.fbLoginScope;

			var emailAddress = hostEmail || prevLoggedInDetails.emailAddress;
			var firstName = hostFirstName || prevLoggedInDetails.firstName;
			var lastName = hostLastName || prevLoggedInDetails.lastName;

			emailAddress && userActions.updateEmailAddress(emailAddress);
			firstName && userActions.updateFirstName(firstName);
			lastName && userActions.updateLastName(lastName);
			hostFbLoginScope && userActions.updateFbLoginScope(hostFbLoginScope);
			userActions.setPropsFromHost(this.props.hostAppProps || {});

			if (prevLoggedInDetails.hasLoggedIn && emailAddress === prevLoggedInDetails.emailAddress) {
				(0, _router.setRoute)(updateRoute, router)(_router.path.join(publicPath, _config.PAGES.PasswordPage.route));
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var children = this.props.children;

			return _react2.default.createElement(
				'div',
				null,
				children
			);
		}
	}]);

	return App;
}(_react.Component), _class.propTypes = {
	updateRoute: _propTypes2.default.func,
	userActions: _propTypes2.default.object,
	children: _propTypes2.default.element.isRequired,
	hostAppProps: _propTypes2.default.object,
	// HOCs
	router: _propTypes2.default.object,
	publicPath: _propTypes2.default.string
}, _class.defaultProps = {
	hostAppProps: {}
}, _temp);


var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return {
		userActions: (0, _redux.bindActionCreators)(_actions.userActions, dispatch)
	};
};

var AppComposed = (0, _reactRouter.withRouter)(App);
exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(AppComposed);

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.EmailPageWithRouter = exports.mapStateToProps = exports.EmailPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(20);

var _reactRouter = __webpack_require__(18);

var _redux = __webpack_require__(21);

var _actions = __webpack_require__(63);

var _mixins = __webpack_require__(139);

var _config = __webpack_require__(46);

var _PageBoilerplateDefault = __webpack_require__(112);

var _PageBoilerplateDefault2 = _interopRequireDefault(_PageBoilerplateDefault);

var _reducers = __webpack_require__(113);

var _router = __webpack_require__(114);

var _components = __webpack_require__(111);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EmailPage = exports.EmailPage = (0, _mixins.Validation)(_class = (_temp = _class2 = function (_Component) {
	_inherits(EmailPage, _Component);

	function EmailPage(props) {
		_classCallCheck(this, EmailPage);

		/**
   * Component-specific UI state
   */
		// Clear existing alerts
		var _this = _possibleConstructorReturn(this, (EmailPage.__proto__ || Object.getPrototypeOf(EmailPage)).call(this, props));

		_this.state = {
			alertFacebookLoginError: false,
			alertEmailLoginError: false
		};

		// Register which fields on the page expected validation
		_this.validatedFields = ['emailAddress'];
		return _this;
	}

	_createClass(EmailPage, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			var _this2 = this;

			this.validatedFields.forEach(function (field) {
				_this2.hasErrors(field) && _this2.clearValidation(field);
			});
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			var propsFromHost = this.props.propsFromHost;


			if (propsFromHost.onEmailPageMount) {
				propsFromHost.onEmailPageMount();
			}
		}
	}, {
		key: 'handleEmailAddressBlur',
		value: function handleEmailAddressBlur(e) {
			this.validate('emailAddress', e.target.value);
		}
	}, {
		key: 'handleEmailAddressChange',
		value: function handleEmailAddressChange(e) {
			var userActions = this.props.userActions;

			userActions.updateEmailAddress(e.target.value);
		}
	}, {
		key: 'handleContinue',
		value: function handleContinue() {
			var _props = this.props,
			    emailAddress = _props.emailAddress,
			    propsFromHost = _props.propsFromHost;


			if (propsFromHost.onLoginWithEmailClicked) {
				propsFromHost.onLoginWithEmailClicked();
			}

			this.isValid('emailAddress', emailAddress) && this.proceed();
		}
	}, {
		key: 'loginWithFacebook',
		value: function loginWithFacebook(e) {
			var _this3 = this;

			var _props2 = this.props,
			    requestSettings = _props2.requestSettings,
			    facebookThunk = _props2.facebookThunk,
			    loginSuccessCallback = _props2.loginSuccessCallback,
			    propsFromHost = _props2.propsFromHost;

			if (propsFromHost.onLoginWithFacebookClicked) {
				propsFromHost.onLoginWithFacebookClicked();
			}
			e.preventDefault();
			// Clear existing error alerts
			this.setState({
				alertFacebookLoginError: false,
				alertEmailLoginError: false
			});
			facebookThunk.facebookLogin(requestSettings).then(loginSuccessCallback).catch(function (error) {
				if (error !== 'unknown') {
					// Show latest Facebook error alerts
					_this3.setState({
						alertFacebookLoginError: true
					});
				}
			});
		}
	}, {
		key: 'getRecoverableError',
		value: function getRecoverableError() {
			var _props3 = this.props,
			    facebookConnectError = _props3.facebookConnectError,
			    iamFacebookLoginError = _props3.iamFacebookLoginError,
			    iamEmailCheckError = _props3.iamEmailCheckError;
			var _state = this.state,
			    alertFacebookLoginError = _state.alertFacebookLoginError,
			    alertEmailLoginError = _state.alertEmailLoginError;


			if (alertFacebookLoginError) {
				return facebookConnectError || iamFacebookLoginError;
			} else if (alertEmailLoginError) {
				return iamEmailCheckError;
			}
		}
	}, {
		key: 'proceed',
		value: function proceed() {
			var _this4 = this;

			var _props4 = this.props,
			    iamThunk = _props4.iamThunk,
			    updateRoute = _props4.updateRoute,
			    router = _props4.router,
			    publicPath = _props4.publicPath;

			// Clear existing error alerts

			this.setState({
				alertFacebookLoginError: false,
				alertEmailLoginError: false
			});
			iamThunk.iamEmailCheck().then(function (response) {
				response === _config.iamMessages.USER_FOUND && (0, _router.setRoute)(updateRoute, router)(_router.path.join(publicPath, 'password'));
				response === _config.iamMessages.NO_USER_FOUND.error && (0, _router.setRoute)(updateRoute, router)(_router.path.join(publicPath, 'register'));
			}).catch(function () {
				// Show latest email check error alerts
				_this4.setState({
					alertEmailLoginError: true
				});
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _props5 = this.props,
			    intl = _props5.intl,
			    emailPageHeading1 = _props5.emailPageHeading1,
			    emailPageFacebookAssuranceMessage = _props5.emailPageFacebookAssuranceMessage,
			    emailAddress = _props5.emailAddress,
			    errors = _props5.errors,
			    mainClassName = _props5.mainClassName,
			    facebookRequestInFlight = _props5.facebookRequestInFlight,
			    iamFacebookRequestInFlight = _props5.iamFacebookRequestInFlight,
			    iamEmailRequestInFlight = _props5.iamEmailRequestInFlight,
			    emailPageContinueButtonLabel = _props5.emailPageContinueButtonLabel,
			    globalAlertsDecoratorClass = _props5.globalAlertsDecoratorClass,
			    isAppDisabled = _props5.isAppDisabled,
			    facebookLoginStatus = _props5.facebookLoginStatus;


			var isFormButtonDisabled = !this.isEveryValid.call(this) || isAppDisabled || facebookRequestInFlight || iamFacebookRequestInFlight;

			return _react2.default.createElement(
				_PageBoilerplateDefault2.default,
				{
					intl: intl,
					globalAlertsDecoratorClass: globalAlertsDecoratorClass,
					HeadingH1Content: emailPageHeading1,
					isRecoverableError: this.getRecoverableError.call(this),
					mainClassName: mainClassName,
					handleSubmit: this.handleContinue.bind(this) },
				_react2.default.createElement(_components.DNAButtonSocial, {
					buttonState: facebookRequestInFlight || iamFacebookRequestInFlight || !facebookLoginStatus ? 'loading' : '',
					intl: intl,
					isDisabled: isAppDisabled,
					buttonText: intl.formatMessage('content|login:email|facebookLoginButtonLabel'),
					socialNetwork: 'Facebook',
					handleClickProp: this.loginWithFacebook.bind(this) }),
				_react2.default.createElement(
					'p',
					{ className: 'login-text-facebook-login dna-text-s' },
					emailPageFacebookAssuranceMessage || intl.formatMessage('content|login:email|facebookAssuranceMessage')
				),
				_react2.default.createElement(
					'div',
					{ className: 'login-section-divider-email-page' },
					intl.formatMessage('content|_defaults|or'),
					_react2.default.createElement(
						'span',
						{ className: 'dna-invisible' },
						'\xA0',
						intl.formatMessage('content|login:email|accessibleEmailLoginText')
					)
				),
				_react2.default.createElement(_components.DNAInputWithLabel, {
					parent: this,
					errorKey: 'emailAddress',
					handleBlur: this.handleEmailAddressBlur.bind(this),
					handleChangeProp: this.handleEmailAddressChange.bind(this),
					type: 'email',
					value: emailAddress,
					id: 'emailAddress',
					label: intl.formatMessage('content|login:email|emailFieldLabel'),
					sizeVariant: 'medium',
					errors: errors.emailAddress }),
				_react2.default.createElement(_components.DNAValidationMessage, {
					intl: intl,
					wrapperClass: 'login-validation-message',
					errors: [].concat(_toConsumableArray(errors.emailAddress || [])) }),
				_react2.default.createElement(
					_components.DNAButtonDefault,
					{
						intl: intl,
						decoratorClass: 'dna-button-brand dna-space-mtm',
						buttonState: iamEmailRequestInFlight ? 'loading' : '',
						handleClick: this.handleContinue.bind(this),
						qaSelector: 'EmailPageContinueButton',
						showDisabled: isFormButtonDisabled,
						isDisabled: isFormButtonDisabled },
					emailPageContinueButtonLabel ? emailPageContinueButtonLabel : intl.formatMessage('content|login:email|defaultContinueButtonLabel')
				)
			);
		}
	}]);

	return EmailPage;
}(_react.Component), _class2.propTypes = {
	updateRoute: _propTypes2.default.func,
	requestSettings: _propTypes2.default.object.isRequired,
	emailPageHeading1: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
	emailPageFacebookAssuranceMessage: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
	isAppDisabled: _propTypes2.default.bool,
	facebookLoginStatus: _propTypes2.default.object,
	emailPageContinueButtonLabel: _propTypes2.default.string,
	globalAlertsDecoratorClass: _propTypes2.default.string,
	emailAddress: _propTypes2.default.string,
	mainClassName: _propTypes2.default.string,
	userActions: _propTypes2.default.object,
	facebookRequestInFlight: _propTypes2.default.bool.isRequired,
	iamFacebookRequestInFlight: _propTypes2.default.bool.isRequired,
	iamEmailRequestInFlight: _propTypes2.default.bool.isRequired,
	facebookConnectError: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	iamEmailCheckError: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	iamFacebookLoginError: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	loginSuccessCallback: _propTypes2.default.func,
	iamThunk: _propTypes2.default.object.isRequired,
	facebookThunk: _propTypes2.default.object.isRequired,
	// HOCs
	intl: _propTypes2.default.object.isRequired,
	router: _propTypes2.default.object,
	// Decorators
	errors: _propTypes2.default.object,
	propsFromHost: _propTypes2.default.object
}, _class2.defaultProps = {
	errors: {},
	emailAddress: '',
	propsFromHost: {}
}, _temp)) || _class;

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
	var facebookRequestInFlight = state.HTTP_request.facebook_connect && state.HTTP_request.facebook_connect.isInflight ? true : false;
	var iamFacebookRequestInFlight = state.HTTP_request.iam_facebook_login && state.HTTP_request.iam_facebook_login.isInflight ? true : false;
	var iamEmailRequestInFlight = state.HTTP_request.iam_email_check && state.HTTP_request.iam_email_check.isInflight ? true : false;

	return {
		facebookRequestInFlight: facebookRequestInFlight,
		facebookConnectError: (0, _reducers.getRecoverableErrorType)(state, 'facebook_connect', state.APP_network),
		iamFacebookRequestInFlight: iamFacebookRequestInFlight,
		iamFacebookLoginError: (0, _reducers.getRecoverableErrorType)(state, 'iam_facebook_login', state.APP_network),
		iamEmailRequestInFlight: iamEmailRequestInFlight,
		iamEmailCheckError: (0, _reducers.getRecoverableErrorType)(state, 'iam_email_check', state.APP_network),
		emailAddress: state.emailAddress || '',
		errors: state.VALIDATION_errors,
		propsFromHost: state.propsFromHost
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return {
		userActions: (0, _redux.bindActionCreators)(_actions.userActions, dispatch),
		appActions: (0, _redux.bindActionCreators)(_actions.appActions, dispatch),
		validationActions: (0, _redux.bindActionCreators)(_actions.validationActions, dispatch),
		facebookThunk: (0, _redux.bindActionCreators)(_actions.facebookThunk, dispatch),
		iamThunk: (0, _redux.bindActionCreators)(_actions.iamThunk, dispatch)
	};
};

var EmailPageComposed = (0, _mixins.Intl)(EmailPage);
var EmailPageWithRouter = exports.EmailPageWithRouter = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactRouter.withRouter)(EmailPageComposed));
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(EmailPageComposed);

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.PasswordPageWithRouter = exports.mapStateToProps = exports.PasswordPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(20);

var _reactRouter = __webpack_require__(18);

var _redux = __webpack_require__(21);

var _actions = __webpack_require__(63);

var _mixins = __webpack_require__(139);

var _PageBoilerplateDefault = __webpack_require__(112);

var _PageBoilerplateDefault2 = _interopRequireDefault(_PageBoilerplateDefault);

var _reducers = __webpack_require__(113);

var _router = __webpack_require__(114);

var _config = __webpack_require__(46);

var _utils = __webpack_require__(22);

var _components = __webpack_require__(111);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PasswordPage = exports.PasswordPage = (0, _mixins.Validation)(_class = (_temp = _class2 = function (_Component) {
	_inherits(PasswordPage, _Component);

	function PasswordPage(props) {
		_classCallCheck(this, PasswordPage);

		/**
   * Component-specific UI state
   */
		// Clear existing alerts
		var _this = _possibleConstructorReturn(this, (PasswordPage.__proto__ || Object.getPrototypeOf(PasswordPage)).call(this, props));

		_this.state = {
			alertLoginError: false
		};

		// Register which fields on the page expected validation
		_this.validatedFields = ['password'];
		return _this;
	}

	_createClass(PasswordPage, [{
		key: 'setEmailFromCookieIfNotAvailableOrRedirectToEmailPage',
		value: function setEmailFromCookieIfNotAvailableOrRedirectToEmailPage() {
			var _hasPreviouslyLoggedIn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _utils.hasPreviouslyLoggedIn;

			var _props = this.props,
			    userActions = _props.userActions,
			    emailAddress = _props.emailAddress;

			if (!emailAddress || typeof emailAddress === 'string' && emailAddress.trim().length === 0) {
				var prevLoggedInDetails = _hasPreviouslyLoggedIn();
				if (prevLoggedInDetails.hasLoggedIn) {
					userActions.updateEmailAddress(prevLoggedInDetails.emailAddress);
				} else {
					this.directToEmailPage();
				}
			}
		}
	}, {
		key: 'componentWillMount',
		value: function componentWillMount() {
			var _this2 = this;

			var userActions = this.props.userActions;
			// Clear password field

			userActions.updatePassword('');

			this.validatedFields.forEach(function (field) {
				_this2.hasErrors(field) && _this2.clearValidation(field);
			});
			this.setEmailFromCookieIfNotAvailableOrRedirectToEmailPage();
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			var propsFromHost = this.props.propsFromHost;


			if (propsFromHost.onPasswordPageMount) {
				propsFromHost.onPasswordPageMount();
			}
		}
	}, {
		key: 'handlePasswordBlur',
		value: function handlePasswordBlur(e) {
			this.validate('password', e.target.value);
		}
	}, {
		key: 'handlePasswordChange',
		value: function handlePasswordChange(e) {
			var userActions = this.props.userActions;

			userActions.updatePassword(e.target.value);
		}
	}, {
		key: 'handleContinue',
		value: function handleContinue() {
			var _props2 = this.props,
			    password = _props2.password,
			    propsFromHost = _props2.propsFromHost;


			if (propsFromHost.onPasswordPageSubmitClicked) {
				propsFromHost.onPasswordPageSubmitClicked();
			}

			this.isValid('password', password) && this.proceed();
		}
	}, {
		key: 'directToEmailPage',
		value: function directToEmailPage() {
			var _props3 = this.props,
			    updateRoute = _props3.updateRoute,
			    router = _props3.router,
			    publicPath = _props3.publicPath;

			(0, _router.setRoute)(updateRoute, router)(_router.path.join(publicPath, 'email'));
		}
	}, {
		key: 'handleEditEmailAddressClick',
		value: function handleEditEmailAddressClick(e) {
			e.preventDefault();
			this.directToEmailPage();
		}
	}, {
		key: 'handleFacebookLoginClick',
		value: function handleFacebookLoginClick(e) {
			e.preventDefault();
			this.directToEmailPage();
		}
	}, {
		key: 'getDefaultHeading1',
		value: function getDefaultHeading1() {
			var _props4 = this.props,
			    intl = _props4.intl,
			    firstName = _props4.firstName;

			return '' + intl.formatMessage('content|login:password|defaultHeading1') + (firstName ? ' ' + firstName : '');
		}
	}, {
		key: 'proceed',
		value: function proceed() {
			var _this3 = this;

			var _props5 = this.props,
			    requestSettings = _props5.requestSettings,
			    iamThunk = _props5.iamThunk,
			    loginSuccessCallback = _props5.loginSuccessCallback;
			// Clear existing alerts

			this.state = {
				alertLoginError: false
			};
			iamThunk.iamJgLogin(requestSettings).then(loginSuccessCallback).catch(function (error) {
				// Enable alerts
				_this3.setState({
					alertLoginError: true
				});
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _props6 = this.props,
			    intl = _props6.intl,
			    passwordPageHeading1 = _props6.passwordPageHeading1,
			    password = _props6.password,
			    errors = _props6.errors,
			    emailAddress = _props6.emailAddress,
			    mainClassName = _props6.mainClassName,
			    iamLoginRequestInFlight = _props6.iamLoginRequestInFlight,
			    passwordPageContinueButtonLabel = _props6.passwordPageContinueButtonLabel,
			    globalAlertsDecoratorClass = _props6.globalAlertsDecoratorClass,
			    isAppDisabled = _props6.isAppDisabled,
			    iamRequestError = _props6.iamRequestError;
			var alertLoginError = this.state.alertLoginError;


			var isFormButtonDisabled = !this.isEveryValid.call(this) || isAppDisabled || iamLoginRequestInFlight;

			return _react2.default.createElement(
				_PageBoilerplateDefault2.default,
				{
					intl: intl,
					globalAlertsDecoratorClass: globalAlertsDecoratorClass,
					HeadingH1Content: '' + (passwordPageHeading1 ? passwordPageHeading1 : this.getDefaultHeading1.call(this)),
					mainClassName: mainClassName,
					isRecoverableError: alertLoginError && iamRequestError,
					handleSubmit: this.handleContinue.bind(this) },
				_react2.default.createElement(_components.Avatar, null),
				emailAddress && _react2.default.createElement(
					'div',
					{ className: 'login-text-user-email dna-text-center' },
					_react2.default.createElement(
						'span',
						{ 'data-qa': 'returningUserEmailAddress' },
						emailAddress
					),
					' ',
					_react2.default.createElement('br', null),
					intl.formatMessage('content|login:password|correctEmailAddressMessage'),
					'\xA0',
					_react2.default.createElement(
						'a',
						{
							'data-qa': 'editEmailAddressLink',
							className: 'dna-text-link',
							onClick: this.handleEditEmailAddressClick.bind(this) },
						intl.formatMessage('content|login:password|editEmailAddressButtonLabel')
					)
				),
				_react2.default.createElement(_components.DNAInputWithLabel, {
					parent: this,
					errorKey: 'password',
					handleBlur: this.handlePasswordBlur.bind(this),
					handleChangeProp: this.handlePasswordChange.bind(this),
					type: 'password',
					isPasswordField: true,
					value: password,
					toggleButtonTextHide: intl.formatMessage('content|login:password|passwordFieldHintLabelHide'),
					toggleButtonTextShow: intl.formatMessage('content|login:password|passwordFieldHintLabelShow'),
					id: 'password',
					label: intl.formatMessage('content|login:password|passwordFieldLabel'),
					sizeVariant: 'medium',
					errors: errors.password }),
				_react2.default.createElement(_components.DNAValidationMessage, {
					wrapperClass: 'login-validation-message',
					intl: intl,
					errors: [].concat(_toConsumableArray(errors.password || [])) }),
				_react2.default.createElement(
					'p',
					{ className: 'login-hint-text-forgot-password dna-text-s-lite' },
					intl.formatMessage('content|login:password|forgotPasswordMessage'),
					'\xA0',
					_react2.default.createElement(
						'a',
						{
							'data-qa': 'resetPasswordLink',
							className: 'dna-text-link dna-text-s',
							href: _config.config.resetPasswordLink,
							target: '_blank' },
						intl.formatMessage('content|login:password|resetPasswordMessage')
					),
					'\xA0 ',
					intl.formatMessage('content|_defaults|or'),
					'\xA0',
					_react2.default.createElement(
						'a',
						{
							'data-qa': 'fbLoginLink',
							className: 'dna-text-link dna-text-s',
							onClick: this.handleFacebookLoginClick.bind(this) },
						intl.formatMessage('content|login:password|loginWithFacebookMessage')
					)
				),
				_react2.default.createElement(
					_components.DNAButtonDefault,
					{
						intl: intl,
						decoratorClass: 'dna-button-brand dna-space-mtm',
						buttonState: iamLoginRequestInFlight ? 'loading' : '',
						showDisabled: isFormButtonDisabled,
						isDisabled: isFormButtonDisabled,
						qaSelector: 'PasswordPageContinueButton',
						handleClick: this.handleContinue.bind(this) },
					passwordPageContinueButtonLabel ? passwordPageContinueButtonLabel : intl.formatMessage('content|login:password|defaultContinueButtonLabel')
				)
			);
		}
	}]);

	return PasswordPage;
}(_react.Component), _class2.propTypes = {
	updateRoute: _propTypes2.default.func,
	requestSettings: _propTypes2.default.object.isRequired,
	passwordPageHeading1: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
	isAppDisabled: _propTypes2.default.bool,
	loginSuccessCallback: _propTypes2.default.func,
	passwordPageContinueButtonLabel: _propTypes2.default.string,
	globalAlertsDecoratorClass: _propTypes2.default.string,
	password: _propTypes2.default.string,
	emailAddress: _propTypes2.default.string,
	firstName: _propTypes2.default.string,
	mainClassName: _propTypes2.default.string,
	iamLoginRequestInFlight: _propTypes2.default.bool.isRequired,
	iamRequestError: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	userActions: _propTypes2.default.object.isRequired,
	iamThunk: _propTypes2.default.object.isRequired,
	// HOCs
	intl: _propTypes2.default.object.isRequired,
	router: _propTypes2.default.object,
	// Decorators
	errors: _propTypes2.default.object,
	propsFromHost: _propTypes2.default.object
}, _class2.defaultProps = {
	propsFromHost: {}
}, _temp)) || _class;

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
	var iamLoginRequestInFlight = state.HTTP_request.iam_jg_login && state.HTTP_request.iam_jg_login.isInflight ? true : false;
	return {
		iamLoginRequestInFlight: iamLoginRequestInFlight,
		firstName: state.firstName || '',
		emailAddress: state.emailAddress || '',
		password: state.password || '',
		errors: state.VALIDATION_errors || {},
		iamRequestError: (0, _reducers.getRecoverableErrorType)(state, 'iam_jg_login', state.APP_network),
		propsFromHost: state.propsFromHost
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return {
		userActions: (0, _redux.bindActionCreators)(_actions.userActions, dispatch),
		appActions: (0, _redux.bindActionCreators)(_actions.appActions, dispatch),
		validationActions: (0, _redux.bindActionCreators)(_actions.validationActions, dispatch),
		iamThunk: (0, _redux.bindActionCreators)(_actions.iamThunk, dispatch)
	};
};

var PasswordPageComposed = (0, _mixins.Intl)(PasswordPage);
var PasswordPageWithRouter = exports.PasswordPageWithRouter = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactRouter.withRouter)(PasswordPageComposed));
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PasswordPageComposed);

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.RegisterPageWithRouter = exports.mapStateToProps = exports.RegisterPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(20);

var _reactRouter = __webpack_require__(18);

var _redux = __webpack_require__(21);

var _config = __webpack_require__(46);

var _actions = __webpack_require__(63);

var _PageBoilerplateDefault = __webpack_require__(112);

var _PageBoilerplateDefault2 = _interopRequireDefault(_PageBoilerplateDefault);

var _mixins = __webpack_require__(139);

var _reducers = __webpack_require__(113);

var _router = __webpack_require__(114);

var _components = __webpack_require__(111);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RegisterPage = exports.RegisterPage = (0, _mixins.Validation)(_class = (_temp = _class2 = function (_Component) {
	_inherits(RegisterPage, _Component);

	function RegisterPage(props) {
		_classCallCheck(this, RegisterPage);

		// Clear existing alerts
		var _this = _possibleConstructorReturn(this, (RegisterPage.__proto__ || Object.getPrototypeOf(RegisterPage)).call(this, props));

		_this.state = {
			alertRegisterError: false
		};

		// Register which fields on the page expected validation
		_this.validatedFields = ['emailAddress', 'firstName', 'lastName', 'password'];
		return _this;
	}

	_createClass(RegisterPage, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			var _this2 = this;

			var userActions = this.props.userActions;
			// Clear password field

			userActions.updatePassword('');

			this.validatedFields.forEach(function (field) {
				_this2.hasErrors(field) && _this2.clearValidation(field);
			});
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			var propsFromHost = this.props.propsFromHost;


			if (propsFromHost.onRegisterPageMount) {
				propsFromHost.onRegisterPageMount();
			}
		}
	}, {
		key: 'handleFieldChange',
		value: function handleFieldChange(action, e) {
			var userActions = this.props.userActions;

			userActions[action] && userActions[action](e.target.value);
		}
	}, {
		key: 'handleFieldBlur',
		value: function handleFieldBlur(e) {
			this.validate(e.target.id, e.target.value);
		}
	}, {
		key: 'handleSubmit',
		value: function handleSubmit(e) {
			var _props = this.props,
			    emailAddress = _props.emailAddress,
			    firstName = _props.firstName,
			    lastName = _props.lastName,
			    password = _props.password,
			    propsFromHost = _props.propsFromHost;


			if (propsFromHost.onRegisterPageSubmitClicked) {
				propsFromHost.onRegisterPageSubmitClicked();
			}

			e && e.preventDefault();
			[this.isValid('emailAddress', emailAddress), this.isValid('firstName', firstName), this.isValid('lastName', lastName), this.isValid('password', password)].every(function (isValid) {
				return isValid;
			}) && this.proceed();
		}
	}, {
		key: 'registerAndLoginWithIam',
		value: function registerAndLoginWithIam() {
			var _this3 = this;

			var _props2 = this.props,
			    iamThunk = _props2.iamThunk,
			    loginSuccessCallback = _props2.loginSuccessCallback;

			// Clear existing error alerts

			this.setState({
				alertRegisterError: false
			});

			iamThunk.iamRegisterAndLogin().then(loginSuccessCallback).catch(function (error) {
				// Show latest register error alerts
				_this3.setState({
					alertRegisterError: true
				});
			});
		}
	}, {
		key: 'proceed',
		value: function proceed() {
			this.registerAndLoginWithIam();
		}
	}, {
		key: 'routeTo',
		value: function routeTo(e, route) {
			e.preventDefault();
			var _props3 = this.props,
			    updateRoute = _props3.updateRoute,
			    router = _props3.router,
			    publicPath = _props3.publicPath;

			(0, _router.setRoute)(updateRoute, router)(_router.path.join(publicPath, route));
		}
	}, {
		key: 'getRecoverableError',
		value: function getRecoverableError() {
			var _this4 = this;

			var _props4 = this.props,
			    iamRequestError = _props4.iamRequestError,
			    intl = _props4.intl;
			var alertRegisterError = this.state.alertRegisterError;


			if (iamRequestError === _config.iamMessages.EMAIL_ADDRESS_IN_USE.error) {
				iamRequestError = {
					intlKey: _config.iamMessages.EMAIL_ADDRESS_IN_USE.error,
					link: function link() {
						return _react2.default.createElement(
							'a',
							{
								href: '#',
								'data-qa': 'linkToPasswordPage',
								className: 'dna-text-link',
								onClick: function onClick(e) {
									return _this4.routeTo.call(_this4, e, 'password');
								} },
							intl.formatMessage('content|login:register|loginAlertLinkText')
						);
					}
				};
			}

			return alertRegisterError && iamRequestError;
		}
	}, {
		key: 'render',
		value: function render() {
			var _this5 = this;

			var _props5 = this.props,
			    intl = _props5.intl,
			    errors = _props5.errors,
			    mainClassName = _props5.mainClassName,
			    emailAddress = _props5.emailAddress,
			    password = _props5.password,
			    firstName = _props5.firstName,
			    lastName = _props5.lastName,
			    registerPageHeading1 = _props5.registerPageHeading1,
			    registerPageContinueButtonLabel = _props5.registerPageContinueButtonLabel,
			    iamRequestInFlight = _props5.iamRequestInFlight,
			    globalAlertsDecoratorClass = _props5.globalAlertsDecoratorClass,
			    isAppDisabled = _props5.isAppDisabled;


			var isFormButtonDisabled = !this.isEveryValid.call(this) || isAppDisabled || iamRequestInFlight;

			return _react2.default.createElement(
				_PageBoilerplateDefault2.default,
				{
					intl: intl,
					globalAlertsDecoratorClass: globalAlertsDecoratorClass,
					isRecoverableError: this.getRecoverableError.call(this),
					HeadingH1Content: registerPageHeading1,
					mainClassName: mainClassName,
					handleSubmit: this.handleSubmit.bind(this) },
				_react2.default.createElement(_components.Avatar, { decoratorClass: 'dna-space-mtm' }),
				_react2.default.createElement(_components.DNAInputWithLabel, {
					intl: intl,
					parent: this,
					type: 'email',
					value: emailAddress,
					handleBlur: this.handleFieldBlur.bind(this),
					handleChangeProp: function handleChangeProp(e) {
						_this5.handleFieldChange.call(_this5, 'updateEmailAddress', e);
						_this5.handleFieldBlur.call(_this5, e);
					},
					id: 'emailAddress',
					label: intl.formatMessage('content|login:email|emailFieldLabel'),
					sizeVariant: 'medium',
					errors: errors.emailAddress }),
				_react2.default.createElement(_components.DNAValidationMessage, {
					intl: intl,
					wrapperClass: 'login-validation-message',
					fieldName: 'emailAddress',
					errors: [].concat(_toConsumableArray(errors.emailAddress || [])) }),
				_react2.default.createElement(
					'div',
					{ className: 'dna-form-field-distribute' },
					_react2.default.createElement(_components.DNAInputWithLabel, {
						intl: intl,
						parent: this,
						errorKey: 'firstName',
						value: firstName,
						handleBlur: this.handleFieldBlur.bind(this),
						handleChangeProp: function handleChangeProp(e) {
							_this5.handleFieldChange.call(_this5, 'updateFirstName', e);
							_this5.handleFieldBlur.call(_this5, e);
						},
						id: 'firstName',
						label: intl.formatMessage('content|login:register|firstNameFieldLabel'),
						sizeVariant: 'medium',
						errors: errors.firstName }),
					_react2.default.createElement(_components.DNAInputWithLabel, {
						intl: intl,
						parent: this,
						errorKey: 'lastName',
						value: lastName,
						handleBlur: this.handleFieldBlur.bind(this),
						handleChangeProp: function handleChangeProp(e) {
							_this5.handleFieldChange.call(_this5, 'updateLastName', e);
							_this5.handleFieldBlur.call(_this5, e);
						},
						id: 'lastName',
						label: intl.formatMessage('content|login:register|lastNameFieldLabel'),
						sizeVariant: 'medium',
						errors: errors.lastName })
				),
				_react2.default.createElement(_components.DNAValidationMessage, {
					intl: intl,
					wrapperClass: 'login-validation-message',
					fieldName: 'firstName_lastName',
					errors: [].concat(_toConsumableArray(errors.firstName || []), _toConsumableArray(errors.lastName || [])) }),
				_react2.default.createElement(_components.DNAInputWithLabel, {
					parent: this,
					errorKey: 'password',
					isPasswordField: true,
					type: 'password',
					value: password,
					toggleButtonTextHide: intl.formatMessage('content|login:password|passwordFieldHintLabelHide'),
					toggleButtonTextShow: intl.formatMessage('content|login:password|passwordFieldHintLabelShow'),
					id: 'password',
					handleBlur: this.handleFieldBlur.bind(this),
					label: intl.formatMessage('content|login:register|passwordFieldLabel'),
					handleChangeProp: function handleChangeProp(e) {
						return _this5.handleFieldChange.call(_this5, 'updatePassword', e);
					},
					sizeVariant: 'medium',
					errors: errors.password }),
				_react2.default.createElement(_components.DNAValidationMessage, {
					intl: intl,
					wrapperClass: 'login-validation-message',
					fieldName: 'password',
					errors: [].concat(_toConsumableArray(errors.password || [])) }),
				_react2.default.createElement(_components.DNAButtonContinue, {
					type: 'submit',
					intl: intl,
					wrapperDecoratorClass: 'dna-space-mtxl',
					handleContinueProp: function handleContinueProp(e) {
						return _this5.handleSubmit.call(_this5, e);
					},
					buttonText: registerPageContinueButtonLabel ? registerPageContinueButtonLabel : intl.formatMessage('content|login:register|defaultContinueButtonLabel'),
					buttonState: iamRequestInFlight ? 'loading' : '',
					showDisabled: isFormButtonDisabled,
					isDisabled: isFormButtonDisabled,
					qaSelector: 'registerContinueButton' }),
				_react2.default.createElement(_components.FootnoteTsAndCs, {
					intl: intl })
			);
		}
	}]);

	return RegisterPage;
}(_react.Component), _class2.propTypes = {
	updateRoute: _propTypes2.default.func,
	requestSettings: _propTypes2.default.object.isRequired,
	registerPageHeading1: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
	isAppDisabled: _propTypes2.default.bool,
	iamRequestInFlight: _propTypes2.default.bool,
	loginSuccessCallback: _propTypes2.default.func,
	registerPageContinueButtonLabel: _propTypes2.default.string,
	globalAlertsDecoratorClass: _propTypes2.default.string,
	mainClassName: _propTypes2.default.string,
	emailAddress: _propTypes2.default.string,
	password: _propTypes2.default.string,
	firstName: _propTypes2.default.string,
	lastName: _propTypes2.default.string,
	appActions: _propTypes2.default.object,
	userActions: _propTypes2.default.object.isRequired,
	iamThunk: _propTypes2.default.object.isRequired,
	iamRequestError: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	// HOCs
	intl: _propTypes2.default.object.isRequired,
	router: _propTypes2.default.object,
	// Decorators
	errors: _react2.default.PropTypes.object,
	propsFromHost: _react2.default.PropTypes.object
}, _class2.defaultProps = {
	errors: {},
	propsFromHost: {}
}, _temp)) || _class;

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
	var iamRequestInFlight = state.HTTP_request.iam_register && state.HTTP_request.iam_register.isInflight ? true : false;

	return {
		emailAddress: state.emailAddress || '',
		firstName: state.firstName || '',
		lastName: state.lastName || '',
		password: state.password || '',
		errors: state.VALIDATION_errors,
		iamRequestInFlight: iamRequestInFlight,
		iamRequestError: (0, _reducers.getRecoverableErrorType)(state, 'iam_register', state.APP_network),
		propsFromHost: state.propsFromHost
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return {
		appActions: (0, _redux.bindActionCreators)(_actions.appActions, dispatch),
		userActions: (0, _redux.bindActionCreators)(_actions.userActions, dispatch),
		validationActions: (0, _redux.bindActionCreators)(_actions.validationActions, dispatch),
		iamThunk: (0, _redux.bindActionCreators)(_actions.iamThunk, dispatch)
	};
};

var RegisterPageComposed = (0, _mixins.Intl)(RegisterPage);
var RegisterPageWithRouter = exports.RegisterPageWithRouter = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactRouter.withRouter)(RegisterPageComposed));
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(RegisterPageComposed);

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.setIdentity = exports.trackPageView = undefined;

var _config = __webpack_require__(46);

var _utils = __webpack_require__(22);

if (!window.atob) {
	var Base64 = __webpack_require__(405);
	window.atob = Base64.atob;
}

var analyticsCookieName = 'TODO';

/* global _kmq b:true */

var cookies = new _utils.Cookies(analyticsCookieName);

/**
 * pushes a 'page view' to kissmetrics
 * @description by convention, all 'jg analytics' providers
 * (that is, all analytics*.js files in this dir) should share
 * the same interface.
 * @param {string} pageName
 * @param {object} data - pertinent tracking data
 */
var trackPageView = exports.trackPageView = function trackPageView(pageName, data) {
	if (window._kmq) {
		_kmq.push(['record', 'page view', {
			'page_type': '',
			'event': 'page view',
			'subtype': pageName,
			'page_section': '',
			'actor_id': '',
			'actor_sources': '',
			'content_id': '',
			'content_type': '',
			'logged_in_guid': cookies.analyticsCookie.logged_in_guid || '',
			'logged_out_guid': cookies.analyticsCookie.logged_out_guid || '',
			'ab_logged_in_guid': cookies.JgAbLoggedInCookie.value || '',
			// TODO: 'session_id': cookie['ASP.NET_SessionId']
			//       The analytics guys want this, but as it's not readily
			//       available, we won't be pushing it for now.
			'url': window.location.href || '',
			'referrer': document.referrer || 'direct',
			'user_agent': window.navigator.userAgent || ''
		}]);
	}
};

/**
 * setIdentity
 * @desc decodes jwt and extracts the users email address.
 * sends email to kissmetrics to identify the logged in session
 * uses Base64 as a polyfill for atob
 * @param {string} JWT
 * */
var setIdentity = exports.setIdentity = function setIdentity(JWT) {
	if (!JWT) {
		return;
	}
	var jwtChunks = JWT.split('.');
	var jwtChunk = jwtChunks && jwtChunks[1];
	var email = jwtChunk && JSON.parse(window.atob(jwtChunk)).unique_name;

	window._kmq && email && window._kmq.push(['identify', email]);
};

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var cof = __webpack_require__(37);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)


var toObject = __webpack_require__(17),
    toIndex = __webpack_require__(71),
    toLength = __webpack_require__(16);

module.exports = [].copyWithin || function copyWithin(target /*= 0*/, start /*= 0, end = @length*/) {
  var O = toObject(this),
      len = toLength(O.length),
      to = toIndex(target, len),
      from = toIndex(start, len),
      end = arguments.length > 2 ? arguments[2] : undefined,
      count = Math.min((end === undefined ? len : toIndex(end, len)) - from, len - to),
      inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];else delete O[to];
    to += inc;
    from += inc;
  }return O;
};

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var forOf = __webpack_require__(77);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var aFunction = __webpack_require__(25),
    toObject = __webpack_require__(17),
    IObject = __webpack_require__(97),
    toLength = __webpack_require__(16);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that),
      self = IObject(O),
      length = toLength(O.length),
      index = isRight ? length - 1 : 0,
      i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (; isRight ? index >= 0 : length > index; index += i) {
    if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
  }return memo;
};

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var aFunction = __webpack_require__(25),
    isObject = __webpack_require__(9),
    invoke = __webpack_require__(119),
    arraySlice = [].slice,
    factories = {};

var construct = function construct(F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) {
      n[i] = 'a[' + i + ']';
    }factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  }return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /*, args... */) {
  var fn = aFunction(this),
      partArgs = arraySlice.call(arguments, 1);
  var bound = function bound() /* args... */{
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var dP = __webpack_require__(13).f,
    create = __webpack_require__(66),
    redefineAll = __webpack_require__(69),
    ctx = __webpack_require__(48),
    anInstance = __webpack_require__(64),
    defined = __webpack_require__(38),
    forOf = __webpack_require__(77),
    $iterDefine = __webpack_require__(153),
    step = __webpack_require__(228),
    setSpecies = __webpack_require__(70),
    DESCRIPTORS = __webpack_require__(12),
    fastKey = __webpack_require__(55).fastKey,
    SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function getEntry(that, key) {
  // fast case
  var index = fastKey(key),
      entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function getConstructor(wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._i = create(null); // index
      that._f = undefined; // first entry
      that._l = undefined; // last entry
      that[SIZE] = 0; // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = this, data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function _delete(key) {
        var that = this,
            entry = getEntry(that, key);
        if (entry) {
          var next = entry.n,
              prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        }return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /*, that = undefined */) {
        anInstance(this, C, 'forEach');
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3),
            entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) {
            entry = entry.p;
          }
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(this, key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function get() {
        return defined(this[SIZE]);
      }
    });
    return C;
  },
  def: function def(that, key, value) {
    var entry = getEntry(that, key),
        prev,
        index;
    // change existing entry
    if (entry) {
      entry.v = value;
      // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key, // <- key
        v: value, // <- value
        p: prev = that._l, // <- previous entry
        n: undefined, // <- next entry
        r: false // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    }return that;
  },
  getEntry: getEntry,
  setStrong: function setStrong(C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = iterated; // target
      this._k = kind; // kind
      this._l = undefined; // previous
    }, function () {
      var that = this,
          kind = that._k,
          entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) {
        entry = entry.p;
      } // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(96),
    from = __webpack_require__(219);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var redefineAll = __webpack_require__(69),
    getWeak = __webpack_require__(55).getWeak,
    anObject = __webpack_require__(4),
    isObject = __webpack_require__(9),
    anInstance = __webpack_require__(64),
    forOf = __webpack_require__(77),
    createArrayMethod = __webpack_require__(41),
    $has = __webpack_require__(23),
    arrayFind = createArrayMethod(5),
    arrayFindIndex = createArrayMethod(6),
    id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function uncaughtFrozenStore(that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function UncaughtFrozenStore() {
  this.a = [];
};
var findUncaughtFrozen = function findUncaughtFrozen(store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function get(key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function has(key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function set(key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;else this.a.push([key, value]);
  },
  'delete': function _delete(key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function getConstructor(wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._i = id++; // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function _delete(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(this)['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(this).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function def(that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = !__webpack_require__(12) && !__webpack_require__(7)(function () {
  return Object.defineProperty(__webpack_require__(145)('div'), 'a', { get: function get() {
      return 7;
    } }).a != 7;
});

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(9),
    floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// call something on iterator step with safe closing on error
var anObject = __webpack_require__(4);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
    // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (done, value) {
  return { value: value, done: !!done };
};

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)

var getKeys = __webpack_require__(68),
    gOPS = __webpack_require__(123),
    pIE = __webpack_require__(98),
    toObject = __webpack_require__(17),
    IObject = __webpack_require__(97),
    $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(7)(function () {
  var A = {},
      B = {},
      S = Symbol(),
      K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) {
    B[k] = k;
  });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) {
  // eslint-disable-line no-unused-vars
  var T = toObject(target),
      aLen = arguments.length,
      index = 1,
      getSymbols = gOPS.f,
      isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]),
        keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S),
        length = keys.length,
        j = 0,
        key;
    while (length > j) {
      if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
    }
  }return T;
} : $assign;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var dP = __webpack_require__(13),
    anObject = __webpack_require__(4),
    getKeys = __webpack_require__(68);

module.exports = __webpack_require__(12) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties),
      length = keys.length,
      i = 0,
      P;
  while (length > i) {
    dP.f(O, P = keys[i++], Properties[P]);
  }return O;
};

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(29),
    gOPN = __webpack_require__(67).f,
    toString = {}.toString;

var windowNames = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function getWindowNames(it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = __webpack_require__(23),
    toIObject = __webpack_require__(29),
    arrayIndexOf = __webpack_require__(115)(false),
    IE_PROTO = __webpack_require__(158)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object),
      i = 0,
      result = [],
      key;
  for (key in O) {
    if (key != IE_PROTO) has(O, key) && result.push(key);
  } // Don't enum bug & hidden keys
  while (names.length > i) {
    if (has(O, key = names[i++])) {
      ~arrayIndexOf(result, key) || result.push(key);
    }
  }return result;
};

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getKeys = __webpack_require__(68),
    toIObject = __webpack_require__(29),
    isEnum = __webpack_require__(98).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it),
        keys = getKeys(O),
        length = keys.length,
        i = 0,
        result = [],
        key;
    while (length > i) {
      if (isEnum.call(O, key = keys[i++])) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }return result;
  };
};

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(67),
    gOPS = __webpack_require__(123),
    anObject = __webpack_require__(4),
    Reflect = __webpack_require__(6).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it)),
      getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $parseFloat = __webpack_require__(6).parseFloat,
    $trim = __webpack_require__(80).trim;

module.exports = 1 / $parseFloat(__webpack_require__(163) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3),
      result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $parseInt = __webpack_require__(6).parseInt,
    $trim = __webpack_require__(80).trim,
    ws = __webpack_require__(163),
    hex = /^[\-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, radix >>> 0 || (hex.test(string) ? 16 : 10));
} : $parseInt;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(16),
    repeat = __webpack_require__(162),
    defined = __webpack_require__(38);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that)),
      stringLength = S.length,
      fillStr = fillString === undefined ? ' ' : String(fillString),
      intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength,
      stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.f = __webpack_require__(11);

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var strong = __webpack_require__(222);

// 23.1 Map Objects
module.exports = __webpack_require__(116)('Map', function (get) {
  return function Map() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(this, key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(this, key === 0 ? 0 : key, value);
  }
}, strong, true);

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(12) && /./g.flags != 'g') __webpack_require__(13).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(118)
});

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var strong = __webpack_require__(222);

// 23.2 Set Objects
module.exports = __webpack_require__(116)('Set', function (get) {
  return function Set() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(this, value = value === 0 ? 0 : value, value);
  }
}, strong);

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var each = __webpack_require__(41)(0),
    redefine = __webpack_require__(27),
    meta = __webpack_require__(55),
    assign = __webpack_require__(230),
    weak = __webpack_require__(224),
    isObject = __webpack_require__(9),
    getWeak = meta.getWeak,
    isExtensible = Object.isExtensible,
    uncaughtFrozenStore = weak.ufstore,
    tmp = {},
    InternalMap;

var wrapper = function wrapper(get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(this).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(this, key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(116)('WeakMap', wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7) {
  InternalMap = weak.getConstructor(wrapper);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype,
        method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
        // store all the rest on native weakmap
      }return method.call(this, a, b);
    });
  });
}

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Alert = function (_Component) {
	_inherits(Alert, _Component);

	function Alert() {
		_classCallCheck(this, Alert);

		return _possibleConstructorReturn(this, (Alert.__proto__ || Object.getPrototypeOf(Alert)).apply(this, arguments));
	}

	_createClass(Alert, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    id = _props.id,
			    alertMessage = _props.alertMessage,
			    alertType = _props.alertType,
			    decoratorClass = _props.decoratorClass,
			    qaSelector = _props.qaSelector;


			return _react2.default.createElement(
				'div',
				{ className: 'dna-alert dna-alert-' + alertType + ' ' + (decoratorClass === undefined ? '' : decoratorClass),
					key: id,
					'data-qa': qaSelector },
				_react2.default.createElement(
					'div',
					{ className: 'dna-alert-body' },
					_react2.default.createElement(
						'p',
						null,
						alertMessage
					)
				)
			);
		}
	}]);

	return Alert;
}(_react.Component);

Alert.propTypes = {
	alertMessage: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.object]).isRequired,
	alertType: _react.PropTypes.string.isRequired,
	id: _react.PropTypes.string.isRequired,
	decoratorClass: _react.PropTypes.string,
	qaSelector: _react.PropTypes.string
};
exports.default = Alert;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactAddonsCssTransitionGroup = __webpack_require__(686);

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _Alert = __webpack_require__(245);

var _Alert2 = _interopRequireDefault(_Alert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AlertSlideDown = function (_Component) {
	_inherits(AlertSlideDown, _Component);

	function AlertSlideDown() {
		_classCallCheck(this, AlertSlideDown);

		return _possibleConstructorReturn(this, (AlertSlideDown.__proto__ || Object.getPrototypeOf(AlertSlideDown)).apply(this, arguments));
	}

	_createClass(AlertSlideDown, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    id = _props.id,
			    alertType = _props.alertType,
			    alertMessage = _props.alertMessage,
			    qaSelector = _props.qaSelector,
			    decoratorClass = _props.decoratorClass,
			    renderAlert = _props.renderAlert,
			    transitionName = _props.transitionName,
			    transitionDuration = _props.transitionDuration,
			    transitionLeave = _props.transitionLeave;


			return _react2.default.createElement(
				_reactAddonsCssTransitionGroup2.default,
				{
					transitionName: transitionName,
					transitionEnterTimeout: transitionDuration,
					transitionLeave: transitionLeave },
				renderAlert && _react2.default.createElement(_Alert2.default, {
					id: id,
					decoratorClass: decoratorClass,
					alertType: alertType,
					alertMessage: alertMessage,
					qaSelector: qaSelector })
			);
		}
	}]);

	return AlertSlideDown;
}(_react.Component);

AlertSlideDown.propTypes = {
	renderAlert: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.bool]),
	alertMessage: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.object]).isRequired,
	qaSelector: _react.PropTypes.string,
	decoratorClass: _react.PropTypes.string,
	id: _react.PropTypes.string,
	transitionName: _react.PropTypes.string,
	transitionDuration: _react.PropTypes.number,
	transitionLeave: _react.PropTypes.bool,
	alertType: _react.PropTypes.string.isRequired
};
AlertSlideDown.defaultProps = {
	id: 'dnaAlertError',
	qaSelector: 'dnaAlertError',
	transitionDuration: 1200,
	transitionLeave: false,
	transitionName: 'alert-slide-down'
};
exports.default = AlertSlideDown;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.logError = exports.initErrorLogger = undefined;

var _raygun = __webpack_require__(600);

var raygun = _interopRequireWildcard(_raygun);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Initialise JustGiving error logger
 */
var initErrorLogger = exports.initErrorLogger = function initErrorLogger(APP_VERSION, APP_NAME) {
	var hasInit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

	raygun.init(APP_VERSION, APP_NAME, hasInit);
};

/**
 * Use this method to log handled exceptions in the app.
 * @param {error} error - an instance of the Error class
 * @param {object} vendorLogger - allows unit tests to mock
 */
var logError = exports.logError = function logError(error) {
	var vendorLogger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : raygun;

	if (error.response) {
		var customData = {};
		customData.httpStatus = error.response.status || '';
		customData.url = error.response.url || '';
		// you can only read the response json once, so we need
		// to check 'response.bodyUsed' to avoid an exception...
		if (!error.response.bodyUsed) {
			error.response.json().then(function (data) {
				customData.json = data || '';
				vendorLogger.logError(error, customData);
			});
		} else {
			vendorLogger.logError(error, customData);
		}
	} else {
		vendorLogger.logError(error);
	}
};

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * range
 * Returns an array filled with numbers between two values
 * @param {number} begin - start value
 * @param {number} end - end value
 * @returns {array} the resulting array
 */
var range = exports.range = function range(begin, end) {
  var result = [];
  for (var i = begin; i <= end; ++i) {
    result.push(i);
  }
  return result;
};

/**
 * @name deduplicateByKey
 * @description Deduplicates objects in an array according to their key
 * @param {Array} items - The original error collection to be deduped
 * @param {string} keyPropertyName - The name of the property by which objects should be compared
 * @returns {Array} A shallow copy of the errors array, sans duplicates
 */
var deduplicateByKey = exports.deduplicateByKey = function deduplicateByKey(items, keyPropertyName) {
  // Can't use a set here because we are using objects
  var uniqueKeys = {};
  items.forEach(function (x) {
    return uniqueKeys[x[keyPropertyName]] = x;
  });
  return Object.keys(uniqueKeys).map(function (key) {
    return uniqueKeys[key];
  }); // babel does not support Object.values yet...
};

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Label = function (_Component) {
	_inherits(Label, _Component);

	function Label() {
		_classCallCheck(this, Label);

		return _possibleConstructorReturn(this, (Label.__proto__ || Object.getPrototypeOf(Label)).apply(this, arguments));
	}

	_createClass(Label, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    forAttr = _props.forAttr,
			    labelClass = _props.labelClass,
			    labelDecoratorClass = _props.labelDecoratorClass,
			    labelIsInvisible = _props.labelIsInvisible,
			    label = _props.label,
			    qaSelector = _props.qaSelector,
			    children = _props.children;


			return _react2.default.createElement(
				'label',
				{
					'data-qa': qaSelector + '-label',
					className: '' + labelClass + (labelIsInvisible ? ' dna-invisible' : '') + (labelDecoratorClass ? ' ' + labelDecoratorClass : ''),
					htmlFor: forAttr },
				label,
				children && children
			);
		}
	}]);

	return Label;
}(_react.Component);

Label.propTypes = {
	forAttr: _react.PropTypes.string.isRequired,
	labelClass: _react.PropTypes.string.isRequired,
	label: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.object]).isRequired,
	labelIsInvisible: _react.PropTypes.bool,
	labelDecoratorClass: _react.PropTypes.string,
	qaSelector: _react.PropTypes.string,
	children: _react.PropTypes.object
};
Label.defaultProps = {
	labelClass: 'dna-label',
	labelIsInvisible: false,
	labelDecoratorClass: ''
};
exports.default = Label;

/***/ }),
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isPrototype = __webpack_require__(258),
    nativeKeys = __webpack_require__(662);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(75)))

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;

  return value === proto;
}

module.exports = isPrototype;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseIsArguments = __webpack_require__(647),
    isObjectLike = __webpack_require__(83);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function () {
    return arguments;
}()) ? baseIsArguments : function (value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var root = __webpack_require__(58),
    stubFalse = __webpack_require__(671);

/** Detect free variable `exports`. */
var freeExports = ( false ? 'undefined' : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && ( false ? 'undefined' : _typeof(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(108)(module)))

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseGetTag = __webpack_require__(73),
    getPrototype = __webpack_require__(656),
    isObjectLike = __webpack_require__(83);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseIsTypedArray = __webpack_require__(650),
    baseUnary = __webpack_require__(653),
    nodeUtil = __webpack_require__(663);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

module.exports = isUndefined;

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.denormalize = exports.normalize = exports.schema = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _Entity = __webpack_require__(679);

var _Entity2 = _interopRequireDefault(_Entity);

var _Union = __webpack_require__(681);

var _Union2 = _interopRequireDefault(_Union);

var _Values = __webpack_require__(682);

var _Values2 = _interopRequireDefault(_Values);

var _Array = __webpack_require__(678);

var ArrayUtils = _interopRequireWildcard(_Array);

var _Object = __webpack_require__(680);

var ObjectUtils = _interopRequireWildcard(_Object);

var _ImmutableUtils = __webpack_require__(126);

var ImmutableUtils = _interopRequireWildcard(_ImmutableUtils);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var visit = function visit(value, parent, key, schema, addEntity) {
  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object' || !value) {
    return value;
  }

  if ((typeof schema === 'undefined' ? 'undefined' : _typeof(schema)) === 'object' && (!schema.normalize || typeof schema.normalize !== 'function')) {
    var method = Array.isArray(schema) ? ArrayUtils.normalize : ObjectUtils.normalize;
    return method(schema, value, parent, key, visit, addEntity);
  }

  return schema.normalize(value, parent, key, visit, addEntity);
};

var addEntities = function addEntities(entities) {
  return function (schema, processedEntity, value, parent, key) {
    var schemaKey = schema.key;
    var id = schema.getId(value, parent, key);
    if (!(schemaKey in entities)) {
      entities[schemaKey] = {};
    }

    var existingEntity = entities[schemaKey][id];
    if (existingEntity) {
      entities[schemaKey][id] = schema.merge(existingEntity, processedEntity);
    } else {
      entities[schemaKey][id] = processedEntity;
    }
  };
};

var schema = exports.schema = {
  Array: ArrayUtils.default,
  Entity: _Entity2.default,
  Object: ObjectUtils.default,
  Union: _Union2.default,
  Values: _Values2.default
};

var normalize = exports.normalize = function normalize(input, schema) {
  if (!input || (typeof input === 'undefined' ? 'undefined' : _typeof(input)) !== 'object') {
    throw new Error('Unexpected input given to normalize. Expected type to be "object", found "' + (typeof input === 'undefined' ? 'undefined' : _typeof(input)) + '".');
  }

  var entities = {};
  var addEntity = addEntities(entities);

  var result = visit(input, input, null, schema, addEntity);
  return { entities: entities, result: result };
};

var unvisitEntity = function unvisitEntity(input, schema, unvisit, getEntity, cache) {
  var entity = getEntity(input, schema);
  if ((typeof entity === 'undefined' ? 'undefined' : _typeof(entity)) !== 'object' || entity === null) {
    return entity;
  }

  var id = schema.getId(entity);

  if (!cache[schema.key]) {
    cache[schema.key] = {};
  }

  if (!cache[schema.key][id]) {
    // Ensure we don't mutate it non-immutable objects
    var entityCopy = ImmutableUtils.isImmutable(entity) ? entity : _extends({}, entity);

    // Need to set this first so that if it is referenced further within the
    // denormalization the reference will already exist.
    cache[schema.key][id] = entityCopy;
    cache[schema.key][id] = schema.denormalize(entityCopy, unvisit);
  }

  return cache[schema.key][id];
};

var getUnvisit = function getUnvisit(entities) {
  var cache = {};
  var getEntity = getEntities(entities);

  return function unvisit(input, schema) {
    if ((typeof schema === 'undefined' ? 'undefined' : _typeof(schema)) === 'object' && (!schema.denormalize || typeof schema.denormalize !== 'function')) {
      var method = Array.isArray(schema) ? ArrayUtils.denormalize : ObjectUtils.denormalize;
      return method(schema, input, unvisit);
    }

    if (input === undefined || input === null) {
      return input;
    }

    if (schema instanceof _Entity2.default) {
      return unvisitEntity(input, schema, unvisit, getEntity, cache);
    }

    return schema.denormalize(input, unvisit);
  };
};

var getEntities = function getEntities(entities) {
  var isImmutable = ImmutableUtils.isImmutable(entities);

  return function (entityOrId, schema) {
    var schemaKey = schema.key;

    if ((typeof entityOrId === 'undefined' ? 'undefined' : _typeof(entityOrId)) === 'object') {
      return entityOrId;
    }

    return isImmutable ? entities.getIn([schemaKey, entityOrId.toString()]) : entities[schemaKey][entityOrId];
  };
};

var denormalize = exports.denormalize = function denormalize(input, schema, entities) {
  if (!input) {
    return input;
  }

  return getUnvisit(entities)(input, schema);
};

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var errcode = __webpack_require__(612);
var retry = __webpack_require__(810);

var hasOwn = Object.prototype.hasOwnProperty;

function isRetryError(err) {
    return err && err.code === 'EPROMISERETRY' && hasOwn.call(err, 'retried');
}

function promiseRetry(fn, options) {
    var temp;
    var operation;

    if ((typeof fn === 'undefined' ? 'undefined' : _typeof(fn)) === 'object' && typeof options === 'function') {
        // Swap options and fn when using alternate signature (options, fn)
        temp = options;
        options = fn;
        fn = temp;
    }

    operation = retry.operation(options);

    return new Promise(function (resolve, reject) {
        operation.attempt(function (number) {
            Promise.resolve().then(function () {
                return fn(function (err) {
                    if (isRetryError(err)) {
                        err = err.retried;
                    }

                    throw errcode('Retrying', 'EPROMISERETRY', { retried: err });
                }, number);
            }).then(resolve, function (err) {
                if (isRetryError(err)) {
                    err = err.retried;

                    if (operation.retry(err || new Error())) {
                        return;
                    }
                }

                reject(err);
            });
        });
    });
}

module.exports = promiseRetry;

/***/ }),
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ACTION_TYPE_DELIMITER = undefined;
exports.default = combineActions;

var _isString = __webpack_require__(178);

var _isString2 = _interopRequireDefault(_isString);

var _isFunction = __webpack_require__(82);

var _isFunction2 = _interopRequireDefault(_isFunction);

var _isEmpty = __webpack_require__(667);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _toString = __webpack_require__(675);

var _toString2 = _interopRequireDefault(_toString);

var _isSymbol = __webpack_require__(179);

var _isSymbol2 = _interopRequireDefault(_isSymbol);

var _invariant = __webpack_require__(15);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ACTION_TYPE_DELIMITER = exports.ACTION_TYPE_DELIMITER = '||';

function isValidActionType(actionType) {
  return (0, _isString2.default)(actionType) || (0, _isFunction2.default)(actionType) || (0, _isSymbol2.default)(actionType);
}

function isValidActionTypes(actionTypes) {
  if ((0, _isEmpty2.default)(actionTypes)) {
    return false;
  }
  return actionTypes.every(isValidActionType);
}

function combineActions() {
  for (var _len = arguments.length, actionsTypes = Array(_len), _key = 0; _key < _len; _key++) {
    actionsTypes[_key] = arguments[_key];
  }

  (0, _invariant2.default)(isValidActionTypes(actionsTypes), 'Expected action types to be strings, symbols, or action creators');
  var combinedActionType = actionsTypes.map(_toString2.default).join(ACTION_TYPE_DELIMITER);
  return { toString: function toString() {
      return combinedActionType;
    } };
}

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createAction;

var _identity = __webpack_require__(175);

var _identity2 = _interopRequireDefault(_identity);

var _isFunction = __webpack_require__(82);

var _isFunction2 = _interopRequireDefault(_isFunction);

var _isUndefined = __webpack_require__(266);

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _isNull = __webpack_require__(669);

var _isNull2 = _interopRequireDefault(_isNull);

var _invariant = __webpack_require__(15);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createAction(type) {
  var payloadCreator = arguments.length <= 1 || arguments[1] === undefined ? _identity2.default : arguments[1];
  var metaCreator = arguments[2];

  (0, _invariant2.default)((0, _isFunction2.default)(payloadCreator) || (0, _isNull2.default)(payloadCreator), 'Expected payloadCreator to be a function, undefined or null');

  var finalPayloadCreator = (0, _isNull2.default)(payloadCreator) ? _identity2.default : payloadCreator;

  var actionCreator = function actionCreator() {
    var hasError = (arguments.length <= 0 ? undefined : arguments[0]) instanceof Error;

    var action = {
      type: type
    };

    var payload = hasError ? arguments.length <= 0 ? undefined : arguments[0] : finalPayloadCreator.apply(undefined, arguments);
    if (!(0, _isUndefined2.default)(payload)) {
      action.payload = payload;
    }

    if (hasError || payload instanceof Error) {
      // Handle FSA errors where the payload is an Error object. Set error.
      action.error = true;
    }

    if ((0, _isFunction2.default)(metaCreator)) {
      action.meta = metaCreator.apply(undefined, arguments);
    }

    return action;
  };

  actionCreator.toString = function () {
    return type.toString();
  };

  return actionCreator;
}

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = handleAction;

var _isFunction = __webpack_require__(82);

var _isFunction2 = _interopRequireDefault(_isFunction);

var _isPlainObject = __webpack_require__(264);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _identity = __webpack_require__(175);

var _identity2 = _interopRequireDefault(_identity);

var _isNil = __webpack_require__(668);

var _isNil2 = _interopRequireDefault(_isNil);

var _isUndefined = __webpack_require__(266);

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _includes = __webpack_require__(666);

var _includes2 = _interopRequireDefault(_includes);

var _invariant = __webpack_require__(15);

var _invariant2 = _interopRequireDefault(_invariant);

var _combineActions = __webpack_require__(314);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;_e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }return _arr;
  }return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

function handleAction(actionType) {
  var reducer = arguments.length <= 1 || arguments[1] === undefined ? _identity2.default : arguments[1];
  var defaultState = arguments[2];

  var actionTypes = actionType.toString().split(_combineActions.ACTION_TYPE_DELIMITER);
  (0, _invariant2.default)(!(0, _isUndefined2.default)(defaultState), 'defaultState for reducer handling ' + actionTypes.join(', ') + ' should be defined');
  (0, _invariant2.default)((0, _isFunction2.default)(reducer) || (0, _isPlainObject2.default)(reducer), 'Expected reducer to be a function or object with next and throw reducers');

  var _ref = (0, _isFunction2.default)(reducer) ? [reducer, reducer] : [reducer.next, reducer.throw].map(function (aReducer) {
    return (0, _isNil2.default)(aReducer) ? _identity2.default : aReducer;
  });

  var _ref2 = _slicedToArray(_ref, 2);

  var nextReducer = _ref2[0];
  var throwReducer = _ref2[1];

  return function () {
    var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
    var action = arguments[1];
    var type = action.type;

    if (!type || !(0, _includes2.default)(actionTypes, type.toString())) {
      return state;
    }

    return (action.error === true ? throwReducer : nextReducer)(state, action);
  };
}

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;

/***/ }),
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.refreshAccessToken = exports.checkAuth = undefined;

var _mainActions = __webpack_require__(93);

var _mainActions2 = _interopRequireDefault(_mainActions);

var _tools = __webpack_require__(62);

var _config2 = __webpack_require__(31);

var _config3 = _interopRequireDefault(_config2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var checkAuth = exports.checkAuth = function checkAuth() {
  return function (dispatch) {
    var authCookie = (0, _tools.getAuthTokens)();

    dispatch(_mainActions2.default.updateUserIsLoggedIn(Boolean(authCookie)));
    if (authCookie) {
      var accessToken = authCookie.access_token,
          refreshToken = authCookie.refresh_token;

      accessToken && dispatch(_mainActions2.default.updateAuthAccessToken(accessToken));
      refreshToken && dispatch(_mainActions2.default.updateAuthRefreshToken(refreshToken));
    }
  };
};

var refreshAccessToken = exports.refreshAccessToken = function refreshAccessToken() {
  var retryAction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var _fetch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : fetch;

  var _config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _config3.default;

  return function (dispatch, getState) {
    return new Promise(function (resolve, reject) {
      var mainStore = getState().mainStore;
      var isUserLoggedIn = mainStore.get('isUserLoggedIn');
      var refreshToken = mainStore.get('authRefreshToken');
      var iamRefreshUrl = _config.IAM_API.BASE_URL + '/account/refresh-access-token';

      if (!isUserLoggedIn) {
        return reject(new Error('User not logged in'));
      }

      var requestOptions = {
        method: 'POST',
        mode: 'cors',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          RefreshToken: refreshToken,
          GrantType: 'refresh_token',
          ClientId: 'jg.web'
        })
      };

      return _fetch(iamRefreshUrl, requestOptions).then(function (response) {
        return response.json();
      }).then(function (data) {
        var _data$Result = data.Result,
            accessToken = _data$Result.access_token,
            refresh_token = _data$Result.refresh_token;

        dispatch(_mainActions2.default.updateAuthAccessToken(accessToken));
        dispatch(_mainActions2.default.updateAuthRefreshToken(refresh_token));
        if (retryAction) {
          if (retryAction.CALL_API) {
            retryAction.CALL_API.requestOptions.headers.Authorization = 'Bearer ' + accessToken;
          }
          dispatch(retryAction);
        }
        return resolve({
          accessToken: accessToken,
          refresh_token: refresh_token
        });
      }).catch(function (error) {
        reject(new Error(error));
      });
    });
  };
};

exports.default = checkAuth;

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.types = undefined;

var _reduxUtils = __webpack_require__(110);

var types = exports.types = {
  FACEBOOK_INITIALISE: '@@jg/FACEBOOK_INITIALISE',
  UPDATE_FACEBOOK_LOGIN_STATUS: '@@jg/UPDATE_FACEBOOK_LOGIN_STATUS'
};

var actions = {
  addFacebookScript: function addFacebookScript(d, s, id) {
    /* eslint-disable */
    var js,
        fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {
      return;
    }
    js = d.createElement(s);js.id = id;
    js.src = "//connect.facebook.net/en_US/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
    /* eslint-enable */
  },

  setFacebookLoginStatus: (0, _reduxUtils.makeActionCreator)(types.UPDATE_FACEBOOK_LOGIN_STATUS, 'facebookLoginStatus'),

  facebookInitialise: function facebookInitialise(appId) {
    return function (dispatch) {
      window.fbAsyncInit = function () {
        window.FB.init({
          appId: appId,
          cookie: true,
          xfbml: true, // maybe set this to false after dev to see if everything still works
          version: 'v2.8'
        });
        window.FB.AppEvents.logPageView();

        dispatch({
          type: types.FACEBOOK_INITIALISE
        });
        window.FB.getLoginStatus(function (response) {
          return dispatch(actions.setFacebookLoginStatus(response));
        });
      };
      actions.addFacebookScript(document, 'script', 'facebook-jssdk');
    };
  }
};

exports.default = actions;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config = __webpack_require__(31);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  participant: {
    requestName: 'participant',
    url: _config2.default.PARTNERS_API.BASE_URL + '/' + _config2.default.PARTNERS_API.ENDPOINTS.PARTICIPANT
  },
  charitySearch: {
    requestName: 'charitySearch',
    url: _config2.default.PARTNERS_API.BASE_URL + '/' + _config2.default.PARTNERS_API.ENDPOINTS.CHARITY
  },
  fundraisingPage: {
    requestName: 'fundraisingPage'
  },
  donationPage: {
    requestName: 'donationPage'
  }
};

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processApiCall = exports.refreshAccessTokenThenRetryRequest = exports.actionWith = exports.CALL_API = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _normalizr = __webpack_require__(267);

var _httpActions = __webpack_require__(135);

var _httpActions2 = _interopRequireDefault(_httpActions);

var _authActions = __webpack_require__(321);

var _tools = __webpack_require__(62);

var _isomorphicFetch = __webpack_require__(629);

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CALL_API = exports.CALL_API = 'CALL_API';

var actionWith = exports.actionWith = function actionWith(action, data) {
  var newAction = Object.assign({}, action, data);
  delete newAction[CALL_API];
  return newAction;
};

var refreshAccessTokenThenRetryRequest = exports.refreshAccessTokenThenRetryRequest = function refreshAccessTokenThenRetryRequest(_ref) {
  var requestName = _ref.requestName,
      store = _ref.store,
      action = _ref.action,
      next = _ref.next;

  next(_httpActions2.default.requestRetry(requestName));
  var retries = store.getState().http.getIn([requestName, 'retries'], 0);
  if (retries <= 3) {
    next((0, _authActions.refreshAccessToken)(action));
  } else {
    throw new Error(requestName + ': Maximum number of retries exceeded');
  }
};

var processApiCall = exports.processApiCall = function processApiCall(_ref2) {
  var store = _ref2.store,
      action = _ref2.action,
      next = _ref2.next,
      callAPI = _ref2.callAPI;
  var endpoint = callAPI.endpoint,
      requestName = callAPI.requestName,
      schema = callAPI.schema,
      types = callAPI.types,
      requestOptions = callAPI.requestOptions;

  var _types = _slicedToArray(types, 3),
      requestType = _types[0],
      successType = _types[1],
      failureType = _types[2];

  var returnHeaders = callAPI.returnHeaders || [];

  if (typeof endpoint !== 'string') {
    throw new Error('Specify a string endpoint URL.');
  }

  if (!Array.isArray(types) || types.length !== 3) {
    throw new Error('Expected an array of three action types.');
  }

  next({ type: requestType });
  next(_httpActions2.default.requestMade(requestName));

  var reqOptions = Object.assign({ credentials: 'same-origin' }, requestOptions);

  if (reqOptions.method === 'POST' || reqOptions.method === 'PUT') {
    reqOptions.body = JSON.stringify(reqOptions.formData);
    reqOptions.headers = Object.assign({
      Accept: 'application/json, text/javascript, *.*',
      'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
    }, requestOptions.headers);
  }

  return (0, _isomorphicFetch2.default)(endpoint, reqOptions).then(function (response) {
    if (!response.ok) {
      if (response.status === 401) {
        refreshAccessTokenThenRetryRequest({ requestName: requestName, store: store, action: action, next: next });
      }
      return Promise.reject(response.statusText);
    }
    return response;
  }).then(function (response) {
    return response.json().then(function (json) {
      return { json: json, response: response };
    });
  }).then(function (_ref3) {
    var json = _ref3.json,
        response = _ref3.response;
    return {
      json: schema ? Object.assign({}, (0, _normalizr.normalize)(json, schema)) : json,
      headers: response.headers
    };
  }).then(function (response) {
    var headers = {};

    returnHeaders.forEach(function (headerName) {
      headers[headerName] = response.headers.get(headerName);
    });

    var actionObj = {
      response: Object.assign(response.json, { headers: headers }),
      type: successType
    };

    next(actionWith(action, actionObj));
    next(_httpActions2.default.requestSuccess(requestName));
  }).catch(function (error) {
    next(actionWith(action, {
      type: failureType,
      error: error.message || 'no error message returned'
    }));
    next(_httpActions2.default.requestError(requestName));

    (0, _tools.logError)(error, { url: endpoint });

    return Promise.reject(error);
  });
};

exports.default = function (store) {
  return function (next) {
    return function (action) {
      var callAPI = action[CALL_API];

      return typeof callAPI === 'undefined' ? next(action) : processApiCall({ store: store, action: action, next: next, callAPI: callAPI });
    };
  };
};

/***/ }),
/* 325 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"#FFFFFF\" d=\"M14.0512821,22.8205128 L14.0512821,12.7589744 L17.4666667,12.7589744 L18.0205128,8.78974359 L14.1435897,8.78974359 L14.1435897,6.2974359 C14.1435897,5.18974359 14.4205128,4.35897436 16.0820513,4.35897436 L18.2051282,4.35897436 L18.2051282,0.851282051 C17.8358974,0.758974359 16.6358974,0.666666667 15.1589744,0.666666667 C12.1128205,0.666666667 10.0820513,2.51282051 10.0820513,5.83589744 L10.0820513,8.6974359 L6.66666667,8.6974359 L6.66666667,12.6666667 L10.0820513,12.6666667 L10.0820513,22.8205128 L14.0512821,22.8205128 L14.0512821,22.8205128 Z\"></path></svg>"

/***/ }),
/* 326 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(210);

__webpack_require__(404);

var _reactDom = __webpack_require__(211);

var _reactRouter = __webpack_require__(18);

var _reactRouterRedux = __webpack_require__(138);

var _reactRedux = __webpack_require__(20);

var _tools = __webpack_require__(62);

var _tools2 = _interopRequireDefault(_tools);

var _config = __webpack_require__(31);

var _config2 = _interopRequireDefault(_config);

var _configureStore = __webpack_require__(828);

var _configureStore2 = _interopRequireDefault(_configureStore);

var _facebookActions = __webpack_require__(322);

var _facebookActions2 = _interopRequireDefault(_facebookActions);

var _routes = __webpack_require__(841);

var _routes2 = _interopRequireDefault(_routes);

var _authActions = __webpack_require__(321);

var _apiActions = __webpack_require__(92);

var _apiActions2 = _interopRequireDefault(_apiActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

try {
  var store = (0, _configureStore2.default)();
  var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store);

  (0, _tools.initLogError)();

  store.dispatch(_facebookActions2.default.facebookInitialise(_config2.default.FACEBOOK_APP_ID));
  store.dispatch((0, _authActions.checkAuth)());

  if (_tools2.default.localStorageAvailable() && window.localStorage.getItem('selectedCharityEntity')) {
    var charityEntity = JSON.parse(window.localStorage.getItem('selectedCharityEntity'));
    if (charityEntity.charityId) {
      store.dispatch(_apiActions2.default.addCharityEntity(String(charityEntity.charityId), charityEntity));
    }
  }

  var mountNode = document.getElementById('app');

  (0, _reactDom.render)(_react2.default.createElement(
    _reactRedux.Provider,
    { store: store },
    _react2.default.createElement(_reactRouter.Router, { history: history, routes: (0, _routes2.default)(store) })
  ), mountNode);
} catch (e) {
  if (typeof window !== 'undefined' && window.rg4js) {
    window.rg4js('send', e);
  } else {
    console.error(e); // eslint-disable-line
  }
}

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _alerts = __webpack_require__(858);

var _alerts2 = _interopRequireDefault(_alerts);

var _tickGreen = __webpack_require__(860);

var _tickGreen2 = _interopRequireDefault(_tickGreen);

var _ = __webpack_require__(24);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var types = ['warning', 'error', 'success'];

var propTypes = {
  className: _propTypes2.default.string,
  type: _propTypes2.default.oneOf(types).isRequired,
  content: _propTypes2.default.node.isRequired
};

var defaultProps = {
  className: ''
};

var Alerts = function Alerts(_ref) {
  var type = _ref.type,
      className = _ref.className,
      content = _ref.content;

  var alertsClasses = 'jg-alerts jg-alerts--' + type;
  var classes = className ? [className, alertsClasses].join(' ') : alertsClasses;

  return _react2.default.createElement('div', { className: classes }, _react2.default.createElement(_.Svg, { className: 'jq-alerts__icon jq-alerts__icon--' + type, markup: type === 'success' ? _tickGreen2.default : _alerts2.default }), content);
};

Alerts.propTypes = propTypes;
Alerts.defaultProps = defaultProps;

exports.default = Alerts;

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Alerts = __webpack_require__(328);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Alerts).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _loading = __webpack_require__(859);

var _loading2 = _interopRequireDefault(_loading);

var _ = __webpack_require__(24);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var sizes = ['small', 'medium', 'large'];

var colours = ['purple', 'white', 'grey', 'blue'];

var propTypes = {
  size: _propTypes2.default.oneOf(sizes),
  colour: _propTypes2.default.oneOf(colours),
  className: _propTypes2.default.string
};

var defaultProps = {
  size: 'medium',
  colour: 'purple',
  className: ''
};

var Loading = function Loading(_ref) {
  var size = _ref.size,
      colour = _ref.colour,
      className = _ref.className;

  var loadingClasses = 'jg-loading--' + size + ' jg-loading--' + colour;
  var classes = className ? [className, loadingClasses].join(' ') : loadingClasses;

  return _react2.default.createElement(_.Svg, { className: classes, markup: _loading2.default });
};

Loading.propTypes = propTypes;

Loading.defaultProps = defaultProps;

exports.default = Loading;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Loading = __webpack_require__(330);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Loading).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MatchMedia = __webpack_require__(35);

var _MatchMedia2 = _interopRequireDefault(_MatchMedia);

var _breakpoints = __webpack_require__(36);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var Large = function Large(_ref) {
  var children = _ref.children,
      mediaFeatures = _ref.mediaFeatures;
  return _react2.default.createElement(_MatchMedia2.default, { mediaQuery: '(min-width: ' + _breakpoints.LARGE + 'px)', mediaFeatures: mediaFeatures }, children);
};

Large.propTypes = {
  mediaFeatures: _propTypes2.default.shape({ width: _propTypes2.default.string })
};

Large.defaultProps = {
  mediaFeatures: null
};

exports.default = Large;

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MatchMedia = __webpack_require__(35);

var _MatchMedia2 = _interopRequireDefault(_MatchMedia);

var _breakpoints = __webpack_require__(36);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var LessThanLarge = function LessThanLarge(_ref) {
  var children = _ref.children,
      mediaFeatures = _ref.mediaFeatures;
  return _react2.default.createElement(_MatchMedia2.default, { mediaQuery: '(max-width: ' + (_breakpoints.LARGE - 1) + 'px)', mediaFeatures: mediaFeatures }, children);
};

LessThanLarge.propTypes = {
  mediaFeatures: _propTypes2.default.shape({ width: _propTypes2.default.string })
};

LessThanLarge.defaultProps = {
  mediaFeatures: null
};

exports.default = LessThanLarge;

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MatchMedia = __webpack_require__(35);

var _MatchMedia2 = _interopRequireDefault(_MatchMedia);

var _breakpoints = __webpack_require__(36);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var LessThanMedium = function LessThanMedium(_ref) {
  var children = _ref.children,
      mediaFeatures = _ref.mediaFeatures;
  return _react2.default.createElement(_MatchMedia2.default, { mediaQuery: '(max-width: ' + (_breakpoints.MEDIUM - 1) + 'px)', mediaFeatures: mediaFeatures }, children);
};

LessThanMedium.propTypes = {
  mediaFeatures: _propTypes2.default.shape({ width: _propTypes2.default.string })
};

LessThanMedium.defaultProps = {
  mediaFeatures: null
};

exports.default = LessThanMedium;

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MatchMedia = __webpack_require__(35);

var _MatchMedia2 = _interopRequireDefault(_MatchMedia);

var _breakpoints = __webpack_require__(36);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var LessThanSmall = function LessThanSmall(_ref) {
  var children = _ref.children,
      mediaFeatures = _ref.mediaFeatures;
  return _react2.default.createElement(_MatchMedia2.default, { mediaQuery: '(max-width: ' + (_breakpoints.SMALL - 1) + 'px)', mediaFeatures: mediaFeatures }, children);
};

LessThanSmall.propTypes = {
  mediaFeatures: _propTypes2.default.shape({ width: _propTypes2.default.string })
};

LessThanSmall.defaultProps = {
  mediaFeatures: null
};

exports.default = LessThanSmall;

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MatchMedia = __webpack_require__(35);

var _MatchMedia2 = _interopRequireDefault(_MatchMedia);

var _breakpoints = __webpack_require__(36);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var LessThanXLarge = function LessThanXLarge(_ref) {
  var children = _ref.children,
      mediaFeatures = _ref.mediaFeatures;
  return _react2.default.createElement(_MatchMedia2.default, { mediaQuery: '(max-width: ' + (_breakpoints.XLARGE - 1) + 'px)', mediaFeatures: mediaFeatures }, children);
};

LessThanXLarge.propTypes = {
  mediaFeatures: _propTypes2.default.shape({ width: _propTypes2.default.string })
};

LessThanXLarge.defaultProps = {
  mediaFeatures: null
};

exports.default = LessThanXLarge;

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MatchMedia = __webpack_require__(35);

var _MatchMedia2 = _interopRequireDefault(_MatchMedia);

var _breakpoints = __webpack_require__(36);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var LessThanXSmall = function LessThanXSmall(_ref) {
  var children = _ref.children,
      mediaFeatures = _ref.mediaFeatures;
  return _react2.default.createElement(_MatchMedia2.default, { mediaQuery: '(max-width: ' + (_breakpoints.XSMALL - 1) + 'px)', mediaFeatures: mediaFeatures }, children);
};

LessThanXSmall.propTypes = {
  mediaFeatures: _propTypes2.default.shape({ width: _propTypes2.default.string })
};

LessThanXSmall.defaultProps = {
  mediaFeatures: null
};

exports.default = LessThanXSmall;

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = {
  width: _propTypes2.default.string,
  children: _propTypes2.default.node
};

var defaultProps = {
  width: null,
  children: null
};

var childContextTypes = {
  mediaFeatures: _propTypes2.default.shape({
    width: _propTypes2.default.string
  })
};

var MediaFeatures = function (_Component) {
  _inherits(MediaFeatures, _Component);

  function MediaFeatures() {
    _classCallCheck(this, MediaFeatures);

    return _possibleConstructorReturn(this, (MediaFeatures.__proto__ || Object.getPrototypeOf(MediaFeatures)).apply(this, arguments));
  }

  _createClass(MediaFeatures, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var width = this.props.width;

      var mediaFeatures = width ? { width: width } : null;
      return { mediaFeatures: mediaFeatures };
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', null, this.props.children);
    }
  }]);

  return MediaFeatures;
}(_react.Component);

MediaFeatures.propTypes = propTypes;

MediaFeatures.defaultProps = defaultProps;

MediaFeatures.childContextTypes = childContextTypes;

exports.default = MediaFeatures;

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MatchMedia = __webpack_require__(35);

var _MatchMedia2 = _interopRequireDefault(_MatchMedia);

var _breakpoints = __webpack_require__(36);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var Medium = function Medium(_ref) {
  var children = _ref.children,
      mediaFeatures = _ref.mediaFeatures;
  return _react2.default.createElement(_MatchMedia2.default, { mediaQuery: '(min-width: ' + _breakpoints.MEDIUM + 'px)', mediaFeatures: mediaFeatures }, children);
};

Medium.propTypes = {
  mediaFeatures: _propTypes2.default.shape({ width: _propTypes2.default.string })
};

Medium.defaultProps = {
  mediaFeatures: null
};

exports.default = Medium;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MatchMedia = __webpack_require__(35);

var _MatchMedia2 = _interopRequireDefault(_MatchMedia);

var _breakpoints = __webpack_require__(36);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var Small = function Small(_ref) {
  var children = _ref.children,
      mediaFeatures = _ref.mediaFeatures;
  return _react2.default.createElement(_MatchMedia2.default, { mediaQuery: '(min-width: ' + _breakpoints.SMALL + 'px)', mediaFeatures: mediaFeatures }, children);
};

Small.propTypes = {
  mediaFeatures: _propTypes2.default.shape({ width: _propTypes2.default.string })
};

Small.defaultProps = {
  mediaFeatures: null
};

exports.default = Small;

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MatchMedia = __webpack_require__(35);

var _MatchMedia2 = _interopRequireDefault(_MatchMedia);

var _breakpoints = __webpack_require__(36);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var XLarge = function XLarge(_ref) {
  var children = _ref.children,
      mediaFeatures = _ref.mediaFeatures;
  return _react2.default.createElement(_MatchMedia2.default, { mediaQuery: '(min-width: ' + _breakpoints.XLARGE + 'px)', mediaFeatures: mediaFeatures }, children);
};

XLarge.propTypes = {
  mediaFeatures: _propTypes2.default.shape({ width: _propTypes2.default.string })
};

XLarge.defaultProps = {
  mediaFeatures: null
};

exports.default = XLarge;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MatchMedia = __webpack_require__(35);

var _MatchMedia2 = _interopRequireDefault(_MatchMedia);

var _breakpoints = __webpack_require__(36);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var XSmall = function XSmall(_ref) {
  var children = _ref.children,
      mediaFeatures = _ref.mediaFeatures;
  return _react2.default.createElement(_MatchMedia2.default, { mediaQuery: '(min-width: ' + _breakpoints.XSMALL + 'px)', mediaFeatures: mediaFeatures }, children);
};

XSmall.propTypes = {
  mediaFeatures: _propTypes2.default.shape({ width: _propTypes2.default.string })
};

XSmall.defaultProps = {
  mediaFeatures: null
};

exports.default = XSmall;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = {
  footerSelector: _propTypes2.default.string,
  stickyClass: _propTypes2.default.string
};

var defaultProps = {
  footerSelector: '#footer',
  stickyClass: 'stick-to-viewport'
};

var StickToFooter = function (_Component) {
  _inherits(StickToFooter, _Component);

  _createClass(StickToFooter, null, [{
    key: 'isServerRendered',
    value: function isServerRendered() {
      return typeof window === 'undefined';
    }
  }]);

  function StickToFooter() {
    _classCallCheck(this, StickToFooter);

    var _this = _possibleConstructorReturn(this, (StickToFooter.__proto__ || Object.getPrototypeOf(StickToFooter)).call(this));

    if (!StickToFooter.isServerRendered()) {
      _this.state = {
        isFooterInView: false
      };
      _this.footerEl = null;
      _this.el = null;
      _this.footerInView = _this.footerInView.bind(_this);
    }
    return _this;
  }

  _createClass(StickToFooter, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var footerSelector = this.props.footerSelector;

      this.footerEl = document.querySelector(footerSelector);
      window.addEventListener('scroll', this.footerInView);
      window.addEventListener('resize', this.footerInView);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.footerInView);
      window.removeEventListener('resize', this.footerInView);
    }
  }, {
    key: 'footerInView',
    value: function footerInView() {
      if (!this.footerEl) {
        console.warn('Missing footer element.'); // eslint-disable-line
        return;
      }

      var winHeight = window.innerHeight;
      var childBounds = this.el.getBoundingClientRect();
      var footerOffsetTop = this.footerEl.getBoundingClientRect().top + this.el.offsetHeight;
      var footerInView = footerOffsetTop < winHeight;
      var childInView = childBounds.top < winHeight;
      var elBottomInView = childBounds.bottom < winHeight;

      if (footerInView && childInView) {
        this.setState({
          isFooterInView: true
        });
      }

      if (!footerInView && !elBottomInView) {
        this.setState({
          isFooterInView: false
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          stickyClass = _props.stickyClass,
          children = _props.children,
          className = _props.className;

      var classes = [className];

      if (!StickToFooter.isServerRendered() && !this.state.isFooterInView) {
        classes.push(stickyClass);
      }

      return _react2.default.createElement('div', { className: classes.join(' ').trim(), ref: function ref(el) {
          _this2.el = el;
        } }, children);
    }
  }]);

  return StickToFooter;
}(_react.Component);

StickToFooter.propTypes = propTypes;

StickToFooter.defaultProps = defaultProps;

exports.default = StickToFooter;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _StickToFooter = __webpack_require__(343);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_StickToFooter).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

var propTypes = {
  markup: _propTypes2.default.string.isRequired
};

var Svg = function Svg(_ref) {
  var markup = _ref.markup,
      props = _objectWithoutProperties(_ref, ['markup']);

  var isBase64 = typeof markup === 'string' && markup.indexOf('data') === 0;
  return isBase64 ? _react2.default.createElement('img', _extends({ src: markup, alt: '' }, props))
  // eslint-disable-next-line react/no-danger
  : _react2.default.createElement('div', _extends({ dangerouslySetInnerHTML: { __html: markup } }, props));
};

Svg.propTypes = propTypes;

exports.default = Svg;

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Svg = __webpack_require__(345);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Svg).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateDeviceType = exports.updateNetworkStatus = exports.updateCurrentPage = exports.updateLocale = undefined;

var _utils = __webpack_require__(22);

var _actionTypes = __webpack_require__(32);

// APP ACTION CREATORS

/**
 * Create an action creator that sets the state value of the server current locale
 * @constant
 * @type {function} updateLocale action creator
 */
var updateLocale = exports.updateLocale = (0, _utils.makeActionCreator)(_actionTypes.appActionTypes.UPDATE_LOCALE, 'locale');

/**
 * Create an action creator that sets the name of the currently active page
 * Fired by components when a new page view is mounted
 * @constant
 * @type {function} updateCurrentPage action creator
 */
var updateCurrentPage = exports.updateCurrentPage = (0, _utils.makeActionCreator)(_actionTypes.appActionTypes.UPDATE_CURRENT_PAGE, 'currentPage');

/**
 * Create an action creator that sets the status of network connectivity
 * Fired by the browser when a network status change is heard
 * @constant
 * @type {function} updateNetworkStatus action creator
 */
var updateNetworkStatus = exports.updateNetworkStatus = (0, _utils.makeActionCreator)(_actionTypes.appActionTypes.UPDATE_NETWORK_STATUS, 'online');

/**
 * Create an action creator that sets the device type being used
 * Fired by the app on enter
 * @constant
 * @type {function} updateDeviceType action creator
 */
var updateDeviceType = exports.updateDeviceType = (0, _utils.makeActionCreator)(_actionTypes.appActionTypes.UPDATE_DEVICE_TYPE, 'deviceType');

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateAuthToken = undefined;

var _utils = __webpack_require__(22);

var _actionTypes = __webpack_require__(32);

// AUTH ACTION CREATORS

/**
 * Create an action creator that sets the auth token
 * @constant
 * @type {function} updateAuthToken action creator
 */
var updateAuthToken = exports.updateAuthToken = (0, _utils.makeActionCreator)(_actionTypes.authActionTypes.UPDATE_AUTH_TOKEN, 'authToken');

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateFacebookAccessToken = exports.updateFacebookEmail = exports.updateFacebookLastName = exports.updateFacebookFirstName = exports.updateFacebookLoginStatus = undefined;

var _utils = __webpack_require__(22);

var _actionTypes = __webpack_require__(32);

// FACEBOOK ACTION CREATORS

/**
 * Create an action creator that sets the state value of the facebook login status, read from app props
 * Fired by the app on mount
 * @constant
 * @type {function} updateFacebookLoginStatus action creator
 */
var updateFacebookLoginStatus = exports.updateFacebookLoginStatus = (0, _utils.makeActionCreator)(_actionTypes.facebookActionTypes.UPDATE_FACEBOOK_LOGIN_STATUS, 'facebookLoginStatus');

/**
 * Create an action creator that sets the state value of the facebook data first name
 * Fired by the app when facebook data is fetched
 * @constant
 * @type {function} updateFacebookFirstName action creator
 */
var updateFacebookFirstName = exports.updateFacebookFirstName = (0, _utils.makeActionCreator)(_actionTypes.facebookActionTypes.UPDATE_FACEBOOK_FIRST_NAME, 'firstName');

/**
 * Create an action creator that sets the name of the facebook data last name
 * Fired by the app when facebook data is fetched
 * @constant
 * @type {function} updateFacebookLastName action creator
 */
var updateFacebookLastName = exports.updateFacebookLastName = (0, _utils.makeActionCreator)(_actionTypes.facebookActionTypes.UPDATE_FACEBOOK_LAST_NAME, 'lastName');

/**
 * Create an action creator that sets the status of facebook data email address
 * Fired by the app when facebook data is fetched
 * @constant
 * @type {function} updateFacebookEmail action creator
 */
var updateFacebookEmail = exports.updateFacebookEmail = (0, _utils.makeActionCreator)(_actionTypes.facebookActionTypes.UPDATE_FACEBOOK_EMAIL, 'email');

/**
 * Create an action creator that sets facebook data access token
 * Fired by the app when facebook data is fetched
 * @constant
 * @type {function} updateFacebookAccessToken action creator
 */
var updateFacebookAccessToken = exports.updateFacebookAccessToken = (0, _utils.makeActionCreator)(_actionTypes.facebookActionTypes.UPDATE_FACEBOOK_ACCESS_TOKEN, 'accessToken');

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iamRequestError = exports.iamRequestSuccess = exports.iamRequestMade = exports.facebookRequestError = exports.facebookRequestSuccess = exports.facebookRequestMade = undefined;

var _utils = __webpack_require__(22);

var _actionTypes = __webpack_require__(32);

// HTTP ACTION CREATORS

/*+++++++++++++++++++++++++++
 /+ FACEBOOK API
 +++++++++++++++++++++++++++*/

/**
 * Create an action creator that sets the state value of Facebook Login API request made
 * @constant
 * @type {function} facebookRequestMade action creator
 */
var facebookRequestMade = exports.facebookRequestMade = (0, _utils.makeActionCreator)(_actionTypes.httpActionTypes.FACEBOOK_REQUEST_MADE, 'request');

/**
 * Create an action creator that sets the state value of Facebook Login API request success
 * @constant
 * @type {function} facebookRequestSuccess action creator
 */
var facebookRequestSuccess = exports.facebookRequestSuccess = (0, _utils.makeActionCreator)(_actionTypes.httpActionTypes.FACEBOOK_REQUEST_SUCCESS, 'request');

/**
 * Create an action creator that sets the state value of Facebook Login API request error
 * @constant
 * @type {function} facebookRequestError action creator
 */
var facebookRequestError = exports.facebookRequestError = (0, _utils.makeActionCreator)(_actionTypes.httpActionTypes.FACEBOOK_REQUEST_ERROR, 'request', 'error');

/*+++++++++++++++++++++++++++
 /+ IAM API
 +++++++++++++++++++++++++++*/

/**
 * Create an action creator that sets the state value of IAM API request made
 * @constant
 * @type {function} iamRequestMade action creator
 */
var iamRequestMade = exports.iamRequestMade = (0, _utils.makeActionCreator)(_actionTypes.httpActionTypes.IAM_REQUEST_MADE, 'request');

/**
 * Create an action creator that sets the state value of IAM API request success
 * @constant
 * @type {function} iamRequestSuccess action creator
 */
var iamRequestSuccess = exports.iamRequestSuccess = (0, _utils.makeActionCreator)(_actionTypes.httpActionTypes.IAM_REQUEST_SUCCESS, 'request');

/**
 * Create an action creator that sets the state value of IAM API request error
 * @constant
 * @type {function} iamRequestError action creator
 */
var iamRequestError = exports.iamRequestError = (0, _utils.makeActionCreator)(_actionTypes.httpActionTypes.IAM_REQUEST_ERROR, 'request', 'error');

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setPropsFromHost = exports.updateFbLoginScope = exports.updateLastName = exports.updateFirstName = exports.updatePassword = exports.updateEmailAddress = undefined;

var _utils = __webpack_require__(22);

var _actionTypes = __webpack_require__(32);

var updateEmailAddress = exports.updateEmailAddress = (0, _utils.makeActionCreator)(_actionTypes.userActionTypes.UPDATE_EMAIL_ADDRESS, 'emailAddress');

var updatePassword = exports.updatePassword = (0, _utils.makeActionCreator)(_actionTypes.userActionTypes.UPDATE_PASSWORD, 'password');

var updateFirstName = exports.updateFirstName = (0, _utils.makeActionCreator)(_actionTypes.userActionTypes.UPDATE_FIRSTNAME, 'firstName');

var updateLastName = exports.updateLastName = (0, _utils.makeActionCreator)(_actionTypes.userActionTypes.UPDATE_LASTNAME, 'lastName');

var updateFbLoginScope = exports.updateFbLoginScope = (0, _utils.makeActionCreator)(_actionTypes.userActionTypes.UPDATE_FB_LOGIN_SCOPE, 'fbLoginScope');

var setPropsFromHost = exports.setPropsFromHost = (0, _utils.makeActionCreator)(_actionTypes.userActionTypes.SET_PROPS_FROM_HOST, 'propsFromHost');

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateValidationErrors = undefined;

var _utils = __webpack_require__(22);

var _actionTypes = __webpack_require__(32);

// VALIDATION ACTION CREATORS

/**
 * Create an action creator that sets the state value of the validation errors
 * Used for updating state at validation
 * @constant
 * @type {function} updateValidationErrors action creator
 */
var updateValidationErrors = exports.updateValidationErrors = (0, _utils.makeActionCreator)(_actionTypes.validationActionTypes.UPDATE_VALIDATION_ERRORS, 'errors');

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.checkFacebookLoginStatus = exports.facebookConnect = exports.facebookLogin = undefined;

var _actions = __webpack_require__(63);

var _utils = __webpack_require__(22);

/**
 * facebookLogin - Top level API for logging in via facebook from a container
 * @desc
 * The Thunk first calls facebook login obtaining the user's permission to login with facebook
 * and fetching the required user data. If the promise resolves (all required FB user data is
 * obtained) we call the IAM facebook login thunk with FB data.
 */
var facebookLogin = exports.facebookLogin = function facebookLogin(requestSettings) {
	return function (dispatch) {
		return dispatch(facebookConnect()).then(function () {
			return dispatch(_actions.iamThunk.iamFacebookLogin(requestSettings));
		});
	};
};

/**
 * facebookConnect - Thunk that makes a request to the Facebook login API to initialise a facebook login
 * @desc
 * The Thunk first checks if the user is already connected via FB login. If not we make the
 * login connection attempt. A failure to connect triggers a rejection of the promise.
 * If already connected, or a successful connection is made, we contact Facebook for required
 * user-data which is then used to resolve the promise.
 * If the we don't have permission to access the users email, facebook will repromt.
 * @param {function} _logError - This is so that we can test the logger is fired
 * @returns {Promise} Redux thunk promise
*/
var facebookConnect = exports.facebookConnect = function facebookConnect() {
	var _logError = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _utils.logError;

	return function (dispatch, getState) {
		var facebookLoginStatus = getState().FACEBOOK_loginStatus;
		if (!facebookLoginStatus) {
			return;
		}
		return new Promise(function (resolve, reject) {
			var requestName = 'facebook_connect';
			dispatch(_actions.httpActions.facebookRequestMade(requestName));
			initFacebookLogin();

			// Log in in user and check permissions, we require email. FB pop up will re-prompt.
			function initFacebookLogin() {
				var fbOptions = {
					scope: getState().fbLoginScope || 'email',
					auth_type: 'rerequest'
				};
				FB.login(function (_ref) {
					var authResponse = _ref.authResponse,
					    status = _ref.status;

					if (status === 'not_authorized' || status === 'connected') {
						// not_authorized = connected to facebook and the app hasn't been authorised
						// connected = connected to facebook and the app has been authorised
						return getUserFacebookData(authResponse);
					} else {
						dispatch(_actions.httpActions.facebookRequestError(requestName, status));
						// returns unknown if the user closes the pop up, don't log this error
						if (status !== 'unknown') {
							_logError(new Error(requestName + ': status: ' + status));
						}
						return reject(status);
					}
				}, fbOptions);
			}

			// We are logged into Facebook - now get required user Facebook data
			function getUserFacebookData(authResponse) {
				if (authResponse) {
					FB.api('/me?fields=picture,email,first_name,last_name', function (response) {
						if (response.email) {
							dispatch(_actions.facebookActions.updateFacebookFirstName(response.first_name));
							dispatch(_actions.facebookActions.updateFacebookLastName(response.last_name));
							dispatch(_actions.facebookActions.updateFacebookEmail(response.email));
							dispatch(_actions.facebookActions.updateFacebookAccessToken(authResponse.accessToken));
							dispatch(_actions.httpActions.facebookRequestSuccess(requestName));
							return resolve();
						} else {
							dispatch(_actions.httpActions.facebookRequestError(requestName, 'fb_user_denied_email'));
							_logError(new Error('fb_user_denied_email'));
							return reject('fb_user_denied_email');
						}
					});
				} else {
					// The user has declined to authorise the JG Facebook app
					dispatch(_actions.httpActions.facebookRequestError(requestName, 'fb_user_denied_email'));
					_logError(new Error('fb_user_denied_app_authorisation'));
					return reject('fb_user_denied_app_authorisation');
				}
			}
		});
	};
};

// Check if the user is logged in to Facebook
var checkFacebookLoginStatus = exports.checkFacebookLoginStatus = function checkFacebookLoginStatus(cb) {
	FB && FB.getLoginStatus(function (response) {
		return cb(response);
	});
};

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.iamRegisterAndLogin = exports.iamJgLogin = exports.iamFacebookLogin = exports.iamEmailCheck = exports.parseHttpError = exports.handleHttpError = undefined;

var _utils = __webpack_require__(22);

var _actions = __webpack_require__(63);

var _config = __webpack_require__(46);

var _analyticsKissmetrics = __webpack_require__(216);

/**
 * handleHttpError
 * @desc helper method to handle 'true' HTTP errors
 * @param {object} error - error returned from http request
 * @param {string} requestName - reference for API call
 * @param {function} dispatch - Redux dispatch
 * @param {function} reject
 * @param {string} errorMessage - optional error message string to log error against in state tree
 * @param {function} _logError - optional function, defaults to imported logError, used for testing
 * @param {object} _iamMessages - optional object, defaults to imported iamMessages, used for testing
 * @returns {promise} reject - promise rejection
 */
var handleHttpError = exports.handleHttpError = function handleHttpError(error, requestName, dispatch, reject, errorMessage) {
	var _logError = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : _utils.logError;

	var _iamMessages = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : _config.iamMessages;

	if (error.message !== _config.iamMessages.INVALID_CREDENTIALS.message) {
		_logError(error);
	}
	switch (error.message) {
		case 'Request timeout':
			dispatch(_actions.appActions.updateNetworkStatus(navigator.onLine));
			dispatch(_actions.httpActions.iamRequestError(requestName, 'iam_request_timeout'));
			break;
		default:
			dispatch(_actions.httpActions.iamRequestError(requestName, errorMessage));
	}
	return reject();
};

/**
 * parseHttpError
 * @desc helper method to parse HTTP errors
 * @param {object} error - error returned from http request
 * @returns {Promise.<T>} resolve with either the response body or an error
 */
var parseHttpError = exports.parseHttpError = function parseHttpError(error) {
	if (error.response) {
		return error.response.json().catch(function (err) {
			return Promise.resolve(err);
		});
	} else {
		return Promise.resolve(error);
	}
};

/**
 * iamEmailCheck
 * @desc Call the IAM Email check API with email address supplied by the user
 * If the user is found a success response is returned. In all other cases, some kind of HTTP error response is
 * returned. We inspect the error response for specific messages, which indicate a successful request execution
 * which we thus want to convert into a resolve of the outer promise. All other errors are assumed to be true HTTP
 * errors and are delegated to a helper function to deal with
 * @returns {Promise} Redux thunk promise
 */
var iamEmailCheck = exports.iamEmailCheck = function iamEmailCheck() {
	return function (dispatch, getState) {
		return new Promise(function (resolve, reject) {
			var requestName = 'iam_email_check';
			var email = getState().emailAddress;

			var url = _config.config.iam.emailCheckUrl;
			var requestAction = (0, _utils.dispatchAction)(dispatch, _actions.httpActions.iamRequestMade(requestName));
			var requestBody = {
				'EmailAddress': email
			};
			return (0, _utils.makeRequest)(url, requestAction, {
				method: 'POST',
				mode: 'cors',
				headers: _utils.iamBaseHeader,
				body: JSON.stringify(requestBody)
			}).then(function () {
				dispatch(_actions.httpActions.iamRequestSuccess(requestName));
				return resolve(_config.iamMessages.USER_FOUND);
			}).catch(function (error) {
				return parseHttpError(error).then(function (errorResponse) {
					if (errorResponse && errorResponse.Errors) {
						switch (errorResponse.Errors[0].ErrorMessage) {
							case _config.iamMessages.NO_USER_FOUND.message:
								dispatch(_actions.httpActions.iamRequestSuccess(requestName));
								return resolve(_config.iamMessages.NO_USER_FOUND.error);
							default:
								return handleHttpError(error, requestName, dispatch, reject, 'iam_email_check');
						}
					} else {
						return handleHttpError(error, requestName, dispatch, reject, 'iam_email_check');
					}
				});
			});
		});
	};
};

/**
 * iamFacebookLogin
 * @desc Call the IAM Facebook login API with data collected from FB login.
 * Abort login and reject the promise if all required facebook data is not available.
 * @param {function} setKissmetricsIdentity used as an override for testing
 * @returns {Promise} Redux thunk promise
 */
var iamFacebookLogin = exports.iamFacebookLogin = function iamFacebookLogin(requestSettings) {
	var setKissmetricsIdentity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _analyticsKissmetrics.setIdentity;
	return function (dispatch, getState) {
		return new Promise(function (resolve, reject) {
			var ClientId = requestSettings.ClientId,
			    RegistrationSource = requestSettings.RegistrationSource,
			    LongLived = requestSettings.LongLived;

			var requestName = 'iam_facebook_login';
			var firstName = getState().FACEBOOK_firstName;
			var lastName = getState().FACEBOOK_lastName;
			var accessToken = getState().FACEBOOK_accessToken;
			var email = getState().FACEBOOK_email;

			if (!firstName || !lastName || !accessToken || !email) {
				dispatch(_actions.httpActions.iamRequestError(requestName, 'insufficient_facebook_data'));
				return reject();
			}
			var url = _config.config.iam.facebookLoginUrl;
			var requestAction = (0, _utils.dispatchAction)(dispatch, _actions.httpActions.iamRequestMade(requestName));
			var requestBody = {
				'FirstName': firstName,
				'LastName': lastName,
				'AccessToken': accessToken,
				'EmailAddress': email,
				'RegistrationSource': RegistrationSource,
				'LongLived': LongLived,
				'GrantType': 'facebook',
				'ClientId': ClientId
			};

			return (0, _utils.makeRequest)(url, requestAction, {
				method: 'POST',
				mode: 'cors',
				credentials: 'include',
				headers: _utils.iamBaseHeader,
				body: JSON.stringify(requestBody)
			}).then(function (response) {
				var accessToken = response.Result.access_token;
				// send jwt [extract email] to kissmetrics
				setKissmetricsIdentity(accessToken);
				dispatch(_actions.authActions.updateAuthToken(accessToken));
				dispatch(_actions.httpActions.iamRequestSuccess(requestName));
				return resolve({
					accessToken: accessToken,
					refreshToken: response.Result.refresh_token
				});
			}).catch(function (error) {
				handleHttpError(error, requestName, dispatch, reject, 'iam_jg_login');
			});
		});
	};
};

/**
 * iamJgLogin
 * @desc Call the IAM 'JG credentials' login API with email address and password supplied by the user.
 * @param {function} setKissmetricsIdentity used as an override for testing
 * @returns {Promise} Redux thunk promise
 */
var iamJgLogin = exports.iamJgLogin = function iamJgLogin(requestSettings) {
	var setKissmetricsIdentity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _analyticsKissmetrics.setIdentity;
	return function (dispatch, getState) {
		return new Promise(function (resolve, reject) {
			var ClientId = requestSettings.ClientId;

			var requestName = 'iam_jg_login';
			var email = getState().emailAddress;
			var password = getState().password;
			var url = _config.config.iam.jgLoginUrl;
			var requestAction = (0, _utils.dispatchAction)(dispatch, _actions.httpActions.iamRequestMade(requestName));
			var requestBody = {
				'Username': email,
				'Password': password,
				'GrantType': 'password',
				'ClientId': ClientId,
				'LongLived': true
			};

			return (0, _utils.makeRequest)(url, requestAction, {
				method: 'POST',
				mode: 'cors',
				credentials: 'include',
				headers: _utils.iamBaseHeader,
				body: JSON.stringify(requestBody)
			}).then(function (response) {
				dispatch(_actions.httpActions.iamRequestSuccess(requestName));
				// send jwt [extract email] to kissmetrics
				setKissmetricsIdentity(response.Result.access_token);
				return resolve({
					accessToken: response.Result.access_token,
					refreshToken: response.Result.refresh_token
				});
			}).catch(function (error) {
				return parseHttpError(error).then(function (errorResponse) {
					var parsedError = error;
					if (errorResponse && errorResponse.Errors) {
						parsedError = new Error(errorResponse.Errors[0].ErrorMessage || 'No error message returned from IAM');
					}
					return handleHttpError(parsedError, requestName, dispatch, reject, 'iam_jg_login');
				});
			});
		});
	};
};

/**
 * iamRegisterAndLogin
 * @desc Call the IAM Register and login API with data collected from register page
 * Abort register call and reject the promise if API returns an error status code.
 * @returns {Promise} Redux thunk promise
 */
var iamRegisterAndLogin = exports.iamRegisterAndLogin = function iamRegisterAndLogin() {
	var setKissmetricsIdentity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _analyticsKissmetrics.setIdentity;
	return function (dispatch, getState) {
		return new Promise(function (resolve, reject) {
			var requestName = 'iam_register';

			var firstName = getState().firstName;
			var lastName = getState().lastName;
			var emailAddress = getState().emailAddress;
			var password = getState().password;

			if (!firstName || !lastName || !emailAddress || !password) {
				dispatch(_actions.httpActions.iamRequestError(requestName, 'insufficient_user_data'));
				return reject();
			}

			var url = _config.config.iam.registerAndLoginUrl;
			var clientId = _config.config.clientId;
			var requestAction = (0, _utils.dispatchAction)(dispatch, _actions.httpActions.iamRequestMade(requestName));
			var requestBody = {
				FirstName: firstName,
				LastName: lastName,
				EmailAddress: emailAddress,
				Password: password,
				GrantType: 'register_justgiving',
				ClientId: clientId,
				RegistrationSource: 2,
				LongLived: true
			};

			return (0, _utils.makeRequest)(url, requestAction, {
				method: 'POST',
				mode: 'cors',
				credentials: 'include',
				headers: _utils.iamBaseHeader,
				body: JSON.stringify(requestBody)
			}).then(function (response) {
				dispatch(_actions.httpActions.iamRequestSuccess(requestName));
				// send jwt [extract email] to kissmetrics
				setKissmetricsIdentity(response.Result.access_token);
				return resolve({
					accessToken: response.Result.access_token,
					refreshToken: response.Result.refresh_token
				});
			}).catch(function (error) {
				return parseHttpError(error).then(function (errorResponse) {
					if (errorResponse && errorResponse.Errors) {
						switch (errorResponse.Errors[0].ErrorMessage) {
							case _config.iamMessages.EMAIL_ADDRESS_IN_USE.message:
								dispatch(_actions.httpActions.iamRequestError(requestName, _config.iamMessages.EMAIL_ADDRESS_IN_USE.error));
								return reject();
							default:
								return handleHttpError(error, requestName, dispatch, reject, 'iam_register');
						}
					} else {
						return handleHttpError(error, requestName, dispatch, reject, 'iam_register');
					}
				});
			});
		});
	};
};

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _AlertSlideDown = __webpack_require__(246);

var _AlertSlideDown2 = _interopRequireDefault(_AlertSlideDown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AlertRecoverableError = (_temp = _class = function (_Component) {
	_inherits(AlertRecoverableError, _Component);

	function AlertRecoverableError() {
		_classCallCheck(this, AlertRecoverableError);

		return _possibleConstructorReturn(this, (AlertRecoverableError.__proto__ || Object.getPrototypeOf(AlertRecoverableError)).apply(this, arguments));
	}

	_createClass(AlertRecoverableError, [{
		key: 'getAlertMessage',
		value: function getAlertMessage() {
			var _props = this.props,
			    isRecoverableError = _props.isRecoverableError,
			    networkStatus = _props.networkStatus,
			    intl = _props.intl;


			var isRecoverableErrorType = typeof isRecoverableError === 'undefined' ? 'undefined' : _typeof(isRecoverableError);
			var alertMessage = isRecoverableErrorType.match(/string|object/) ? isRecoverableError : 'recoverable';

			if ((typeof alertMessage === 'undefined' ? 'undefined' : _typeof(alertMessage)) === 'object' && alertMessage.link) {
				return _react2.default.createElement(
					'span',
					null,
					intl.formatMessage('err:' + alertMessage.intlKey),
					alertMessage.link()
				);
			} else {
				return intl.formatMessage('err:' + alertMessage);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _props2 = this.props,
			    decoratorClass = _props2.decoratorClass,
			    isRecoverableError = _props2.isRecoverableError;


			return _react2.default.createElement(_AlertSlideDown2.default, {
				renderAlert: isRecoverableError ? true : false,
				id: 'isRecoverableError',
				decoratorClass: decoratorClass,
				alertType: 'amber',
				alertMessage: this.getAlertMessage.call(this),
				qaSelector: 'alertRecoverableError' });
		}
	}]);

	return AlertRecoverableError;
}(_react.Component), _class.propTypes = {
	intl: _propTypes2.default.object.isRequired,
	isRecoverableError: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string, _propTypes2.default.object]),
	networkStatus: _propTypes2.default.string,
	decoratorClass: _propTypes2.default.string
}, _temp);
exports.default = AlertRecoverableError;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Avatar = (_temp = _class = function (_Component) {
	_inherits(Avatar, _Component);

	function Avatar() {
		_classCallCheck(this, Avatar);

		return _possibleConstructorReturn(this, (Avatar.__proto__ || Object.getPrototypeOf(Avatar)).apply(this, arguments));
	}

	_createClass(Avatar, [{
		key: 'render',
		value: function render() {
			var decoratorClass = this.props.decoratorClass;

			return _react2.default.createElement(
				'div',
				{ className: 'login-avatar ' + (decoratorClass ? decoratorClass : '') },
				_react2.default.createElement('span', {
					className: 'login-avatar-fallback',
					'aria-hidden': 'true' })
			);
		}
	}]);

	return Avatar;
}(_react.Component), _class.propTypes = {
	decoratorClass: _propTypes2.default.string
}, _temp);
exports.default = Avatar;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FootnoteTsAndCs = (_temp = _class = function (_Component) {
	_inherits(FootnoteTsAndCs, _Component);

	function FootnoteTsAndCs() {
		_classCallCheck(this, FootnoteTsAndCs);

		return _possibleConstructorReturn(this, (FootnoteTsAndCs.__proto__ || Object.getPrototypeOf(FootnoteTsAndCs)).apply(this, arguments));
	}

	_createClass(FootnoteTsAndCs, [{
		key: 'render',
		value: function render() {
			var intl = this.props.intl;

			return _react2.default.createElement(
				'p',
				{ className: 'dna-text-center dna-space-mtm', 'data-qa': 'footnote' },
				_react2.default.createElement(
					'small',
					{ className: 'dna-text-xs-light' },
					intl.formatMessage('content|login:register|TsAndCs-1'),
					'\xA0',
					_react2.default.createElement(
						'a',
						{ 'data-qa': 'termsOfService', href: 'https://www.justgiving.com/info/terms-of-service/', target: '_blank' },
						intl.formatMessage('content|login:register|termsOfServiceLinkText')
					),
					'\xA0',
					intl.formatMessage('content|_defaults|and'),
					'\xA0',
					_react2.default.createElement(
						'a',
						{ 'data-qa': 'privacyPolicy', href: 'https://www.justgiving.com/info/privacy/', target: '_blank' },
						intl.formatMessage('content|login:register|PrivacyPolicyLinkText')
					)
				)
			);
		}
	}]);

	return FootnoteTsAndCs;
}(_react.Component), _class.propTypes = {
	intl: _propTypes2.default.object.isRequired
}, _temp);
exports.default = FootnoteTsAndCs;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _queryString = __webpack_require__(170);

exports.default = {
	get app() {
		return {
			get name() {
				return window.GG.jgLoginAppSettings.APP_NAME;
			},
			get version() {
				return window.GG.jgLoginAppSettings.APP_VERSION;
			}
		};
	},
	get iam() {
		return {
			get baseUrl() {
				var iamQueryStringUrl = (0, _queryString.queryStringParse)(location.search).iamUrl;
				var iamUrl = iamQueryStringUrl || window.GG.jgLoginAppSettings.IAM_API.BASE_URL;
				return iamUrl.endsWith('/') ? iamUrl : iamUrl + '/';
			},
			get facebookLoginUrl() {
				return '' + this.baseUrl + window.GG.jgLoginAppSettings.IAM_API.ENDPOINTS.FB_LOGIN_URL;
			},
			get jgLoginUrl() {
				return '' + this.baseUrl + window.GG.jgLoginAppSettings.IAM_API.ENDPOINTS.JG_LOGIN_URL;
			},
			get registerAndLoginUrl() {
				return '' + this.baseUrl + window.GG.jgLoginAppSettings.IAM_API.ENDPOINTS.REGISTER_AND_LOGIN_URL;
			},
			get emailCheckUrl() {
				return '' + this.baseUrl + window.GG.jgLoginAppSettings.IAM_API.ENDPOINTS.EMAIL_CHECK_URL;
			}
		};
	},
	get imageService() {
		return {
			get baseUrl() {
				return window.GG.jgLoginAppSettings.IMAGE_SERVICE_URL;
			},
			get defaultSize() {
				return window.GG.jgLoginAppSettings.IMAGE_SERVICE_SIZE;
			}
		};
	},
	get defaultLocale() {
		return window.GG.jgLoginAppSettings.DEFAULT_LOCALE;
	},
	get JgAnalyticsCookieName() {
		return window.GG.jgLoginAppSettings.JG_ANALYTICS_COOKIE_NAME;
	},
	get requestTimeoutDeadline() {
		return window.GG.jgLoginAppSettings.REQUEST_TIMEOUT_DEADLINE;
	},
	get clientId() {
		return window.GG.jgLoginAppSettings.CLIENT_ID;
	},
	get resetPasswordLink() {
		return 'http://www.justgiving.com/signin/?m=pwreset';
	}
};

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
/**
 * IAM response message configuration
 * @constant iamMessages
 * @type {object}
 * IAM response (success or error) ERROR messages, or custom messages, mapped to constants */

var iamMessages = exports.iamMessages = {
	EMAIL_ADDRESS_IN_USE: {
		message: 'EmailAddress is in use.',
		error: 'iam_register_email_in_use'
	},
	NO_USER_FOUND: {
		message: 'No user association found.',
		error: 'iam_email_check_no_user'
	},
	USER_FOUND: {
		message: 'iam_email_check_has_user'
	},
	INVALID_CREDENTIALS: {
		message: 'The username or password is incorrect.'
	}
};

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
/**
 * Application page configuration
 * @constant PAGES
 * @type {object}
 * High-level configuration for the 'pages' (routes) of the application
 * that can be consulted by various components within the app (router, validators, http).
 * By storing this configuration in a config file we avoid hard-coded values in our containers
 * etc. and can therefore abstract generic util methods and change application behaviour more easily
 */
var PAGES = exports.PAGES = {
	EmailPage: {
		name: 'EmailPage',
		route: 'email'
	},
	RegisterPage: {
		name: 'RegisterPage',
		route: 'register'
	},
	PasswordPage: {
		name: 'PasswordPage',
		route: 'password'
	}
};

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _redux = __webpack_require__(21);

var _reactRedux = __webpack_require__(20);

var _reactRouter = __webpack_require__(18);

var _configureStore = __webpack_require__(388);

var _configureStore2 = _interopRequireDefault(_configureStore);

var _config = __webpack_require__(46);

var _actions = __webpack_require__(63);

var _mobileDetect = __webpack_require__(677);

var _mobileDetect2 = _interopRequireDefault(_mobileDetect);

var _history = __webpack_require__(385);

var _history2 = _interopRequireDefault(_history);

var _utils = __webpack_require__(22);

var _EmailPage = __webpack_require__(213);

var _RegisterPage = __webpack_require__(215);

var _PasswordPage = __webpack_require__(214);

var _App = __webpack_require__(212);

var _App2 = _interopRequireDefault(_App);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Root = (_temp = _class = function (_Component) {
	_inherits(Root, _Component);

	function Root(props) {
		_classCallCheck(this, Root);

		var _this = _possibleConstructorReturn(this, (Root.__proto__ || Object.getPrototypeOf(Root)).call(this, props));

		_this.store = (0, _configureStore2.default)();
		return _this;
	}

	_createClass(Root, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this.setLocale();
			this.initErrorLogger();
			this.setFacebookLoginStatus();
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.setDeviceType();
		}
	}, {
		key: 'setFacebookLoginStatus',
		value: function setFacebookLoginStatus() {
			var facebookLoginStatus = this.props.facebookLoginStatus;

			this.store.dispatch(_actions.facebookActions.updateFacebookLoginStatus(facebookLoginStatus));
		}
	}, {
		key: 'setLocale',
		value: function setLocale() {
			var locale = this.props.locale;

			this.store.dispatch(_actions.appActions.updateLocale(locale ? locale : _config.config.defaultLocale));
		}
	}, {
		key: 'setDeviceType',
		value: function setDeviceType() {
			var deviceDetected = new _mobileDetect2.default(window.navigator.userAgent);
			var deviceType = deviceDetected.mobile() ? 'Mobile' : 'Desktop';
			this.store.dispatch(_actions.appActions.updateDeviceType(deviceType));
		}
	}, {
		key: 'initErrorLogger',
		value: function initErrorLogger() {
			var initErrorLogger = this.props.initErrorLogger;
			var _config$app = _config.config.app,
			    version = _config$app.version,
			    name = _config$app.name;

			var hasInit = false;
			initErrorLogger(version, name, hasInit);
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    children = _props.children,
			    isAppEmbedded = _props.isAppEmbedded,
			    publicPath = _props.publicPath;


			var EmailPageWithProps = (0, _utils.passPropsTo)(_EmailPage.EmailPageWithRouter, _extends({}, this.props));
			var PasswordPageWithProps = (0, _utils.passPropsTo)(_PasswordPage.PasswordPageWithRouter, _extends({}, this.props));
			var RegisterPageWithProps = (0, _utils.passPropsTo)(_RegisterPage.RegisterPageWithRouter, _extends({}, this.props));
			var AppWithProps = (0, _utils.passPropsTo)(_App2.default, _extends({}, this.props));

			return _react2.default.createElement(
				_reactRedux.Provider,
				{ store: this.store },
				isAppEmbedded ? _react2.default.createElement(
					'div',
					null,
					children
				) : _react2.default.createElement(
					_reactRouter.Router,
					{ history: _history2.default },
					_react2.default.createElement(
						_reactRouter.Route,
						{
							path: publicPath || '/',
							component: AppWithProps },
						_react2.default.createElement(_reactRouter.IndexRoute, { components: EmailPageWithProps }),
						_react2.default.createElement(_reactRouter.Route, {
							path: _config.PAGES.EmailPage.route,
							components: EmailPageWithProps }),
						_react2.default.createElement(_reactRouter.Route, {
							path: _config.PAGES.PasswordPage.route,
							components: PasswordPageWithProps }),
						_react2.default.createElement(_reactRouter.Route, {
							path: _config.PAGES.RegisterPage.route,
							components: RegisterPageWithProps }),
						_react2.default.createElement(_reactRouter.Route, {
							path: '*',
							components: EmailPageWithProps })
					)
				)
			);
		}
	}]);

	return Root;
}(_react.Component), _class.propTypes = {
	locale: _propTypes2.default.string,
	facebookLoginStatus: _propTypes2.default.object,
	isAppEmbedded: _propTypes2.default.bool,
	children: _propTypes2.default.element,
	publicPath: _propTypes2.default.string,
	initErrorLogger: _propTypes2.default.func.isRequired
}, _class.defaultProps = {
	isAppEmbedded: true,
	initErrorLogger: _utils.initErrorLogger
}, _temp);
exports.default = Root;

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* global ga b:true */

/**
 * pushes a 'page view' to google
 * @description by convention, all 'jg analytics' providers
 * (that is, all analytics*.js files in this dir) should share
 * the same interface.
 * @param {string} pageName - name of current page
 */
var trackPageView = exports.trackPageView = function trackPageView(pageName) {
  if (window.ga) {
    ga('set', 'page', pageName);
    ga('send', 'pageview');
  }
};

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageView = undefined;

var _config = __webpack_require__(46);

/**
 * Fires bespoke events for given pages
 * @param {string} pageName - name of the current page
 * @param {object} data - pertinent tracking data
 * @param {Array} providers - Array of JG analytics providers (eg. GA, Kissmetrics,...)
 */
var pageView = exports.pageView = function pageView(pageName, data, providers) {
  switch (pageName) {}
};

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	metadata: {},
	messageTemplates: {}
};

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	metadata: {},
	messageTemplates: {}
};

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
		value: true
});
exports.default = {
		messageTemplates: {
				'content|_defaults|accessibleIsLoadingText': 'Processing, please wait a moment',
				'content|_defaults|continueLabel': 'Continue',
				'content|_defaults|and': 'and',
				'content|_defaults|or': 'or',

				'content|login:email|facebookLoginButtonLabel': 'Continue with Facebook',
				'content|login:email|facebookAssuranceMessage': 'Donate faster. We\'ll never post on your behalf',
				'content|login:email|emailFieldLabel': 'Email',
				'content|login:email|defaultContinueButtonLabel': 'Continue',
				'content|login:email|accessibleEmailLoginText': 'log in with your email address',

				'content|login:password|defaultHeading1': 'Welcome back',
				'content|login:password|passwordFieldLabel': 'Password',
				'content|login:password|defaultContinueButtonLabel': 'Login',
				'content|login:password|passwordFieldHintLabelShow': 'Show',
				'content|login:password|passwordFieldHintLabelHide': 'Hide',
				'content|login:password|editEmailAddressButtonLabel': 'Edit',
				'content|login:password|correctEmailAddressMessage': 'Not you?',
				'content|login:password|forgotPasswordMessage': 'Forgot your password?',
				'content|login:password|loginWithFacebookMessage': 'Log in with Facebook',
				'content|login:password|resetPasswordMessage': 'Reset your password',

				'content|login:register|firstNameFieldLabel': 'First name',
				'content|login:register|lastNameFieldLabel': 'Last name',
				'content|login:register|passwordFieldLabel': 'Password',
				'content|login:register|defaultContinueButtonLabel': 'Continue',
				'content|login:register|loginAlertLinkText': 'Log In',
				'content|login:register|TsAndCs-1': 'By clicking continue you agree to JustGiving’s',
				'content|login:register|termsOfServiceLinkText': 'Terms of Service',
				'content|login:register|PrivacyPolicyLinkText': 'Privacy Policy'
		}
};

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	messageTemplates: {
		'err:recoverable': 'Oops! Something went wrong. Please try again in a moment',
		'err:offline': 'Oops! Something went wrong. You may have lost internet connectivity. Please try again in a moment',
		'err:iam_request_timeout': 'Oops! Something went wrong. Please try again in a moment',
		'err:facebook_connect': 'Sorry, there was a problem logging in to Facebook. Please try again',
		'err:fb_user_denied_email': 'Sorry, we have been unable to retrieve your Facebook credentials. Please log in using your email address',
		'err:insufficient_facebook_data': 'Sorry, we have been unable to log in using your Facebook credentials. Please log in using your email address',
		'err:iam_jg_login': 'We\'re having trouble logging you in. Please try again',
		'err:iam_register_email_in_use': 'It looks like you already have an account on JustGiving. Please ',
		'err:iam_email_check': 'We\'re having trouble looking up your email address. Please try again.',
		'err:iam_register': 'We\'re having trouble creating your account. Please try again.',
		'err:emailRequired': 'Please enter your email address',
		'err:emailValid': 'Sorry, the email address you entered is not valid',
		'err:emailMaxLength': 'Sorry, the email address you entered is too long',
		'err:firstNameRequired': 'Please enter your first name',
		'err:firstNameMaxLength': 'Sorry, the first name you entered is too long',
		'err:lastNameRequired': 'Please enter your last name',
		'err:lastNameMaxLength': 'Sorry, the last name you entered is too long',
		'err:passwordRequired': 'Please enter your password',
		'err:passwordMinLength': 'Please enter a password that is at least six characters long'
	}
};

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	messageTemplates: {}
};

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _en_content = __webpack_require__(366);

var _en_content2 = _interopRequireDefault(_en_content);

var _en_errormessages = __webpack_require__(367);

var _en_errormessages2 = _interopRequireDefault(_en_errormessages);

var _en_metadata = __webpack_require__(368);

var _en_metadata2 = _interopRequireDefault(_en_metadata);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var messageTemplates = Object.assign({}, _en_content2.default.messageTemplates, _en_errormessages2.default.messageTemplates, _en_metadata2.default.messageTemplates);
exports.default = { messageTemplates: messageTemplates };

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _en = __webpack_require__(369);

var _en2 = _interopRequireDefault(_en);

var _enAu = __webpack_require__(364);

var _enAu2 = _interopRequireDefault(_enAu);

var _enUs = __webpack_require__(365);

var _enUs2 = _interopRequireDefault(_enUs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	'en': _en2.default,
	'en-au': _enAu2.default,
	'en-us': _enUs2.default
};

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * simple class that is used to describe the
 * outcome of a validation rule
 */
var IsValid =
/**
 * @param {boolean} isValid
 * @param {string} message
 * @param {boolean} endAllIfInvalid
 */
function IsValid(isValid, message) {
	var endAllIfInvalid = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

	_classCallCheck(this, IsValid);

	this.isValid = isValid;
	this.message = message;
	this.endAllIfInvalid = endAllIfInvalid;
};

exports.default = IsValid;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _IsValid = __webpack_require__(371);

var _IsValid2 = _interopRequireDefault(_IsValid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Class that allows you to chain together individual
 * validation rules
 */
var Rules = function () {
	function Rules() {
		_classCallCheck(this, Rules);

		this.rules = [];
		return this;
	}

	_createClass(Rules, [{
		key: 'required',
		value: function required() {
			var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

			// returns a named function to increase testability
			this.rules.push(function required(value) {
				return new _IsValid2.default(!!value, message, true);
			});
			return this;
		}
	}, {
		key: 'maxLength',
		value: function maxLength() {
			var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
			var length = arguments[1];

			this.rules.push(function maxLength(value) {
				return new _IsValid2.default(typeof value !== 'string' || !value || value.length <= length, message);
			});
			return this;
		}
	}, {
		key: 'minLength',
		value: function minLength() {
			var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
			var length = arguments[1];

			this.rules.push(function minLength(value) {
				return new _IsValid2.default(typeof value !== 'string' || !value || value.length >= length, message);
			});
			return this;
		}
	}, {
		key: 'email',
		value: function email() {
			var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

			this.rules.push(function email(value) {
				var emailRegEx = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
				return new _IsValid2.default(emailRegEx.test(value), message);
			});
			return this;
		}
	}, {
		key: 'done',
		value: function done() {
			return this.rules;
		}
	}]);

	return Rules;
}();

exports.default = Rules;

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _Rules = __webpack_require__(372);

var _Rules2 = _interopRequireDefault(_Rules);

var _Validator = __webpack_require__(374);

var _Validator2 = _interopRequireDefault(_Validator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Object that contains our apps validation rules
 */
exports.default = {
	emailAddress: new _Validator2.default('emailAddress', new _Rules2.default().required('err:emailRequired').email('err:emailValid').maxLength('err:emailMaxLength', 100).done()),
	firstName: new _Validator2.default('firstName', new _Rules2.default().required('err:firstNameRequired').maxLength('err:firstNameMaxLength', 100).done()),
	lastName: new _Validator2.default('lastName', new _Rules2.default().required('err:lastNameRequired').maxLength('err:lastNameMaxLength', 50).done()),
	password: new _Validator2.default('password', new _Rules2.default().required('err:passwordRequired').minLength('err:passwordMinLength', 6).done())
};

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Class that runs through the passed array
 * of validation rules
 */
var Validator = function () {
	/**
  * @param {string} key
  * @param {Array} validation rules - output from a 'Rules' chain
  */
	function Validator() {
		var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
		var validationRules = arguments[1];

		_classCallCheck(this, Validator);

		this.key = key;
		this.validationRules = validationRules;
	}
	/**
  * Valiates the passed value against the passed
  * 'validation rules'
  * @param {string|number} value
  * @returns {Array} of validation messages
  */


	_createClass(Validator, [{
		key: 'validate',
		value: function validate(value) {
			var messages = [];
			this.validationRules.every(function (validationRule) {
				var validationResult = validationRule(value);
				if (!validationResult.isValid) {
					messages.push({
						key: validationResult.message,
						messageTemplateValues: ''
					});
					return !validationResult.endAllIfInvalid;
				} else {
					return true;
				}
			});
			return messages;
		}
	}]);

	return Validator;
}();

exports.default = Validator;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Schema = __webpack_require__(373);

var _Schema2 = _interopRequireDefault(_Schema);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Schema2.default;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(20);

var _Analytics = __webpack_require__(607);

var _Analytics2 = _interopRequireDefault(_Analytics);

var _analyticsGoogle = __webpack_require__(362);

var analyticsGoogle = _interopRequireWildcard(_analyticsGoogle);

var _analyticsKissmetrics = __webpack_require__(216);

var analyticsKissmetrics = _interopRequireWildcard(_analyticsKissmetrics);

var _analytics = __webpack_require__(363);

var analytics = _interopRequireWildcard(_analytics);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var analyticsProviders = [analyticsGoogle, analyticsKissmetrics];

function mapStateToProps(state) {
	return {
		analyticsData: {}
	};
}

var Analytics = function Analytics(ComposedComponent, pageName) {
	return (0, _reactRedux.connect)(mapStateToProps, null)((0, _Analytics2.default)(ComposedComponent, pageName, analytics, analyticsProviders));
};

exports.default = Analytics;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _Intl = __webpack_require__(608);

var _Intl2 = _interopRequireDefault(_Intl);

var _reactRedux = __webpack_require__(20);

var _lang = __webpack_require__(370);

var _lang2 = _interopRequireDefault(_lang);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
	return {
		locale: state.APP_locale
	};
}

exports.default = function (ComposedComponent) {
	return (0, _reactRedux.connect)(mapStateToProps, null)((0, _Intl2.default)(ComposedComponent, _lang2.default));
};

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = function (ExtendedComponent) {
	var _class, _temp;

	return _temp = _class = function (_ExtendedComponent) {
		_inherits(ValidationComponent, _ExtendedComponent);

		function ValidationComponent() {
			_classCallCheck(this, ValidationComponent);

			return _possibleConstructorReturn(this, (ValidationComponent.__proto__ || Object.getPrototypeOf(ValidationComponent)).apply(this, arguments));
		}

		_createClass(ValidationComponent, [{
			key: 'validate',
			value: function validate(key, value) {
				var validators = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _validation2.default;
				var validationActions = this.props.validationActions;
				// Defer validation to prevent over-eager validation errors

				return window.setTimeout(function () {
					validationActions.updateValidationErrors(_defineProperty({}, key, validators[key].validate(value)));
				}, 100);
			}
		}, {
			key: 'isValid',
			value: function isValid(key, value) {
				var validators = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _validation2.default;

				this.validate(key, value, validators);
				return !validators[key].validate(value).length > 0;
			}
		}, {
			key: 'isEveryValid',
			value: function isEveryValid() {
				var _this2 = this;

				if (this.validatedFields.length === 0) {
					return true;
				}
				return this.validatedFields.map(function (field) {
					return !_this2.hasErrors(field);
				}).every(function (isValid) {
					return isValid;
				});
			}
		}, {
			key: 'hasErrors',
			value: function hasErrors(key) {
				var errors = this.props.errors;

				return key ? errors && !!errors[key] && !!errors[key].length : errors && !!Object.keys(errors).length;
			}
		}, {
			key: 'clearValidation',
			value: function clearValidation(key) {
				var validationActions = this.props.validationActions;

				validationActions.updateValidationErrors(_defineProperty({}, key, []));
			}
		}]);

		return ValidationComponent;
	}(ExtendedComponent), _class.propTypes = Object.assign({}, ExtendedComponent.propTypes, {
		errors: _propTypes2.default.object.isRequired
	}), _class.defaultProps = Object.assign({}, ExtendedComponent.defaultProps, {
		errors: {}
	}), _temp;
};

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _validation = __webpack_require__(375);

var _validation2 = _interopRequireDefault(_validation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.APP_currentPage = APP_currentPage;
exports.APP_locale = APP_locale;
exports.APP_network = APP_network;
exports.APP_deviceType = APP_deviceType;

var _actionTypes = __webpack_require__(32);

var actionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var appActionTypes = actionTypes.appActionTypes;

/**
 * Current page reducer: update current page
 * @param {string} state - current state
 * @param {object} action
 * @return {string} next state
 */
function APP_currentPage() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	var action = arguments[1];

	switch (action.type) {
		case appActionTypes.UPDATE_CURRENT_PAGE:
			return action.currentPage;
		default:
			return state;
	}
}

/**
 * Locale reducer: update locale
 * @param {string} state - current state
 * @param {object} action
 * @return {string} next state
 */
function APP_locale() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	var action = arguments[1];

	switch (action.type) {
		case appActionTypes.UPDATE_LOCALE:
			return action.locale;
		default:
			return state;
	}
}

/**
 * Network reducer: update network connectivity status
 * @param {string} state - current state
 * @param {object} action
 * @return {string} next state
 */
function APP_network() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	var action = arguments[1];

	switch (action.type) {
		case appActionTypes.UPDATE_NETWORK_STATUS:
			return action.online === true ? 'online' : 'offline';
		default:
			return state;
	}
}

/**
 * Device type reducer: update device type
 * @param {string} state - current state
 * @param {object} action
 * @return {string} next state
 */
function APP_deviceType() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	var action = arguments[1];

	switch (action.type) {
		case appActionTypes.UPDATE_DEVICE_TYPE:
			return action.deviceType;
		default:
			return state;
	}
}

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.AUTH_authToken = AUTH_authToken;

var _actionTypes = __webpack_require__(32);

var actionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var authActionTypes = actionTypes.authActionTypes;

/**
 * Auth reducer: update authorisation (access) token
 * @param {string} state - current state
 * @param {object} action
 * @return {string} next state
 */
function AUTH_authToken() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	var action = arguments[1];

	switch (action.type) {
		case authActionTypes.UPDATE_AUTH_TOKEN:
			return action.authToken;
		default:
			return state;
	}
}

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.FACEBOOK_loginStatus = FACEBOOK_loginStatus;
exports.FACEBOOK_firstName = FACEBOOK_firstName;
exports.FACEBOOK_lastName = FACEBOOK_lastName;
exports.FACEBOOK_email = FACEBOOK_email;
exports.FACEBOOK_accessToken = FACEBOOK_accessToken;

var _actionTypes = __webpack_require__(32);

var actionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var facebookActionTypes = actionTypes.facebookActionTypes;

/**
 * Facebook login status reducer: update facebook login status
 * @param {object} state - current state
 * @param {object} action
 * @return {object} next state
 */
function FACEBOOK_loginStatus() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	var action = arguments[1];

	switch (action.type) {
		case facebookActionTypes.UPDATE_FACEBOOK_LOGIN_STATUS:
			return _extends({}, action.facebookLoginStatus);
		default:
			return state;
	}
}

/**
 * First name reducer: update facebook data first name
 * @param {string} state - current state
 * @param {object} action
 * @return {string} next state
 */
function FACEBOOK_firstName() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	var action = arguments[1];

	switch (action.type) {
		case facebookActionTypes.UPDATE_FACEBOOK_FIRST_NAME:
			return action.firstName;
		default:
			return state;
	}
}

/**
 * Last name reducer: update facebook data last name
 * @param {string} state - current state
 * @param {object} action
 * @return {string} next state
 */
function FACEBOOK_lastName() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	var action = arguments[1];

	switch (action.type) {
		case facebookActionTypes.UPDATE_FACEBOOK_LAST_NAME:
			return action.lastName;
		default:
			return state;
	}
}

/**
 * Email reducer: update facebook data email
 * @param {string} state - current state
 * @param {object} action
 * @return {string} next state
 */
function FACEBOOK_email() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	var action = arguments[1];

	switch (action.type) {
		case facebookActionTypes.UPDATE_FACEBOOK_EMAIL:
			return action.email;
		default:
			return state;
	}
}

/**
 * Access Token reducer: update facebook data access Token
 * @param {string} state - current state
 * @param {object} action
 * @return {string} next state
 */
function FACEBOOK_accessToken() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	var action = arguments[1];

	switch (action.type) {
		case facebookActionTypes.UPDATE_FACEBOOK_ACCESS_TOKEN:
			return action.accessToken;
		default:
			return state;
	}
}

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.isOffline = exports.getRecoverableErrorType = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.HTTP_request = HTTP_request;

var _actionTypes = __webpack_require__(32);

var actionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var httpActionTypes = actionTypes.httpActionTypes;

/**
 * Request sub-reducer: update the nested request object
 * @param {object} state - current state
 * @param {object} action
 * @return {object} next state
 */
function request() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	var action = arguments[1];

	switch (action.type) {
		case httpActionTypes.FACEBOOK_REQUEST_MADE:
		case httpActionTypes.IAM_REQUEST_MADE:
			return _defineProperty({}, action.request, _extends({}, state, {
				isInflight: true
			}));
		case httpActionTypes.FACEBOOK_REQUEST_SUCCESS:
		case httpActionTypes.IAM_REQUEST_SUCCESS:
			return _defineProperty({}, action.request, _extends({}, state, {
				isInflight: false,
				isError: false
			}));
		case httpActionTypes.FACEBOOK_REQUEST_ERROR:
		case httpActionTypes.IAM_REQUEST_ERROR:
			return _defineProperty({}, action.request, _extends({}, state, {
				isInflight: false,
				isError: action.error
			}));

	}
};

/**
 * HTTP request reducer: update HTTP request branch
 * @param {object} state - current state
 * @param {object} action
 * @return {object} next state
 */
function HTTP_request() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	var action = arguments[1];

	switch (action.type) {
		case httpActionTypes.FACEBOOK_REQUEST_MADE:
		case httpActionTypes.IAM_REQUEST_MADE:
		case httpActionTypes.FACEBOOK_REQUEST_SUCCESS:
		case httpActionTypes.IAM_REQUEST_SUCCESS:
		case httpActionTypes.FACEBOOK_REQUEST_ERROR:
		case httpActionTypes.IAM_REQUEST_ERROR:
			return _extends({}, state, request(state[action.request], action));
		default:
			return state;
	}
}

/**
 * UI selectors
 */

/**
 * getRecoverableErrorType
 * @desc Get a recoverable error type key for intl lookup, based on the error key and request
 * @param {object} state - current state
 * @param {string} request - request
 * @param {string} networkStatus - navigator.onLine value
 * @return {string} error message key
 */
var getRecoverableErrorType = exports.getRecoverableErrorType = function getRecoverableErrorType(state, request, networkStatus) {
	if (!state) {
		return false;
	}
	switch (request) {
		case 'facebook_connect':
			var _isOffline = isOffline(state, networkStatus);
			var newState = state === 'fb_user_denied_email' ? 'fb_user_denied_email' : 'facebook_connect';
			return _isOffline || newState;
		case 'iam_jg_login':
			return isOffline(state, networkStatus) || state;
		case 'iam_facebook_login':
			return isOffline(state, networkStatus) || state;
		case 'iam_email_check':
			return isOffline(state, networkStatus) || state;
		case 'iam_register':
			return isOffline(state, networkStatus) || state;
		default:
			return true;
	}
};

var isOffline = exports.isOffline = function isOffline(state, networkStatus) {
	return state === 'iam_request_timeout' && networkStatus === 'offline' ? 'offline' : false;
};

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.emailAddress = emailAddress;
exports.password = password;
exports.firstName = firstName;
exports.lastName = lastName;
exports.fbLoginScope = fbLoginScope;
exports.propsFromHost = propsFromHost;

var _actionTypes = __webpack_require__(32);

var actionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var userActionTypes = actionTypes.userActionTypes;

/*+++++++++++++++++++++++++++
/+ EMAIL PAGE
+++++++++++++++++++++++++++*/

/**
 * Email address reducer: update state client email address
 * @param {string} state - current state
 * @param {object} action
 * @return {string} next state
 */
function emailAddress() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	var action = arguments[1];

	switch (action.type) {
		case userActionTypes.UPDATE_EMAIL_ADDRESS:
			return action.emailAddress;
		default:
			return state;
	}
}

/*+++++++++++++++++++++++++++
 /+ PASSWORD PAGE
 +++++++++++++++++++++++++++*/

/**
 * password reducer: update state client password
 * @param {string} state - current state
 * @param {object} action
 * @return {string} next state
 */
function password() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	var action = arguments[1];

	switch (action.type) {
		case userActionTypes.UPDATE_PASSWORD:
			return action.password;
		default:
			return state;
	}
}

/*+++++++++++++++++++++++++++
 /+ REGISTER PAGE
 +++++++++++++++++++++++++++*/

/**
 * firstName reducer: update state client firstName
 * @param {string} state - current state
 * @param {object} action
 * @return {string} next state
 */
function firstName() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	var action = arguments[1];

	switch (action.type) {
		case userActionTypes.UPDATE_FIRSTNAME:
			return action.firstName;
		default:
			return state;
	}
}

/**
 * lastName reducer: update state client lastName
 * @param {string} state - current state
 * @param {object} action
 * @return {string} next state
 */
function lastName() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	var action = arguments[1];

	switch (action.type) {
		case userActionTypes.UPDATE_LASTNAME:
			return action.lastName;
		default:
			return state;
	}
}

function fbLoginScope() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	var action = arguments[1];

	switch (action.type) {
		case userActionTypes.UPDATE_FB_LOGIN_SCOPE:
			return action.fbLoginScope;
		default:
			return state;
	}
}

function propsFromHost() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	var action = arguments[1];

	switch (action.type) {
		case userActionTypes.SET_PROPS_FROM_HOST:
			return action.propsFromHost;
		default:
			return state;
	}
}

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.VALIDATION_errors = VALIDATION_errors;

var _actionTypes = __webpack_require__(32);

var actionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var validationActionTypes = actionTypes.validationActionTypes;

/**
 * Update errors from validation
 * @param {object} state
 * @param {object} action
 * @return {object} state
 */
function VALIDATION_errors() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	var action = arguments[1];

	switch (action.type) {
		case validationActionTypes.UPDATE_VALIDATION_ERRORS:
			var nextState = Object.assign({}, state);

			for (var key in action.errors) {
				if (action.errors.hasOwnProperty(key)) {
					var errors = action.errors[key];

					if (errors.length) {
						nextState[key] = errors;
					} else {
						delete nextState[key];
					}
				}
			}
			return nextState;

		default:
			return state;
	}
}

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRouter = __webpack_require__(18);

exports.default = _reactRouter.browserHistory;

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var join = exports.join = function join(first) {
	for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		rest[_key - 1] = arguments[_key];
	}

	// we will send an empty string by default
	var path = first || '';

	// remove forward slash suffix
	if (path.length > 1 && path.substr(path.length - 1) === '/') {
		path = path.slice(0, -1);
	}

	// if there is only one parameter then return it as the path
	if (rest.length === 0) {
		return path;
	}

	// process the rest of the url parts
	var parts = rest.filter(function (part) {
		return typeof part === 'string';
	}).map(function (part) {
		return part.replace(/^\/|\/$/, '');
	}) // trim forward slashes
	.filter(function (part) {
		return part.length > 0;
	}); // remove empty strings

	// if after processing the parts there isn't anything to add then return
	if (parts.length === 0) {
		return path;
	}

	parts = parts.join('/');

	path += path === '/' || path === '' ? parts : '/' + parts;

	return path;
};

exports.default = {
	join: join
};

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.setRoute = undefined;

var _utils = __webpack_require__(22);

var _queryString = __webpack_require__(170);

var qs = (0, _queryString.queryStringParse)(location.search);

var setRoute = exports.setRoute = function setRoute(updateRoute, router) {
	var queries = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : qs;

	return updateRoute ? function (route) {
		return updateRoute(route, (0, _utils.getQueryString)(queries, 'iamUrl'));
	} : function (route) {
		return router.push(route + (0, _utils.getQueryString)(queries, 'iamUrl'));
	};
};

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = configureStore;

var _redux = __webpack_require__(21);

var _reduxThunk = __webpack_require__(317);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reducers = __webpack_require__(113);

var _reducers2 = _interopRequireDefault(_reducers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var debugEnv = "production" !== 'production';

/**
 * Configure the store with middleware:
 * thunk - thunk actions (actions that return a function)
 * createLogger - log action dispatch in browser console [LOCAL env only]
 * devToolsExtension - log action dispatch in dev tools extension [LOCAL env only]
 */

function configureStore(initialState) {
	return debugEnv ? (0, _redux.compose)((0, _redux.applyMiddleware)(_reduxThunk2.default), window.devToolsExtension ? window.devToolsExtension() : function (f) {
		return f;
	})(_redux.createStore)(_reducers2.default, initialState) : (0, _redux.compose)((0, _redux.applyMiddleware)(_reduxThunk2.default))(_redux.createStore)(_reducers2.default, initialState);
}

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.passPropsTo = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var passPropsTo = exports.passPropsTo = function passPropsTo(Component, props) {
	return function (_React$Component) {
		_inherits(NewComponent, _React$Component);

		function NewComponent() {
			_classCallCheck(this, NewComponent);

			return _possibleConstructorReturn(this, (NewComponent.__proto__ || Object.getPrototypeOf(NewComponent)).apply(this, arguments));
		}

		_createClass(NewComponent, [{
			key: 'render',
			value: function render() {
				return (0, _react.createElement)(Component, Object.assign({}, this.props, props));
			}
		}]);

		return NewComponent;
	}(_react2.default.Component);
};

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.hasPreviouslyLoggedIn = undefined;

var _ = __webpack_require__(22);

var _cookies = new _.Cookies();

/**
 * Determines if the current user has previously logged into JG
 * @param {string} cookies - instance of the Cookies util class (for unit testing)
 */
var hasPreviouslyLoggedIn = exports.hasPreviouslyLoggedIn = function hasPreviouslyLoggedIn() {
	var cookies = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _cookies;

	var userMetadata = cookies.JgUserMetadataCookie;
	return {
		hasLoggedIn: !!userMetadata.JGEmail,
		emailAddress: userMetadata.JGEmail || '',
		firstName: userMetadata.JGFirstName || ''
	};
};

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.makeRequest = exports.iamBaseHeader = undefined;

var _config = __webpack_require__(46);

var _http = __webpack_require__(598);

/**
 * CONSTANTS
 */

var iamBaseHeader = exports.iamBaseHeader = {
	'Content-Type': 'application/json',
	'Accept': 'application/json',
	'Cache-Control': 'no-cache'
};

var makeRequest = exports.makeRequest = function makeRequest(url, action, options) {
	var deadline = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _config.config.requestTimeoutDeadline;
	return (0, _http.makeRequest)(url, action, options, deadline);
};

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.logError = undefined;

var _errors = __webpack_require__(247);

var logError = exports.logError = function logError(err) {
	var _dnaErrorLogger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _errors.logError;

	var error = new Error('Cannot find the cause of error');

	if (err instanceof Error || err instanceof TypeError) {
		error = err;
	} else {
		error.message = err && err.message || error.message;
	}
	_dnaErrorLogger(error);
};

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var getQueryString = exports.getQueryString = function getQueryString(queries) {
	var queryKeys = Object.keys(queries);
	if (!queryKeys.length) {
		return '';
	}
	return Object.keys(queries).reduce(function (string, key, i) {
		return '' + string + (i !== 0 ? '&' : '') + key + '=' + queries[key];
	}, '?');
};

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var pollFor = function pollFor(propName, msInterval, resolve) {
	window[propName] ? setTimeout(resolve, 10) : setTimeout(function () {
		return pollFor(propName, msInterval, resolve);
	}, 100);
};

exports.default = function (propName, msInterval) {
	return new Promise(function (resolve, reject) {
		pollFor(propName, msInterval, resolve);
	});
};

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}(); //TODO: Setup A GO deployment to test integration


var _utils = __webpack_require__(142);

var _cookieDataEnricher = __webpack_require__(399);

var _cookieDataEnricher2 = _interopRequireDefault(_cookieDataEnricher);

var _dataSender = __webpack_require__(402);

var _dataSender2 = _interopRequireDefault(_dataSender);

var _featureDetection = __webpack_require__(141);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var Analytics = function () {
    function Analytics(options, request) {
        _classCallCheck(this, Analytics);

        if (!request && (0, _featureDetection.isServer)()) {
            throw "Request object is required when calling library from the server";
        }

        this._browserInfo = (0, _utils.getBrowserInfo)(request);

        this._dataSender = new _dataSender2.default((0, _featureDetection.isServer)() ? options.apiUrl + "-server" : options.apiUrl);
        if (false) {
            var Validator = require('./lib/validator.js').Validator;
            this._validator = new Validator();
        }
        this._cookieDataEnricher = new _cookieDataEnricher2.default(this._browserInfo.cookies, (0, _utils.getCurrentEnvironment)(this._browserInfo.url));

        this._isDebug = (0, _utils.queryStringToObject)(this._browserInfo.url).debug_koala ? (0, _utils.queryStringToObject)(this._browserInfo.url).debug_koala.toLowerCase() === 'true' : options.isDebug || false;
    }

    //TODO: Chore: This would be better implemented as a promise
    //TODO: Feature: Cast core fields to lower capitals


    _createClass(Analytics, [{
        key: 'track',
        value: function track(data) {
            var _this = this;

            if (this._eventProperties) {
                data = (0, _utils.extend)(data, this._eventProperties);
            }

            if (this._isDebug && this._validator) {
                return this._validator.validate(data).then(function (validationError) {
                    if (validationError) {
                        console.error('Analytics - ' + validationError);
                        data.failed_validation = true;
                        data.failed_validation_message = validationError;
                    }
                    return data;
                }).then(function (data) {
                    return _this._send(data);
                });
            }

            return this._send(data);
        }
    }, {
        key: '_send',
        value: function _send(data) {
            var _this2 = this;

            data = this._cookieDataEnricher.enrich(data);
            data.device_timestamp = new Date().getTime();
            data.capture_library_version = '1.1.22';
            data.capture_library_type = (0, _featureDetection.isServer)() ? "koala_server" : "koala_client";
            (0, _utils.setValueOrEmptyString)("url", this._browserInfo.url, data);
            (0, _utils.setValueOrEmptyString)("referrer", this._browserInfo.referer, data);
            (0, _utils.setValueOrEmptyString)("user_agent", this._browserInfo.user_agent, data);

            return this._dataSender.sendData(data).then(function (data) {
                if (_this2._isDebug == true) {
                    console.info('DEBUG: Analytics - Data sent ' + data);
                };
                return data;
            });
        }
    }, {
        key: 'set',
        value: function set(eventProperties) {
            this._eventProperties = eventProperties;
        }
    }, {
        key: 'importSchema',
        value: function importSchema(schema) {
            if (this._validator) {
                this._validator.importSchema(schema);
            }
        }

        /* -------------------------------------------- */
        /*              Utility Methods                 */
        /* -------------------------------------------- */

    }, {
        key: 'trackPage',
        value: function trackPage(data) {}
    }, {
        key: 'trackLink',
        value: function trackLink(link, data) {}
    }]);

    return Analytics;
}();

exports.default = Analytics;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _analytics = __webpack_require__(395);

var _analytics2 = _interopRequireDefault(_analytics);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

module.exports = _analytics2.default;

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _cookieBrowserApi = __webpack_require__(398);

var cookieBrowserApi = _interopRequireWildcard(_cookieBrowserApi);

var _cookieInMemoryApi = __webpack_require__(400);

var _cookieInMemoryApi2 = _interopRequireDefault(_cookieInMemoryApi);

var _cookieNames = __webpack_require__(140);

var _featureDetection = __webpack_require__(141);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var CookieApi = function () {
    function CookieApi(cookies, env) {
        _classCallCheck(this, CookieApi);

        if ((0, _featureDetection.isServer)()) {
            cookies = cookies || '';
            this._api = new _cookieInMemoryApi2.default(cookies);
        } else {
            this._api = cookieBrowserApi;
        }
        this._env = env;
    }

    _createClass(CookieApi, [{
        key: 'getAnalyticsCookie',
        value: function getAnalyticsCookie() {
            return this._api.getAnalyticsCookie();
        }
    }, {
        key: 'getAbCookie',
        value: function getAbCookie() {
            return this._api.getAbCookie();
        }
    }, {
        key: 'getKissmetricsCookie',
        value: function getKissmetricsCookie() {
            return this._api.getKissmetricsCookie();
        }
    }, {
        key: 'getCookieString',
        value: function getCookieString() {
            return this._api.getCookieString();
        }
    }, {
        key: 'getAuthUserEmail',
        value: function getAuthUserEmail() {
            var authCookieEnvMap = {
                'PROD': _cookieNames.COOKIE_NAMES.GGASPXAUTH_PROD_ID,
                'STAGING': _cookieNames.COOKIE_NAMES.GGASPXAUTH_STAGING_ID,
                'DEV': _cookieNames.COOKIE_NAMES.GGASPXAUTH_DEV_ID,
                'SANDBOX': _cookieNames.COOKIE_NAMES.GGASPXAUTH_SANDBOX_ID
            };

            return this._api.getAuthUserEmail(authCookieEnvMap[this._env]);
        }
    }, {
        key: 'getKOALAEmailIdentity',
        value: function getKOALAEmailIdentity() {
            return this._api.getKOALAEmailIdentity();
        }
    }, {
        key: 'setAnalyticsCookie',
        value: function setAnalyticsCookie(logged_out_cookie, logged_in_cookie) {
            this._api.setAnalyticsCookie(logged_out_cookie, logged_in_cookie);
        }
    }, {
        key: 'setKOALAEmailIdentity',
        value: function setKOALAEmailIdentity(email) {
            this._api.setKOALAEmailIdentity(email);
        }
    }, {
        key: 'setCookie',
        value: function setCookie(name, value) {
            this._api.setCookie(name, value);
        }
    }]);

    return CookieApi;
}();

exports.default = CookieApi;

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getAnalyticsCookie = getAnalyticsCookie;
exports.getAbCookie = getAbCookie;
exports.getKissmetricsCookie = getKissmetricsCookie;
exports.getCookieString = getCookieString;
exports.getAuthUserEmail = getAuthUserEmail;
exports.getKOALAEmailIdentity = getKOALAEmailIdentity;
exports.setAnalyticsCookie = setAnalyticsCookie;
exports.setKOALAEmailIdentity = setKOALAEmailIdentity;
exports.setCookie = setCookie;

var _jsCookie = __webpack_require__(630);

var Cookies = _interopRequireWildcard(_jsCookie);

var _cookieNames = __webpack_require__(140);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

var multiValueCookieParser = Cookies.withConverter(function (value, name) {
    return _readMultipleValues(value);
});

function _readMultipleValues(value) {
    var cookieValues = {};
    value.split('&').forEach(function (part) {
        var _keyVal = part.split('=');
        cookieValues[_keyVal[0]] = _keyVal[1];
    });
    return cookieValues;
}

function getAnalyticsCookie() {
    var cookie = multiValueCookieParser.get(_cookieNames.COOKIE_NAMES.JG_ANALYTICS_COOKIE_NAME);
    return cookie ? cookie : {};
}

function getAbCookie() {
    var cookie = multiValueCookieParser.get(_cookieNames.COOKIE_NAMES.JG_ANALYTICS_AB);
    cookie = cookie ? cookie : {};
    return cookie.id;
}

function getKissmetricsCookie() {
    return Cookies.get(_cookieNames.COOKIE_NAMES.KM);
}

function getCookieString() {
    return Cookies.get();
}

function getAuthUserEmail(envCookieName) {
    var cookie = multiValueCookieParser.get(envCookieName);
    cookie = cookie ? cookie : {};
    return cookie.Email;
}

function getKOALAEmailIdentity() {
    return Cookies.get(_cookieNames.COOKIE_NAMES.KOALA_EmailIdentity);
}

function setAnalyticsCookie(logged_out_cookie, logged_in_cookie) {
    if (!logged_in_cookie) {
        logged_in_cookie = '00000000-0000-0000-0000-000000000000';
    };
    if (!logged_out_cookie) {
        logged_out_cookie = '00000000-0000-0000-0000-000000000000';
    };

    setCookie(_cookieNames.COOKIE_NAMES.JG_ANALYTICS_COOKIE_NAME, 'logged_in_guid=' + logged_in_cookie + '&logged_out_guid=' + logged_out_cookie); //Backward Compatibility
}

function setKOALAEmailIdentity(email) {
    setCookie(_cookieNames.COOKIE_NAMES.KOALA_EmailIdentity, email);
}

function setCookie(name, value) {
    Cookies.set(name, value, { expires: 3650 });
}

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _cookieApi = __webpack_require__(397);

var _cookieApi2 = _interopRequireDefault(_cookieApi);

var _utils = __webpack_require__(142);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var CookieDataEnricher = function () {
    function CookieDataEnricher(cookies, env) {
        _classCallCheck(this, CookieDataEnricher);

        this._cookieApi = new _cookieApi2.default(cookies, env);
    }

    _createClass(CookieDataEnricher, [{
        key: 'enrich',
        value: function enrich(eventData) {
            this.setLoggedOutGuid(eventData);
            (0, _utils.setValueOrEmptyString)("logged_in_guid", this._cookieApi.getAnalyticsCookie().logged_in_guid, eventData);
            (0, _utils.setValueOrEmptyString)("ab_logged_in_guid", this._cookieApi.getAbCookie(), eventData);
            this.setUserIdentity(eventData);
            eventData = this._setKissmetricsCookieProperties(eventData);
            return eventData;
        }
    }, {
        key: 'setLoggedOutGuid',
        value: function setLoggedOutGuid(eventData, setAnalyticsCookie) {
            var logged_out_guid = this._cookieApi.getAnalyticsCookie().logged_out_guid;
            if (!logged_out_guid) {
                logged_out_guid = (0, _utils.generateGUID)();
                typeof setAnalyticsCookie === 'function' ? setAnalyticsCookie(logged_out_guid, '') : this._cookieApi.setAnalyticsCookie(logged_out_guid, '');
            }
            (0, _utils.setValueOrEmptyString)("logged_out_guid", logged_out_guid, eventData);
        }
    }, {
        key: 'setUserIdentity',
        value: function setUserIdentity(eventData, setUserIdentityCookie) {
            var authEmail = this._cookieApi.getAuthUserEmail();
            var loggedIn = 0;
            if (authEmail) {
                loggedIn = 1;
            } else {
                authEmail = this._cookieApi.getKOALAEmailIdentity() || this._cookieApi.getKissmetricsCookie();
                if (authEmail && authEmail.indexOf('@') === -1) {
                    authEmail = null;
                }
            }

            if (authEmail) {
                typeof setUserIdentityCookie === 'function' ? setUserIdentityCookie(authEmail) : this._cookieApi.setKOALAEmailIdentity(authEmail);
            }

            (0, _utils.setValueOrEmptyString)("is_logged_in", loggedIn, eventData);
            (0, _utils.setValueOrEmptyString)("email", authEmail, eventData);
        }
    }, {
        key: '_setKissmetricsCookieProperties',
        value: function _setKissmetricsCookieProperties(eventData) {
            var cookieValue = this._cookieApi.getKissmetricsCookie();
            if (typeof cookieValue !== 'string') {
                return eventData;
            }

            if (cookieValue.indexOf('@') === -1) {
                (0, _utils.setValueOrEmptyString)("km_id", cookieValue, eventData);
            } else {
                (0, _utils.setValueOrEmptyString)("km_email", cookieValue, eventData);
            }

            return eventData;
        }
    }]);

    return CookieDataEnricher;
}();

exports.default = CookieDataEnricher;

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _cookieNames = __webpack_require__(140);

var _cookies = __webpack_require__(601);

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var CookieInMemoryApi = function () {
    function CookieInMemoryApi(cookies) {
        _classCallCheck(this, CookieInMemoryApi);

        this._cookies = new _cookies.Cookies(_cookieNames.COOKIE_NAMES.JG_ANALYTICS_COOKIE_NAME, cookies);
    }

    _createClass(CookieInMemoryApi, [{
        key: 'getAnalyticsCookie',
        value: function getAnalyticsCookie() {
            return this._cookies.analyticsCookie;
        }
    }, {
        key: 'getAbCookie',
        value: function getAbCookie() {
            return this._cookies.JgAbLoggedInCookie.value;
        }
    }, {
        key: 'getKissmetricsCookie',
        value: function getKissmetricsCookie() {
            return this._cookies.cookies.km_ai;
        }
    }, {
        key: 'getCookieString',
        value: function getCookieString() {
            return this._cookies.cookiesSource;
        }
    }, {
        key: 'getAuthUserEmail',
        value: function getAuthUserEmail(envCookieName) {
            return this._cookies.cookieToObject(envCookieName).Email;
        }
    }, {
        key: 'getKOALAEmailIdentity',
        value: function getKOALAEmailIdentity() {
            return this._cookies.cookies[_cookieNames.COOKIE_NAMES.KOALA_EmailIdentity];
        }

        //TODO Feature: Node how to pass the cookies back

    }, {
        key: 'setAnalyticsCookie',
        value: function setAnalyticsCookie(logged_out_cookie, logged_in_cookie) {}
    }, {
        key: 'setKOALAEmailIdentity',
        value: function setKOALAEmailIdentity(email) {}
    }, {
        key: 'setCookie',
        value: function setCookie(name, value) {}
    }]);

    return CookieInMemoryApi;
}();

exports.default = CookieInMemoryApi;

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.xhrSend = xhrSend;
exports.beaconSend = beaconSend;
function xhrSend(apiUrl, data) {

    var xhr = new XMLHttpRequest();
    xhr.open('POST', apiUrl);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.send(data);
}

function beaconSend(apiUrl, encodedData) {
    var beacon = new Image(1, 1);
    beacon.src = apiUrl + "?data=" + encodedData;
}

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _utils = __webpack_require__(142);

var _featureDetection = __webpack_require__(141);

var _httpsShim = __webpack_require__(403);

var _dataDispatcher = __webpack_require__(401);

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var DataSender = function () {
    function DataSender(apiUrl) {
        _classCallCheck(this, DataSender);

        this._apiUrl = apiUrl;
    }

    _createClass(DataSender, [{
        key: 'sendData',
        value: function sendData(data) {
            var _this = this;

            var that = this;

            return new Promise(function (resolve, reject) {
                if (!_this._apiUrl) {
                    reject('Koala - Data sender: missing apiUrl');
                }

                data = JSON.stringify(data);

                var utfEightString = unescape(encodeURIComponent(data));
                var encodedData = encodeURIComponent((0, _utils.encodeBase64)(utfEightString));

                if ((0, _featureDetection.isServer)()) {
                    (0, _httpsShim.getHttps)().get(_this._apiUrl + "?data=" + encodedData, function (res) {
                        resolve(data);
                    }).on('error', function (e) {
                        reject(e);
                    });
                } else {
                    if ("string" === typeof encodedData && 4000 <= encodedData.length) {
                        (0, _dataDispatcher.xhrSend)(_this._apiUrl, data);
                        resolve(data);
                    } else {
                        //TODO: write a unit test to see if this works now.
                        (0, _dataDispatcher.beaconSend)(_this._apiUrl, encodedData);
                        resolve(data);
                    }
                }
            });
        }
    }]);

    return DataSender;
}();

exports.default = DataSender;

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
   value: true
});
exports.init = init;
exports.getHttps = getHttps;
var _https;

function init(https) {
   _https = https;
}

function getHttps() {
   if (_https) {
      return _https;
   }
   return {};
}

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*! Raygun4js - v1.18.4 - 2015-11-18
* https://github.com/MindscapeHQ/raygun4js
* Copyright (c) 2015 MindscapeHQ; Licensed MIT */
(function (window, undefined) {

    var TraceKit = {};
    var _oldTraceKit = window.TraceKit;

    // global reference to slice
    var _slice = [].slice;
    var UNKNOWN_FUNCTION = '?';

    /**
     * _has, a better form of hasOwnProperty
     * Example: _has(MainHostObject, property) === true/false
     *
     * @param {Object} host object to check property
     * @param {string} key to check
     */
    function _has(object, key) {
        return Object.prototype.hasOwnProperty.call(object, key);
    }

    function _isUndefined(what) {
        return typeof what === 'undefined';
    }

    /**
     * TraceKit.noConflict: Export TraceKit out to another variable
     * Example: var TK = TraceKit.noConflict()
     */
    TraceKit.noConflict = function noConflict() {
        window.TraceKit = _oldTraceKit;
        return TraceKit;
    };

    /**
     * TraceKit.wrap: Wrap any function in a TraceKit reporter
     * Example: func = TraceKit.wrap(func);
     *
     * @param {Function} func Function to be wrapped
     * @return {Function} The wrapped func
     */
    TraceKit.wrap = function traceKitWrapper(func) {
        function wrapped() {
            try {
                return func.apply(this, arguments);
            } catch (e) {
                TraceKit.report(e);
                throw e;
            }
        }
        return wrapped;
    };

    /**
     * TraceKit.report: cross-browser processing of unhandled exceptions
     *
     * Syntax:
     *   TraceKit.report.subscribe(function(stackInfo) { ... })
     *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
     *   TraceKit.report(exception)
     *   try { ...code... } catch(ex) { TraceKit.report(ex); }
     *
     * Supports:
     *   - Firefox: full stack trace with line numbers, plus column number
     *              on top frame; column number is not guaranteed
     *   - Opera:   full stack trace with line and column numbers
     *   - Chrome:  full stack trace with line and column numbers
     *   - Safari:  line and column number for the top frame only; some frames
     *              may be missing, and column number is not guaranteed
     *   - IE:      line and column number for the top frame only; some frames
     *              may be missing, and column number is not guaranteed
     *
     * In theory, TraceKit should work on all of the following versions:
     *   - IE5.5+ (only 8.0 tested)
     *   - Firefox 0.9+ (only 3.5+ tested)
     *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
     *     Exceptions Have Stacktrace to be enabled in opera:config)
     *   - Safari 3+ (only 4+ tested)
     *   - Chrome 1+ (only 5+ tested)
     *   - Konqueror 3.5+ (untested)
     *
     * Requires TraceKit.computeStackTrace.
     *
     * Tries to catch all unhandled exceptions and report them to the
     * subscribed handlers. Please note that TraceKit.report will rethrow the
     * exception. This is REQUIRED in order to get a useful stack trace in IE.
     * If the exception does not reach the top of the browser, you will only
     * get a stack trace from the point where TraceKit.report was called.
     *
     * Handlers receive a stackInfo object as described in the
     * TraceKit.computeStackTrace docs.
     */
    TraceKit.report = function reportModuleWrapper() {
        var handlers = [],
            lastException = null,
            lastExceptionStack = null;

        /**
         * Add a crash handler.
         * @param {Function} handler
         */
        function subscribe(handler) {
            installGlobalHandler();
            handlers.push(handler);
        }

        /**
         * Remove a crash handler.
         * @param {Function} handler
         */
        function unsubscribe(handler) {
            for (var i = handlers.length - 1; i >= 0; --i) {
                if (handlers[i] === handler) {
                    handlers.splice(i, 1);
                }
            }
        }

        /**
         * Dispatch stack information to all handlers.
         * @param {Object.<string, *>} stack
         */
        function notifyHandlers(stack, windowError) {
            var exception = null;
            if (windowError && !TraceKit.collectWindowErrors) {
                return;
            }
            for (var i in handlers) {
                if (_has(handlers, i)) {
                    try {
                        handlers[i].apply(null, [stack].concat(_slice.call(arguments, 2)));
                    } catch (inner) {
                        exception = inner;
                    }
                }
            }

            if (exception) {
                throw exception;
            }
        }

        var _oldOnerrorHandler, _onErrorHandlerInstalled;

        /**
         * Ensures all global unhandled exceptions are recorded.
         * Supported by Gecko and IE.
         * @param {string} message Error message.
         * @param {string} url URL of script that generated the exception.
         * @param {(number|string)} lineNo The line number at which the error
         * occurred.
         */
        function traceKitWindowOnError(message, url, lineNo, columnNo, errorObj) {
            var stack = null;

            if (errorObj) {
                stack = TraceKit.computeStackTrace(errorObj);
            } else {
                if (lastExceptionStack) {
                    TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(lastExceptionStack, url, lineNo, message);
                    stack = lastExceptionStack;
                    lastExceptionStack = null;
                    lastException = null;
                } else {
                    var location = {
                        'url': url,
                        'line': lineNo,
                        'column': columnNo
                    };
                    location.func = TraceKit.computeStackTrace.guessFunctionName(location.url, location.line);
                    location.context = TraceKit.computeStackTrace.gatherContext(location.url, location.line);
                    stack = {
                        'mode': 'onerror',
                        'message': message,
                        'url': document.location.href,
                        'stack': [location],
                        'useragent': navigator.userAgent
                    };
                }
            }

            notifyHandlers(stack, 'from window.onerror');

            if (_oldOnerrorHandler) {
                return _oldOnerrorHandler.apply(this, arguments);
            }

            return false;
        }

        function installGlobalHandler() {
            if (_onErrorHandlerInstalled === true) {
                return;
            }
            _oldOnerrorHandler = window.onerror;
            window.onerror = traceKitWindowOnError;
            _onErrorHandlerInstalled = true;
        }

        /**
         * Reports an unhandled Error to TraceKit.
         * @param {Error} ex
         */
        function report(ex) {
            var args = _slice.call(arguments, 1);
            if (lastExceptionStack) {
                if (lastException === ex) {
                    return; // already caught by an inner catch block, ignore
                } else {
                    var s = lastExceptionStack;
                    lastExceptionStack = null;
                    lastException = null;
                    notifyHandlers.apply(null, [s, null].concat(args));
                }
            }

            var stack = TraceKit.computeStackTrace(ex);
            lastExceptionStack = stack;
            lastException = ex;

            // If the stack trace is incomplete, wait for 2 seconds for
            // slow slow IE to see if onerror occurs or not before reporting
            // this exception; otherwise, we will end up with an incomplete
            // stack trace
            window.setTimeout(function () {
                if (lastException === ex) {
                    lastExceptionStack = null;
                    lastException = null;
                    notifyHandlers.apply(null, [stack, null].concat(args));
                }
            }, stack.incomplete ? 2000 : 0);

            throw ex; // re-throw to propagate to the top level (and cause window.onerror)
        }

        report.subscribe = subscribe;
        report.unsubscribe = unsubscribe;
        return report;
    }();

    /**
     * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
     *
     * Syntax:
     *   s = TraceKit.computeStackTrace.ofCaller([depth])
     *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
     * Returns:
     *   s.name              - exception name
     *   s.message           - exception message
     *   s.stack[i].url      - JavaScript or HTML file URL
     *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
     *   s.stack[i].args     - arguments passed to the function, if known
     *   s.stack[i].line     - line number, if known
     *   s.stack[i].column   - column number, if known
     *   s.stack[i].context  - an array of source code lines; the middle element corresponds to the correct line#
     *   s.mode              - 'stack', 'stacktrace', 'multiline', 'callers', 'onerror', or 'failed' -- method used to collect the stack trace
     *
     * Supports:
     *   - Firefox:  full stack trace with line numbers and unreliable column
     *               number on top frame
     *   - Opera 10: full stack trace with line and column numbers
     *   - Opera 9-: full stack trace with line numbers
     *   - Chrome:   full stack trace with line and column numbers
     *   - Safari:   line and column number for the topmost stacktrace element
     *               only
     *   - IE:       no line numbers whatsoever
     *
     * Tries to guess names of anonymous functions by looking for assignments
     * in the source code. In IE and Safari, we have to guess source file names
     * by searching for function bodies inside all page scripts. This will not
     * work for scripts that are loaded cross-domain.
     * Here be dragons: some function names may be guessed incorrectly, and
     * duplicate functions may be mismatched.
     *
     * TraceKit.computeStackTrace should only be used for tracing purposes.
     * Logging of unhandled exceptions should be done with TraceKit.report,
     * which builds on top of TraceKit.computeStackTrace and provides better
     * IE support by utilizing the window.onerror event to retrieve information
     * about the top of the stack.
     *
     * Note: In IE and Safari, no stack trace is recorded on the Error object,
     * so computeStackTrace instead walks its *own* chain of callers.
     * This means that:
     *  * in Safari, some methods may be missing from the stack trace;
     *  * in IE, the topmost function in the stack trace will always be the
     *    caller of computeStackTrace.
     *
     * This is okay for tracing (because you are likely to be calling
     * computeStackTrace from the function you want to be the topmost element
     * of the stack trace anyway), but not okay for logging unhandled
     * exceptions (because your catch block will likely be far away from the
     * inner function that actually caused the exception).
     *
     * Tracing example:
     *     function trace(message) {
     *         var stackInfo = TraceKit.computeStackTrace.ofCaller();
     *         var data = message + "\n";
     *         for(var i in stackInfo.stack) {
     *             var item = stackInfo.stack[i];
     *             data += (item.func || '[anonymous]') + "() in " + item.url + ":" + (item.line || '0') + "\n";
     *         }
     *         if (window.console)
     *             console.info(data);
     *         else
     *             alert(data);
     *     }
     */
    TraceKit.computeStackTrace = function computeStackTraceWrapper() {
        var debug = false,
            sourceCache = {};

        /**
         * Attempts to retrieve source code via XMLHttpRequest, which is used
         * to look up anonymous function names.
         * @param {string} url URL of source code.
         * @return {string} Source contents.
         */
        function loadSource(url) {
            if (typeof url !== 'string') {
                return [];
            }

            if (!TraceKit.remoteFetching) {
                //Only attempt request if remoteFetching is on.
                return '';
            }
            try {
                var getXHR = function getXHR() {
                    try {
                        return new window.XMLHttpRequest();
                    } catch (e) {
                        // explicitly bubble up the exception if not found
                        return new window.ActiveXObject('Microsoft.XMLHTTP');
                    }
                };

                var request = getXHR();
                request.open('GET', url, false);
                request.send('');
                return request.responseText;
            } catch (e) {
                return '';
            }
        }

        /**
         * Retrieves source code from the source code cache.
         * @param {string} url URL of source code.
         * @return {Array.<string>} Source contents.
         */
        function getSource(url) {
            if (!_has(sourceCache, url)) {
                // URL needs to be able to fetched within the acceptable domain.  Otherwise,
                // cross-domain errors will be triggered.
                var source = '';

                url = url || "";

                if (url.indexOf && url.indexOf(document.domain) !== -1) {
                    source = loadSource(url);
                }
                sourceCache[url] = source ? source.split('\n') : [];
            }

            return sourceCache[url];
        }

        /**
         * Tries to use an externally loaded copy of source code to determine
         * the name of a function by looking at the name of the variable it was
         * assigned to, if any.
         * @param {string} url URL of source code.
         * @param {(string|number)} lineNo Line number in source code.
         * @return {string} The function name, if discoverable.
         */
        function guessFunctionName(url, lineNo) {
            var reFunctionArgNames = /function ([^(]*)\(([^)]*)\)/,
                reGuessFunction = /['"]?([0-9A-Za-z$_]+)['"]?\s*[:=]\s*(function|eval|new Function)/,
                line = '',
                maxLines = 10,
                source = getSource(url),
                m;

            if (!source.length) {
                return UNKNOWN_FUNCTION;
            }

            // Walk backwards from the first line in the function until we find the line which
            // matches the pattern above, which is the function definition
            for (var i = 0; i < maxLines; ++i) {
                line = source[lineNo - i] + line;

                if (!_isUndefined(line)) {
                    if (m = reGuessFunction.exec(line)) {
                        return m[1];
                    } else if (m = reFunctionArgNames.exec(line)) {
                        return m[1];
                    }
                }
            }

            return UNKNOWN_FUNCTION;
        }

        /**
         * Retrieves the surrounding lines from where an exception occurred.
         * @param {string} url URL of source code.
         * @param {(string|number)} line Line number in source code to centre
         * around for context.
         * @return {?Array.<string>} Lines of source code.
         */
        function gatherContext(url, line) {
            var source = getSource(url);

            if (!source.length) {
                return null;
            }

            var context = [],

            // linesBefore & linesAfter are inclusive with the offending line.
            // if linesOfContext is even, there will be one extra line
            //   *before* the offending line.
            linesBefore = Math.floor(TraceKit.linesOfContext / 2),

            // Add one extra line if linesOfContext is odd
            linesAfter = linesBefore + TraceKit.linesOfContext % 2,
                start = Math.max(0, line - linesBefore - 1),
                end = Math.min(source.length, line + linesAfter - 1);

            line -= 1; // convert to 0-based index

            for (var i = start; i < end; ++i) {
                if (!_isUndefined(source[i])) {
                    context.push(source[i]);
                }
            }

            return context.length > 0 ? context : null;
        }

        /**
         * Escapes special characters, except for whitespace, in a string to be
         * used inside a regular expression as a string literal.
         * @param {string} text The string.
         * @return {string} The escaped string literal.
         */
        function escapeRegExp(text) {
            return text.replace(/[\-\[\]{}()*+?.,\\\^$|#]/g, '\\$&');
        }

        /**
         * Escapes special characters in a string to be used inside a regular
         * expression as a string literal. Also ensures that HTML entities will
         * be matched the same as their literal friends.
         * @param {string} body The string.
         * @return {string} The escaped string.
         */
        function escapeCodeAsRegExpForMatchingInsideHTML(body) {
            return escapeRegExp(body).replace('<', '(?:<|&lt;)').replace('>', '(?:>|&gt;)').replace('&', '(?:&|&amp;)').replace('"', '(?:"|&quot;)').replace(/\s+/g, '\\s+');
        }

        /**
         * Determines where a code fragment occurs in the source code.
         * @param {RegExp} re The function definition.
         * @param {Array.<string>} urls A list of URLs to search.
         * @return {?Object.<string, (string|number)>} An object containing
         * the url, line, and column number of the defined function.
         */
        function findSourceInUrls(re, urls) {
            var source, m;
            for (var i = 0, j = urls.length; i < j; ++i) {
                // console.log('searching', urls[i]);
                if ((source = getSource(urls[i])).length) {
                    source = source.join('\n');
                    if (m = re.exec(source)) {
                        // console.log('Found function in ' + urls[i]);

                        return {
                            'url': urls[i],
                            'line': source.substring(0, m.index).split('\n').length,
                            'column': m.index - source.lastIndexOf('\n', m.index) - 1
                        };
                    }
                }
            }

            // console.log('no match');

            return null;
        }

        /**
         * Determines at which column a code fragment occurs on a line of the
         * source code.
         * @param {string} fragment The code fragment.
         * @param {string} url The URL to search.
         * @param {(string|number)} line The line number to examine.
         * @return {?number} The column number.
         */
        function findSourceInLine(fragment, url, line) {
            var source = getSource(url),
                re = new RegExp('\\b' + escapeRegExp(fragment) + '\\b'),
                m;

            line -= 1;

            if (source && source.length > line && (m = re.exec(source[line]))) {
                return m.index;
            }

            return null;
        }

        /**
         * Determines where a function was defined within the source code.
         * @param {(Function|string)} func A function reference or serialized
         * function definition.
         * @return {?Object.<string, (string|number)>} An object containing
         * the url, line, and column number of the defined function.
         */
        function findSourceByFunctionBody(func) {
            var urls = [window.location.href],
                scripts = document.getElementsByTagName('script'),
                body,
                code = '' + func,
                codeRE = /^function(?:\s+([\w$]+))?\s*\(([\w\s,]*)\)\s*\{\s*(\S[\s\S]*\S)\s*\}\s*$/,
                eventRE = /^function on([\w$]+)\s*\(event\)\s*\{\s*(\S[\s\S]*\S)\s*\}\s*$/,
                re,
                parts,
                result;

            for (var i = 0; i < scripts.length; ++i) {
                var script = scripts[i];
                if (script.src) {
                    urls.push(script.src);
                }
            }

            if (!(parts = codeRE.exec(code))) {
                re = new RegExp(escapeRegExp(code).replace(/\s+/g, '\\s+'));
            }

            // not sure if this is really necessary, but I don’t have a test
            // corpus large enough to confirm that and it was in the original.
            else {
                    var name = parts[1] ? '\\s+' + parts[1] : '',
                        args = parts[2].split(',').join('\\s*,\\s*');

                    body = escapeRegExp(parts[3]).replace(/;$/, ';?'); // semicolon is inserted if the function ends with a comment.replace(/\s+/g, '\\s+');
                    re = new RegExp('function' + name + '\\s*\\(\\s*' + args + '\\s*\\)\\s*{\\s*' + body + '\\s*}');
                }

            // look for a normal function definition
            if (result = findSourceInUrls(re, urls)) {
                return result;
            }

            // look for an old-school event handler function
            if (parts = eventRE.exec(code)) {
                var event = parts[1];
                body = escapeCodeAsRegExpForMatchingInsideHTML(parts[2]);

                // look for a function defined in HTML as an onXXX handler
                re = new RegExp('on' + event + '=[\\\'"]\\s*' + body + '\\s*[\\\'"]', 'i');

                if (result = findSourceInUrls(re, urls[0])) {
                    return result;
                }

                // look for ???
                re = new RegExp(body);

                if (result = findSourceInUrls(re, urls)) {
                    return result;
                }
            }

            return null;
        }

        // Contents of Exception in various browsers.
        //
        // SAFARI:
        // ex.message = Can't find variable: qq
        // ex.line = 59
        // ex.sourceId = 580238192
        // ex.sourceURL = http://...
        // ex.expressionBeginOffset = 96
        // ex.expressionCaretOffset = 98
        // ex.expressionEndOffset = 98
        // ex.name = ReferenceError
        //
        // FIREFOX:
        // ex.message = qq is not defined
        // ex.fileName = http://...
        // ex.lineNumber = 59
        // ex.stack = ...stack trace... (see the example below)
        // ex.name = ReferenceError
        //
        // CHROME:
        // ex.message = qq is not defined
        // ex.name = ReferenceError
        // ex.type = not_defined
        // ex.arguments = ['aa']
        // ex.stack = ...stack trace...
        //
        // INTERNET EXPLORER:
        // ex.message = ...
        // ex.name = ReferenceError
        //
        // OPERA:
        // ex.message = ...message... (see the example below)
        // ex.name = ReferenceError
        // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
        // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'

        /**
         * Computes stack trace information from the stack property.
         * Chrome and Gecko use this property.
         * Added WinJS regex for Raygun4JS's offline caching support
         * @param {Error} ex
         * @return {?Object.<string, *>} Stack trace information.
         */
        function computeStackTraceFromStackProp(ex) {
            if (!ex.stack) {
                return null;
            }

            var chrome = /^\s*at (.*?) ?\(?((?:file|http|https|chrome-extension):.*?):(\d+)(?::(\d+))?\)?\s*$/i,
                gecko = /^\s*(.*?)(?:\((.*?)\))?@?((?:file|http|https|chrome):.*?):(\d+)(?::(\d+))?\s*$/i,
                winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:ms-appx|http|https):.*?):(\d+)(?::(\d+))?\)?\s*$/i,
                lines = ex.stack.split('\n'),
                stack = [],
                parts,
                element,
                reference = /^(.*) is undefined$/.exec(ex.message);

            for (var i = 0, j = lines.length; i < j; ++i) {
                if (parts = gecko.exec(lines[i])) {
                    element = {
                        'url': parts[3],
                        'func': parts[1] || UNKNOWN_FUNCTION,
                        'args': parts[2] ? parts[2].split(',') : '',
                        'line': +parts[4],
                        'column': parts[5] ? +parts[5] : null
                    };
                } else if (parts = chrome.exec(lines[i])) {
                    element = {
                        'url': parts[2],
                        'func': parts[1] || UNKNOWN_FUNCTION,
                        'line': +parts[3],
                        'column': parts[4] ? +parts[4] : null
                    };
                } else if (parts = winjs.exec(lines[i])) {
                    element = {
                        'url': parts[2],
                        'func': parts[1] || UNKNOWN_FUNCTION,
                        'line': +parts[3],
                        'column': parts[4] ? +parts[4] : null
                    };
                } else {
                    continue;
                }

                if (!element.func && element.line) {
                    element.func = guessFunctionName(element.url, element.line);
                }

                if (element.line) {
                    element.context = gatherContext(element.url, element.line);
                }

                stack.push(element);
            }

            if (stack[0] && stack[0].line && !stack[0].column && reference) {
                stack[0].column = findSourceInLine(reference[1], stack[0].url, stack[0].line);
            } else if (!stack[0].column && typeof ex.columnNumber !== 'undefined') {
                // Firefox column number
                stack[0].column = ex.columnNumber + 1;
            }

            if (!stack.length) {
                return null;
            }

            return {
                'mode': 'stack',
                'name': ex.name,
                'message': ex.message,
                'url': document.location.href,
                'stack': stack,
                'useragent': navigator.userAgent
            };
        }

        /**
         * Computes stack trace information from the stacktrace property.
         * Opera 10 uses this property.
         * @param {Error} ex
         * @return {?Object.<string, *>} Stack trace information.
         */
        function computeStackTraceFromStacktraceProp(ex) {
            // Access and store the stacktrace property before doing ANYTHING
            // else to it because Opera is not very good at providing it
            // reliably in other circumstances.
            var stacktrace = ex.stacktrace;

            var testRE = / line (\d+), column (\d+) in (?:<anonymous function: ([^>]+)>|([^\)]+))\((.*)\) in (.*):\s*$/i,
                lines = stacktrace !== null ? stacktrace.split('\n') : stacktrace,
                stack = [],
                parts;

            for (var i = 0, j = lines.length; i < j; i += 2) {
                if (parts = testRE.exec(lines[i])) {
                    var element = {
                        'line': +parts[1],
                        'column': +parts[2],
                        'func': parts[3] || parts[4],
                        'args': parts[5] ? parts[5].split(',') : [],
                        'url': parts[6]
                    };

                    if (!element.func && element.line) {
                        element.func = guessFunctionName(element.url, element.line);
                    }
                    if (element.line) {
                        try {
                            element.context = gatherContext(element.url, element.line);
                        } catch (exc) {}
                    }

                    if (!element.context) {
                        element.context = [lines[i + 1]];
                    }

                    stack.push(element);
                }
            }

            if (!stack.length) {
                return null;
            }

            return {
                'mode': 'stacktrace',
                'name': ex.name,
                'message': ex.message,
                'url': document.location.href,
                'stack': stack,
                'useragent': navigator.userAgent
            };
        }

        /**
         * NOT TESTED.
         * Computes stack trace information from an error message that includes
         * the stack trace.
         * Opera 9 and earlier use this method if the option to show stack
         * traces is turned on in opera:config.
         * @param {Error} ex
         * @return {?Object.<string, *>} Stack information.
         */
        function computeStackTraceFromOperaMultiLineMessage(ex) {
            // Opera includes a stack trace into the exception message. An example is:
            //
            // Statement on line 3: Undefined variable: undefinedFunc
            // Backtrace:
            //   Line 3 of linked script file://localhost/Users/andreyvit/Projects/TraceKit/javascript-client/sample.js: In function zzz
            //         undefinedFunc(a);
            //   Line 7 of inline#1 script in file://localhost/Users/andreyvit/Projects/TraceKit/javascript-client/sample.html: In function yyy
            //           zzz(x, y, z);
            //   Line 3 of inline#1 script in file://localhost/Users/andreyvit/Projects/TraceKit/javascript-client/sample.html: In function xxx
            //           yyy(a, a, a);
            //   Line 1 of function script
            //     try { xxx('hi'); return false; } catch(ex) { TraceKit.report(ex); }
            //   ...

            var lines = ex.message.split('\n');
            if (lines.length < 4) {
                return null;
            }

            var lineRE1 = /^\s*Line (\d+) of linked script ((?:file|http|https)\S+)(?:: in function (\S+))?\s*$/i,
                lineRE2 = /^\s*Line (\d+) of inline#(\d+) script in ((?:file|http|https)\S+)(?:: in function (\S+))?\s*$/i,
                lineRE3 = /^\s*Line (\d+) of function script\s*$/i,
                stack = [],
                scripts = document.getElementsByTagName('script'),
                inlineScriptBlocks = [],
                parts,
                i,
                len,
                source;

            for (i in scripts) {
                if (_has(scripts, i) && !scripts[i].src) {
                    inlineScriptBlocks.push(scripts[i]);
                }
            }

            for (i = 2, len = lines.length; i < len; i += 2) {
                var item = null;
                if (parts = lineRE1.exec(lines[i])) {
                    item = {
                        'url': parts[2],
                        'func': parts[3],
                        'line': +parts[1]
                    };
                } else if (parts = lineRE2.exec(lines[i])) {
                    item = {
                        'url': parts[3],
                        'func': parts[4]
                    };
                    var relativeLine = +parts[1]; // relative to the start of the <SCRIPT> block
                    var script = inlineScriptBlocks[parts[2] - 1];
                    if (script) {
                        source = getSource(item.url);
                        if (source) {
                            source = source.join('\n');
                            var pos = source.indexOf(script.innerText);
                            if (pos >= 0) {
                                item.line = relativeLine + source.substring(0, pos).split('\n').length;
                            }
                        }
                    }
                } else if (parts = lineRE3.exec(lines[i])) {
                    var url = window.location.href.replace(/#.*$/, ''),
                        line = parts[1];
                    var re = new RegExp(escapeCodeAsRegExpForMatchingInsideHTML(lines[i + 1]));
                    source = findSourceInUrls(re, [url]);
                    item = {
                        'url': url,
                        'line': source ? source.line : line,
                        'func': ''
                    };
                }

                if (item) {
                    if (!item.func) {
                        item.func = guessFunctionName(item.url, item.line);
                    }
                    var context = gatherContext(item.url, item.line);
                    var midline = context ? context[Math.floor(context.length / 2)] : null;
                    if (context && midline.replace(/^\s*/, '') === lines[i + 1].replace(/^\s*/, '')) {
                        item.context = context;
                    } else {
                        // if (context) alert("Context mismatch. Correct midline:\n" + lines[i+1] + "\n\nMidline:\n" + midline + "\n\nContext:\n" + context.join("\n") + "\n\nURL:\n" + item.url);
                        item.context = [lines[i + 1]];
                    }
                    stack.push(item);
                }
            }
            if (!stack.length) {
                return null; // could not parse multiline exception message as Opera stack trace
            }

            return {
                'mode': 'multiline',
                'name': ex.name,
                'message': lines[0],
                'url': document.location.href,
                'stack': stack,
                'useragent': navigator.userAgent
            };
        }

        /**
         * Adds information about the first frame to incomplete stack traces.
         * Safari and IE require this to get complete data on the first frame.
         * @param {Object.<string, *>} stackInfo Stack trace information from
         * one of the compute* methods.
         * @param {string} url The URL of the script that caused an error.
         * @param {(number|string)} lineNo The line number of the script that
         * caused an error.
         * @param {string=} message The error generated by the browser, which
         * hopefully contains the name of the object that caused the error.
         * @return {boolean} Whether or not the stack information was
         * augmented.
         */
        function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
            var initial = {
                'url': url,
                'line': lineNo
            };

            if (initial.url && initial.line) {
                stackInfo.incomplete = false;

                if (!initial.func) {
                    initial.func = guessFunctionName(initial.url, initial.line);
                }

                if (!initial.context) {
                    initial.context = gatherContext(initial.url, initial.line);
                }

                var reference = / '([^']+)' /.exec(message);
                if (reference) {
                    initial.column = findSourceInLine(reference[1], initial.url, initial.line);
                }

                if (stackInfo.stack.length > 0) {
                    if (stackInfo.stack[0].url === initial.url) {
                        if (stackInfo.stack[0].line === initial.line) {
                            return false; // already in stack trace
                        } else if (!stackInfo.stack[0].line && stackInfo.stack[0].func === initial.func) {
                            stackInfo.stack[0].line = initial.line;
                            stackInfo.stack[0].context = initial.context;
                            return false;
                        }
                    }
                }

                stackInfo.stack.unshift(initial);
                stackInfo.partial = true;
                return true;
            } else {
                stackInfo.incomplete = true;
            }

            return false;
        }

        /**
         * Computes stack trace information by walking the arguments.caller
         * chain at the time the exception occurred. This will cause earlier
         * frames to be missed but is the only way to get any stack trace in
         * Safari and IE. The top frame is restored by
         * {@link augmentStackTraceWithInitialElement}.
         * @param {Error} ex
         * @return {?Object.<string, *>} Stack trace information.
         */
        function computeStackTraceByWalkingCallerChain(ex, depth) {
            var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
                stack = [],
                funcs = {},
                recursion = false,
                parts,
                item,
                source;

            for (var curr = computeStackTraceByWalkingCallerChain.caller; curr && !recursion; curr = curr.caller) {
                if (curr === computeStackTrace || curr === TraceKit.report) {
                    // console.log('skipping internal function');
                    continue;
                }

                item = {
                    'url': null,
                    'func': UNKNOWN_FUNCTION,
                    'line': null,
                    'column': null
                };

                if (curr.name) {
                    item.func = curr.name;
                } else if (parts = functionName.exec(curr.toString())) {
                    item.func = parts[1];
                }

                if (typeof item.func === 'undefined') {
                    try {
                        item.func = parts.input.substring(0, parts.input.indexOf('{'));
                    } catch (e) {}
                }

                if (source = findSourceByFunctionBody(curr)) {
                    item.url = source.url;
                    item.line = source.line;

                    if (item.func === UNKNOWN_FUNCTION) {
                        item.func = guessFunctionName(item.url, item.line);
                    }

                    var reference = / '([^']+)' /.exec(ex.message || ex.description);
                    if (reference) {
                        item.column = findSourceInLine(reference[1], source.url, source.line);
                    }
                }

                if (funcs['' + curr]) {
                    recursion = true;
                } else {
                    funcs['' + curr] = true;
                }

                stack.push(item);
            }

            if (depth) {
                // console.log('depth is ' + depth);
                // console.log('stack is ' + stack.length);
                stack.splice(0, depth);
            }

            var result = {
                'mode': 'callers',
                'name': ex.name,
                'message': ex.message,
                'url': document.location.href,
                'stack': stack,
                'useragent': navigator.userAgent
            };
            augmentStackTraceWithInitialElement(result, ex.sourceURL || ex.fileName, ex.line || ex.lineNumber, ex.message || ex.description);
            return result;
        }

        /**
         * Computes a stack trace for an exception.
         * @param {Error} ex
         * @param {(string|number)=} depth
         */
        function computeStackTrace(ex, depth) {
            var stack = null;
            depth = depth == null ? 0 : +depth;

            try {
                // This must be tried first because Opera 10 *destroys*
                // its stacktrace property if you try to access the stack
                // property first!!
                stack = computeStackTraceFromStacktraceProp(ex);
                if (stack) {
                    return stack;
                }
            } catch (e) {
                if (debug) {
                    throw e;
                }
            }

            try {
                stack = computeStackTraceFromStackProp(ex);
                if (stack) {
                    return stack;
                }
            } catch (e) {
                if (debug) {
                    throw e;
                }
            }

            try {
                stack = computeStackTraceFromOperaMultiLineMessage(ex);
                if (stack) {
                    return stack;
                }
            } catch (e) {
                if (debug) {
                    throw e;
                }
            }

            try {
                stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
                if (stack) {
                    return stack;
                }
            } catch (e) {
                if (debug) {
                    throw e;
                }
            }

            return {
                'mode': 'failed'
            };
        }

        /**
         * Logs a stacktrace starting from the previous call and working down.
         * @param {(number|string)=} depth How many frames deep to trace.
         * @return {Object.<string, *>} Stack trace information.
         */
        function computeStackTraceOfCaller(depth) {
            depth = (depth == null ? 0 : +depth) + 1; // "+ 1" because "ofCaller" should drop one frame
            try {
                throw new Error();
            } catch (ex) {
                return computeStackTrace(ex, depth + 1);
            }
        }

        computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
        computeStackTrace.guessFunctionName = guessFunctionName;
        computeStackTrace.gatherContext = gatherContext;
        computeStackTrace.ofCaller = computeStackTraceOfCaller;

        return computeStackTrace;
    }();

    /**
     * Extends support for global error handling for asynchronous browser
     * functions. Adopted from Closure Library's errorhandler.js
     */
    TraceKit.extendToAsynchronousCallbacks = function () {
        var _helper = function _helper(fnName) {
            var originalFn = window[fnName];
            window[fnName] = function traceKitAsyncExtension() {
                // Make a copy of the arguments
                var args = _slice.call(arguments);
                var originalCallback = args[0];
                if (typeof originalCallback === 'function') {
                    args[0] = TraceKit.wrap(originalCallback);
                }
                // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
                // also only supports 2 argument and doesn't care what "this" is, so we
                // can just call the original function directly.
                if (originalFn.apply) {
                    return originalFn.apply(this, args);
                } else {
                    return originalFn(args[0], args[1]);
                }
            };
        };

        _helper('setTimeout');
        _helper('setInterval');
    };

    //Default options:
    if (!TraceKit.remoteFetching) {
        TraceKit.remoteFetching = true;
    }
    if (!TraceKit.collectWindowErrors) {
        TraceKit.collectWindowErrors = true;
    }
    if (!TraceKit.linesOfContext || TraceKit.linesOfContext < 1) {
        // 5 lines before, the offending line, 5 lines after
        TraceKit.linesOfContext = 11;
    }

    // Export to global object
    window.TraceKit = TraceKit;
})(window);

(function traceKitAsyncForjQuery($, TraceKit) {
    'use strict';
    // quit if jQuery isn't on the page

    if (!$) {
        return;
    }

    var _oldEventAdd = $.event.add;
    $.event.add = function traceKitEventAdd(elem, types, handler, data, selector) {
        if (typeof handler !== 'function' && typeof handler.handler !== 'function') {
            _oldEventAdd.call(this, elem, types, handler, data, selector);
        }

        var _handler;

        if (handler.handler) {
            _handler = handler.handler;
            handler.handler = TraceKit.wrap(handler.handler);
        } else {
            _handler = handler;
            handler = TraceKit.wrap(handler);
        }

        // If the handler we are attaching doesn’t have the same guid as
        // the original, it will never be removed when someone tries to
        // unbind the original function later. Technically as a result of
        // this our guids are no longer globally unique, but whatever, that
        // never hurt anybody RIGHT?!
        if (_handler.guid) {
            handler.guid = _handler.guid;
        } else {
            handler.guid = _handler.guid = $.guid++;
        }

        return _oldEventAdd.call(this, elem, types, handler, data, selector);
    };

    var _oldReady = $.fn.ready;
    $.fn.ready = function traceKitjQueryReadyWrapper(fn) {
        return _oldReady.call(this, TraceKit.wrap(fn));
    };

    var _oldAjax = $.ajax;
    $.ajax = function traceKitAjaxWrapper(url, options) {
        if ((typeof url === 'undefined' ? 'undefined' : _typeof(url)) === "object") {
            options = url;
            url = undefined;
        }

        options = options || {};

        var keys = ['complete', 'error', 'success'],
            key;
        while (key = keys.pop()) {
            if ($.isFunction(options[key])) {
                options[key] = TraceKit.wrap(options[key]);
            }
        }

        try {
            return url ? _oldAjax.call(this, url, options) : _oldAjax.call(this, options);
        } catch (e) {
            TraceKit.report(e);
            throw e;
        }
    };
})(window.jQuery, window.TraceKit);

var raygunFactory = function raygunFactory(window, $, undefined) {

    // pull local copy of TraceKit to handle stack trace collection
    var _traceKit = TraceKit,
        _raygun = !!window.GG ? window.GG.Raygun : undefined,
        _debugMode = false,
        _allowInsecureSubmissions = false,
        _ignoreAjaxAbort = false,
        _ignoreAjaxError = false,
        _enableOfflineSave = false,
        _ignore3rdPartyErrors = true,
        _disableAnonymousUserTracking = false,
        _wrapAsynchronousCallbacks = false,
        _customData = {},
        _tags = ["clientside"],
        _user,
        _applicationVersion,
        _applicationName,
        _filteredKeys,
        _whitelistedScriptDomains = [],
        _beforeSendCallback,
        _raygunApiUrl = '',
        _excludedHostnames = null,
        _excludedUserAgents = null,
        _filterScope = 'customData',
        $document;

    if ($) {
        $document = $(document);
    }

    var Raygun = {
        noConflict: function noConflict() {
            window.GG.Raygun = _raygun;
            return Raygun;
        },

        constructNewRaygun: function constructNewRaygun() {
            var rgInstance = window.raygunFactory(window, window.jQuery);
            window.raygunJsUrlFactory(window, rgInstance);

            return rgInstance;
        },

        init: function init(url, options, customdata) {
            if (!url) throw "Must supply the url for the diagnostics service";

            _raygunApiUrl = url + (url[url.length - 1] === "/" ? "" : "/") + "error/js/";
            _traceKit.remoteFetching = false;
            _customData = customdata;

            if (options) {
                _allowInsecureSubmissions = options.allowInsecureSubmissions || false;
                _ignoreAjaxAbort = options.ignoreAjaxAbort || false;
                _ignoreAjaxError = options.ignoreAjaxError || false;
                _disableAnonymousUserTracking = options.disableAnonymousUserTracking || false;
                _excludedHostnames = options.excludedHostnames || false;
                _excludedUserAgents = options.excludedUserAgents || false;
                _ignore3rdPartyErrors = options.ignore3rdPartyErrors || true;

                if (typeof options.wrapAsynchronousCallbacks !== 'undefined') {
                    _wrapAsynchronousCallbacks = options.wrapAsynchronousCallbacks;
                }

                if (options.debugMode) {
                    _debugMode = options.debugMode;
                }
            }

            sendSavedErrors();

            return Raygun;
        },

        withCustomData: function withCustomData(customdata) {
            _customData = customdata;
            return Raygun;
        },

        withTags: function withTags(tags) {
            _tags = tags;
            return Raygun;
        },

        attach: function attach() {
            _traceKit.report.subscribe(function (stacktrace) {
                processUnhandledException(stacktrace, { tags: ["unhandled"] });
            });

            if (_wrapAsynchronousCallbacks) {
                _traceKit.extendToAsynchronousCallbacks();
            }

            if ($document && !_ignoreAjaxError) {
                $document.ajaxError(processJQueryAjaxError);
            }
            return Raygun;
        },

        detach: function detach() {
            _traceKit.report.unsubscribe(processUnhandledException);
            if ($document) {
                $document.unbind('ajaxError', processJQueryAjaxError);
            }
            return Raygun;
        },

        send: function send(ex, customData, tags) {
            try {
                tags = mergeArray(tags || [], ["handled"]);
                processUnhandledException(_traceKit.computeStackTrace(ex), {
                    customData: typeof _customData === 'function' ? merge(_customData(), customData) : merge(_customData, customData),
                    tags: mergeArray(_tags, tags)
                });
            } catch (traceKitException) {
                if (ex !== traceKitException) {
                    throw traceKitException;
                }
            }
            return Raygun;
        },

        sendMessage: function sendMessage(message, customData, tags) {
            try {
                var partialPayload = {
                    'Message': message
                };
                generatePayloadAndSendToRaygun(partialPayload, {
                    customData: typeof _customData === 'function' ? merge(_customData(), customData) : merge(_customData, customData),
                    tags: mergeArray(_tags, tags)
                });
            } catch (traceKitException) {
                if (ex !== traceKitException) {
                    throw traceKitException;
                }
            }
            return Raygun;
        },

        setUser: function setUser(user, isAnonymous, email, fullName, firstName, uuid) {
            _user = {
                'Identifier': user
            };
            if (typeof isAnonymous !== 'undefined') {
                _user['IsAnonymous'] = isAnonymous;
            }
            if (typeof email !== 'undefined') {
                _user['Email'] = email;
            }
            if (typeof fullName !== 'undefined') {
                _user['FullName'] = fullName;
            }
            if (typeof firstName !== 'undefined') {
                _user['FirstName'] = firstName;
            }
            if (typeof uuid !== 'undefined') {
                _user['UUID'] = uuid;
            }

            return Raygun;
        },

        resetAnonymousUser: function resetAnonymousUser() {
            _private.clearCookie('raygun4js-userid');
        },

        setVersion: function setVersion(version, name) {
            _applicationVersion = version;
            _applicationName = name;
            return Raygun;
        },

        saveIfOffline: function saveIfOffline(enableOffline) {
            if (typeof enableOffline !== 'undefined' && typeof enableOffline === 'boolean') {
                _enableOfflineSave = enableOffline;
            }

            return Raygun;
        },

        filterSensitiveData: function filterSensitiveData(filteredKeys) {
            _filteredKeys = filteredKeys;
            return Raygun;
        },

        setFilterScope: function setFilterScope(scope) {
            if (scope === 'customData' || scope === 'all') {
                _filterScope = scope;
            }
            return Raygun;
        },

        whitelistCrossOriginDomains: function whitelistCrossOriginDomains(whitelist) {
            _whitelistedScriptDomains = whitelist;
            return Raygun;
        },

        onBeforeSend: function onBeforeSend(callback) {
            _beforeSendCallback = callback;

            return Raygun;
        }
    };

    var _private = Raygun._private = Raygun._private || {},
        _seal = Raygun._seal = Raygun._seal || function () {
        delete Raygun._private;
        delete Raygun._seal;
        delete Raygun._unseal;
    },
        _unseal = Raygun._unseal = Raygun._unseal || function () {
        Raygun._private = _private;
        Raygun._seal = _seal;
        Raygun._unseal = _unseal;
    };

    _private.getUuid = function () {
        function _p8(s) {
            var p = (Math.random().toString(16) + "000000000").substr(2, 8);
            return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p;
        }
        return _p8() + _p8(true) + _p8(true) + _p8();
    };

    _private.createCookie = function (name, value, hours) {
        var expires;
        if (hours) {
            var date = new Date();
            date.setTime(date.getTime() + hours * 60 * 60 * 1000);
            expires = "; expires=" + date.toGMTString();
        } else {
            expires = "";
        }

        document.cookie = name + "=" + value + expires + "; path=/";
    };

    _private.readCookie = function (name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) === 0) {
                return c.substring(nameEQ.length, c.length);
            }
        }
        return null;
    };

    _private.clearCookie = function (key) {
        _private.createCookie(key, '', -1);
    };

    _private.log = function (message, data) {
        if (window.console && window.console.log && _debugMode) {
            window.console.log(message);

            if (data) {
                window.console.log(data);
            }
        }
    };

    /* internals */

    function truncateURL(url) {
        // truncate after fourth /, or 24 characters, whichever is shorter
        // /api/1/diagrams/xyz/server becomes
        // /api/1/diagrams/...
        var truncated = url;
        var path = url.split('//')[1];

        if (path) {
            var queryStart = path.indexOf('?');
            var sanitizedPath = path.toString().substring(0, queryStart);
            var truncated_parts = sanitizedPath.split('/').slice(0, 4).join('/');
            var truncated_length = sanitizedPath.substring(0, 48);
            truncated = truncated_parts.length < truncated_length.length ? truncated_parts : truncated_length;
            if (truncated !== sanitizedPath) {
                truncated += '..';
            }
        }

        return truncated;
    }

    function processJQueryAjaxError(event, jqXHR, ajaxSettings, thrownError) {
        var message = 'AJAX Error: ' + (jqXHR.statusText || 'unknown') + ' ' + (ajaxSettings.type || 'unknown') + ' ' + (truncateURL(ajaxSettings.url) || 'unknown');

        // ignore ajax abort if set in the options
        if (_ignoreAjaxAbort) {
            if (!jqXHR.getAllResponseHeaders()) {
                return;
            }
        }

        Raygun.send(thrownError || event.type, {
            status: jqXHR.status,
            statusText: jqXHR.statusText,
            type: ajaxSettings.type,
            url: ajaxSettings.url,
            ajaxErrorMessage: message,
            contentType: ajaxSettings.contentType,
            requestData: ajaxSettings.data && ajaxSettings.data.slice ? ajaxSettings.data.slice(0, 10240) : undefined,
            responseData: jqXHR.responseText && jqXHR.responseText.slice ? jqXHR.responseText.slice(0, 10240) : undefined
        });
    }

    function merge(o1, o2) {
        var a,
            o3 = {};
        for (a in o1) {
            o3[a] = o1[a];
        }
        for (a in o2) {
            o3[a] = o2[a];
        }
        return o3;
    }

    function mergeArray(t0, t1) {
        if (t1 != null) {
            return t0.concat(t1);
        }
        return t0;
    }

    function forEach(set, func) {
        for (var i = 0; i < set.length; i++) {
            func.call(null, i, set[i]);
        }
    }

    function isEmpty(o) {
        for (var p in o) {
            if (o.hasOwnProperty(p)) {
                return false;
            }
        }
        return true;
    }

    function getRandomInt() {
        return Math.floor(Math.random() * 9007199254740993);
    }

    function getViewPort() {
        var e = document.documentElement,
            g = document.getElementsByTagName('body')[0],
            x = window.innerWidth || e.clientWidth || g.clientWidth,
            y = window.innerHeight || e.clientHeight || g.clientHeight;
        return { width: x, height: y };
    }

    function offlineSave(data) {
        var dateTime = new Date().toJSON();

        try {
            var key = 'raygunjs=' + dateTime + '=' + getRandomInt();

            if (typeof localStorage[key] === 'undefined') {
                localStorage[key] = data;
            }
        } catch (e) {
            _private.log('Raygun4JS: LocalStorage full, cannot save exception');
        }
    }

    function localStorageAvailable() {
        try {
            return 'localStorage' in window && window['localStorage'] !== null;
        } catch (e) {
            return false;
        }
    }

    function sendSavedErrors() {
        if (localStorageAvailable() && localStorage && localStorage.length > 0) {
            for (var key in localStorage) {
                if (key.substring(0, 9) === 'raygunjs=') {
                    try {
                        sendToRaygun(JSON.parse(localStorage[key]));
                    } catch (e) {
                        _private.log('Raygun4JS: Invalid JSON object in LocalStorage');
                    }

                    try {
                        localStorage.removeItem(key);
                    } catch (e) {
                        _private.log('Raygun4JS: Unable to remove error');
                    }
                }
            }
        }
    }

    function ensureUser() {
        if (!_user && !_disableAnonymousUserTracking) {
            var userKey = 'raygun4js-userid';
            var rgUserId = _private.readCookie(userKey);
            var anonymousUuid;

            if (!rgUserId) {
                anonymousUuid = _private.getUuid();

                _private.createCookie(userKey, anonymousUuid, 24 * 31);
            } else {
                anonymousUuid = rgUserId;
            }

            Raygun.setUser(anonymousUuid, true, null, null, null, anonymousUuid);
        }
    }

    function filterValue(key, value) {
        if (_filteredKeys) {
            for (var i = 0; i < _filteredKeys.length; i++) {
                if (_typeof(_filteredKeys[i]) === 'object' && typeof _filteredKeys[i].exec === 'function') {
                    if (_filteredKeys[i].exec(key) !== null) {
                        return '[removed by filter]';
                    }
                } else if (_filteredKeys[i] === key) {
                    return '[removed by filter]';
                }
            }
        }

        return value;
    }

    function filterObject(reference, parentKey) {
        if (reference == null) {
            return reference;
        }

        if (Object.prototype.toString.call(reference) !== '[object Object]') {
            return reference;
        }

        for (var propertyName in reference) {
            var propertyValue = reference[propertyName];

            if (propertyValue == null) {
                continue;
            }

            if (Object.prototype.toString.call(propertyValue) === '[object Object]') {
                if (parentKey !== 'Details' || propertyName !== 'Client') {
                    reference[propertyName] = filterObject(filterValue(propertyName, propertyValue), propertyName);
                }
            } else {
                if (typeof parentKey !== 'undefined' || propertyName !== 'OccurredOn') {
                    reference[propertyName] = filterValue(propertyName, propertyValue);
                }
            }
        }

        return reference;
    }

    function processUnhandledException(stackTrace, options) {
        var stack = "",
            qs = {};

        if (options === undefined) {
            options = {};
        }

        if (_ignore3rdPartyErrors) {
            if (!stackTrace.stack || !stackTrace.stack.length) {
                _private.log('Raygun4JS: Cancelling send due to null stacktrace');
                return;
            }

            var domain = _private.parseUrl('domain');

            var scriptError = 'Script error';
            var msg = stackTrace.message || options.status || scriptError;
            if (msg.substring(0, scriptError.length) === scriptError && stackTrace.stack[0].url !== null && stackTrace.stack[0].url.indexOf(domain) === -1 && (stackTrace.stack[0].line === 0 || stackTrace.stack[0].func === '?')) {
                _private.log('Raygun4JS: cancelling send due to third-party script error with no stacktrace and message');
                return;
            }

            if (stackTrace.stack[0].url !== null && stackTrace.stack[0].url.indexOf(domain) === -1) {
                var allowedDomainFound = false;

                for (var i in _whitelistedScriptDomains) {
                    if (stackTrace.stack[0].url.indexOf(_whitelistedScriptDomains[i]) > -1) {
                        allowedDomainFound = true;
                    }
                }

                if (!allowedDomainFound) {
                    _private.log('Raygun4JS: cancelling send due to error on non-origin, non-whitelisted domain');

                    return;
                }
            }
        }

        if (stackTrace.stack && stackTrace.stack.length) {
            forEach(stackTrace.stack, function (i, frame) {
                var funcName = !frame.func || frame.func === "at " ? "[anonymous]" : frame.func;
                stack += funcName + " @ " + "(" + (frame.url || '[anonymous]') + ":" + (frame.line || "?").toString() + ":" + (frame.column || "?").toString() + ")\n";
            });
        }

        if (isEmpty(options.customData)) {
            if (typeof _customData === 'function') {
                options.customData = _customData();
            } else {
                options.customData = _customData;
            }
        }

        var custom_message = options.customData && options.customData.ajaxErrorMessage;

        var finalMessage = custom_message || stackTrace.message || options.status || 'Script error';
        finalMessage = finalMessage.substring(0, 512);

        var partialPayload = {
            'Exception': {
                'Type': stackTrace.name || null,
                'Message': finalMessage || null,
                'StackTrace': stack || null
            }
        };

        generatePayloadAndSendToRaygun(partialPayload, options);
    }

    function generatePayloadAndSendToRaygun(partialPayload, options) {
        var qs = {};

        if (_excludedHostnames instanceof Array) {
            for (var hostIndex in _excludedHostnames) {
                if (_excludedHostnames.hasOwnProperty(hostIndex)) {
                    if (window.location.hostname && window.location.hostname.match(_excludedHostnames[hostIndex])) {
                        _private.log('Raygun4JS: cancelling send as error originates from an excluded hostname');

                        return;
                    }
                }
            }
        }

        if (_excludedUserAgents instanceof Array) {
            for (var userAgentIndex in _excludedUserAgents) {
                if (_excludedUserAgents.hasOwnProperty(userAgentIndex)) {
                    if (navigator.userAgent.match(_excludedUserAgents[userAgentIndex])) {
                        _private.log('Raygun4JS: cancelling send as error originates from an excluded user agent');

                        return;
                    }
                }
            }
        }

        var queryString = _private.parseUrl('?');

        if (queryString.length > 0) {
            forEach(queryString.split('&'), function (i, segment) {
                var parts = segment.split('=');
                if (parts && parts.length === 2) {
                    var key = decodeURIComponent(parts[0]);
                    var value = filterValue(key, parts[1]);

                    qs[key] = value;
                }
            });
        }

        if (options === undefined) {
            options = {};
        }

        if (isEmpty(options.customData)) {
            if (typeof _customData === 'function') {
                options.customData = _customData();
            } else {
                options.customData = _customData;
            }
        }

        if (isEmpty(options.tags)) {
            if (typeof _tags === 'function') {
                options.tags = _tags();
            } else {
                options.tags = _tags;
            }
        } else {
            options.tags = mergeArray(options.tags, _tags);
        }

        var screen = window.screen || { width: getViewPort().width, height: getViewPort().height, colorDepth: 8 };

        var finalCustomData;
        if (_filterScope === 'customData') {
            finalCustomData = filterObject(options.customData, 'UserCustomData');
        } else {
            finalCustomData = options.customData;
        }

        try {
            JSON.stringify(finalCustomData);
        } catch (e) {
            var msg = 'Cannot add custom data; may contain circular reference';
            finalCustomData = { error: msg };
            _private.log('Raygun4JS: ' + msg);
        }
        var payload = {
            'TimeStamp': new Date(),
            'Client': {
                'Browser': {
                    'UtcOffset': new Date().getTimezoneOffset() / -60.0,
                    'UserLanguage': navigator.userLanguage,
                    'DocumentMode': document.documentMode,
                    'BrowserWidth': getViewPort().width,
                    'BrowserHeight': getViewPort().height,
                    'ScreenWidth': screen.width,
                    'ScreenHeight': screen.height,
                    'ColorDepth': screen.colorDepth
                }
            },
            'Request': {
                'Url': [location.protocol, '//', location.host, location.pathname, location.hash].join(''),
                'UrlReferrer': document.referrer,
                'QueryString': qs
            },
            'Tags': options.tags,
            'CustomData': finalCustomData,
            'Server': {
                'ApplicationVersion': _applicationVersion || 'Not supplied',
                'ApplicationName': _applicationName || 'Not supplied'
            }
        };

        payload = merge(payload, partialPayload);

        if (_filterScope === 'all') {
            payload = filterObject(payload);
        }

        if (typeof _beforeSendCallback === 'function') {
            var mutatedPayload = _beforeSendCallback(payload);

            if (mutatedPayload) {
                sendToRaygun(mutatedPayload);
            }
        } else {
            sendToRaygun(payload);
        }
    }

    function sendToRaygun(data) {
        _private.log('Sending exception data to Raygun:', data);
        makePostCorsRequest(_raygunApiUrl, JSON.stringify(data));
    }

    // Create the XHR object.
    function createCORSRequest(method, url) {
        var xhr;

        xhr = new window.XMLHttpRequest();
        if ("withCredentials" in xhr) {
            // XHR for Chrome/Firefox/Opera/Safari.
            xhr.open(method, url, true);
            xhr.withCredentials = true;
        } else if (window.XDomainRequest) {
            // XDomainRequest for IE.
            if (_allowInsecureSubmissions) {
                // remove 'https:' and use relative protocol
                // this allows IE8 to post messages when running
                // on http
                url = url.slice(6);
            }

            xhr = new window.XDomainRequest();
            xhr.open(method, url);
        }

        xhr.timeout = 10000;

        return xhr;
    }

    // Make the actual CORS request.
    function makePostCorsRequest(url, data) {
        var xhr = createCORSRequest('POST', url, data);

        if ('withCredentials' in xhr) {

            xhr.onreadystatechange = function () {
                if (xhr.readyState !== 4) {
                    return;
                }

                if (xhr.status === 202) {
                    sendSavedErrors();
                } else if (_enableOfflineSave && xhr.status !== 403 && xhr.status !== 400 && xhr.status !== 429) {
                    offlineSave(data);
                }
            };

            xhr.onload = function () {
                _private.log('logged error to Raygun');
            };
        } else if (window.XDomainRequest) {
            xhr.ontimeout = function () {
                if (_enableOfflineSave) {
                    _private.log('Raygun: saved error locally');
                    offlineSave(data);
                }
            };

            xhr.onload = function () {
                _private.log('logged error to Raygun');
                sendSavedErrors();
            };
        }

        xhr.onerror = function () {
            _private.log('failed to log error to Raygun');
        };

        if (!xhr) {
            _private.log('CORS not supported');
            return;
        }

        xhr.send(data);
    }

    if (!window.GG) {
        window.GG = {};
    };
    if (!window.GG.Raygun) {
        window.GG.Raygun = Raygun;
    }

    return Raygun;
};

raygunFactory(window, window.jQuery);

// js-url - see LICENSE file

var raygunJsUrlFactory = function raygunJsUrlFactory(window, Raygun) {

    Raygun._private.parseUrl = function (arg, url) {
        function isNumeric(arg) {
            return !isNaN(parseFloat(arg)) && isFinite(arg);
        }

        return function (arg, url) {
            var _ls = url || window.location.toString();

            if (!arg) {
                return _ls;
            } else {
                arg = arg.toString();
            }

            if (_ls.substring(0, 2) === '//') {
                _ls = 'http:' + _ls;
            } else if (_ls.split('://').length === 1) {
                _ls = 'http://' + _ls;
            }

            url = _ls.split('/');
            var _l = { auth: '' },
                host = url[2].split('@');

            if (host.length === 1) {
                host = host[0].split(':');
            } else {
                _l.auth = host[0];host = host[1].split(':');
            }

            _l.protocol = url[0];
            _l.hostname = host[0];
            _l.port = host[1] || (_l.protocol.split(':')[0].toLowerCase() === 'https' ? '443' : '80');
            _l.pathname = (url.length > 3 ? '/' : '') + url.slice(3, url.length).join('/').split('?')[0].split('#')[0];
            var _p = _l.pathname;

            if (_p.charAt(_p.length - 1) === '/') {
                _p = _p.substring(0, _p.length - 1);
            }
            var _h = _l.hostname,
                _hs = _h.split('.'),
                _ps = _p.split('/');

            if (arg === 'hostname') {
                return _h;
            } else if (arg === 'domain') {
                if (/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/.test(_h)) {
                    return _h;
                }
                return _hs.slice(-2).join('.');
            }
            //else if (arg === 'tld') { return _hs.slice(-1).join('.'); }
            else if (arg === 'sub') {
                    return _hs.slice(0, _hs.length - 2).join('.');
                } else if (arg === 'port') {
                    return _l.port;
                } else if (arg === 'protocol') {
                    return _l.protocol.split(':')[0];
                } else if (arg === 'auth') {
                    return _l.auth;
                } else if (arg === 'user') {
                    return _l.auth.split(':')[0];
                } else if (arg === 'pass') {
                    return _l.auth.split(':')[1] || '';
                } else if (arg === 'path') {
                    return _l.pathname;
                } else if (arg.charAt(0) === '.') {
                    arg = arg.substring(1);
                    if (isNumeric(arg)) {
                        arg = parseInt(arg, 10);return _hs[arg < 0 ? _hs.length + arg : arg - 1] || '';
                    }
                } else if (isNumeric(arg)) {
                    arg = parseInt(arg, 10);return _ps[arg < 0 ? _ps.length + arg : arg] || '';
                } else if (arg === 'file') {
                    return _ps.slice(-1)[0];
                } else if (arg === 'filename') {
                    return _ps.slice(-1)[0].split('.')[0];
                } else if (arg === 'fileext') {
                    return _ps.slice(-1)[0].split('.')[1] || '';
                } else if (arg.charAt(0) === '?' || arg.charAt(0) === '#') {
                    var params = _ls,
                        param = null;

                    if (arg.charAt(0) === '?') {
                        params = (params.split('?')[1] || '').split('#')[0];
                    } else if (arg.charAt(0) === '#') {
                        params = params.split('#')[1] || '';
                    }

                    if (!arg.charAt(1)) {
                        return params;
                    }

                    arg = arg.substring(1);
                    params = params.split('&');

                    for (var i = 0, ii = params.length; i < ii; i++) {
                        param = params[i].split('=');
                        if (param[0] === arg) {
                            return param[1] || '';
                        }
                    }

                    return null;
                }

            return '';
        }(arg, url);
    };
};

raygunJsUrlFactory(window, window.GG.Raygun);
window.GG.Raygun._seal();

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


;(function () {

  var object =  true ? exports : typeof self != 'undefined' ? self : // #8: web workers
  $.global; // #31: ExtendScript

  var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

  function InvalidCharacterError(message) {
    this.message = message;
  }
  InvalidCharacterError.prototype = new Error();
  InvalidCharacterError.prototype.name = 'InvalidCharacterError';

  // encoder
  // [https://gist.github.com/999166] by [https://github.com/nignag]
  object.btoa || (object.btoa = function (input) {
    var str = String(input);
    for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars, output = '';
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)) {
      charCode = str.charCodeAt(idx += 3 / 4);
      if (charCode > 0xFF) {
        throw new InvalidCharacterError("'btoa' failed: The string to be encoded contains characters outside of the Latin1 range.");
      }
      block = block << 8 | charCode;
    }
    return output;
  });

  // decoder
  // [https://gist.github.com/1020396] by [https://github.com/atk]
  object.atob || (object.atob = function (input) {
    var str = String(input).replace(/[=]+$/, ''); // #31: ExtendScript bad parse of /=
    if (str.length % 4 == 1) {
      throw new InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
    }
    for (
    // initialize result and counters
    var bc = 0, bs, buffer, idx = 0, output = '';
    // get next character
    buffer = str.charAt(idx++);
    // character found in table? initialize bit storage and add its ascii value;
    ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
    // and if not first of each 4 characters,
    // convert the first 8 bits to one ascii character
    bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0) {
      // try to find character in table (0-63, not found => -1)
      buffer = chars.indexOf(buffer);
    }
    return output;
  });
})();

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(415);
module.exports = __webpack_require__(47).RegExp.escape;

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isObject = __webpack_require__(9),
    isArray = __webpack_require__(151),
    SPECIES = __webpack_require__(11)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  }return C === undefined ? Array : C;
};

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(407);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(4),
    toPrimitive = __webpack_require__(43),
    NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(68),
    gOPS = __webpack_require__(123),
    pIE = __webpack_require__(98);
module.exports = function (it) {
  var result = getKeys(it),
      getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it),
        isEnum = pIE.f,
        i = 0,
        key;
    while (symbols.length > i) {
      if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
  }return result;
};

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getKeys = __webpack_require__(68),
    toIObject = __webpack_require__(29);
module.exports = function (object, el) {
  var O = toIObject(object),
      keys = getKeys(O),
      length = keys.length,
      index = 0,
      key;
  while (length > index) {
    if (O[key = keys[index++]] === el) return key;
  }
};

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var path = __webpack_require__(413),
    invoke = __webpack_require__(119),
    aFunction = __webpack_require__(25);
module.exports = function () /* ...pargs */{
  var fn = aFunction(this),
      length = arguments.length,
      pargs = Array(length),
      i = 0,
      _ = path._,
      holder = false;
  while (length > i) {
    if ((pargs[i] = arguments[i++]) === _) holder = true;
  }return function () /* ...args */{
    var that = this,
        aLen = arguments.length,
        j = 0,
        k = 0,
        args;
    if (!holder && !aLen) return invoke(fn, pargs, that);
    args = pargs.slice();
    if (holder) for (; length > j; j++) {
      if (args[j] === _) args[j] = arguments[k++];
    }while (aLen > k) {
      args.push(arguments[k++]);
    }return invoke(fn, args, that);
  };
};

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(6);

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(0),
    $re = __webpack_require__(414)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) {
    return $re(it);
  } });

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { copyWithin: __webpack_require__(218) });

__webpack_require__(76)('copyWithin');

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(0),
    $every = __webpack_require__(41)(4);

$export($export.P + $export.F * !__webpack_require__(39)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { fill: __webpack_require__(143) });

__webpack_require__(76)('fill');

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(0),
    $filter = __webpack_require__(41)(2);

$export($export.P + $export.F * !__webpack_require__(39)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)

var $export = __webpack_require__(0),
    $find = __webpack_require__(41)(6),
    KEY = 'findIndex',
    forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () {
  forced = false;
});
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /*, that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(76)(KEY);

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)

var $export = __webpack_require__(0),
    $find = __webpack_require__(41)(5),
    KEY = 'find',
    forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () {
  forced = false;
});
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /*, that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(76)(KEY);

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(0),
    $forEach = __webpack_require__(41)(0),
    STRICT = __webpack_require__(39)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ctx = __webpack_require__(48),
    $export = __webpack_require__(0),
    toObject = __webpack_require__(17),
    call = __webpack_require__(227),
    isArrayIter = __webpack_require__(150),
    toLength = __webpack_require__(16),
    createProperty = __webpack_require__(144),
    getIterFn = __webpack_require__(167);

$export($export.S + $export.F * !__webpack_require__(121)(function (iter) {
  Array.from(iter);
}), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /*, mapfn = undefined, thisArg = undefined*/) {
    var O = toObject(arrayLike),
        C = typeof this == 'function' ? this : Array,
        aLen = arguments.length,
        mapfn = aLen > 1 ? arguments[1] : undefined,
        mapping = mapfn !== undefined,
        index = 0,
        iterFn = getIterFn(O),
        length,
        result,
        step,
        iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(0),
    $indexOf = __webpack_require__(115)(false),
    $native = [].indexOf,
    NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(39)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /*, fromIndex = 0 */) {
    return NEGATIVE_ZERO
    // convert -0 to +0
    ? $native.apply(this, arguments) || 0 : $indexOf(this, searchElement, arguments[1]);
  }
});

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(0);

$export($export.S, 'Array', { isArray: __webpack_require__(151) });

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)

var $export = __webpack_require__(0),
    toIObject = __webpack_require__(29),
    arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(97) != Object || !__webpack_require__(39)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(0),
    toIObject = __webpack_require__(29),
    toInteger = __webpack_require__(57),
    toLength = __webpack_require__(16),
    $native = [].lastIndexOf,
    NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(39)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /*, fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this),
        length = toLength(O.length),
        index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (; index >= 0; index--) {
      if (index in O) if (O[index] === searchElement) return index || 0;
    }return -1;
  }
});

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(0),
    $map = __webpack_require__(41)(1);

$export($export.P + $export.F * !__webpack_require__(39)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(0),
    createProperty = __webpack_require__(144);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(7)(function () {
  function F() {}
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of() /* ...args */{
    var index = 0,
        aLen = arguments.length,
        result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) {
      createProperty(result, index, arguments[index++]);
    }result.length = aLen;
    return result;
  }
});

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(0),
    $reduce = __webpack_require__(220);

$export($export.P + $export.F * !__webpack_require__(39)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(0),
    $reduce = __webpack_require__(220);

$export($export.P + $export.F * !__webpack_require__(39)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(0),
    html = __webpack_require__(148),
    cof = __webpack_require__(37),
    toIndex = __webpack_require__(71),
    toLength = __webpack_require__(16),
    arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(7)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length),
        klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toIndex(begin, len),
        upTo = toIndex(end, len),
        size = toLength(upTo - start),
        cloned = Array(size),
        i = 0;
    for (; i < size; i++) {
      cloned[i] = klass == 'String' ? this.charAt(start + i) : this[start + i];
    }return cloned;
  }
});

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(0),
    $some = __webpack_require__(41)(3);

$export($export.P + $export.F * !__webpack_require__(39)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(0),
    aFunction = __webpack_require__(25),
    toObject = __webpack_require__(17),
    fails = __webpack_require__(7),
    $sort = [].sort,
    test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(39)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined ? $sort.call(toObject(this)) : $sort.call(toObject(this), aFunction(comparefn));
  }
});

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(70)('Array');

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(0);

$export($export.S, 'Date', { now: function now() {
    return new Date().getTime();
  } });

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()

var $export = __webpack_require__(0),
    fails = __webpack_require__(7),
    getTime = Date.prototype.getTime;

var lz = function lz(num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (fails(function () {
  return new Date(-5e13 - 1).toISOString() != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  new Date(NaN).toISOString();
})), 'Date', {
  toISOString: function toISOString() {
    if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
    var d = this,
        y = d.getUTCFullYear(),
        m = d.getUTCMilliseconds(),
        s = y < 0 ? '-' : y > 9999 ? '+' : '';
    return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) + '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) + 'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) + ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
  }
});

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(0),
    toObject = __webpack_require__(17),
    toPrimitive = __webpack_require__(43);

$export($export.P + $export.F * __webpack_require__(7)(function () {
  return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({ toISOString: function toISOString() {
      return 1;
    } }) !== 1;
}), 'Date', {
  toJSON: function toJSON(key) {
    var O = toObject(this),
        pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var TO_PRIMITIVE = __webpack_require__(11)('toPrimitive'),
    proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(26)(proto, TO_PRIMITIVE, __webpack_require__(409));

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DateProto = Date.prototype,
    INVALID_DATE = 'Invalid Date',
    TO_STRING = 'toString',
    $toString = DateProto[TO_STRING],
    getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(27)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(0);

$export($export.P, 'Function', { bind: __webpack_require__(221) });

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isObject = __webpack_require__(9),
    getPrototypeOf = __webpack_require__(34),
    HAS_INSTANCE = __webpack_require__(11)('hasInstance'),
    FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(13).f(FunctionProto, HAS_INSTANCE, { value: function value(O) {
    if (typeof this != 'function' || !isObject(O)) return false;
    if (!isObject(this.prototype)) return O instanceof this;
    // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
    while (O = getPrototypeOf(O)) {
      if (this.prototype === O) return true;
    }return false;
  } });

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var dP = __webpack_require__(13).f,
    createDesc = __webpack_require__(56),
    has = __webpack_require__(23),
    FProto = Function.prototype,
    nameRE = /^\s*function ([^ (]*)/,
    NAME = 'name';

var isExtensible = Object.isExtensible || function () {
  return true;
};

// 19.2.4.2 name
NAME in FProto || __webpack_require__(12) && dP(FProto, NAME, {
  configurable: true,
  get: function get() {
    try {
      var that = this,
          name = ('' + that).match(nameRE)[1];
      has(that, NAME) || !isExtensible(that) || dP(that, NAME, createDesc(5, name));
      return name;
    } catch (e) {
      return '';
    }
  }
});

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(0),
    log1p = __webpack_require__(229),
    sqrt = Math.sqrt,
    $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
// V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
&& Math.floor($acosh(Number.MAX_VALUE)) == 710
// Tor Browser bug: Math.acosh(Infinity) -> NaN 
&& $acosh(Infinity) == Infinity), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156 ? Math.log(x) + Math.LN2 : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(0),
    $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0 
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(0),
    $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0 
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(0),
    sign = __webpack_require__(155);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(0),
    exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(0),
    $expm1 = __webpack_require__(154);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(0),
    sign = __webpack_require__(155),
    pow = Math.pow,
    EPSILON = pow(2, -52),
    EPSILON32 = pow(2, -23),
    MAX32 = pow(2, 127) * (2 - EPSILON32),
    MIN32 = pow(2, -126);

var roundTiesToEven = function roundTiesToEven(n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

$export($export.S, 'Math', {
  fround: function fround(x) {
    var $abs = Math.abs(x),
        $sign = sign(x),
        a,
        result;
    if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
    a = (1 + EPSILON32 / EPSILON) * $abs;
    result = a - (a - $abs);
    if (result > MAX32 || result != result) return $sign * Infinity;
    return $sign * result;
  }
});

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(0),
    abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) {
    // eslint-disable-line no-unused-vars
    var sum = 0,
        i = 0,
        aLen = arguments.length,
        larg = 0,
        arg,
        div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(0),
    $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(7)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff,
        xn = +x,
        yn = +y,
        xl = UINT16 & xn,
        yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) / Math.LN10;
  }
});

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { log1p: __webpack_require__(229) });

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { sign: __webpack_require__(155) });

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(0),
    expm1 = __webpack_require__(154),
    exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(7)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1 ? (expm1(x) - expm1(-x)) / 2 : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(0),
    expm1 = __webpack_require__(154),
    exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x),
        b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global = __webpack_require__(6),
    has = __webpack_require__(23),
    cof = __webpack_require__(37),
    inheritIfRequired = __webpack_require__(149),
    toPrimitive = __webpack_require__(43),
    fails = __webpack_require__(7),
    gOPN = __webpack_require__(67).f,
    gOPD = __webpack_require__(33).f,
    dP = __webpack_require__(13).f,
    $trim = __webpack_require__(80).trim,
    NUMBER = 'Number',
    $Number = global[NUMBER],
    Base = $Number,
    proto = $Number.prototype
// Opera ~12 has broken Object#toString
,
    BROKEN_COF = cof(__webpack_require__(66)(proto)) == NUMBER,
    TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function toNumber(argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0),
        third,
        radix,
        maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66:case 98:
          radix = 2;maxCode = 49;break; // fast equal /^0b[01]+$/i
        case 79:case 111:
          radix = 8;maxCode = 55;break; // fast equal /^0o[0-7]+$/i
        default:
          return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      }return parseInt(digits, radix);
    }
  }return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value,
        that = this;
    return that instanceof $Number
    // check on 1..constructor(foo) case
    && (BROKEN_COF ? fails(function () {
      proto.valueOf.call(that);
    }) : cof(that) != NUMBER) ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(12) ? gOPN(Base) : (
  // ES3:
  'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
  // ES6 (in case, if modules with ES6 Number statics required before):
  'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' + 'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger').split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(27)(global, NUMBER, $Number);
}

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(0);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(0),
    _isFinite = __webpack_require__(6).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', { isInteger: __webpack_require__(226) });

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    return number != number;
  }
});

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(0),
    isInteger = __webpack_require__(226),
    abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(0),
    $parseFloat = __webpack_require__(236);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(0),
    $parseInt = __webpack_require__(237);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(0),
    toInteger = __webpack_require__(57),
    aNumberValue = __webpack_require__(217),
    repeat = __webpack_require__(162),
    $toFixed = 1..toFixed,
    floor = Math.floor,
    data = [0, 0, 0, 0, 0, 0],
    ERROR = 'Number.toFixed: incorrect invocation!',
    ZERO = '0';

var multiply = function multiply(n, c) {
  var i = -1,
      c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function divide(n) {
  var i = 6,
      c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = c % n * 1e7;
  }
};
var numToString = function numToString() {
  var i = 6,
      s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  }return s;
};
var pow = function pow(x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function log(x) {
  var n = 0,
      x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  }return n;
};

$export($export.P + $export.F * (!!$toFixed && (0.00008.toFixed(3) !== '0.000' || 0.9.toFixed(0) !== '1' || 1.255.toFixed(2) !== '1.25' || 1000000000000000128..toFixed(0) !== '1000000000000000128') || !__webpack_require__(7)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR),
        f = toInteger(fractionDigits),
        s = '',
        m = ZERO,
        e,
        z,
        j,
        k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    }return m;
  }
});

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(0),
    $fails = __webpack_require__(7),
    aNumberValue = __webpack_require__(217),
    $toPrecision = 1..toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(0);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(230) });

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(0);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(66) });

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(0);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(12), 'Object', { defineProperties: __webpack_require__(231) });

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(0);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(12), 'Object', { defineProperty: __webpack_require__(13).f });

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(9),
    meta = __webpack_require__(55).onFreeze;

__webpack_require__(42)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(29),
    $getOwnPropertyDescriptor = __webpack_require__(33).f;

__webpack_require__(42)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(42)('getOwnPropertyNames', function () {
  return __webpack_require__(232).f;
});

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(17),
    $getPrototypeOf = __webpack_require__(34);

__webpack_require__(42)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(9);

__webpack_require__(42)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(9);

__webpack_require__(42)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(9);

__webpack_require__(42)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { is: __webpack_require__(238) });

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(17),
    $keys = __webpack_require__(68);

__webpack_require__(42)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(9),
    meta = __webpack_require__(55).onFreeze;

__webpack_require__(42)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(9),
    meta = __webpack_require__(55).onFreeze;

__webpack_require__(42)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(157).set });

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()

var classof = __webpack_require__(96),
    test = {};
test[__webpack_require__(11)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(27)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(0),
    $parseFloat = __webpack_require__(236);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(0),
    $parseInt = __webpack_require__(237);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var LIBRARY = __webpack_require__(65),
    global = __webpack_require__(6),
    ctx = __webpack_require__(48),
    classof = __webpack_require__(96),
    $export = __webpack_require__(0),
    isObject = __webpack_require__(9),
    aFunction = __webpack_require__(25),
    anInstance = __webpack_require__(64),
    forOf = __webpack_require__(77),
    speciesConstructor = __webpack_require__(159),
    task = __webpack_require__(164).set,
    microtask = __webpack_require__(156)(),
    PROMISE = 'Promise',
    TypeError = global.TypeError,
    process = global.process,
    $Promise = global[PROMISE],
    process = global.process,
    isNode = classof(process) == 'process',
    empty = function empty() {/* empty */},
    Internal,
    GenericPromiseCapability,
    Wrapper;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1),
        FakePromise = (promise.constructor = {})[__webpack_require__(11)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) {/* empty */}
}();

// helpers
var sameConstructor = function sameConstructor(a, b) {
  // with library wrapper special case
  return a === b || a === $Promise && b === Wrapper;
};
var isThenable = function isThenable(it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var newPromiseCapability = function newPromiseCapability(C) {
  return sameConstructor($Promise, C) ? new PromiseCapability(C) : new GenericPromiseCapability(C);
};
var PromiseCapability = GenericPromiseCapability = function GenericPromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
};
var perform = function perform(exec) {
  try {
    exec();
  } catch (e) {
    return { error: e };
  }
};
var notify = function notify(promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v,
        ok = promise._s == 1,
        i = 0;
    var run = function run(reaction) {
      var handler = ok ? reaction.ok : reaction.fail,
          resolve = reaction.resolve,
          reject = reaction.reject,
          domain = reaction.domain,
          result,
          then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) {
      run(chain[i++]);
    } // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function onUnhandled(promise) {
  task.call(global, function () {
    var value = promise._v,
        abrupt,
        handler,
        console;
    if (isUnhandled(promise)) {
      abrupt = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    }promise._a = undefined;
    if (abrupt) throw abrupt.error;
  });
};
var isUnhandled = function isUnhandled(promise) {
  if (promise._h == 1) return false;
  var chain = promise._a || promise._c,
      i = 0,
      reaction;
  while (chain.length > i) {
    reaction = chain[i++];
    if (reaction.fail || !isUnhandled(reaction.promise)) return false;
  }return true;
};
var onHandleUnhandled = function onHandleUnhandled(promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function $reject(value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function $resolve(value) {
  var promise = this,
      then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  Internal = function Promise(executor) {
    this._c = []; // <- awaiting reactions
    this._a = undefined; // <- checked in isUnhandled reactions
    this._s = 0; // <- state
    this._d = false; // <- done
    this._v = undefined; // <- value
    this._h = 0; // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false; // <- notify
  };
  Internal.prototype = __webpack_require__(69)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function _catch(onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  PromiseCapability = function PromiseCapability() {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(79)($Promise, PROMISE);
__webpack_require__(70)(PROMISE);
Wrapper = __webpack_require__(47)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this),
        $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
    if (x instanceof $Promise && sameConstructor(x.constructor, this)) return x;
    var capability = newPromiseCapability(this),
        $$resolve = capability.resolve;
    $$resolve(x);
    return capability.promise;
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(121)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this,
        capability = newPromiseCapability(C),
        resolve = capability.resolve,
        reject = capability.reject;
    var abrupt = perform(function () {
      var values = [],
          index = 0,
          remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++,
            alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (abrupt) reject(abrupt.error);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this,
        capability = newPromiseCapability(C),
        reject = capability.reject;
    var abrupt = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (abrupt) reject(abrupt.error);
    return capability.promise;
  }
});

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(0),
    aFunction = __webpack_require__(25),
    anObject = __webpack_require__(4),
    rApply = (__webpack_require__(6).Reflect || {}).apply,
    fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(7)(function () {
  rApply(function () {});
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target),
        L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(0),
    create = __webpack_require__(66),
    aFunction = __webpack_require__(25),
    anObject = __webpack_require__(4),
    isObject = __webpack_require__(9),
    fails = __webpack_require__(7),
    bind = __webpack_require__(221),
    rConstruct = (__webpack_require__(6).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() {}
  return !(rConstruct(function () {}, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () {});
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /*, newTarget*/) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0:
          return new Target();
        case 1:
          return new Target(args[0]);
        case 2:
          return new Target(args[0], args[1]);
        case 3:
          return new Target(args[0], args[1], args[2]);
        case 4:
          return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype,
        instance = create(isObject(proto) ? proto : Object.prototype),
        result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(13),
    $export = __webpack_require__(0),
    anObject = __webpack_require__(4),
    toPrimitive = __webpack_require__(43);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(7)(function () {
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(0),
    gOPD = __webpack_require__(33).f,
    anObject = __webpack_require__(4);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)

var $export = __webpack_require__(0),
    anObject = __webpack_require__(4);
var Enumerate = function Enumerate(iterated) {
  this._t = anObject(iterated); // target
  this._i = 0; // next index
  var keys = this._k = [] // keys
  ,
      key;
  for (key in iterated) {
    keys.push(key);
  }
};
__webpack_require__(152)(Enumerate, 'Object', function () {
  var that = this,
      keys = that._k,
      key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(33),
    $export = __webpack_require__(0),
    anObject = __webpack_require__(4);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(0),
    getProto = __webpack_require__(34),
    anObject = __webpack_require__(4);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(33),
    getPrototypeOf = __webpack_require__(34),
    has = __webpack_require__(23),
    $export = __webpack_require__(0),
    isObject = __webpack_require__(9),
    anObject = __webpack_require__(4);

function get(target, propertyKey /*, receiver*/) {
  var receiver = arguments.length < 3 ? target : arguments[2],
      desc,
      proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value') ? desc.value : desc.get !== undefined ? desc.get.call(receiver) : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(0),
    anObject = __webpack_require__(4),
    $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(235) });

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(0),
    anObject = __webpack_require__(4),
    $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(0),
    setProto = __webpack_require__(157);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(13),
    gOPD = __webpack_require__(33),
    getPrototypeOf = __webpack_require__(34),
    has = __webpack_require__(23),
    $export = __webpack_require__(0),
    createDesc = __webpack_require__(56),
    anObject = __webpack_require__(4),
    isObject = __webpack_require__(9);

function set(target, propertyKey, V /*, receiver*/) {
  var receiver = arguments.length < 4 ? target : arguments[3],
      ownDesc = gOPD.f(anObject(target), propertyKey),
      existingDescriptor,
      proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
    existingDescriptor.value = V;
    dP.f(receiver, propertyKey, existingDescriptor);
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global = __webpack_require__(6),
    inheritIfRequired = __webpack_require__(149),
    dP = __webpack_require__(13).f,
    gOPN = __webpack_require__(67).f,
    isRegExp = __webpack_require__(120),
    $flags = __webpack_require__(118),
    $RegExp = global.RegExp,
    Base = $RegExp,
    proto = $RegExp.prototype,
    re1 = /a/g,
    re2 = /a/g
// "new" creates a new object, old webkit buggy here
,
    CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(12) && (!CORRECT_NEW || __webpack_require__(7)(function () {
  re2[__webpack_require__(11)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp,
        piRE = isRegExp(p),
        fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p : inheritIfRequired(CORRECT_NEW ? new Base(piRE && !fiU ? p.source : p, f) : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f), tiRE ? this : proto, $RegExp);
  };
  var proxy = function proxy(key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function get() {
        return Base[key];
      },
      set: function set(it) {
        Base[key] = it;
      }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) {
    proxy(keys[i++]);
  }proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(27)(global, 'RegExp', $RegExp);
}

__webpack_require__(70)('RegExp');

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// @@match logic
__webpack_require__(117)('match', 1, function (defined, MATCH, $match) {
  // 21.1.3.11 String.prototype.match(regexp)
  return [function match(regexp) {
    'use strict';

    var O = defined(this),
        fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, $match];
});

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// @@replace logic
__webpack_require__(117)('replace', 2, function (defined, REPLACE, $replace) {
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue) {
    'use strict';

    var O = defined(this),
        fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined ? fn.call(searchValue, O, replaceValue) : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// @@search logic
__webpack_require__(117)('search', 1, function (defined, SEARCH, $search) {
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp) {
    'use strict';

    var O = defined(this),
        fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// @@split logic
__webpack_require__(117)('split', 2, function (defined, SPLIT, $split) {
  'use strict';

  var isRegExp = __webpack_require__(120),
      _split = $split,
      $push = [].push,
      $SPLIT = 'split',
      LENGTH = 'length',
      LAST_INDEX = 'lastIndex';
  if ('abbc'[$SPLIT](/(b)*/)[1] == 'c' || 'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 || 'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 || '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 || '.'[$SPLIT](/()()/)[LENGTH] > 1 || ''[$SPLIT](/.?/)[LENGTH]) {
    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
    // based on es5-shim implementation, need to rework it
    $split = function $split(separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return _split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') + (separator.multiline ? 'm' : '') + (separator.unicode ? 'u' : '') + (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var separator2, match, lastIndex, lastLength, i;
      // Doesn't need flags gy, but they don't hurt
      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
      while (match = separatorCopy.exec(string)) {
        // `separatorCopy.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0][LENGTH];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
            for (i = 1; i < arguments[LENGTH] - 2; i++) {
              if (arguments[i] === undefined) match[i] = undefined;
            }
          });
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
    // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    $split = function $split(separator, limit) {
      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
    };
  }
  // 21.1.3.17 String.prototype.split(separator, limit)
  return [function split(separator, limit) {
    var O = defined(this),
        fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
  }, $split];
});

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(242);
var anObject = __webpack_require__(4),
    $flags = __webpack_require__(118),
    DESCRIPTORS = __webpack_require__(12),
    TO_STRING = 'toString',
    $toString = /./[TO_STRING];

var define = function define(fn) {
  __webpack_require__(27)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(7)(function () {
  return $toString.call({ source: 'a', flags: 'b' }) != '/a/b';
})) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/', 'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
  // FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)

__webpack_require__(28)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()

__webpack_require__(28)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()

__webpack_require__(28)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()

__webpack_require__(28)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(0),
    $at = __webpack_require__(160)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])


var $export = __webpack_require__(0),
    toLength = __webpack_require__(16),
    context = __webpack_require__(161),
    ENDS_WITH = 'endsWith',
    $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(147)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /*, endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH),
        endPosition = arguments.length > 1 ? arguments[1] : undefined,
        len = toLength(that.length),
        end = endPosition === undefined ? len : Math.min(toLength(endPosition), len),
        search = String(searchString);
    return $endsWith ? $endsWith.call(that, search, end) : that.slice(end - search.length, end) === search;
  }
});

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()

__webpack_require__(28)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)

__webpack_require__(28)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)

__webpack_require__(28)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(0),
    toIndex = __webpack_require__(71),
    fromCharCode = String.fromCharCode,
    $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) {
    // eslint-disable-line no-unused-vars
    var res = [],
        aLen = arguments.length,
        i = 0,
        code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000 ? fromCharCode(code) : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00));
    }return res.join('');
  }
});

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)


var $export = __webpack_require__(0),
    context = __webpack_require__(161),
    INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(147)(INCLUDES), 'String', {
  includes: function includes(searchString /*, position = 0 */) {
    return !!~context(this, searchString, INCLUDES).indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()

__webpack_require__(28)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $at = __webpack_require__(160)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(153)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0; // next index
  // 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t,
      index = this._i,
      point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)

__webpack_require__(28)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(0),
    toIObject = __webpack_require__(29),
    toLength = __webpack_require__(16);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw),
        len = toLength(tpl.length),
        aLen = arguments.length,
        res = [],
        i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    }return res.join('');
  }
});

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(0);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(162)
});

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()

__webpack_require__(28)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])


var $export = __webpack_require__(0),
    toLength = __webpack_require__(16),
    context = __webpack_require__(161),
    STARTS_WITH = 'startsWith',
    $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(147)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /*, position = 0 */) {
    var that = context(this, searchString, STARTS_WITH),
        index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length)),
        search = String(searchString);
    return $startsWith ? $startsWith.call(that, search, index) : that.slice(index, index + search.length) === search;
  }
});

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()

__webpack_require__(28)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()

__webpack_require__(28)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()

__webpack_require__(28)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()

__webpack_require__(80)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var global = __webpack_require__(6),
    has = __webpack_require__(23),
    DESCRIPTORS = __webpack_require__(12),
    $export = __webpack_require__(0),
    redefine = __webpack_require__(27),
    META = __webpack_require__(55).KEY,
    $fails = __webpack_require__(7),
    shared = __webpack_require__(124),
    setToStringTag = __webpack_require__(79),
    uid = __webpack_require__(72),
    wks = __webpack_require__(11),
    wksExt = __webpack_require__(240),
    wksDefine = __webpack_require__(166),
    keyOf = __webpack_require__(411),
    enumKeys = __webpack_require__(410),
    isArray = __webpack_require__(151),
    anObject = __webpack_require__(4),
    toIObject = __webpack_require__(29),
    toPrimitive = __webpack_require__(43),
    createDesc = __webpack_require__(56),
    _create = __webpack_require__(66),
    gOPNExt = __webpack_require__(232),
    $GOPD = __webpack_require__(33),
    $DP = __webpack_require__(13),
    $keys = __webpack_require__(68),
    gOPD = $GOPD.f,
    dP = $DP.f,
    gOPN = gOPNExt.f,
    $Symbol = global.Symbol,
    $JSON = global.JSON,
    _stringify = $JSON && $JSON.stringify,
    PROTOTYPE = 'prototype',
    HIDDEN = wks('_hidden'),
    TO_PRIMITIVE = wks('toPrimitive'),
    isEnum = {}.propertyIsEnumerable,
    SymbolRegistry = shared('symbol-registry'),
    AllSymbols = shared('symbols'),
    OPSymbols = shared('op-symbols'),
    ObjectProto = Object[PROTOTYPE],
    USE_NATIVE = typeof $Symbol == 'function',
    QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function get() {
      return dP(this, 'a', { value: 7 }).a;
    }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function wrap(tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && _typeof($Symbol.iterator) == 'symbol' ? function (it) {
  return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    }return setSymbolDesc(it, key, D);
  }return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P)),
      i = 0,
      l = keys.length,
      key;
  while (l > i) {
    $defineProperty(it, key = keys[i++], P[key]);
  }return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it)),
      result = [],
      i = 0,
      key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  }return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto,
      names = gOPN(IS_OP ? OPSymbols : toIObject(it)),
      result = [],
      i = 0,
      key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  }return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function _Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function $set(value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(67).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(98).f = $propertyIsEnumerable;
  __webpack_require__(123).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(65)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var symbols =
// 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), i = 0; symbols.length > i;) {
  wks(symbols[i++]);
}for (var symbols = $keys(wks.store), i = 0; symbols.length > i;) {
  wksDefine(symbols[i++]);
}$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function _for(key) {
    return has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key) {
    if (isSymbol(key)) return keyOf(SymbolRegistry, key);
    throw TypeError(key + ' is not a symbol!');
  },
  useSetter: function useSetter() {
    setter = true;
  },
  useSimple: function useSimple() {
    setter = false;
  }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    var args = [it],
        i = 1,
        replacer,
        $replacer;
    while (arguments.length > i) {
      args.push(arguments[i++]);
    }replacer = args[1];
    if (typeof replacer == 'function') $replacer = replacer;
    if ($replacer || !isArray(replacer)) replacer = function replacer(key, value) {
      if ($replacer) value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(26)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(0),
    $typed = __webpack_require__(125),
    buffer = __webpack_require__(165),
    anObject = __webpack_require__(4),
    toIndex = __webpack_require__(71),
    toLength = __webpack_require__(16),
    isObject = __webpack_require__(9),
    ArrayBuffer = __webpack_require__(6).ArrayBuffer,
    speciesConstructor = __webpack_require__(159),
    $ArrayBuffer = buffer.ArrayBuffer,
    $DataView = buffer.DataView,
    $isView = $typed.ABV && ArrayBuffer.isView,
    $slice = $ArrayBuffer.prototype.slice,
    VIEW = $typed.VIEW,
    ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(7)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength,
        first = toIndex(start, len),
        final = toIndex(end === undefined ? len : end, len),
        result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first)),
        viewS = new $DataView(this),
        viewT = new $DataView(result),
        index = 0;
    while (first < final) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    }return result;
  }
});

__webpack_require__(70)(ARRAY_BUFFER);

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(0);
$export($export.G + $export.W + $export.F * !__webpack_require__(125).ABV, {
  DataView: __webpack_require__(165).DataView
});

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(50)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var weak = __webpack_require__(224);

// 23.4 WeakSet Objects
__webpack_require__(116)('WeakSet', function (get) {
  return function WeakSet() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(this, value, true);
  }
}, weak, false, true);

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes

var $export = __webpack_require__(0),
    $includes = __webpack_require__(115)(true);

$export($export.P, 'Array', {
  includes: function includes(el /*, fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(76)('includes');

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(0),
    microtask = __webpack_require__(156)(),
    process = __webpack_require__(6).process,
    isNode = __webpack_require__(37)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(0),
    cof = __webpack_require__(37);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(223)('Map') });

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0,
        $x1 = x1 >>> 0,
        $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff,
        $u = +u,
        $v = +v,
        u0 = $u & UINT16,
        v0 = $v & UINT16,
        u1 = $u >> 16,
        v1 = $v >> 16,
        t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0,
        $x1 = x1 >>> 0,
        $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff,
        $u = +u,
        $v = +v,
        u0 = $u & UINT16,
        v0 = $v & UINT16,
        u1 = $u >>> 16,
        v1 = $v >>> 16,
        t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(0),
    toObject = __webpack_require__(17),
    aFunction = __webpack_require__(25),
    $defineProperty = __webpack_require__(13);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(12) && $export($export.P + __webpack_require__(122), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(0),
    toObject = __webpack_require__(17),
    aFunction = __webpack_require__(25),
    $defineProperty = __webpack_require__(13);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(12) && $export($export.P + __webpack_require__(122), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0),
    $entries = __webpack_require__(234)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(0),
    ownKeys = __webpack_require__(235),
    toIObject = __webpack_require__(29),
    gOPD = __webpack_require__(33),
    createProperty = __webpack_require__(144);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object),
        getDesc = gOPD.f,
        keys = ownKeys(O),
        result = {},
        i = 0,
        key;
    while (keys.length > i) {
      createProperty(result, key = keys[i++], getDesc(O, key));
    }return result;
  }
});

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(0),
    toObject = __webpack_require__(17),
    toPrimitive = __webpack_require__(43),
    getPrototypeOf = __webpack_require__(34),
    getOwnPropertyDescriptor = __webpack_require__(33).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(12) && $export($export.P + __webpack_require__(122), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this),
        K = toPrimitive(P, true),
        D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(0),
    toObject = __webpack_require__(17),
    toPrimitive = __webpack_require__(43),
    getPrototypeOf = __webpack_require__(34),
    getOwnPropertyDescriptor = __webpack_require__(33).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(12) && $export($export.P + __webpack_require__(122), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this),
        K = toPrimitive(P, true),
        D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0),
    $values = __webpack_require__(234)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable

var $export = __webpack_require__(0),
    global = __webpack_require__(6),
    core = __webpack_require__(47),
    microtask = __webpack_require__(156)(),
    OBSERVABLE = __webpack_require__(11)('observable'),
    aFunction = __webpack_require__(25),
    anObject = __webpack_require__(4),
    anInstance = __webpack_require__(64),
    redefineAll = __webpack_require__(69),
    hide = __webpack_require__(26),
    forOf = __webpack_require__(77),
    RETURN = forOf.RETURN;

var getMethod = function getMethod(fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function cleanupSubscription(subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function subscriptionClosed(subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function closeSubscription(subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function Subscription(observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer),
        subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function cleanup() {
        subscription.unsubscribe();
      };else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  }if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() {
    closeSubscription(this);
  }
});

var SubscriptionObserver = function SubscriptionObserver(subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    }cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      }cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function next(value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          }observer.complete();
        }
      });
      return function () {
        done = true;
      };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = Array(l); i < l;) {
      items[i] = arguments[i++];
    }return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var i = 0; i < items.length; ++i) {
            observer.next(items[i]);
            if (done) return;
          }observer.complete();
        }
      });
      return function () {
        done = true;
      };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () {
  return this;
});

$export($export.G, { Observable: $Observable });

__webpack_require__(70)('Observable');

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var metadata = __webpack_require__(49),
    anObject = __webpack_require__(4),
    toMetaKey = metadata.key,
    ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
    ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
  } });

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var metadata = __webpack_require__(49),
    anObject = __webpack_require__(4),
    toMetaKey = metadata.key,
    getOrCreateMetadataMap = metadata.map,
    store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /*, targetKey */) {
    var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]),
        metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
    if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
    if (metadataMap.size) return true;
    var targetMetadata = store.get(target);
    targetMetadata['delete'](targetKey);
    return !!targetMetadata.size || store['delete'](target);
  } });

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Set = __webpack_require__(243),
    from = __webpack_require__(219),
    metadata = __webpack_require__(49),
    anObject = __webpack_require__(4),
    getPrototypeOf = __webpack_require__(34),
    ordinaryOwnMetadataKeys = metadata.keys,
    toMetaKey = metadata.key;

var ordinaryMetadataKeys = function ordinaryMetadataKeys(O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P),
      parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /*, targetKey */) {
    return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
  } });

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var metadata = __webpack_require__(49),
    anObject = __webpack_require__(4),
    getPrototypeOf = __webpack_require__(34),
    ordinaryHasOwnMetadata = metadata.has,
    ordinaryGetOwnMetadata = metadata.get,
    toMetaKey = metadata.key;

var ordinaryGetMetadata = function ordinaryGetMetadata(MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /*, targetKey */) {
    return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
  } });

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var metadata = __webpack_require__(49),
    anObject = __webpack_require__(4),
    ordinaryOwnMetadataKeys = metadata.keys,
    toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /*, targetKey */) {
    return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
  } });

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var metadata = __webpack_require__(49),
    anObject = __webpack_require__(4),
    ordinaryGetOwnMetadata = metadata.get,
    toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /*, targetKey */) {
    return ordinaryGetOwnMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
  } });

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var metadata = __webpack_require__(49),
    anObject = __webpack_require__(4),
    getPrototypeOf = __webpack_require__(34),
    ordinaryHasOwnMetadata = metadata.has,
    toMetaKey = metadata.key;

var ordinaryHasMetadata = function ordinaryHasMetadata(MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /*, targetKey */) {
    return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
  } });

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var metadata = __webpack_require__(49),
    anObject = __webpack_require__(4),
    ordinaryHasOwnMetadata = metadata.has,
    toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /*, targetKey */) {
    return ordinaryHasOwnMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
  } });

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var metadata = __webpack_require__(49),
    anObject = __webpack_require__(4),
    aFunction = __webpack_require__(25),
    toMetaKey = metadata.key,
    ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
    return function decorator(target, targetKey) {
      ordinaryDefineOwnMetadata(metadataKey, metadataValue, (targetKey !== undefined ? anObject : aFunction)(target), toMetaKey(targetKey));
    };
  } });

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(223)('Set') });

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at

var $export = __webpack_require__(0),
    $at = __webpack_require__(160)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/

var $export = __webpack_require__(0),
    defined = __webpack_require__(38),
    toLength = __webpack_require__(16),
    isRegExp = __webpack_require__(120),
    getFlags = __webpack_require__(118),
    RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function $RegExpStringIterator(regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(152)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this),
        flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp),
        rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end

var $export = __webpack_require__(0),
    $pad = __webpack_require__(239);

$export($export.P, 'String', {
  padEnd: function padEnd(maxLength /*, fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end

var $export = __webpack_require__(0),
    $pad = __webpack_require__(239);

$export($export.P, 'String', {
  padStart: function padStart(maxLength /*, fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim

__webpack_require__(80)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim

__webpack_require__(80)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(166)('asyncIterator');

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(166)('observable');

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://github.com/ljharb/proposal-global
var $export = __webpack_require__(0);

$export($export.S, 'System', { global: __webpack_require__(6) });

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $iterators = __webpack_require__(168),
    redefine = __webpack_require__(27),
    global = __webpack_require__(6),
    hide = __webpack_require__(26),
    Iterators = __webpack_require__(78),
    wks = __webpack_require__(11),
    ITERATOR = wks('iterator'),
    TO_STRING_TAG = wks('toStringTag'),
    ArrayValues = Iterators.Array;

for (var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++) {
  var NAME = collections[i],
      Collection = global[NAME],
      proto = Collection && Collection.prototype,
      key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    for (key in $iterators) {
      if (!proto[key]) redefine(proto, key, $iterators[key], true);
    }
  }
}

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(0),
    $task = __webpack_require__(164);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(6),
    $export = __webpack_require__(0),
    invoke = __webpack_require__(119),
    partial = __webpack_require__(412),
    navigator = global.navigator,
    MSIE = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
var wrap = function wrap(set) {
  return MSIE ? function (fn, time /*, ...args */) {
    return set(invoke(partial, [].slice.call(arguments, 2), typeof fn == 'function' ? fn : Function(fn)), time);
  } : set;
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(535);
__webpack_require__(474);
__webpack_require__(476);
__webpack_require__(475);
__webpack_require__(478);
__webpack_require__(480);
__webpack_require__(485);
__webpack_require__(479);
__webpack_require__(477);
__webpack_require__(487);
__webpack_require__(486);
__webpack_require__(482);
__webpack_require__(483);
__webpack_require__(481);
__webpack_require__(473);
__webpack_require__(484);
__webpack_require__(488);
__webpack_require__(489);
__webpack_require__(441);
__webpack_require__(443);
__webpack_require__(442);
__webpack_require__(491);
__webpack_require__(490);
__webpack_require__(461);
__webpack_require__(471);
__webpack_require__(472);
__webpack_require__(462);
__webpack_require__(463);
__webpack_require__(464);
__webpack_require__(465);
__webpack_require__(466);
__webpack_require__(467);
__webpack_require__(468);
__webpack_require__(469);
__webpack_require__(470);
__webpack_require__(444);
__webpack_require__(445);
__webpack_require__(446);
__webpack_require__(447);
__webpack_require__(448);
__webpack_require__(449);
__webpack_require__(450);
__webpack_require__(451);
__webpack_require__(452);
__webpack_require__(453);
__webpack_require__(454);
__webpack_require__(455);
__webpack_require__(456);
__webpack_require__(457);
__webpack_require__(458);
__webpack_require__(459);
__webpack_require__(460);
__webpack_require__(522);
__webpack_require__(527);
__webpack_require__(534);
__webpack_require__(525);
__webpack_require__(517);
__webpack_require__(518);
__webpack_require__(523);
__webpack_require__(528);
__webpack_require__(530);
__webpack_require__(513);
__webpack_require__(514);
__webpack_require__(515);
__webpack_require__(516);
__webpack_require__(519);
__webpack_require__(520);
__webpack_require__(521);
__webpack_require__(524);
__webpack_require__(526);
__webpack_require__(529);
__webpack_require__(531);
__webpack_require__(532);
__webpack_require__(533);
__webpack_require__(436);
__webpack_require__(438);
__webpack_require__(437);
__webpack_require__(440);
__webpack_require__(439);
__webpack_require__(425);
__webpack_require__(423);
__webpack_require__(429);
__webpack_require__(426);
__webpack_require__(432);
__webpack_require__(434);
__webpack_require__(422);
__webpack_require__(428);
__webpack_require__(419);
__webpack_require__(433);
__webpack_require__(417);
__webpack_require__(431);
__webpack_require__(430);
__webpack_require__(424);
__webpack_require__(427);
__webpack_require__(416);
__webpack_require__(418);
__webpack_require__(421);
__webpack_require__(420);
__webpack_require__(435);
__webpack_require__(168);
__webpack_require__(507);
__webpack_require__(512);
__webpack_require__(242);
__webpack_require__(508);
__webpack_require__(509);
__webpack_require__(510);
__webpack_require__(511);
__webpack_require__(492);
__webpack_require__(241);
__webpack_require__(243);
__webpack_require__(244);
__webpack_require__(547);
__webpack_require__(536);
__webpack_require__(537);
__webpack_require__(542);
__webpack_require__(545);
__webpack_require__(546);
__webpack_require__(540);
__webpack_require__(543);
__webpack_require__(541);
__webpack_require__(544);
__webpack_require__(538);
__webpack_require__(539);
__webpack_require__(493);
__webpack_require__(494);
__webpack_require__(495);
__webpack_require__(496);
__webpack_require__(497);
__webpack_require__(500);
__webpack_require__(498);
__webpack_require__(499);
__webpack_require__(501);
__webpack_require__(502);
__webpack_require__(503);
__webpack_require__(504);
__webpack_require__(506);
__webpack_require__(505);
__webpack_require__(548);
__webpack_require__(574);
__webpack_require__(577);
__webpack_require__(576);
__webpack_require__(578);
__webpack_require__(579);
__webpack_require__(575);
__webpack_require__(580);
__webpack_require__(581);
__webpack_require__(559);
__webpack_require__(562);
__webpack_require__(558);
__webpack_require__(556);
__webpack_require__(557);
__webpack_require__(560);
__webpack_require__(561);
__webpack_require__(551);
__webpack_require__(573);
__webpack_require__(582);
__webpack_require__(550);
__webpack_require__(552);
__webpack_require__(554);
__webpack_require__(553);
__webpack_require__(555);
__webpack_require__(564);
__webpack_require__(565);
__webpack_require__(567);
__webpack_require__(566);
__webpack_require__(569);
__webpack_require__(568);
__webpack_require__(570);
__webpack_require__(571);
__webpack_require__(572);
__webpack_require__(549);
__webpack_require__(563);
__webpack_require__(585);
__webpack_require__(584);
__webpack_require__(583);
module.exports = __webpack_require__(47);

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*! http://mths.be/base64 v0.1.0 by @mathias | MIT license */
;(function (root) {

	// Detect free variables `exports`.
	var freeExports = ( false ? 'undefined' : _typeof(exports)) == 'object' && exports;

	// Detect free variable `module`.
	var freeModule = ( false ? 'undefined' : _typeof(module)) == 'object' && module && module.exports == freeExports && module;

	// Detect free variable `global`, from Node.js or Browserified code, and use
	// it as `root`.
	var freeGlobal = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) == 'object' && global;
	if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
		root = freeGlobal;
	}

	/*--------------------------------------------------------------------------*/

	var InvalidCharacterError = function InvalidCharacterError(message) {
		this.message = message;
	};
	InvalidCharacterError.prototype = new Error();
	InvalidCharacterError.prototype.name = 'InvalidCharacterError';

	var error = function error(message) {
		// Note: the error messages used throughout this file match those used by
		// the native `atob`/`btoa` implementation in Chromium.
		throw new InvalidCharacterError(message);
	};

	var TABLE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	// http://whatwg.org/html/common-microsyntaxes.html#space-character
	var REGEX_SPACE_CHARACTERS = /[\t\n\f\r ]/g;

	// `decode` is designed to be fully compatible with `atob` as described in the
	// HTML Standard. http://whatwg.org/html/webappapis.html#dom-windowbase64-atob
	// The optimized base64-decoding algorithm used is based on @atk’s excellent
	// implementation. https://gist.github.com/atk/1020396
	var decode = function decode(input) {
		input = String(input).replace(REGEX_SPACE_CHARACTERS, '');
		var length = input.length;
		if (length % 4 == 0) {
			input = input.replace(/==?$/, '');
			length = input.length;
		}
		if (length % 4 == 1 ||
		// http://whatwg.org/C#alphanumeric-ascii-characters
		/[^+a-zA-Z0-9/]/.test(input)) {
			error('Invalid character: the string to be decoded is not correctly encoded.');
		}
		var bitCounter = 0;
		var bitStorage;
		var buffer;
		var output = '';
		var position = -1;
		while (++position < length) {
			buffer = TABLE.indexOf(input.charAt(position));
			bitStorage = bitCounter % 4 ? bitStorage * 64 + buffer : buffer;
			// Unless this is the first of a group of 4 characters…
			if (bitCounter++ % 4) {
				// …convert the first 8 bits to a single ASCII character.
				output += String.fromCharCode(0xFF & bitStorage >> (-2 * bitCounter & 6));
			}
		}
		return output;
	};

	// `encode` is designed to be fully compatible with `btoa` as described in the
	// HTML Standard: http://whatwg.org/html/webappapis.html#dom-windowbase64-btoa
	var encode = function encode(input) {
		input = String(input);
		if (/[^\0-\xFF]/.test(input)) {
			// Note: no need to special-case astral symbols here, as surrogates are
			// matched, and the input is supposed to only contain ASCII anyway.
			error('The string to be encoded contains characters outside of the ' + 'Latin1 range.');
		}
		var padding = input.length % 3;
		var output = '';
		var position = -1;
		var a;
		var b;
		var c;
		var d;
		var buffer;
		// Make sure any padding is handled outside of the loop.
		var length = input.length - padding;

		while (++position < length) {
			// Read three bytes, i.e. 24 bits.
			a = input.charCodeAt(position) << 16;
			b = input.charCodeAt(++position) << 8;
			c = input.charCodeAt(++position);
			buffer = a + b + c;
			// Turn the 24 bits into four chunks of 6 bits each, and append the
			// matching character for each of them to the output.
			output += TABLE.charAt(buffer >> 18 & 0x3F) + TABLE.charAt(buffer >> 12 & 0x3F) + TABLE.charAt(buffer >> 6 & 0x3F) + TABLE.charAt(buffer & 0x3F);
		}

		if (padding == 2) {
			a = input.charCodeAt(position) << 8;
			b = input.charCodeAt(++position);
			buffer = a + b;
			output += TABLE.charAt(buffer >> 10) + TABLE.charAt(buffer >> 4 & 0x3F) + TABLE.charAt(buffer << 2 & 0x3F) + '=';
		} else if (padding == 1) {
			buffer = input.charCodeAt(position);
			output += TABLE.charAt(buffer >> 2) + TABLE.charAt(buffer << 4 & 0x3F) + '==';
		}

		return output;
	};

	var base64 = {
		'encode': encode,
		'decode': decode,
		'version': '0.1.0'
	};

	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if ("function" == 'function' && _typeof(__webpack_require__(326)) == 'object' && __webpack_require__(326)) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return base64;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && !freeExports.nodeType) {
		if (freeModule) {
			// in Node.js or RingoJS v0.8.0+
			freeModule.exports = base64;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (var key in base64) {
				base64.hasOwnProperty(key) && (freeExports[key] = base64[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.base64 = base64;
	}
})(undefined);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(108)(module), __webpack_require__(75)))

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;

var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i];
  revLookup[code.charCodeAt(i)] = i;
}

revLookup['-'.charCodeAt(0)] = 62;
revLookup['_'.charCodeAt(0)] = 63;

function placeHoldersCount(b64) {
  var len = b64.length;
  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4');
  }

  // the number of equal signs (place holders)
  // if there are two placeholders, than the two characters before it
  // represent one byte
  // if there is only one, then the three characters before it represent 2 bytes
  // this is just a cheap hack to not do indexOf twice
  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0;
}

function byteLength(b64) {
  // base64 is 4/3 + up to two characters of the original data
  return b64.length * 3 / 4 - placeHoldersCount(b64);
}

function toByteArray(b64) {
  var i, j, l, tmp, placeHolders, arr;
  var len = b64.length;
  placeHolders = placeHoldersCount(b64);

  arr = new Arr(len * 3 / 4 - placeHolders);

  // if there are placeholders, only get up to the last complete 4 chars
  l = placeHolders > 0 ? len - 4 : len;

  var L = 0;

  for (i = 0, j = 0; i < l; i += 4, j += 3) {
    tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
    arr[L++] = tmp >> 16 & 0xFF;
    arr[L++] = tmp >> 8 & 0xFF;
    arr[L++] = tmp & 0xFF;
  }

  if (placeHolders === 2) {
    tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
    arr[L++] = tmp & 0xFF;
  } else if (placeHolders === 1) {
    tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
    arr[L++] = tmp >> 8 & 0xFF;
    arr[L++] = tmp & 0xFF;
  }

  return arr;
}

function tripletToBase64(num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}

function encodeChunk(uint8, start, end) {
  var tmp;
  var output = [];
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + uint8[i + 2];
    output.push(tripletToBase64(tmp));
  }
  return output.join('');
}

function fromByteArray(uint8) {
  var tmp;
  var len = uint8.length;
  var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
  var output = '';
  var parts = [];
  var maxChunkLength = 16383; // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1];
    output += lookup[tmp >> 2];
    output += lookup[tmp << 4 & 0x3F];
    output += '==';
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1];
    output += lookup[tmp >> 10];
    output += lookup[tmp >> 4 & 0x3F];
    output += lookup[tmp << 2 & 0x3F];
    output += '=';
  }

  parts.push(output);

  return parts.join('');
}

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(588);
var ieee754 = __webpack_require__(627);
var isArray = __webpack_require__(628);

exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined ? global.TYPED_ARRAY_SUPPORT : typedArraySupport();

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength();

function typedArraySupport() {
  try {
    var arr = new Uint8Array(1);
    arr.__proto__ = { __proto__: Uint8Array.prototype, foo: function foo() {
        return 42;
      } };
    return arr.foo() === 42 && // typed array instances can be augmented
    typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
    arr.subarray(1, 1).byteLength === 0; // ie10 has broken `subarray`
  } catch (e) {
    return false;
  }
}

function kMaxLength() {
  return Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}

function createBuffer(that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length');
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length);
    that.__proto__ = Buffer.prototype;
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length);
    }
    that.length = length;
  }

  return that;
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer(arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length);
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error('If encoding is specified then the first argument must be a string');
    }
    return allocUnsafe(this, arg);
  }
  return from(this, arg, encodingOrOffset, length);
}

Buffer.poolSize = 8192; // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype;
  return arr;
};

function from(that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number');
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length);
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset);
  }

  return fromObject(that, value);
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length);
};

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype;
  Buffer.__proto__ = Uint8Array;
  if (typeof Symbol !== 'undefined' && Symbol.species && Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    });
  }
}

function assertSize(size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number');
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative');
  }
}

function alloc(that, size, fill, encoding) {
  assertSize(size);
  if (size <= 0) {
    return createBuffer(that, size);
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string' ? createBuffer(that, size).fill(fill, encoding) : createBuffer(that, size).fill(fill);
  }
  return createBuffer(that, size);
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding);
};

function allocUnsafe(that, size) {
  assertSize(size);
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0;
    }
  }
  return that;
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size);
};

function fromString(that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8';
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding');
  }

  var length = byteLength(string, encoding) | 0;
  that = createBuffer(that, length);

  var actual = that.write(string, encoding);

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
  }

  return that;
}

function fromArrayLike(that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0;
  that = createBuffer(that, length);
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255;
  }
  return that;
}

function fromArrayBuffer(that, array, byteOffset, length) {
  array.byteLength; // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds');
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds');
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array);
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset);
  } else {
    array = new Uint8Array(array, byteOffset, length);
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array;
    that.__proto__ = Buffer.prototype;
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array);
  }
  return that;
}

function fromObject(that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0;
    that = createBuffer(that, len);

    if (that.length === 0) {
      return that;
    }

    obj.copy(that, 0, 0, len);
    return that;
  }

  if (obj) {
    if (typeof ArrayBuffer !== 'undefined' && obj.buffer instanceof ArrayBuffer || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0);
      }
      return fromArrayLike(that, obj);
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data);
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.');
}

function checked(length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' + 'size: 0x' + kMaxLength().toString(16) + ' bytes');
  }
  return length | 0;
}

function SlowBuffer(length) {
  if (+length != length) {
    // eslint-disable-line eqeqeq
    length = 0;
  }
  return Buffer.alloc(+length);
}

Buffer.isBuffer = function isBuffer(b) {
  return !!(b != null && b._isBuffer);
};

Buffer.compare = function compare(a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers');
  }

  if (a === b) return 0;

  var x = a.length;
  var y = b.length;

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }

  if (x < y) return -1;
  if (y < x) return 1;
  return 0;
};

Buffer.isEncoding = function isEncoding(encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true;
    default:
      return false;
  }
};

Buffer.concat = function concat(list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers');
  }

  if (list.length === 0) {
    return Buffer.alloc(0);
  }

  var i;
  if (length === undefined) {
    length = 0;
    for (i = 0; i < list.length; ++i) {
      length += list[i].length;
    }
  }

  var buffer = Buffer.allocUnsafe(length);
  var pos = 0;
  for (i = 0; i < list.length; ++i) {
    var buf = list[i];
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers');
    }
    buf.copy(buffer, pos);
    pos += buf.length;
  }
  return buffer;
};

function byteLength(string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length;
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength;
  }
  if (typeof string !== 'string') {
    string = '' + string;
  }

  var len = string.length;
  if (len === 0) return 0;

  // Use a for loop to avoid recursion
  var loweredCase = false;
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len;
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length;
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2;
      case 'hex':
        return len >>> 1;
      case 'base64':
        return base64ToBytes(string).length;
      default:
        if (loweredCase) return utf8ToBytes(string).length; // assume utf8
        encoding = ('' + encoding).toLowerCase();
        loweredCase = true;
    }
  }
}
Buffer.byteLength = byteLength;

function slowToString(encoding, start, end) {
  var loweredCase = false;

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0;
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return '';
  }

  if (end === undefined || end > this.length) {
    end = this.length;
  }

  if (end <= 0) {
    return '';
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0;
  start >>>= 0;

  if (end <= start) {
    return '';
  }

  if (!encoding) encoding = 'utf8';

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end);

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end);

      case 'ascii':
        return asciiSlice(this, start, end);

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end);

      case 'base64':
        return base64Slice(this, start, end);

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end);

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
        encoding = (encoding + '').toLowerCase();
        loweredCase = true;
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true;

function swap(b, n, m) {
  var i = b[n];
  b[n] = b[m];
  b[m] = i;
}

Buffer.prototype.swap16 = function swap16() {
  var len = this.length;
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits');
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1);
  }
  return this;
};

Buffer.prototype.swap32 = function swap32() {
  var len = this.length;
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits');
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3);
    swap(this, i + 1, i + 2);
  }
  return this;
};

Buffer.prototype.swap64 = function swap64() {
  var len = this.length;
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits');
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7);
    swap(this, i + 1, i + 6);
    swap(this, i + 2, i + 5);
    swap(this, i + 3, i + 4);
  }
  return this;
};

Buffer.prototype.toString = function toString() {
  var length = this.length | 0;
  if (length === 0) return '';
  if (arguments.length === 0) return utf8Slice(this, 0, length);
  return slowToString.apply(this, arguments);
};

Buffer.prototype.equals = function equals(b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
  if (this === b) return true;
  return Buffer.compare(this, b) === 0;
};

Buffer.prototype.inspect = function inspect() {
  var str = '';
  var max = exports.INSPECT_MAX_BYTES;
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
    if (this.length > max) str += ' ... ';
  }
  return '<Buffer ' + str + '>';
};

Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer');
  }

  if (start === undefined) {
    start = 0;
  }
  if (end === undefined) {
    end = target ? target.length : 0;
  }
  if (thisStart === undefined) {
    thisStart = 0;
  }
  if (thisEnd === undefined) {
    thisEnd = this.length;
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index');
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0;
  }
  if (thisStart >= thisEnd) {
    return -1;
  }
  if (start >= end) {
    return 1;
  }

  start >>>= 0;
  end >>>= 0;
  thisStart >>>= 0;
  thisEnd >>>= 0;

  if (this === target) return 0;

  var x = thisEnd - thisStart;
  var y = end - start;
  var len = Math.min(x, y);

  var thisCopy = this.slice(thisStart, thisEnd);
  var targetCopy = target.slice(start, end);

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i];
      y = targetCopy[i];
      break;
    }
  }

  if (x < y) return -1;
  if (y < x) return 1;
  return 0;
};

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1;

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset;
    byteOffset = 0;
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff;
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000;
  }
  byteOffset = +byteOffset; // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
  if (byteOffset >= buffer.length) {
    if (dir) return -1;else byteOffset = buffer.length - 1;
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0;else return -1;
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding);
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1;
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
  } else if (typeof val === 'number') {
    val = val & 0xFF; // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
  }

  throw new TypeError('val must be string, number or Buffer');
}

function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
  var indexSize = 1;
  var arrLength = arr.length;
  var valLength = val.length;

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase();
    if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1;
      }
      indexSize = 2;
      arrLength /= 2;
      valLength /= 2;
      byteOffset /= 2;
    }
  }

  function read(buf, i) {
    if (indexSize === 1) {
      return buf[i];
    } else {
      return buf.readUInt16BE(i * indexSize);
    }
  }

  var i;
  if (dir) {
    var foundIndex = -1;
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i;
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
      } else {
        if (foundIndex !== -1) i -= i - foundIndex;
        foundIndex = -1;
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
    for (i = byteOffset; i >= 0; i--) {
      var found = true;
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false;
          break;
        }
      }
      if (found) return i;
    }
  }

  return -1;
}

Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1;
};

Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};

Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};

function hexWrite(buf, string, offset, length) {
  offset = Number(offset) || 0;
  var remaining = buf.length - offset;
  if (!length) {
    length = remaining;
  } else {
    length = Number(length);
    if (length > remaining) {
      length = remaining;
    }
  }

  // must be an even number of digits
  var strLen = string.length;
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string');

  if (length > strLen / 2) {
    length = strLen / 2;
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16);
    if (isNaN(parsed)) return i;
    buf[offset + i] = parsed;
  }
  return i;
}

function utf8Write(buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}

function asciiWrite(buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length);
}

function latin1Write(buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length);
}

function base64Write(buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length);
}

function ucs2Write(buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}

Buffer.prototype.write = function write(string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8';
    length = this.length;
    offset = 0;
    // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset;
    length = this.length;
    offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0;
    if (isFinite(length)) {
      length = length | 0;
      if (encoding === undefined) encoding = 'utf8';
    } else {
      encoding = length;
      length = undefined;
    }
    // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
  }

  var remaining = this.length - offset;
  if (length === undefined || length > remaining) length = remaining;

  if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds');
  }

  if (!encoding) encoding = 'utf8';

  var loweredCase = false;
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length);

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length);

      case 'ascii':
        return asciiWrite(this, string, offset, length);

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length);

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length);

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length);

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
        encoding = ('' + encoding).toLowerCase();
        loweredCase = true;
    }
  }
};

Buffer.prototype.toJSON = function toJSON() {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  };
};

function base64Slice(buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf);
  } else {
    return base64.fromByteArray(buf.slice(start, end));
  }
}

function utf8Slice(buf, start, end) {
  end = Math.min(buf.length, end);
  var res = [];

  var i = start;
  while (i < end) {
    var firstByte = buf[i];
    var codePoint = null;
    var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint;

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte;
          }
          break;
        case 2:
          secondByte = buf[i + 1];
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint;
            }
          }
          break;
        case 3:
          secondByte = buf[i + 1];
          thirdByte = buf[i + 2];
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint;
            }
          }
          break;
        case 4:
          secondByte = buf[i + 1];
          thirdByte = buf[i + 2];
          fourthByte = buf[i + 3];
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint;
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD;
      bytesPerSequence = 1;
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000;
      res.push(codePoint >>> 10 & 0x3FF | 0xD800);
      codePoint = 0xDC00 | codePoint & 0x3FF;
    }

    res.push(codePoint);
    i += bytesPerSequence;
  }

  return decodeCodePointsArray(res);
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;

function decodeCodePointsArray(codePoints) {
  var len = codePoints.length;
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = '';
  var i = 0;
  while (i < len) {
    res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
  }
  return res;
}

function asciiSlice(buf, start, end) {
  var ret = '';
  end = Math.min(buf.length, end);

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F);
  }
  return ret;
}

function latin1Slice(buf, start, end) {
  var ret = '';
  end = Math.min(buf.length, end);

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i]);
  }
  return ret;
}

function hexSlice(buf, start, end) {
  var len = buf.length;

  if (!start || start < 0) start = 0;
  if (!end || end < 0 || end > len) end = len;

  var out = '';
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i]);
  }
  return out;
}

function utf16leSlice(buf, start, end) {
  var bytes = buf.slice(start, end);
  var res = '';
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
  }
  return res;
}

Buffer.prototype.slice = function slice(start, end) {
  var len = this.length;
  start = ~~start;
  end = end === undefined ? len : ~~end;

  if (start < 0) {
    start += len;
    if (start < 0) start = 0;
  } else if (start > len) {
    start = len;
  }

  if (end < 0) {
    end += len;
    if (end < 0) end = 0;
  } else if (end > len) {
    end = len;
  }

  if (end < start) end = start;

  var newBuf;
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end);
    newBuf.__proto__ = Buffer.prototype;
  } else {
    var sliceLen = end - start;
    newBuf = new Buffer(sliceLen, undefined);
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start];
    }
  }

  return newBuf;
};

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset(offset, ext, length) {
  if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}

Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);

  var val = this[offset];
  var mul = 1;
  var i = 0;
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul;
  }

  return val;
};

Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length);
  }

  var val = this[offset + --byteLength];
  var mul = 1;
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul;
  }

  return val;
};

Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length);
  return this[offset];
};

Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  return this[offset] | this[offset + 1] << 8;
};

Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  return this[offset] << 8 | this[offset + 1];
};

Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};

Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};

Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);

  var val = this[offset];
  var mul = 1;
  var i = 0;
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul;
  }
  mul *= 0x80;

  if (val >= mul) val -= Math.pow(2, 8 * byteLength);

  return val;
};

Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);

  var i = byteLength;
  var mul = 1;
  var val = this[offset + --i];
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul;
  }
  mul *= 0x80;

  if (val >= mul) val -= Math.pow(2, 8 * byteLength);

  return val;
};

Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length);
  if (!(this[offset] & 0x80)) return this[offset];
  return (0xff - this[offset] + 1) * -1;
};

Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  var val = this[offset] | this[offset + 1] << 8;
  return val & 0x8000 ? val | 0xFFFF0000 : val;
};

Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  var val = this[offset + 1] | this[offset] << 8;
  return val & 0x8000 ? val | 0xFFFF0000 : val;
};

Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};

Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};

Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);
  return ieee754.read(this, offset, true, 23, 4);
};

Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);
  return ieee754.read(this, offset, false, 23, 4);
};

Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length);
  return ieee754.read(this, offset, true, 52, 8);
};

Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length);
  return ieee754.read(this, offset, false, 52, 8);
};

function checkInt(buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
  if (offset + ext > buf.length) throw new RangeError('Index out of range');
}

Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    checkInt(this, value, offset, byteLength, maxBytes, 0);
  }

  var mul = 1;
  var i = 0;
  this[offset] = value & 0xFF;
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = value / mul & 0xFF;
  }

  return offset + byteLength;
};

Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    checkInt(this, value, offset, byteLength, maxBytes, 0);
  }

  var i = byteLength - 1;
  var mul = 1;
  this[offset + i] = value & 0xFF;
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = value / mul & 0xFF;
  }

  return offset + byteLength;
};

Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
  this[offset] = value & 0xff;
  return offset + 1;
};

function objectWriteUInt16(buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1;
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
  } else {
    objectWriteUInt16(this, value, offset, true);
  }
  return offset + 2;
};

Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
  } else {
    objectWriteUInt16(this, value, offset, false);
  }
  return offset + 2;
};

function objectWriteUInt32(buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1;
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
  } else {
    objectWriteUInt32(this, value, offset, true);
  }
  return offset + 4;
};

Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
  } else {
    objectWriteUInt32(this, value, offset, false);
  }
  return offset + 4;
};

Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1);

    checkInt(this, value, offset, byteLength, limit - 1, -limit);
  }

  var i = 0;
  var mul = 1;
  var sub = 0;
  this[offset] = value & 0xFF;
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1;
    }
    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
  }

  return offset + byteLength;
};

Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1);

    checkInt(this, value, offset, byteLength, limit - 1, -limit);
  }

  var i = byteLength - 1;
  var mul = 1;
  var sub = 0;
  this[offset + i] = value & 0xFF;
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1;
    }
    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
  }

  return offset + byteLength;
};

Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
  if (value < 0) value = 0xff + value + 1;
  this[offset] = value & 0xff;
  return offset + 1;
};

Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
  } else {
    objectWriteUInt16(this, value, offset, true);
  }
  return offset + 2;
};

Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
  } else {
    objectWriteUInt16(this, value, offset, false);
  }
  return offset + 2;
};

Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
  } else {
    objectWriteUInt32(this, value, offset, true);
  }
  return offset + 4;
};

Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
  if (value < 0) value = 0xffffffff + value + 1;
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
  } else {
    objectWriteUInt32(this, value, offset, false);
  }
  return offset + 4;
};

function checkIEEE754(buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range');
  if (offset < 0) throw new RangeError('Index out of range');
}

function writeFloat(buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4);
  return offset + 4;
}

Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert);
};

Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert);
};

function writeDouble(buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308);
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8);
  return offset + 8;
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert);
};

Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert);
};

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
  if (!start) start = 0;
  if (!end && end !== 0) end = this.length;
  if (targetStart >= target.length) targetStart = target.length;
  if (!targetStart) targetStart = 0;
  if (end > 0 && end < start) end = start;

  // Copy 0 bytes; we're done
  if (end === start) return 0;
  if (target.length === 0 || this.length === 0) return 0;

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds');
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds');
  if (end < 0) throw new RangeError('sourceEnd out of bounds');

  // Are we oob?
  if (end > this.length) end = this.length;
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start;
  }

  var len = end - start;
  var i;

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start];
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start];
    }
  } else {
    Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
  }

  return len;
};

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start;
      start = 0;
      end = this.length;
    } else if (typeof end === 'string') {
      encoding = end;
      end = this.length;
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0);
      if (code < 256) {
        val = code;
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string');
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding);
    }
  } else if (typeof val === 'number') {
    val = val & 255;
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index');
  }

  if (end <= start) {
    return this;
  }

  start = start >>> 0;
  end = end === undefined ? this.length : end >>> 0;

  if (!val) val = 0;

  var i;
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val;
    }
  } else {
    var bytes = Buffer.isBuffer(val) ? val : utf8ToBytes(new Buffer(val, encoding).toString());
    var len = bytes.length;
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len];
    }
  }

  return this;
};

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;

function base64clean(str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '');
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return '';
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '=';
  }
  return str;
}

function stringtrim(str) {
  if (str.trim) return str.trim();
  return str.replace(/^\s+|\s+$/g, '');
}

function toHex(n) {
  if (n < 16) return '0' + n.toString(16);
  return n.toString(16);
}

function utf8ToBytes(string, units) {
  units = units || Infinity;
  var codePoint;
  var length = string.length;
  var leadSurrogate = null;
  var bytes = [];

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i);

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          continue;
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          continue;
        }

        // valid lead
        leadSurrogate = codePoint;

        continue;
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        leadSurrogate = codePoint;
        continue;
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
    }

    leadSurrogate = null;

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break;
      bytes.push(codePoint);
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break;
      bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break;
      bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break;
      bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
    } else {
      throw new Error('Invalid code point');
    }
  }

  return bytes;
}

function asciiToBytes(str) {
  var byteArray = [];
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
  }
  return byteArray;
}

function utf16leToBytes(str, units) {
  var c, hi, lo;
  var byteArray = [];
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break;

    c = str.charCodeAt(i);
    hi = c >> 8;
    lo = c % 256;
    byteArray.push(lo);
    byteArray.push(hi);
  }

  return byteArray;
}

function base64ToBytes(str) {
  return base64.toByteArray(base64clean(str));
}

function blitBuffer(src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if (i + offset >= dst.length || i >= src.length) break;
    dst[i + offset] = src[i];
  }
  return i;
}

function isnan(val) {
  return val !== val; // eslint-disable-line no-self-compare
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(75)))

/***/ }),
/* 590 */,
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/



exports.match = matchQuery;
exports.parse = parseQuery;

// -----------------------------------------------------------------------------

var RE_MEDIA_QUERY = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i,
    RE_MQ_EXPRESSION = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/,
    RE_MQ_FEATURE = /^(?:(min|max)-)?(.+)/,
    RE_LENGTH_UNIT = /(em|rem|px|cm|mm|in|pt|pc)?$/,
    RE_RESOLUTION_UNIT = /(dpi|dpcm|dppx)?$/;

function matchQuery(mediaQuery, values) {
    return parseQuery(mediaQuery).some(function (query) {
        var inverse = query.inverse;

        // Either the parsed or specified `type` is "all", or the types must be
        // equal for a match.
        var typeMatch = query.type === 'all' || values.type === query.type;

        // Quit early when `type` doesn't match, but take "not" into account.
        if (typeMatch && inverse || !(typeMatch || inverse)) {
            return false;
        }

        var expressionsMatch = query.expressions.every(function (expression) {
            var feature = expression.feature,
                modifier = expression.modifier,
                expValue = expression.value,
                value = values[feature];

            // Missing or falsy values don't match.
            if (!value) {
                return false;
            }

            switch (feature) {
                case 'orientation':
                case 'scan':
                    return value.toLowerCase() === expValue.toLowerCase();

                case 'width':
                case 'height':
                case 'device-width':
                case 'device-height':
                    expValue = toPx(expValue);
                    value = toPx(value);
                    break;

                case 'resolution':
                    expValue = toDpi(expValue);
                    value = toDpi(value);
                    break;

                case 'aspect-ratio':
                case 'device-aspect-ratio':
                case /* Deprecated */'device-pixel-ratio':
                    expValue = toDecimal(expValue);
                    value = toDecimal(value);
                    break;

                case 'grid':
                case 'color':
                case 'color-index':
                case 'monochrome':
                    expValue = parseInt(expValue, 10) || 1;
                    value = parseInt(value, 10) || 0;
                    break;
            }

            switch (modifier) {
                case 'min':
                    return value >= expValue;
                case 'max':
                    return value <= expValue;
                default:
                    return value === expValue;
            }
        });

        return expressionsMatch && !inverse || !expressionsMatch && inverse;
    });
}

function parseQuery(mediaQuery) {
    return mediaQuery.split(',').map(function (query) {
        query = query.trim();

        var captures = query.match(RE_MEDIA_QUERY),
            modifier = captures[1],
            type = captures[2],
            expressions = captures[3] || '',
            parsed = {};

        parsed.inverse = !!modifier && modifier.toLowerCase() === 'not';
        parsed.type = type ? type.toLowerCase() : 'all';

        // Split expressions into a list.
        expressions = expressions.match(/\([^\)]+\)/g) || [];

        parsed.expressions = expressions.map(function (expression) {
            var captures = expression.match(RE_MQ_EXPRESSION),
                feature = captures[1].toLowerCase().match(RE_MQ_FEATURE);

            return {
                modifier: feature[1],
                feature: feature[2],
                value: captures[2]
            };
        });

        return parsed;
    });
}

// -- Utilities ----------------------------------------------------------------

function toDecimal(ratio) {
    var decimal = Number(ratio),
        numbers;

    if (!decimal) {
        numbers = ratio.match(/^(\d+)\s*\/\s*(\d+)$/);
        decimal = numbers[1] / numbers[2];
    }

    return decimal;
}

function toDpi(resolution) {
    var value = parseFloat(resolution),
        units = String(resolution).match(RE_RESOLUTION_UNIT)[1];

    switch (units) {
        case 'dpcm':
            return value / 2.54;
        case 'dppx':
            return value * 96;
        default:
            return value;
    }
}

function toPx(length) {
    var value = parseFloat(length),
        units = String(length).match(RE_LENGTH_UNIT)[1];

    switch (units) {
        case 'em':
            return value * 16;
        case 'rem':
            return value * 16;
        case 'cm':
            return value * 96 / 2.54;
        case 'mm':
            return value * 96 / 2.54 / 10;
        case 'in':
            return value * 96;
        case 'pt':
            return value * 72;
        case 'pc':
            return value * 72 / 12;
        default:
            return value;
    }
}

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _ButtonDefault = __webpack_require__(169);

var _ButtonDefault2 = _interopRequireDefault(_ButtonDefault);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonContinue = function (_Component) {
	_inherits(ButtonContinue, _Component);

	function ButtonContinue() {
		_classCallCheck(this, ButtonContinue);

		return _possibleConstructorReturn(this, (ButtonContinue.__proto__ || Object.getPrototypeOf(ButtonContinue)).apply(this, arguments));
	}

	_createClass(ButtonContinue, [{
		key: 'getButtonText',
		value: function getButtonText() {
			var _props = this.props,
			    buttonText = _props.buttonText,
			    intl = _props.intl;

			return buttonText ? buttonText : intl.formatMessage('content|_defaults|continueLabel');
		}
	}, {
		key: 'handleContinue',
		value: function handleContinue(e) {
			e.preventDefault();
			var _props2 = this.props,
			    buttonState = _props2.buttonState,
			    handleContinueProp = _props2.handleContinueProp;

			if (buttonState === 'loading') {
				return;
			}
			handleContinueProp();
		}
	}, {
		key: 'render',
		value: function render() {
			var _props3 = this.props,
			    id = _props3.id,
			    type = _props3.type,
			    intl = _props3.intl,
			    qaSelector = _props3.qaSelector,
			    buttonState = _props3.buttonState,
			    isDisabled = _props3.isDisabled,
			    showDisabled = _props3.showDisabled,
			    decoratorClass = _props3.decoratorClass,
			    wrapperDecoratorClass = _props3.wrapperDecoratorClass,
			    continueButtonFootnote = _props3.continueButtonFootnote,
			    accessibleIsLoadingText = _props3.accessibleIsLoadingText;


			var buttonText = this.getButtonText.call(this);

			return _react2.default.createElement(
				'div',
				{ className: '' + (wrapperDecoratorClass ? wrapperDecoratorClass : '') },
				_react2.default.createElement(
					_ButtonDefault2.default,
					{
						id: id,
						intl: intl,
						type: type,
						buttonState: buttonState,
						isDisabled: isDisabled,
						showDisabled: showDisabled,
						decoratorClass: 'dna-button-brand ' + (decoratorClass ? decoratorClass : '') + ' ' + (continueButtonFootnote ? 'dna-space-mbm' : ''),
						qaSelector: qaSelector,
						accessibleIsLoadingText: accessibleIsLoadingText,
						handleClick: this.handleContinue.bind(this) },
					buttonText
				),
				continueButtonFootnote && continueButtonFootnote
			);
		}
	}]);

	return ButtonContinue;
}(_react.Component);

ButtonContinue.propTypes = {
	handleContinueProp: _react.PropTypes.func.isRequired,
	buttonText: _react.PropTypes.string,
	decoratorClass: _react.PropTypes.string,
	buttonState: _react.PropTypes.string,
	intl: _react.PropTypes.object, // GG.FrontEnd.DNA.react.intl
	isDisabled: _react.PropTypes.bool,
	showDisabled: _react.PropTypes.bool,
	qaSelector: _react.PropTypes.string,
	continueButtonFootnote: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.object]),
	wrapperDecoratorClass: _react.PropTypes.string,
	id: _react.PropTypes.string,
	type: _react.PropTypes.string,
	accessibleIsLoadingText: _react.PropTypes.string
};
ButtonContinue.defaultProps = {
	id: 'continue',
	type: 'submit'
};
exports.default = ButtonContinue;

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _ButtonDefault = __webpack_require__(169);

var _ButtonDefault2 = _interopRequireDefault(_ButtonDefault);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonSocial = function (_Component) {
	_inherits(ButtonSocial, _Component);

	function ButtonSocial() {
		_classCallCheck(this, ButtonSocial);

		return _possibleConstructorReturn(this, (ButtonSocial.__proto__ || Object.getPrototypeOf(ButtonSocial)).apply(this, arguments));
	}

	_createClass(ButtonSocial, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    id = _props.id,
			    intl = _props.intl,
			    type = _props.type,
			    buttonText = _props.buttonText,
			    buttonState = _props.buttonState,
			    handleClickProp = _props.handleClickProp,
			    socialNetwork = _props.socialNetwork,
			    isDisabled = _props.isDisabled,
			    showDisabled = _props.showDisabled,
			    accessibleIsLoadingText = _props.accessibleIsLoadingText;


			return _react2.default.createElement(
				_ButtonDefault2.default,
				{
					id: id,
					intl: intl,
					type: type,
					buttonState: buttonState,
					isDisabled: isDisabled,
					showDisabled: showDisabled,
					decoratorClass: 'dna-button-' + socialNetwork.toLowerCase(),
					qaSelector: '' + socialNetwork.toLowerCase(),
					accessibleIsLoadingText: accessibleIsLoadingText,
					handleClick: handleClickProp },
				buttonText
			);
		}
	}]);

	return ButtonSocial;
}(_react.Component);

ButtonSocial.propTypes = {
	buttonText: _react.PropTypes.string.isRequired,
	handleClickProp: _react.PropTypes.func.isRequired,
	socialNetwork: _react.PropTypes.string.isRequired,
	id: _react.PropTypes.string,
	buttonState: _react.PropTypes.string,
	intl: _react.PropTypes.object, // GG.FrontEnd.DNA.react.intl
	type: _react.PropTypes.string,
	isDisabled: _react.PropTypes.bool,
	showDisabled: _react.PropTypes.bool,
	accessibleIsLoadingText: _react.PropTypes.string
};
exports.default = ButtonSocial;

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var EventEmitter = __webpack_require__(613);

exports.emitter = new EventEmitter();

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Loading = function Loading(_ref) {
	var qaSelector = _ref.qaSelector,
	    className = _ref.className,
	    accessibleText = _ref.accessibleText,
	    _ref$ariaHidden = _ref.ariaHidden,
	    ariaHidden = _ref$ariaHidden === undefined ? false : _ref$ariaHidden;
	return _react2.default.createElement(
		"span",
		{
			"data-qa": qaSelector,
			className: className,
			"aria-hidden": ariaHidden },
		_react2.default.createElement(
			"span",
			{
				className: "dna-invisible" },
			accessibleText
		)
	);
};

Loading.propTypes = {
	qaSelector: _react.PropTypes.string,
	className: _react.PropTypes.string.isRequired,
	accessibleText: _react.PropTypes.string.isRequired,
	ariaHidden: _react.PropTypes.bool.isRequired
};

exports.default = Loading;

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.isKeySuitableForNumberField = undefined;

var _value = __webpack_require__(248);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Determine whether a character is valid for entry into a number field
 * @param {number} keyCode - The key (not ascii) code of the button being pressed
 * @param {bool} allowDecimal - TWhether or not decimal separators are allowed
 * @summary Allows numbers from the top row + number pad, as well as a few
 * 			special characters to aid navigation around and out of the field
 * @returns {bool} Whether the supplied key is valid for a numerical field
 */
var isKeySuitableForNumberField = exports.isKeySuitableForNumberField = function isKeySuitableForNumberField(keyCode) {
	var allowDecimal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

	var topDigits = (0, _value.range)(48, 57);
	var numPadDigits = (0, _value.range)(96, 105);

	var validKeyCodes = [].concat(_toConsumableArray(topDigits), _toConsumableArray(numPadDigits), [8, // backspace
	9, // tab
	35, // end
	36, // home
	46, // delete
	37, // left
	39 // right
	]);

	if (allowDecimal) {
		validKeyCodes = [].concat(_toConsumableArray(validKeyCodes), [110, // numeric period
		188, // comma
		190 // period
		]);
	}

	return validKeyCodes.includes(keyCode);
};

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Cookies = exports.Cookies = function () {

	/**
  * Constructor for the JG cookie utility class
  * @param {string} analyticsCookieName
  * @paran {object} cookieSource - for unit testing
  */
	function Cookies(analyticsCookieName) {
		var cookiesSource = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		_classCallCheck(this, Cookies);

		this._analyticsCookieName = analyticsCookieName || '';
		this._cookiesSource = cookiesSource;
		this._cookies = null;
	}

	/**
  * for a given JG cookie convert it's content
  * into an object (with the appropriate keys/values)
  * @returns {object}
  */


	_createClass(Cookies, [{
		key: 'cookieToObject',
		value: function cookieToObject(cookieName) {
			var _cookies = this.cookies;
			var _cookie = null;
			var _cookieValues = {};
			_cookie = _cookies[cookieName];
			if (_cookie) {
				_cookie.split('&').forEach(function (part) {
					var _keyVal = part.split('=');
					_cookieValues[_keyVal[0]] = _keyVal[1];
				});
			}
			return _cookieValues;
		}

		/**
   * 'Getter' for the cookies source.
   * @description This is primarily here for testing
   * purposes. Think what yo get from 'document.cookie'
   * @returns {string}
   */

	}, {
		key: 'cookiesSource',
		get: function get() {
			if (this._cookiesSource === null) {
				this._cookiesSource = document.cookie;
			}
			return this._cookiesSource;
		}

		/**
   * 'Getter' for our cookies
   * @returns {object} key/value pairs
   */

	}, {
		key: 'cookies',
		get: function get() {
			if (this._cookies === null) {
				this._cookies = {};
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {
					for (var _iterator = this.cookiesSource.split('; ')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var _cookie = _step.value;

						var _equalsIndex = _cookie.indexOf('=');
						var _key = _cookie.substr(0, _equalsIndex);
						var _value = _cookie.substr(_equalsIndex + 1, _cookie.length);
						this._cookies[_key] = decodeURIComponent(_value);
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
			}
			return this._cookies;
		}

		/**
   * 'Getter' for the values/content of the JG
   * Analytics cookie.
   * @returns {object} - content split into keys/values
   */

	}, {
		key: 'analyticsCookie',
		get: function get() {
			return this.cookieToObject(this._analyticsCookieName);
		}

		/**
   * 'Getter for the values/content of
   * the JG AB Logged in cookie
   * @returns {string} - the id this cookie contains
   */

	}, {
		key: 'JgAbLoggedInCookie',
		get: function get() {
			return this.cookies.JGABID ? { value: this.cookies.JGABID.replace('id=', '') } : '';
		}

		/**
   * 'Getter' for the values/content of
   * the JG User Metadata cookie
   * @returns {object}
   */

	}, {
		key: 'JgUserMetadataCookie',
		get: function get() {
			return this.cookieToObject('JGUserMetadata');
		}
	}]);

	return Cookies;
}();

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
/**
 * HTTP request Fetch API utils module
 * @module: utils/http
 * @exports: verifyStatus, parseJSON, makeRequest, getAuthorizationHeader
 */

/**
 * verifyStatus
 * Verifies success status of fetch request
 * @param {object} response returned from fetch request
 * @returns the server response for responses with a success status, or an error object for non-success statuses
 */
var verifyStatus = exports.verifyStatus = function verifyStatus(response) {
	if (response.status >= 200 && response.status < 300) {
		return response;
	}
	var error = new Error(response.statusText);
	error.response = response;
	throw error;
};

/**
 * parseJSON
 * Parse a server response to JSON
 * @param {object} response returned from fetch request
 * @returns server response parsed to JSON
 */
var parseJSON = exports.parseJSON = function parseJSON(response) {
	if (response.status !== 204) {
		return response.json();
	}
	return '{}';
};

/**
 * makeRequest
 * Make a server request, verifying the status and parsing the response to JSON
 * @param {string} url - URL to send request
 * @param {function} action - Higher-order function that dispatches Redux action
 * @param {object} options - Fetch request options
 * @param {Number} deadline - Fetch request timeout deadline
 * @returns {object} request promise stream [thenable]
 */
var makeRequest = exports.makeRequest = function makeRequest(url, action, options, deadline) {
	action && action();
	var timeout = new Error('Request timeout');
	timeout.response = new Response(JSON.stringify({}), {
		ok: false,
		status: 408,
		statusText: 'Request Timeout'
	});
	return Promise.race([fetch(url, options), new Promise(function (resolve, reject) {
		setTimeout(function () {
			return reject(timeout);
		}, deadline);
	})]).then(verifyStatus).then(parseJSON);
};

/**
 * getAuthorizationHeader
 * Write authorization header
 * @desc Returns an Authorization header using state auth token
 * @return {object} Authorization header object
 */
var getAuthorizationHeader = exports.getAuthorizationHeader = function getAuthorizationHeader(authToken) {
	if (!authToken) {
		return new Error('No authorization data available');
	}
	return {
		'Authorization': 'Bearer ' + authToken
	};
};

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeActionCreator = makeActionCreator;
exports.dispatchAction = dispatchAction;
/**
 * Redux Action utils module
 * @module: utils/reduxAction
 * @exports: makeActionCreator, dispatchAction
 */

/**
 * Generates a function that creates an action creator
 * @param {string} type - action type the action creator passes to the reducer
 * @param {Array} argNames - Any other arguments the action creator passes to the reducer
 * @returns {function} the action creator
 * @exports makeActionCreator
 */
function makeActionCreator(type) {
  for (var _len = arguments.length, argNames = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    argNames[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var action = { type: type };
    argNames.forEach(function (arg, index) {
      action[argNames[index]] = args[index];
    });
    return action;
  };
}

/**
 * Generates a function that dispatches a Redux action
 * @param {function} dispatch - Redux dispatch function
 * @param {object} action - Action object to dispatch
 * @returns {function} Function that dispatches a Redux action
 * @exports dispatchAction
 */
function dispatchAction(dispatch, action) {
  return function () {
    dispatch(action);
  };
}

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Set up raygun with the correct app version and name
 */
var init = exports.init = function init(APP_VERSION, APP_NAME, hasInit) {
  if (window.GG && window.GG.Raygun && !hasInit) {
    hasInit = true;
    window.GG.Raygun.setVersion(APP_VERSION, APP_NAME);
  }
};

/**
 * the underlying raygun lib will not log an error
 * if the 'stack' is not available. In this scenario
 * we return a new Error
 * @param {Error} error
 * @returns {Error}
 */
var checkError = exports.checkError = function checkError(error) {
  return !error.stack || error instanceof TypeError ? new Error(error.message) : error;
};

/**
 * Use this method to log handled exceptions in the app.
 * @param {error} error - an instance of the Error class
 * @param {object} customData - additional info
 * @summary the GG.Raygun script automatically takes care
 *          of 'unhandled' js errors
 */
var logError = exports.logError = function logError(error) {
  var customData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (window.GG && window.GG.Raygun) {
    window.GG.Raygun.send(checkError(error), customData);
  }
};

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () {
	function defineProperties(target, props) {
		for (var i = 0; i < props.length; i++) {
			var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		}
	}return function (Constructor, protoProps, staticProps) {
		if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	};
}();

function _classCallCheck(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

var Cookies = exports.Cookies = function () {

	/**
  * Constructor for the JG cookie utility class
  * @param {string} analyticsCookieName
  * @paran {object} cookieSource - for unit testing
  */
	function Cookies(analyticsCookieName) {
		var cookiesSource = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];

		_classCallCheck(this, Cookies);

		this._analyticsCookieName = analyticsCookieName || '';
		this._cookiesSource = cookiesSource;
		this._cookies = null;
	}

	/**
  * for a given JG cookie convert it's content
  * into an object (with the appropriate keys/values)
  * @returns {object}
  */

	_createClass(Cookies, [{
		key: 'cookieToObject',
		value: function cookieToObject(cookieName) {
			var _cookies = this.cookies;
			var _cookie = null;
			var _cookieValues = {};
			_cookie = _cookies[cookieName];
			if (_cookie) {
				_cookie.split('&').forEach(function (part) {
					var _keyVal = part.split('=');
					_cookieValues[_keyVal[0]] = _keyVal[1];
				});
			}
			return _cookieValues;
		}

		/**
   * 'Getter' for the cookies source.
   * @description This is primarily here for testing
   * purposes. Think what yo get from 'document.cookie'
   * @returns {string}
   */

	}, {
		key: 'cookiesSource',
		get: function get() {
			if (this._cookiesSource === null) {
				this._cookiesSource = document.cookie;
			}
			return this._cookiesSource;
		}

		/**
   * 'Getter' for our cookies
   * @returns {object} key/value pairs
   */

	}, {
		key: 'cookies',
		get: function get() {
			if (this._cookies === null) {
				this._cookies = {};
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {
					for (var _iterator = this.cookiesSource.split('; ')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var _cookie = _step.value;

						var _equalsIndex = _cookie.indexOf('=');
						var _key = _cookie.substr(0, _equalsIndex);
						var _value = _cookie.substr(_equalsIndex + 1, _cookie.length);
						this._cookies[_key] = decodeURIComponent(_value);
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
			}
			return this._cookies;
		}

		/**
   * 'Getter' for the values/content of the JG
   * Analytics cookie.
   * @returns {object} - content split into keys/values
   */

	}, {
		key: 'analyticsCookie',
		get: function get() {
			return this.cookieToObject(this._analyticsCookieName);
		}

		/**
   * 'Getter for the values/content of
   * the JG AB Logged in cookie
   * @returns {string} - the id this cookie contains
   */

	}, {
		key: 'JgAbLoggedInCookie',
		get: function get() {
			return this.cookies.JGABID ? { value: this.cookies.JGABID.replace('id=', '') } : '';
		}

		/**
   * 'Getter' for the values/content of
   * the JG User Metadata cookie
   * @returns {object}
   */

	}, {
		key: 'JgUserMetadataCookie',
		get: function get() {
			return this.cookieToObject('JGUserMetadata');
		}
	}]);

	return Cookies;
}();

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Label = __webpack_require__(249);

var _Label2 = _interopRequireDefault(_Label);

var _CheckBox = __webpack_require__(603);

var _CheckBox2 = _interopRequireDefault(_CheckBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CheckBoxWithLabel = function (_Component) {
	_inherits(CheckBoxWithLabel, _Component);

	function CheckBoxWithLabel() {
		_classCallCheck(this, CheckBoxWithLabel);

		return _possibleConstructorReturn(this, (CheckBoxWithLabel.__proto__ || Object.getPrototypeOf(CheckBoxWithLabel)).apply(this, arguments));
	}

	_createClass(CheckBoxWithLabel, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    id = _props.id,
			    wrapperClass = _props.wrapperClass;


			return _react2.default.createElement(
				'div',
				{ className: 'dna-form-field ' + wrapperClass },
				_react2.default.createElement(_CheckBox2.default, this.props),
				_react2.default.createElement(_Label2.default, _extends({ forAttr: id }, this.props))
			);
		}
	}]);

	return CheckBoxWithLabel;
}(_react.Component);

CheckBoxWithLabel.propTypes = {
	handleChange: _react.PropTypes.func.isRequired,
	id: _react.PropTypes.string.isRequired,
	value: _react.PropTypes.string,
	checked: _react.PropTypes.bool.isRequired,
	label: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.object]).isRequired,
	labelIsInvisible: _react.PropTypes.bool,
	labelDecoratorClass: _react.PropTypes.string,
	wrapperClass: _react.PropTypes.string,
	qaSelector: _react.PropTypes.string
};
CheckBoxWithLabel.defaultProps = {
	wrapperClass: ''
};
exports.default = CheckBoxWithLabel;

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CheckBox = function (_Component) {
	_inherits(CheckBox, _Component);

	function CheckBox() {
		_classCallCheck(this, CheckBox);

		return _possibleConstructorReturn(this, (CheckBox.__proto__ || Object.getPrototypeOf(CheckBox)).apply(this, arguments));
	}

	_createClass(CheckBox, [{
		key: "render",
		value: function render() {
			var _props = this.props,
			    id = _props.id,
			    value = _props.value,
			    checked = _props.checked,
			    handleChange = _props.handleChange,
			    required = _props.required,
			    disabled = _props.disabled,
			    qaSelector = _props.qaSelector,
			    name = _props.name;


			return _react2.default.createElement("input", {
				id: id,
				name: name || id,
				type: "checkbox",
				checked: checked,
				value: value,
				"data-qa": qaSelector,
				className: "dna-checkbox",
				onChange: handleChange,
				required: required,
				disabled: disabled });
		}
	}]);

	return CheckBox;
}(_react.Component);

CheckBox.propTypes = {
	handleChange: _react.PropTypes.func.isRequired,
	id: _react.PropTypes.string.isRequired,
	name: _react.PropTypes.string,
	value: _react.PropTypes.string,
	checked: _react.PropTypes.bool.isRequired,
	required: _react.PropTypes.bool,
	disabled: _react.PropTypes.bool,
	qaSelector: _react.PropTypes.string
};
CheckBox.defaultProps = {
	required: false,
	disabled: false
};
exports.default = CheckBox;

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _eventemitter = __webpack_require__(594);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint no-unused-expressions: 0 */

/**
 * Class representing a dna input-prefix
 * @classdesc Constructor for a dna input-prefix
 * @param {Object} options.el. Class instance's parent element
 */
var InputPrefix = function () {
	function InputPrefix() {
		var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

		_classCallCheck(this, InputPrefix);

		this.el = options.el;

		// Cancel instantiation if DOM not as expected
		if (!this.verifyDOM()) {
			_eventemitter.emitter.emit('dna.InputPrefix.didCancelInit', {
				emitter: this
			});
			return {};
		}

		this.init();

		// Everything inited as expected
		_eventemitter.emitter.emit('dna.InputPrefix.didInit', {
			emitter: this
		});

		return this;
	}
	/**
  * Verify the required DOM nodes are present
  * @description Check that the object instance's parent element, and any necessary child nodes, are present in the DOM
  * @returns {Boolean} Whether all DOM nodes are present or not
  */


	_createClass(InputPrefix, [{
		key: 'verifyDOM',
		value: function verifyDOM() {
			var hasVerified = true;
			if (!this.el || !this.el.hasAttribute('data-dna-input-prefix')) {
				hasVerified = false;
			}
			return hasVerified;
		}
		/**
   * Initialise the class
   * @description
   */

	}, {
		key: 'init',
		value: function init() {
			this.inputPadding = parseInt(getComputedStyle(this.el).paddingLeft, 10);
			this.wrapInput();
			this.createTokenEl();
			this.appendToken();
			this.setPrefix();
		}
		/**
   * Create wrapper around input
   */

	}, {
		key: 'wrapInput',
		value: function wrapInput() {
			if (!this.el.parentNode.classList.contains('dna-input-prefix')) {
				this.wrapper = document.createElement('span');
				this.wrapper.classList.add('dna-input-prefix');
				this.el.parentNode.insertBefore(this.wrapper, this.el);
				this.wrapper.appendChild(this.el);
			}
		}
		/**
   * Create element to hold prefix
   */

	}, {
		key: 'createTokenEl',
		value: function createTokenEl() {
			this.token = document.createElement('span');
			this.token.classList.add('dna-input-prefix-token');
		}
		/**
   * Append the prefix token to the input wrapper
   */

	}, {
		key: 'appendToken',
		value: function appendToken() {
			this.wrapper.appendChild(this.token);
		}
	}, {
		key: 'setPrefix',
		value: function setPrefix() {
			this.setTokenLabel();
			this.getPrefixWidth();
			this.setInputPadding();
		}
		/**
   * Set the text (label) of the prefix token to the data-dna-input-prefix value
   */

	}, {
		key: 'setTokenLabel',
		value: function setTokenLabel() {
			var dataset = this.el.dataset;
			this.token.innerHTML = dataset && dataset.dnaInputPrefix ? dataset.dnaInputPrefix : '';
		}
		/**
   * Get the computed width of the label
   */

	}, {
		key: 'getPrefixWidth',
		value: function getPrefixWidth() {
			return this.token.offsetWidth;
		}
		/**
   * Set padding on the input to account for prefix width plus its own padding
   */

	}, {
		key: 'setInputPadding',
		value: function setInputPadding() {
			this.el.style.paddingLeft = this.inputPadding + this.getPrefixWidth() + 'px';
		}
		/**
   * Reset the prefix label to latest data-dna-input-prefix value
   */

	}, {
		key: 'updatePrefix',
		value: function updatePrefix() {
			this.setTokenLabel();
			this.setInputPadding();
		}
		/**
   * Remove nodes and event listeners for cleanup
   */

	}, {
		key: 'destroy',
		value: function destroy() {
			// Remove token
			var token = this.el.parentNode.querySelector('.dna-input-prefix-token');
			token && this.el.parentNode.removeChild(token);

			// Remove Input wrapper
			var parent = this.el.parentNode.classList.contains('dna-input-prefix') ? this.el.parentNode : null;
			parent && this.el.parentNode.parentNode.removeChild(parent);
		}
	}]);

	return InputPrefix;
}();

exports.default = InputPrefix;

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Label = __webpack_require__(249);

var _Label2 = _interopRequireDefault(_Label);

var _inputPrefix = __webpack_require__(604);

var _inputPrefix2 = _interopRequireDefault(_inputPrefix);

var _browser = __webpack_require__(596);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint no-unused-expressions: 0, no-nested-ternary: 0 */

var InputWithLabel = function (_Component) {
	_inherits(InputWithLabel, _Component);

	function InputWithLabel(props) {
		_classCallCheck(this, InputWithLabel);

		// Set local state for showing/hiding field content
		var _this = _possibleConstructorReturn(this, (InputWithLabel.__proto__ || Object.getPrototypeOf(InputWithLabel)).call(this, props));

		_this.state = {
			isFieldRevealed: false
		};
		return _this;
	}
	/**
  * Initialise input prefix
  */


	_createClass(InputWithLabel, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var _props = this.props,
			    inputPrefix = _props.inputPrefix,
			    id = _props.id;


			if (inputPrefix) {
				this.inputPrefix = new _inputPrefix2.default({
					el: this.refs[id]
				});
			}
		}
		/**
   * Update input prefix
   */

	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps) {
			if (prevProps.inputPrefix !== this.props.inputPrefix) {
				this.inputPrefix.updatePrefix();
			}
		}
		/**
   * Destroy input prefix
   */

	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			if (this.inputPrefix) {
				this.inputPrefix.destroy();
				this.inputPrefix = null;
			}
		}
	}, {
		key: 'handleFieldVisibilityToggle',
		value: function handleFieldVisibilityToggle(e) {
			var isFieldRevealed = this.state.isFieldRevealed;

			e.preventDefault();
			this.setState({
				isFieldRevealed: !isFieldRevealed
			});
		}
	}, {
		key: 'handleChange',
		value: function handleChange(e) {
			// Clear validation errors then call passed-in prop change handler
			var _props2 = this.props,
			    errorKey = _props2.errorKey,
			    parent = _props2.parent,
			    handleChangeProp = _props2.handleChangeProp;

			parent.hasErrors(errorKey) && parent.clearValidation(errorKey);
			handleChangeProp(e);
		}
	}, {
		key: 'filterNumbersInput',
		value: function filterNumbersInput(e) {
			var _props3 = this.props,
			    type = _props3.type,
			    allowDecimalNumber = _props3.allowDecimalNumber;

			type === 'number' && !(0, _browser.isKeySuitableForNumberField)(e.which, !!allowDecimalNumber) && e.preventDefault();
		}
	}, {
		key: 'render',
		value: function render() {
			var _props4 = this.props,
			    type = _props4.type,
			    id = _props4.id,
			    name = _props4.name,
			    placeholder = _props4.placeholder,
			    value = _props4.value,
			    sizeVariant = _props4.sizeVariant,
			    errors = _props4.errors,
			    handleBlur = _props4.handleBlur,
			    handleFocus = _props4.handleFocus,
			    wrapperClass = _props4.wrapperClass,
			    required = _props4.required,
			    disabled = _props4.disabled,
			    nudgeText = _props4.nudgeText,
			    inputPrefix = _props4.inputPrefix,
			    toggleButtonTextHide = _props4.toggleButtonTextHide,
			    toggleButtonTextShow = _props4.toggleButtonTextShow,
			    isPasswordField = _props4.isPasswordField,
			    inputDecoratorClass = _props4.inputDecoratorClass,
			    qaSelector = _props4.qaSelector;
			var isFieldRevealed = this.state.isFieldRevealed;

			var sizeClass = sizeVariant ? 'dna-input-' + sizeVariant : '';
			var errorClass = errors ? 'dna-input-error' : '';

			return _react2.default.createElement(
				'div',
				{ className: 'dna-form-field ' + wrapperClass },
				_react2.default.createElement(_Label2.default, _extends({ forAttr: id }, this.props, { 'qa-selector': qaSelector })),
				_react2.default.createElement(
					'div',
					{ className: '' + (isPasswordField ? 'dna-input-password-wrap' : '') },
					_react2.default.createElement('input', {
						type: isPasswordField ? isFieldRevealed ? 'text' : 'password' : type,
						ref: id,
						id: id,
						name: name || id,
						placeholder: placeholder,
						className: 'dna-input ' + sizeClass + ' ' + inputDecoratorClass + ' ' + errorClass + ' ' + (isPasswordField ? 'dna-input-password' : ''),
						onBlur: handleBlur,
						onFocus: handleFocus,
						onChange: this.handleChange.bind(this),
						onKeyDown: this.filterNumbersInput.bind(this),
						value: value,
						required: required,
						disabled: disabled,
						'data-qa': qaSelector,
						'data-dna-input-prefix': inputPrefix }),
					isPasswordField && _react2.default.createElement(
						'button',
						{
							className: 'dna-input-password-button',
							type: 'button',
							onClick: this.handleFieldVisibilityToggle.bind(this) },
						isFieldRevealed ? toggleButtonTextHide : toggleButtonTextShow
					)
				),
				nudgeText && _react2.default.createElement(
					'div',
					{ className: 'dna-input-nudge' },
					nudgeText
				)
			);
		}
	}]);

	return InputWithLabel;
}(_react.Component);

InputWithLabel.propTypes = {
	handleBlur: _react.PropTypes.func,
	handleFocus: _react.PropTypes.func,
	handleChangeProp: _react.PropTypes.func.isRequired,
	type: _react.PropTypes.string,
	id: _react.PropTypes.string.isRequired,
	name: _react.PropTypes.string,
	value: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	placeholder: _react.PropTypes.string,
	label: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.object]).isRequired,
	labelIsInvisible: _react.PropTypes.bool,
	labelDecoratorClass: _react.PropTypes.string,
	wrapperClass: _react.PropTypes.string,
	inputDecoratorClass: _react.PropTypes.string,
	required: _react.PropTypes.bool,
	disabled: _react.PropTypes.bool,
	nudgeText: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.object]),
	inputPrefix: _react.PropTypes.string,
	sizeVariant: _react.PropTypes.string,
	qaSelector: _react.PropTypes.string,
	errors: _react.PropTypes.array,
	errorKey: _react.PropTypes.string,
	allowDecimalNumber: _react.PropTypes.bool,
	parent: _react.PropTypes.object,
	isPasswordField: _react.PropTypes.bool,
	toggleButtonTextHide: _react.PropTypes.string,
	toggleButtonTextShow: _react.PropTypes.string
};
InputWithLabel.defaultProps = {
	type: 'text',
	handleBlur: function handleBlur() {},
	handleChangeProp: function handleChangeProp() {},
	required: false,
	disabled: false,
	wrapperClass: '',
	inputDecoratorClass: '',
	parent: {
		hasErrors: function hasErrors() {
			return false;
		}
	},
	isPasswordField: false
};
exports.default = InputWithLabel;

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _value = __webpack_require__(248);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ValidationMessage = function (_Component) {
	_inherits(ValidationMessage, _Component);

	function ValidationMessage() {
		_classCallCheck(this, ValidationMessage);

		return _possibleConstructorReturn(this, (ValidationMessage.__proto__ || Object.getPrototypeOf(ValidationMessage)).apply(this, arguments));
	}

	_createClass(ValidationMessage, [{
		key: 'getErrors',
		value: function getErrors() {
			var _props = this.props,
			    errors = _props.errors,
			    intl = _props.intl;

			var nonEmptyErrors = errors.filter(function (error) {
				return !!error;
			});
			var formattedErrors = nonEmptyErrors.map(function (error) {
				return {
					key: error.key,
					message: intl ? intl.formatMessage(error.key, error.messageTemplateValues) : error.message
				};
			});

			var uniquelyKeyedErrors = (0, _value.deduplicateByKey)(formattedErrors, 'key');
			return (0, _value.deduplicateByKey)(uniquelyKeyedErrors, 'message').map(function (error) {
				return _react2.default.createElement(
					'li',
					{ 'data-qa': 'validationErrors',
						className: 'dna-input-validation-error',
						key: error.key },
					error.message
				);
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var wrapperClass = this.props.wrapperClass;

			return _react2.default.createElement(
				'div',
				{ className: 'dna-input-validation ' + (wrapperClass ? wrapperClass : '') },
				_react2.default.createElement(
					'ul',
					null,
					this.getErrors.call(this)
				)
			);
		}
	}]);

	return ValidationMessage;
}(_react.Component);

ValidationMessage.propTypes = {
	errors: _react.PropTypes.array.isRequired,
	wrapperClass: _react.PropTypes.string,
	intl: _react.PropTypes.object
};
ValidationMessage.defaultProps = {
	errors: []
};
exports.default = ValidationMessage;

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = Analytics;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Analytics HOC factory
 * Creates and returns a higher-order component which wraps the supplied component.
 * Handles Analytics logic.
 * @type {function} Analytics
 * @param {component} ComposedComponent - The component to wrap in the returned Analytics HOC
 * @param {string} pageName - The page container's canonical page name
 * @param {Object} analytics - Bespoke methods to be invoked by Analytics framework events
 * @param {Array} analyticsProviders - Analytics service providers used (e.g. Google Analytics)
 * @returns {Class} An Analytics HOC class
 */
function Analytics(ComposedComponent, pageName, analytics, analyticsProviders) {
	var _class, _temp;

	return _temp = _class = function (_Component) {
		_inherits(_class, _Component);

		function _class(props) {
			_classCallCheck(this, _class);

			return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));
		}

		_createClass(_class, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				var analyticsData = this.props.analyticsData;

				this.trackPageView(analyticsData);
			}
			/**
    * Track a SPA 'page view' to provided analytics providers
    * @param {object} analyticsData - pertinent tracking data required by providers
    */

		}, {
			key: 'trackPageView',
			value: function trackPageView(analyticsData) {
				analyticsProviders.forEach(function (provider) {
					provider.trackPageView(pageName, analyticsData);
				});
				// Opportunity to fire bespoke actions provided by analytics when a given page is viewed
				analytics.pageView && analytics.pageView(pageName, analyticsData, analyticsProviders);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(ComposedComponent, this.props);
			}
		}]);

		return _class;
	}(_react.Component), _class.propTypes = {
		analyticsData: _react2.default.PropTypes.object.isRequired
	}, _temp;
}

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = Intl;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _localiser = __webpack_require__(609);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 * Intl higher-order component (HOC) factory
 * Component for passing internationalisation props onto child component
 * @type {function} Intl
 */

function Intl(ComposedComponent, stringsTable) {
	var _class, _temp;

	return _temp = _class = function (_Component) {
		_inherits(_class, _Component);

		function _class(props) {
			_classCallCheck(this, _class);

			var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

			_this.locale = props.locale;
			_this.stringsTable = stringsTable;
			_this.intl = _this.getIntl();
			return _this;
		}

		_createClass(_class, [{
			key: 'getIntl',
			value: function getIntl() {
				var _this2 = this;

				return {
					locale: this.locale,
					formatMessage: function formatMessage(key, values) {
						return (0, _localiser.formatMessage)(_this2.stringsTable, key, _this2.locale, values);
					},
					formatCurrencySymbol: _localiser.currencySymbol
				};
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(ComposedComponent, _extends({}, this.props, { intl: this.intl }));
			}
		}]);

		return _class;
	}(_react.Component), _class.propTypes = {
		locale: _react.PropTypes.string.isRequired
	}, _temp;
}

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getBestLocale = getBestLocale;
exports.getTemplateForLocale = getTemplateForLocale;
exports.formatMessageInternal = formatMessageInternal;
exports.formatMessage = formatMessage;
exports.currencySymbol = currencySymbol;

var _stringFormat = __webpack_require__(814);

var _stringFormat2 = _interopRequireDefault(_stringFormat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @private
 * @type {function} getBestLocale
 * @param {string} key - The key of the message template we wish to find
 * @param {string} locale - The preferred locale for said key.  should be in 'language' or 'language-territory' format
 * @param {object} stringsTable - The full dictionary of all localisable strings in the system
 * @returns {string} - A best fit locale for given key in in the following preference order:
 * 	locale-territory
 * 	locale
 * 	en
 */
function getBestLocale(key, locale, stringsTable) {
	var bestLocale = [locale, locale.substring(0, 2), 'en'].find(function (locale) {
		var workingLocale = locale.toLowerCase();
		return stringsTable[workingLocale] && stringsTable[workingLocale].messageTemplates && stringsTable[workingLocale].messageTemplates[key];
	});

	if (!bestLocale) {
		throw new Error('Could not find any string lookup for ' + key);
	}

	return bestLocale.toLowerCase();
}

/**
 * @private
 * @type {function} - getTemplateForLocale
 * @param {string} key - The key of the message template we wish to find
 * @param {string} locale - The preferred locale for said key.  should be in 'language' or 'language-territory' format
 * @param {object} stringsTable - The full dictionary of all localisable strings in the system
 * @returns {string} The template string for a chosen locale according to getBestLocale
 */
function getTemplateForLocale(key, locale, stringsTable) {
	return stringsTable[getBestLocale(key, locale, stringsTable)].messageTemplates[key];
}

/**
 * @private
 * @type {function} getTemplateForLocale
 * @param {string} key - The key of the message template we wish to find
 * @param {object} values - A dictionary of values to interpolate into the string
 * @param {string} locale The preferred locale for said key.  should be in 'language' or 'language-territory' format
 * @param {object} stringsTable - The full dictionary of all localisable strings in the system
 * @returns {string} A formatted message string
 */
function formatMessageInternal(stringsTable, key, locale, values) {
	var formatter = !!Object.prototype.toLocaleString ? function (x) {
		return x.toLocaleString();
	} : function (x) {
		return x.toString();
	};
	var template = getTemplateForLocale(key, locale, stringsTable);

	if (!values) {
		return template;
	}

	var localeSpecificValues = {};
	for (var k in values) {
		localeSpecificValues[k] = formatter(values[k]);
	}

	return (0, _stringFormat2.default)(template, localeSpecificValues);
}

/**
 * @public
 * @type {function} getTemplateForLocale
 * @param {Object} stringsTable - Hashmap of all local string tables
 * @param {string} key - The key of the message template we wish to find
 * @param {object} values - A dictionary of values to interpolate into the string
 * @param {string} locale The preferred locale for said key.  should be in 'language' or 'language-territory' format
 * @returns {string} A formatted message string
 */
function formatMessage(stringsTable, key, locale) {
	var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

	return formatMessageInternal(stringsTable, key, locale, values);
}

/**
 * @public
 * @type {function} currencySymbol
 * @param {string} currencyCode - Currency code to find currency symbol for
 * @returns {string} currency symbol
 *
 */
function currencySymbol(currencyCode) {
	switch (currencyCode) {
		case 'AED':
			return 'د.إ';
		case 'AUD':
			return '$';
		case 'CAD':
			return '$';
		case 'EUR':
			return '€';
		case 'GBP':
			return '£';
		case 'HKD':
			return '$';
		case 'SGD':
			return '$';
		case 'USD':
			return '$';
		case 'ZAR':
			return 'R';
		default:
			return '£';
	}
}

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HeadingH1 = function (_Component) {
	_inherits(HeadingH1, _Component);

	function HeadingH1() {
		_classCallCheck(this, HeadingH1);

		return _possibleConstructorReturn(this, (HeadingH1.__proto__ || Object.getPrototypeOf(HeadingH1)).apply(this, arguments));
	}

	_createClass(HeadingH1, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    children = _props.children,
			    headingDecoratorClass = _props.headingDecoratorClass;


			return _react2.default.createElement(
				'h1',
				{ 'data-qa': 'h1-header', className: 'dna-text-center dna-h1 dna-space-mbl ' + headingDecoratorClass },
				children
			);
		}
	}]);

	return HeadingH1;
}(_react.Component);

HeadingH1.propTypes = {
	headingDecoratorClass: _react.PropTypes.string,
	children: _react2.default.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node])
};
HeadingH1.defaultProps = {
	headingDecoratorClass: ''
};
exports.default = HeadingH1;

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HeadingH2 = function (_Component) {
	_inherits(HeadingH2, _Component);

	function HeadingH2() {
		_classCallCheck(this, HeadingH2);

		return _possibleConstructorReturn(this, (HeadingH2.__proto__ || Object.getPrototypeOf(HeadingH2)).apply(this, arguments));
	}

	_createClass(HeadingH2, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    children = _props.children,
			    qaSelector = _props.qaSelector,
			    headingDecoratorClass = _props.headingDecoratorClass;


			return _react2.default.createElement(
				'h2',
				{ 'data-qa': qaSelector, className: 'dna-h2 ' + headingDecoratorClass },
				children
			);
		}
	}]);

	return HeadingH2;
}(_react.Component);

HeadingH2.propTypes = {
	qaSelector: _react.PropTypes.string,
	headingDecoratorClass: _react.PropTypes.string,
	children: _react2.default.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node])
};
HeadingH2.defaultProps = {
	headingDecoratorClass: ''
};
exports.default = HeadingH2;

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function createError(msg, code, props) {
    var err = msg instanceof Error ? msg : new Error(msg);
    var key;

    if ((typeof code === 'undefined' ? 'undefined' : _typeof(code)) === 'object') {
        props = code;
    } else if (code != null) {
        err.code = code;
    }

    if (props) {
        for (key in props) {
            err[key] = props[key];
        }
    }

    return err;
}

module.exports = createError;

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty;

//
// We store our EE objects in a plain object whose properties are event names.
// If `Object.create(null)` is not supported we prefix the event names with a
// `~` to make sure that the built-in object properties are not overridden or
// used as an attack vector.
// We also assume that `Object.create(null)` is available when the event name
// is an ES6 Symbol.
//
var prefix = typeof Object.create !== 'function' ? '~' : false;

/**
 * Representation of a single EventEmitter function.
 *
 * @param {Function} fn Event handler to be called.
 * @param {Mixed} context Context for function execution.
 * @param {Boolean} [once=false] Only emit once
 * @api private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Minimal EventEmitter interface that is molded against the Node.js
 * EventEmitter interface.
 *
 * @constructor
 * @api public
 */
function EventEmitter() {} /* Nothing to set */

/**
 * Hold the assigned EventEmitters by name.
 *
 * @type {Object}
 * @private
 */
EventEmitter.prototype._events = undefined;

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @api public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var events = this._events,
      names = [],
      name;

  if (!events) return names;

  for (name in events) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return a list of assigned event listeners.
 *
 * @param {String} event The events that should be listed.
 * @param {Boolean} exists We only need to know if there are listeners.
 * @returns {Array|Boolean}
 * @api public
 */
EventEmitter.prototype.listeners = function listeners(event, exists) {
  var evt = prefix ? prefix + event : event,
      available = this._events && this._events[evt];

  if (exists) return !!available;
  if (!available) return [];
  if (available.fn) return [available.fn];

  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
    ee[i] = available[i].fn;
  }

  return ee;
};

/**
 * Emit an event to all registered event listeners.
 *
 * @param {String} event The name of the event.
 * @returns {Boolean} Indication if we've emitted an event.
 * @api public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events || !this._events[evt]) return false;

  var listeners = this._events[evt],
      len = arguments.length,
      args,
      i;

  if ('function' === typeof listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1:
        return listeners.fn.call(listeners.context), true;
      case 2:
        return listeners.fn.call(listeners.context, a1), true;
      case 3:
        return listeners.fn.call(listeners.context, a1, a2), true;
      case 4:
        return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5:
        return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6:
        return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len - 1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length,
        j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1:
          listeners[i].fn.call(listeners[i].context);break;
        case 2:
          listeners[i].fn.call(listeners[i].context, a1);break;
        case 3:
          listeners[i].fn.call(listeners[i].context, a1, a2);break;
        default:
          if (!args) for (j = 1, args = new Array(len - 1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Register a new EventListener for the given event.
 *
 * @param {String} event Name of the event.
 * @param {Function} fn Callback function.
 * @param {Mixed} [context=this] The context of the function.
 * @api public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  var listener = new EE(fn, context || this),
      evt = prefix ? prefix + event : event;

  if (!this._events) this._events = prefix ? {} : Object.create(null);
  if (!this._events[evt]) this._events[evt] = listener;else {
    if (!this._events[evt].fn) this._events[evt].push(listener);else this._events[evt] = [this._events[evt], listener];
  }

  return this;
};

/**
 * Add an EventListener that's only called once.
 *
 * @param {String} event Name of the event.
 * @param {Function} fn Callback function.
 * @param {Mixed} [context=this] The context of the function.
 * @api public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  var listener = new EE(fn, context || this, true),
      evt = prefix ? prefix + event : event;

  if (!this._events) this._events = prefix ? {} : Object.create(null);
  if (!this._events[evt]) this._events[evt] = listener;else {
    if (!this._events[evt].fn) this._events[evt].push(listener);else this._events[evt] = [this._events[evt], listener];
  }

  return this;
};

/**
 * Remove event listeners.
 *
 * @param {String} event The event we want to remove.
 * @param {Function} fn The listener that we need to find.
 * @param {Mixed} context Only remove listeners matching this context.
 * @param {Boolean} once Only remove once listeners.
 * @api public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events || !this._events[evt]) return this;

  var listeners = this._events[evt],
      events = [];

  if (fn) {
    if (listeners.fn) {
      if (listeners.fn !== fn || once && !listeners.once || context && listeners.context !== context) {
        events.push(listeners);
      }
    } else {
      for (var i = 0, length = listeners.length; i < length; i++) {
        if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) {
          events.push(listeners[i]);
        }
      }
    }
  }

  //
  // Reset the array, or remove it completely if we have no more listeners.
  //
  if (events.length) {
    this._events[evt] = events.length === 1 ? events[0] : events;
  } else {
    delete this._events[evt];
  }

  return this;
};

/**
 * Remove all listeners or only the listeners for the specified event.
 *
 * @param {String} event The event want to remove all listeners for.
 * @api public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  if (!this._events) return this;

  if (event) delete this._events[prefix ? prefix + event : event];else this._events = prefix ? {} : Object.create(null);

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// This function doesn't apply anymore.
//
EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
  return this;
};

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Expose the module.
//
if (true) {
  module.exports = EventEmitter;
}

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var invariant = __webpack_require__(3);

/**
 * The CSSCore module specifies the API (and implements most of the methods)
 * that should be used when dealing with the display of elements (via their
 * CSS classes and visibility on screen. It is an API focused on mutating the
 * display and not reading it as no logical state should be encoded in the
 * display of elements.
 */

/* Slow implementation for browsers that don't natively support .matches() */
function matchesSelector_SLOW(element, selector) {
  var root = element;
  while (root.parentNode) {
    root = root.parentNode;
  }

  var all = root.querySelectorAll(selector);
  return Array.prototype.indexOf.call(all, element) !== -1;
}

var CSSCore = {

  /**
   * Adds the class passed in to the element if it doesn't already have it.
   *
   * @param {DOMElement} element the element to set the class on
   * @param {string} className the CSS className
   * @return {DOMElement} the element passed in
   */
  addClass: function addClass(element, className) {
    !!/\s/.test(className) ?  false ? invariant(false, 'CSSCore.addClass takes only a single class name. "%s" contains ' + 'multiple classes.', className) : invariant(false) : void 0;

    if (className) {
      if (element.classList) {
        element.classList.add(className);
      } else if (!CSSCore.hasClass(element, className)) {
        element.className = element.className + ' ' + className;
      }
    }
    return element;
  },

  /**
   * Removes the class passed in from the element
   *
   * @param {DOMElement} element the element to set the class on
   * @param {string} className the CSS className
   * @return {DOMElement} the element passed in
   */
  removeClass: function removeClass(element, className) {
    !!/\s/.test(className) ?  false ? invariant(false, 'CSSCore.removeClass takes only a single class name. "%s" contains ' + 'multiple classes.', className) : invariant(false) : void 0;

    if (className) {
      if (element.classList) {
        element.classList.remove(className);
      } else if (CSSCore.hasClass(element, className)) {
        element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ') // multiple spaces to one
        .replace(/^\s*|\s*$/g, ''); // trim the ends
      }
    }
    return element;
  },

  /**
   * Helper to add or remove a class from an element based on a condition.
   *
   * @param {DOMElement} element the element to set the class on
   * @param {string} className the CSS className
   * @param {*} bool condition to whether to add or remove the class
   * @return {DOMElement} the element passed in
   */
  conditionClass: function conditionClass(element, className, bool) {
    return (bool ? CSSCore.addClass : CSSCore.removeClass)(element, className);
  },

  /**
   * Tests whether the element has the class specified.
   *
   * @param {DOMNode|DOMWindow} element the element to check the class on
   * @param {string} className the CSS className
   * @return {boolean} true if the element has the class, false if not
   */
  hasClass: function hasClass(element, className) {
    !!/\s/.test(className) ?  false ? invariant(false, 'CSS.hasClass takes only a single class name.') : invariant(false) : void 0;
    if (element.classList) {
      return !!className && element.classList.contains(className);
    }
    return (' ' + element.className + ' ').indexOf(' ' + className + ' ') > -1;
  },

  /**
   * Tests whether the element matches the selector specified
   *
   * @param {DOMNode|DOMWindow} element the element that we are querying
   * @param {string} selector the CSS selector
   * @return {boolean} true if the element matches the selector, false if not
   */
  matchesSelector: function matchesSelector(element, selector) {
    var matchesImpl = element.matches || element.webkitMatchesSelector || element.mozMatchesSelector || element.msMatchesSelector || function (s) {
      return matchesSelector_SLOW(element, s);
    };
    return matchesImpl.call(element, selector);
  }

};

module.exports = CSSCore;

/***/ }),
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = -7;
  var i = isLE ? nBytes - 1 : 0;
  var d = isLE ? -1 : 1;
  var s = buffer[offset + i];

  i += d;

  e = s & (1 << -nBits) - 1;
  s >>= -nBits;
  nBits += eLen;
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : (s ? -1 : 1) * Infinity;
  } else {
    m = m + Math.pow(2, mLen);
    e = e - eBias;
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
  var i = isLE ? 0 : nBytes - 1;
  var d = isLE ? 1 : -1;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;

  value = Math.abs(value);

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0;
    e = eMax;
  } else {
    e = Math.floor(Math.log(value) / Math.LN2);
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * Math.pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }

    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
      e = 0;
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128;
};

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
__webpack_require__(818);
module.exports = self.fetch.bind(self);

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * JavaScript Cookie v2.1.4
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader = false;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (( false ? 'undefined' : _typeof(exports)) === 'object') {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
})(function () {
	function extend() {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[i];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function init(converter) {
		function api(key, value, attributes) {
			var result;
			if (typeof document === 'undefined') {
				return;
			}

			// Write

			if (arguments.length > 1) {
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);

				if (typeof attributes.expires === 'number') {
					var expires = new Date();
					expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
					attributes.expires = expires;
				}

				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

				try {
					result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}

				if (!converter.write) {
					value = encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
				} else {
					value = converter.write(value, key);
				}

				key = encodeURIComponent(String(key));
				key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
				key = key.replace(/[\(\)]/g, escape);

				var stringifiedAttributes = '';

				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
					stringifiedAttributes += '=' + attributes[attributeName];
				}
				return document.cookie = key + '=' + value + stringifiedAttributes;
			}

			// Read

			if (!key) {
				result = {};
			}

			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all. Also prevents odd result when
			// calling "get()"
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var rdecode = /(%[0-9A-Z]{2})+/g;
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = parts[0].replace(rdecode, decodeURIComponent);
					cookie = converter.read ? converter.read(cookie, name) : converter(cookie, name) || cookie.replace(rdecode, decodeURIComponent);

					if (this.json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					if (key === name) {
						result = cookie;
						break;
					}

					if (!key) {
						result[name] = cookie;
					}
				} catch (e) {}
			}

			return result;
		}

		api.set = api;
		api.get = function (key) {
			return api.call(api, key);
		};
		api.getJSON = function () {
			return api.apply({
				json: true
			}, [].slice.call(arguments));
		};
		api.defaults = {};

		api.remove = function (key, attributes) {
			api(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
});

/***/ }),
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getNative = __webpack_require__(99),
    root = __webpack_require__(58);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getNative = __webpack_require__(99),
    root = __webpack_require__(58);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getNative = __webpack_require__(99),
    root = __webpack_require__(58);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getNative = __webpack_require__(99),
    root = __webpack_require__(58);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getNative = __webpack_require__(99),
    root = __webpack_require__(58);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseTimes = __webpack_require__(651),
    isArguments = __webpack_require__(261),
    isArray = __webpack_require__(100),
    isBuffer = __webpack_require__(262),
    isIndex = __webpack_require__(660),
    isTypedArray = __webpack_require__(265);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (
    // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' ||
    // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') ||
    // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
    // Skip index properties.
    isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while (fromRight ? index-- : ++index < length) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseFindIndex = __webpack_require__(645),
    baseIsNaN = __webpack_require__(648),
    strictIndexOf = __webpack_require__(665);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
    return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseGetTag = __webpack_require__(73),
    isObjectLike = __webpack_require__(83);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isFunction = __webpack_require__(82),
    isMasked = __webpack_require__(661),
    isObject = __webpack_require__(177),
    toSource = __webpack_require__(260);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseGetTag = __webpack_require__(73),
    isLength = __webpack_require__(263),
    isObjectLike = __webpack_require__(83);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Symbol = __webpack_require__(174),
    arrayMap = __webpack_require__(255),
    isArray = __webpack_require__(100),
    isSymbol = __webpack_require__(179);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

module.exports = baseToString;

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}

module.exports = baseUnary;

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var arrayMap = __webpack_require__(255);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function (key) {
    return object[key];
  });
}

module.exports = baseValues;

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var root = __webpack_require__(58);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var overArg = __webpack_require__(259);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Symbol = __webpack_require__(174);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DataView = __webpack_require__(639),
    Map = __webpack_require__(640),
    Promise = __webpack_require__(641),
    Set = __webpack_require__(642),
    WeakMap = __webpack_require__(643),
    baseGetTag = __webpack_require__(73),
    toSource = __webpack_require__(260);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
    getTag = function getTag(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
            switch (ctorString) {
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
        }
        return result;
    };
}

module.exports = getTag;

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

module.exports = isIndex;

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var coreJsData = __webpack_require__(655);

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

module.exports = isMasked;

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var overArg = __webpack_require__(259);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var freeGlobal = __webpack_require__(257);

/** Detect free variable `exports`. */
var freeExports = ( false ? 'undefined' : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && ( false ? 'undefined' : _typeof(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = function () {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}();

module.exports = nodeUtil;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(108)(module)))

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseIndexOf = __webpack_require__(646),
    isArrayLike = __webpack_require__(176),
    isString = __webpack_require__(178),
    toInteger = __webpack_require__(673),
    values = __webpack_require__(676);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
}

module.exports = includes;

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseKeys = __webpack_require__(256),
    getTag = __webpack_require__(658),
    isArguments = __webpack_require__(261),
    isArray = __webpack_require__(100),
    isArrayLike = __webpack_require__(176),
    isBuffer = __webpack_require__(262),
    isPrototype = __webpack_require__(258),
    isTypedArray = __webpack_require__(265);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Checks if `value` is `null`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
 * @example
 *
 * _.isNull(null);
 * // => true
 *
 * _.isNull(void 0);
 * // => false
 */
function isNull(value) {
  return value === null;
}

module.exports = isNull;

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var arrayLikeKeys = __webpack_require__(644),
    baseKeys = __webpack_require__(256),
    isArrayLike = __webpack_require__(176);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toNumber = __webpack_require__(674);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = value < 0 ? -1 : 1;
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toFinite = __webpack_require__(672);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? remainder ? result - remainder : result : 0;
}

module.exports = toInteger;

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isObject = __webpack_require__(177),
    isSymbol = __webpack_require__(179);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? other + '' : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

module.exports = toNumber;

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseToString = __webpack_require__(652);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseValues = __webpack_require__(654),
    keys = __webpack_require__(670);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// THIS FILE IS GENERATED - DO NOT EDIT!
/*!mobile-detect v1.3.6 2017-04-05*/
/*global module:false, define:false*/
/*jshint latedef:false*/
/*!@license Copyright 2013, Heinrich Goebl, License: MIT, see https://github.com/hgoebl/mobile-detect.js*/
(function (define, undefined) {
    define(function () {
        'use strict';

        var impl = {};

        impl.mobileDetectRules = {
            "phones": {
                "iPhone": "\\biPhone\\b|\\biPod\\b",
                "BlackBerry": "BlackBerry|\\bBB10\\b|rim[0-9]+",
                "HTC": "HTC|HTC.*(Sensation|Evo|Vision|Explorer|6800|8100|8900|A7272|S510e|C110e|Legend|Desire|T8282)|APX515CKT|Qtek9090|APA9292KT|HD_mini|Sensation.*Z710e|PG86100|Z715e|Desire.*(A8181|HD)|ADR6200|ADR6400L|ADR6425|001HT|Inspire 4G|Android.*\\bEVO\\b|T-Mobile G1|Z520m",
                "Nexus": "Nexus One|Nexus S|Galaxy.*Nexus|Android.*Nexus.*Mobile|Nexus 4|Nexus 5|Nexus 6",
                "Dell": "Dell.*Streak|Dell.*Aero|Dell.*Venue|DELL.*Venue Pro|Dell Flash|Dell Smoke|Dell Mini 3iX|XCD28|XCD35|\\b001DL\\b|\\b101DL\\b|\\bGS01\\b",
                "Motorola": "Motorola|DROIDX|DROID BIONIC|\\bDroid\\b.*Build|Android.*Xoom|HRI39|MOT-|A1260|A1680|A555|A853|A855|A953|A955|A956|Motorola.*ELECTRIFY|Motorola.*i1|i867|i940|MB200|MB300|MB501|MB502|MB508|MB511|MB520|MB525|MB526|MB611|MB612|MB632|MB810|MB855|MB860|MB861|MB865|MB870|ME501|ME502|ME511|ME525|ME600|ME632|ME722|ME811|ME860|ME863|ME865|MT620|MT710|MT716|MT720|MT810|MT870|MT917|Motorola.*TITANIUM|WX435|WX445|XT300|XT301|XT311|XT316|XT317|XT319|XT320|XT390|XT502|XT530|XT531|XT532|XT535|XT603|XT610|XT611|XT615|XT681|XT701|XT702|XT711|XT720|XT800|XT806|XT860|XT862|XT875|XT882|XT883|XT894|XT901|XT907|XT909|XT910|XT912|XT928|XT926|XT915|XT919|XT925|XT1021|\\bMoto E\\b",
                "Samsung": "\\bSamsung\\b|SM-G9250|GT-19300|SGH-I337|BGT-S5230|GT-B2100|GT-B2700|GT-B2710|GT-B3210|GT-B3310|GT-B3410|GT-B3730|GT-B3740|GT-B5510|GT-B5512|GT-B5722|GT-B6520|GT-B7300|GT-B7320|GT-B7330|GT-B7350|GT-B7510|GT-B7722|GT-B7800|GT-C3010|GT-C3011|GT-C3060|GT-C3200|GT-C3212|GT-C3212I|GT-C3262|GT-C3222|GT-C3300|GT-C3300K|GT-C3303|GT-C3303K|GT-C3310|GT-C3322|GT-C3330|GT-C3350|GT-C3500|GT-C3510|GT-C3530|GT-C3630|GT-C3780|GT-C5010|GT-C5212|GT-C6620|GT-C6625|GT-C6712|GT-E1050|GT-E1070|GT-E1075|GT-E1080|GT-E1081|GT-E1085|GT-E1087|GT-E1100|GT-E1107|GT-E1110|GT-E1120|GT-E1125|GT-E1130|GT-E1160|GT-E1170|GT-E1175|GT-E1180|GT-E1182|GT-E1200|GT-E1210|GT-E1225|GT-E1230|GT-E1390|GT-E2100|GT-E2120|GT-E2121|GT-E2152|GT-E2220|GT-E2222|GT-E2230|GT-E2232|GT-E2250|GT-E2370|GT-E2550|GT-E2652|GT-E3210|GT-E3213|GT-I5500|GT-I5503|GT-I5700|GT-I5800|GT-I5801|GT-I6410|GT-I6420|GT-I7110|GT-I7410|GT-I7500|GT-I8000|GT-I8150|GT-I8160|GT-I8190|GT-I8320|GT-I8330|GT-I8350|GT-I8530|GT-I8700|GT-I8703|GT-I8910|GT-I9000|GT-I9001|GT-I9003|GT-I9010|GT-I9020|GT-I9023|GT-I9070|GT-I9082|GT-I9100|GT-I9103|GT-I9220|GT-I9250|GT-I9300|GT-I9305|GT-I9500|GT-I9505|GT-M3510|GT-M5650|GT-M7500|GT-M7600|GT-M7603|GT-M8800|GT-M8910|GT-N7000|GT-S3110|GT-S3310|GT-S3350|GT-S3353|GT-S3370|GT-S3650|GT-S3653|GT-S3770|GT-S3850|GT-S5210|GT-S5220|GT-S5229|GT-S5230|GT-S5233|GT-S5250|GT-S5253|GT-S5260|GT-S5263|GT-S5270|GT-S5300|GT-S5330|GT-S5350|GT-S5360|GT-S5363|GT-S5369|GT-S5380|GT-S5380D|GT-S5560|GT-S5570|GT-S5600|GT-S5603|GT-S5610|GT-S5620|GT-S5660|GT-S5670|GT-S5690|GT-S5750|GT-S5780|GT-S5830|GT-S5839|GT-S6102|GT-S6500|GT-S7070|GT-S7200|GT-S7220|GT-S7230|GT-S7233|GT-S7250|GT-S7500|GT-S7530|GT-S7550|GT-S7562|GT-S7710|GT-S8000|GT-S8003|GT-S8500|GT-S8530|GT-S8600|SCH-A310|SCH-A530|SCH-A570|SCH-A610|SCH-A630|SCH-A650|SCH-A790|SCH-A795|SCH-A850|SCH-A870|SCH-A890|SCH-A930|SCH-A950|SCH-A970|SCH-A990|SCH-I100|SCH-I110|SCH-I400|SCH-I405|SCH-I500|SCH-I510|SCH-I515|SCH-I600|SCH-I730|SCH-I760|SCH-I770|SCH-I830|SCH-I910|SCH-I920|SCH-I959|SCH-LC11|SCH-N150|SCH-N300|SCH-R100|SCH-R300|SCH-R351|SCH-R400|SCH-R410|SCH-T300|SCH-U310|SCH-U320|SCH-U350|SCH-U360|SCH-U365|SCH-U370|SCH-U380|SCH-U410|SCH-U430|SCH-U450|SCH-U460|SCH-U470|SCH-U490|SCH-U540|SCH-U550|SCH-U620|SCH-U640|SCH-U650|SCH-U660|SCH-U700|SCH-U740|SCH-U750|SCH-U810|SCH-U820|SCH-U900|SCH-U940|SCH-U960|SCS-26UC|SGH-A107|SGH-A117|SGH-A127|SGH-A137|SGH-A157|SGH-A167|SGH-A177|SGH-A187|SGH-A197|SGH-A227|SGH-A237|SGH-A257|SGH-A437|SGH-A517|SGH-A597|SGH-A637|SGH-A657|SGH-A667|SGH-A687|SGH-A697|SGH-A707|SGH-A717|SGH-A727|SGH-A737|SGH-A747|SGH-A767|SGH-A777|SGH-A797|SGH-A817|SGH-A827|SGH-A837|SGH-A847|SGH-A867|SGH-A877|SGH-A887|SGH-A897|SGH-A927|SGH-B100|SGH-B130|SGH-B200|SGH-B220|SGH-C100|SGH-C110|SGH-C120|SGH-C130|SGH-C140|SGH-C160|SGH-C170|SGH-C180|SGH-C200|SGH-C207|SGH-C210|SGH-C225|SGH-C230|SGH-C417|SGH-C450|SGH-D307|SGH-D347|SGH-D357|SGH-D407|SGH-D415|SGH-D780|SGH-D807|SGH-D980|SGH-E105|SGH-E200|SGH-E315|SGH-E316|SGH-E317|SGH-E335|SGH-E590|SGH-E635|SGH-E715|SGH-E890|SGH-F300|SGH-F480|SGH-I200|SGH-I300|SGH-I320|SGH-I550|SGH-I577|SGH-I600|SGH-I607|SGH-I617|SGH-I627|SGH-I637|SGH-I677|SGH-I700|SGH-I717|SGH-I727|SGH-i747M|SGH-I777|SGH-I780|SGH-I827|SGH-I847|SGH-I857|SGH-I896|SGH-I897|SGH-I900|SGH-I907|SGH-I917|SGH-I927|SGH-I937|SGH-I997|SGH-J150|SGH-J200|SGH-L170|SGH-L700|SGH-M110|SGH-M150|SGH-M200|SGH-N105|SGH-N500|SGH-N600|SGH-N620|SGH-N625|SGH-N700|SGH-N710|SGH-P107|SGH-P207|SGH-P300|SGH-P310|SGH-P520|SGH-P735|SGH-P777|SGH-Q105|SGH-R210|SGH-R220|SGH-R225|SGH-S105|SGH-S307|SGH-T109|SGH-T119|SGH-T139|SGH-T209|SGH-T219|SGH-T229|SGH-T239|SGH-T249|SGH-T259|SGH-T309|SGH-T319|SGH-T329|SGH-T339|SGH-T349|SGH-T359|SGH-T369|SGH-T379|SGH-T409|SGH-T429|SGH-T439|SGH-T459|SGH-T469|SGH-T479|SGH-T499|SGH-T509|SGH-T519|SGH-T539|SGH-T559|SGH-T589|SGH-T609|SGH-T619|SGH-T629|SGH-T639|SGH-T659|SGH-T669|SGH-T679|SGH-T709|SGH-T719|SGH-T729|SGH-T739|SGH-T746|SGH-T749|SGH-T759|SGH-T769|SGH-T809|SGH-T819|SGH-T839|SGH-T919|SGH-T929|SGH-T939|SGH-T959|SGH-T989|SGH-U100|SGH-U200|SGH-U800|SGH-V205|SGH-V206|SGH-X100|SGH-X105|SGH-X120|SGH-X140|SGH-X426|SGH-X427|SGH-X475|SGH-X495|SGH-X497|SGH-X507|SGH-X600|SGH-X610|SGH-X620|SGH-X630|SGH-X700|SGH-X820|SGH-X890|SGH-Z130|SGH-Z150|SGH-Z170|SGH-ZX10|SGH-ZX20|SHW-M110|SPH-A120|SPH-A400|SPH-A420|SPH-A460|SPH-A500|SPH-A560|SPH-A600|SPH-A620|SPH-A660|SPH-A700|SPH-A740|SPH-A760|SPH-A790|SPH-A800|SPH-A820|SPH-A840|SPH-A880|SPH-A900|SPH-A940|SPH-A960|SPH-D600|SPH-D700|SPH-D710|SPH-D720|SPH-I300|SPH-I325|SPH-I330|SPH-I350|SPH-I500|SPH-I600|SPH-I700|SPH-L700|SPH-M100|SPH-M220|SPH-M240|SPH-M300|SPH-M305|SPH-M320|SPH-M330|SPH-M350|SPH-M360|SPH-M370|SPH-M380|SPH-M510|SPH-M540|SPH-M550|SPH-M560|SPH-M570|SPH-M580|SPH-M610|SPH-M620|SPH-M630|SPH-M800|SPH-M810|SPH-M850|SPH-M900|SPH-M910|SPH-M920|SPH-M930|SPH-N100|SPH-N200|SPH-N240|SPH-N300|SPH-N400|SPH-Z400|SWC-E100|SCH-i909|GT-N7100|GT-N7105|SCH-I535|SM-N900A|SGH-I317|SGH-T999L|GT-S5360B|GT-I8262|GT-S6802|GT-S6312|GT-S6310|GT-S5312|GT-S5310|GT-I9105|GT-I8510|GT-S6790N|SM-G7105|SM-N9005|GT-S5301|GT-I9295|GT-I9195|SM-C101|GT-S7392|GT-S7560|GT-B7610|GT-I5510|GT-S7582|GT-S7530E|GT-I8750|SM-G9006V|SM-G9008V|SM-G9009D|SM-G900A|SM-G900D|SM-G900F|SM-G900H|SM-G900I|SM-G900J|SM-G900K|SM-G900L|SM-G900M|SM-G900P|SM-G900R4|SM-G900S|SM-G900T|SM-G900V|SM-G900W8|SHV-E160K|SCH-P709|SCH-P729|SM-T2558|GT-I9205|SM-G9350|SM-J120F|SM-G920F|SM-G920V|SM-G930F|SM-N910C",
                "LG": "\\bLG\\b;|LG[- ]?(C800|C900|E400|E610|E900|E-900|F160|F180K|F180L|F180S|730|855|L160|LS740|LS840|LS970|LU6200|MS690|MS695|MS770|MS840|MS870|MS910|P500|P700|P705|VM696|AS680|AS695|AX840|C729|E970|GS505|272|C395|E739BK|E960|L55C|L75C|LS696|LS860|P769BK|P350|P500|P509|P870|UN272|US730|VS840|VS950|LN272|LN510|LS670|LS855|LW690|MN270|MN510|P509|P769|P930|UN200|UN270|UN510|UN610|US670|US740|US760|UX265|UX840|VN271|VN530|VS660|VS700|VS740|VS750|VS910|VS920|VS930|VX9200|VX11000|AX840A|LW770|P506|P925|P999|E612|D955|D802|MS323)",
                "Sony": "SonyST|SonyLT|SonyEricsson|SonyEricssonLT15iv|LT18i|E10i|LT28h|LT26w|SonyEricssonMT27i|C5303|C6902|C6903|C6906|C6943|D2533",
                "Asus": "Asus.*Galaxy|PadFone.*Mobile",
                "NokiaLumia": "Lumia [0-9]{3,4}",
                "Micromax": "Micromax.*\\b(A210|A92|A88|A72|A111|A110Q|A115|A116|A110|A90S|A26|A51|A35|A54|A25|A27|A89|A68|A65|A57|A90)\\b",
                "Palm": "PalmSource|Palm",
                "Vertu": "Vertu|Vertu.*Ltd|Vertu.*Ascent|Vertu.*Ayxta|Vertu.*Constellation(F|Quest)?|Vertu.*Monika|Vertu.*Signature",
                "Pantech": "PANTECH|IM-A850S|IM-A840S|IM-A830L|IM-A830K|IM-A830S|IM-A820L|IM-A810K|IM-A810S|IM-A800S|IM-T100K|IM-A725L|IM-A780L|IM-A775C|IM-A770K|IM-A760S|IM-A750K|IM-A740S|IM-A730S|IM-A720L|IM-A710K|IM-A690L|IM-A690S|IM-A650S|IM-A630K|IM-A600S|VEGA PTL21|PT003|P8010|ADR910L|P6030|P6020|P9070|P4100|P9060|P5000|CDM8992|TXT8045|ADR8995|IS11PT|P2030|P6010|P8000|PT002|IS06|CDM8999|P9050|PT001|TXT8040|P2020|P9020|P2000|P7040|P7000|C790",
                "Fly": "IQ230|IQ444|IQ450|IQ440|IQ442|IQ441|IQ245|IQ256|IQ236|IQ255|IQ235|IQ245|IQ275|IQ240|IQ285|IQ280|IQ270|IQ260|IQ250",
                "Wiko": "KITE 4G|HIGHWAY|GETAWAY|STAIRWAY|DARKSIDE|DARKFULL|DARKNIGHT|DARKMOON|SLIDE|WAX 4G|RAINBOW|BLOOM|SUNSET|GOA(?!nna)|LENNY|BARRY|IGGY|OZZY|CINK FIVE|CINK PEAX|CINK PEAX 2|CINK SLIM|CINK SLIM 2|CINK +|CINK KING|CINK PEAX|CINK SLIM|SUBLIM",
                "iMobile": "i-mobile (IQ|i-STYLE|idea|ZAA|Hitz)",
                "SimValley": "\\b(SP-80|XT-930|SX-340|XT-930|SX-310|SP-360|SP60|SPT-800|SP-120|SPT-800|SP-140|SPX-5|SPX-8|SP-100|SPX-8|SPX-12)\\b",
                "Wolfgang": "AT-B24D|AT-AS50HD|AT-AS40W|AT-AS55HD|AT-AS45q2|AT-B26D|AT-AS50Q",
                "Alcatel": "Alcatel",
                "Nintendo": "Nintendo 3DS",
                "Amoi": "Amoi",
                "INQ": "INQ",
                "GenericPhone": "Tapatalk|PDA;|SAGEM|\\bmmp\\b|pocket|\\bpsp\\b|symbian|Smartphone|smartfon|treo|up.browser|up.link|vodafone|\\bwap\\b|nokia|Series40|Series60|S60|SonyEricsson|N900|MAUI.*WAP.*Browser"
            },
            "tablets": {
                "iPad": "iPad|iPad.*Mobile",
                "NexusTablet": "Android.*Nexus[\\s]+(7|9|10)",
                "SamsungTablet": "SAMSUNG.*Tablet|Galaxy.*Tab|SC-01C|GT-P1000|GT-P1003|GT-P1010|GT-P3105|GT-P6210|GT-P6800|GT-P6810|GT-P7100|GT-P7300|GT-P7310|GT-P7500|GT-P7510|SCH-I800|SCH-I815|SCH-I905|SGH-I957|SGH-I987|SGH-T849|SGH-T859|SGH-T869|SPH-P100|GT-P3100|GT-P3108|GT-P3110|GT-P5100|GT-P5110|GT-P6200|GT-P7320|GT-P7511|GT-N8000|GT-P8510|SGH-I497|SPH-P500|SGH-T779|SCH-I705|SCH-I915|GT-N8013|GT-P3113|GT-P5113|GT-P8110|GT-N8010|GT-N8005|GT-N8020|GT-P1013|GT-P6201|GT-P7501|GT-N5100|GT-N5105|GT-N5110|SHV-E140K|SHV-E140L|SHV-E140S|SHV-E150S|SHV-E230K|SHV-E230L|SHV-E230S|SHW-M180K|SHW-M180L|SHW-M180S|SHW-M180W|SHW-M300W|SHW-M305W|SHW-M380K|SHW-M380S|SHW-M380W|SHW-M430W|SHW-M480K|SHW-M480S|SHW-M480W|SHW-M485W|SHW-M486W|SHW-M500W|GT-I9228|SCH-P739|SCH-I925|GT-I9200|GT-P5200|GT-P5210|GT-P5210X|SM-T311|SM-T310|SM-T310X|SM-T210|SM-T210R|SM-T211|SM-P600|SM-P601|SM-P605|SM-P900|SM-P901|SM-T217|SM-T217A|SM-T217S|SM-P6000|SM-T3100|SGH-I467|XE500|SM-T110|GT-P5220|GT-I9200X|GT-N5110X|GT-N5120|SM-P905|SM-T111|SM-T2105|SM-T315|SM-T320|SM-T320X|SM-T321|SM-T520|SM-T525|SM-T530NU|SM-T230NU|SM-T330NU|SM-T900|XE500T1C|SM-P605V|SM-P905V|SM-T337V|SM-T537V|SM-T707V|SM-T807V|SM-P600X|SM-P900X|SM-T210X|SM-T230|SM-T230X|SM-T325|GT-P7503|SM-T531|SM-T330|SM-T530|SM-T705|SM-T705C|SM-T535|SM-T331|SM-T800|SM-T700|SM-T537|SM-T807|SM-P907A|SM-T337A|SM-T537A|SM-T707A|SM-T807A|SM-T237|SM-T807P|SM-P607T|SM-T217T|SM-T337T|SM-T807T|SM-T116NQ|SM-P550|SM-T350|SM-T550|SM-T9000|SM-P9000|SM-T705Y|SM-T805|GT-P3113|SM-T710|SM-T810|SM-T815|SM-T360|SM-T533|SM-T113|SM-T335|SM-T715|SM-T560|SM-T670|SM-T677|SM-T377|SM-T567|SM-T357T|SM-T555|SM-T561|SM-T713|SM-T719|SM-T813|SM-T819|SM-T580|SM-T355Y|SM-T280|SM-T817A|SM-T820|SM-W700|SM-P580|SM-T587",
                "Kindle": "Kindle|Silk.*Accelerated|Android.*\\b(KFOT|KFTT|KFJWI|KFJWA|KFOTE|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|WFJWAE|KFSAWA|KFSAWI|KFASWI|KFARWI|KFFOWI|KFGIWI|KFMEWI)\\b|Android.*Silk\/[0-9.]+ like Chrome\/[0-9.]+ (?!Mobile)",
                "SurfaceTablet": "Windows NT [0-9.]+; ARM;.*(Tablet|ARMBJS)",
                "HPTablet": "HP Slate (7|8|10)|HP ElitePad 900|hp-tablet|EliteBook.*Touch|HP 8|Slate 21|HP SlateBook 10",
                "AsusTablet": "^.*PadFone((?!Mobile).)*$|Transformer|TF101|TF101G|TF300T|TF300TG|TF300TL|TF700T|TF700KL|TF701T|TF810C|ME171|ME301T|ME302C|ME371MG|ME370T|ME372MG|ME172V|ME173X|ME400C|Slider SL101|\\bK00F\\b|\\bK00C\\b|\\bK00E\\b|\\bK00L\\b|TX201LA|ME176C|ME102A|\\bM80TA\\b|ME372CL|ME560CG|ME372CG|ME302KL| K010 | K011 | K017 | K01E |ME572C|ME103K|ME170C|ME171C|\\bME70C\\b|ME581C|ME581CL|ME8510C|ME181C|P01Y|PO1MA|P01Z",
                "BlackBerryTablet": "PlayBook|RIM Tablet",
                "HTCtablet": "HTC_Flyer_P512|HTC Flyer|HTC Jetstream|HTC-P715a|HTC EVO View 4G|PG41200|PG09410",
                "MotorolaTablet": "xoom|sholest|MZ615|MZ605|MZ505|MZ601|MZ602|MZ603|MZ604|MZ606|MZ607|MZ608|MZ609|MZ615|MZ616|MZ617",
                "NookTablet": "Android.*Nook|NookColor|nook browser|BNRV200|BNRV200A|BNTV250|BNTV250A|BNTV400|BNTV600|LogicPD Zoom2",
                "AcerTablet": "Android.*; \\b(A100|A101|A110|A200|A210|A211|A500|A501|A510|A511|A700|A701|W500|W500P|W501|W501P|W510|W511|W700|G100|G100W|B1-A71|B1-710|B1-711|A1-810|A1-811|A1-830)\\b|W3-810|\\bA3-A10\\b|\\bA3-A11\\b|\\bA3-A20\\b|\\bA3-A30",
                "ToshibaTablet": "Android.*(AT100|AT105|AT200|AT205|AT270|AT275|AT300|AT305|AT1S5|AT500|AT570|AT700|AT830)|TOSHIBA.*FOLIO",
                "LGTablet": "\\bL-06C|LG-V909|LG-V900|LG-V700|LG-V510|LG-V500|LG-V410|LG-V400|LG-VK810\\b",
                "FujitsuTablet": "Android.*\\b(F-01D|F-02F|F-05E|F-10D|M532|Q572)\\b",
                "PrestigioTablet": "PMP3170B|PMP3270B|PMP3470B|PMP7170B|PMP3370B|PMP3570C|PMP5870C|PMP3670B|PMP5570C|PMP5770D|PMP3970B|PMP3870C|PMP5580C|PMP5880D|PMP5780D|PMP5588C|PMP7280C|PMP7280C3G|PMP7280|PMP7880D|PMP5597D|PMP5597|PMP7100D|PER3464|PER3274|PER3574|PER3884|PER5274|PER5474|PMP5097CPRO|PMP5097|PMP7380D|PMP5297C|PMP5297C_QUAD|PMP812E|PMP812E3G|PMP812F|PMP810E|PMP880TD|PMT3017|PMT3037|PMT3047|PMT3057|PMT7008|PMT5887|PMT5001|PMT5002",
                "LenovoTablet": "Lenovo TAB|Idea(Tab|Pad)( A1|A10| K1|)|ThinkPad([ ]+)?Tablet|YT3-X90L|YT3-X90F|YT3-X90X|Lenovo.*(S2109|S2110|S5000|S6000|K3011|A3000|A3500|A1000|A2107|A2109|A1107|A5500|A7600|B6000|B8000|B8080)(-|)(FL|F|HV|H|)",
                "DellTablet": "Venue 11|Venue 8|Venue 7|Dell Streak 10|Dell Streak 7",
                "YarvikTablet": "Android.*\\b(TAB210|TAB211|TAB224|TAB250|TAB260|TAB264|TAB310|TAB360|TAB364|TAB410|TAB411|TAB420|TAB424|TAB450|TAB460|TAB461|TAB464|TAB465|TAB467|TAB468|TAB07-100|TAB07-101|TAB07-150|TAB07-151|TAB07-152|TAB07-200|TAB07-201-3G|TAB07-210|TAB07-211|TAB07-212|TAB07-214|TAB07-220|TAB07-400|TAB07-485|TAB08-150|TAB08-200|TAB08-201-3G|TAB08-201-30|TAB09-100|TAB09-211|TAB09-410|TAB10-150|TAB10-201|TAB10-211|TAB10-400|TAB10-410|TAB13-201|TAB274EUK|TAB275EUK|TAB374EUK|TAB462EUK|TAB474EUK|TAB9-200)\\b",
                "MedionTablet": "Android.*\\bOYO\\b|LIFE.*(P9212|P9514|P9516|S9512)|LIFETAB",
                "ArnovaTablet": "97G4|AN10G2|AN7bG3|AN7fG3|AN8G3|AN8cG3|AN7G3|AN9G3|AN7dG3|AN7dG3ST|AN7dG3ChildPad|AN10bG3|AN10bG3DT|AN9G2",
                "IntensoTablet": "INM8002KP|INM1010FP|INM805ND|Intenso Tab|TAB1004",
                "IRUTablet": "M702pro",
                "MegafonTablet": "MegaFon V9|\\bZTE V9\\b|Android.*\\bMT7A\\b",
                "EbodaTablet": "E-Boda (Supreme|Impresspeed|Izzycomm|Essential)",
                "AllViewTablet": "Allview.*(Viva|Alldro|City|Speed|All TV|Frenzy|Quasar|Shine|TX1|AX1|AX2)",
                "ArchosTablet": "\\b(101G9|80G9|A101IT)\\b|Qilive 97R|Archos5|\\bARCHOS (70|79|80|90|97|101|FAMILYPAD|)(b|c|)(G10| Cobalt| TITANIUM(HD|)| Xenon| Neon|XSK| 2| XS 2| PLATINUM| CARBON|GAMEPAD)\\b",
                "AinolTablet": "NOVO7|NOVO8|NOVO10|Novo7Aurora|Novo7Basic|NOVO7PALADIN|novo9-Spark",
                "NokiaLumiaTablet": "Lumia 2520",
                "SonyTablet": "Sony.*Tablet|Xperia Tablet|Sony Tablet S|SO-03E|SGPT12|SGPT13|SGPT114|SGPT121|SGPT122|SGPT123|SGPT111|SGPT112|SGPT113|SGPT131|SGPT132|SGPT133|SGPT211|SGPT212|SGPT213|SGP311|SGP312|SGP321|EBRD1101|EBRD1102|EBRD1201|SGP351|SGP341|SGP511|SGP512|SGP521|SGP541|SGP551|SGP621|SGP612|SOT31",
                "PhilipsTablet": "\\b(PI2010|PI3000|PI3100|PI3105|PI3110|PI3205|PI3210|PI3900|PI4010|PI7000|PI7100)\\b",
                "CubeTablet": "Android.*(K8GT|U9GT|U10GT|U16GT|U17GT|U18GT|U19GT|U20GT|U23GT|U30GT)|CUBE U8GT",
                "CobyTablet": "MID1042|MID1045|MID1125|MID1126|MID7012|MID7014|MID7015|MID7034|MID7035|MID7036|MID7042|MID7048|MID7127|MID8042|MID8048|MID8127|MID9042|MID9740|MID9742|MID7022|MID7010",
                "MIDTablet": "M9701|M9000|M9100|M806|M1052|M806|T703|MID701|MID713|MID710|MID727|MID760|MID830|MID728|MID933|MID125|MID810|MID732|MID120|MID930|MID800|MID731|MID900|MID100|MID820|MID735|MID980|MID130|MID833|MID737|MID960|MID135|MID860|MID736|MID140|MID930|MID835|MID733|MID4X10",
                "MSITablet": "MSI \\b(Primo 73K|Primo 73L|Primo 81L|Primo 77|Primo 93|Primo 75|Primo 76|Primo 73|Primo 81|Primo 91|Primo 90|Enjoy 71|Enjoy 7|Enjoy 10)\\b",
                "SMiTTablet": "Android.*(\\bMID\\b|MID-560|MTV-T1200|MTV-PND531|MTV-P1101|MTV-PND530)",
                "RockChipTablet": "Android.*(RK2818|RK2808A|RK2918|RK3066)|RK2738|RK2808A",
                "FlyTablet": "IQ310|Fly Vision",
                "bqTablet": "Android.*(bq)?.*(Elcano|Curie|Edison|Maxwell|Kepler|Pascal|Tesla|Hypatia|Platon|Newton|Livingstone|Cervantes|Avant|Aquaris [E|M]10)|Maxwell.*Lite|Maxwell.*Plus",
                "HuaweiTablet": "MediaPad|MediaPad 7 Youth|IDEOS S7|S7-201c|S7-202u|S7-101|S7-103|S7-104|S7-105|S7-106|S7-201|S7-Slim",
                "NecTablet": "\\bN-06D|\\bN-08D",
                "PantechTablet": "Pantech.*P4100",
                "BronchoTablet": "Broncho.*(N701|N708|N802|a710)",
                "VersusTablet": "TOUCHPAD.*[78910]|\\bTOUCHTAB\\b",
                "ZyncTablet": "z1000|Z99 2G|z99|z930|z999|z990|z909|Z919|z900",
                "PositivoTablet": "TB07STA|TB10STA|TB07FTA|TB10FTA",
                "NabiTablet": "Android.*\\bNabi",
                "KoboTablet": "Kobo Touch|\\bK080\\b|\\bVox\\b Build|\\bArc\\b Build",
                "DanewTablet": "DSlide.*\\b(700|701R|702|703R|704|802|970|971|972|973|974|1010|1012)\\b",
                "TexetTablet": "NaviPad|TB-772A|TM-7045|TM-7055|TM-9750|TM-7016|TM-7024|TM-7026|TM-7041|TM-7043|TM-7047|TM-8041|TM-9741|TM-9747|TM-9748|TM-9751|TM-7022|TM-7021|TM-7020|TM-7011|TM-7010|TM-7023|TM-7025|TM-7037W|TM-7038W|TM-7027W|TM-9720|TM-9725|TM-9737W|TM-1020|TM-9738W|TM-9740|TM-9743W|TB-807A|TB-771A|TB-727A|TB-725A|TB-719A|TB-823A|TB-805A|TB-723A|TB-715A|TB-707A|TB-705A|TB-709A|TB-711A|TB-890HD|TB-880HD|TB-790HD|TB-780HD|TB-770HD|TB-721HD|TB-710HD|TB-434HD|TB-860HD|TB-840HD|TB-760HD|TB-750HD|TB-740HD|TB-730HD|TB-722HD|TB-720HD|TB-700HD|TB-500HD|TB-470HD|TB-431HD|TB-430HD|TB-506|TB-504|TB-446|TB-436|TB-416|TB-146SE|TB-126SE",
                "PlaystationTablet": "Playstation.*(Portable|Vita)",
                "TrekstorTablet": "ST10416-1|VT10416-1|ST70408-1|ST702xx-1|ST702xx-2|ST80208|ST97216|ST70104-2|VT10416-2|ST10216-2A|SurfTab",
                "PyleAudioTablet": "\\b(PTBL10CEU|PTBL10C|PTBL72BC|PTBL72BCEU|PTBL7CEU|PTBL7C|PTBL92BC|PTBL92BCEU|PTBL9CEU|PTBL9CUK|PTBL9C)\\b",
                "AdvanTablet": "Android.* \\b(E3A|T3X|T5C|T5B|T3E|T3C|T3B|T1J|T1F|T2A|T1H|T1i|E1C|T1-E|T5-A|T4|E1-B|T2Ci|T1-B|T1-D|O1-A|E1-A|T1-A|T3A|T4i)\\b ",
                "DanyTechTablet": "Genius Tab G3|Genius Tab S2|Genius Tab Q3|Genius Tab G4|Genius Tab Q4|Genius Tab G-II|Genius TAB GII|Genius TAB GIII|Genius Tab S1",
                "GalapadTablet": "Android.*\\bG1\\b",
                "MicromaxTablet": "Funbook|Micromax.*\\b(P250|P560|P360|P362|P600|P300|P350|P500|P275)\\b",
                "KarbonnTablet": "Android.*\\b(A39|A37|A34|ST8|ST10|ST7|Smart Tab3|Smart Tab2)\\b",
                "AllFineTablet": "Fine7 Genius|Fine7 Shine|Fine7 Air|Fine8 Style|Fine9 More|Fine10 Joy|Fine11 Wide",
                "PROSCANTablet": "\\b(PEM63|PLT1023G|PLT1041|PLT1044|PLT1044G|PLT1091|PLT4311|PLT4311PL|PLT4315|PLT7030|PLT7033|PLT7033D|PLT7035|PLT7035D|PLT7044K|PLT7045K|PLT7045KB|PLT7071KG|PLT7072|PLT7223G|PLT7225G|PLT7777G|PLT7810K|PLT7849G|PLT7851G|PLT7852G|PLT8015|PLT8031|PLT8034|PLT8036|PLT8080K|PLT8082|PLT8088|PLT8223G|PLT8234G|PLT8235G|PLT8816K|PLT9011|PLT9045K|PLT9233G|PLT9735|PLT9760G|PLT9770G)\\b",
                "YONESTablet": "BQ1078|BC1003|BC1077|RK9702|BC9730|BC9001|IT9001|BC7008|BC7010|BC708|BC728|BC7012|BC7030|BC7027|BC7026",
                "ChangJiaTablet": "TPC7102|TPC7103|TPC7105|TPC7106|TPC7107|TPC7201|TPC7203|TPC7205|TPC7210|TPC7708|TPC7709|TPC7712|TPC7110|TPC8101|TPC8103|TPC8105|TPC8106|TPC8203|TPC8205|TPC8503|TPC9106|TPC9701|TPC97101|TPC97103|TPC97105|TPC97106|TPC97111|TPC97113|TPC97203|TPC97603|TPC97809|TPC97205|TPC10101|TPC10103|TPC10106|TPC10111|TPC10203|TPC10205|TPC10503",
                "GUTablet": "TX-A1301|TX-M9002|Q702|kf026",
                "PointOfViewTablet": "TAB-P506|TAB-navi-7-3G-M|TAB-P517|TAB-P-527|TAB-P701|TAB-P703|TAB-P721|TAB-P731N|TAB-P741|TAB-P825|TAB-P905|TAB-P925|TAB-PR945|TAB-PL1015|TAB-P1025|TAB-PI1045|TAB-P1325|TAB-PROTAB[0-9]+|TAB-PROTAB25|TAB-PROTAB26|TAB-PROTAB27|TAB-PROTAB26XL|TAB-PROTAB2-IPS9|TAB-PROTAB30-IPS9|TAB-PROTAB25XXL|TAB-PROTAB26-IPS10|TAB-PROTAB30-IPS10",
                "OvermaxTablet": "OV-(SteelCore|NewBase|Basecore|Baseone|Exellen|Quattor|EduTab|Solution|ACTION|BasicTab|TeddyTab|MagicTab|Stream|TB-08|TB-09)",
                "HCLTablet": "HCL.*Tablet|Connect-3G-2.0|Connect-2G-2.0|ME Tablet U1|ME Tablet U2|ME Tablet G1|ME Tablet X1|ME Tablet Y2|ME Tablet Sync",
                "DPSTablet": "DPS Dream 9|DPS Dual 7",
                "VistureTablet": "V97 HD|i75 3G|Visture V4( HD)?|Visture V5( HD)?|Visture V10",
                "CrestaTablet": "CTP(-)?810|CTP(-)?818|CTP(-)?828|CTP(-)?838|CTP(-)?888|CTP(-)?978|CTP(-)?980|CTP(-)?987|CTP(-)?988|CTP(-)?989",
                "MediatekTablet": "\\bMT8125|MT8389|MT8135|MT8377\\b",
                "ConcordeTablet": "Concorde([ ]+)?Tab|ConCorde ReadMan",
                "GoCleverTablet": "GOCLEVER TAB|A7GOCLEVER|M1042|M7841|M742|R1042BK|R1041|TAB A975|TAB A7842|TAB A741|TAB A741L|TAB M723G|TAB M721|TAB A1021|TAB I921|TAB R721|TAB I720|TAB T76|TAB R70|TAB R76.2|TAB R106|TAB R83.2|TAB M813G|TAB I721|GCTA722|TAB I70|TAB I71|TAB S73|TAB R73|TAB R74|TAB R93|TAB R75|TAB R76.1|TAB A73|TAB A93|TAB A93.2|TAB T72|TAB R83|TAB R974|TAB R973|TAB A101|TAB A103|TAB A104|TAB A104.2|R105BK|M713G|A972BK|TAB A971|TAB R974.2|TAB R104|TAB R83.3|TAB A1042",
                "ModecomTablet": "FreeTAB 9000|FreeTAB 7.4|FreeTAB 7004|FreeTAB 7800|FreeTAB 2096|FreeTAB 7.5|FreeTAB 1014|FreeTAB 1001 |FreeTAB 8001|FreeTAB 9706|FreeTAB 9702|FreeTAB 7003|FreeTAB 7002|FreeTAB 1002|FreeTAB 7801|FreeTAB 1331|FreeTAB 1004|FreeTAB 8002|FreeTAB 8014|FreeTAB 9704|FreeTAB 1003",
                "VoninoTablet": "\\b(Argus[ _]?S|Diamond[ _]?79HD|Emerald[ _]?78E|Luna[ _]?70C|Onyx[ _]?S|Onyx[ _]?Z|Orin[ _]?HD|Orin[ _]?S|Otis[ _]?S|SpeedStar[ _]?S|Magnet[ _]?M9|Primus[ _]?94[ _]?3G|Primus[ _]?94HD|Primus[ _]?QS|Android.*\\bQ8\\b|Sirius[ _]?EVO[ _]?QS|Sirius[ _]?QS|Spirit[ _]?S)\\b",
                "ECSTablet": "V07OT2|TM105A|S10OT1|TR10CS1",
                "StorexTablet": "eZee[_']?(Tab|Go)[0-9]+|TabLC7|Looney Tunes Tab",
                "VodafoneTablet": "SmartTab([ ]+)?[0-9]+|SmartTabII10|SmartTabII7|VF-1497",
                "EssentielBTablet": "Smart[ ']?TAB[ ]+?[0-9]+|Family[ ']?TAB2",
                "RossMoorTablet": "RM-790|RM-997|RMD-878G|RMD-974R|RMT-705A|RMT-701|RME-601|RMT-501|RMT-711",
                "iMobileTablet": "i-mobile i-note",
                "TolinoTablet": "tolino tab [0-9.]+|tolino shine",
                "AudioSonicTablet": "\\bC-22Q|T7-QC|T-17B|T-17P\\b",
                "AMPETablet": "Android.* A78 ",
                "SkkTablet": "Android.* (SKYPAD|PHOENIX|CYCLOPS)",
                "TecnoTablet": "TECNO P9",
                "JXDTablet": "Android.* \\b(F3000|A3300|JXD5000|JXD3000|JXD2000|JXD300B|JXD300|S5800|S7800|S602b|S5110b|S7300|S5300|S602|S603|S5100|S5110|S601|S7100a|P3000F|P3000s|P101|P200s|P1000m|P200m|P9100|P1000s|S6600b|S908|P1000|P300|S18|S6600|S9100)\\b",
                "iJoyTablet": "Tablet (Spirit 7|Essentia|Galatea|Fusion|Onix 7|Landa|Titan|Scooby|Deox|Stella|Themis|Argon|Unique 7|Sygnus|Hexen|Finity 7|Cream|Cream X2|Jade|Neon 7|Neron 7|Kandy|Scape|Saphyr 7|Rebel|Biox|Rebel|Rebel 8GB|Myst|Draco 7|Myst|Tab7-004|Myst|Tadeo Jones|Tablet Boing|Arrow|Draco Dual Cam|Aurix|Mint|Amity|Revolution|Finity 9|Neon 9|T9w|Amity 4GB Dual Cam|Stone 4GB|Stone 8GB|Andromeda|Silken|X2|Andromeda II|Halley|Flame|Saphyr 9,7|Touch 8|Planet|Triton|Unique 10|Hexen 10|Memphis 4GB|Memphis 8GB|Onix 10)",
                "FX2Tablet": "FX2 PAD7|FX2 PAD10",
                "XoroTablet": "KidsPAD 701|PAD[ ]?712|PAD[ ]?714|PAD[ ]?716|PAD[ ]?717|PAD[ ]?718|PAD[ ]?720|PAD[ ]?721|PAD[ ]?722|PAD[ ]?790|PAD[ ]?792|PAD[ ]?900|PAD[ ]?9715D|PAD[ ]?9716DR|PAD[ ]?9718DR|PAD[ ]?9719QR|PAD[ ]?9720QR|TelePAD1030|Telepad1032|TelePAD730|TelePAD731|TelePAD732|TelePAD735Q|TelePAD830|TelePAD9730|TelePAD795|MegaPAD 1331|MegaPAD 1851|MegaPAD 2151",
                "ViewsonicTablet": "ViewPad 10pi|ViewPad 10e|ViewPad 10s|ViewPad E72|ViewPad7|ViewPad E100|ViewPad 7e|ViewSonic VB733|VB100a",
                "OdysTablet": "LOOX|XENO10|ODYS[ -](Space|EVO|Xpress|NOON)|\\bXELIO\\b|Xelio10Pro|XELIO7PHONETAB|XELIO10EXTREME|XELIOPT2|NEO_QUAD10",
                "CaptivaTablet": "CAPTIVA PAD",
                "IconbitTablet": "NetTAB|NT-3702|NT-3702S|NT-3702S|NT-3603P|NT-3603P|NT-0704S|NT-0704S|NT-3805C|NT-3805C|NT-0806C|NT-0806C|NT-0909T|NT-0909T|NT-0907S|NT-0907S|NT-0902S|NT-0902S",
                "TeclastTablet": "T98 4G|\\bP80\\b|\\bX90HD\\b|X98 Air|X98 Air 3G|\\bX89\\b|P80 3G|\\bX80h\\b|P98 Air|\\bX89HD\\b|P98 3G|\\bP90HD\\b|P89 3G|X98 3G|\\bP70h\\b|P79HD 3G|G18d 3G|\\bP79HD\\b|\\bP89s\\b|\\bA88\\b|\\bP10HD\\b|\\bP19HD\\b|G18 3G|\\bP78HD\\b|\\bA78\\b|\\bP75\\b|G17s 3G|G17h 3G|\\bP85t\\b|\\bP90\\b|\\bP11\\b|\\bP98t\\b|\\bP98HD\\b|\\bG18d\\b|\\bP85s\\b|\\bP11HD\\b|\\bP88s\\b|\\bA80HD\\b|\\bA80se\\b|\\bA10h\\b|\\bP89\\b|\\bP78s\\b|\\bG18\\b|\\bP85\\b|\\bA70h\\b|\\bA70\\b|\\bG17\\b|\\bP18\\b|\\bA80s\\b|\\bA11s\\b|\\bP88HD\\b|\\bA80h\\b|\\bP76s\\b|\\bP76h\\b|\\bP98\\b|\\bA10HD\\b|\\bP78\\b|\\bP88\\b|\\bA11\\b|\\bA10t\\b|\\bP76a\\b|\\bP76t\\b|\\bP76e\\b|\\bP85HD\\b|\\bP85a\\b|\\bP86\\b|\\bP75HD\\b|\\bP76v\\b|\\bA12\\b|\\bP75a\\b|\\bA15\\b|\\bP76Ti\\b|\\bP81HD\\b|\\bA10\\b|\\bT760VE\\b|\\bT720HD\\b|\\bP76\\b|\\bP73\\b|\\bP71\\b|\\bP72\\b|\\bT720SE\\b|\\bC520Ti\\b|\\bT760\\b|\\bT720VE\\b|T720-3GE|T720-WiFi",
                "OndaTablet": "\\b(V975i|Vi30|VX530|V701|Vi60|V701s|Vi50|V801s|V719|Vx610w|VX610W|V819i|Vi10|VX580W|Vi10|V711s|V813|V811|V820w|V820|Vi20|V711|VI30W|V712|V891w|V972|V819w|V820w|Vi60|V820w|V711|V813s|V801|V819|V975s|V801|V819|V819|V818|V811|V712|V975m|V101w|V961w|V812|V818|V971|V971s|V919|V989|V116w|V102w|V973|Vi40)\\b[\\s]+",
                "JaytechTablet": "TPC-PA762",
                "BlaupunktTablet": "Endeavour 800NG|Endeavour 1010",
                "DigmaTablet": "\\b(iDx10|iDx9|iDx8|iDx7|iDxD7|iDxD8|iDsQ8|iDsQ7|iDsQ8|iDsD10|iDnD7|3TS804H|iDsQ11|iDj7|iDs10)\\b",
                "EvolioTablet": "ARIA_Mini_wifi|Aria[ _]Mini|Evolio X10|Evolio X7|Evolio X8|\\bEvotab\\b|\\bNeura\\b",
                "LavaTablet": "QPAD E704|\\bIvoryS\\b|E-TAB IVORY|\\bE-TAB\\b",
                "AocTablet": "MW0811|MW0812|MW0922|MTK8382|MW1031|MW0831|MW0821|MW0931|MW0712",
                "MpmanTablet": "MP11 OCTA|MP10 OCTA|MPQC1114|MPQC1004|MPQC994|MPQC974|MPQC973|MPQC804|MPQC784|MPQC780|\\bMPG7\\b|MPDCG75|MPDCG71|MPDC1006|MP101DC|MPDC9000|MPDC905|MPDC706HD|MPDC706|MPDC705|MPDC110|MPDC100|MPDC99|MPDC97|MPDC88|MPDC8|MPDC77|MP709|MID701|MID711|MID170|MPDC703|MPQC1010",
                "CelkonTablet": "CT695|CT888|CT[\\s]?910|CT7 Tab|CT9 Tab|CT3 Tab|CT2 Tab|CT1 Tab|C820|C720|\\bCT-1\\b",
                "WolderTablet": "miTab \\b(DIAMOND|SPACE|BROOKLYN|NEO|FLY|MANHATTAN|FUNK|EVOLUTION|SKY|GOCAR|IRON|GENIUS|POP|MINT|EPSILON|BROADWAY|JUMP|HOP|LEGEND|NEW AGE|LINE|ADVANCE|FEEL|FOLLOW|LIKE|LINK|LIVE|THINK|FREEDOM|CHICAGO|CLEVELAND|BALTIMORE-GH|IOWA|BOSTON|SEATTLE|PHOENIX|DALLAS|IN 101|MasterChef)\\b",
                "MiTablet": "\\bMI PAD\\b|\\bHM NOTE 1W\\b",
                "NibiruTablet": "Nibiru M1|Nibiru Jupiter One",
                "NexoTablet": "NEXO NOVA|NEXO 10|NEXO AVIO|NEXO FREE|NEXO GO|NEXO EVO|NEXO 3G|NEXO SMART|NEXO KIDDO|NEXO MOBI",
                "LeaderTablet": "TBLT10Q|TBLT10I|TBL-10WDKB|TBL-10WDKBO2013|TBL-W230V2|TBL-W450|TBL-W500|SV572|TBLT7I|TBA-AC7-8G|TBLT79|TBL-8W16|TBL-10W32|TBL-10WKB|TBL-W100",
                "UbislateTablet": "UbiSlate[\\s]?7C",
                "PocketBookTablet": "Pocketbook",
                "KocasoTablet": "\\b(TB-1207)\\b",
                "HisenseTablet": "\\b(F5281|E2371)\\b",
                "Hudl": "Hudl HT7S3|Hudl 2",
                "TelstraTablet": "T-Hub2",
                "GenericTablet": "Android.*\\b97D\\b|Tablet(?!.*PC)|BNTV250A|MID-WCDMA|LogicPD Zoom2|\\bA7EB\\b|CatNova8|A1_07|CT704|CT1002|\\bM721\\b|rk30sdk|\\bEVOTAB\\b|M758A|ET904|ALUMIUM10|Smartfren Tab|Endeavour 1010|Tablet-PC-4|Tagi Tab|\\bM6pro\\b|CT1020W|arc 10HD|\\bTP750\\b"
            },
            "oss": {
                "AndroidOS": "Android",
                "BlackBerryOS": "blackberry|\\bBB10\\b|rim tablet os",
                "PalmOS": "PalmOS|avantgo|blazer|elaine|hiptop|palm|plucker|xiino",
                "SymbianOS": "Symbian|SymbOS|Series60|Series40|SYB-[0-9]+|\\bS60\\b",
                "WindowsMobileOS": "Windows CE.*(PPC|Smartphone|Mobile|[0-9]{3}x[0-9]{3})|Window Mobile|Windows Phone [0-9.]+|WCE;",
                "WindowsPhoneOS": "Windows Phone 10.0|Windows Phone 8.1|Windows Phone 8.0|Windows Phone OS|XBLWP7|ZuneWP7|Windows NT 6.[23]; ARM;",
                "iOS": "\\biPhone.*Mobile|\\biPod|\\biPad",
                "MeeGoOS": "MeeGo",
                "MaemoOS": "Maemo",
                "JavaOS": "J2ME\/|\\bMIDP\\b|\\bCLDC\\b",
                "webOS": "webOS|hpwOS",
                "badaOS": "\\bBada\\b",
                "BREWOS": "BREW"
            },
            "uas": {
                "Chrome": "\\bCrMo\\b|CriOS|Android.*Chrome\/[.0-9]* (Mobile)?",
                "Dolfin": "\\bDolfin\\b",
                "Opera": "Opera.*Mini|Opera.*Mobi|Android.*Opera|Mobile.*OPR\/[0-9.]+|Coast\/[0-9.]+",
                "Skyfire": "Skyfire",
                "Edge": "Mobile Safari\/[.0-9]* Edge",
                "IE": "IEMobile|MSIEMobile",
                "Firefox": "fennec|firefox.*maemo|(Mobile|Tablet).*Firefox|Firefox.*Mobile|FxiOS",
                "Bolt": "bolt",
                "TeaShark": "teashark",
                "Blazer": "Blazer",
                "Safari": "Version.*Mobile.*Safari|Safari.*Mobile|MobileSafari",
                "UCBrowser": "UC.*Browser|UCWEB",
                "baiduboxapp": "baiduboxapp",
                "baidubrowser": "baidubrowser",
                "DiigoBrowser": "DiigoBrowser",
                "Puffin": "Puffin",
                "Mercury": "\\bMercury\\b",
                "ObigoBrowser": "Obigo",
                "NetFront": "NF-Browser",
                "GenericBrowser": "NokiaBrowser|OviBrowser|OneBrowser|TwonkyBeamBrowser|SEMC.*Browser|FlyFlow|Minimo|NetFront|Novarra-Vision|MQQBrowser|MicroMessenger",
                "PaleMoon": "Android.*PaleMoon|Mobile.*PaleMoon"
            },
            "props": {
                "Mobile": "Mobile\/[VER]",
                "Build": "Build\/[VER]",
                "Version": "Version\/[VER]",
                "VendorID": "VendorID\/[VER]",
                "iPad": "iPad.*CPU[a-z ]+[VER]",
                "iPhone": "iPhone.*CPU[a-z ]+[VER]",
                "iPod": "iPod.*CPU[a-z ]+[VER]",
                "Kindle": "Kindle\/[VER]",
                "Chrome": ["Chrome\/[VER]", "CriOS\/[VER]", "CrMo\/[VER]"],
                "Coast": ["Coast\/[VER]"],
                "Dolfin": "Dolfin\/[VER]",
                "Firefox": ["Firefox\/[VER]", "FxiOS\/[VER]"],
                "Fennec": "Fennec\/[VER]",
                "Edge": "Edge\/[VER]",
                "IE": ["IEMobile\/[VER];", "IEMobile [VER]", "MSIE [VER];", "Trident\/[0-9.]+;.*rv:[VER]"],
                "NetFront": "NetFront\/[VER]",
                "NokiaBrowser": "NokiaBrowser\/[VER]",
                "Opera": [" OPR\/[VER]", "Opera Mini\/[VER]", "Version\/[VER]"],
                "Opera Mini": "Opera Mini\/[VER]",
                "Opera Mobi": "Version\/[VER]",
                "UC Browser": "UC Browser[VER]",
                "MQQBrowser": "MQQBrowser\/[VER]",
                "MicroMessenger": "MicroMessenger\/[VER]",
                "baiduboxapp": "baiduboxapp\/[VER]",
                "baidubrowser": "baidubrowser\/[VER]",
                "SamsungBrowser": "SamsungBrowser\/[VER]",
                "Iron": "Iron\/[VER]",
                "Safari": ["Version\/[VER]", "Safari\/[VER]"],
                "Skyfire": "Skyfire\/[VER]",
                "Tizen": "Tizen\/[VER]",
                "Webkit": "webkit[ \/][VER]",
                "PaleMoon": "PaleMoon\/[VER]",
                "Gecko": "Gecko\/[VER]",
                "Trident": "Trident\/[VER]",
                "Presto": "Presto\/[VER]",
                "Goanna": "Goanna\/[VER]",
                "iOS": " \\bi?OS\\b [VER][ ;]{1}",
                "Android": "Android [VER]",
                "BlackBerry": ["BlackBerry[\\w]+\/[VER]", "BlackBerry.*Version\/[VER]", "Version\/[VER]"],
                "BREW": "BREW [VER]",
                "Java": "Java\/[VER]",
                "Windows Phone OS": ["Windows Phone OS [VER]", "Windows Phone [VER]"],
                "Windows Phone": "Windows Phone [VER]",
                "Windows CE": "Windows CE\/[VER]",
                "Windows NT": "Windows NT [VER]",
                "Symbian": ["SymbianOS\/[VER]", "Symbian\/[VER]"],
                "webOS": ["webOS\/[VER]", "hpwOS\/[VER];"]
            },
            "utils": {
                "Bot": "Googlebot|facebookexternalhit|AdsBot-Google|Google Keyword Suggestion|Facebot|YandexBot|YandexMobileBot|bingbot|ia_archiver|AhrefsBot|Ezooms|GSLFbot|WBSearchBot|Twitterbot|TweetmemeBot|Twikle|PaperLiBot|Wotbox|UnwindFetchor|Exabot|MJ12bot|YandexImages|TurnitinBot|Pingdom",
                "MobileBot": "Googlebot-Mobile|AdsBot-Google-Mobile|YahooSeeker\/M1A1-R2D2",
                "DesktopMode": "WPDesktop",
                "TV": "SonyDTV|HbbTV",
                "WebKit": "(webkit)[ \/]([\\w.]+)",
                "Console": "\\b(Nintendo|Nintendo WiiU|Nintendo 3DS|PLAYSTATION|Xbox)\\b",
                "Watch": "SM-V700"
            }
        };

        // following patterns come from http://detectmobilebrowsers.com/
        impl.detectMobileBrowsers = {
            fullPattern: /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
            shortPattern: /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
            tabletPattern: /android|ipad|playbook|silk/i
        };

        var hasOwnProp = Object.prototype.hasOwnProperty,
            isArray;

        impl.FALLBACK_PHONE = 'UnknownPhone';
        impl.FALLBACK_TABLET = 'UnknownTablet';
        impl.FALLBACK_MOBILE = 'UnknownMobile';

        isArray = 'isArray' in Array ? Array.isArray : function (value) {
            return Object.prototype.toString.call(value) === '[object Array]';
        };

        function equalIC(a, b) {
            return a != null && b != null && a.toLowerCase() === b.toLowerCase();
        }

        function containsIC(array, value) {
            var valueLC,
                i,
                len = array.length;
            if (!len || !value) {
                return false;
            }
            valueLC = value.toLowerCase();
            for (i = 0; i < len; ++i) {
                if (valueLC === array[i].toLowerCase()) {
                    return true;
                }
            }
            return false;
        }

        function convertPropsToRegExp(object) {
            for (var key in object) {
                if (hasOwnProp.call(object, key)) {
                    object[key] = new RegExp(object[key], 'i');
                }
            }
        }

        (function init() {
            var key,
                values,
                value,
                i,
                len,
                verPos,
                mobileDetectRules = impl.mobileDetectRules;
            for (key in mobileDetectRules.props) {
                if (hasOwnProp.call(mobileDetectRules.props, key)) {
                    values = mobileDetectRules.props[key];
                    if (!isArray(values)) {
                        values = [values];
                    }
                    len = values.length;
                    for (i = 0; i < len; ++i) {
                        value = values[i];
                        verPos = value.indexOf('[VER]');
                        if (verPos >= 0) {
                            value = value.substring(0, verPos) + '([\\w._\\+]+)' + value.substring(verPos + 5);
                        }
                        values[i] = new RegExp(value, 'i');
                    }
                    mobileDetectRules.props[key] = values;
                }
            }
            convertPropsToRegExp(mobileDetectRules.oss);
            convertPropsToRegExp(mobileDetectRules.phones);
            convertPropsToRegExp(mobileDetectRules.tablets);
            convertPropsToRegExp(mobileDetectRules.uas);
            convertPropsToRegExp(mobileDetectRules.utils);

            // copy some patterns to oss0 which are tested first (see issue#15)
            mobileDetectRules.oss0 = {
                WindowsPhoneOS: mobileDetectRules.oss.WindowsPhoneOS,
                WindowsMobileOS: mobileDetectRules.oss.WindowsMobileOS
            };
        })();

        /**
         * Test userAgent string against a set of rules and find the first matched key.
         * @param {Object} rules (key is String, value is RegExp)
         * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
         * @returns {String|null} the matched key if found, otherwise <tt>null</tt>
         * @private
         */
        impl.findMatch = function (rules, userAgent) {
            for (var key in rules) {
                if (hasOwnProp.call(rules, key)) {
                    if (rules[key].test(userAgent)) {
                        return key;
                    }
                }
            }
            return null;
        };

        /**
         * Test userAgent string against a set of rules and return an array of matched keys.
         * @param {Object} rules (key is String, value is RegExp)
         * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
         * @returns {Array} an array of matched keys, may be empty when there is no match, but not <tt>null</tt>
         * @private
         */
        impl.findMatches = function (rules, userAgent) {
            var result = [];
            for (var key in rules) {
                if (hasOwnProp.call(rules, key)) {
                    if (rules[key].test(userAgent)) {
                        result.push(key);
                    }
                }
            }
            return result;
        };

        /**
         * Check the version of the given property in the User-Agent.
         *
         * @param {String} propertyName
         * @param {String} userAgent
         * @return {String} version or <tt>null</tt> if version not found
         * @private
         */
        impl.getVersionStr = function (propertyName, userAgent) {
            var props = impl.mobileDetectRules.props,
                patterns,
                i,
                len,
                match;
            if (hasOwnProp.call(props, propertyName)) {
                patterns = props[propertyName];
                len = patterns.length;
                for (i = 0; i < len; ++i) {
                    match = patterns[i].exec(userAgent);
                    if (match !== null) {
                        return match[1];
                    }
                }
            }
            return null;
        };

        /**
         * Check the version of the given property in the User-Agent.
         * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
         *
         * @param {String} propertyName
         * @param {String} userAgent
         * @return {Number} version or <tt>NaN</tt> if version not found
         * @private
         */
        impl.getVersion = function (propertyName, userAgent) {
            var version = impl.getVersionStr(propertyName, userAgent);
            return version ? impl.prepareVersionNo(version) : NaN;
        };

        /**
         * Prepare the version number.
         *
         * @param {String} version
         * @return {Number} the version number as a floating number
         * @private
         */
        impl.prepareVersionNo = function (version) {
            var numbers;

            numbers = version.split(/[a-z._ \/\-]/i);
            if (numbers.length === 1) {
                version = numbers[0];
            }
            if (numbers.length > 1) {
                version = numbers[0] + '.';
                numbers.shift();
                version += numbers.join('');
            }
            return Number(version);
        };

        impl.isMobileFallback = function (userAgent) {
            return impl.detectMobileBrowsers.fullPattern.test(userAgent) || impl.detectMobileBrowsers.shortPattern.test(userAgent.substr(0, 4));
        };

        impl.isTabletFallback = function (userAgent) {
            return impl.detectMobileBrowsers.tabletPattern.test(userAgent);
        };

        impl.prepareDetectionCache = function (cache, userAgent, maxPhoneWidth) {
            if (cache.mobile !== undefined) {
                return;
            }
            var phone, tablet, phoneSized;

            // first check for stronger tablet rules, then phone (see issue#5)
            tablet = impl.findMatch(impl.mobileDetectRules.tablets, userAgent);
            if (tablet) {
                cache.mobile = cache.tablet = tablet;
                cache.phone = null;
                return; // unambiguously identified as tablet
            }

            phone = impl.findMatch(impl.mobileDetectRules.phones, userAgent);
            if (phone) {
                cache.mobile = cache.phone = phone;
                cache.tablet = null;
                return; // unambiguously identified as phone
            }

            // our rules haven't found a match -> try more general fallback rules
            if (impl.isMobileFallback(userAgent)) {
                phoneSized = MobileDetect.isPhoneSized(maxPhoneWidth);
                if (phoneSized === undefined) {
                    cache.mobile = impl.FALLBACK_MOBILE;
                    cache.tablet = cache.phone = null;
                } else if (phoneSized) {
                    cache.mobile = cache.phone = impl.FALLBACK_PHONE;
                    cache.tablet = null;
                } else {
                    cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
                    cache.phone = null;
                }
            } else if (impl.isTabletFallback(userAgent)) {
                cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
                cache.phone = null;
            } else {
                // not mobile at all!
                cache.mobile = cache.tablet = cache.phone = null;
            }
        };

        // t is a reference to a MobileDetect instance
        impl.mobileGrade = function (t) {
            // impl note:
            // To keep in sync w/ Mobile_Detect.php easily, the following code is tightly aligned to the PHP version.
            // When changes are made in Mobile_Detect.php, copy this method and replace:
            //     $this-> / t.
            //     self::MOBILE_GRADE_(.) / '$1'
            //     , self::VERSION_TYPE_FLOAT / (nothing)
            //     isIOS() / os('iOS')
            //     [reg] / (nothing)   <-- jsdelivr complaining about unescaped unicode character U+00AE
            var $isMobile = t.mobile() !== null;

            if (
            // Apple iOS 3.2-5.1 - Tested on the original iPad (4.3 / 5.0), iPad 2 (4.3), iPad 3 (5.1), original iPhone (3.1), iPhone 3 (3.2), 3GS (4.3), 4 (4.3 / 5.0), and 4S (5.1)
            t.os('iOS') && t.version('iPad') >= 4.3 || t.os('iOS') && t.version('iPhone') >= 3.1 || t.os('iOS') && t.version('iPod') >= 3.1 ||

            // Android 2.1-2.3 - Tested on the HTC Incredible (2.2), original Droid (2.2), HTC Aria (2.1), Google Nexus S (2.3). Functional on 1.5 & 1.6 but performance may be sluggish, tested on Google G1 (1.5)
            // Android 3.1 (Honeycomb)  - Tested on the Samsung Galaxy Tab 10.1 and Motorola XOOM
            // Android 4.0 (ICS)  - Tested on a Galaxy Nexus. Note: transition performance can be poor on upgraded devices
            // Android 4.1 (Jelly Bean)  - Tested on a Galaxy Nexus and Galaxy 7
            t.version('Android') > 2.1 && t.is('Webkit') ||

            // Windows Phone 7-7.5 - Tested on the HTC Surround (7.0) HTC Trophy (7.5), LG-E900 (7.5), Nokia Lumia 800
            t.version('Windows Phone OS') >= 7.0 ||

            // Blackberry 7 - Tested on BlackBerry Torch 9810
            // Blackberry 6.0 - Tested on the Torch 9800 and Style 9670
            t.is('BlackBerry') && t.version('BlackBerry') >= 6.0 ||
            // Blackberry Playbook (1.0-2.0) - Tested on PlayBook
            t.match('Playbook.*Tablet') ||

            // Palm WebOS (1.4-2.0) - Tested on the Palm Pixi (1.4), Pre (1.4), Pre 2 (2.0)
            t.version('webOS') >= 1.4 && t.match('Palm|Pre|Pixi') ||
            // Palm WebOS 3.0  - Tested on HP TouchPad
            t.match('hp.*TouchPad') ||

            // Firefox Mobile (12 Beta) - Tested on Android 2.3 device
            t.is('Firefox') && t.version('Firefox') >= 12 ||

            // Chrome for Android - Tested on Android 4.0, 4.1 device
            t.is('Chrome') && t.is('AndroidOS') && t.version('Android') >= 4.0 ||

            // Skyfire 4.1 - Tested on Android 2.3 device
            t.is('Skyfire') && t.version('Skyfire') >= 4.1 && t.is('AndroidOS') && t.version('Android') >= 2.3 ||

            // Opera Mobile 11.5-12: Tested on Android 2.3
            t.is('Opera') && t.version('Opera Mobi') > 11 && t.is('AndroidOS') ||

            // Meego 1.2 - Tested on Nokia 950 and N9
            t.is('MeeGoOS') ||

            // Tizen (pre-release) - Tested on early hardware
            t.is('Tizen') ||

            // Samsung Bada 2.0 - Tested on a Samsung Wave 3, Dolphin browser
            // @todo: more tests here!
            t.is('Dolfin') && t.version('Bada') >= 2.0 ||

            // UC Browser - Tested on Android 2.3 device
            (t.is('UC Browser') || t.is('Dolfin')) && t.version('Android') >= 2.3 ||

            // Kindle 3 and Fire  - Tested on the built-in WebKit browser for each
            t.match('Kindle Fire') || t.is('Kindle') && t.version('Kindle') >= 3.0 ||

            // Nook Color 1.4.1 - Tested on original Nook Color, not Nook Tablet
            t.is('AndroidOS') && t.is('NookTablet') ||

            // Chrome Desktop 11-21 - Tested on OS X 10.7 and Windows 7
            t.version('Chrome') >= 11 && !$isMobile ||

            // Safari Desktop 4-5 - Tested on OS X 10.7 and Windows 7
            t.version('Safari') >= 5.0 && !$isMobile ||

            // Firefox Desktop 4-13 - Tested on OS X 10.7 and Windows 7
            t.version('Firefox') >= 4.0 && !$isMobile ||

            // Internet Explorer 7-9 - Tested on Windows XP, Vista and 7
            t.version('MSIE') >= 7.0 && !$isMobile ||

            // Opera Desktop 10-12 - Tested on OS X 10.7 and Windows 7
            // @reference: http://my.opera.com/community/openweb/idopera/
            t.version('Opera') >= 10 && !$isMobile) {
                return 'A';
            }

            if (t.os('iOS') && t.version('iPad') < 4.3 || t.os('iOS') && t.version('iPhone') < 3.1 || t.os('iOS') && t.version('iPod') < 3.1 ||

            // Blackberry 5.0: Tested on the Storm 2 9550, Bold 9770
            t.is('Blackberry') && t.version('BlackBerry') >= 5 && t.version('BlackBerry') < 6 ||

            //Opera Mini (5.0-6.5) - Tested on iOS 3.2/4.3 and Android 2.3
            t.version('Opera Mini') >= 5.0 && t.version('Opera Mini') <= 6.5 && (t.version('Android') >= 2.3 || t.is('iOS')) ||

            // Nokia Symbian^3 - Tested on Nokia N8 (Symbian^3), C7 (Symbian^3), also works on N97 (Symbian^1)
            t.match('NokiaN8|NokiaC7|N97.*Series60|Symbian/3') ||

            // @todo: report this (tested on Nokia N71)
            t.version('Opera Mobi') >= 11 && t.is('SymbianOS')) {
                return 'B';
            }

            if (
            // Blackberry 4.x - Tested on the Curve 8330
            t.version('BlackBerry') < 5.0 ||
            // Windows Mobile - Tested on the HTC Leo (WinMo 5.2)
            t.match('MSIEMobile|Windows CE.*Mobile') || t.version('Windows Mobile') <= 5.2) {
                return 'C';
            }

            //All older smartphone platforms and featurephones - Any device that doesn't support media queries
            //will receive the basic, C grade experience.
            return 'C';
        };

        impl.detectOS = function (ua) {
            return impl.findMatch(impl.mobileDetectRules.oss0, ua) || impl.findMatch(impl.mobileDetectRules.oss, ua);
        };

        impl.getDeviceSmallerSide = function () {
            return window.screen.width < window.screen.height ? window.screen.width : window.screen.height;
        };

        /**
         * Constructor for MobileDetect object.
         * <br>
         * Such an object will keep a reference to the given user-agent string and cache most of the detect queries.<br>
         * <div style="background-color: #d9edf7; border: 1px solid #bce8f1; color: #3a87ad; padding: 14px; border-radius: 2px; margin-top: 20px">
         *     <strong>Find information how to download and install:</strong>
         *     <a href="https://github.com/hgoebl/mobile-detect.js/">github.com/hgoebl/mobile-detect.js/</a>
         * </div>
         *
         * @example <pre>
         *     var md = new MobileDetect(window.navigator.userAgent);
         *     if (md.mobile()) {
         *         location.href = (md.mobileGrade() === 'A') ? '/mobile/' : '/lynx/';
         *     }
         * </pre>
         *
         * @param {string} userAgent typically taken from window.navigator.userAgent or http_header['User-Agent']
         * @param {number} [maxPhoneWidth=600] <strong>only for browsers</strong> specify a value for the maximum
         *        width of smallest device side (in logical "CSS" pixels) until a device detected as mobile will be handled
         *        as phone.
         *        This is only used in cases where the device cannot be classified as phone or tablet.<br>
         *        See <a href="http://developer.android.com/guide/practices/screens_support.html">Declaring Tablet Layouts
         *        for Android</a>.<br>
         *        If you provide a value < 0, then this "fuzzy" check is disabled.
         * @constructor
         * @global
         */
        function MobileDetect(userAgent, maxPhoneWidth) {
            this.ua = userAgent || '';
            this._cache = {};
            //600dp is typical 7" tablet minimum width
            this.maxPhoneWidth = maxPhoneWidth || 600;
        }

        MobileDetect.prototype = {
            constructor: MobileDetect,

            /**
             * Returns the detected phone or tablet type or <tt>null</tt> if it is not a mobile device.
             * <br>
             * For a list of possible return values see {@link MobileDetect#phone} and {@link MobileDetect#tablet}.<br>
             * <br>
             * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
             * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
             * is positive, a value of <code>UnknownPhone</code>, <code>UnknownTablet</code> or
             * <code>UnknownMobile</code> is returned.<br>
             * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
             * <br>
             * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
             * and <code>UnknownMobile</code>, so you will get <code>UnknownMobile</code> here.<br>
             * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
             * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
             * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
             * <br>
             * In most cases you will use the return value just as a boolean.
             *
             * @returns {String} the key for the phone family or tablet family, e.g. "Nexus".
             * @function MobileDetect#mobile
             */
            mobile: function mobile() {
                impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
                return this._cache.mobile;
            },

            /**
             * Returns the detected phone type/family string or <tt>null</tt>.
             * <br>
             * The returned tablet (family or producer) is one of following keys:<br>
             * <br><tt>iPhone, BlackBerry, HTC, Nexus, Dell, Motorola, Samsung, LG, Sony, Asus,
             * NokiaLumia, Micromax, Palm, Vertu, Pantech, Fly, Wiko, iMobile, SimValley,
             * Wolfgang, Alcatel, Nintendo, Amoi, INQ, GenericPhone</tt><br>
             * <br>
             * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
             * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
             * is positive, a value of <code>UnknownPhone</code> or <code>UnknownMobile</code> is returned.<br>
             * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
             * <br>
             * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
             * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
             * will return <code>UnknownMobile</code>.<br>
             * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
             * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
             * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
             * <br>
             * In most cases you will use the return value just as a boolean.
             *
             * @returns {String} the key of the phone family or producer, e.g. "iPhone"
             * @function MobileDetect#phone
             */
            phone: function phone() {
                impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
                return this._cache.phone;
            },

            /**
             * Returns the detected tablet type/family string or <tt>null</tt>.
             * <br>
             * The returned tablet (family or producer) is one of following keys:<br>
             * <br><tt>iPad, NexusTablet, SamsungTablet, Kindle, SurfaceTablet, HPTablet, AsusTablet,
             * BlackBerryTablet, HTCtablet, MotorolaTablet, NookTablet, AcerTablet,
             * ToshibaTablet, LGTablet, FujitsuTablet, PrestigioTablet, LenovoTablet,
             * DellTablet, YarvikTablet, MedionTablet, ArnovaTablet, IntensoTablet, IRUTablet,
             * MegafonTablet, EbodaTablet, AllViewTablet, ArchosTablet, AinolTablet,
             * NokiaLumiaTablet, SonyTablet, PhilipsTablet, CubeTablet, CobyTablet, MIDTablet,
             * MSITablet, SMiTTablet, RockChipTablet, FlyTablet, bqTablet, HuaweiTablet,
             * NecTablet, PantechTablet, BronchoTablet, VersusTablet, ZyncTablet,
             * PositivoTablet, NabiTablet, KoboTablet, DanewTablet, TexetTablet,
             * PlaystationTablet, TrekstorTablet, PyleAudioTablet, AdvanTablet,
             * DanyTechTablet, GalapadTablet, MicromaxTablet, KarbonnTablet, AllFineTablet,
             * PROSCANTablet, YONESTablet, ChangJiaTablet, GUTablet, PointOfViewTablet,
             * OvermaxTablet, HCLTablet, DPSTablet, VistureTablet, CrestaTablet,
             * MediatekTablet, ConcordeTablet, GoCleverTablet, ModecomTablet, VoninoTablet,
             * ECSTablet, StorexTablet, VodafoneTablet, EssentielBTablet, RossMoorTablet,
             * iMobileTablet, TolinoTablet, AudioSonicTablet, AMPETablet, SkkTablet,
             * TecnoTablet, JXDTablet, iJoyTablet, FX2Tablet, XoroTablet, ViewsonicTablet,
             * OdysTablet, CaptivaTablet, IconbitTablet, TeclastTablet, OndaTablet,
             * JaytechTablet, BlaupunktTablet, DigmaTablet, EvolioTablet, LavaTablet,
             * AocTablet, MpmanTablet, CelkonTablet, WolderTablet, MiTablet, NibiruTablet,
             * NexoTablet, LeaderTablet, UbislateTablet, PocketBookTablet, KocasoTablet,
             * HisenseTablet, Hudl, TelstraTablet, GenericTablet</tt><br>
             * <br>
             * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
             * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
             * is positive, a value of <code>UnknownTablet</code> or <code>UnknownMobile</code> is returned.<br>
             * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
             * <br>
             * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
             * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
             * will return <code>UnknownMobile</code>.<br>
             * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
             * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
             * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
             * <br>
             * In most cases you will use the return value just as a boolean.
             *
             * @returns {String} the key of the tablet family or producer, e.g. "SamsungTablet"
             * @function MobileDetect#tablet
             */
            tablet: function tablet() {
                impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
                return this._cache.tablet;
            },

            /**
             * Returns the (first) detected user-agent string or <tt>null</tt>.
             * <br>
             * The returned user-agent is one of following keys:<br>
             * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
             * Safari, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Puffin, Mercury,
             * ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
             * <br>
             * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
             * cases where a mobile device pretends to be more than one particular browser. You can get the
             * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
             * providing one of the defined keys as first argument to {@link MobileDetect#is}.
             *
             * @returns {String} the key for the detected user-agent or <tt>null</tt>
             * @function MobileDetect#userAgent
             */
            userAgent: function userAgent() {
                if (this._cache.userAgent === undefined) {
                    this._cache.userAgent = impl.findMatch(impl.mobileDetectRules.uas, this.ua);
                }
                return this._cache.userAgent;
            },

            /**
             * Returns all detected user-agent strings.
             * <br>
             * The array is empty or contains one or more of following keys:<br>
             * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
             * Safari, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Puffin, Mercury,
             * ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
             * <br>
             * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
             * cases where a mobile device pretends to be more than one particular browser. You can get the
             * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
             * providing one of the defined keys as first argument to {@link MobileDetect#is}.
             *
             * @returns {Array} the array of detected user-agent keys or <tt>[]</tt>
             * @function MobileDetect#userAgents
             */
            userAgents: function userAgents() {
                if (this._cache.userAgents === undefined) {
                    this._cache.userAgents = impl.findMatches(impl.mobileDetectRules.uas, this.ua);
                }
                return this._cache.userAgents;
            },

            /**
             * Returns the detected operating system string or <tt>null</tt>.
             * <br>
             * The operating system is one of following keys:<br>
             * <br><tt>AndroidOS, BlackBerryOS, PalmOS, SymbianOS, WindowsMobileOS, WindowsPhoneOS,
             * iOS, MeeGoOS, MaemoOS, JavaOS, webOS, badaOS, BREWOS</tt><br>
             *
             * @returns {String} the key for the detected operating system.
             * @function MobileDetect#os
             */
            os: function os() {
                if (this._cache.os === undefined) {
                    this._cache.os = impl.detectOS(this.ua);
                }
                return this._cache.os;
            },

            /**
             * Get the version (as Number) of the given property in the User-Agent.
             * <br>
             * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
             *
             * @param {String} key a key defining a thing which has a version.<br>
             *        You can use one of following keys:<br>
             * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
             * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
             * Opera Mobi, UC Browser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
             * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon, Gecko, Trident,
             * Presto, Goanna, iOS, Android, BlackBerry, BREW, Java, Windows Phone OS, Windows
             * Phone, Windows CE, Windows NT, Symbian, webOS</tt><br>
             *
             * @returns {Number} the version as float or <tt>NaN</tt> if User-Agent doesn't contain this version.
             *          Be careful when comparing this value with '==' operator!
             * @function MobileDetect#version
             */
            version: function version(key) {
                return impl.getVersion(key, this.ua);
            },

            /**
             * Get the version (as String) of the given property in the User-Agent.
             * <br>
             *
             * @param {String} key a key defining a thing which has a version.<br>
             *        You can use one of following keys:<br>
             * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
             * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
             * Opera Mobi, UC Browser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
             * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon, Gecko, Trident,
             * Presto, Goanna, iOS, Android, BlackBerry, BREW, Java, Windows Phone OS, Windows
             * Phone, Windows CE, Windows NT, Symbian, webOS</tt><br>
             *
             * @returns {String} the "raw" version as String or <tt>null</tt> if User-Agent doesn't contain this version.
             *
             * @function MobileDetect#versionStr
             */
            versionStr: function versionStr(key) {
                return impl.getVersionStr(key, this.ua);
            },

            /**
             * Global test key against userAgent, os, phone, tablet and some other properties of userAgent string.
             *
             * @param {String} key the key (case-insensitive) of a userAgent, an operating system, phone or
             *        tablet family.<br>
             *        For a complete list of possible values, see {@link MobileDetect#userAgent},
             *        {@link MobileDetect#os}, {@link MobileDetect#phone}, {@link MobileDetect#tablet}.<br>
             *        Additionally you have following keys:<br>
             * <br><tt>Bot, MobileBot, DesktopMode, TV, WebKit, Console, Watch</tt><br>
             *
             * @returns {boolean} <tt>true</tt> when the given key is one of the defined keys of userAgent, os, phone,
             *                    tablet or one of the listed additional keys, otherwise <tt>false</tt>
             * @function MobileDetect#is
             */
            is: function is(key) {
                return containsIC(this.userAgents(), key) || equalIC(key, this.os()) || equalIC(key, this.phone()) || equalIC(key, this.tablet()) || containsIC(impl.findMatches(impl.mobileDetectRules.utils, this.ua), key);
            },

            /**
             * Do a quick test against navigator::userAgent.
             *
             * @param {String|RegExp} pattern the pattern, either as String or RegExp
             *                        (a string will be converted to a case-insensitive RegExp).
             * @returns {boolean} <tt>true</tt> when the pattern matches, otherwise <tt>false</tt>
             * @function MobileDetect#match
             */
            match: function match(pattern) {
                if (!(pattern instanceof RegExp)) {
                    pattern = new RegExp(pattern, 'i');
                }
                return pattern.test(this.ua);
            },

            /**
             * Checks whether the mobile device can be considered as phone regarding <code>screen.width</code>.
             * <br>
             * Obviously this method makes sense in browser environments only (not for Node.js)!
             * @param {number} [maxPhoneWidth] the maximum logical pixels (aka. CSS-pixels) to be considered as phone.<br>
             *        The argument is optional and if not present or falsy, the value of the constructor is taken.
             * @returns {boolean|undefined} <code>undefined</code> if screen size wasn't detectable, else <code>true</code>
             *          when screen.width is less or equal to maxPhoneWidth, otherwise <code>false</code>.<br>
             *          Will always return <code>undefined</code> server-side.
             */
            isPhoneSized: function isPhoneSized(maxPhoneWidth) {
                return MobileDetect.isPhoneSized(maxPhoneWidth || this.maxPhoneWidth);
            },

            /**
             * Returns the mobile grade ('A', 'B', 'C').
             *
             * @returns {String} one of the mobile grades ('A', 'B', 'C').
             * @function MobileDetect#mobileGrade
             */
            mobileGrade: function mobileGrade() {
                if (this._cache.grade === undefined) {
                    this._cache.grade = impl.mobileGrade(this);
                }
                return this._cache.grade;
            }
        };

        // environment-dependent
        if (typeof window !== 'undefined' && window.screen) {
            MobileDetect.isPhoneSized = function (maxPhoneWidth) {
                return maxPhoneWidth < 0 ? undefined : impl.getDeviceSmallerSide() <= maxPhoneWidth;
            };
        } else {
            MobileDetect.isPhoneSized = function () {};
        }

        // should not be replaced by a completely new object - just overwrite existing methods
        MobileDetect._impl = impl;

        MobileDetect.version = '1.3.6 2017-04-05';

        return MobileDetect;
    }); // end of call of define()
})(function (undefined) {
    if (typeof module !== 'undefined' && module.exports) {
        return function (factory) {
            module.exports = factory();
        };
    } else if (true) {
        return __webpack_require__(866);
    } else if (typeof window !== 'undefined') {
        return function (factory) {
            window.MobileDetect = factory();
        };
    } else {
        // please file a bug if you get this error!
        throw new Error('unknown environment');
    }
}());

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.denormalize = exports.normalize = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _Polymorphic = __webpack_require__(180);

var _Polymorphic2 = _interopRequireDefault(_Polymorphic);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var validateSchema = function validateSchema(definition) {
  var isArray = Array.isArray(definition);
  if (isArray && definition.length > 1) {
    throw new Error('Expected schema definition to be a single schema, but found ' + definition.length + '.');
  }

  return definition[0];
};

var getValues = function getValues(input) {
  return Array.isArray(input) ? input : Object.keys(input).map(function (key) {
    return input[key];
  });
};

var normalize = exports.normalize = function normalize(schema, input, parent, key, visit, addEntity) {
  schema = validateSchema(schema);

  var values = getValues(input);

  // Special case: Arrays pass *their* parent on to their children, since there
  // is not any special information that can be gathered from themselves directly
  return values.map(function (value, index) {
    return visit(value, parent, key, schema, addEntity);
  });
};

var denormalize = exports.denormalize = function denormalize(schema, input, unvisit) {
  schema = validateSchema(schema);
  return input && input.map ? input.map(function (entityOrId) {
    return unvisit(entityOrId, schema);
  }) : input;
};

var ArraySchema = function (_PolymorphicSchema) {
  _inherits(ArraySchema, _PolymorphicSchema);

  function ArraySchema() {
    _classCallCheck(this, ArraySchema);

    return _possibleConstructorReturn(this, (ArraySchema.__proto__ || Object.getPrototypeOf(ArraySchema)).apply(this, arguments));
  }

  _createClass(ArraySchema, [{
    key: 'normalize',
    value: function normalize(input, parent, key, visit, addEntity) {
      var _this2 = this;

      var values = getValues(input);

      return values.map(function (value, index) {
        return _this2.normalizeValue(value, parent, key, visit, addEntity);
      }).filter(function (value) {
        return value !== undefined && value !== null;
      });
    }
  }, {
    key: 'denormalize',
    value: function denormalize(input, unvisit) {
      var _this3 = this;

      return input && input.map ? input.map(function (value) {
        return _this3.denormalizeValue(value, unvisit);
      }) : input;
    }
  }]);

  return ArraySchema;
}(_Polymorphic2.default);

exports.default = ArraySchema;

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _ImmutableUtils = __webpack_require__(126);

var ImmutableUtils = _interopRequireWildcard(_ImmutableUtils);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var getDefaultGetId = function getDefaultGetId(idAttribute) {
  return function (input) {
    return ImmutableUtils.isImmutable(input) ? input.get(idAttribute) : input[idAttribute];
  };
};

var EntitySchema = function () {
  function EntitySchema(key) {
    var definition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, EntitySchema);

    if (!key || typeof key !== 'string') {
      throw new Error('Expected a string key for Entity, but found ' + key + '.');
    }

    var _options$idAttribute = options.idAttribute,
        idAttribute = _options$idAttribute === undefined ? 'id' : _options$idAttribute,
        _options$mergeStrateg = options.mergeStrategy,
        mergeStrategy = _options$mergeStrateg === undefined ? function (entityA, entityB) {
      return _extends({}, entityA, entityB);
    } : _options$mergeStrateg,
        _options$processStrat = options.processStrategy,
        processStrategy = _options$processStrat === undefined ? function (input) {
      return _extends({}, input);
    } : _options$processStrat;

    this._key = key;
    this._getId = typeof idAttribute === 'function' ? idAttribute : getDefaultGetId(idAttribute);
    this._idAttribute = idAttribute;
    this._mergeStrategy = mergeStrategy;
    this._processStrategy = processStrategy;
    this.define(definition);
  }

  _createClass(EntitySchema, [{
    key: 'define',
    value: function define(definition) {
      this.schema = Object.keys(definition).reduce(function (entitySchema, key) {
        var schema = definition[key];
        return _extends({}, entitySchema, _defineProperty({}, key, schema));
      }, this.schema || {});
    }
  }, {
    key: 'getId',
    value: function getId(input, parent, key) {
      return this._getId(input, parent, key);
    }
  }, {
    key: 'merge',
    value: function merge(entityA, entityB) {
      return this._mergeStrategy(entityA, entityB);
    }
  }, {
    key: 'normalize',
    value: function normalize(input, parent, key, visit, addEntity) {
      var _this = this;

      var processedEntity = this._processStrategy(input, parent, key);
      Object.keys(this.schema).forEach(function (key) {
        if (processedEntity.hasOwnProperty(key) && _typeof(processedEntity[key]) === 'object') {
          var schema = _this.schema[key];
          processedEntity[key] = visit(processedEntity[key], processedEntity, key, schema, addEntity);
        }
      });

      addEntity(this, processedEntity, input, parent, key);
      return this.getId(input, parent, key);
    }
  }, {
    key: 'denormalize',
    value: function denormalize(entity, unvisit) {
      var _this2 = this;

      if (ImmutableUtils.isImmutable(entity)) {
        return ImmutableUtils.denormalizeImmutable(this.schema, entity, unvisit);
      }

      Object.keys(this.schema).forEach(function (key) {
        if (entity.hasOwnProperty(key)) {
          var schema = _this2.schema[key];
          entity[key] = unvisit(entity[key], schema);
        }
      });
      return entity;
    }
  }, {
    key: 'key',
    get: function get() {
      return this._key;
    }
  }, {
    key: 'idAttribute',
    get: function get() {
      return this._idAttribute;
    }
  }]);

  return EntitySchema;
}();

exports.default = EntitySchema;

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.denormalize = exports.normalize = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _ImmutableUtils = __webpack_require__(126);

var ImmutableUtils = _interopRequireWildcard(_ImmutableUtils);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var _normalize = function _normalize(schema, input, parent, key, visit, addEntity) {
  var object = _extends({}, input);
  Object.keys(schema).forEach(function (key) {
    var localSchema = schema[key];
    var value = visit(input[key], input, key, localSchema, addEntity);
    if (value === undefined || value === null) {
      delete object[key];
    } else {
      object[key] = value;
    }
  });
  return object;
};

exports.normalize = _normalize;
var _denormalize = function _denormalize(schema, input, unvisit) {
  if (ImmutableUtils.isImmutable(input)) {
    return ImmutableUtils.denormalizeImmutable(schema, input, unvisit);
  }

  var object = _extends({}, input);
  Object.keys(schema).forEach(function (key) {
    if (object[key]) {
      object[key] = unvisit(object[key], schema[key]);
    }
  });
  return object;
};

exports.denormalize = _denormalize;

var ObjectSchema = function () {
  function ObjectSchema(definition) {
    _classCallCheck(this, ObjectSchema);

    this.define(definition);
  }

  _createClass(ObjectSchema, [{
    key: 'define',
    value: function define(definition) {
      this.schema = Object.keys(definition).reduce(function (entitySchema, key) {
        var schema = definition[key];
        return _extends({}, entitySchema, _defineProperty({}, key, schema));
      }, this.schema || {});
    }
  }, {
    key: 'normalize',
    value: function normalize() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _normalize.apply(undefined, [this.schema].concat(args));
    }
  }, {
    key: 'denormalize',
    value: function denormalize() {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _denormalize.apply(undefined, [this.schema].concat(args));
    }
  }]);

  return ObjectSchema;
}();

exports.default = ObjectSchema;

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _Polymorphic = __webpack_require__(180);

var _Polymorphic2 = _interopRequireDefault(_Polymorphic);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var UnionSchema = function (_PolymorphicSchema) {
  _inherits(UnionSchema, _PolymorphicSchema);

  function UnionSchema(definition, schemaAttribute) {
    _classCallCheck(this, UnionSchema);

    if (!schemaAttribute) {
      throw new Error('Expected option "schemaAttribute" not found on UnionSchema.');
    }
    return _possibleConstructorReturn(this, (UnionSchema.__proto__ || Object.getPrototypeOf(UnionSchema)).call(this, definition, schemaAttribute));
  }

  _createClass(UnionSchema, [{
    key: 'normalize',
    value: function normalize(input, parent, key, visit, addEntity) {
      return this.normalizeValue(input, parent, key, visit, addEntity);
    }
  }, {
    key: 'denormalize',
    value: function denormalize(input, unvisit) {
      return this.denormalizeValue(input, unvisit);
    }
  }]);

  return UnionSchema;
}(_Polymorphic2.default);

exports.default = UnionSchema;

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _Polymorphic = __webpack_require__(180);

var _Polymorphic2 = _interopRequireDefault(_Polymorphic);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ValuesSchema = function (_PolymorphicSchema) {
  _inherits(ValuesSchema, _PolymorphicSchema);

  function ValuesSchema() {
    _classCallCheck(this, ValuesSchema);

    return _possibleConstructorReturn(this, (ValuesSchema.__proto__ || Object.getPrototypeOf(ValuesSchema)).apply(this, arguments));
  }

  _createClass(ValuesSchema, [{
    key: 'normalize',
    value: function normalize(input, parent, key, visit, addEntity) {
      var _this2 = this;

      return Object.keys(input).reduce(function (output, key, index) {
        var value = input[key];
        return value !== undefined && value !== null ? _extends({}, output, _defineProperty({}, key, _this2.normalizeValue(value, input, key, visit, addEntity))) : output;
      }, {});
    }
  }, {
    key: 'denormalize',
    value: function denormalize(input, unvisit) {
      var _this3 = this;

      return Object.keys(input).reduce(function (output, key) {
        var entityOrId = input[key];
        return _extends({}, output, _defineProperty({}, key, _this3.denormalizeValue(entityOrId, unvisit)));
      }, {});
    }
  }]);

  return ValuesSchema;
}(_Polymorphic2.default);

exports.default = ValuesSchema;

/***/ }),
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(784);

/***/ }),
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOM = __webpack_require__(273);

exports.getReactDOM = function () {
  return ReactDOM;
};

if (false) {
  var ReactPerf;
  var ReactTestUtils;

  exports.getReactPerf = function () {
    if (!ReactPerf) {
      ReactPerf = require('react-dom/lib/ReactPerf');
    }
    return ReactPerf;
  };

  exports.getReactTestUtils = function () {
    if (!ReactTestUtils) {
      ReactTestUtils = require('react-dom/lib/ReactTestUtils');
    }
    return ReactTestUtils;
  };
}

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _assign = __webpack_require__(10);

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var React = __webpack_require__(53);
var propTypesFactory = __webpack_require__(101);
var PropTypes = propTypesFactory(React.isValidElement);

var ReactTransitionGroup = __webpack_require__(794);
var ReactCSSTransitionGroupChild = __webpack_require__(785);

function createTransitionTimeoutPropValidator(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to ReactCSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }
  };
}

/**
 * An easy way to perform CSS transitions and animations when a React component
 * enters or leaves the DOM.
 * See https://facebook.github.io/react/docs/animation.html#high-level-api-reactcsstransitiongroup
 */

var ReactCSSTransitionGroup = function (_React$Component) {
  _inherits(ReactCSSTransitionGroup, _React$Component);

  function ReactCSSTransitionGroup() {
    var _temp, _this, _ret;

    _classCallCheck(this, ReactCSSTransitionGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
      // We need to provide this childFactory so that
      // ReactCSSTransitionGroupChild can receive updates to name, enter, and
      // leave while it is leaving.
      return React.createElement(ReactCSSTransitionGroupChild, {
        name: _this.props.transitionName,
        appear: _this.props.transitionAppear,
        enter: _this.props.transitionEnter,
        leave: _this.props.transitionLeave,
        appearTimeout: _this.props.transitionAppearTimeout,
        enterTimeout: _this.props.transitionEnterTimeout,
        leaveTimeout: _this.props.transitionLeaveTimeout
      }, child);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ReactCSSTransitionGroup.prototype.render = function render() {
    return React.createElement(ReactTransitionGroup, _assign({}, this.props, { childFactory: this._wrapChild }));
  };

  return ReactCSSTransitionGroup;
}(React.Component);

ReactCSSTransitionGroup.displayName = 'ReactCSSTransitionGroup';
ReactCSSTransitionGroup.propTypes = {
  transitionName: ReactCSSTransitionGroupChild.propTypes.name,

  transitionAppear: PropTypes.bool,
  transitionEnter: PropTypes.bool,
  transitionLeave: PropTypes.bool,
  transitionAppearTimeout: createTransitionTimeoutPropValidator('Appear'),
  transitionEnterTimeout: createTransitionTimeoutPropValidator('Enter'),
  transitionLeaveTimeout: createTransitionTimeoutPropValidator('Leave')
};
ReactCSSTransitionGroup.defaultProps = {
  transitionAppear: false,
  transitionEnter: true,
  transitionLeave: true
};

module.exports = ReactCSSTransitionGroup;

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var React = __webpack_require__(53);
var ReactAddonsDOMDependencies = __webpack_require__(783);

var propTypesFactory = __webpack_require__(101);
var PropTypes = propTypesFactory(React.isValidElement);

var CSSCore = __webpack_require__(614);
var ReactTransitionEvents = __webpack_require__(793);

var onlyChild = __webpack_require__(312);

var TICK = 17;

var ReactCSSTransitionGroupChild = function (_React$Component) {
  _inherits(ReactCSSTransitionGroupChild, _React$Component);

  function ReactCSSTransitionGroupChild() {
    var _temp, _this, _ret;

    _classCallCheck(this, ReactCSSTransitionGroupChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._isMounted = false, _this.transition = function (animationType, finishCallback, userSpecifiedDelay) {
      var node = ReactAddonsDOMDependencies.getReactDOM().findDOMNode(_this);

      if (!node) {
        if (finishCallback) {
          finishCallback();
        }
        return;
      }

      var className = _this.props.name[animationType] || _this.props.name + '-' + animationType;
      var activeClassName = _this.props.name[animationType + 'Active'] || className + '-active';
      var timeout = null;

      var endListener = function endListener(e) {
        if (e && e.target !== node) {
          return;
        }

        clearTimeout(timeout);

        CSSCore.removeClass(node, className);
        CSSCore.removeClass(node, activeClassName);

        ReactTransitionEvents.removeEndEventListener(node, endListener);

        // Usually this optional callback is used for informing an owner of
        // a leave animation and telling it to remove the child.
        if (finishCallback) {
          finishCallback();
        }
      };

      CSSCore.addClass(node, className);

      // Need to do this to actually trigger a transition.
      _this.queueClassAndNode(activeClassName, node);

      // If the user specified a timeout delay.
      if (userSpecifiedDelay) {
        // Clean-up the animation after the specified delay
        timeout = setTimeout(endListener, userSpecifiedDelay);
        _this.transitionTimeouts.push(timeout);
      } else {
        // DEPRECATED: this listener will be removed in a future version of react
        ReactTransitionEvents.addEndEventListener(node, endListener);
      }
    }, _this.queueClassAndNode = function (className, node) {
      _this.classNameAndNodeQueue.push({
        className: className,
        node: node
      });

      if (!_this.timeout) {
        _this.timeout = setTimeout(_this.flushClassNameAndNodeQueue, TICK);
      }
    }, _this.flushClassNameAndNodeQueue = function () {
      if (_this._isMounted) {
        _this.classNameAndNodeQueue.forEach(function (obj) {
          CSSCore.addClass(obj.node, obj.className);
        });
      }
      _this.classNameAndNodeQueue.length = 0;
      _this.timeout = null;
    }, _this.componentWillAppear = function (done) {
      if (_this.props.appear) {
        _this.transition('appear', done, _this.props.appearTimeout);
      } else {
        done();
      }
    }, _this.componentWillEnter = function (done) {
      if (_this.props.enter) {
        _this.transition('enter', done, _this.props.enterTimeout);
      } else {
        done();
      }
    }, _this.componentWillLeave = function (done) {
      if (_this.props.leave) {
        _this.transition('leave', done, _this.props.leaveTimeout);
      } else {
        done();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ReactCSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
    this.classNameAndNodeQueue = [];
    this.transitionTimeouts = [];
  };

  ReactCSSTransitionGroupChild.prototype.componentDidMount = function componentDidMount() {
    this._isMounted = true;
  };

  ReactCSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
    this._isMounted = false;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.transitionTimeouts.forEach(function (timeout) {
      clearTimeout(timeout);
    });

    this.classNameAndNodeQueue.length = 0;
  };

  ReactCSSTransitionGroupChild.prototype.render = function render() {
    return onlyChild(this.props.children);
  };

  return ReactCSSTransitionGroupChild;
}(React.Component);

ReactCSSTransitionGroupChild.propTypes = {
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    enter: PropTypes.string,
    leave: PropTypes.string,
    active: PropTypes.string
  }), PropTypes.shape({
    enter: PropTypes.string,
    enterActive: PropTypes.string,
    leave: PropTypes.string,
    leaveActive: PropTypes.string,
    appear: PropTypes.string,
    appearActive: PropTypes.string
  })]).isRequired,

  // Once we require timeouts to be specified, we can remove the
  // boolean flags (appear etc.) and just accept a number
  // or a bool for the timeout flags (appearTimeout etc.)
  appear: PropTypes.bool,
  enter: PropTypes.bool,
  leave: PropTypes.bool,
  appearTimeout: PropTypes.number,
  enterTimeout: PropTypes.number,
  leaveTimeout: PropTypes.number
};

module.exports = ReactCSSTransitionGroupChild;

/***/ }),
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var flattenChildren = __webpack_require__(796);

var ReactTransitionChildMapping = {
  /**
   * Given `this.props.children`, return an object mapping key to child. Just
   * simple syntactic sugar around flattenChildren().
   *
   * @param {*} children `this.props.children`
   * @param {number=} selfDebugID Optional debugID of the current internal instance.
   * @return {object} Mapping of key to child
   */
  getChildMapping: function getChildMapping(children, selfDebugID) {
    if (!children) {
      return children;
    }

    if (false) {
      return flattenChildren(children, selfDebugID);
    }

    return flattenChildren(children);
  },

  /**
   * When you're adding or removing children some may be added or removed in the
   * same render pass. We want to show *both* since we want to simultaneously
   * animate elements in and out. This function takes a previous set of keys
   * and a new set of keys and merges them with its best guess of the correct
   * ordering. In the future we may expose some of the utilities in
   * ReactMultiChild to make this easy, but for now React itself does not
   * directly have this concept of the union of prevChildren and nextChildren
   * so we implement it here.
   *
   * @param {object} prev prev children as returned from
   * `ReactTransitionChildMapping.getChildMapping()`.
   * @param {object} next next children as returned from
   * `ReactTransitionChildMapping.getChildMapping()`.
   * @return {object} a key set that contains all keys in `prev` and all keys
   * in `next` in a reasonable order.
   */
  mergeChildMappings: function mergeChildMappings(prev, next) {
    prev = prev || {};
    next = next || {};

    function getValueForKey(key) {
      if (next.hasOwnProperty(key)) {
        return next[key];
      } else {
        return prev[key];
      }
    }

    // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = {};

    var pendingKeys = [];
    for (var prevKey in prev) {
      if (next.hasOwnProperty(prevKey)) {
        if (pendingKeys.length) {
          nextKeysPending[prevKey] = pendingKeys;
          pendingKeys = [];
        }
      } else {
        pendingKeys.push(prevKey);
      }
    }

    var i;
    var childMapping = {};
    for (var nextKey in next) {
      if (nextKeysPending.hasOwnProperty(nextKey)) {
        for (i = 0; i < nextKeysPending[nextKey].length; i++) {
          var pendingNextKey = nextKeysPending[nextKey][i];
          childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
      }
      childMapping[nextKey] = getValueForKey(nextKey);
    }

    // Finally, add the keys which didn't appear before any key in `next`
    for (i = 0; i < pendingKeys.length; i++) {
      childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    }

    return childMapping;
  }
};

module.exports = ReactTransitionChildMapping;

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(19);

var getVendorPrefixedEventName = __webpack_require__(287);

var endEvents = [];

function detectEvents() {
  var animEnd = getVendorPrefixedEventName('animationend');
  var transEnd = getVendorPrefixedEventName('transitionend');

  if (animEnd) {
    endEvents.push(animEnd);
  }

  if (transEnd) {
    endEvents.push(transEnd);
  }
}

if (ExecutionEnvironment.canUseDOM) {
  detectEvents();
}

// We use the raw {add|remove}EventListener() call because EventListener
// does not know how to remove event listeners and we really should
// clean up. Also, these events are not triggered in older browsers
// so we should be A-OK here.

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var ReactTransitionEvents = {
  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      // If CSS transitions are not supported, trigger an "end animation"
      // event immediately.
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },

  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

module.exports = ReactTransitionEvents;

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _assign = __webpack_require__(10);

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var React = __webpack_require__(53);
var ReactTransitionChildMapping = __webpack_require__(792);

var propTypesFactory = __webpack_require__(101);
var PropTypes = propTypesFactory(React.isValidElement);

var emptyFunction = __webpack_require__(30);

/**
 * A basis for animations. When children are declaratively added or removed,
 * special lifecycle hooks are called.
 * See https://facebook.github.io/react/docs/animation.html#low-level-api-reacttransitiongroup
 */

var ReactTransitionGroup = function (_React$Component) {
  _inherits(ReactTransitionGroup, _React$Component);

  function ReactTransitionGroup() {
    var _temp, _this, _ret;

    _classCallCheck(this, ReactTransitionGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      // TODO: can we get useful debug information to show at this point?
      children: ReactTransitionChildMapping.getChildMapping(_this.props.children)
    }, _this.performAppear = function (key) {
      _this.currentlyTransitioningKeys[key] = true;

      var component = _this.refs[key];

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key));
      } else {
        _this._handleDoneAppearing(key);
      }
    }, _this._handleDoneAppearing = function (key) {
      var component = _this.refs[key];
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key);
      }
    }, _this.performEnter = function (key) {
      _this.currentlyTransitioningKeys[key] = true;

      var component = _this.refs[key];

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key));
      } else {
        _this._handleDoneEntering(key);
      }
    }, _this._handleDoneEntering = function (key) {
      var component = _this.refs[key];
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key);
      }
    }, _this.performLeave = function (key) {
      _this.currentlyTransitioningKeys[key] = true;

      var component = _this.refs[key];
      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key);
      }
    }, _this._handleDoneLeaving = function (key) {
      var component = _this.refs[key];

      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.performEnter(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _assign({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ReactTransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  ReactTransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key);
      }
    }
  };

  ReactTransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = ReactTransitionChildMapping.getChildMapping(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: ReactTransitionChildMapping.mergeChildMappings(prevChildMapping, nextChildMapping)
    });

    var key;

    for (key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(key);
      if (prevChildMapping[key] && !hasNext && !this.currentlyTransitioningKeys[key]) {
        this.keysToLeave.push(key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  ReactTransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(this.performEnter);

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(this.performLeave);
  };

  ReactTransitionGroup.prototype.render = function render() {
    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];
    for (var key in this.state.children) {
      var child = this.state.children[key];
      if (child) {
        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(React.cloneElement(this.props.childFactory(child), { ref: key, key: key }));
      }
    }

    // Do not forward ReactTransitionGroup props to primitive DOM nodes
    var props = _assign({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return React.createElement(this.props.component, props, childrenToRender);
  };

  return ReactTransitionGroup;
}(React.Component);

ReactTransitionGroup.displayName = 'ReactTransitionGroup';
ReactTransitionGroup.propTypes = {
  component: PropTypes.any,
  childFactory: PropTypes.func
};
ReactTransitionGroup.defaultProps = {
  component: 'span',
  childFactory: emptyFunction.thatReturnsArgument
};

module.exports = ReactTransitionGroup;

/***/ }),
/* 795 */,
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var KeyEscapeUtils = __webpack_require__(309);
var traverseAllChildren = __webpack_require__(313);
var warning = __webpack_require__(5);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && process.env && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(207);
}

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */
function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
  // We found a component instance.
  if (traverseContext && (typeof traverseContext === 'undefined' ? 'undefined' : _typeof(traverseContext)) === 'object') {
    var result = traverseContext;
    var keyUnique = result[name] === undefined;
    if (false) {
      if (!ReactComponentTreeHook) {
        ReactComponentTreeHook = require('./ReactComponentTreeHook');
      }
      if (!keyUnique) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
      }
    }
    if (keyUnique && child != null) {
      result[name] = child;
    }
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children, selfDebugID) {
  if (children == null) {
    return children;
  }
  var result = {};

  if (false) {
    traverseAllChildren(children, function (traverseContext, child, name) {
      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
    }, result);
  } else {
    traverseAllChildren(children, flattenSingleChildIntoContext, result);
  }
  return result;
}

module.exports = flattenChildren;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(127)))

/***/ }),
/* 797 */,
/* 798 */,
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = reduceReducers;

function reduceReducers() {
  for (var _len = arguments.length, reducers = Array(_len), _key = 0; _key < _len; _key++) {
    reducers[_key] = arguments[_key];
  }

  return function (previous, current) {
    return reducers.reduce(function (p, r) {
      return r(p, current);
    }, previous);
  };
}

module.exports = exports["default"];

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// based on https://github.com/lodash/lodash/blob/4.17.2/lodash.js#L14100
// eslint-disable-next-line max-len
var wordPattern = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:(?:1ST|2ND|3RD|(?![123])\dTH)\b)|\d*(?:(?:1st|2nd|3rd|(?![123])\dth)\b)|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g;
var namespacer = '/';

function camelCase(string) {
  return string.match(wordPattern).reduce(function (camelCased, word, index) {
    return camelCased + (index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.substring(1).toLowerCase());
  }, '');
}

exports.default = function (actionType) {
  return actionType.split(namespacer).map(camelCase).join(namespacer);
};

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createActions;

var _identity = __webpack_require__(175);

var _identity2 = _interopRequireDefault(_identity);

var _camelCase = __webpack_require__(800);

var _camelCase2 = _interopRequireDefault(_camelCase);

var _isPlainObject = __webpack_require__(264);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _isArray = __webpack_require__(100);

var _isArray2 = _interopRequireDefault(_isArray);

var _isString = __webpack_require__(178);

var _isString2 = _interopRequireDefault(_isString);

var _isFunction = __webpack_require__(82);

var _isFunction2 = _interopRequireDefault(_isFunction);

var _createAction = __webpack_require__(315);

var _createAction2 = _interopRequireDefault(_createAction);

var _invariant = __webpack_require__(15);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;_e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }return _arr;
  }return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}

function createActions(actionsMap) {
  for (var _len = arguments.length, identityActions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    identityActions[_key - 1] = arguments[_key];
  }

  (0, _invariant2.default)(identityActions.every(_isString2.default) && ((0, _isString2.default)(actionsMap) || (0, _isPlainObject2.default)(actionsMap)), 'Expected optional object followed by string action types');
  if ((0, _isString2.default)(actionsMap)) {
    return fromIdentityActions([actionsMap].concat(identityActions));
  }
  return _extends({}, fromActionsMap(actionsMap), fromIdentityActions(identityActions));
}

function isValidActionsMapValue(actionsMapValue) {
  if ((0, _isFunction2.default)(actionsMapValue)) {
    return true;
  } else if ((0, _isArray2.default)(actionsMapValue)) {
    var _actionsMapValue = _slicedToArray(actionsMapValue, 2);

    var _actionsMapValue$ = _actionsMapValue[0];
    var payload = _actionsMapValue$ === undefined ? _identity2.default : _actionsMapValue$;
    var meta = _actionsMapValue[1];

    return (0, _isFunction2.default)(payload) && (0, _isFunction2.default)(meta);
  }
  return false;
}

function fromActionsMap(actionsMap) {
  return Object.keys(actionsMap).reduce(function (actionCreatorsMap, type) {
    var actionsMapValue = actionsMap[type];
    (0, _invariant2.default)(isValidActionsMapValue(actionsMapValue), 'Expected function, undefined, or array with payload and meta ' + ('functions for ' + type));
    var actionCreator = (0, _isArray2.default)(actionsMapValue) ? _createAction2.default.apply(undefined, [type].concat(_toConsumableArray(actionsMapValue))) : (0, _createAction2.default)(type, actionsMapValue);
    return _extends({}, actionCreatorsMap, _defineProperty({}, (0, _camelCase2.default)(type), actionCreator));
  }, {});
}

function fromIdentityActions(identityActions) {
  return fromActionsMap(identityActions.reduce(function (actionsMap, actionType) {
    return _extends({}, actionsMap, _defineProperty({}, actionType, _identity2.default));
  }, {}));
}

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = handleActions;

var _handleAction = __webpack_require__(316);

var _handleAction2 = _interopRequireDefault(_handleAction);

var _ownKeys = __webpack_require__(803);

var _ownKeys2 = _interopRequireDefault(_ownKeys);

var _reduceReducers = __webpack_require__(799);

var _reduceReducers2 = _interopRequireDefault(_reduceReducers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}

function handleActions(handlers, defaultState) {
  var reducers = (0, _ownKeys2.default)(handlers).map(function (type) {
    return (0, _handleAction2.default)(type, handlers[type], defaultState);
  });
  var reducer = _reduceReducers2.default.apply(undefined, _toConsumableArray(reducers));
  return function (state, action) {
    return reducer(state, action);
  };
}

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ownKeys;
function ownKeys(object) {
  if (typeof Reflect !== 'undefined' && typeof Reflect.ownKeys === 'function') {
    return Reflect.ownKeys(object);
  }

  var keys = Object.getOwnPropertyNames(object);

  if (typeof Object.getOwnPropertySymbols === 'function') {
    keys = keys.concat(Object.getOwnPropertySymbols(object));
  }

  return keys;
}

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var compose = __webpack_require__(21).compose;

exports.__esModule = true;
exports.composeWithDevTools = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function () {
  if (arguments.length === 0) return undefined;
  if (_typeof(arguments[0]) === 'object') return compose;
  return compose.apply(null, arguments);
};

exports.devToolsEnhancer = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function () {
  return function (noop) {
    return noop;
  };
};

/***/ }),
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!function (global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = ( false ? "undefined" : _typeof(module)) === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      prototype[method] = function (arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function (genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor ? ctor === GeneratorFunction ||
    // For the native GeneratorFunction constructor, the best we can
    // do is to check its .name property.
    (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
  };

  runtime.mark = function (genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function (arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value && (typeof value === "undefined" ? "undefined" : _typeof(value)) === "object" && hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function (value) {
            invoke("next", value, resolve, reject);
          }, function (err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function (unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (_typeof(global.process) === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
      // If enqueue has been called before, then we want to wait until
      // all previous Promises have been resolved before calling invoke,
      // so that results are always delivered in the correct order. If
      // enqueue has not been called before, then it is important to
      // call invoke immediately, without waiting on a callback to fire,
      // so that the async generator function has the opportunity to do
      // any necessary setup in a predictable way. This predictability
      // is why the Promise constructor synchronously invokes its
      // executor callback, and why async functions synchronously
      // execute code before the first await. Since we implement simple
      // async functions in terms of async generators, it is especially
      // important to get this right, even though it requires care.
      previousPromise ? previousPromise.then(callInvokeWithMethodAndArg,
      // Avoid propagating failures to Promises returned by later
      // invocations of the iterator.
      callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function (innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));

    return runtime.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
    : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;
        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);
        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done ? GenStateCompleted : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };
        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (!info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }
    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function () {
    return this;
  };

  Gp.toString = function () {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function (object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function reset(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function stop() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function dispatchException(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }
          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function complete(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" || record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
}(
// Among the various tricks for obtaining a reference to the global
// object, this seems to be the most reliable technique that does not
// use indirect eval (which violates Content Security Policy).
(typeof global === "undefined" ? "undefined" : _typeof(global)) === "object" ? global : (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" ? window : (typeof self === "undefined" ? "undefined" : _typeof(self)) === "object" ? self : undefined);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(75), __webpack_require__(108)(module)))

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep === 'undefined' ? 'undefined' : _typeof(dep);
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = defaultMemoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if ((typeof selectors === 'undefined' ? 'undefined' : _typeof(selectors)) !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + (typeof selectors === 'undefined' ? 'undefined' : _typeof(selectors))));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(811);

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var RetryOperation = __webpack_require__(812);

exports.operation = function (options) {
  var timeouts = exports.timeouts(options);
  return new RetryOperation(timeouts, {
    forever: options && options.forever,
    unref: options && options.unref
  });
};

exports.timeouts = function (options) {
  if (options instanceof Array) {
    return [].concat(options);
  }

  var opts = {
    retries: 10,
    factor: 2,
    minTimeout: 1 * 1000,
    maxTimeout: Infinity,
    randomize: false
  };
  for (var key in options) {
    opts[key] = options[key];
  }

  if (opts.minTimeout > opts.maxTimeout) {
    throw new Error('minTimeout is greater than maxTimeout');
  }

  var timeouts = [];
  for (var i = 0; i < opts.retries; i++) {
    timeouts.push(this.createTimeout(i, opts));
  }

  if (options && options.forever && !timeouts.length) {
    timeouts.push(this.createTimeout(i, opts));
  }

  // sort the array numerically ascending
  timeouts.sort(function (a, b) {
    return a - b;
  });

  return timeouts;
};

exports.createTimeout = function (attempt, opts) {
  var random = opts.randomize ? Math.random() + 1 : 1;

  var timeout = Math.round(random * opts.minTimeout * Math.pow(opts.factor, attempt));
  timeout = Math.min(timeout, opts.maxTimeout);

  return timeout;
};

exports.wrap = function (obj, options, methods) {
  if (options instanceof Array) {
    methods = options;
    options = null;
  }

  if (!methods) {
    methods = [];
    for (var key in obj) {
      if (typeof obj[key] === 'function') {
        methods.push(key);
      }
    }
  }

  for (var i = 0; i < methods.length; i++) {
    var method = methods[i];
    var original = obj[method];

    obj[method] = function retryWrapper() {
      var op = exports.operation(options);
      var args = Array.prototype.slice.call(arguments);
      var callback = args.pop();

      args.push(function (err) {
        if (op.retry(err)) {
          return;
        }
        if (err) {
          arguments[0] = op.mainError();
        }
        callback.apply(this, arguments);
      });

      op.attempt(function () {
        original.apply(obj, args);
      });
    };
    obj[method].options = options;
  }
};

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function RetryOperation(timeouts, options) {
  // Compatibility for the old (timeouts, retryForever) signature
  if (typeof options === 'boolean') {
    options = { forever: options };
  }

  this._timeouts = timeouts;
  this._options = options || {};
  this._fn = null;
  this._errors = [];
  this._attempts = 1;
  this._operationTimeout = null;
  this._operationTimeoutCb = null;
  this._timeout = null;

  if (this._options.forever) {
    this._cachedTimeouts = this._timeouts.slice(0);
  }
}
module.exports = RetryOperation;

RetryOperation.prototype.stop = function () {
  if (this._timeout) {
    clearTimeout(this._timeout);
  }

  this._timeouts = [];
  this._cachedTimeouts = null;
};

RetryOperation.prototype.retry = function (err) {
  if (this._timeout) {
    clearTimeout(this._timeout);
  }

  if (!err) {
    return false;
  }

  this._errors.push(err);

  var timeout = this._timeouts.shift();
  if (timeout === undefined) {
    if (this._cachedTimeouts) {
      // retry forever, only keep last error
      this._errors.splice(this._errors.length - 1, this._errors.length);
      this._timeouts = this._cachedTimeouts.slice(0);
      timeout = this._timeouts.shift();
    } else {
      return false;
    }
  }

  var self = this;
  var timer = setTimeout(function () {
    self._attempts++;

    if (self._operationTimeoutCb) {
      self._timeout = setTimeout(function () {
        self._operationTimeoutCb(self._attempts);
      }, self._operationTimeout);

      if (this._options.unref) {
        self._timeout.unref();
      }
    }

    self._fn(self._attempts);
  }, timeout);

  if (this._options.unref) {
    timer.unref();
  }

  return true;
};

RetryOperation.prototype.attempt = function (fn, timeoutOps) {
  this._fn = fn;

  if (timeoutOps) {
    if (timeoutOps.timeout) {
      this._operationTimeout = timeoutOps.timeout;
    }
    if (timeoutOps.cb) {
      this._operationTimeoutCb = timeoutOps.cb;
    }
  }

  var self = this;
  if (this._operationTimeoutCb) {
    this._timeout = setTimeout(function () {
      self._operationTimeoutCb();
    }, self._operationTimeout);
  }

  this._fn(this._attempts);
};

RetryOperation.prototype.try = function (fn) {
  console.log('Using RetryOperation.try() is deprecated');
  this.attempt(fn);
};

RetryOperation.prototype.start = function (fn) {
  console.log('Using RetryOperation.start() is deprecated');
  this.attempt(fn);
};

RetryOperation.prototype.start = RetryOperation.prototype.try;

RetryOperation.prototype.errors = function () {
  return this._errors;
};

RetryOperation.prototype.attempts = function () {
  return this._attempts;
};

RetryOperation.prototype.mainError = function () {
  if (this._errors.length === 0) {
    return null;
  }

  var counts = {};
  var mainError = null;
  var mainErrorCount = 0;

  for (var i = 0; i < this._errors.length; i++) {
    var error = this._errors[i];
    var message = error.message;
    var count = (counts[message] || 0) + 1;

    counts[message] = count;

    if (count >= mainErrorCount) {
      mainError = error;
      mainErrorCount = count;
    }
  }

  return mainError;
};

/***/ }),
/* 813 */,
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Generated by CoffeeScript 1.8.0
(function () {
  var ValueError,
      create,
      explicitToImplicit,
      format,
      implicitToExplicit,
      lookup,
      resolve,
      __hasProp = {}.hasOwnProperty,
      __extends = function __extends(child, parent) {
    for (var key in parent) {
      if (__hasProp.call(parent, key)) child[key] = parent[key];
    }function ctor() {
      this.constructor = child;
    }ctor.prototype = parent.prototype;child.prototype = new ctor();child.__super__ = parent.prototype;return child;
  },
      __slice = [].slice;

  ValueError = function (_super) {
    __extends(ValueError, _super);

    function ValueError(message) {
      this.message = message;
    }

    ValueError.prototype.name = 'ValueError';

    return ValueError;
  }(Error);

  implicitToExplicit = 'cannot switch from implicit to explicit numbering';

  explicitToImplicit = 'cannot switch from explicit to implicit numbering';

  create = function create(transformers) {
    if (transformers == null) {
      transformers = {};
    }
    return function () {
      var args, explicit, idx, implicit, message, template;
      template = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
      idx = 0;
      explicit = implicit = false;
      message = 'cannot switch from {} to {} numbering';
      return template.replace(/([{}])\1|[{](.*?)(?:!(.+?))?[}]/g, function (match, literal, key, transformer) {
        var value, _ref, _ref1;
        if (literal) {
          return literal;
        }
        if (key.length) {
          if (implicit) {
            throw new ValueError(implicitToExplicit);
          }
          explicit = true;
          value = (_ref = lookup(args, key)) != null ? _ref : '';
        } else {
          if (explicit) {
            throw new ValueError(explicitToImplicit);
          }
          implicit = true;
          value = (_ref1 = args[idx++]) != null ? _ref1 : '';
        }
        if (Object.prototype.hasOwnProperty.call(transformers, transformer)) {
          return transformers[transformer](value);
        } else {
          return value;
        }
      });
    };
  };

  lookup = function lookup(object, key) {
    var match;
    if (!/^(\d+)([.]|$)/.test(key)) {
      key = '0.' + key;
    }
    while (match = /(.+?)[.](.+)/.exec(key)) {
      object = resolve(object, match[1]);
      key = match[2];
    }
    return resolve(object, key);
  };

  resolve = function resolve(object, key) {
    var value;
    value = object[key];
    if (typeof value === 'function') {
      return value.call(object);
    } else {
      return value;
    }
  };

  format = create({});

  format.create = create;

  format.extend = function (prototype, transformers) {
    var $format;
    $format = create(transformers);
    prototype.format = function () {
      return $format.apply(null, [this].concat(__slice.call(arguments)));
    };
  };

  if (true) {
    module.exports = format;
  } else if (typeof define === 'function' && define.amd) {
    define(format);
  } else {
    window.format = format;
  }
}).call(undefined);

/***/ }),
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  'use strict';

  if (self.fetch) {
    return;
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name');
    }
    return name.toLowerCase();
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value;
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function (value, name) {
        this.append(name, value);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function (name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function (name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var list = this.map[name];
    if (!list) {
      list = [];
      this.map[name] = list;
    }
    list.push(value);
  };

  Headers.prototype['delete'] = function (name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function (name) {
    var values = this.map[normalizeName(name)];
    return values ? values[0] : null;
  };

  Headers.prototype.getAll = function (name) {
    return this.map[normalizeName(name)] || [];
  };

  Headers.prototype.has = function (name) {
    return this.map.hasOwnProperty(normalizeName(name));
  };

  Headers.prototype.set = function (name, value) {
    this.map[normalizeName(name)] = [normalizeValue(value)];
  };

  Headers.prototype.forEach = function (callback, thisArg) {
    Object.getOwnPropertyNames(this.map).forEach(function (name) {
      this.map[name].forEach(function (value) {
        callback.call(thisArg, value, name, this);
      }, this);
    }, this);
  };

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'));
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function (resolve, reject) {
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function () {
        reject(reader.error);
      };
    });
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    reader.readAsArrayBuffer(blob);
    return fileReaderReady(reader);
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    reader.readAsText(blob);
    return fileReaderReady(reader);
  }

  var support = {
    blob: 'FileReader' in self && 'Blob' in self && function () {
      try {
        new Blob();
        return true;
      } catch (e) {
        return false;
      }
    }(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function Body() {
    this.bodyUsed = false;

    this._initBody = function (body) {
      this._bodyInit = body;
      if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (!body) {
        this._bodyText = '';
      } else if (support.arrayBuffer && ArrayBuffer.prototype.isPrototypeOf(body)) {
        // Only support ArrayBuffers for POST method.
        // Receiving ArrayBuffers happens via Blobs, instead.
      } else {
        throw new Error('unsupported BodyInit type');
      }
    };

    if (support.blob) {
      this.blob = function () {
        var rejected = consumed(this);
        if (rejected) {
          return rejected;
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob);
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob');
        } else {
          return Promise.resolve(new Blob([this._bodyText]));
        }
      };

      this.arrayBuffer = function () {
        return this.blob().then(readBlobAsArrayBuffer);
      };

      this.text = function () {
        var rejected = consumed(this);
        if (rejected) {
          return rejected;
        }

        if (this._bodyBlob) {
          return readBlobAsText(this._bodyBlob);
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as text');
        } else {
          return Promise.resolve(this._bodyText);
        }
      };
    } else {
      this.text = function () {
        var rejected = consumed(this);
        return rejected ? rejected : Promise.resolve(this._bodyText);
      };
    }

    if (support.formData) {
      this.formData = function () {
        return this.text().then(decode);
      };
    }

    this.json = function () {
      return this.text().then(JSON.parse);
    };

    return this;
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method;
  }

  function Request(input, options) {
    options = options || {};
    var body = options.body;
    if (Request.prototype.isPrototypeOf(input)) {
      if (input.bodyUsed) {
        throw new TypeError('Already read');
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      if (!body) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = input;
    }

    this.credentials = options.credentials || this.credentials || 'omit';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests');
    }
    this._initBody(body);
  }

  Request.prototype.clone = function () {
    return new Request(this);
  };

  function decode(body) {
    var form = new FormData();
    body.trim().split('&').forEach(function (bytes) {
      if (bytes) {
        var split = bytes.split('=');
        var name = split.shift().replace(/\+/g, ' ');
        var value = split.join('=').replace(/\+/g, ' ');
        form.append(decodeURIComponent(name), decodeURIComponent(value));
      }
    });
    return form;
  }

  function headers(xhr) {
    var head = new Headers();
    var pairs = xhr.getAllResponseHeaders().trim().split('\n');
    pairs.forEach(function (header) {
      var split = header.trim().split(':');
      var key = split.shift().trim();
      var value = split.join(':').trim();
      head.append(key, value);
    });
    return head;
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!options) {
      options = {};
    }

    this._initBody(bodyInit);
    this.type = 'default';
    this.status = options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText;
    this.headers = options.headers instanceof Headers ? options.headers : new Headers(options.headers);
    this.url = options.url || '';
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function () {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    });
  };

  Response.error = function () {
    var response = new Response(null, { status: 0, statusText: '' });
    response.type = 'error';
    return response;
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function (url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code');
    }

    return new Response(null, { status: status, headers: { location: url } });
  };

  self.Headers = Headers;
  self.Request = Request;
  self.Response = Response;

  self.fetch = function (input, init) {
    return new Promise(function (resolve, reject) {
      var request;
      if (Request.prototype.isPrototypeOf(input) && !init) {
        request = input;
      } else {
        request = new Request(input, init);
      }

      var xhr = new XMLHttpRequest();

      function responseURL() {
        if ('responseURL' in xhr) {
          return xhr.responseURL;
        }

        // Avoid security warnings on getResponseHeader when not allowed by CORS
        if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
          return xhr.getResponseHeader('X-Request-URL');
        }

        return;
      }

      xhr.onload = function () {
        var status = xhr.status === 1223 ? 204 : xhr.status;
        if (status < 100 || status > 599) {
          reject(new TypeError('Network request failed'));
          return;
        }
        var options = {
          status: status,
          statusText: xhr.statusText,
          headers: headers(xhr),
          url: responseURL()
        };
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        resolve(new Response(body, options));
      };

      xhr.onerror = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function (value, name) {
        xhr.setRequestHeader(name, value);
      });

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    });
  };
  self.fetch.polyfill = true;
})();

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = __webpack_require__(24);

var _config = __webpack_require__(31);

var _config2 = _interopRequireDefault(_config);

var _charityDefault = __webpack_require__(865);

var _charityDefault2 = _interopRequireDefault(_charityDefault);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CharityImage = function (_React$Component) {
  _inherits(CharityImage, _React$Component);

  function CharityImage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CharityImage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CharityImage.__proto__ || Object.getPrototypeOf(CharityImage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      errored: false
    }, _this.handleError = function () {
      _this.setState({ errored: true });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CharityImage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          src = _props.src,
          alt = _props.alt,
          classNames = _props.classNames;
      var errored = this.state.errored;

      if (errored || !src || src.includes('No_image')) {
        return _react2.default.createElement(_components.Svg, { markup: _charityDefault2.default, alt: alt, className: classNames });
      }
      var srcURI = _config2.default.IMAGE_SERVICE_URL + '/' + src;
      return _react2.default.createElement('img', { className: classNames, src: srcURI, alt: alt, onError: this.handleError });
    }
  }]);

  return CharityImage;
}(_react2.default.Component);

CharityImage.propTypes = {
  src: _propTypes2.default.string,
  alt: _propTypes2.default.string,
  classNames: _propTypes2.default.string
};
CharityImage.defaultProps = {
  src: '',
  alt: '',
  classNames: ''
};
exports.default = CharityImage;

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _components = __webpack_require__(24);

var _rocknrollLogo = __webpack_require__(864);

var _rocknrollLogo2 = _interopRequireDefault(_rocknrollLogo);

__webpack_require__(842);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return _react2.default.createElement(
    'div',
    { className: 'cobranded-header' },
    _react2.default.createElement(
      'div',
      { className: 'cobranded-header__inner container' },
      _react2.default.createElement(_components.Svg, { markup: _rocknrollLogo2.default, alt: 'Rock \'n\' Roll', className: 'cobranded-header__rocknroll-logo' })
    )
  );
};

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _components = __webpack_require__(24);

var _justgiving_logo = __webpack_require__(861);

var _justgiving_logo2 = _interopRequireDefault(_justgiving_logo);

__webpack_require__(843);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Footer = function Footer() {
  return _react2.default.createElement(
    'div',
    { className: 'footer' },
    _react2.default.createElement(
      'ul',
      { className: 'footer__list' },
      _react2.default.createElement(
        'li',
        { className: 'footer__list__item' },
        _react2.default.createElement(
          'a',
          { href: 'https://www.justgiving.com/info/terms-of-service', target: '_blank', rel: 'noopener noreferrer' },
          'Terms of Service'
        )
      ),
      _react2.default.createElement(
        'li',
        { className: 'footer__list__item' },
        _react2.default.createElement(
          'a',
          { href: 'https://www.justgiving.com/info/privacy', target: '_blank', rel: 'noopener noreferrer' },
          'Privacy'
        )
      ),
      _react2.default.createElement(
        'li',
        { className: 'footer__list__item' },
        _react2.default.createElement(
          'a',
          { href: 'https://www.justgiving.com/info/cookies', target: '_blank', rel: 'noopener noreferrer' },
          'Cookies'
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'footer__powered-by' },
      'Powered by',
      _react2.default.createElement(_components.Svg, { markup: _justgiving_logo2.default, alt: 'Just Giving', className: 'footer__powered-by__logo' })
    )
  );
};

exports.default = Footer;

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(18);

var _locationUtils = __webpack_require__(95);

var _locationUtils2 = _interopRequireDefault(_locationUtils);

var _components = __webpack_require__(24);

var _config = __webpack_require__(31);

var _config2 = _interopRequireDefault(_config);

var _matchmymilesWhite = __webpack_require__(863);

var _matchmymilesWhite2 = _interopRequireDefault(_matchmymilesWhite);

__webpack_require__(845);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var numberOfRunners = '575,000';

var LandingHero = function LandingHero(_ref) {
  var location = _ref.location,
      isLoading = _ref.isLoading,
      isError = _ref.isError,
      onCTAClick = _ref.onCTAClick;
  return _react2.default.createElement(
    'div',
    { className: 'landing-hero' },
    _react2.default.createElement(
      'div',
      { className: 'landing-hero__inner' },
      _react2.default.createElement(_components.Svg, { markup: _matchmymilesWhite2.default, alt: 'MATCHmyMILES', className: 'landing-hero__logo' }),
      _react2.default.createElement(
        'p',
        { className: 'landing-hero__strap' },
        'Join our community of ',
        _react2.default.createElement(
          'strong',
          null,
          numberOfRunners,
          ' runners'
        ),
        ' matching their miles for charity'
      ),
      _react2.default.createElement(
        'div',
        { className: 'landing-hero__get-started-btn__wrapper' },
        _react2.default.createElement(
          _reactRouter.Link,
          {
            onClick: onCTAClick,
            to: _config2.default.ROOT_PATH + '/charity-search?guid=' + location.query.guid,
            disabled: isError,
            className: 'landing-hero__get-started-btn ' + (isLoading && 'inactive-link') + ' ' + (isError && 'is-disabled')
          },
          isLoading ? _react2.default.createElement(_components.Loading, { size: 'small', colour: 'white' }) : 'Get Started'
        )
      )
    )
  );
};

LandingHero.propTypes = {
  onCTAClick: _propTypes2.default.func,
  location: _propTypes2.default.objectOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])),
  isError: _propTypes2.default.bool.isRequired,
  isLoading: _propTypes2.default.bool.isRequired
};

LandingHero.defaultProps = {
  location: _locationUtils2.default.locationStub,
  isError: false,
  isLoading: false
};

exports.default = LandingHero;

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(18);

var _locationUtils = __webpack_require__(95);

var _locationUtils2 = _interopRequireDefault(_locationUtils);

var _components = __webpack_require__(24);

var _config = __webpack_require__(31);

var _config2 = _interopRequireDefault(_config);

__webpack_require__(846);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LandingSteps = function LandingSteps(_ref) {
  var location = _ref.location,
      isLoading = _ref.isLoading,
      isError = _ref.isError,
      onCTAClick = _ref.onCTAClick;
  return _react2.default.createElement(
    'section',
    { className: 'landing-steps' },
    _react2.default.createElement(
      'div',
      { className: 'landing-steps__inner' },
      _react2.default.createElement(
        'h1',
        { className: 'landing-steps__heading' },
        'Make every step count by raising money for the charity of your choice'
      ),
      _react2.default.createElement(
        'ol',
        { className: 'landing-steps__list' },
        _react2.default.createElement(
          'li',
          { className: 'landing-steps__list__item', style: { backgroundImage: 'url(src/assets/png/choose-charity.png)' } },
          _react2.default.createElement(
            'h2',
            null,
            'Choose a charity'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Support one of our partner charities or take your pick'
          )
        ),
        _react2.default.createElement(
          'li',
          { className: 'landing-steps__list__item', style: { backgroundImage: 'url(src/assets/png/invite-friends.png)' } },
          _react2.default.createElement(
            'h2',
            null,
            'Invite friends'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Invite friends to match your race miles with a charity donation'
          )
        ),
        _react2.default.createElement(
          'li',
          { className: 'landing-steps__list__item', style: { backgroundImage: 'url(src/assets/png/match-miles.png)' } },
          _react2.default.createElement(
            'h2',
            null,
            'Match your miles!'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Make an impact for your charity with every step of your race'
          )
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'landing-steps__cta-btn__wrapper' },
        _react2.default.createElement(
          _reactRouter.Link,
          {
            onClick: onCTAClick,
            to: _config2.default.ROOT_PATH + '/charity-search?guid=' + location.query.guid,
            disabled: isError,
            className: 'landing-steps__cta-btn ' + (isLoading && 'inactive-link') + ' ' + (isError && 'is-disabled')
          },
          isLoading ? _react2.default.createElement(_components.Loading, { size: 'small', colour: 'white' }) : 'Ok, Let’s do this!'
        )
      )
    )
  );
};

LandingSteps.propTypes = {
  onCTAClick: _propTypes2.default.func,
  location: _propTypes2.default.objectOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])),
  isError: _propTypes2.default.bool.isRequired,
  isLoading: _propTypes2.default.bool.isRequired
};

LandingSteps.defaultProps = {
  location: _locationUtils2.default.locationStub,
  isError: false,
  isLoading: false
};

exports.default = LandingSteps;

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CharityImage = __webpack_require__(819);

var _CharityImage2 = _interopRequireDefault(_CharityImage);

__webpack_require__(847);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectList = function SelectList(_ref) {
  var showRadioIcon = _ref.showRadioIcon,
      items = _ref.items,
      selectedId = _ref.selectedId,
      onSelect = _ref.onSelect,
      labelKey = _ref.labelKey,
      idKey = _ref.idKey;
  return _react2.default.createElement(
    'ul',
    { className: 'select-list', role: 'radiogroup' },
    items.filter(function (item) {
      return !selectedId || selectedId === item[idKey];
    }).map(function (item) {
      return _react2.default.createElement(
        'li',
        {
          key: item[idKey],
          className: 'select-list__item ' + (item[idKey] === selectedId && '--selected') + ' ' + (showRadioIcon && '--radio-icon')
        },
        _react2.default.createElement(
          'a',
          {
            href: '',
            className: 'select-list__item__inner',
            role: 'radio',
            'aria-checked': item[idKey] === selectedId,
            tabIndex: '0',
            onClick: onSelect,
            'data-id': item[idKey]
          },
          _react2.default.createElement(
            'div',
            { className: 'select-list__item__pic__wrapper' },
            _react2.default.createElement(_CharityImage2.default, {
              src: item.charityImageUrl,
              alt: item.charityName,
              classNames: 'select-list__item__pic'
            })
          ),
          item[labelKey]
        )
      );
    })
  );
};

SelectList.propTypes = {
  showRadioIcon: _propTypes2.default.bool,
  items: _propTypes2.default.arrayOf(_propTypes2.default.object),
  selectedId: _propTypes2.default.number,
  labelKey: _propTypes2.default.string,
  idKey: _propTypes2.default.string,
  onSelect: _propTypes2.default.func
};

SelectList.defaultProps = {
  showRadioIcon: false,
  items: [],
  selectedId: null,
  labelKey: 'label',
  idKey: 'id',
  onSelect: function onSelect() {}
};

exports.default = SelectList;

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(848);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Steps = function Steps(_ref) {
  var step = _ref.step;
  return _react2.default.createElement(
    'div',
    { className: 'steps' },
    _react2.default.createElement(
      'div',
      { className: 'steps__inner' },
      _react2.default.createElement(
        'div',
        { className: 'steps__step steps__step--1 ' + (step >= '1' ? '--selected' : '') },
        _react2.default.createElement(
          'div',
          { className: 'steps__step__number' },
          step > 1 ? _react2.default.createElement('i', { className: 'steps__step__number__tick' }) : '1'
        ),
        _react2.default.createElement(
          'div',
          { className: 'steps__step__description' },
          'Confirm your charity'
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'steps__step steps__step--2 ' + (step >= '2' ? '--selected' : '') },
        _react2.default.createElement(
          'div',
          { className: 'steps__step__number' },
          step > 2 ? _react2.default.createElement('i', { className: 'steps__step__number__tick' }) : '2'
        ),
        _react2.default.createElement(
          'div',
          { className: 'steps__step__description' },
          'Invite your friends'
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'steps__step steps__step--3 ' + (step >= '3' ? '--selected' : '') },
        _react2.default.createElement(
          'div',
          { className: 'steps__step__number' },
          step > 3 ? _react2.default.createElement('i', { className: 'steps__step__number__tick' }) : '3'
        ),
        _react2.default.createElement(
          'div',
          { className: 'steps__step__description' },
          'Match your miles'
        )
      )
    )
  );
};

Steps.propTypes = {
  step: _propTypes2.default.string
};

Steps.defaultProps = {
  step: '1'
};

exports.default = Steps;

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _immutable = __webpack_require__(44);

var _immutable2 = _interopRequireDefault(_immutable);

__webpack_require__(849);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TagList = function (_React$Component) {
  _inherits(TagList, _React$Component);

  function TagList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TagList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TagList.__proto__ || Object.getPrototypeOf(TagList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      itemTabIndex: 0
    }, _this.onTagListKeyUp = function (event) {
      _this.removeFriendSelectionOnBackspace(event);
      _this.handleEnterPress(event.keyCode);
      _this.handleArrowKeys(event);
    }, _this.toggleFriendSelection = function (event) {
      event.preventDefault();
      var toggleFriendSelection = _this.props.toggleFriendSelection;


      toggleFriendSelection(event);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TagList, [{
    key: 'removeFriendSelectionOnBackspace',
    value: function removeFriendSelectionOnBackspace(event) {
      var _props = this.props,
          selectedItems = _props.selectedItems,
          removeFriendSelection = _props.removeFriendSelection;

      var backSpaceKeyCode = 8;
      var inputVal = event.currentTarget.value;

      if (event.keyCode === backSpaceKeyCode && inputVal === '' && !this.oldInputVal && selectedItems.size > 0) {
        removeFriendSelection(selectedItems.last());
      }

      this.oldInputVal = inputVal;
    }
  }, {
    key: 'handleEnterPress',
    value: function handleEnterPress(keyCode) {
      var _props2 = this.props,
          addFriendSelectionOnEnterPress = _props2.addFriendSelectionOnEnterPress,
          value = _props2.value;

      var enterKey = 13;
      var firstFriendId = this.filteredFriends.getIn([this.state.itemTabIndex, 'id']);

      if (keyCode === enterKey && firstFriendId && value) {
        addFriendSelectionOnEnterPress(firstFriendId);
        this.oldInputVal = '';
      }
    }
  }, {
    key: 'handleArrowKeys',
    value: function handleArrowKeys(event) {
      var keyCode = event.keyCode;
      var upKey = 38;
      var downKey = 40;

      if (keyCode === upKey && this.state.itemTabIndex > 0) {
        this.setState({
          itemTabIndex: this.state.itemTabIndex - 1
        });
      } else if (keyCode === downKey && this.state.itemTabIndex < this.filteredFriends.size) {
        this.setState({
          itemTabIndex: this.state.itemTabIndex + 1
        });
      } else {
        this.setState({
          itemTabIndex: 0
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          selectedIds = _props3.selectedIds,
          selectedItems = _props3.selectedItems,
          allFriends = _props3.allFriends,
          removeSelection = _props3.removeSelection,
          placeholder = _props3.placeholder,
          value = _props3.value,
          onChange = _props3.onChange;

      var lowerCasedFriendsFilterText = value.toLowerCase();
      this.filteredFriends = allFriends.size ? allFriends.filter(function (friend) {
        return friend.get('name').toLowerCase().includes(lowerCasedFriendsFilterText) && !selectedIds.includes(friend.get('id'));
      }) : _immutable2.default.List();

      return _react2.default.createElement(
        'div',
        { className: 'tag-list' },
        _react2.default.createElement(
          'div',
          { className: 'tag-list__list__wrapper' },
          _react2.default.createElement(
            'label',
            { className: 'tag-list__inner', htmlFor: 'tag-list__input' },
            _react2.default.createElement(
              'ul',
              { className: 'tag-list__list' },
              selectedItems.map(function (friend) {
                return _react2.default.createElement(
                  'li',
                  { key: friend.get('id'), className: 'tag-list__list__item' },
                  _react2.default.createElement(
                    'a',
                    { href: '', className: 'tag-list__list__item__btn', onClick: removeSelection, 'data-id': friend.get('id') },
                    friend.get('name'),
                    _react2.default.createElement('i', { className: 'tag-list__list__item__cross-icon' })
                  )
                );
              })
            ),
            _react2.default.createElement('input', {
              type: 'text',
              id: 'tag-list__input',
              className: 'tag-list__input',
              autoFocus: window.innerWidth >= 768,
              placeholder: placeholder,
              value: value,
              onChange: onChange,
              onKeyUp: this.onTagListKeyUp
            })
          ),
          this.props.value.length > 0 && _react2.default.createElement(
            'div',
            null,
            this.filteredFriends.size ? _react2.default.createElement(
              'ul',
              { className: 'tag-list__suggestions' },
              this.filteredFriends.map(function (friend, index) {
                return _react2.default.createElement(
                  'li',
                  { key: friend.get('id'), className: 'tag-list__suggestions__item' },
                  _react2.default.createElement(
                    'a',
                    {
                      href: '',
                      className: 'tag-list__suggestions__item__btn ' + (_this2.state.itemTabIndex === index && '--active'),
                      onClick: _this2.toggleFriendSelection, 'data-id': friend.get('id')
                    },
                    _react2.default.createElement(
                      'div',
                      { className: 'tag-list__suggestions__item__btn__inner' },
                      _react2.default.createElement('img', { src: friend.getIn(['picture', 'data', 'url']), alt: '' }),
                      friend.get('name')
                    )
                  )
                );
              })
            ) : _react2.default.createElement(
              'div',
              { className: 'tag-list__suggestions__no-matches' },
              'There are no friends that match your search'
            )
          )
        )
      );
    }
  }]);

  return TagList;
}(_react2.default.Component);

TagList.propTypes = {
  onChange: _propTypes2.default.func,
  removeSelection: _propTypes2.default.func,
  toggleFriendSelection: _propTypes2.default.func,
  addFriendSelectionOnEnterPress: _propTypes2.default.func,
  value: _propTypes2.default.string,
  selectedItems: _propTypes2.default.object,
  allFriends: _propTypes2.default.object,
  removeFriendSelection: _propTypes2.default.func,
  placeholder: _propTypes2.default.string,
  selectedIds: _propTypes2.default.object
};
TagList.defaultProps = {
  removeSelection: function removeSelection() {},
  toggleFriendSelection: function toggleFriendSelection() {},
  addFriendSelectionOnEnterPress: function addFriendSelectionOnEnterPress() {},
  value: '',
  placeholder: '',
  onChange: function onChange() {},
  selectedItems: _immutable2.default.List(),
  allFriends: _immutable2.default.List(),
  removeFriendSelection: function removeFriendSelection() {},
  selectedIds: _immutable2.default.List()
};
exports.default = TagList;

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(850);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var TextInput = function TextInput(_ref) {
  var icon = _ref.icon,
      clearInput = _ref.clearInput,
      props = _objectWithoutProperties(_ref, ['icon', 'clearInput']);

  return _react2.default.createElement(
    'div',
    { className: 'text-input' },
    icon && _react2.default.createElement('i', { className: 'text-input__icon text-input__icon-' + icon }),
    _react2.default.createElement('input', _extends({ type: 'text', className: 'text-input__input' }, props)),
    props.value && _react2.default.createElement(
      'a',
      { href: '', onClick: clearInput, className: 'text-input__clear-input' },
      _react2.default.createElement(
        'span',
        { className: 'hide-text' },
        'Clear search'
      )
    )
  );
};

TextInput.propTypes = {
  icon: _propTypes2.default.string,
  clearInput: _propTypes2.default.func,
  value: _propTypes2.default.string
};

TextInput.defaultProps = {
  icon: '',
  value: '',
  clearInput: function clearInput() {}
};

exports.default = TextInput;

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRouter = __webpack_require__(18);

var _reactRouterRedux = __webpack_require__(138);

var _redux = __webpack_require__(21);

var _reduxDevtoolsExtension = __webpack_require__(804);

var _reduxThunk = __webpack_require__(317);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _mainReducers = __webpack_require__(840);

var _mainReducers2 = _interopRequireDefault(_mainReducers);

var _apiReducers = __webpack_require__(836);

var _apiReducers2 = _interopRequireDefault(_apiReducers);

var _httpReducers = __webpack_require__(839);

var _httpReducers2 = _interopRequireDefault(_httpReducers);

var _facebookReducers = __webpack_require__(838);

var _facebookReducers2 = _interopRequireDefault(_facebookReducers);

var _facebookInviteFriendsReducers = __webpack_require__(837);

var _facebookInviteFriendsReducers2 = _interopRequireDefault(_facebookInviteFriendsReducers);

var _apiMiddleware = __webpack_require__(324);

var _apiMiddleware2 = _interopRequireDefault(_apiMiddleware);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var configureStore = function configureStore() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var middleware = [_apiMiddleware2.default, (0, _reactRouterRedux.routerMiddleware)(_reactRouter.browserHistory), _reduxThunk2.default];

  var reducer = (0, _redux.combineReducers)({
    routing: _reactRouterRedux.routerReducer,
    mainStore: _mainReducers2.default,
    facebookStore: _facebookReducers2.default,
    facebookInviteFriendsStore: _facebookInviteFriendsReducers2.default,
    api: _apiReducers2.default,
    http: _httpReducers2.default
  });

  var store = (0, _redux.createStore)(reducer, initialState, (0, _reduxDevtoolsExtension.composeWithDevTools)(_redux.applyMiddleware.apply(undefined, middleware)));

  return store;
};

exports.default = configureStore;

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Footer = __webpack_require__(821);

var _Footer2 = _interopRequireDefault(_Footer);

__webpack_require__(851);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var App = function App(_ref) {
  var props = _objectWithoutProperties(_ref, []);

  return _react2.default.createElement(
    'div',
    { className: 'app' },
    _react2.default.createElement(
      'div',
      { className: 'app__inner' },
      props.children
    ),
    _react2.default.createElement(_Footer2.default, null)
  );
};

App.propTypes = {
  children: _propTypes2.default.element
};

App.defaultProps = {
  children: null
};

exports.default = App;

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CharitySearch = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(18);

var _redux = __webpack_require__(21);

var _reactRedux = __webpack_require__(20);

var _Header = __webpack_require__(109);

var _Header2 = _interopRequireDefault(_Header);

var _components = __webpack_require__(24);

var _config = __webpack_require__(31);

var _config2 = _interopRequireDefault(_config);

var _TextInput = __webpack_require__(827);

var _TextInput2 = _interopRequireDefault(_TextInput);

var _SelectList = __webpack_require__(824);

var _SelectList2 = _interopRequireDefault(_SelectList);

var _mainActions = __webpack_require__(93);

var _mainActions2 = _interopRequireDefault(_mainActions);

var _httpActions = __webpack_require__(135);

var _httpActions2 = _interopRequireDefault(_httpActions);

var _apiActions = __webpack_require__(92);

var _apiActions2 = _interopRequireDefault(_apiActions);

var _analytics = __webpack_require__(137);

var _analytics2 = _interopRequireDefault(_analytics);

var _apiSelectors = __webpack_require__(94);

var _immutable = __webpack_require__(44);

var _immutable2 = _interopRequireDefault(_immutable);

var _tools = __webpack_require__(62);

var _tools2 = _interopRequireDefault(_tools);

var _locationUtils = __webpack_require__(95);

var _locationUtils2 = _interopRequireDefault(_locationUtils);

__webpack_require__(852);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CharitySearch = exports.CharitySearch = function (_React$Component) {
  _inherits(CharitySearch, _React$Component);

  function CharitySearch() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CharitySearch);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CharitySearch.__proto__ || Object.getPrototypeOf(CharitySearch)).call.apply(_ref, [this].concat(args))), _this), _this.onContinueBtnClick = function () {
      var _this$props = _this.props,
          participantEmail = _this$props.participantEmail,
          eventId = _this$props.eventId,
          location = _this$props.location;

      _analytics2.default.track({
        page_type: 'custom project page',
        event: 'link click',
        subtype: 'button',
        event_value: 'continue',
        page_section: 'match my miles > choose your charity',
        activity_id: eventId,
        activity_type: 'event_id',
        email: participantEmail,
        actor_id: location.query.guid,
        actor_sources: 'participant guid'
      });

      _tools2.default.scrollToTop();
    }, _this.onSearchInputClick = function () {
      _this.onItemClick('search for a charity');
    }, _this.debouncedDoCharitySearch = _tools2.default.debounce(_this.props.apiActionsBound.getCharitySuggestions, 500), _this.updateTextQuery = function (event) {
      var _this$props2 = _this.props,
          mainActionsBound = _this$props2.mainActionsBound,
          httpActionsBound = _this$props2.httpActionsBound,
          timeKeyStrokeApiRequestGap = _this$props2.timeKeyStrokeApiRequestGap,
          minNumberOfCharsBeforeSearch = _this$props2.minNumberOfCharsBeforeSearch;

      var queryText = event.currentTarget.value;
      mainActionsBound.updateQueryText(queryText);
      if (queryText.length < minNumberOfCharsBeforeSearch) {
        return;
      }
      clearTimeout(_this.charitySearchTimer);
      _this.charitySearchTimer = setTimeout(function () {
        httpActionsBound.requestMade('charitySearch');
        _this.debouncedDoCharitySearch();
      }, timeKeyStrokeApiRequestGap);
    }, _this.selectCharity = function (event) {
      var _this$props3 = _this.props,
          mainActionsBound = _this$props3.mainActionsBound,
          charityEntities = _this$props3.charityEntities;

      event.preventDefault();
      var charityId = event.currentTarget.getAttribute('data-id');
      mainActionsBound.clearQueryText();
      mainActionsBound.setCharity(charityId);

      if (_tools2.default.localStorageAvailable()) {
        var entity = JSON.stringify(charityEntities.get(charityId).toJS());
        window.localStorage.setItem('selectedCharityEntity', entity);
      }

      _this.onItemClick('charity', {
        content_id: charityId,
        content_type: 'charity_id',
        charity_id: charityId
      });
    }, _this.changeCharity = function (event) {
      var mainActionsBound = _this.props.mainActionsBound;

      event.preventDefault();
      mainActionsBound.resetCharitySelection();
      _this.onItemClick('choose a different charity');
    }, _this.clearInput = function (event) {
      var mainActionsBound = _this.props.mainActionsBound;

      event.preventDefault();
      mainActionsBound.clearQueryText();
    }, _this.firePageView = function () {
      var _this$props4 = _this.props,
          participantEmail = _this$props4.participantEmail,
          eventId = _this$props4.eventId,
          location = _this$props4.location;

      _analytics2.default.track({
        page_type: 'custom project page',
        event: 'page view',
        subtype: 'match my miles',
        event_value: 'choose your charity',
        activity_id: eventId,
        activity_type: 'event_id',
        email: participantEmail,
        actor_id: location.query.guid,
        actor_sources: 'participant guid'
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CharitySearch, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var mainStore = this.props.mainStore;

      mainStore.get('participantPromise').then(this.firePageView);
    }
  }, {
    key: 'onItemClick',
    value: function onItemClick(text) {
      var extras = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _props = this.props,
          participantEmail = _props.participantEmail,
          eventId = _props.eventId,
          location = _props.location;

      _analytics2.default.track(_extends({
        page_type: 'custom project page',
        event: 'click',
        subtype: 'button',
        event_value: text,
        page_section: 'match my miles > choose your charity',
        activity_id: eventId,
        activity_type: 'event_id',
        email: participantEmail,
        actor_id: location.query.guid,
        actor_sources: 'participant guid'
      }, extras));
    }
  }, {
    key: 'getNextRoute',
    value: function getNextRoute() {
      var _props2 = this.props,
          isUserLoggedIn = _props2.isUserLoggedIn,
          location = _props2.location,
          selectedCharityId = _props2.selectedCharityId;

      var query = '?guid=' + location.query.guid + '&charityId=' + selectedCharityId;
      var nextRoute = isUserLoggedIn ? '/invite-friends' : '/login';
      return '' + _config2.default.ROOT_PATH + nextRoute + query;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          mainStore = _props3.mainStore,
          apiStore = _props3.apiStore,
          http = _props3.http,
          suggestedCharities = _props3.suggestedCharities,
          charitiesSearchResponse = _props3.charitiesSearchResponse,
          participantFirstName = _props3.participantFirstName,
          charitySearchEnabled = _props3.charitySearchEnabled,
          selectedCharityId = _props3.selectedCharityId,
          maxNumberOfResults = _props3.maxNumberOfResults;


      var charityEntities = apiStore.getIn(['normalized', 'entities', 'charities'], _immutable2.default.Map());
      var charitiesSearchResponseJS = charitiesSearchResponse.toJS().slice(0, maxNumberOfResults);

      var selectedCharity = [selectedCharityId].map(function () {
        return charityEntities.get('' + selectedCharityId, _immutable2.default.Map()).toJS();
      });
      var queryText = mainStore.get('queryText');

      return _react2.default.createElement(
        'div',
        { className: 'charity-search' },
        _react2.default.createElement(_Header2.default, { step: '1' }),
        _react2.default.createElement(
          'div',
          { className: 'charity-search__body container' },
          _react2.default.createElement(
            'p',
            { className: 'charity-search__hey' },
            'Hey ',
            participantFirstName,
            '!'
          ),
          suggestedCharities.size === 1 && !charitySearchEnabled ? _react2.default.createElement(
            'p',
            { className: 'charity-search__which-charity' },
            'You are raising funds for'
          ) : _react2.default.createElement(
            'p',
            { className: 'charity-search__which-charity' },
            'Which charity are you supporting?'
          ),
          charitySearchEnabled && _react2.default.createElement(
            'div',
            { className: 'charity-search__input' },
            _react2.default.createElement(_TextInput2.default, {
              icon: queryText ? '' : 'magnify',
              placeholder: 'Search for a charity\u2026',
              onChange: this.updateTextQuery,
              onClick: this.onSearchInputClick,
              value: queryText,
              clearInput: this.clearInput
            }),
            queryText && _react2.default.createElement(
              'div',
              null,
              http.getIn(['charitySearch', 'isInFlight']) ? _react2.default.createElement(
                'div',
                { className: 'charity-search__input__no-results' },
                _react2.default.createElement(_components.Loading, { size: 'small' })
              ) : _react2.default.createElement(
                'div',
                { className: 'charity-search__input__select-charity-overlay' },
                charitiesSearchResponseJS.length > 0 && _react2.default.createElement(_SelectList2.default, {
                  onSelect: this.selectCharity,
                  items: charitiesSearchResponseJS,
                  labelKey: 'charityName',
                  idKey: 'charityId'
                }),
                !charitiesSearchResponseJS.length && _react2.default.createElement(
                  'div',
                  { className: 'charity-search__input__no-results' },
                  'There are no results for your search'
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'charity-search__select-charity ' + (queryText && '--searching') },
            selectedCharityId ? _react2.default.createElement(_SelectList2.default, {
              showRadioIcon: true,
              selectedId: Number(selectedCharityId),
              onSelect: this.selectCharity,
              items: selectedCharity,
              labelKey: 'charityName',
              idKey: 'charityId'
            }) : _react2.default.createElement(_SelectList2.default, {
              showRadioIcon: true,
              onSelect: this.selectCharity,
              items: suggestedCharities.toJS(),
              labelKey: 'charityName',
              idKey: 'charityId'
            })
          ),
          selectedCharityId && suggestedCharities.size > 1 && _react2.default.createElement(
            'a',
            { href: '', role: 'button', onClick: this.changeCharity, className: 'charity-search__change-charity-btn' },
            'Change charity'
          ),
          _react2.default.createElement(
            'div',
            { className: 'charity-search__continute-btn__wrapper' },
            _react2.default.createElement(
              _reactRouter.Link,
              { to: this.getNextRoute(), className: 'charity-search__continute-btn ' + (!selectedCharityId && 'is-disabled'), onClick: this.onContinueBtnClick },
              'Continue'
            )
          )
        )
      );
    }
  }]);

  return CharitySearch;
}(_react2.default.Component);

CharitySearch.propTypes = {
  mainActionsBound: _propTypes2.default.object,
  apiActionsBound: _propTypes2.default.object,
  httpActionsBound: _propTypes2.default.object,
  mainStore: _propTypes2.default.object,
  apiStore: _propTypes2.default.object,
  http: _propTypes2.default.object,
  suggestedCharities: _propTypes2.default.object,
  charitiesSearchResponse: _propTypes2.default.object,
  charityEntities: _propTypes2.default.object,
  charitySearchEnabled: _propTypes2.default.bool,
  participantFirstName: _propTypes2.default.string,
  location: _propTypes2.default.object,
  isUserLoggedIn: _propTypes2.default.bool,
  selectedCharityId: _propTypes2.default.string,
  minNumberOfCharsBeforeSearch: _propTypes2.default.number,
  timeKeyStrokeApiRequestGap: _propTypes2.default.number,
  maxNumberOfResults: _propTypes2.default.number,
  participantEmail: _propTypes2.default.string,
  eventId: _propTypes2.default.number
};
CharitySearch.defaultProps = {
  mainActionsBound: {},
  apiActionsBound: {},
  httpActionsBound: {},
  suggestedCharities: _immutable2.default.List(),
  charitiesSearchResponse: _immutable2.default.List(),
  charityEntities: _immutable2.default.Map(),
  charitySearchEnabled: false,
  mainStore: _immutable2.default.fromJS({
    participantPromise: Promise.resolve()
  }),
  apiStore: _immutable2.default.Map(),
  http: _immutable2.default.Map(),
  participantFirstName: '',
  location: _locationUtils2.default.locationStub,
  minNumberOfCharsBeforeSearch: 2,
  timeKeyStrokeApiRequestGap: 800, // milliseconds
  maxNumberOfResults: 5
};


var mapStateToProps = function mapStateToProps(state) {
  return {
    participantEmail: (0, _apiSelectors.getParticipantEmail)(state),
    eventId: (0, _apiSelectors.getEventId)(state),
    mainStore: state.mainStore,
    charityEntities: (0, _apiSelectors.getCharityEntities)(state),
    http: state.http,
    apiStore: state.api,
    isUserLoggedIn: state.mainStore.get('isUserLoggedIn'),
    suggestedCharities: (0, _apiSelectors.getSuggestedCharities)(state),
    charitiesSearchResponse: (0, _apiSelectors.getCharitiesSearchResponse)(state),
    participantFirstName: (0, _apiSelectors.getParticipantFirstName)(state),
    charitySearchEnabled: (0, _apiSelectors.charitySearchEnabledSelector)(state),
    selectedCharityId: (0, _apiSelectors.getCharityId)(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    mainActionsBound: (0, _redux.bindActionCreators)(_mainActions2.default, dispatch),
    apiActionsBound: (0, _redux.bindActionCreators)(_apiActions2.default, dispatch),
    httpActionsBound: (0, _redux.bindActionCreators)(_httpActions2.default, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CharitySearch);

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _locationUtils = __webpack_require__(95);

var _locationUtils2 = _interopRequireDefault(_locationUtils);

var _Header = __webpack_require__(109);

var _Header2 = _interopRequireDefault(_Header);

var _reactRouter = __webpack_require__(18);

__webpack_require__(853);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var goBack = function goBack(event) {
  event.preventDefault();
  _reactRouter.browserHistory.goBack();
};

var Landing = function Landing() {
  return _react2.default.createElement(
    'div',
    { className: 'error-page' },
    _react2.default.createElement(_Header2.default, null),
    _react2.default.createElement(
      'div',
      { className: 'container' },
      _react2.default.createElement(
        'h1',
        { className: 'error-page__heading' },
        'Oops, something went wrong'
      ),
      _react2.default.createElement(
        'p',
        { className: 'error-page__blurb' },
        'Remember the more you share, the more miles you will match for your charity'
      ),
      _react2.default.createElement(
        'p',
        { className: 'error-page__blurb' },
        _react2.default.createElement(
          'a',
          { href: '', onClick: goBack },
          'Go back'
        )
      )
    )
  );
};

Landing.propTypes = {
  location: _propTypes2.default.objectOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]))
};

Landing.defaultProps = {
  location: _locationUtils2.default.locationStub
};

exports.default = Landing;

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InviteFriends = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _promiseRetry = __webpack_require__(268);

var _promiseRetry2 = _interopRequireDefault(_promiseRetry);

var _redux = __webpack_require__(21);

var _reactRedux = __webpack_require__(20);

var _Header = __webpack_require__(109);

var _Header2 = _interopRequireDefault(_Header);

var _TagList = __webpack_require__(826);

var _TagList2 = _interopRequireDefault(_TagList);

var _mainActions = __webpack_require__(93);

var _mainActions2 = _interopRequireDefault(_mainActions);

var _apiActions = __webpack_require__(92);

var _apiActions2 = _interopRequireDefault(_apiActions);

var _facebookInviteFriendsActions = __webpack_require__(209);

var _facebookInviteFriendsActions2 = _interopRequireDefault(_facebookInviteFriendsActions);

var _httpSelectors = __webpack_require__(136);

var _apiSelectors = __webpack_require__(94);

var _analytics = __webpack_require__(137);

var _analytics2 = _interopRequireDefault(_analytics);

var _components = __webpack_require__(24);

var _facebookWhite = __webpack_require__(325);

var _facebookWhite2 = _interopRequireDefault(_facebookWhite);

var _immutable = __webpack_require__(44);

var _immutable2 = _interopRequireDefault(_immutable);

var _tools = __webpack_require__(62);

var _tools2 = _interopRequireDefault(_tools);

__webpack_require__(854);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InviteFriends = exports.InviteFriends = function (_React$Component) {
  _inherits(InviteFriends, _React$Component);

  function InviteFriends() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InviteFriends);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InviteFriends.__proto__ || Object.getPrototypeOf(InviteFriends)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      lastIndexVisible: 20
    }, _this.onResize = _tools2.default.debounce(function () {
      // to recalculate the max height style on the list of friends
      _this.forceUpdate();
    }, 200), _this.onFriendsListScroll = function (event) {
      if (typeof window !== 'undefined' && event.target.scrollTop + _this.friendsListWrapperRef.clientHeight >= _this.friendsListRef.clientHeight) {
        _this.increaseLastIndexVisible();
      }
    }, _this.onBodyClick = function () {
      /* istanbul ignore next */
      var input = window.document.querySelector('.tag-list__input');
      /* istanbul ignore next */
      if (input && window.innerWidth >= 768) {
        input.focus();
      }
    }, _this.onProceedToInviteFriendsClick = function () {
      var facebookInviteFriendsActionsBound = _this.props.facebookInviteFriendsActionsBound;

      facebookInviteFriendsActionsBound.fbLogin();
      _this.trackClick('invite your friends');
    }, _this.onSubmitFriendSelection = function () {
      var _this$props = _this.props,
          mainActionsBound = _this$props.mainActionsBound,
          facebookInviteFriendsStore = _this$props.facebookInviteFriendsStore;

      mainActionsBound.confirmFriendsSelection();
      _this.trackClick('invite your friends', {
        card_count: facebookInviteFriendsStore.get('selectedFriends').size,
        card_id: 'friends_count',
        page_section: 'match my miles > invite your friends > add friends'
      });
    }, _this.onSkipSharing = function (event) {
      event.preventDefault();
      var _this$props2 = _this.props,
          mainActionsBound = _this$props2.mainActionsBound,
          facebookStore = _this$props2.facebookStore,
          facebookInviteFriendsStore = _this$props2.facebookInviteFriendsStore;

      mainActionsBound.proceedToDonationClicked();
      var fbFriendsLoaded = facebookStore.get('fbFriendsLoaded');

      var extras = {};

      if (fbFriendsLoaded) {
        extras.card_count = facebookInviteFriendsStore.get('selectedFriends').size;
        extras.card_id = 'friends_count';
        extras.page_section = 'match my miles > invite your friends > add friends';
      }

      _this.trackClick('skip sharing', extras);
    }, _this.setFriendsListWrapperRef = function (ref) {
      _this.friendsListWrapperRef = ref;
    }, _this.setFriendsListRef = function (ref) {
      _this.friendsListRef = ref;
    }, _this.getListMaxHeight = function () {
      var height = window.innerHeight / 3;

      if (height < 120) {
        height = 120;
      }

      return height;
    }, _this.firePageView = function () {
      var eventId = _this.props.eventId;

      if (!_this.pageViewFired && !_this.isLoggedIn() && eventId) {
        _this.firePartialPageView('match my miles > invite your friends');
        _this.pageViewFired = true;
      }
      if (!_this.loggedInPageViewFired && _this.isLoggedIn()) {
        _this.firePartialPageView('match my miles > invite your friends > add friends');
        _this.loggedInPageViewFired = true;
      }
    }, _this.firePartialPageView = function (pageSection) {
      var _this$props3 = _this.props,
          eventId = _this$props3.eventId,
          location = _this$props3.location;

      var charityId = Number(location.query.charityId);
      _analytics2.default.track({
        page_type: 'custom project page',
        event: 'page view',
        subtype: 'match my miles',
        event_value: 'invite your friends',
        page_section: pageSection,
        activity_id: eventId,
        activity_type: 'event_id',
        content_id: charityId,
        content_type: 'charity_id',
        charity_id: charityId,
        actor_id: location.query.guid,
        actor_sources: 'participant guid'
      });
    }, _this.createDonation = function () {
      var apiActionsBound = _this.props.apiActionsBound;

      (0, _promiseRetry2.default)(function (retry) {
        return apiActionsBound.createDonation().catch(retry);
      }, {
        retries: 7,
        factor: 1,
        minTimeout: 2000,
        maxTimeout: 2000
      });
    }, _this.increaseLastIndexVisible = _tools2.default.debounce(function () {
      _this.setState({ lastIndexVisible: _this.state.lastIndexVisible + 20 });
    }, 500), _this.toggleFriendSelection = function (event) {
      var _this$props4 = _this.props,
          facebookInviteFriendsActionsBound = _this$props4.facebookInviteFriendsActionsBound,
          facebookInviteFriendsStore = _this$props4.facebookInviteFriendsStore;

      event.preventDefault();
      var friendId = event.currentTarget.getAttribute('data-id');
      facebookInviteFriendsActionsBound.toggleFriendSelection(friendId);
      facebookInviteFriendsActionsBound.filterFriends('');

      var isDeselection = facebookInviteFriendsStore.get('selectedFriends').includes(friendId);
      var isFiltering = !!facebookInviteFriendsStore.get('friendsFilterText', false);

      _this.trackFriendSelection(isDeselection, isFiltering);
    }, _this.addFriendSelectionOnEnterPress = function (friendId) {
      var facebookInviteFriendsActionsBound = _this.props.facebookInviteFriendsActionsBound;

      facebookInviteFriendsActionsBound.toggleFriendSelection(friendId);
      facebookInviteFriendsActionsBound.filterFriends('');

      var isDeselection = false;
      var isFiltering = true;

      _this.trackFriendSelection(isDeselection, isFiltering);
    }, _this.removeSelection = function (event) {
      var facebookInviteFriendsActionsBound = _this.props.facebookInviteFriendsActionsBound;

      event.preventDefault();
      var friendId = event.currentTarget.getAttribute('data-id');
      facebookInviteFriendsActionsBound.removeFriendSelection(friendId);
      facebookInviteFriendsActionsBound.filterFriends('');

      _this.trackFriendSelection(true);
    }, _this.filterFriends = function (event) {
      var facebookInviteFriendsActionsBound = _this.props.facebookInviteFriendsActionsBound;

      facebookInviteFriendsActionsBound.filterFriends(event.currentTarget.value);
      _this.trackTyping();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InviteFriends, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props = this.props,
          mainStore = _props.mainStore,
          apiActionsBound = _props.apiActionsBound,
          mainActionsBound = _props.mainActionsBound;


      mainActionsBound.resetProceedToDonationClicked();

      mainStore.get('participantPromise').then(function () {
        _this2.firePageView();
        (0, _promiseRetry2.default)(function (retry) {
          return apiActionsBound.createFundraisingPage().catch(retry);
        }, {
          retries: 2,
          factor: 1,
          minTimeout: 3000,
          maxTimeout: 3000
        }).then(_this2.createDonation);
      });

      /* istanbul ignore next */
      if (typeof window !== 'undefined' && typeof window.document.querySelector === 'function') {
        window.document.querySelector('body').addEventListener('click', this.onBodyClick);
        this.friendsListWrapperRef.addEventListener('scroll', this.onFriendsListScroll);
        window.addEventListener('resize', this.onResize);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var _props2 = this.props,
          mainStore = _props2.mainStore,
          donationLocation = _props2.donationLocation;


      if (mainStore.get('proceedToDonationClicked') && donationLocation && !this.navigated) {
        this.navigated = true;
        window.location.href = donationLocation;
      }

      this.firePageView();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      /* istanbul ignore next */
      if (typeof window !== 'undefined') {
        window.document.querySelector('body').removeEventListener('click', this.onBodyClick);
        this.friendsListWrapperRef.removeEventListener('scroll', this.onFriendsListScroll);
        window.removeEventListener('resize', this.onResize);
      }

      this.pageViewFired = false;
      this.loggedInPageViewFired = false;
    }
  }, {
    key: 'getSelectedFriendsNames',
    value: function getSelectedFriendsNames(fbFriendsData) {
      var facebookInviteFriendsStore = this.props.facebookInviteFriendsStore;

      // todo use normalizr for fb friends response

      return facebookInviteFriendsStore.get('selectedFriends').map(function (friendId) {
        return fbFriendsData.find(function (friend) {
          return friend.get('id') === friendId;
        });
      });
    }
  }, {
    key: 'trackClick',
    value: function trackClick(text) {
      var extras = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _props3 = this.props,
          eventId = _props3.eventId,
          location = _props3.location;

      if (eventId) {
        var charityId = Number(location.query.charityId);
        _analytics2.default.track(_extends({
          page_type: 'custom project page',
          event: 'link click',
          subtype: 'button',
          event_value: text,
          page_section: extras.page_section || 'match my miles > invite your friends',
          activity_id: eventId,
          activity_type: 'event_id',
          content_id: charityId,
          content_type: 'charity_id',
          charity_id: charityId,
          actor_id: location.query.guid,
          actor_sources: 'participant guid'
        }, extras));
      }
    }
  }, {
    key: 'trackFriendSelection',
    value: function trackFriendSelection(isDeselection) {
      var isFiltering = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _props4 = this.props,
          eventId = _props4.eventId,
          location = _props4.location;


      var charityId = Number(location.query.charityId);
      _analytics2.default.track({
        page_type: 'custom project page',
        event: 'click',
        subtype: isFiltering ? 'drop down' : 'toggle',
        event_value: isDeselection ? 'friend deselected' : 'friend selected',
        page_section: 'match my miles > invite your friends > add friends',
        activity_id: eventId,
        activity_type: 'event_id',
        content_id: charityId,
        content_type: 'charity_id',
        charity_id: charityId,
        actor_id: location.query.guid,
        actor_sources: 'participant guid'
      });
    }
  }, {
    key: 'trackTyping',
    value: function trackTyping() {
      var _props5 = this.props,
          eventId = _props5.eventId,
          location = _props5.location;


      var charityId = Number(location.query.charityId);
      _analytics2.default.track({
        page_type: 'custom project page',
        event: 'click',
        subtype: 'button',
        event_value: 'start typing',
        page_section: 'match my miles > invite your friends > add friends',
        activity_id: eventId,
        activity_type: 'event_id',
        content_id: charityId,
        content_type: 'charity_id',
        charity_id: charityId,
        actor_id: location.query.guid,
        actor_sources: 'participant guid'
      });
    }
  }, {
    key: 'isLoggedIn',
    value: function isLoggedIn() {
      var facebookInviteFriendsStore = this.props.facebookInviteFriendsStore;

      return !!facebookInviteFriendsStore.get('fbAuthResponse');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props6 = this.props,
          mainStore = _props6.mainStore,
          facebookStore = _props6.facebookStore,
          facebookInviteFriendsStore = _props6.facebookInviteFriendsStore,
          isInviteFriendsRequestInFlight = _props6.isInviteFriendsRequestInFlight,
          facebookInviteFriendsActionsBound = _props6.facebookInviteFriendsActionsBound;


      var fbFriendsDataAll = facebookInviteFriendsStore.get('fbFriendsData', _immutable2.default.List());
      var fbFriendsLoaded = facebookInviteFriendsStore.get('fbFriendsLoaded');

      var fbFriendsData = fbFriendsDataAll.slice(0, this.state.lastIndexVisible);
      var friendsFilterText = facebookInviteFriendsStore.get('friendsFilterText', '');

      var selectedFriends = this.getSelectedFriendsNames(fbFriendsDataAll);
      var selectedFriendsIds = facebookInviteFriendsStore.get('selectedFriends');

      var proceedToDonationClicked = mainStore.get('proceedToDonationClicked');

      return _react2.default.createElement(
        'div',
        { className: 'invite-friends' },
        _react2.default.createElement(_Header2.default, { step: '2' }),
        _react2.default.createElement(
          'div',
          { className: 'invite-friends__body container' },
          _react2.default.createElement(
            'p',
            { className: 'invite-friends__nice-choice' },
            'Awesome! Invite your friends to match you'
          ),
          _react2.default.createElement(
            'p',
            { className: 'invite-friends__intro' },
            'Ask your friends to match your miles with a pledge'
          ),
          !this.isLoggedIn() ? _react2.default.createElement(
            'div',
            null,
            facebookStore.get('fbInitialised') && _react2.default.createElement(
              'div',
              { className: 'invite-friends__continute-btn__wrapper' },
              _react2.default.createElement(
                'button',
                { type: 'button', className: 'invite-friends__continute-btn', onClick: this.onProceedToInviteFriendsClick },
                _react2.default.createElement(_components.Svg, { markup: _facebookWhite2.default, alt: 'Facebook Icon', className: 'invite-friends__continute-btn__fb-icon' }),
                'Invite Friends'
              )
            )
          ) : _react2.default.createElement(
            'div',
            null,
            !fbFriendsLoaded && _react2.default.createElement(_components.Loading, { className: 'invite-friends__loading-friends' }),
            fbFriendsData.size > 0 && _react2.default.createElement(_TagList2.default, {
              selectedItems: selectedFriends,
              selectedIds: selectedFriendsIds,
              removeSelection: this.removeSelection,
              onChange: this.filterFriends,
              value: friendsFilterText,
              allFriends: fbFriendsDataAll,
              removeFriendSelection: facebookInviteFriendsActionsBound.removeFriendSelection,
              toggleFriendSelection: this.toggleFriendSelection,
              addFriendSelectionOnEnterPress: this.addFriendSelectionOnEnterPress,
              placeholder: selectedFriends.size === 0 ? 'Start typing a friend’s name' : ''
            }),
            fbFriendsLoaded && fbFriendsData.size === 0 && _react2.default.createElement(
              'p',
              { className: 'invite-friends__intro' },
              'Oh dear! It looks like you don\u2019t have any friends.'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'invite-friends__list__wrapper', ref: this.setFriendsListWrapperRef, style: { display: fbFriendsData.size ? 'block' : 'none', maxHeight: this.getListMaxHeight() } },
            _react2.default.createElement(
              'ul',
              { className: 'invite-friends__list ' + (friendsFilterText.length > 0 && '--filtering'), ref: this.setFriendsListRef },
              fbFriendsData.map(function (friend) {
                return _react2.default.createElement(
                  'li',
                  { key: friend.get('id'), className: 'invite-friends__list__item ' + (selectedFriendsIds.includes(friend.get('id')) && '--selected') },
                  _react2.default.createElement(
                    'a',
                    { href: '', className: 'invite-friends__list__item__btn', onClick: _this3.toggleFriendSelection, 'data-id': friend.get('id') },
                    _react2.default.createElement(
                      'div',
                      { className: 'invite-friends__list__item__btn__inner' },
                      _react2.default.createElement('img', { src: friend.getIn(['picture', 'data', 'url']), alt: '' }),
                      friend.get('name')
                    )
                  )
                );
              })
            ),
            this.state.lastIndexVisible + 1 < fbFriendsDataAll.size && _react2.default.createElement(
              'div',
              { className: 'invite-friends__loading-next-friends' },
              _react2.default.createElement(_components.Loading, { size: 'small' })
            )
          ),
          this.isLoggedIn() && fbFriendsData.size > 0 && _react2.default.createElement(
            'div',
            { className: 'invite-friends__continute-btn__wrapper' },
            _react2.default.createElement(
              'button',
              { type: 'button', className: 'invite-friends__continute-btn ' + (selectedFriends.size ? '' : 'is-disabled'), onClick: this.onSubmitFriendSelection },
              _react2.default.createElement(_components.Svg, { markup: _facebookWhite2.default, alt: 'Facebook Icon', className: 'invite-friends__continute-btn__fb-icon' }),
              isInviteFriendsRequestInFlight || proceedToDonationClicked ? _react2.default.createElement(_components.Loading, { size: 'small', colour: 'white' }) : _react2.default.createElement(
                'span',
                null,
                'Invite and Continue'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'invite-friends__skip-btn__wrapper' },
            proceedToDonationClicked ? _react2.default.createElement(_components.Loading, { size: 'small' }) : _react2.default.createElement(
              'a',
              { href: '', onClick: this.onSkipSharing, className: 'invite-friends__skip-btn' },
              'Skip sharing'
            )
          )
        )
      );
    }
  }]);

  return InviteFriends;
}(_react2.default.Component);

InviteFriends.propTypes = {
  location: _propTypes2.default.object,
  mainActionsBound: _propTypes2.default.object,
  apiActionsBound: _propTypes2.default.object,
  facebookInviteFriendsActionsBound: _propTypes2.default.object,
  mainStore: _propTypes2.default.object,
  facebookStore: _propTypes2.default.object,
  facebookInviteFriendsStore: _propTypes2.default.object,
  isInviteFriendsRequestInFlight: _propTypes2.default.bool,
  donationLocation: _propTypes2.default.string,
  eventId: _propTypes2.default.number
};
InviteFriends.defaultProps = {
  mainActionsBound: {
    resetProceedToDonationClicked: function resetProceedToDonationClicked() {}
  },
  apiActionsBound: {
    createFundraisingPage: function createFundraisingPage() {}
  },
  mainStore: _immutable2.default.fromJS({
    participantPromise: Promise.resolve(function () {
      return Promise.resolve;
    })
  }),
  facebookInviteFriendsStore: _immutable2.default.fromJS({
    selectedFriends: []
  }),
  isInviteFriendsRequestInFlight: false,
  donationLocation: '',
  facebookStore: _immutable2.default.Map()
};


var mapStateToProps = function mapStateToProps(state) {
  return {
    eventId: (0, _apiSelectors.getEventId)(state),
    mainStore: state.mainStore,
    facebookStore: state.facebookStore,
    facebookInviteFriendsStore: state.facebookInviteFriendsStore,
    isInviteFriendsRequestInFlight: (0, _httpSelectors.isRequestInFlight)('inviteFriends')(state),
    participantPageName: (0, _apiSelectors.getParticipantPageName)(state),
    participantPageUrl: (0, _apiSelectors.getParticipantPageUrl)(state),
    donationLocation: (0, _apiSelectors.getDonationLocation)(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
  return {
    mainActionsBound: (0, _redux.bindActionCreators)(_mainActions2.default, dispatch),
    apiActionsBound: (0, _redux.bindActionCreators)(_apiActions2.default, dispatch),
    facebookInviteFriendsActionsBound: (0, _redux.bindActionCreators)(_facebookInviteFriendsActions2.default, dispatch)
  };
})(InviteFriends);

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Landing = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(20);

var _components = __webpack_require__(24);

var _locationUtils = __webpack_require__(95);

var _locationUtils2 = _interopRequireDefault(_locationUtils);

var _tools = __webpack_require__(62);

var _tools2 = _interopRequireDefault(_tools);

var _CobrandedHeader = __webpack_require__(820);

var _CobrandedHeader2 = _interopRequireDefault(_CobrandedHeader);

var _LandingHero = __webpack_require__(822);

var _LandingHero2 = _interopRequireDefault(_LandingHero);

var _LandingSteps = __webpack_require__(823);

var _LandingSteps2 = _interopRequireDefault(_LandingSteps);

var _analytics = __webpack_require__(137);

var _analytics2 = _interopRequireDefault(_analytics);

var _apiSelectors = __webpack_require__(94);

var _immutable = __webpack_require__(44);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Landing = exports.Landing = function (_React$Component) {
  _inherits(Landing, _React$Component);

  function Landing() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Landing);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Landing.__proto__ || Object.getPrototypeOf(Landing)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isLoading: true
    }, _this.onHeroCTAClick = function () {
      _this.onCTAClick('get started');
    }, _this.onStepsCTAClick = function () {
      _this.onCTAClick('ok lets do this');
    }, _this.firePageView = function () {
      var _this$props = _this.props,
          participantEmail = _this$props.participantEmail,
          eventId = _this$props.eventId,
          location = _this$props.location;

      _analytics2.default.track({
        page_type: 'custom project page',
        event: 'page view',
        subtype: 'match my miles',
        activity_id: eventId,
        activity_type: 'event_id',
        email: participantEmail,
        actor_id: location.query.guid,
        actor_sources: 'participant guid'
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Landing, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.props.mainStore.get('participantPromise').then(function () {
        _this2.firePageView();
        _this2.setState({ isLoading: false });
      });
    }
  }, {
    key: 'onCTAClick',
    value: function onCTAClick(btnText) {
      var _props = this.props,
          participantEmail = _props.participantEmail,
          eventId = _props.eventId,
          location = _props.location;

      _analytics2.default.track({
        page_type: 'custom project page',
        event: 'link click',
        subtype: 'button',
        event_value: btnText,
        page_section: 'match my miles',
        activity_id: eventId,
        activity_type: 'event_id',
        email: participantEmail,
        actor_id: location.query.guid,
        actor_sources: 'participant guid'
      });

      _tools2.default.scrollToTop();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          location = _props2.location,
          isParticipantError = _props2.isParticipantError;
      var isLoading = this.state.isLoading;

      return _react2.default.createElement(
        'div',
        { className: 'landing' },
        _react2.default.createElement(_CobrandedHeader2.default, null),
        isParticipantError && _react2.default.createElement(_components.Alerts, { type: 'error', content: 'Oops, something went wrong. Please try again later' }),
        _react2.default.createElement(_LandingHero2.default, {
          onCTAClick: this.onHeroCTAClick,
          isLoading: isLoading,
          isError: isParticipantError,
          location: location
        }),
        _react2.default.createElement(_LandingSteps2.default, {
          onCTAClick: this.onStepsCTAClick,
          isLoading: isLoading,
          isError: isParticipantError,
          location: location
        })
      );
    }
  }]);

  return Landing;
}(_react2.default.Component);

Landing.propTypes = {
  location: _propTypes2.default.objectOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])),
  isParticipantError: _propTypes2.default.bool.isRequired,
  participantEmail: _propTypes2.default.string,
  eventId: _propTypes2.default.number,
  mainStore: _propTypes2.default.object
};
Landing.defaultProps = {
  location: _locationUtils2.default.locationStub,
  isParticipantError: false,
  mainStore: _immutable2.default.fromJS({
    participantPromise: Promise.resolve()
  })
};


var mapStateToProps = function mapStateToProps(state) {
  return {
    mainStore: state.mainStore,
    participantEmail: (0, _apiSelectors.getParticipantEmail)(state),
    eventId: (0, _apiSelectors.getEventId)(state),
    isParticipantError: Boolean(state.mainStore.getIn(['participantRequestError']))
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(Landing);

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoginPage = exports.addProps = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _app = __webpack_require__(361);

var _app2 = _interopRequireDefault(_app);

var _App = __webpack_require__(212);

var _App2 = _interopRequireDefault(_App);

var _redux = __webpack_require__(21);

var _reactRedux = __webpack_require__(20);

var _Header = __webpack_require__(109);

var _Header2 = _interopRequireDefault(_Header);

var _config = __webpack_require__(31);

var _config2 = _interopRequireDefault(_config);

var _components = __webpack_require__(24);

var _mainActions = __webpack_require__(93);

var _mainActions2 = _interopRequireDefault(_mainActions);

var _locationUtils = __webpack_require__(95);

var _locationUtils2 = _interopRequireDefault(_locationUtils);

var _apiSelectors = __webpack_require__(94);

var _httpSelectors = __webpack_require__(136);

var _analytics = __webpack_require__(137);

var _analytics2 = _interopRequireDefault(_analytics);

var _reactRouter = __webpack_require__(18);

var _resources = __webpack_require__(323);

var _resources2 = _interopRequireDefault(_resources);

var _tools = __webpack_require__(62);

var _tools2 = _interopRequireDefault(_tools);

__webpack_require__(856);

__webpack_require__(855);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var addProps = exports.addProps = function addProps(elements, props) {
  return _react.Children.map(elements, function (element) {
    return (0, _react.cloneElement)(element, _extends({}, props));
  });
};

var LoginPage = exports.LoginPage = function (_React$Component) {
  _inherits(LoginPage, _React$Component);

  function LoginPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LoginPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LoginPage.__proto__ || Object.getPrototypeOf(LoginPage)).call.apply(_ref, [this].concat(args))), _this), _this.childrenWithProps = function () {
      var children = _this.props.children;

      return addProps(children, _this.getLoginAppProps());
    }, _this.updateRoute = function (route, queryString) {
      var push = _this.props.push;

      var validRoutes = {
        email: 'email',
        register: 'register',
        password: 'password'
      };
      validRoutes[route] && push(_config2.default.ROOT_PATH + '/login/' + validRoutes[route] + (queryString || ''));

      _tools2.default.scrollToTop();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LoginPage, [{
    key: 'getLoginAppProps',
    value: function getLoginAppProps() {
      var _this2 = this;

      var facebookLoginStatus = this.props.facebookLoginStatus;

      return {
        locale: 'en-gb',
        emailPageContinueButtonLabel: 'Continue',
        registerPageContinueButtonLabel: 'Continue',
        passwordPageContinueButtonLabel: 'Continue',
        loginSuccessCallback: function loginSuccessCallback(response) {
          return _this2.handleUserIsLoggedIn(response);
        },
        emailPageHeading1: _react2.default.createElement(
          'span',
          null,
          'Nice choice!',
          _react2.default.createElement(
            'span',
            { className: 'jg-text--light dna-block' },
            'You\u2019re almost ready to MATCHmyMILES!'
          )
        ),
        emailPageFacebookAssuranceMessage: _react2.default.createElement(
          'span',
          { className: 'invite-friends__terms' },
          _react2.default.createElement(
            'span',
            null,
            'By continuing to the next step you are agreeing to the '
          ),
          _react2.default.createElement(
            'a',
            { href: 'https://www.justgiving.com/info/terms-of-service', target: '_blank', rel: 'noopener noreferrer' },
            'terms of service'
          ),
          _react2.default.createElement(
            'span',
            null,
            ' of JustGiving'
          )
        ),
        passwordPageHeading1: 'Welcome back',
        registerPageHeading1: 'Register for MATCHmyMILES',
        globalAlertsDecoratorClass: 'login-alert-donate',
        mainClassName: 'donate-login',
        requestSettings: {
          ClientId: 'jg.web',
          RegistrationSource: 2,
          LongLived: true
        },
        isAppDisabled: false,
        updateRoute: this.updateRoute,
        facebookLoginStatus: facebookLoginStatus
      };
    }
  }, {
    key: 'getPageContent',
    value: function getPageContent() {
      var _props = this.props,
          isParticipantInFlight = _props.isParticipantInFlight,
          hostAppProps = _props.hostAppProps;

      if (isParticipantInFlight) {
        return _react2.default.createElement(_components.Loading, { size: 'large' });
      }
      return _react2.default.createElement(
        _app2.default,
        { locale: 'en-GB' },
        _react2.default.createElement(
          _App2.default,
          { updateRoute: this.updateRoute, hostAppProps: hostAppProps },
          _react2.default.createElement(
            'div',
            null,
            this.childrenWithProps()
          )
        )
      );
    }
  }, {
    key: 'handleUserIsLoggedIn',
    value: function handleUserIsLoggedIn(response) {
      var accessToken = response.accessToken,
          refreshToken = response.refreshToken;
      var _props2 = this.props,
          push = _props2.push,
          location = _props2.location,
          mainActionsBound = _props2.mainActionsBound,
          charityId = _props2.charityId;

      mainActionsBound.updateAuthAccessToken(accessToken);
      mainActionsBound.updateAuthRefreshToken(refreshToken);
      push(_config2.default.ROOT_PATH + '/invite-friends?guid=' + location.query.guid + '&charityId=' + charityId);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'login' },
        _react2.default.createElement(_Header2.default, { step: '1.5' }),
        _react2.default.createElement(
          'div',
          { className: 'login__body container' },
          this.getPageContent()
        )
      );
    }
  }]);

  return LoginPage;
}(_react2.default.Component);

LoginPage.propTypes = {
  children: _propTypes2.default.element.isRequired,
  push: _propTypes2.default.func,
  facebookLoginStatus: _propTypes2.default.object,
  location: _propTypes2.default.object,
  hostAppProps: _propTypes2.default.object,
  isParticipantInFlight: _propTypes2.default.bool,
  mainActionsBound: _propTypes2.default.object,
  charityId: _propTypes2.default.string
};
LoginPage.defaultProps = {
  push: _reactRouter.browserHistory && _reactRouter.browserHistory.push,
  location: _locationUtils2.default.locationStub,
  charityId: ''
};


var trackClick = function trackClick(state, _ref2) {
  var pageSection = _ref2.pageSection,
      eventValue = _ref2.eventValue;

  var location = state.routing.locationBeforeTransitions;
  var participantEmail = (0, _apiSelectors.getParticipantEmail)(state);
  var eventId = (0, _apiSelectors.getEventId)(state);
  var charityId = Number(location.query.charityId);
  _analytics2.default.track({
    page_type: 'custom project page',
    event: 'link click',
    subtype: 'button',
    event_value: eventValue,
    page_section: pageSection,
    activity_id: eventId,
    activity_type: 'event_id',
    content_id: charityId,
    content_type: 'charity_id',
    charity_id: charityId,
    email: participantEmail,
    actor_id: location.query.guid,
    actor_sources: 'participant guid'
  });
};

var trackPageView = function trackPageView(state, eventValue, extras) {
  var location = state.routing.locationBeforeTransitions;
  var participantEmail = (0, _apiSelectors.getParticipantEmail)(state);
  var eventId = (0, _apiSelectors.getEventId)(state);
  var charityId = Number(location.query.charityId);
  _analytics2.default.track(_extends({
    page_type: 'custom project page',
    event: 'page view',
    subtype: 'match my miles',
    event_value: eventValue,
    activity_id: eventId,
    activity_type: 'event_id',
    content_id: charityId,
    content_type: 'charity_id',
    charity_id: charityId,
    email: participantEmail,
    actor_id: location.query.guid,
    actor_sources: 'participant guid'
  }, extras));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    participantEmail: (0, _apiSelectors.getParticipantEmail)(state),
    eventId: (0, _apiSelectors.getEventId)(state),
    facebookLoginStatus: state.facebookStore.get('facebookLoginStatus').toJS(),
    hostAppProps: {
      emailAddress: (0, _apiSelectors.getParticipantEmail)(state),
      firstName: (0, _apiSelectors.getParticipantFirstName)(state),
      lastName: (0, _apiSelectors.getParticipantLastName)(state),
      fbLoginScope: 'email user_friends',
      onLoginWithFacebookClicked: function onLoginWithFacebookClicked() {
        trackClick(state, {
          pageSection: 'match my miles > log in',
          eventValue: 'continue with facebook'
        });
      },
      onLoginWithEmailClicked: function onLoginWithEmailClicked() {
        trackClick(state, {
          pageSection: 'match my miles > log in',
          eventValue: 'continue'
        });
      },
      onRegisterPageSubmitClicked: function onRegisterPageSubmitClicked() {
        trackClick(state, {
          pageSection: 'match my miles > log in > about you',
          eventValue: 'continue'
        });

        _tools2.default.scrollToTop();
      },
      onEmailPageMount: function onEmailPageMount() {
        state.mainStore.get('participantPromise').then(function () {
          trackPageView(state, 'log in');
        });
      },
      onPasswordPageMount: function onPasswordPageMount() {
        state.mainStore.get('participantPromise').then(function () {
          trackPageView(state, 'about you', {
            page_section: 'match my miles > log in > about you'
          });
        });
      },
      onRegisterPageMount: function onRegisterPageMount() {
        state.mainStore.get('participantPromise').then(function () {
          trackPageView(state, 'about you', {
            page_section: 'match my miles > log in > about you'
          });
        });
      }
    },
    isParticipantInFlight: (0, _httpSelectors.isRequestInFlight)(_resources2.default.participant.requestName)(state),
    charityId: (0, _apiSelectors.getCharityId)(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
  return {
    mainActionsBound: (0, _redux.bindActionCreators)(_mainActions2.default, dispatch)
  };
})(LoginPage);

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SummaryPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(20);

var _Header = __webpack_require__(109);

var _Header2 = _interopRequireDefault(_Header);

var _components = __webpack_require__(24);

var _facebookWhite = __webpack_require__(325);

var _facebookWhite2 = _interopRequireDefault(_facebookWhite);

var _apiSelectors = __webpack_require__(94);

var _httpSelectors = __webpack_require__(136);

__webpack_require__(857);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SummaryPage = exports.SummaryPage = function (_React$Component) {
  _inherits(SummaryPage, _React$Component);

  function SummaryPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SummaryPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SummaryPage.__proto__ || Object.getPrototypeOf(SummaryPage)).call.apply(_ref, [this].concat(args))), _this), _this.share = function (event) {
      event.preventDefault();

      var participantPageUrl = _this.props.participantPageUrl;


      window.FB.ui({
        method: 'share',
        href: participantPageUrl
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SummaryPage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          participantFirstName = _props.participantFirstName,
          participantPageUrl = _props.participantPageUrl,
          participantPageName = _props.participantPageName,
          participantCallIsInFlight = _props.participantCallIsInFlight;


      return _react2.default.createElement(
        'div',
        { className: 'summary-page' },
        _react2.default.createElement(_Header2.default, { step: '4' }),
        _react2.default.createElement(
          'div',
          { className: 'summary-page__body container' },
          participantCallIsInFlight ? _react2.default.createElement(_components.Loading, { size: 'large' }) : _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement('img', { src: '/src/assets/png/match-miles.png', className: 'summary-page__main-image', alt: '' }),
            _react2.default.createElement(
              'p',
              { className: 'summary-page__running' },
              'You\u2019re off and running, ',
              participantFirstName,
              '!'
            ),
            _react2.default.createElement(
              'p',
              { className: 'summary-page__share-more' },
              'Remember the more you share, the more people will match your miles'
            ),
            participantPageUrl && _react2.default.createElement(
              'div',
              { className: 'summary-page__share-btn__wrapper' },
              _react2.default.createElement(
                'a',
                { href: '', className: 'summary-page__share-btn', onClick: this.share },
                _react2.default.createElement(_components.Svg, { markup: _facebookWhite2.default, alt: 'Facebook Icon' }),
                'Share to Facebook'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'summary-page__fundraising-page' },
              _react2.default.createElement(
                'p',
                null,
                'See your MATCHmyMILES page'
              ),
              participantPageUrl ? _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'a',
                  { href: participantPageUrl },
                  participantPageName
                )
              ) : _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'a',
                  { href: 'https://profile.justgiving.com/#/Fundraising' },
                  'profile.justgiving.com'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return SummaryPage;
}(_react2.default.Component);

SummaryPage.propTypes = {
  participantFirstName: _propTypes2.default.string,
  participantPageUrl: _propTypes2.default.string,
  participantPageName: _propTypes2.default.string,
  participantCallIsInFlight: _propTypes2.default.bool
};
SummaryPage.defaultProps = {
  participantFirstName: '',
  participantPageUrl: '',
  participantPageName: '',
  participantCallIsInFlight: true
};
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    participantCallIsInFlight: (0, _httpSelectors.isRequestInFlight)('participant')(state),
    participantFirstName: (0, _apiSelectors.getParticipantFirstName)(state),
    participantPageUrl: (0, _apiSelectors.getParticipantPageUrl)(state),
    participantPageName: (0, _apiSelectors.getParticipantPageName)(state)
  };
})(SummaryPage);

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.charitySearchSchema = exports.participantSchema = exports.charitiesSchema = exports.initialState = undefined;

var _handleActions;

var _reduxActions = __webpack_require__(107);

var _immutable = __webpack_require__(44);

var _immutable2 = _interopRequireDefault(_immutable);

var _apiActions = __webpack_require__(92);

var _normalizr = __webpack_require__(267);

var _config = __webpack_require__(31);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = exports.initialState = _immutable2.default.fromJS({});

var charitiesSchema = exports.charitiesSchema = new _normalizr.schema.Entity('charities', {}, {
  idAttribute: 'charityId'
});

var participantSchema = exports.participantSchema = {
  participant: {
    charities: [charitiesSchema]
  }
};
var charitySearchSchema = exports.charitySearchSchema = {
  charities: [charitiesSchema]
};

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _apiActions.types.GET_PARTICIPANT_SUCCESS, function (state, action) {
  var newState = state;

  if (action.response) {
    var normalizedParticipant = (0, _normalizr.normalize)({ participant: action.response }, participantSchema);
    newState = newState.mergeDeep({ normalized: normalizedParticipant });
  }

  return newState;
}), _defineProperty(_handleActions, _apiActions.types.CHARITY_SEARCH_SUCCESS, function (state, action) {
  var newState = state;

  if (action.response) {
    var normalizedCharities = (0, _normalizr.normalize)({ charities: action.response.charities }, charitySearchSchema);
    newState = newState.setIn(['normalized', 'result', 'charities'], _immutable2.default.List());
    newState = newState.mergeDeep({ normalized: normalizedCharities });
  }

  return newState;
}), _defineProperty(_handleActions, _apiActions.types.CREATE_FUNDRAISING_PAGE_SUCCESS, function (state, action) {
  var newState = state;

  if (action.response) {
    var participant = newState.getIn(['normalized', 'result', 'participant']);
    newState = newState.setIn(['normalized', 'result', 'participant'], participant.merge(action.response));
  }

  return newState;
}), _defineProperty(_handleActions, _apiActions.types.CREATE_DONATION_PAGE_SUCCESS, function (state, action) {
  var newState = state;

  if (action.response && action.response.headers) {
    var encodedLocation = new Buffer(action.response.headers.location).toString('base64');

    newState = newState.setIn(['normalized', 'result', 'participant', 'donationLocation'], _config2.default.DONATE_URI + '/?uri=' + encodedLocation);
  }

  return newState;
}), _defineProperty(_handleActions, _apiActions.types.ADD_CHARITY_ENTITY, function (state, action) {
  return state.setIn(['normalized', 'entities', 'charities', action.charityId], _immutable2.default.fromJS(action.entity));
}), _handleActions), initialState);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(589).Buffer))

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleFriendSelection = exports.initialState = undefined;

var _handleActions;

var _reduxActions = __webpack_require__(107);

var _immutable = __webpack_require__(44);

var _immutable2 = _interopRequireDefault(_immutable);

var _facebookInviteFriendsActions = __webpack_require__(209);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = exports.initialState = _immutable2.default.fromJS({
  friendsFilterText: '',
  selectedFriends: [],
  fbFriendsData: [],
  fbFriendsLoaded: false
});

var toggleFriendSelection = exports.toggleFriendSelection = function toggleFriendSelection(state, action) {
  var newState = void 0;

  var selectedFriends = state.get('selectedFriends');
  var indexOfSelectedFriend = selectedFriends.indexOf(action.id);

  if (indexOfSelectedFriend > -1) {
    newState = state.set('selectedFriends', selectedFriends.delete(indexOfSelectedFriend));
  } else {
    newState = state.set('selectedFriends', selectedFriends.push(action.id));
  }

  return newState;
};

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _facebookInviteFriendsActions.types.UPDATE_AUTH_RESPONSE, function (state, action) {
  return state.merge({ fbAuthResponse: action.fbAuthResponse });
}), _defineProperty(_handleActions, _facebookInviteFriendsActions.types.UPDATE_FRIENDS_LIST, function (state, action) {
  return state.merge({ fbFriendsData: action.fbFriendsData }).merge({ fbFriendsLoaded: true });
}), _defineProperty(_handleActions, _facebookInviteFriendsActions.types.TOGGLE_FRIEND_SELECTION, toggleFriendSelection), _defineProperty(_handleActions, _facebookInviteFriendsActions.types.REMOVE_FRIEND_SELECTION, function (state, action) {
  var selectedFriends = state.get('selectedFriends');
  var indexOfSelectedFriend = selectedFriends.indexOf(action.id);
  return state.set('selectedFriends', selectedFriends.delete(indexOfSelectedFriend));
}), _defineProperty(_handleActions, _facebookInviteFriendsActions.types.FILTER_FRIENDS, function (state, action) {
  return state.merge({ friendsFilterText: action.friendsFilterText });
}), _handleActions), initialState);

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = undefined;

var _handleActions;

var _reduxActions = __webpack_require__(107);

var _immutable = __webpack_require__(44);

var _immutable2 = _interopRequireDefault(_immutable);

var _facebookActions = __webpack_require__(322);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = exports.initialState = _immutable2.default.fromJS({
  facebookLoginStatus: {}
});

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _facebookActions.types.FACEBOOK_INITIALISE, function (state) {
  return state.merge({ fbInitialised: true });
}), _defineProperty(_handleActions, _facebookActions.types.UPDATE_FACEBOOK_LOGIN_STATUS, function (state, action) {
  return state.merge({ facebookLoginStatus: action.facebookLoginStatus });
}), _handleActions), initialState);

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleActions;

var _reduxActions = __webpack_require__(107);

var _immutable = __webpack_require__(44);

var _immutable2 = _interopRequireDefault(_immutable);

var _httpActions = __webpack_require__(135);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _httpActions.types.REQUEST_MADE, function (state, action) {
  return state.setIn([action.requestName, 'isInFlight'], true);
}), _defineProperty(_handleActions, _httpActions.types.REQUEST_SUCCESS, function (state, action) {
  return state.setIn([action.requestName, 'isInFlight'], false).setIn([action.requestName, 'isError'], false).setIn([action.requestName, 'retries'], 0);
}), _defineProperty(_handleActions, _httpActions.types.REQUEST_ERROR, function (state, action) {
  return state.setIn([action.requestName, 'isError'], true).setIn([action.requestName, 'isInFlight'], false);
}), _defineProperty(_handleActions, _httpActions.types.REQUEST_RETRY, function (state, action) {
  var retries = state.getIn([action.requestName, 'retries'], 0);
  return state.setIn([action.requestName, 'retries'], retries + 1);
}), _handleActions), _immutable2.default.Map());

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = undefined;

var _handleActions;

var _reduxActions = __webpack_require__(107);

var _immutable = __webpack_require__(44);

var _immutable2 = _interopRequireDefault(_immutable);

var _mainActions = __webpack_require__(93);

var _apiActions = __webpack_require__(92);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = exports.initialState = _immutable2.default.fromJS({
  queryText: '',
  isLoading: false,
  isUserLoggedIn: false,
  authAccessToken: null,
  authRefreshToken: null
});

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _mainActions.types.START_LOADING, function (state) {
  return state.merge({ isLoading: true });
}), _defineProperty(_handleActions, _mainActions.types.STOP_LOADING, function (state) {
  return state.merge({ isLoading: false });
}), _defineProperty(_handleActions, _mainActions.types.SET_CHARITY, function (state, action) {
  return state.merge({ charityId: action.charityId });
}), _defineProperty(_handleActions, _mainActions.types.RESET_CHARITY_SELECTION, function (state) {
  return state.merge({ charityId: null });
}), _defineProperty(_handleActions, _mainActions.types.UPDATE_QUERY_TEXT, function (state, action) {
  return state.merge({ queryText: action.queryText });
}), _defineProperty(_handleActions, _mainActions.types.CLEAR_QUERY_TEXT, function (state) {
  return state.merge({ queryText: '' });
}), _defineProperty(_handleActions, _mainActions.types.UPDATE_IS_USER_LOGGED_IN, function (state, action) {
  return state.set('isUserLoggedIn', action.isUserLoggedIn);
}), _defineProperty(_handleActions, _apiActions.types.GET_PARTICIPANT_SUCCESS, function (state, action) {
  var newState = state;

  if (action.response && action.response.charitySearchEnabled === false && action.response.charities && action.response.charities.length === 1) {
    newState = newState.merge({ charityId: String(action.response.charities[0].charityId) });
  }

  return newState;
}), _defineProperty(_handleActions, _mainActions.types.UPDATE_AUTH_ACCESS_TOKEN, function (state, action) {
  return state.set('authAccessToken', action.accessToken);
}), _defineProperty(_handleActions, _mainActions.types.UPDATE_AUTH_REFRESH_TOKEN, function (state, action) {
  return state.set('authRefreshToken', action.refreshToken);
}), _defineProperty(_handleActions, _mainActions.types.PARTICIPANT_PROMISE, function (state, action) {
  return state.set('participantPromise', action.participantPromise);
}), _defineProperty(_handleActions, _mainActions.types.PARTICIPANT_REQUEST_ERROR, function (state, action) {
  return state.set('participantRequestError', action.participantRequestError);
}), _defineProperty(_handleActions, _mainActions.types.RESET_PROCEED_TO_DONATION_CLICKED, function (state) {
  return state.set('proceedToDonationClicked', false);
}), _defineProperty(_handleActions, _mainActions.types.PROCEED_TO_DONATION_CLICKED, function (state) {
  return state.set('proceedToDonationClicked', true);
}), _handleActions), initialState);

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(18);

var _promiseRetry = __webpack_require__(268);

var _promiseRetry2 = _interopRequireDefault(_promiseRetry);

var _EmailPage = __webpack_require__(213);

var _EmailPage2 = _interopRequireDefault(_EmailPage);

var _PasswordPage = __webpack_require__(214);

var _PasswordPage2 = _interopRequireDefault(_PasswordPage);

var _RegisterPage = __webpack_require__(215);

var _RegisterPage2 = _interopRequireDefault(_RegisterPage);

var _App = __webpack_require__(829);

var _App2 = _interopRequireDefault(_App);

var _Landing = __webpack_require__(833);

var _Landing2 = _interopRequireDefault(_Landing);

var _CharitySearch = __webpack_require__(830);

var _CharitySearch2 = _interopRequireDefault(_CharitySearch);

var _InviteFriends = __webpack_require__(832);

var _InviteFriends2 = _interopRequireDefault(_InviteFriends);

var _SummaryPage = __webpack_require__(835);

var _SummaryPage2 = _interopRequireDefault(_SummaryPage);

var _apiActions = __webpack_require__(92);

var _apiActions2 = _interopRequireDefault(_apiActions);

var _mainActions = __webpack_require__(93);

var _mainActions2 = _interopRequireDefault(_mainActions);

var _Login = __webpack_require__(834);

var _Login2 = _interopRequireDefault(_Login);

var _ErrorPage = __webpack_require__(831);

var _ErrorPage2 = _interopRequireDefault(_ErrorPage);

var _config = __webpack_require__(31);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createRoutes = function createRoutes(store) {
  var handleRootOnEnter = function handleRootOnEnter(nextState) {
    var query = nextState.location.query;
    var participantPromise = (0, _promiseRetry2.default)(function (retry) {
      return store.dispatch(_apiActions2.default.getParticipant(query.guid)).catch(retry);
    }, {
      retries: 2,
      factor: 1,
      minTimeout: 2000,
      maxTimeout: 3000
    }).catch(function () {
      store.dispatch(_mainActions2.default.updateParticipantRequestError(true));
    });
    store.dispatch(_mainActions2.default.saveParticipantPromise(participantPromise));
    if (query.charityId) {
      store.dispatch(_mainActions2.default.setCharity(query.charityId));
    }
  };

  return _react2.default.createElement(
    _reactRouter.Route,
    { path: _config2.default.ROOT_PATH || '/', component: _App2.default, onEnter: handleRootOnEnter },
    _react2.default.createElement(_reactRouter.IndexRoute, { component: _Landing2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: 'charity-search', component: _CharitySearch2.default }),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'login', component: _Login2.default },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _EmailPage2.default }),
      _react2.default.createElement(_reactRouter.Route, { path: 'email', component: _EmailPage2.default }),
      _react2.default.createElement(_reactRouter.Route, { path: 'password', component: _PasswordPage2.default }),
      _react2.default.createElement(_reactRouter.Route, { path: 'register', component: _RegisterPage2.default })
    ),
    _react2.default.createElement(_reactRouter.Route, { path: 'invite-friends', component: _InviteFriends2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: 'summary', component: _SummaryPage2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: '*', component: _ErrorPage2.default })
  );
};

exports.default = createRoutes;

/***/ }),
/* 842 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 843 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 844 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 845 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 846 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 847 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 848 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 849 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 850 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 851 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 852 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 853 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 854 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 855 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 856 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 857 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 858 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 23.08C5.9 23.08.92 18.08.92 12 .92 5.9 5.92.92 12 .92c6.1 0 11.08 5 11.08 11.08 0 6.1-5 11.08-11.08 11.08zm0-20.22c-4.98 0-9.14 4.06-9.14 9.14 0 5.08 4.06 9.14 9.14 9.14 4.98 0 9.14-4.06 9.14-9.14 0-5.08-4.16-9.14-9.14-9.14z\"></path><path d=\"M12.46 7.66h-.83v-1.2h.83v1.2zm0 9.6h-.83V10.9h.83v6.36z\"></path><path d=\"M12.46 17.9h-.83c-.37 0-.65-.27-.65-.64V10.9c0-.38.28-.65.65-.65h.83c.37 0 .65.27.65.64v6.36c0 .37-.27.65-.64.65z\"></path><ellipse cx=\"12\" cy=\"7.11\" rx=\"1.2\" ry=\"1.2\"></ellipse></svg>"

/***/ }),
/* 859 */
/***/ (function(module, exports) {

module.exports = "<svg class=\"jg-loading__container\" viewBox=\"0 0 48 48\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"jg-loading__circle\" cx=\"24\" cy=\"24\" r=\"20\"></circle></svg>"

/***/ }),
/* 860 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"#15cc5e\" d=\"M7.625,19.925 L2.225,14.525 C1.925,14.225 1.925,13.925 2.225,13.725 L3.525,12.425 C3.825,12.125 4.125,12.125 4.325,12.425 L7.825,15.925 C7.925,16.025 8.125,16.025 8.325,15.925 L20.025,4.225 C20.325,3.925 20.625,3.925 20.825,4.225 L22.125,5.525 C22.425,5.825 22.425,6.125 22.125,6.325 L8.425,20.025 C8.225,20.125 7.925,20.125 7.625,19.925 L7.625,19.925 Z\"></path></svg>"

/***/ }),
/* 861 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"-534 383 211 36\" enable-background=\"new -534 383 211 36\" xml:space=\"preserve\"><title>justgiving_logo</title><desc>Created with Sketch.</desc><g id=\"Base-Template\" sketch:type=\"MSPage\"><g id=\"Events-by-Charity\" transform=\"translate(-169.000000, -796.000000)\" sketch:type=\"MSArtboardGroup\"><g id=\"Footer\" transform=\"translate(23.000000, -118.000000)\" sketch:type=\"MSLayerGroup\"></g><g id=\"CTA\" transform=\"translate(23.000000, 715.000000)\" sketch:type=\"MSLayerGroup\"></g><path id=\"justgiving_logo\" sketch:type=\"MSShapeGroup\" fill=\"#AC29B5\" d=\"M-284.2,1193.8c0,8.1,6.6,14.8,14.8,14.8 c8.2,0,14.8-6.6,14.8-14.8c0-1.1-0.1-2.2-0.4-3.2h-10.4l-6.1,6h8.3c-1.1,2.4-3.5,4.1-6.4,4.1c-3.8,0-7-3.1-7-6.9 c0-3.8,3.1-6.9,7-6.9c1.4,0,2.7,0.4,3.8,1.1l5.6-5.6c-2.6-2.1-5.8-3.3-9.4-3.3h0C-277.5,1179-284.2,1185.6-284.2,1193.8z M-252.5,1185.9h7.3v22.1h-7.3V1185.9z M-252.5,1179.5h7.3v4.4h-7.3V1179.5z M-228.7,1208.1l8.7-22.2h-7.7l-4.2,12.3l-4.1-12.3 h-7.8l8.7,22.1l0.1,0.2H-228.7z M-218.6,1185.9h7.3v22.1h-7.3V1185.9z M-218.6,1179.5h7.3v4.4h-7.3V1179.5z M-188.5,1207.9v-14.1 c0-5.2-3-8.4-7.8-8.4c-2.2,0-4,0.8-5.6,2.4l-2-2h-5.1v22.1h7.3v-12.2c0-1.6,0.5-3.5,3-3.5c1.9,0,2.8,1.2,2.8,3.5v12.2H-188.5z M-355.2,1208.3c6.6,0,10.3-3.8,10.3-10.4v-18.3h-7.6v18.1c0,2.5-0.9,3.7-2.9,3.7c-1.5,0-2.8-0.7-4.4-2.5l-0.3-0.3l-5,4.9l0.4,0.5 C-362.2,1206.9-359.1,1208.3-355.2,1208.3z M-175.8,1208.6c-1.9,0-3.6-0.3-5.3-1.1l-4.8,4.8l0.7,0.4c2.8,1.5,6.1,2.2,9.5,2.2 c8.4,0,12.4-4.3,12.4-12.2v-16.8h-5.3l-1.9,1.9c-1.8-1.5-3.7-2.3-6.2-2.3c-5,0-10,3.6-10,10.4v0.1c0,6.8,5,10.4,10,10.4 c2.4,0,4.2-0.7,5.9-2.1C-171.1,1206.9-172.7,1208.6-175.8,1208.6z M-175,1200.4c-2.7,0-4.7-1.8-4.7-4.4v-0.1c0-2.6,2-4.4,4.7-4.4 c2.7,0,4.7,1.8,4.7,4.4v0.1C-170.3,1198.5-172.3,1200.4-175,1200.4z M-342.5,1185.9v14.1c0,5.2,3,8.4,7.8,8.4c2.2,0,4-0.8,5.6-2.4 l2,2h5.1v-22.1h-7.3v12.2c0,1.6-0.5,3.5-2.9,3.5c-1.9,0-2.8-1.2-2.8-3.5v-12.2H-342.5z M-286.3,1192.3v-6.4h-4.9v-6.3h-7.3v6.3 h-2.5v6.4h2.5v9c0,4.7,2.2,6.9,6.8,6.9c1.9,0,3.5-0.4,5-1.3l0.4-0.2v-6.3l-1.1,0.6c-0.8,0.4-1.7,0.7-2.6,0.7 c-0.9,0-1.2-0.3-1.2-1.3v-8.1H-286.3z M-310.5,1202.9c-1.8,0-3.9-0.8-5.9-2.1l-4,4l-0.1,0.1l0.4,0.3c2.7,2.1,6.1,3.3,9.5,3.3 c5.4,0,8.7-2.7,8.7-7.3v-0.1c0-4.5-4.4-6-6.8-6.8l-0.7-0.2c-1.7-0.6-3.3-1.1-3.3-1.8v-0.1c0-0.7,0.9-1,1.7-1 c1.2,0,2.8,0.5,4.5,1.4l4.2-4.2l-0.3-0.2c-2.4-1.6-5.5-2.6-8.2-2.6c-5,0-8.3,2.9-8.3,7.3v0.1c0,4.3,3.4,5.9,6.7,6.8 c0.3,0.1,0.6,0.2,0.8,0.2c1.8,0.5,3.3,1,3.3,1.7v0.1C-308.5,1202.7-309.6,1202.9-310.5,1202.9z M-161.8,1186.9h1v2.5h1.2v-2.5h1 v-1h-3.3V1186.9z M-155.4,1185.9l-0.8,1.2l-0.8-1.2h-1.2v3.5h1.2v-1.8l0.5,0.8h0.6l0.5-0.8v1.8h1.2v-3.5H-155.4z\"></path></g></g></svg>"

/***/ }),
/* 862 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 288 53.2\" enable-background=\"new 0 0 288 53.2\" xml:space=\"preserve\"><g><g><defs><ellipse id=\"SVGID_25_\" cx=\"470.2\" cy=\"-202\" rx=\"22\" ry=\"22.5\"></ellipse></defs><clipPath id=\"SVGID_2_\"><use xlink:href=\"#SVGID_25_\" overflow=\"visible\"></use></clipPath><g clip-path=\"url(#SVGID_2_)\"><defs><rect id=\"SVGID_27_\" x=\"-138.2\" y=\"-413.6\" width=\"1370.4\" height=\"2648.6\"></rect></defs><clipPath id=\"SVGID_4_\"><use xlink:href=\"#SVGID_27_\" overflow=\"visible\"></use></clipPath></g></g><g><defs><path id=\"SVGID_31_\" d=\"M470.2-180c11.9,0,21.5-9.8,21.5-22c0-12.1-9.6-22-21.5-22s-21.5,9.8-21.5,22 C448.7-189.9,458.3-180,470.2-180z M436.6-236.1h67.2v68.1h-67.2V-236.1z\"></path></defs><clipPath id=\"SVGID_6_\"><use xlink:href=\"#SVGID_31_\" overflow=\"visible\"></use></clipPath><g clip-path=\"url(#SVGID_6_)\"><defs><rect id=\"SVGID_33_\" x=\"-138.2\" y=\"-413.6\" width=\"1370.4\" height=\"2648.6\"></rect></defs><clipPath id=\"SVGID_8_\"><use xlink:href=\"#SVGID_33_\" overflow=\"visible\"></use></clipPath></g></g><g><defs><ellipse id=\"SVGID_57_\" cx=\"470.2\" cy=\"-202\" rx=\"22\" ry=\"22.5\"></ellipse></defs><clipPath id=\"SVGID_10_\"><use xlink:href=\"#SVGID_57_\" overflow=\"visible\"></use></clipPath><g clip-path=\"url(#SVGID_10_)\"><defs><rect id=\"SVGID_59_\" x=\"-138.2\" y=\"-413.6\" width=\"1370.4\" height=\"2648.6\"></rect></defs><clipPath id=\"SVGID_12_\"><use xlink:href=\"#SVGID_59_\" overflow=\"visible\"></use></clipPath></g></g><g><g><defs><rect id=\"SVGID_63_\" x=\"-138.2\" y=\"-413.6\" width=\"1370.4\" height=\"2648.6\"></rect></defs><clipPath id=\"SVGID_14_\"><use xlink:href=\"#SVGID_63_\" overflow=\"visible\"></use></clipPath></g></g></g><g><path d=\"M150.8,10.6C151,10.5,150.9,10.5,150.8,10.6L150.8,10.6z\"></path><polygon fill=\"none\" points=\"39.8,16 45.1,16 42.5,9.4 \"></polygon><polygon fill=\"#EE1C25\" points=\"15.5,11 9.9,1.9 3,1.9 3,25.3 9.4,25.3 9.4,11.9 15.3,21 15.5,21 21.5,11.9 21.5,25.3 27.9,25.3 27.9,1.9 21.1,1.9 \"></polygon><path fill=\"#EE1C25\" d=\"M39.4,1.7l-10,23.6h6.8l1.7-4.2H47l1.7,4.2h7l-10-23.6H39.4z M39.8,16l2.6-6.6l2.6,6.6H39.8z\"></path><polygon fill=\"#EE1C25\" points=\"52.8,7.6 59.8,7.6 59.8,25.3 66.3,25.3 66.3,7.6 73.3,7.6 73.3,1.9 52.8,1.9 \"></polygon><path fill=\"#EE1C25\" d=\"M85.8,19.9c-3.3,0-5.6-2.7-5.6-6.3v-0.1c0-3.4,2.3-6.2,5.6-6.2c2.2,0,3.8,1.1,5.1,2.7l4.9-3.8 c-2.1-2.8-5.2-4.9-10-4.9c-7.1,0-12.3,5.4-12.3,12.2v0.1c0,7,5.4,12.1,12.1,12.1c5.2,0,8.1-2.2,10.4-5.3L91.1,17 C89.7,18.7,88.3,19.9,85.8,19.9z\"></path><polygon fill=\"#EE1C25\" points=\"112.8,10.6 104.5,10.6 104.5,1.9 98,1.9 98,25.3 104.5,25.3 104.5,16.4 112.8,16.4 112.8,25.3 119.3,25.3 119.3,1.9 112.8,1.9 \"></polygon><polygon fill=\"#EE1C25\" points=\"199.4,11 193.8,1.9 187,1.9 187,25.3 193.3,25.3 193.3,11.9 199.3,21 199.4,21 205.4,11.9 205.4,25.3 211.9,25.3 211.9,1.9 205,1.9 \"></polygon><rect x=\"215.4\" y=\"1.9\" fill=\"#EE1C25\" width=\"6.5\" height=\"23.5\"></rect><polygon fill=\"#EE1C25\" points=\"231.8,1.9 225.3,1.9 225.3,25.3 243.2,25.3 243.2,19.6 231.8,19.6 \"></polygon><polygon fill=\"#EE1C25\" points=\"251.6,16.1 262.9,16.1 262.9,11 251.6,11 251.6,7.4 264,7.4 264,1.9 245.2,1.9 245.2,25.3 264.2,25.3 264.2,19.8 251.6,19.8 \"></polygon><path fill=\"#EE1C25\" d=\"M276.7,10.7c-3.3-0.7-4.1-1.2-4.1-2.3V8.4c0-0.9,0.8-1.5,2.3-1.5c2.1,0,4.4,0.8,6.6,2.3l3.3-4.6 c-2.5-2-5.7-3.1-9.7-3.1c-5.6,0-9.1,3.2-9.1,7.5V9c0,4.8,3.9,6.2,8.8,7.3c3.2,0.8,4,1.3,4,2.3v0.1c0,1-0.9,1.6-2.7,1.6 c-2.7,0-5.3-1-7.6-2.8l-3.6,4.3c2.9,2.6,6.8,3.9,11,3.9c5.7,0,9.5-2.8,9.5-7.6V18C285.4,13.6,282.1,11.9,276.7,10.7z\"></path><path d=\"M131.1,23.8c0.9-3.6,2-7.1,3.3-10.6c0.6-1.6,1.2-3.3,1.9-4.9c0.3-0.8,0.7-1.6,1-2.3c0.1-0.1,0.1-0.2,0.2-0.4 c0.1,0.2,0.1,0.3,0.2,0.4c0.2,0.7,0.3,1.5,0.4,2.2c0.3,1.9,0.5,3.8,0.7,5.7c0.5,3.9,1,7.9,1.5,11.8c0.2,1.6,3.3,0.9,3.7-0.3 c1.2-3.7,2.4-7.5,4.2-11c0.4-0.9,0.9-1.7,1.5-2.5c0.2-0.3,0.5-0.6,0.8-0.9c0.2,0.3,0.5,0.6,0.6,0.8c1.1,2.1,1.7,4.5,2.3,6.7 c0.5,2.2,1,4.5,1.2,6.8c0.1,2,4,1.5,3.8-0.3c-0.2-3-0.8-6-1.6-8.9c-0.7-2.4-1.4-5.5-3.2-7.4c-2.5-2.7-5.8,0.2-7.4,2.4 c-1.2,1.8-2.2,3.8-3,5.8c-0.3-2.3-0.6-4.7-0.9-7c-0.3-2.7-0.3-8.8-4.4-8.3c-1.8,0.2-2.9,1.6-3.7,3.1c-1.1,2-1.9,4.1-2.7,6.2 c-0.3,0.7-0.6,1.5-0.8,2.2c-0.3-3.9-0.6-7.8-0.6-11.7c0-2-3.8-1.5-3.8,0.3c0,7.4,1.1,14.8,1.1,22.2 C127.2,26.2,130.7,25.4,131.1,23.8z M150.8,10.6C150.9,10.5,151,10.5,150.8,10.6L150.8,10.6z\"></path><path d=\"M175.9,1.6c-0.2,0.9-0.5,1.9-0.7,2.8c-0.7,2.5-1.4,4.9-2.5,7.2c-1.3,2.9-3,6.1-5.8,7.9c-0.9,0.5-2.2,1-3.1,0.2 c-1.1-1.1-0.6-3.8-0.6-5.2c0-4.1,0-8.1,0-12.2c0-1.1-3.8-0.4-3.8,1c0,5.1-0.3,10.2,0,15.3c0.3,4.1,4.8,4.1,7.8,3 c2.3-0.9,4.1-2.3,5.7-4.2c-0.4,4.4-0.9,8.8-1.9,13.1c-1.3,5.1-3.7,10.3-7.4,14.1c-2.2,2.3-5.2,3.2-8.3,3.7c-2.5,0.5-5,0.7-7.5,0.3 c-7-1-12.2-5.9-15.5-12c-0.7-1.3-4.3,0-3.8,1c3.1,5.9,7.9,10.6,14.4,12.5c5.7,1.6,12.3,0.7,17.8-1.3c5.9-2.2,9.8-7.7,12.2-13.4 c2.7-6.4,3.2-13.6,3.9-20.5c0.4-4.4,1.5-8.6,2.5-12.9c0.1-0.3,0.1-0.6,0.2-0.8C180-0.3,176.2,0.3,175.9,1.6z\"></path></g></svg>"

/***/ }),
/* 863 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 875 159.3\" enable-background=\"new 0 0 875 159.3\" xml:space=\"preserve\"><g><g><defs><ellipse id=\"SVGID_25_\" cx=\"470.2\" cy=\"280.5\" rx=\"22\" ry=\"22.5\"></ellipse></defs><clipPath id=\"SVGID_2_\"><use xlink:href=\"#SVGID_25_\" overflow=\"visible\"></use></clipPath><g clip-path=\"url(#SVGID_2_)\"><defs><rect id=\"SVGID_27_\" x=\"-138.2\" y=\"68.9\" width=\"1370.4\" height=\"2648.6\"></rect></defs><clipPath id=\"SVGID_4_\"><use xlink:href=\"#SVGID_27_\" overflow=\"visible\"></use></clipPath></g></g><g><defs><path id=\"SVGID_31_\" d=\"M470.2,302.5c11.9,0,21.5-9.8,21.5-22c0-12.1-9.6-22-21.5-22s-21.5,9.8-21.5,22 C448.7,292.6,458.3,302.5,470.2,302.5z M436.6,246.5h67.2v68.1h-67.2V246.5z\"></path></defs><clipPath id=\"SVGID_6_\"><use xlink:href=\"#SVGID_31_\" overflow=\"visible\"></use></clipPath><g clip-path=\"url(#SVGID_6_)\"><defs><rect id=\"SVGID_33_\" x=\"-138.2\" y=\"68.9\" width=\"1370.4\" height=\"2648.6\"></rect></defs><clipPath id=\"SVGID_8_\"><use xlink:href=\"#SVGID_33_\" overflow=\"visible\"></use></clipPath></g></g><g><defs><ellipse id=\"SVGID_57_\" cx=\"470.2\" cy=\"280.5\" rx=\"22\" ry=\"22.5\"></ellipse></defs><clipPath id=\"SVGID_10_\"><use xlink:href=\"#SVGID_57_\" overflow=\"visible\"></use></clipPath><g clip-path=\"url(#SVGID_10_)\"><defs><rect id=\"SVGID_59_\" x=\"-138.2\" y=\"68.9\" width=\"1370.4\" height=\"2648.6\"></rect></defs><clipPath id=\"SVGID_12_\"><use xlink:href=\"#SVGID_59_\" overflow=\"visible\"></use></clipPath></g></g><g><g><defs><rect id=\"SVGID_63_\" x=\"-138.2\" y=\"68.9\" width=\"1370.4\" height=\"2648.6\"></rect></defs><clipPath id=\"SVGID_14_\"><use xlink:href=\"#SVGID_63_\" overflow=\"visible\"></use></clipPath></g></g></g><g><path fill=\"#FFFFFF\" d=\"M457.3,31.6C457.6,31.5,457.6,31.3,457.3,31.6L457.3,31.6z\"></path><polygon fill=\"#FFFFFF\" points=\"42.8,32.8 25.7,5 4.6,5 4.6,76.8 24.1,76.8 24.1,35.7 42.4,63.7 42.8,63.7 61.2,35.6 61.2,76.8 81,76.8 81,5 59.9,5 \"></polygon><path fill=\"#FFFFFF\" d=\"M116,4.5L85.5,76.8h20.8l5.1-12.9h27.8l5.1,12.9h21.3L135.2,4.5H116z M117.3,48.4l8.1-20.3l8,20.3H117.3z\"></path><polygon fill=\"#FFFFFF\" points=\"157,22.4 178.5,22.4 178.5,76.8 198.4,76.8 198.4,22.4 219.9,22.4 219.9,5 157,5 \"></polygon><path fill=\"#FFFFFF\" d=\"M258.2,60.1c-10.1,0-17.1-8.4-17.1-19.2v-0.2c0-10.5,7.1-19.1,17.1-19.1c6.9,0,11.6,3.4,15.7,8.4l15-11.6 c-6.4-8.7-15.8-14.9-30.5-14.9c-21.8,0-37.8,16.4-37.8,37.4v0.2c0,21.4,16.5,37.2,37,37.2c15.8,0,24.9-6.9,31.7-16.2l-15-10.7 C270.1,56.6,265.7,60.1,258.2,60.1z\"></path><polygon fill=\"#FFFFFF\" points=\"340.9,31.9 315.4,31.9 315.4,5 295.5,5 295.5,76.8 315.4,76.8 315.4,49.5 340.9,49.5 340.9,76.8 360.9,76.8 360.9,5 340.9,5 \"></polygon><polygon fill=\"#FFFFFF\" points=\"606,32.8 588.9,5 567.9,5 567.9,76.8 587.4,76.8 587.4,35.7 605.6,63.7 606,63.7 624.4,35.6 624.4,76.8 644.2,76.8 644.2,5 623.2,5 \"></polygon><rect x=\"654.9\" y=\"5\" fill=\"#FFFFFF\" width=\"19.9\" height=\"71.8\"></rect><polygon fill=\"#FFFFFF\" points=\"705.3,5 685.4,5 685.4,76.8 740.1,76.8 740.1,59.4 705.3,59.4 \"></polygon><polygon fill=\"#FFFFFF\" points=\"765.8,48.5 800.3,48.5 800.3,32.8 765.8,32.8 765.8,21.8 803.9,21.8 803.9,5 746.1,5 746.1,76.8 804.4,76.8 804.4,59.9 765.8,59.9 \"></polygon><path fill=\"#FFFFFF\" d=\"M842.7,32.1c-10.1-2.3-12.5-3.7-12.5-7v-0.2c0-2.7,2.4-4.6,7.2-4.6c6.4,0,13.5,2.4,20.1,7.1l10-14.1 c-7.8-6.3-17.3-9.5-29.6-9.5c-17.2,0-27.8,9.6-27.8,23V27c0,14.7,11.8,19,27.1,22.5c9.9,2.4,12.2,3.9,12.2,7v0.2 c0,3.1-2.9,4.9-8.3,4.9c-8.3,0-16.1-3-23.3-8.6l-11.1,13.2c8.9,7.9,20.9,11.9,33.7,11.9c17.4,0,29-8.7,29-23.4v-0.2 C869.4,41,859.1,35.7,842.7,32.1z\"></path><path fill=\"#FFFFFF\" d=\"M396.8,72c2.9-10.9,6.3-21.7,10.2-32.4c1.8-5,3.8-10,5.9-14.9c1-2.4,2-4.8,3.1-7.1c0.2-0.4,0.4-0.8,0.6-1.1 c0.2,0.5,0.4,1,0.5,1.2c0.6,2.2,0.9,4.5,1.2,6.7c0.8,5.8,1.4,11.6,2.1,17.4c1.5,12,3,24.1,4.4,36.1c0.6,5,10.2,2.8,11.4-0.8 c3.7-11.4,7.4-23,12.9-33.8c1.3-2.6,2.7-5.2,4.5-7.6c0.7-1,1.5-1.8,2.3-2.7c0.6,0.8,1.4,1.7,1.7,2.4c3.3,6.3,5.2,13.7,6.9,20.6 c1.7,6.8,3.2,13.8,3.7,20.8c0.5,6.2,12.2,4.5,11.8-0.8c-0.7-9.2-2.5-18.3-4.9-27.2c-2-7.5-4.3-16.9-9.7-22.8 c-7.6-8.2-17.8,0.6-22.5,7.5c-3.8,5.6-6.8,11.6-9.3,17.9c-0.9-7.2-1.8-14.3-2.6-21.5c-1-8.1-1-26.9-13.6-25.3 c-5.5,0.7-8.9,4.9-11.3,9.4c-3.3,6-5.7,12.7-8.2,19.1c-0.9,2.2-1.7,4.5-2.5,6.7c-0.9-12-1.7-23.9-1.8-35.9c0-6.2-11.8-4.6-11.8,0.8 c0.1,22.7,3.2,45.3,3.3,68C385,79.4,395.5,76.9,396.8,72z M457.3,31.6C457.6,31.3,457.6,31.5,457.3,31.6L457.3,31.6z\"></path><path fill=\"#FFFFFF\" d=\"M534.1,4.1c-0.7,2.8-1.4,5.7-2.1,8.5c-2,7.5-4.4,14.9-7.5,22c-3.8,8.8-9.2,18.8-17.6,24.1 c-2.6,1.7-6.8,3.1-9.4,0.5c-3.3-3.3-2-11.6-2-15.8c0-12.5,0-24.9,0-37.4c0-3.5-11.6-1.4-11.6,3.1c0,15.5-1,31.4,0.1,46.8 c0.9,12.6,14.6,12.6,24,9.1c7-2.6,12.7-7.2,17.4-12.8c-1.3,13.5-2.7,26.9-5.9,40.1c-3.9,15.8-11.2,31.4-22.7,43.2 c-6.8,7-16,9.7-25.4,11.4c-7.6,1.4-15.3,2.2-23,1.1c-21.3-3.2-37.5-18.1-47.3-36.7c-2.1-3.9-13.3-0.1-11.6,3.1 c9.6,18,24.1,32.5,44.1,38.2c17.5,4.9,37.8,2.2,54.6-4.1c18.1-6.8,30.1-23.7,37.4-41c8.4-19.7,9.8-41.7,11.9-62.8 c1.3-13.6,4.5-26.2,7.6-39.4c0.2-0.9,0.4-1.7,0.6-2.6C546.7-1.6,535.1,0.2,534.1,4.1z\"></path></g></svg>"

/***/ }),
/* 864 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" x=\"0\" y=\"0\" viewBox=\"0 0 443.5 98.9\" enable-background=\"new 0 0 443.5 98.9\" xml:space=\"preserve\"><path d=\"M175.3 98.9c-0.2 0-0.4-0.2-0.4-0.4V9.9c0-0.2 0.2-0.4 0.4-0.4s0.4 0.2 0.4 0.4v88.6C175.7 98.7 175.6 98.9 175.3 98.9z\"></path><path fill=\"#E31C23\" d=\"M91.3 24.2c1.1-0.9 3.3-2.5 4.7-2.9 -3.8 0.2-8.2 2.9-10.7 6C86.9 25.6 89 24.5 91.3 24.2\"></path><path fill=\"#E31C23\" d=\"M82.7 50.2c-3.3 7.2-12.3 10.5-20 7.4 -7.7-3.1-11.3-11.5-8-18.7l-1 2.2c-3.3 7.2 0.3 15.6 8 18.7 7.7 3.1 16.7-0.2 20-7.4L82.7 50.2zM68.9 31.4c0.6-0.8 1.1-1.6 1.5-2.5 1.8-4 1.1-8.4-1.5-11.6 0.9 1.9 1 4.2 0.1 6.3 -0.9 2-2.6 3.4-4.5 4.1 -0.2-2.4-1.2-4.7-3.1-6.4 1.6 2.6 1.9 5.9 0.6 8.8 -0.6 1.3-1.5 2.5-2.6 3.4 -1.6 1.3-2.9 2.9-3.7 4.8 -3.2 7 0.2 15 7.6 18 7.4 3 16-0.2 19.2-7.2 1.5-3.4 1.6-7 0.3-10.1 -1.3-3.2-1.3-6.9 0.3-10.3 1.8-4 5.5-6.8 9.6-7.9 -7 1.3-13.2 5.8-16.3 12.4 -1.3 2.8-1.9 5.6-1.8 8.4 0 0.6-0.1 1.2-0.4 1.8 -1 2.2-3.7 3.2-6.1 2.3 -2.2-0.9-3.3-3.2-2.5-5.4 0.2-0.4 0.4-0.8 0.8-1.1 0.7-0.6 1.1-1.4 1.1-2.3 0-0.7-0.2-1.3-0.6-1.8 0 0-0.7-1-0.1-2.1 0 0 0.4-0.6 1.1-0.9C68 32.1 68.6 31.8 68.9 31.4\"></path><path fill=\"#E31C23\" d=\"M66.9 15.7c0.1 0.7 0.1 1.7-0.1 2.6 1.1 1 1.9 2.8 1.8 4.2C69 20.1 68.4 17.7 66.9 15.7z\"></path><path fill=\"#E31C23\" d=\"M79.9 84.4h-4.2c-1.3 0-1.7-0.5-1.3-1.5l1.6-3.5 -5.2 4.2c0 0-1.2 0.8-2.1 0.8h-1.2l2.5-6.2h3.8l-0.6 1.7 1.5-1.1c1.1-0.8 2.7-0.9 4-0.9 0.7 0 1.4 0.5 0.9 1.7L78.2 83h4.3C82.1 84.2 80.6 84.4 79.9 84.4\"></path><polygon fill=\"#E31C23\" points=\"66.7 76.6 69.2 76.6 67.9 80 66.7 80 \"></polygon><polygon fill=\"#E31C23\" points=\"82.4 76.7 85.3 76.7 82.5 79.9 80.9 79.9 \"></polygon><path fill=\"#E31C23\" d=\"M59.5 82.7l-1.9-2.4 5.6-4.3h-3.5l-5.8 4 3.4-7.4h-3.7L53 73.8l-3.9 8.6h-7.7c-1.5 0-2.2-0.5-1.8-1.7l1.1-2.6h1.7v0c0.6 0 2.1 0 1.9 0.7 0 0.1-0.1 0.2-0.1 0.3l-0.4 1.2c0.4 0.2 0.9 0.3 1.4 0.3 1.5 0 2.8-1 2.8-2.3 0-1.3-1.3-2.2-2.8-2.2h-9.7 -0.7 -8.3c-4.2 0-6.5 1.6-6.9 3.9 -0.2 0.8 0 1.5 0.4 2.2 0.1 0.2 0.3 0.3 0.4 0.5h-0.2H16l-2.5-3.7c2.4-0.8 7.2-2.5 7.2-5.1 0-3-4.1-3.4-6.6-3.4H1.9L0 73.2h12.3c1.4 0 3 0.3 3 1.7 0 1.1-1 1.9-2.4 2.5 -0.2 0.1-1.3 0.4-2.4 0.6l-1.1 2.4 1.8 2.4c0 0 0.9 1.5 2.3 1.5h4.7c0.9 0 2-0.3 2.4-1 0-0.1 0.1-0.1 0.1-0.2 1 0.8 2.8 1.4 5.3 1.4 3.6 0 6.3-1.5 6.6-4.2 0.1-0.6-0.3-1.8-1-2.2h2.6 1.5c-0.7 0.7-1.2 1.5-1.3 2.5 -0.4 2.9 3.2 3.7 5.9 3.7h8.2c0 0 0.1 0 0.1 0h1.4c1.4 0 1.9-0.4 3.1-1.2 0 0 0.4-0.3 1.1-0.7 0.6 0.9 1.5 1.9 2.4 1.9h4.9c0.8 0 2.6-0.3 3.1-1.6H59.5zM28.5 79.5L27 83.1c-4.1 0.4-2.9-1.9-2.9-1.9l1.2-3.4C29.6 77.4 28.5 79.5 28.5 79.5zM10.7 74.4H6.3l-4.4 10h4.4l2.3-5.2 0 0 0.3-0.7c0 0 0 0 0 0L10.7 74.4zM131.6 82.9l4.6-10.2h-4.4l-4.6 10.2h-4.6l4.6-10.2h-4.4l-1.6 3.7h-10.6c-4.2 0-6.5 1.6-6.9 3.9 -0.2 0.8 0 1.5 0.4 2.2 0.1 0.1 0.2 0.2 0.3 0.4h-0.1 -4.2l-2.5-3.7c2.4-0.8 7.1-2.5 7.1-5.1 0-3-4-3.4-6.5-3.4h-12l-1.9 2.5h12.2c1.4 0 3 0.3 3 1.7 0 1.1-1 1.9-2.4 2.5 -0.2 0.1-1.3 0.4-2.4 0.6l-1 2.4 1.8 2.5c0 0 0.9 1.5 2.3 1.5h4.6c0.9 0 1.9-0.3 2.3-1 0 0 0-0.1 0-0.1 1 0.9 2.8 1.4 5.4 1.4 3.7 0 6.3-1.5 6.6-4.2 0.1-0.6-0.3-1.8-1-2.2h4.5l-0.5 1.1h0l-1.6 3.5c-0.5 1.1 0.3 1.6 1.7 1.6h4.7c0.6 0 1.7-0.2 2.4-0.9 0.1 0.6 0.8 0.9 1.8 0.9h4.7c0.8 0 2.6-0.3 3.1-1.6H131.6zM112.7 79.7l-1.4 3.6c-4.1 0.4-2.9-1.9-2.9-1.9l1.2-3.4C113.7 77.6 112.7 79.7 112.7 79.7zM90.7 74.5l-4.3 10h4.3l4.4-10H90.7z\"></path><polygon points=\"19.4 96.9 19.4 92.7 19.3 92.7 17 95.2 14.8 92.7 14.7 92.7 14.7 96.9 13 96.9 13 90.3 14.6 90.3 17 93.1 19.5 90.3 21.1 90.3 21.1 96.9 \"></polygon><path d=\"M29 96.9l-0.7-1.4H25l-0.7 1.4h-1.9l3.2-6.7h2l3.3 6.7H29zM26.6 91.7L26.6 91.7l-1.2 2.7h2.4L26.6 91.7zM37 96.9l-1.2-2.3c-0.1-0.2-0.2-0.2-0.4-0.2H34v2.5h-1.8v-6.6c1-0.1 1.9-0.1 2.9-0.1 1.7 0 3.5 0.3 3.5 2 0 0.8-0.4 1.5-1.4 1.8v0c0.2 0 0.3 0.2 0.3 0.3l1.4 2.5H37zM35.2 91.3c-0.4 0-0.7 0-1.1 0.1v1.9h1.4c0.9 0 1.5-0.2 1.5-1C36.9 91.4 36.1 91.3 35.2 91.3M46 96.9l-0.7-1.4h-3.3l-0.7 1.4h-1.9l3.2-6.7h1.9l3.3 6.7H46zM43.7 91.7L43.7 91.7l-1.2 2.7h2.4L43.7 91.7z\"></path><polygon points=\"51.9 91.5 51.9 96.9 50 96.9 50 91.5 47.7 91.5 47.7 90.3 54.2 90.3 54.2 91.5 \"></polygon><polygon points=\"60.6 96.9 60.6 94.1 57.4 94.1 57.4 96.9 55.6 96.9 55.6 90.3 57.4 90.3 57.4 92.7 60.6 92.7 60.6 90.3 62.4 90.3 62.4 96.9 \"></polygon><path d=\"M68.4 97c-2.5 0-4.1-1.1-4.1-3.4 0-2.3 1.6-3.4 4.1-3.4 2.5 0 4.1 1.1 4.1 3.4C72.5 96 70.9 97 68.4 97M68.4 91.3c-1.7 0-2.2 0.8-2.2 2.3 0 1.4 0.5 2.3 2.2 2.3 1.7 0 2.2-0.8 2.2-2.3C70.6 92.2 70.1 91.3 68.4 91.3\"></path><polygon points=\"80.1 96.9 76.2 92.7 76.2 92.7 76.2 96.9 74.4 96.9 74.4 90.3 76.1 90.3 79.9 94.4 79.9 94.4 79.9 90.3 81.7 90.3 81.7 96.9 \"></polygon><path d=\"M90.6 97c-1.3 0-2.3-0.2-3.4-0.8l0.8-1c0.8 0.4 1.6 0.7 2.5 0.7 0.7 0 1.4-0.1 1.4-0.8 0-0.7-1.2-0.8-2.3-1.1 -1.1-0.3-2.2-0.8-2.2-2 0-1.4 1.6-1.9 3.1-1.9 1 0 2 0.2 2.9 0.6l-0.7 1.1c-0.6-0.3-1.4-0.5-2.1-0.5 -0.7 0-1.4 0.1-1.4 0.7 0 0.5 0.8 0.7 1.8 0.9 1.2 0.3 2.6 0.7 2.6 2.1C93.8 96.5 92.3 97 90.6 97\"></path><polygon points=\"95.5 96.9 95.5 90.3 101.2 90.3 101.2 91.5 97.4 91.5 97.4 92.9 100.9 92.9 100.9 94.1 97.4 94.1 97.4 95.7 101.3 95.7 101.3 96.9 \"></polygon><path d=\"M107.8 96.9l-1.2-2.3c-0.1-0.2-0.2-0.2-0.4-0.2h-1.4v2.5H103v-6.6c1-0.1 1.9-0.1 2.9-0.1 1.7 0 3.5 0.3 3.5 2 0 0.8-0.4 1.5-1.4 1.8v0c0.2 0 0.2 0.2 0.3 0.3l1.4 2.5H107.8zM105.9 91.3c-0.4 0-0.7 0-1.1 0.1v1.9h1.3c0.9 0 1.5-0.2 1.5-1C107.6 91.4 106.8 91.3 105.9 91.3\"></path><rect x=\"111.3\" y=\"90.3\" width=\"1.8\" height=\"6.7\"></rect><polygon points=\"115.2 96.9 115.2 90.3 120.9 90.3 120.9 91.5 117 91.5 117 92.9 120.5 92.9 120.5 94.1 117 94.1 117 95.7 121 95.7 121 96.9 \"></polygon><path d=\"M125.5 97c-1.3 0-2.3-0.2-3.4-0.8l0.8-1c0.8 0.4 1.6 0.7 2.5 0.7 0.7 0 1.4-0.1 1.4-0.8 0-0.7-1.2-0.8-2.3-1.1 -1.1-0.3-2.2-0.8-2.2-2 0-1.4 1.6-1.9 3.1-1.9 1 0 2 0.2 2.9 0.6l-0.7 1.1c-0.6-0.3-1.4-0.5-2.1-0.5 -0.7 0-1.4 0.1-1.4 0.7 0 0.5 0.8 0.7 1.8 0.9 1.2 0.3 2.6 0.7 2.6 2.1C128.6 96.5 127.2 97 125.5 97\"></path><path d=\"M131.4 89.1c0.9 0 1.7 0.8 1.7 1.7 0 0.9-0.8 1.7-1.7 1.7 -0.9 0-1.7-0.8-1.7-1.7C129.7 89.8 130.4 89.1 131.4 89.1L131.4 89.1zM131.4 89.4c-0.7 0-1.3 0.6-1.3 1.4 0 0.8 0.6 1.4 1.3 1.4 0.7 0 1.3-0.6 1.3-1.4C132.7 90 132.1 89.4 131.4 89.4L131.4 89.4zM131.1 91.8h-0.4v-1.9c0.1 0 0.3-0.1 0.6-0.1 0.3 0 0.5 0.1 0.6 0.2 0.1 0.1 0.2 0.2 0.2 0.4 0 0.2-0.2 0.4-0.4 0.4v0c0.2 0 0.3 0.2 0.3 0.5 0 0.3 0.1 0.4 0.1 0.5h-0.4c0-0.1-0.1-0.2-0.1-0.5 0-0.2-0.2-0.3-0.4-0.3h-0.2V91.8zM131.1 90.7h0.2c0.2 0 0.4-0.1 0.4-0.3 0-0.2-0.1-0.3-0.4-0.3 -0.1 0-0.2 0-0.2 0V90.7z\"></path><path d=\"M99.4 34.5c0.4 4.5-0.3 9.2-2.2 13.7C91 62.6 74.4 69.2 60.1 63c-14.3-6.2-21-22.8-14.8-37.1C50.8 13.1 64.7 6.4 77.8 9.6c-14.1-3.9-29.2 3.1-35.1 16.9 -6.5 15 0.5 32.5 15.5 39 15.1 6.5 32.5-0.5 39-15.5C99.4 44.9 100 39.6 99.4 34.5M77.9 18.6L76.8 21l2.4 1 2.3-5.9 -1.8-0.8L77.9 18.6zM70.8 32.9c1.5-2.6 3.8-4.8 6.5-6.2l0.5-1.3 0.8-2.2 -2.5-1L70.8 32.9zM80.2 14l1.7 0.7L84.1 9l0.3-0.9 -1.1-0.5L80.2 14zM87.2 0l-3.3 6.7 1 0.4 2.6-7L87.2 0z\"></path><rect x=\"336.4\" y=\"26.1\" fill=\"#AC29B5\" width=\"8\" height=\"24.1\"></rect><path fill=\"#AC29B5\" d=\"M333.9 31.3h-11.3l-6.6 6.6h9.1c-1.2 2.6-3.8 4.5-6.9 4.5 -4.2 0-7.6-3.4-7.6-7.6 0-4.2 3.4-7.6 7.6-7.6 1.5 0 2.9 0.4 4.1 1.2l6.1-6.1c-2.8-2.3-6.4-3.7-10.2-3.7 -8.9 0-16.1 7.2-16.1 16.1 0 8.9 7.2 16.1 16.1 16.1 8.9 0 16.1-7.2 16.1-16.1C334.3 33.6 334.1 32.4 333.9 31.3\"></path><rect x=\"336.4\" y=\"19.2\" fill=\"#AC29B5\" width=\"8\" height=\"4.9\"></rect><polygon fill=\"#AC29B5\" points=\"362.4 50.4 355.5 50.4 355.4 50.3 346 26.1 354.5 26.1 359 39.5 363.5 26.1 371.9 26.1 \"></polygon><rect x=\"373.3\" y=\"26.1\" fill=\"#AC29B5\" width=\"8\" height=\"24.1\"></rect><rect x=\"373.3\" y=\"19.2\" fill=\"#AC29B5\" width=\"8\" height=\"4.9\"></rect><path fill=\"#AC29B5\" d=\"M406.1 50.3h-8V36.9c0-2.5-1-3.8-3.1-3.8 -2.7 0-3.2 2.1-3.2 3.8v13.4h-8V26.1h5.5l2.2 2.2c1.7-1.8 3.7-2.6 6.1-2.6 5.2 0 8.4 3.5 8.4 9.2V50.3L406.1 50.3zM224.6 50.7c-4.2 0-7.6-1.6-10.2-4.7l-0.4-0.5 5.4-5.4 0.3 0.3c1.7 1.9 3.1 2.7 4.8 2.7 2.2 0 3.2-1.3 3.2-4.1V19.2h8.2v20.1C235.9 46.5 231.8 50.7 224.6 50.7M427.8 26.1l-2 2c-1.9-1.7-4.1-2.5-6.7-2.5 -5.4 0-10.9 3.9-10.9 11.4v0.1c0 7.5 5.5 11.4 10.9 11.4 2.6 0 4.6-0.7 6.4-2.3 -0.3 2.9-2.1 4.8-5.5 4.8 -2.1 0-3.9-0.4-5.7-1.2L409 55l0.7 0.4c3 1.6 6.6 2.5 10.4 2.5 9.2 0 13.5-4.7 13.5-13.4V26.1H427.8zM426 37.2c0 2.8-2.2 4.8-5.1 4.8 -3 0-5.1-2-5.1-4.8v-0.1c0-2.8 2.1-4.8 5.1-4.8C423.8 32.3 426 34.3 426 37.2L426 37.2zM247 50.7c-5.2 0-8.4-3.5-8.4-9.2V26.1h8v13.4c0 2.5 1 3.8 3.1 3.8 2.7 0 3.2-2.1 3.2-3.8V26.1h8v24.1h-5.5l-2.2-2.2C251.4 49.8 249.4 50.7 247 50.7M293.8 50.7c-4.9 0-7.4-2.5-7.4-7.6v-9.9h-2.7v-7.1h2.7v-6.9h8v6.9h5.3v7.1h-5.3V42c0 1.1 0.3 1.4 1.3 1.4 1 0 1.9-0.2 2.8-0.7l1.2-0.6V49l-0.4 0.2C297.6 50.2 295.9 50.7 293.8 50.7M275.2 35.4l-0.7-0.2c-1.9-0.6-3.6-1.2-3.6-2v-0.1c0-0.8 1-1.1 1.9-1.1 1.3 0 3 0.5 4.9 1.5l4.6-4.6 -0.4-0.2c-2.6-1.7-5.9-2.8-9-2.8 -5.4 0-9 3.2-9 7.9v0.1c0 4.7 3.7 6.4 7.3 7.5 0.3 0.1 0.6 0.2 0.9 0.3 1.9 0.6 3.5 1 3.5 1.9v0.1c0 1-1.2 1.2-2.2 1.2 -1.9 0-4.2-0.8-6.4-2.3l-4.4 4.4 -0.1 0.1 0.4 0.3c3 2.3 6.6 3.6 10.3 3.6 5.9 0 9.4-3 9.4-8v-0.1C282.6 37.9 277.8 36.3 275.2 35.4\"></path><polygon fill=\"#AC29B5\" points=\"435.2 27.2 436.4 27.2 436.4 30 437.6 30 437.6 27.2 438.8 27.2 438.8 26.1 435.2 26.1 \"></polygon><polygon fill=\"#AC29B5\" points=\"442.2 26.1 441.3 27.5 440.5 26.1 439.2 26.1 439.2 30 440.4 30 440.4 28.1 441 29 441.7 29 442.2 28.1 442.2 30 443.5 30 443.5 26.1 \"></polygon><path d=\"M232 92v0.4c0 3.1-2.2 5.4-5.3 5.4 -3.1 0-5.7-2.7-5.7-5.8 0-3.2 2.6-5.9 5.8-5.9 1.7 0 3.5 0.8 4.6 2.2l-1 0.9c-0.8-1.1-2.2-1.8-3.5-1.8 -2.5 0-4.5 2-4.5 4.5 0 2.3 1.9 4.6 4.3 4.6 1.7 0 3.6-1.5 3.7-3.3h-2.9V92H232zM234.7 96.4h3.4v1.3h-4.8V86.5h1.4V96.4zM250 92.1c0 3.3-2.6 5.8-5.9 5.8 -3.2 0-5.9-2.5-5.9-5.8 0-3.2 2.7-5.8 5.9-5.8C247.3 86.2 250 88.9 250 92.1zM248.6 92.1c0-2.5-1.8-4.5-4.5-4.5 -2.6 0-4.5 2.1-4.5 4.5 0 2.6 2 4.5 4.5 4.5S248.6 94.6 248.6 92.1zM251.2 86.5h1.4c2.1 0 4.1 0.5 4.1 3.1 0 0.8-0.4 1.8-1.2 2.1v0c1.3 0.2 2.2 1.5 2.2 2.8 0 2.2-1.9 3.1-3.9 3.1h-2.6V86.5zM252.6 91.4h0.4c1.3 0 2.4-0.3 2.4-1.9 0-1.6-1.1-1.8-2.4-1.8h-0.4V91.4zM252.6 96.4h1.1c1.3 0 2.6-0.4 2.6-2 0-1.6-1.6-1.9-2.8-1.9h-0.9V96.4zM260.9 94.9l-1.3 2.8h-1.5l5.3-11.7 5.3 11.7h-1.5l-1.3-2.8H260.9zM263.4 89.1l-2 4.5h4L263.4 89.1zM271.1 96.4h3.4v1.3h-4.8V86.5h1.4V96.4zM281.1 87.8v3.1h3.9v1.3h-3.9v5.5h-1.4V86.5h5.4v1.3H281.1zM287.9 86.5v6.6c0 1.8 0.5 3.5 2.7 3.5 2.2 0 2.7-1.7 2.7-3.5v-6.6h1.4v7.1c0 2.5-1.5 4.3-4.1 4.3 -2.6 0-4.1-1.9-4.1-4.3v-7.1H287.9zM296.5 85.9l8.4 8.8v-8.3h1.4v11.6l-8.4-8.8v8.3h-1.4V85.9zM308.2 86.5h2.3c3.4 0 6.3 1.8 6.3 5.5 0 3.8-2.8 5.7-6.3 5.7h-2.3V86.5zM309.6 96.4h0.5c2.8 0 5.3-1.1 5.3-4.3 0-3.3-2.5-4.3-5.3-4.3h-0.5V96.4zM325.1 97.7h-1.7l-3.3-4.7h-0.6v4.7h-1.4V86.5h1.7c1 0 2.1 0 3 0.5 0.9 0.5 1.5 1.6 1.5 2.7 0 1.6-1.1 2.9-2.7 3.1L325.1 97.7zM319.6 91.8h0.4c1.4 0 3-0.3 3-2 0-1.8-1.7-2-3-2h-0.4V91.8zM327.8 94.9l-1.3 2.8H325l5.3-11.7 5.3 11.7h-1.5l-1.3-2.8H327.8zM330.4 89.1l-2 4.5h4L330.4 89.1zM338 97.7h-1.4V86.5h1.4V97.7zM345.1 88.6c-0.4-0.7-0.9-1.1-1.8-1.1 -0.9 0-1.9 0.6-1.9 1.6 0 0.9 0.9 1.3 1.6 1.6l0.8 0.3c1.6 0.6 2.8 1.5 2.8 3.4 0 2-1.6 3.5-3.6 3.5 -1.8 0-3.2-1.3-3.5-3.1l1.4-0.3c0 1.2 1 2.1 2.2 2.1 1.2 0 2.1-1 2.1-2.2 0-1.2-1-1.7-1.9-2.1l-0.8-0.3c-1.3-0.5-2.4-1.3-2.4-2.8 0-1.8 1.6-2.9 3.3-2.9 1.2 0 2.3 0.6 2.9 1.7L345.1 88.6zM349.4 97.7H348V86.5h1.4V97.7zM351.4 85.9l8.4 8.8v-8.3h1.4v11.6l-8.4-8.8v8.3h-1.4V85.9zM373.3 92v0.4c0 3.1-2.2 5.4-5.3 5.4 -3.1 0-5.7-2.7-5.7-5.8 0-3.2 2.6-5.9 5.8-5.9 1.7 0 3.5 0.8 4.6 2.2l-1 0.9c-0.8-1.1-2.2-1.8-3.5-1.8 -2.5 0-4.5 2-4.5 4.5 0 2.3 1.9 4.6 4.3 4.6 1.7 0 3.6-1.5 3.7-3.3h-2.9V92H373.3zM380.4 97.7H379V86.5h1.6c3.4 0 4.5 1.2 4.5 3.2 0 2.4-1.8 3.3-3.9 3.3h-0.8V97.7zM380.4 91.7h0.4c1.4 0 3-0.3 3-2 0-1.8-1.7-2-3-2h-0.4V91.7zM386.7 94.9l-1.3 2.8H384l5.3-11.7 5.3 11.7h-1.5l-1.3-2.8H386.7zM389.3 89.1l-2 4.5h4L389.3 89.1zM402.5 97.7h-1.7l-3.3-4.7H397v4.7h-1.4V86.5h1.7c1 0 2.1 0 3 0.5 0.9 0.5 1.5 1.6 1.5 2.7 0 1.6-1.1 2.9-2.7 3.1L402.5 97.7zM397 91.8h0.4c1.4 0 3-0.3 3-2 0-1.8-1.7-2-3-2H397V91.8zM406.4 97.7H405v-9.9h-2.7v-1.3h6.7v1.3h-2.7V97.7zM410 85.9l8.4 8.8v-8.3h1.4v11.6l-8.4-8.8v8.3H410V85.9zM421.8 86.5h6v1.3h-4.6v3.1h4.5v1.3h-4.5v4.2h4.6v1.3h-6V86.5zM436.4 97.7h-1.7l-3.3-4.7h-0.6v4.7h-1.4V86.5h1.7c1 0 2.1 0 3 0.5 0.9 0.5 1.5 1.6 1.5 2.7 0 1.6-1.1 2.9-2.7 3.1L436.4 97.7zM430.9 91.8h0.4c1.4 0 3-0.3 3-2 0-1.8-1.7-2-3-2h-0.4V91.8z\"></path></svg>"

/***/ }),
/* 865 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 57 50\"><path d=\"M40.3 0c-4.5 0-8.5 1.9-11.7 5-3.1-3.1-7.1-5-11.7-5C7.6 0 0 7.3 0 16.6c0 5.4 1.7 9.2 5.5 13.9l.2.3.3.2 19.3 16.3 3.1 2.6 3.1-2.6L50.8 31l.3-.2.2-.3c4.1-4.7 5.5-8.5 5.5-13.9C57.3 7.3 49.7 0 40.3 0m0 4.7c6.7 0 12 5.2 12 11.6 0 3.8-.7 6.7-4.3 10.7L28.6 43.3 9.3 27C5.7 23 5 20.1 5 16.3 5 9.7 10.3 4.7 16.9 4.7c6 0 11 4.5 11.7 10.2 1-5.7 5.8-10.2 11.7-10.2\" fill=\"#CCC\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),
/* 866 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(210);
module.exports = __webpack_require__(327);


/***/ })
],[867]);


// WEBPACK FOOTER //
// bundle.app.js